export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: number | string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * Scalar for exposing dates or date times. `Date` should always be used when you're API is exposing
   * dates or date times. It's an [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) `String`
   * based on the `Zulu` timezone. This is is basically the same format our API gateway `xws` uses.
   * Valid values are for example `2007-12-24T18:21Z` or `2008-02-01T09:00:22Z`.
   * Also partial dates complaint with [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) like `2020-02`.
   */
  Date: any;
  /** DEPRECATED: Use custom errors instead. Raw JSON of a domain error */
  DomainError: any;
  /** Scalar to signal that this field contains an email address. The contained type is just a `String` */
  Email: string;
  /** A marker type for an expression that is evaluated. The context is responsible for the evaluation, it does nothing by itself. */
  Expression: any;
  /**
   * Used to create a globally unique id by combining the natural identifiers of an object together with type information.
   *
   * A `GlobalID` is expected to be an URN. If it's served by the backend, the URN is
   * expected to follow the conventions outlined by the [URN guidelines](https://new-work.atlassian.net/wiki/spaces/SOLAR/pages/45912687/Internal+URNs). In both
   * cases the naming portions of the URN are expected to be in "snake_case".
   */
  GlobalID: any;
  /**
   * An `HTML` escaped `String`. Fields with this type will be automatically escape any `HTML` entities in the content,
   * before it is returned to the caller.
   *
   * > Please note that the content of this scalar will be escaped only on the web channel.
   * > For mobile requests the content will be forwarded unescaped.
   */
  HTMLEscaped: any;
  /** Raw JSON scalar */
  JSON: any;
  /** The `Long` scalar type represents non-fractional signed whole numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  /** Scalar to signal that this field returns [markdown](https://daringfireball.net/projects/markdown/syntax) flavoured `String`. */
  Markdown: any;
  /**
   * An [E.164](https://en.wikipedia.org/wiki/E.164) compliant `String` made popular by
   * Googles [libphonenumber](https://github.com/googlei18n/libphonenumber),
   * examples are `+49403018` or `+491607812165`. There are a variety of libraries out there which can
   * produce an E.164 compliant `Strings`. For `Ruby on Rails` based applications,
   * you can use [phonelib](https://github.com/daddyz/phonelib).
   */
  PhoneNumberE164: any;
  /**
   * ***Scrambles*** (signs) all `IDs` in a `URL` (for web) that has a `https` or `http` scheme
   * Used to create an URL that has obfuscated ids to prevent misuse.
   *
   * ***Please note*** that this kind of Scrambling differs from the Scrambling that is used by the
   * `xing-scrambling` gem https://source.xing.com/gems/xing-scrambling
   *
   *
   * Example
   *
   *  https://www.xing.com/chats/1298071111.d055e2
   *
   * find more testcases in the FieldScramblingSpec.scala
   */
  ScrambledURL: any;
  /**
   * **scrambled** for both web and mobile requests (in the `ID` case)
   *
   * Sometimes you want to support an external alias for an `ID`.
   * Some of our internal APIs accept either an `ID` or a "slug-like" identifier.
   * One example of this is the `page name` of the profile team. This scalar is primarily intended to be used with
   * field arguments and should be used, when you want to expose such APIs.
   *
   * > Please note that the `SlugOrID` scalar doesn't consider blank strings as valid values.
   * > `""` or `"   "` as input values will result in query analysis errors.
   */
  SlugOrID: any;
  /**
   * An [RFC 3986][rfc_3986], [RFC 3987][rfc_3987], and [RFC 6570][rfc_6570] (level 4) compliant URL `String`.
   *
   * Examples are
   *
   * * `https://www.xing.com`
   * * `http://api.xing.com/v1/some/api`
   * * `foo://example.com:8042/over/there?name=ferret#nose`
   *
   * [rfc_3986]: https://www.ietf.org/rfc/rfc3986.txt
   * [rfc_3987]: https://www.ietf.org/rfc/rfc3987.txt
   * [rfc_6570]: https://www.ietf.org/rfc/rfc6570.txt
   */
  URL: string;
  /**
   * An [RFC 3986][rfc_3986], [RFC 3987][rfc_3987], and [RFC 6570][rfc_6570] (level 4) compliant URN `String`.
   *
   * Examples are
   *
   * * `urn:oasis:names:specification:docbook:dtd:xml:4.1.2`
   * * `urn:x-xing:communities:group:1234`
   *
   * See [general concept](https://new-work.atlassian.net/wiki/spaces/SOLAR/pages/45912687/Internal+URNs)
   * And the [internal URN catalog](https://new-work.atlassian.net/wiki/spaces/SOLAR/pages/45933515/Internal+URN+Catalog)
   *
   * [rfc_3986]: https://www.ietf.org/rfc/rfc3986.txt
   * [rfc_3987]: https://www.ietf.org/rfc/rfc3987.txt
   * [rfc_6570]: https://www.ietf.org/rfc/rfc6570.txt
   */
  URN: any;
  /**
   * A __universally unique identifier (UUID)__ is a 128-bit number used to identify information in computer systems.
   * The term __globally unique identifier (GUID)__ is also used.
   *
   * In its canonical textual representation, the sixteen octets of a `UUID` are represented as 32 hexadecimal (base 16) digits, i
   * displayed in five groups separated by hyphens, in the form `8-4-4-4-12` for a total of 36 characters (32 alphanumeric characters and four hyphens).
   *
   * For example:
   *
   * - `123e4567-e89b-12d3-a456-426655440000`
   * - `xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx`
   *
   * See [here](https://en.wikipedia.org/wiki/Universally_unique_identifier) for more information
   */
  UUID: any;
  /**
   * Scalar to represent an authorization token for a specific upload. The content of the token is an opague string.
   * It is intended to be used to authenticate with the upload service in order to upload data to the platform.
   */
  UploadAuthToken: any;
  /**
   * Scalar to represent an id for an upload. The content of the token is an opague string.
   * This enables to reference and download an uploaded file at the internal upload API.
   */
  UploadId: any;
};



export type AboutCompany = {
  __typename?: 'AboutCompany';
  /** #logged-out #soft-logged-in */
  companySizeRange?: Maybe<CompanySizeRange>;
  companySizeId?: Maybe<Scalars['ID']>;
  /** #paginated #logged-out #soft-logged-in #rest #virtual */
  affiliates?: Maybe<CompanyAffiliatesConnection>;
  /** #logged-out #soft-logged-in */
  kununuData?: Maybe<CompanyKununuData>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  industry?: Maybe<Industry>;
};


export type AboutCompanyAffiliatesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type AboutEntity = {
  __typename?: 'AboutEntity';
  /** #logged-out #soft-logged-in */
  aboutHeadline?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  aboutSummary?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Moved to the about us facts query. WILL BE REMOVED ...
   */
  foundingYear?: Maybe<Scalars['Int']>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Moved to the about us facts query. WILL BE REMOVED ...
   */
  imprint?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Moved to the about us facts query. WILL BE REMOVED ...
   */
  websiteUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  aboutArticleReference?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in */
  groupRulesArticleReference?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in */
  articleReferences: Array<Scalars['JSON']>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   * @deprecated This attribute will be removed in favour of using the `entityPageModule` query to fetch module properties information. WILL BE REMOVED ...
   */
  properties?: Maybe<LegacyAboutUsProperties>;
  /** #logged-out #soft-logged-in #rest #virtual */
  documents?: Maybe<EntityDocumentResult>;
  /** #logged-out #soft-logged-in #rest #virtual */
  media?: Maybe<EntityMediaResult>;
  /** #logged-out #soft-logged-in #rest #virtual */
  aboutArticle?: Maybe<ContentServiceContent>;
  /** #logged-out #soft-logged-in #rest #virtual */
  groupRulesArticle?: Maybe<ContentServiceContent>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   * @deprecated Moved to the about us facts query. WILL BE REMOVED ...
   */
  companyData?: Maybe<AboutCompany>;
};


export type AboutEntityPropertiesArgs = {
  includeDisabled?: Maybe<Scalars['Boolean']>;
};


export type AboutEntityDocumentsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


export type AboutEntityMediaArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  includeDisabled?: Maybe<Scalars['Boolean']>;
};


export type AboutEntityAboutArticleArgs = {
  supportedBlockTypes?: Array<ArticleSupportedBlockTypes>;
};


export type AboutEntityGroupRulesArticleArgs = {
  supportedBlockTypes?: Array<ArticleSupportedBlockTypes>;
};


export type AboutEntityCompanyDataArgs = {
  companyId?: Maybe<Scalars['SlugOrID']>;
};

export type AboutEntityMutationInput = {
  aboutHeadline?: Maybe<Scalars['String']>;
  aboutSummary?: Maybe<Scalars['String']>;
  foundingYear?: Maybe<Scalars['Int']>;
  imprint?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['URL']>;
  aboutArticleReference?: Maybe<Scalars['GlobalID']>;
};

export type AboutEntityResult = AboutEntity | EntityPageError;

export type AboutUsFactsProperties = {
  __typename?: 'AboutUsFactsProperties';
  displayLinks?: Maybe<Scalars['Boolean']>;
};

export type AboutUsFactsResult = CompanyAboutUsFacts | GroupsAboutUsFacts | PublisherAboutUsFacts | FallbackAboutUsFacts | EntityPageError;

export type AboutUsProperties = {
  __typename?: 'AboutUsProperties';
  /** #logged-out #soft-logged-in */
  hasSubpage: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  hasGallery: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  hasDocuments: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  hasAffiliates: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  hasExtraRules: Scalars['Boolean'];
};

/** Available academic titles on the XING ID */
export enum AcademicTitle {
  /** No title provided */
  None = 'NONE',
  /** All countries, Doctor */
  Dr = 'DR',
  /** All countries, Professor */
  Prof = 'PROF',
  /** All countries, Professor Doctor */
  ProfDr = 'PROF_DR',
  /** Austrian only, [Ingenieur](https://de.wikipedia.org/wiki/Ingenieur#Standes-_bzw._Qualifikationsbezeichnung_Ingenieur) */
  Ing = 'ING',
  /** Austrian only, [Diplom-Ingenieur](https://de.wikipedia.org/wiki/Akademischer_Grad#Zweiter_Zyklus_.E2.80.93_Ebene_2_.28Master-Ebene.29) */
  DiplIng = 'DIPL_ING',
  /** Austrian only, [Magister](https://de.wikipedia.org/wiki/Akademischer_Grad#Zweiter_Zyklus_.E2.80.93_Ebene_2_.28Master-Ebene.29) */
  Mag = 'MAG'
}

export type Accomplishment = {
  __typename?: 'Accomplishment';
  id: Scalars['ID'];
  globalId: Scalars['GlobalID'];
  value: Scalars['String'];
  subtype: AccomplishmentTypeIdentifier;
  year?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export type AccomplishmentCreateInput = {
  value: Scalars['String'];
  subtype: AccomplishmentTypeIdentifier;
  year?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export type AccomplishmentCreateResult = Accomplishment | AccomplishmentMutationError;

export type AccomplishmentDeleteInput = {
  globalId: Scalars['GlobalID'];
};

export type AccomplishmentDeleteResult = Accomplishment | AccomplishmentMutationError;

export type AccomplishmentMutationError = {
  __typename?: 'AccomplishmentMutationError';
  message?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['JSON']>;
};

export enum AccomplishmentTypeIdentifier {
  Award = 'AWARD',
  Qualification = 'QUALIFICATION'
}

export type AccomplishmentUpdateInput = {
  globalId: Scalars['GlobalID'];
  value?: Maybe<Scalars['String']>;
  subtype: AccomplishmentTypeIdentifier;
  year?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export type AccomplishmentUpdateResult = Accomplishment | AccomplishmentMutationError;

export type AccomplishmentsCollection = {
  __typename?: 'AccomplishmentsCollection';
  collection: Array<Maybe<Accomplishment>>;
};

export type AccomplishmentsModule = ModuleInterface & {
  __typename?: 'AccomplishmentsModule';
  title: Scalars['String'];
  order: Scalars['Int'];
  /** #rest #virtual */
  content?: Maybe<AccomplishmentsCollection>;
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type AccountDeactivationSettings = {
  __typename?: 'AccountDeactivationSettings';
  deactivation?: Maybe<DeactivationSetting>;
};

export type AccountDeactivationSettingsInput = {
  deactivation: DeactivationSettingInput;
};

export type AccountDeactivationSettingsMutationResult = {
  error?: Maybe<AccountDeactivationSettings>;
  accountDeactivationSettings?: Maybe<AccountDeactivationSettings>;
};

export type AccountDeactivationSettingsMutationResultError = AccountDeactivationSettingsMutationResult & {
  __typename?: 'AccountDeactivationSettingsMutationResultError';
  error?: Maybe<AccountDeactivationSettings>;
  accountDeactivationSettings?: Maybe<AccountDeactivationSettings>;
};

export type AccountDeactivationSettingsMutationResultSuccess = AccountDeactivationSettingsMutationResult & {
  __typename?: 'AccountDeactivationSettingsMutationResultSuccess';
  error?: Maybe<AccountDeactivationSettings>;
  accountDeactivationSettings?: Maybe<AccountDeactivationSettings>;
};

export type AccountDeletionSettings = {
  __typename?: 'AccountDeletionSettings';
  deletion?: Maybe<DeletionSetting>;
};

export type AccountDeletionSettingsInput = {
  deletion: DeletionSettingInput;
};

export type AccountDeletionSettingsMutationResult = {
  error?: Maybe<AccountDeletionSettings>;
  accountDeletionSettings?: Maybe<AccountDeletionSettings>;
};

export type AccountDeletionSettingsMutationResultError = AccountDeletionSettingsMutationResult & {
  __typename?: 'AccountDeletionSettingsMutationResultError';
  error?: Maybe<AccountDeletionSettings>;
  accountDeletionSettings?: Maybe<AccountDeletionSettings>;
};

export type AccountDeletionSettingsMutationResultSuccess = AccountDeletionSettingsMutationResult & {
  __typename?: 'AccountDeletionSettingsMutationResultSuccess';
  error?: Maybe<AccountDeletionSettings>;
  accountDeletionSettings?: Maybe<AccountDeletionSettings>;
};

/** Account related settings */
export type AccountSettings = {
  __typename?: 'AccountSettings';
  userName?: Maybe<TextSetting>;
  email?: Maybe<EmailSetting>;
  phone?: Maybe<PhoneSetting>;
  /** #soft-logged-in */
  createdAt?: Maybe<TextSetting>;
  /** #soft-logged-in */
  language?: Maybe<SelectSetting>;
  /** #soft-logged-in */
  timeZone?: Maybe<SelectSetting>;
  userMayDeleteThemselves?: Maybe<ToggleSetting>;
};

export type AccountSettingsInput = {
  userName?: Maybe<TextSettingInput>;
  email?: Maybe<EmailSettingInput>;
  phone?: Maybe<PhoneSettingInput>;
  language?: Maybe<SelectSettingInput>;
  timeZone?: Maybe<SelectSettingInput>;
};

export type AccountSettingsMutationResult = {
  __typename?: 'AccountSettingsMutationResult';
  error?: Maybe<AccountSettings>;
  response?: Maybe<AccountSettings>;
};

/** Activities settings (stored in Perl user properties in settings app) */
export type ActivitiesSettings = {
  __typename?: 'ActivitiesSettings';
  /** Profile changes: whether activity should be created on profile change of wants, haves etc */
  personalData?: Maybe<ToggleSetting>;
  /** Profile changes: whether activity should be created on profile change of professional experience */
  workExperience?: Maybe<ToggleSetting>;
  /** Profile changes: whether activity should be created on profile change of photo or business contact details */
  basicData?: Maybe<ToggleSetting>;
  /** Other activities: whether activity should be created when adding new contact */
  newContacts?: Maybe<ToggleSetting>;
  /** Other activities: whether activity should be created when attending or organising an event */
  events?: Maybe<ToggleSetting>;
  /** Other activities: whether activity should be created when joining a group or posting in a group */
  groupMemberships?: Maybe<ToggleSetting>;
  /** Other activities: whether activity should be created when following a company */
  companyProfiles?: Maybe<ToggleSetting>;
  /** Other activities: whether activity should be created when following content page or commenting on klartext article */
  cppFollow?: Maybe<ToggleSetting>;
  /** Other activities: whether activity should be created when having an anniversary */
  anniversary?: Maybe<ToggleSetting>;
  /** Other activities: whether activity you like/comment on should be spread via social proof */
  socialReactions?: Maybe<ToggleSetting>;
};

export type ActivitiesSettingsInput = {
  /** Profile changes: whether activity should be created when changing wants, haves etc */
  personalData?: Maybe<ToggleSettingInput>;
  /** Profile changes: whether activity should be created when changing professional experience */
  workExperience?: Maybe<ToggleSettingInput>;
  /** Profile changes: whether activity should be created when changing a photo or business contact details */
  basicData?: Maybe<ToggleSettingInput>;
  /** Other activities: whether activity should be created when adding new contact */
  newContacts?: Maybe<ToggleSettingInput>;
  /** Other activities: whether activity should be created when attending or organising an event */
  events?: Maybe<ToggleSettingInput>;
  /** Other activities: whether activity should be created when joining a group or posting in a group */
  groupMemberships?: Maybe<ToggleSettingInput>;
  /** Other activities: whether activity should be created when following a company */
  companyProfiles?: Maybe<ToggleSettingInput>;
  /** Other activities: whether activity should be created when following content page or commenting on klartext article */
  cppFollow?: Maybe<ToggleSettingInput>;
  /** Other activities: whether activity should be created when having an anniversary */
  anniversary?: Maybe<ToggleSettingInput>;
  /** Other activities: whether activity you like/comment on should be spread via social proof */
  socialReactions?: Maybe<ToggleSettingInput>;
};

export type ActivitiesSettingsMutationResult = {
  __typename?: 'ActivitiesSettingsMutationResult';
  error?: Maybe<ActivitiesSettings>;
  response?: Maybe<ActivitiesSettings>;
};

export type AdAuctionWinners = {
  __typename?: 'AdAuctionWinners';
  /** #logged-out #soft-logged-in */
  collection: Array<WinningAd>;
};

export type AdConversationStarter = ConversationStarter & {
  __typename?: 'AdConversationStarter';
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type AdImage = {
  __typename?: 'AdImage';
  /** #logged-out #soft-logged-in */
  large?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  small: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  square?: Maybe<Scalars['URL']>;
};

export type AdNegativeFeedbackError = {
  __typename?: 'AdNegativeFeedbackError';
  message?: Maybe<Scalars['String']>;
};

export type AdNegativeFeedbackInput = {
  deliveryId: Scalars['ID'];
  adId: Scalars['ID'];
};

export type AdSender = {
  __typename?: 'AdSender';
  /** #logged-out #soft-logged-in */
  image: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  link: Scalars['String'];
  /** #logged-out #soft-logged-in */
  name: Scalars['String'];
  /** #logged-out #soft-logged-in */
  urn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  surn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  followersCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  jobDescription?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  type: AdSenderTypes;
};

export enum AdSenderTypes {
  User = 'user',
  Company = 'company',
  PublisherPage = 'publisher_page',
  Page = 'page',
  EntityPage = 'entity_page'
}

export enum AdTypes {
  EventAd = 'EventAd',
  WebsiteAd = 'WebsiteAd',
  VideoAd = 'VideoAd',
  LeadAd = 'LeadAd',
  PostingAd = 'PostingAd',
  EntityPageAd = 'EntityPageAd'
}

export type AddMessengerChatParticipantsError = {
  __typename?: 'AddMessengerChatParticipantsError';
  message: Scalars['String'];
};

export type AddMessengerChatParticipantsInput = {
  chatId: Scalars['ID'];
  participantUserIds: Array<Scalars['ID']>;
};

export type AddMessengerChatParticipantsResult = MessengerChat | AddMessengerChatParticipantsError;

/** A standard container for representing an address */
export type Address = Addressable & {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  country?: Maybe<Country>;
  /** #rest(batched) #virtual */
  province?: Maybe<Province>;
};

/**
 * Defines the interface for an address. We have a default implementation
 * `Address` that should cover most of the cases. Use this interface only
 * when you want to represent address-like data and composition is not an option.
 */
export type Addressable = {
  city?: Maybe<Scalars['String']>;
  /** @deprecated use addressable.country.provinces instead */
  province?: Maybe<Province>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
};

export type AdsTrackingError = {
  __typename?: 'AdsTrackingError';
  message?: Maybe<Scalars['String']>;
};

export type AdsTrackingInput = {
  /** Id of the ad */
  id: Scalars['ID'];
  /** Tracking token received from the backend */
  token: Scalars['String'];
  /** ScrambledId for loggedOut tracking */
  scrambledId?: Maybe<Scalars['String']>;
};

export type AdsTrackingIntIdError = {
  __typename?: 'AdsTrackingIntIdError';
  message?: Maybe<Scalars['String']>;
};

export type AdsTrackingIntIdInput = {
  /** Id of the ad */
  id: Scalars['Int'];
  /** Tracking token received from the backend */
  token: Scalars['String'];
  /** ScrambledId for loggedOut tracking */
  scrambledId?: Maybe<Scalars['String']>;
};

export type AdsTrackingIntIdResult = {
  __typename?: 'AdsTrackingIntIdResult';
  error?: Maybe<AdsTrackingIntIdError>;
};

export type AdsTrackingResult = {
  __typename?: 'AdsTrackingResult';
  error?: Maybe<AdsTrackingError>;
};

export type AgeGroup = Localizable & {
  __typename?: 'AgeGroup';
  id: Scalars['ID'];
  /** The raw text resource key from Phraseapp */
  localizationKey: Scalars['String'];
  /** The value localized based on the `Accept-Language` header */
  localizationValue: Scalars['String'];
};

export type AgeGroupElement = {
  __typename?: 'AgeGroupElement';
  ageGroup?: Maybe<AgeGroup>;
  total: Scalars['Int'];
};

export type AggregatedNotification = {
  /** #rest(batched) #virtual */
  bucketPreview?: Maybe<Array<Maybe<Notification>>>;
  total: Scalars['Int'];
};

/** By default we define an aggregation like a count (Int) and a value (String). The value is the id for applying the filter and the count is the number of documents which match that filter */
export type Aggregation = HasAggregationCount & {
  __typename?: 'Aggregation';
  value: Scalars['String'];
  count: Scalars['Int'];
};

export type AiCompanyEnrichment = {
  isAiEnriched?: Maybe<Scalars['Boolean']>;
};

export type AllJobFilterCollection = JobFilterBenefit | JobFilterBenefitEmployeePerk | JobFilterBenefitWorkingCulture | JobFilterCareerLevel | JobFilterCountry | JobFilterDiscipline | JobFilterEmploymentType | JobFilterIndustry | JobFilterCity | JobFilterSalary | JobFilterDisabledSalary | JobFilterPublishToCompany | JobFilterRemoteOption | JobFilterCompany | JobFilterLocation;

/** At Any Time Phone Preferences Type */
export type AnyTimePhonePreferences = {
  __typename?: 'AnyTimePhonePreferences';
  at: PhonePreferencesOptions;
};

export type AppStats = {
  __typename?: 'AppStats';
  /**
   * #soft-logged-in
   *
   *  number of chats that haven't been marked as read
   */
  unreadChats?: Maybe<Scalars['Int']>;
  /** number of chats that haven't been seen yet */
  unseenChats?: Maybe<Scalars['Int']>;
  /** number of received contact requests */
  toConfirm?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  number of unseen contact requests
   */
  contactRequests?: Maybe<Scalars['Int']>;
  /** number of newly acquired contacts */
  latestContacts?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  number of new activity related notifications
   */
  activities?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  number of new updates on the event market
   */
  events?: Maybe<Scalars['Int']>;
  /** number of birthdays today */
  birthdays?: Maybe<Scalars['Int']>;
  /** number of unseen profile visits */
  visitors?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  number of unseen updates in the news section
   */
  news?: Maybe<Scalars['Int']>;
  /** number of unseen updates in the news section (mobile only) */
  newsMobile?: Maybe<Scalars['Int']>;
  /** number of unseen updates for klartext */
  klartext?: Maybe<Scalars['Int']>;
  /** number of unseen updates in the news section (web only) */
  newsFrontPage?: Maybe<Scalars['Int']>;
  /**
   * number of new community related updates
   * @deprecated group badge is not available anymore
   */
  groups?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  number of new community related updates (web only)
   * @deprecated group badge is not available anymore
   */
  groupsWeb?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  number of updates on the job market
   */
  jobs?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  number of probusiness related notifications
   */
  probusinessNotifications?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  number of new notifications in the notification center (web only)
   */
  notificationCenterWeb?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  number of new aggregated and single notifications for the new notification center (web only)
   */
  ncWeb?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  number of new notifications in the notification center for vision type version (web only)
   */
  notificationCenterWebVisionType?: Maybe<Scalars['Int']>;
  /** number of new premium perks */
  premiumPerksNew?: Maybe<Scalars['Int']>;
  /** number of unseen updates for Resonance Hub (Armstrong) */
  resonanceHub?: Maybe<Scalars['Int']>;
  /** number of unseen updates for Network Home (Armstrong) */
  networkHome?: Maybe<Scalars['Int']>;
  /** number of unseen updates for Me Hub (Armstrong) */
  meHub?: Maybe<Scalars['Int']>;
  /** number of unseen messages for Messenger (Armstrong) */
  unseenMessages?: Maybe<Scalars['Int']>;
};

export type AppearInRecruiterSearchNotification = Notification & {
  __typename?: 'AppearInRecruiterSearchNotification';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type ApplyServiceSettings = {
  __typename?: 'ApplyServiceSettings';
  /** #logged-out #soft-logged-in */
  loggedoutApplicationsEnabled: Scalars['Boolean'];
};

/** Possible block types */
export type ArticleBlock = ArticleParagraph | ArticleH2 | ArticleH3 | ArticleH4 | ArticleUnorderedListItem | ArticleOrderedListItem | ArticleQuote | ArticleEmphasis | ArticleBodyImage;

export type ArticleBodyImage = {
  __typename?: 'ArticleBodyImage';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  uuid: Scalars['UUID'];
  /** #logged-out #soft-logged-in */
  caption?: Maybe<ArticleCaption>;
  /** #logged-out #soft-logged-in #virtual */
  image?: Maybe<Array<ScaledImage>>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  imageMetadata?: Maybe<OriginalImageMetadata>;
};


export type ArticleBodyImageImageArgs = {
  dimensions: Array<ScaledImageDimension>;
};

/**
 * Input for the body image block, where `inputType` determines which action will be taken in the backend.
 * If IMAGE_CACHE_UUID is passed, then an Image Cache UUID is expected in `inputValue` and the service will keep the image as is.
 * If it's UPLOAD_ID, then an Upload ID is expected in `inputValue` and the service will upload a new image to Image Cache.
 */
export type ArticleBodyImageInput = {
  id?: Maybe<Scalars['Int']>;
  inputType: ArticleMediaInputType;
  inputValue: Scalars['String'];
  caption?: Maybe<ArticleTextInput>;
};

export type ArticleBoldMarkup = ArticleMarkupInterface & {
  __typename?: 'ArticleBoldMarkup';
  /** #logged-out #soft-logged-in */
  start: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  end: Scalars['Int'];
};

export type ArticleCaption = {
  __typename?: 'ArticleCaption';
  /** #logged-out #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type ArticleCover = ArticleCoverImage | ArticleCoverVideo;

export type ArticleCoverImage = {
  __typename?: 'ArticleCoverImage';
  uuid?: Maybe<Scalars['UUID']>;
  /** #logged-out #soft-logged-in */
  caption?: Maybe<ArticleCaption>;
  /** #logged-out #soft-logged-in #virtual */
  image?: Maybe<Array<ScaledImage>>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  imageMetadata?: Maybe<OriginalImageMetadata>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['String']>;
};


export type ArticleCoverImageImageArgs = {
  dimensions: Array<ScaledImageDimension>;
};

export type ArticleCoverVideo = {
  __typename?: 'ArticleCoverVideo';
  /** #logged-out #soft-logged-in */
  ref?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  video?: Maybe<VideoV2>;
  /** #logged-out #soft-logged-in */
  caption?: Maybe<ArticleCaption>;
};

export type ArticleEmphasis = {
  __typename?: 'ArticleEmphasis';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
};

export type ArticleH2 = ArticleTextWithMarkup & {
  __typename?: 'ArticleH2';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
  /** #logged-out #soft-logged-in */
  markups: Array<ArticleMarkupInterface>;
};

export type ArticleH3 = ArticleTextWithMarkup & {
  __typename?: 'ArticleH3';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
  /** #logged-out #soft-logged-in */
  markups: Array<ArticleMarkupInterface>;
};

export type ArticleH4 = ArticleTextWithMarkup & {
  __typename?: 'ArticleH4';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
  /** #logged-out #soft-logged-in */
  markups: Array<ArticleMarkupInterface>;
};

export type ArticleHeader = {
  __typename?: 'ArticleHeader';
  /** #logged-out #soft-logged-in */
  title: ArticleTitle;
  /** #logged-out #soft-logged-in */
  summary?: Maybe<ArticleSummary>;
  /** #logged-out #soft-logged-in */
  cover?: Maybe<ArticleCover>;
};

export type ArticleHeaderCoverImageInput = {
  inputType: ArticleMediaInputType;
  inputValue: Scalars['String'];
};

export type ArticleHeaderCoverInput = {
  image?: Maybe<ArticleHeaderCoverImageInput>;
  imageUrl?: Maybe<Scalars['String']>;
  videoRef?: Maybe<Scalars['String']>;
  caption?: Maybe<ArticleTextInput>;
};

export type ArticleItalicMarkup = ArticleMarkupInterface & {
  __typename?: 'ArticleItalicMarkup';
  /** #logged-out #soft-logged-in */
  start: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  end: Scalars['Int'];
};

export type ArticleLinkMarkup = ArticleMarkupInterface & {
  __typename?: 'ArticleLinkMarkup';
  /** #logged-out #soft-logged-in */
  href: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  start: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  end: Scalars['Int'];
};

export type ArticleLinkMarkupInput = {
  start: Scalars['Int'];
  end: Scalars['Int'];
  href: Scalars['URL'];
};

/** Only one of them is allowed */
export type ArticleMarkupInput = {
  bold?: Maybe<ArticleSimpleMarkupInput>;
  italic?: Maybe<ArticleSimpleMarkupInput>;
  link?: Maybe<ArticleLinkMarkupInput>;
  mention?: Maybe<ArticleMentionMarkupInput>;
};

/** Article Markup specifies a range of characters in a text to be styled, depending on markup type. */
export type ArticleMarkupInterface = {
  /** #logged-out #soft-logged-in */
  start: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  end: Scalars['Int'];
};

export enum ArticleMediaInputType {
  ImageCacheUuid = 'IMAGE_CACHE_UUID',
  UploadId = 'UPLOAD_ID'
}

export enum ArticleMembership {
  NoMembership = 'NO_MEMBERSHIP',
  Premium = 'PREMIUM',
  Projobs = 'PROJOBS'
}

export type ArticleMentionMarkup = ArticleMarkupInterface & {
  __typename?: 'ArticleMentionMarkup';
  /** #logged-out #soft-logged-in */
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  /** #logged-out #soft-logged-in */
  start: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  end: Scalars['Int'];
};

export type ArticleMentionMarkupInput = {
  start: Scalars['Int'];
  end: Scalars['Int'];
  userId: Scalars['ID'];
};

export type ArticleOrderedListItem = ArticleTextWithMarkup & {
  __typename?: 'ArticleOrderedListItem';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
  /** #logged-out #soft-logged-in */
  markups: Array<ArticleMarkupInterface>;
};

export type ArticleParagraph = ArticleTextWithMarkup & {
  __typename?: 'ArticleParagraph';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
  /** #logged-out #soft-logged-in */
  markups: Array<ArticleMarkupInterface>;
};

export enum ArticlePublicationState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED',
  Disabled = 'DISABLED'
}

export type ArticleQuote = {
  __typename?: 'ArticleQuote';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
  /** #logged-out #soft-logged-in */
  source?: Maybe<Scalars['String']>;
};

export type ArticleQuoteInput = {
  text: Scalars['String'];
  source?: Maybe<Scalars['String']>;
};

/** SEO related features */
export type ArticleSettings = {
  __typename?: 'ArticleSettings';
  /** #logged-out #soft-logged-in */
  noindex: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  titleTag isnt the same as the article title, its manually updated by SEO Managers
   */
  titleTag?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  descriptionTag isnt the same as the article description, its manually updated by SEO Managers
   */
  descriptionTag?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  membership: ArticleMembership;
};

export type ArticleSettingsInput = {
  noindex?: Maybe<Scalars['Boolean']>;
  titleTag?: Maybe<Scalars['String']>;
  descriptionTag?: Maybe<Scalars['String']>;
  membership?: Maybe<ArticleMembership>;
};

export type ArticleSimpleMarkupInput = {
  start: Scalars['Int'];
  end: Scalars['Int'];
};

export type ArticleSummary = {
  __typename?: 'ArticleSummary';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
};

export enum ArticleSupportedBlockTypes {
  ArticleParagraph = 'ARTICLE_PARAGRAPH',
  ArticleH2 = 'ARTICLE_H2',
  ArticleH3 = 'ARTICLE_H3',
  ArticleH4 = 'ARTICLE_H4',
  ArticleUnorderedListItem = 'ARTICLE_UNORDERED_LIST_ITEM',
  ArticleOrderedListItem = 'ARTICLE_ORDERED_LIST_ITEM',
  ArticleQuote = 'ARTICLE_QUOTE',
  ArticleEmphasis = 'ARTICLE_EMPHASIS',
  ArticleBodyImage = 'ARTICLE_BODY_IMAGE'
}

export type ArticleTextInput = {
  text: Scalars['String'];
};

export type ArticleTextWithMarkup = {
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
  /** #logged-out #soft-logged-in */
  markups: Array<ArticleMarkupInterface>;
};

export type ArticleTitle = {
  __typename?: 'ArticleTitle';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
};

export type ArticleUnorderedListItem = ArticleTextWithMarkup & {
  __typename?: 'ArticleUnorderedListItem';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
  /** #logged-out #soft-logged-in */
  markups: Array<ArticleMarkupInterface>;
};

/** Permissions provided by any service that implements articles */
export type ArticlesAbilitiesInterface = {
  /**
   * #logged-out #soft-logged-in
   *
   *  true if the current user can edit the article
   */
  canEdit: Scalars['Boolean'];
};

/** Representation of an article */
export type ArticlesArticle = HasGlobalId & {
  __typename?: 'ArticlesArticle';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Unique identifier for the Article (i.e. URN)
   */
  globalId: Scalars['GlobalID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Identifier for where the article belongs. E.g. a page, an insider, etc.
   */
  contextGlobalId: Scalars['GlobalID'];
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  where the article belongs. E.g. a page
   */
  context?: Maybe<ArticlesContextInterface>;
  /** #logged-out #soft-logged-in */
  header: ArticleHeader;
  /**
   * #logged-out #soft-logged-in
   *
   *  The article's content
   */
  blocks: Array<ArticleBlock>;
  /**
   * #logged-out #soft-logged-in
   *
   *  The date of publication. null indicates it's a draft.
   */
  publishedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  publicationState: ArticlePublicationState;
  /** #logged-out #soft-logged-in */
  slug: Scalars['SlugOrID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Most recent version of article; used for optimistic locking
   */
  lockVersion: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  The URN to be used when integrating social interactions into this article
   */
  socialInteractionTargetUrn?: Maybe<Scalars['GlobalID']>;
  /** #rest(batched) #virtual */
  socialInteractionTarget?: Maybe<SocialInteractionTarget>;
  /** #logged-out #soft-logged-in */
  visitUrl?: Maybe<Scalars['URL']>;
  /** #expand #logged-out #soft-logged-in */
  settings: ArticleSettings;
  /** #logged-out #soft-logged-in */
  content?: Maybe<Scalars['JSON']>;
  /** #logged-out #soft-logged-in */
  updatedAt: Scalars['Date'];
};

export type ArticlesArticleImageSettings = {
  __typename?: 'ArticlesArticleImageSettings';
  uploadUrl: Scalars['String'];
  downloadUrl: Scalars['String'];
};

/**
 * Enables any service to embed articles.
 * Ensures presence of the minimum context information required by clients.
 */
export type ArticlesContextInterface = {
  /** #logged-out #soft-logged-in */
  abilities: ArticlesAbilitiesInterface;
};

/**
 * Only submit one of the attributes.
 *
 * For `articleBodyImage`: passing the `id` of an existing block will keep its content unchanged and update its position if necessary.
 * Not passing an `id` or passing one that does not belong to the parent article will create a new image block.
 */
export type ArticlesCreateArticleBlocksInput = {
  articleParagraph?: Maybe<ArticlesTextWithMarkupsInput>;
  articleH2?: Maybe<ArticlesTextWithMarkupsInput>;
  articleH3?: Maybe<ArticlesTextWithMarkupsInput>;
  articleH4?: Maybe<ArticlesTextWithMarkupsInput>;
  articleOrderedListItem?: Maybe<ArticlesTextWithMarkupsInput>;
  articleUnorderedListItem?: Maybe<ArticlesTextWithMarkupsInput>;
  articleQuote?: Maybe<ArticleQuoteInput>;
  articleEmphasis?: Maybe<ArticleTextInput>;
  articleBodyImage?: Maybe<ArticleBodyImageInput>;
};

export type ArticlesCreateArticleHeaderInput = {
  title: ArticleTextInput;
  summary?: Maybe<ArticleTextInput>;
  cover?: Maybe<ArticleHeaderCoverInput>;
};

export type ArticlesCreateArticleImageInput = {
  articleGlobalId: Scalars['GlobalID'];
};

export type ArticlesCreateArticleImageResult = ArticlesArticleImageSettings | ArticlesError;

export type ArticlesCreateArticleInput = {
  contextGlobalId: Scalars['GlobalID'];
  header: ArticlesCreateArticleHeaderInput;
  blocks?: Maybe<Array<ArticlesCreateArticleBlocksInput>>;
  publish?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['Date']>;
  supportedBlockTypes?: Maybe<Array<ArticleSupportedBlockTypes>>;
  content?: Maybe<Scalars['JSON']>;
};

export type ArticlesDeleteArticleInput = {
  articleGlobalId: Scalars['GlobalID'];
};

export type ArticlesDeleteArticleResult = ArticlesArticle | ArticlesError;

export type ArticlesDisableArticleInput = {
  articleGlobalId: Scalars['GlobalID'];
};

export type ArticlesDisableArticleResult = ArticlesArticle | ArticlesError;

export type ArticlesEnableArticleInput = {
  articleGlobalId: Scalars['GlobalID'];
};

export type ArticlesEnableArticleResult = ArticlesArticle | ArticlesError;

export type ArticlesError = {
  __typename?: 'ArticlesError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  details?: Maybe<Array<Scalars['String']>>;
};

export type ArticlesPublishArticleInput = {
  articleGlobalId: Scalars['GlobalID'];
  supportedBlockTypes?: Maybe<Array<ArticleSupportedBlockTypes>>;
};

export type ArticlesPublishArticleResult = {
  __typename?: 'ArticlesPublishArticleResult';
  success?: Maybe<ArticlesArticle>;
  error?: Maybe<ArticlesError>;
};

export type ArticlesSaveArticleResult = {
  __typename?: 'ArticlesSaveArticleResult';
  success?: Maybe<ArticlesArticle>;
  error?: Maybe<ArticlesError>;
};

export type ArticlesTextWithMarkupsInput = {
  text: Scalars['String'];
  markups?: Maybe<Array<ArticleMarkupInput>>;
};

export type ArticlesUnpublishArticleInput = {
  articleGlobalId: Scalars['GlobalID'];
  supportedBlockTypes?: Maybe<Array<ArticleSupportedBlockTypes>>;
};

export type ArticlesUnpublishArticleResult = ArticlesArticle | ArticlesError;

export type ArticlesUpdateArticleInput = {
  lockVersion?: Maybe<Scalars['Int']>;
  articleGlobalId: Scalars['GlobalID'];
  header: ArticlesCreateArticleHeaderInput;
  blocks?: Maybe<Array<ArticlesCreateArticleBlocksInput>>;
  publishedAt?: Maybe<Scalars['Date']>;
  supportedBlockTypes?: Maybe<Array<ArticleSupportedBlockTypes>>;
  content?: Maybe<Scalars['JSON']>;
};

export type ArticlesUpdateArticleSettingsInput = {
  articleGlobalId: Scalars['GlobalID'];
  supportedBlockTypes?: Maybe<Array<ArticleSupportedBlockTypes>>;
  settings: ArticleSettingsInput;
};

export type AuctionAdPlaceholder = HasOperationalDataTrackingTokens & {
  __typename?: 'AuctionAdPlaceholder';
  channel: Scalars['String'];
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AuctionAttributes = {
  channel: Scalars['String'];
  adCount: Scalars['Int'];
  adTypes?: Maybe<Array<AdTypes>>;
  advertisementId?: Maybe<DeviceTrackingInput>;
  scrambledId?: Maybe<Scalars['String']>;
};

export type AuctionEventAd = WinningAd & {
  __typename?: 'AuctionEventAd';
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  dates: DateRange;
  /** #logged-out #soft-logged-in */
  location: EventLocation;
  /** #logged-out #soft-logged-in */
  targetSurn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  ticketPriceStart?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  ticketPriceEnd?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  ticketCurrency?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  networkParticipants?: Maybe<EventAdNetworkParticipants>;
  /** #logged-out #soft-logged-in */
  targetUrl: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  image: AdImage;
  /** #logged-out #soft-logged-in */
  showTicketPrices?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  linkedEvent?: Maybe<Scalars['Boolean']>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Field no longer supported
   */
  id: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  sid: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  surn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  type: AdTypes;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  sender: AdSender;
  /** #logged-out #soft-logged-in */
  deliveryId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated ODT shutdown
   */
  odtTrackingToken: Scalars['String'];
};

export type AuctionLeadAd = WinningAd & {
  __typename?: 'AuctionLeadAd';
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  leadAdFormId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  buttonCopy: Scalars['String'];
  /** #logged-out #soft-logged-in */
  targetUrl: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  image: AdImage;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Field no longer supported
   */
  id: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  sid: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  surn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  type: AdTypes;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  sender: AdSender;
  /** #logged-out #soft-logged-in */
  deliveryId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated ODT shutdown
   */
  odtTrackingToken: Scalars['String'];
};

export type AuctionPageAd = WinningAd & {
  __typename?: 'AuctionPageAd';
  /** #logged-out #soft-logged-in */
  imageUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  followerCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  userIsFollowing?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  slogan?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  entityPageAdId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated Field no longer supported
   */
  id: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  sid: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  surn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  type: AdTypes;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  sender: AdSender;
  /** #logged-out #soft-logged-in */
  deliveryId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated ODT shutdown
   */
  odtTrackingToken: Scalars['String'];
};

export type AuctionPostingAd = WinningAd & {
  __typename?: 'AuctionPostingAd';
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  subtype: PostingAdSubType;
  /** #logged-out #soft-logged-in */
  siteName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  linkTeaserText?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  linkImageUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  targetUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  image?: Maybe<AdImage>;
  /** #logged-out #soft-logged-in */
  postingActivitySurn?: Maybe<Scalars['GlobalID']>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Field no longer supported
   */
  id: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  sid: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  surn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  type: AdTypes;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  sender: AdSender;
  /** #logged-out #soft-logged-in */
  deliveryId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated ODT shutdown
   */
  odtTrackingToken: Scalars['String'];
};

export type AuctionVideoAd = WinningAd & {
  __typename?: 'AuctionVideoAd';
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  videoId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  videoRef: Scalars['SlugOrID'];
  /** #logged-out #soft-logged-in */
  thumbnails?: Maybe<Array<VideoAdImage>>;
  /** #logged-out #soft-logged-in */
  siteName: Scalars['String'];
  /** #logged-out #soft-logged-in */
  targetUrl: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  image: AdImage;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Field no longer supported
   */
  id: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  sid: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  surn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  type: AdTypes;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  sender: AdSender;
  /** #logged-out #soft-logged-in */
  deliveryId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated ODT shutdown
   */
  odtTrackingToken: Scalars['String'];
};

export type AuctionWebsiteAd = WinningAd & {
  __typename?: 'AuctionWebsiteAd';
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  siteName: Scalars['String'];
  /** #logged-out #soft-logged-in */
  targetUrl: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  image: AdImage;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Field no longer supported
   */
  id: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  sid: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  surn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  type: AdTypes;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  sender: AdSender;
  /** #logged-out #soft-logged-in */
  deliveryId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated ODT shutdown
   */
  odtTrackingToken: Scalars['String'];
};

export type AutocompletionCompanyNameSuggestion = {
  __typename?: 'AutocompletionCompanyNameSuggestion';
  /** Company urn */
  globalID?: Maybe<Scalars['GlobalID']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Suggestion text
   */
  suggestion?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Suggestion text with highlight
   */
  highlight?: Maybe<Scalars['String']>;
  /** Link to thumbnail size logo image from companies rest api (shrinked to 80x25) */
  thumbnail?: Maybe<Scalars['URL']>;
  /** Link to logo image from companies rest api (shrinked to 285x70) */
  logo?: Maybe<Scalars['URL']>;
  /** Tracking token for use in autocompletionTrack mutation */
  trackingToken?: Maybe<Scalars['String']>;
  /** 0-based position in suggestion list */
  position?: Maybe<Scalars['Int']>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Company object
   */
  company?: Maybe<Company>;
};

export type AutocompletionCompanyNameSuggestions = {
  __typename?: 'AutocompletionCompanyNameSuggestions';
  /** #logged-out #soft-logged-in */
  collection: Array<AutocompletionCompanyNameSuggestion>;
  /** Suggestions service name for use in autocompletionTrack mutation */
  service?: Maybe<Scalars['String']>;
  /** #virtual #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export type AutocompletionJobsSkillSuggestion = {
  __typename?: 'AutocompletionJobsSkillSuggestion';
  /** Unique identifier of the entity */
  id?: Maybe<Scalars['ID']>;
  /** URN of the entity */
  urn?: Maybe<Scalars['URN']>;
  /** Suggestion text */
  suggestion?: Maybe<Scalars['String']>;
  /** Tracking token */
  trackingToken?: Maybe<Scalars['String']>;
  /** 0-based position in suggestion list */
  position?: Maybe<Scalars['Int']>;
};

export type AutocompletionJobsSkillSuggestions = {
  __typename?: 'AutocompletionJobsSkillSuggestions';
  collection: Array<Maybe<AutocompletionJobsSkillSuggestion>>;
  /** Suggestions service name for use in autocompletionTrack mutation */
  service?: Maybe<Scalars['String']>;
  /** #virtual */
  total: Scalars['Int'];
};

export type AutocompletionLocationsCitySuggestion = {
  __typename?: 'AutocompletionLocationsCitySuggestion';
  /**
   * #logged-out #soft-logged-in
   *
   *  Suggestion text
   */
  name?: Maybe<Scalars['String']>;
  /** Suggestion text with highlight */
  highlight?: Maybe<Scalars['String']>;
  /** Tracking token */
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  0-based position in suggestion list
   */
  position?: Maybe<Scalars['Int']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City ID as int
   */
  cityId?: Maybe<Scalars['Int']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City ID
   */
  cityIdWithScrambling?: Maybe<Scalars['ID']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City's country code
   */
  countryCode?: Maybe<CountryCodesAlpha2>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City's country name
   */
  formattedCountry?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City's province name
   */
  adminArea?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City's province ID
   */
  adminAreaId?: Maybe<Scalars['Int']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City's province ID
   */
  adminAreaIdWithScrambling?: Maybe<Scalars['ID']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City's administrative district name
   */
  adminArea3?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City's administrative district ID
   */
  adminArea3Id?: Maybe<Scalars['Int']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City's administrative district ID
   */
  adminArea3IdWithScrambling?: Maybe<Scalars['ID']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City's zip codes
   */
  zipCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City's latitude
   */
  latitude?: Maybe<Scalars['Float']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  City's longitude
   */
  longitude?: Maybe<Scalars['Float']>;
};

export type AutocompletionLocationsCitySuggestions = {
  __typename?: 'AutocompletionLocationsCitySuggestions';
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<AutocompletionLocationsCitySuggestion>>;
  /** Suggestions service name for use in autocompletionTrack mutation */
  service?: Maybe<Scalars['String']>;
  /** #virtual #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export type AutocompletionProfileFieldOfStudySuggestion = {
  __typename?: 'AutocompletionProfileFieldOfStudySuggestion';
  /** Suggestion text */
  suggestion?: Maybe<Scalars['String']>;
  /** Tracking token for use in autocompletionTrack mutation */
  trackingToken?: Maybe<Scalars['String']>;
  /** 0-based position in suggestion list */
  position?: Maybe<Scalars['Int']>;
};

export type AutocompletionProfileFieldOfStudySuggestions = {
  __typename?: 'AutocompletionProfileFieldOfStudySuggestions';
  collection: Array<AutocompletionProfileFieldOfStudySuggestion>;
  /** Suggestions service name for use in autocompletionTrack mutation */
  service?: Maybe<Scalars['String']>;
  /** #virtual */
  total: Scalars['Int'];
};

export type AutocompletionProfileHaveSuggestion = {
  __typename?: 'AutocompletionProfileHaveSuggestion';
  /**
   * #logged-out #soft-logged-in
   *
   *  Suggestion text
   */
  suggestion?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Tracking token for use in autocompletionTrack mutation
   */
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  0-based position in suggestion list
   */
  position?: Maybe<Scalars['Int']>;
};

export type AutocompletionProfileHaveSuggestions = {
  __typename?: 'AutocompletionProfileHaveSuggestions';
  /** #logged-out #soft-logged-in */
  collection: Array<AutocompletionProfileHaveSuggestion>;
  /** Suggestions service name for use in autocompletionTrack mutation */
  service?: Maybe<Scalars['String']>;
  /** #virtual #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export type AutocompletionProfileJobRoleSuggestion = {
  __typename?: 'AutocompletionProfileJobRoleSuggestion';
  /**
   * #logged-out #soft-logged-in
   *
   *  Unique identifier of the entity
   */
  id?: Maybe<Scalars['ID']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  URN of the entity
   */
  urn?: Maybe<Scalars['URN']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Suggestion text
   */
  suggestion?: Maybe<Scalars['String']>;
  /** Suggestion text with highlight */
  highlight?: Maybe<Scalars['String']>;
  /** Tracking token for use in autocompletionTrack mutation */
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  0-based position in suggestion list
   */
  position?: Maybe<Scalars['Int']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Disciplines of the job role
   */
  disciplines?: Maybe<Array<Maybe<AutocompletionProfileJobRoleSuggestionDiscipline>>>;
};

export type AutocompletionProfileJobRoleSuggestionDiscipline = {
  __typename?: 'AutocompletionProfileJobRoleSuggestionDiscipline';
  /** Unique identifier of the entity */
  disciplineId?: Maybe<Scalars['ID']>;
  /** Identifier used by Xing tooling */
  xingId?: Maybe<Scalars['ID']>;
  relType?: Maybe<Scalars['String']>;
  /** Name of discipline */
  label?: Maybe<Scalars['String']>;
  /** Localized string to be shown */
  lang?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type AutocompletionProfileJobRoleSuggestions = {
  __typename?: 'AutocompletionProfileJobRoleSuggestions';
  /** #logged-out #soft-logged-in */
  collection: Array<AutocompletionProfileJobRoleSuggestion>;
  /** Suggestions service name for use in autocompletionTrack mutation */
  service?: Maybe<Scalars['String']>;
  /** #virtual #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export type AutocompletionProfileProfileSuggestion = {
  __typename?: 'AutocompletionProfileProfileSuggestion';
  /** Unique identifier of the entity */
  id?: Maybe<Scalars['ID']>;
  /**
   * #rest(batched) #virtual
   *
   *  The profile information for the user
   */
  xingId?: Maybe<XingId>;
  /** Tracking token */
  trackingToken?: Maybe<Scalars['String']>;
  /** 0-based position in suggestion list */
  position?: Maybe<Scalars['Int']>;
};

/**
 * Use this if you want only members incremental/autocomplete search. For more info about filters you can use check https://apidoc.xing.io/apidoc/?api=autocompletion%2Frest#/routes/getProfilesProfileSuggestions
 * If you need further support, contact nw-ds-support Slack channel.
 */
export type AutocompletionProfileProfileSuggestions = {
  __typename?: 'AutocompletionProfileProfileSuggestions';
  collection: Array<Maybe<AutocompletionProfileProfileSuggestion>>;
  /** #virtual */
  total: Scalars['Int'];
};

export type AutocompletionProfileUniversitySuggestion = {
  __typename?: 'AutocompletionProfileUniversitySuggestion';
  /** Suggestion text */
  suggestion?: Maybe<Scalars['String']>;
  /** Tracking token for use in autocompletionTrack mutation */
  trackingToken?: Maybe<Scalars['String']>;
  /** 0-based position in suggestion list */
  position?: Maybe<Scalars['Int']>;
};

export type AutocompletionProfileUniversitySuggestions = {
  __typename?: 'AutocompletionProfileUniversitySuggestions';
  collection: Array<AutocompletionProfileUniversitySuggestion>;
  /** Suggestions service name for use in autocompletionTrack mutation */
  service?: Maybe<Scalars['String']>;
  /** #virtual */
  total: Scalars['Int'];
};

export type AutomaticPool = {
  __typename?: 'AutomaticPool';
  id: Scalars['ID'];
  company?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Available Xing ID actions */
export enum AvailableAction {
  /** Make a contact request */
  AddContact = 'ADD_CONTACT',
  /** Add a ProBusiness Lead */
  AddLead = 'ADD_LEAD',
  /** Remove a ProBusiness Lead */
  RemoveLead = 'REMOVE_LEAD',
  /** Block a user. Only available for non contacts */
  BlockUser = 'BLOCK_USER',
  /** Bookmark interesting user. Only available for non contacts */
  BookmarkUser = 'BOOKMARK_USER',
  /** Call a contact. Only available on mobile */
  Call = 'CALL',
  /** Confirm a contact */
  ConfirmContact = 'CONFIRM_CONTACT',
  /** Delete an exiting contact */
  DeleteContact = 'DELETE_CONTACT',
  /** Decline contact request */
  DeclineContactRequest = 'DECLINE_CONTACT_REQUEST',
  /** Edit XING ID. Only available for self */
  EditXingId = 'EDIT_XING_ID',
  /** Follow a contact. Only available for insiders */
  Follow = 'FOLLOW',
  /** Import VCard. Only available on mobile */
  ImportVcard = 'IMPORT_VCARD',
  /** Invite user to a group. Only available for contacts */
  InviteGroup = 'INVITE_GROUP',
  /** Lunch Profile Filling Wizard. Only available for self */
  LaunchWizard = 'LAUNCH_WIZARD',
  /** Open settings page. Only available for self */
  OpenSettings = 'OPEN_SETTINGS',
  /** Open an XTM profile. Only available for contacts with XTM */
  OpenXtm = 'OPEN_XTM',
  /** Report contact. Only available for contacts */
  ReportProfile = 'REPORT_PROFILE',
  /** Send a message */
  SendMessage = 'SEND_MESSAGE',
  /** Share a contact. Only available on mobile */
  Share = 'SHARE',
  /** Show users contact details */
  ShowContactDetails = 'SHOW_CONTACT_DETAILS',
  /** Unblock a user. Only available for non contacts */
  UnblockUser = 'UNBLOCK_USER',
  /** Unbookmark a user. Only available for non contacts */
  UnbookmarkUser = 'UNBOOKMARK_USER',
  /** Unfollow a contact. Only available for insiders */
  Unfollow = 'UNFOLLOW',
  /** Show ProJobs settings related to career wishes. Only available for self */
  MyCareerWishes = 'MY_CAREER_WISHES',
  /** Show ProJobs career wishes to visitors. Only available for others */
  ShowCareerWishes = 'SHOW_CAREER_WISHES',
  /** Show a printable version of the Profile */
  Print = 'PRINT',
  /** Open the insider article collection */
  OpenInsiderCollection = 'OPEN_INSIDER_COLLECTION',
  /** Open preview of LO profile */
  OpenLoPreview = 'OPEN_LO_PREVIEW',
  /** Open recruiter preview of xtm */
  OpenRecruiterPreview = 'OPEN_RECRUITER_PREVIEW'
}

export type AvailableJob = {
  __typename?: 'AvailableJob';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  job?: Maybe<JobResult>;
  skillsMatchedCount?: Maybe<Scalars['Int']>;
  skillsNotMatchedCount?: Maybe<Scalars['Int']>;
  skillsTotal?: Maybe<Scalars['Int']>;
  skillsMatched?: Maybe<Array<Maybe<DreamJobSkills>>>;
  skillsNotMatched?: Maybe<Array<Maybe<DreamJobSkills>>>;
  experienceMatchedScore?: Maybe<Scalars['Int']>;
  experienceTotal?: Maybe<Scalars['Int']>;
  preferredIndustry?: Maybe<DreamJobIndusty>;
  preferredDiscipline?: Maybe<DreamJobDiscipline>;
  similarMembersCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  similarMembers?: Maybe<Array<Maybe<DreamJobSimilarMembers>>>;
  /** #logged-out #soft-logged-in */
  salary?: Maybe<JobSalary>;
  trackingToken?: Maybe<Scalars['String']>;
  urn?: Maybe<Scalars['URN']>;
};

export type B2BProfileFieldError = {
  __typename?: 'B2BProfileFieldError';
  error?: Maybe<Scalars['String']>;
};

export type B2BProfileSettings = {
  __typename?: 'B2BProfileSettings';
  businessEmail?: Maybe<Scalars['String']>;
  language?: Maybe<LanguageCode>;
  hashedEmail?: Maybe<Scalars['String']>;
  candidateSavedNotification?: Maybe<Scalars['Boolean']>;
  candidateFoundNotification?: Maybe<Scalars['Boolean']>;
};

export type B2BProfileSettingsError = {
  __typename?: 'B2BProfileSettingsError';
  errors?: Maybe<B2BProfileSettingsErrors>;
};

export type B2BProfileSettingsErrors = {
  __typename?: 'B2BProfileSettingsErrors';
  businessEmail?: Maybe<Array<Maybe<B2BProfileFieldError>>>;
  language?: Maybe<Array<Maybe<B2BProfileFieldError>>>;
};

export type B2BProfileSettingsInput = {
  businessEmail?: Maybe<Scalars['String']>;
  language?: Maybe<LanguageCode>;
  candidateSavedNotification?: Maybe<Scalars['Boolean']>;
  candidateFoundNotification?: Maybe<Scalars['Boolean']>;
};

export type B2BProfileSettingsSuccess = {
  __typename?: 'B2BProfileSettingsSuccess';
  data?: Maybe<B2BProfileSettings>;
};

export type BannerProperty = {
  __typename?: 'BannerProperty';
  value?: Maybe<Scalars['Boolean']>;
};

export type BannerPropertyDisableError = {
  __typename?: 'BannerPropertyDisableError';
  message: Scalars['String'];
};

export type BannerPropertyDisableInput = {
  propertyName?: Maybe<BannerPropertyName>;
};

export type BannerPropertyDisableResult = BannerPropertyDisableSuccess | BannerPropertyDisableError;

export type BannerPropertyDisableSuccess = {
  __typename?: 'BannerPropertyDisableSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export enum BannerPropertyName {
  DisplayInsightsBanner = 'DISPLAY_INSIGHTS_BANNER'
}

export type BaseApplyQuestion = {
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

/** Deprecated: JobSeeker object for Basic and Premium Users */
export type Basic = JobSeeker & {
  __typename?: 'Basic';
  /** @deprecated The type Basic is deprecated, this field will be removed soon. WILL BE REMOVED ... */
  statusVisibility?: Maybe<StatusVisibility>;
  id: Scalars['ID'];
  /** #paginated #rest #virtual */
  idealEmployers?: Maybe<ProJobsIdealEmployersConnection>;
  isPendingFirstEdit: Scalars['Boolean'];
  seekingStatus: SeekingStatus;
  salaryExpectation?: Maybe<Salary>;
};


/** Deprecated: JobSeeker object for Basic and Premium Users */
export type BasicIdealEmployersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

/** Count of contacts for a specific user */
export type BatchContactsCount = {
  __typename?: 'BatchContactsCount';
  id: Scalars['ID'];
  count: Scalars['Int'];
};

/** Personal Details module data of the user */
export type BirthDate = {
  __typename?: 'BirthDate';
  day: Scalars['Int'];
  month: Scalars['Int'];
  year?: Maybe<Scalars['Int']>;
};

export type BirthDateUpdateInput = {
  day: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type BirthdayConversationStarter = ConversationStarter & {
  __typename?: 'BirthdayConversationStarter';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  object?: Maybe<PersonalDetails>;
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type BirthdayNotification = Notification & {
  __typename?: 'BirthdayNotification';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  object?: Maybe<PersonalDetails>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type BirthdayStack = SignalsStack & {
  __typename?: 'BirthdayStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type BirthdayStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type BlacklistedSkills = {
  __typename?: 'BlacklistedSkills';
  userId: Scalars['ID'];
  skills: Array<Scalars['ID']>;
};

export type BlacklistedSkillsError = {
  __typename?: 'BlacklistedSkillsError';
  error: Scalars['String'];
};

export type BlacklistedSkillsInput = {
  skills: Array<Scalars['ID']>;
};

export type BlacklistedSkillsResult = BlacklistedSkills | BlacklistedSkillsError;

/** BlockedCompanies Type */
export type BlockedCompanies = {
  __typename?: 'BlockedCompanies';
  /** #rest(batched) #virtual */
  companies: Array<Maybe<Company>>;
};

export type BlockedEntitiesConnection = HasCursorPagination & {
  __typename?: 'BlockedEntitiesConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<BlockedEntitiesEdge>;
};

export type BlockedEntitiesEdge = PaginationEdge & {
  __typename?: 'BlockedEntitiesEdge';
  cursor: Scalars['String'];
  urn: Scalars['GlobalID'];
  /** #rest(batched) #virtual */
  node: BlockingServiceBlockedEntityObject;
};

export type BlockedEntitiesPage = {
  __typename?: 'BlockedEntitiesPage';
  /** #paginated #rest #virtual */
  blockedEntitiesPaginated?: Maybe<BlockedEntitiesConnection>;
};


export type BlockedEntitiesPageBlockedEntitiesPaginatedArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  entitiesSelection?: Maybe<BlockedServiceEntitiesSelection>;
};

export enum BlockedServiceEntitiesSelection {
  /** Return only blocked user entities */
  Users = 'USERS',
  /** Return only non users blocked entities */
  NonUsers = 'NON_USERS'
}

export type BlockingServiceBlockError = {
  __typename?: 'BlockingServiceBlockError';
  message?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['JSON']>;
};

export type BlockingServiceBlockInput = {
  urns?: Maybe<Array<Scalars['GlobalID']>>;
};

export type BlockingServiceBlockResult = BlockingServiceBlockSuccess | BlockingServiceBlockError;

export type BlockingServiceBlockSuccess = {
  __typename?: 'BlockingServiceBlockSuccess';
  message?: Maybe<Scalars['String']>;
};

export type BlockingServiceBlockedEntity = {
  __typename?: 'BlockingServiceBlockedEntity';
  id: Scalars['ID'];
  urn: Scalars['GlobalID'];
  entityType: Scalars['String'];
};

export type BlockingServiceBlockedEntityObject = XingId | BlockingServiceBlockedEntity;

export type BlockingServiceUnblockError = {
  __typename?: 'BlockingServiceUnblockError';
  message?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['JSON']>;
};

export type BlockingServiceUnblockInput = {
  urn: Scalars['GlobalID'];
};

export type BlockingServiceUnblockResult = BlockingServiceUnblockSuccess | BlockingServiceUnblockError;

export type BlockingServiceUnblockSuccess = {
  __typename?: 'BlockingServiceUnblockSuccess';
  message?: Maybe<Scalars['String']>;
};

export type BookmarkedByRecruiterNotification = Notification & {
  __typename?: 'BookmarkedByRecruiterNotification';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type BooleanCustomQuestion = BaseApplyQuestion & {
  __typename?: 'BooleanCustomQuestion';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

export type BoundedTotal = {
  __typename?: 'BoundedTotal';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  bound: Scalars['Int'];
};

export type BpayClientBalance = {
  __typename?: 'BpayClientBalance';
  /** ISO-4217 currency codes. e.g. EUR, USD, CHF */
  currency?: Maybe<PaymentCurrency>;
  /** Amount in cents. e.g. 25.17 EUR would be 2517 */
  amountCents?: Maybe<Scalars['Int']>;
  /** A product group related to the credit/discount amount */
  productGroup?: Maybe<PaymentClientProductGroup>;
};

/** Client credit/discount balance data */
export type BpayClientBalanceData = {
  __typename?: 'BpayClientBalanceData';
  /** An array of discounts of the client with product group and currency */
  discountBalance?: Maybe<Array<BpayClientBalance>>;
  /** An array of credits of the client with product group and currency */
  creditBalance?: Maybe<Array<BpayClientBalance>>;
  /** An array of discounts with expiration date and amount left specified */
  expiringDiscounts?: Maybe<Array<BpayExpiringClientDiscount>>;
  /** Blocked discount means contract of the discount has `blocked_invoice` in `true` */
  hasBlockedDiscounts: Scalars['Boolean'];
  /** Blocked credit means contract of the credit has `blocked_invoice` in `true` */
  hasBlockedCredits: Scalars['Boolean'];
};

export type BpayClientBalanceResult = BpayClientBalanceData | ErrorResponse;

export type BpayCreditCardUrl = {
  __typename?: 'BpayCreditCardUrl';
  url?: Maybe<Scalars['String']>;
};

export type BpayExpiringClientDiscount = {
  __typename?: 'BpayExpiringClientDiscount';
  id?: Maybe<Scalars['ID']>;
  /** A discount expiration date */
  expiresAt?: Maybe<Scalars['String']>;
  /** An amount left after discount usages, in cents. e.g. 25.17 EUR would be 2517 */
  amountCentsLeft?: Maybe<Scalars['Int']>;
};

/** Link type */
export type BpayLink = {
  __typename?: 'BpayLink';
  url?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** Pay method types */
export type BpayPaymentMethodData = {
  type: Scalars['String'];
  clientName: Scalars['String'];
};

/** Payment method Query/Mutation */
export type BpayPaymentMethodDataResult = CreditCardData | DirectDebitData | InvoiceData | ErrorResponse;

export type BpayPaymentMethodInput = {
  paymethod: BpayPaymentMethodTypeInput;
  sepa?: Maybe<BpaySepaPaymentMethodInput>;
  clientId?: Maybe<Scalars['ID']>;
  embeddedBy?: Maybe<Scalars['String']>;
  testActionAllowed?: Maybe<Scalars['Boolean']>;
};

export enum BpayPaymentMethodTypeInput {
  Invoice = 'INVOICE',
  Sepa = 'SEPA'
}

export type BpayProductGroupRunningContractsResponse = {
  __typename?: 'BpayProductGroupRunningContractsResponse';
  productGroupLink?: Maybe<BpayLink>;
  contractsSummary?: Maybe<Scalars['String']>;
  runningContractProducts?: Maybe<Array<Maybe<BpayRunningContractsTable>>>;
};

export type BpayProductGroupRunningContractsResult = BpayProductGroupRunningContractsResponse | ErrorResponse;

export type BpayRunningContractsTable = {
  __typename?: 'BpayRunningContractsTable';
  productName: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  renewalDate?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  amount: PaymentPrice;
};

/** Input for updating payment method */
export type BpaySepaPaymentMethodInput = {
  iban: Scalars['String'];
  accountHolder: Scalars['String'];
  tandc: Scalars['Boolean'];
};

export type Briefing = {
  __typename?: 'Briefing';
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startedAt?: Maybe<Scalars['Date']>;
  status: BriefingStatus;
  url: Scalars['String'];
  urn?: Maybe<Scalars['GlobalID']>;
  candidates?: Maybe<Array<Candidate>>;
};

/** Types for Xing Sourcing Service Briefing Candidates */
export enum BriefingCandidateClientStatus {
  Contacted = 'CONTACTED',
  NotContacted = 'NOT_CONTACTED',
  Interested = 'INTERESTED',
  Uninterested = 'UNINTERESTED',
  Rejected = 'REJECTED'
}

export type BriefingConnection = HasCursorPagination & {
  __typename?: 'BriefingConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<BriefingEdge>>;
};

export type BriefingDetailsSummary = {
  __typename?: 'BriefingDetailsSummary';
  /** #virtual */
  briefing: Briefing;
};

export type BriefingEdge = PaginationEdge & {
  __typename?: 'BriefingEdge';
  cursor: Scalars['String'];
  node: Briefing;
};

export enum BriefingStatus {
  Created = 'CREATED',
  Draft = 'DRAFT',
  Started = 'STARTED',
  Finished = 'FINISHED',
  Archived = 'ARCHIVED'
}

export type Candidate = {
  __typename?: 'Candidate';
  /** #rest(batched) #virtual */
  profileDetails?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  profileAdditionalDetails?: Maybe<ProfileAdditionalDetails>;
  message?: Maybe<Scalars['String']>;
  reasons?: Maybe<Array<Scalars['String']>>;
  urn?: Maybe<Scalars['GlobalID']>;
};

export type CandidateConnection = HasCursorPagination & {
  __typename?: 'CandidateConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<CandidateEdge>>;
};

export type CandidateEdge = PaginationEdge & {
  __typename?: 'CandidateEdge';
  cursor: Scalars['String'];
  node: Candidate;
};

export type CandidateSearch = {
  __typename?: 'CandidateSearch';
  id: Scalars['ID'];
  status: CandidateSearchStatus;
  candidatesFound: Scalars['Int'];
  excludedCompanyIds?: Maybe<Array<Scalars['ID']>>;
};

export type CandidateSearchAggregations = {
  __typename?: 'CandidateSearchAggregations';
  jobRoles?: Maybe<Array<Maybe<CandidateSearchJobRoleAggregation>>>;
  currentJobRoles?: Maybe<Array<Maybe<CandidateSearchJobRoleAggregation>>>;
  previousJobRoles?: Maybe<Array<Maybe<CandidateSearchJobRoleAggregation>>>;
  anyJobRoles?: Maybe<Array<Maybe<CandidateSearchJobRoleAggregation>>>;
  currentTitle?: Maybe<Array<Maybe<CandidateSearchTitleAggregation>>>;
  previousTitle?: Maybe<Array<Maybe<CandidateSearchTitleAggregation>>>;
  careerLevel?: Maybe<Array<Maybe<CandidateSearchCareerLevelAggregation>>>;
  skills?: Maybe<Array<Maybe<CandidateSearchSkillsAggregation>>>;
  city?: Maybe<Array<Maybe<CandidateSearchCityAggregation>>>;
  anyCities?: Maybe<Array<Maybe<CandidateSearchAnyCityAggregation>>>;
  workExperience?: Maybe<Array<Maybe<CandidateSearchWorkExperienceAggregation>>>;
  wtcj?: Maybe<Array<Maybe<CandidateSearchWtcjAggregation>>>;
  jobseekerCities?: Maybe<Array<Maybe<CandidateSearchJobseekerCityAggregation>>>;
  currentDiscipline?: Maybe<Array<Maybe<CandidateSearchCurrentDisciplineAggregation>>>;
  jobseekerDiscipline?: Maybe<Array<Maybe<CandidateSearchJobseekerDisciplineAggregation>>>;
  anyDiscipline?: Maybe<Array<Maybe<CandidateSearchAnyDisciplineAggregation>>>;
  jobseekerSalary?: Maybe<Array<Maybe<CandidateSearchJobseekerSalaryAggregation>>>;
  jobseekerCareerLevel?: Maybe<Array<Maybe<CandidateSearchJobseekerCareerLevelAggregation>>>;
  anyCareerLevel?: Maybe<Array<Maybe<CandidateSearchAnyCareerLevelAggregation>>>;
  jobseekerStatus?: Maybe<Array<Maybe<CandidateSearchJobseekerStatusAggregation>>>;
  languages?: Maybe<Array<Maybe<CandidateSearchLanguagesAggregation>>>;
  languagesWithLevel?: Maybe<Array<Maybe<CandidateSearchLanguagesWithLevelAggregation>>>;
  currentWorkExperienceStartAt?: Maybe<Array<Maybe<CandidateSearchCurrentWorkExperienceStartAtAggregation>>>;
  employmentType?: Maybe<Array<Maybe<CandidateSearchEmploymentTypeAggregation>>>;
  jobseekerWorkplace?: Maybe<Array<Maybe<CandidateSearchJobseekerWorkplaceAggregation>>>;
  jobseekerWorkingHours?: Maybe<Array<Maybe<CandidateSearchJobseekerWorkingHoursAggregation>>>;
  currentIndustries?: Maybe<Array<Maybe<CandidateSearchCurrentIndustriesAggregation>>>;
  jobseekerIndustries?: Maybe<Array<Maybe<CandidateSearchJobseekerIndustriesAggregation>>>;
  anyIndustries?: Maybe<Array<Maybe<CandidateSearchAnyIndustriesAggregation>>>;
  jobseekerWillingnessToTravel?: Maybe<Array<Maybe<CandidateSearchJobseekerWillingnessToTravelAggregation>>>;
  currentCompany?: Maybe<Array<Maybe<CandidateSearchCurrentCompanyAggregation>>>;
  previousCompany?: Maybe<Array<Maybe<CandidateSearchPreviousCompanyAggregation>>>;
  anyCompany?: Maybe<Array<Maybe<CandidateSearchAnyCompanyAggregation>>>;
  jobseekerEmployers?: Maybe<Array<Maybe<CandidateSearchJobseekerEmployersAggregation>>>;
  currentCompanySize?: Maybe<Array<Maybe<CandidateSearchCurrentCompanySizeAggregation>>>;
  jobseekerJobTitle?: Maybe<Array<Maybe<CandidateSearchJobseekerJobTitleAggregation>>>;
  country?: Maybe<Array<Maybe<CandidateSearchCountryAggregation>>>;
  talentPools?: Maybe<Array<Maybe<TalentPoolsAggregation>>>;
};

/** Available aggregations (facets) for candidate search. It's expecting the number of aggregations to return. For performance reasons it shouldn't be greater than 20. */
export type CandidateSearchAggregationsInput = {
  jobRoles?: Maybe<Scalars['Int']>;
  currentJobRoles?: Maybe<Scalars['Int']>;
  previousJobRoles?: Maybe<Scalars['Int']>;
  anyJobRoles?: Maybe<Scalars['Int']>;
  currentTitle?: Maybe<Scalars['Int']>;
  previousTitle?: Maybe<Scalars['Int']>;
  careerLevel?: Maybe<Scalars['Int']>;
  skills?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['Int']>;
  anyCities?: Maybe<Scalars['Int']>;
  workExperience?: Maybe<Scalars['Int']>;
  wtcj?: Maybe<Scalars['Int']>;
  jobseekerCities?: Maybe<Scalars['Int']>;
  currentDiscipline?: Maybe<Scalars['Int']>;
  jobseekerDiscipline?: Maybe<Scalars['Int']>;
  anyDiscipline?: Maybe<Scalars['Int']>;
  jobseekerSalary?: Maybe<Scalars['Int']>;
  jobseekerCareerLevel?: Maybe<Scalars['Int']>;
  anyCareerLevel?: Maybe<Scalars['Int']>;
  jobseekerStatus?: Maybe<Scalars['Int']>;
  languages?: Maybe<Scalars['Int']>;
  languagesWithLevel?: Maybe<Scalars['Int']>;
  currentWorkExperienceStartAt?: Maybe<Scalars['Int']>;
  employmentType?: Maybe<Scalars['Int']>;
  jobseekerWorkplace?: Maybe<Scalars['Int']>;
  jobseekerWorkingHours?: Maybe<Scalars['Int']>;
  currentIndustries?: Maybe<Scalars['Int']>;
  jobseekerIndustries?: Maybe<Scalars['Int']>;
  anyIndustries?: Maybe<Scalars['Int']>;
  jobseekerWillingnessToTravel?: Maybe<Scalars['Int']>;
  currentCompany?: Maybe<Scalars['Int']>;
  previousCompany?: Maybe<Scalars['Int']>;
  anyCompany?: Maybe<Scalars['Int']>;
  jobseekerEmployers?: Maybe<Scalars['Int']>;
  currentCompanySize?: Maybe<Scalars['Int']>;
  jobseekerJobTitle?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['Int']>;
  talentPools?: Maybe<Scalars['Int']>;
};

export type CandidateSearchAnyCareerLevelAggregation = {
  __typename?: 'CandidateSearchAnyCareerLevelAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  level?: Maybe<CareerLevel>;
};

export type CandidateSearchAnyCityAggregation = {
  __typename?: 'CandidateSearchAnyCityAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  city?: Maybe<City>;
};

export type CandidateSearchAnyCompanyAggregation = {
  __typename?: 'CandidateSearchAnyCompanyAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  name?: Maybe<Scalars['String']>;
};

export type CandidateSearchAnyDisciplineAggregation = {
  __typename?: 'CandidateSearchAnyDisciplineAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
};

export type CandidateSearchAnyIndustriesAggregation = {
  __typename?: 'CandidateSearchAnyIndustriesAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  industries?: Maybe<Industry>;
};

export type CandidateSearchCareerLevelAggregation = {
  __typename?: 'CandidateSearchCareerLevelAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  level?: Maybe<CareerLevel>;
};

export type CandidateSearchCityAggregation = {
  __typename?: 'CandidateSearchCityAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  city?: Maybe<City>;
};

export type CandidateSearchCollection = {
  __typename?: 'CandidateSearchCollection';
  collection: Array<CandidateSearchResultItem>;
  aggs?: Maybe<CandidateSearchAggregations>;
  total: Scalars['Int'];
  took: Scalars['Int'];
  service?: Maybe<Scalars['String']>;
  requestTrackingToken?: Maybe<Scalars['String']>;
};

export type CandidateSearchCountryAggregation = {
  __typename?: 'CandidateSearchCountryAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CandidateSearchCurrentCompanyAggregation = {
  __typename?: 'CandidateSearchCurrentCompanyAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  name?: Maybe<Scalars['String']>;
};

export type CandidateSearchCurrentCompanySizeAggregation = {
  __typename?: 'CandidateSearchCurrentCompanySizeAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type CandidateSearchCurrentDisciplineAggregation = {
  __typename?: 'CandidateSearchCurrentDisciplineAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
};

export type CandidateSearchCurrentIndustriesAggregation = {
  __typename?: 'CandidateSearchCurrentIndustriesAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  industries?: Maybe<Industry>;
};

export type CandidateSearchCurrentWorkExperienceStartAtAggregation = {
  __typename?: 'CandidateSearchCurrentWorkExperienceStartAtAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type CandidateSearchDetailsSummary = {
  __typename?: 'CandidateSearchDetailsSummary';
  /** #virtual */
  candidateSearch: CandidateSearch;
};

export type CandidateSearchEmploymentTypeAggregation = {
  __typename?: 'CandidateSearchEmploymentTypeAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  employmentType?: Maybe<WorkExperienceStatus>;
};

/** Available filters for candidate search. The possible values for each filter are the one listed as values in the corresponding aggregations. */
export type CandidateSearchFiltersInput = {
  /** Job role ids to filter by (combined current and previous) */
  jobRolesIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Current job role ids to filter by */
  currentJobRolesIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Previous job role ids to filter by */
  previousJobRolesIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Any job role ids to filter by */
  anyJobRolesIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Job title tags to filter by */
  currentTitle?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Job title tags to filter by */
  previousTitle?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Career level ids to filter by */
  careerLevel?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Skill ids to filter by */
  skills?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by comma-separated list of city ids */
  city?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by comma-separated list of city ids */
  anyCities?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filters results found within the given distance(in kms) from the given point(Example: 0.47,0.52,10). Distance can't be 0. Note that city filter should be unset if distance filter is used. */
  distance?: Maybe<Scalars['String']>;
  /** Work experience values to filter by */
  workExperience?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** WTCJ values to filter by */
  wtcj?: Maybe<Array<Maybe<TracyWillingnessToChangeJobsClass>>>;
  /** Excluded candidate ids */
  excludedCandidates?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** jobseeker cities values to filter by */
  jobseekerCities?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** current discipline to filter by */
  currentDiscipline?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** jobseeker discipline (preferred) values to filter by */
  jobseekerDiscipline?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** anyDiscipline (current and preferred) values to filter by */
  anyDiscipline?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** jobseeker salary values to filter by */
  jobseekerSalary?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** jobseeker career level values to filter by */
  jobseekerCareerLevel?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Any Career level to filter by */
  anyCareerLevel?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** jobseeker status values to filter by */
  jobseekerStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** languages values to filter by */
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** languages with level values to filter by */
  languagesWithLevel?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** exclude from search candidates in the projects with the given ids */
  excludedProjects?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by work experience start date */
  currentWorkExperienceStartAt?: Maybe<Scalars['String']>;
  /** Filter by employment type */
  employmentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter by jobseeker workplace */
  jobseekerWorkplace?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter by jobseeker working hours */
  jobseekerWorkingHours?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter by current industries */
  currentIndustries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by jobseeker industries */
  jobseekerIndustries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by any industries */
  anyIndustries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by jobseeker willingness to travel */
  jobseekerWillingnessToTravel?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter by current company */
  currentCompany?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter by previous company */
  previousCompany?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter by any company (current and previous) */
  anyCompany?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter by jobseeker employers */
  jobseekerEmployers?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter by current company size from 1 to 9 */
  currentCompanySize?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by talent pool ids, can be more than one comma separated */
  talentPools?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by jobseeker job title */
  jobseekerJobTitle?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by xing user ids */
  xingIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by country */
  country?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter by contact level */
  contactLevel?: Maybe<Scalars['Int']>;
  /** Filter by membership features */
  membership?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter by active status */
  active?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter by new members */
  completedAt?: Maybe<Scalars['String']>;
  /** Filter by assigned to company XTM projects */
  assignedTo?: Maybe<Scalars['ID']>;
  /** Filter by not assigned to company XTM projects */
  notAssignedTo?: Maybe<Scalars['ID']>;
  /** Post filter to return only facets for the given talent pool ids */
  availableTalentPoolIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type CandidateSearchHighlight = {
  __typename?: 'CandidateSearchHighlight';
  currentTitle?: Maybe<Array<Maybe<Scalars['String']>>>;
  previousTitle?: Maybe<Array<Maybe<Scalars['String']>>>;
  currentCompany?: Maybe<Array<Maybe<Scalars['String']>>>;
  previousCompany?: Maybe<Array<Maybe<Scalars['String']>>>;
  skills?: Maybe<Array<Maybe<Scalars['String']>>>;
  education?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CandidateSearchJobRoleAggregation = {
  __typename?: 'CandidateSearchJobRoleAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #virtual */
  role?: Maybe<JobRoleLabel>;
};

export type CandidateSearchJobseekerCareerLevelAggregation = {
  __typename?: 'CandidateSearchJobseekerCareerLevelAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  level?: Maybe<CareerLevel>;
};

export type CandidateSearchJobseekerCityAggregation = {
  __typename?: 'CandidateSearchJobseekerCityAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  city?: Maybe<City>;
};

export type CandidateSearchJobseekerDisciplineAggregation = {
  __typename?: 'CandidateSearchJobseekerDisciplineAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
};

export type CandidateSearchJobseekerEmployersAggregation = {
  __typename?: 'CandidateSearchJobseekerEmployersAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  name?: Maybe<Scalars['String']>;
};

export type CandidateSearchJobseekerIndustriesAggregation = {
  __typename?: 'CandidateSearchJobseekerIndustriesAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  industries?: Maybe<Industry>;
};

export type CandidateSearchJobseekerJobTitleAggregation = {
  __typename?: 'CandidateSearchJobseekerJobTitleAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #virtual */
  role?: Maybe<JobRoleLabel>;
};

export type CandidateSearchJobseekerSalaryAggregation = {
  __typename?: 'CandidateSearchJobseekerSalaryAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type CandidateSearchJobseekerStatusAggregation = {
  __typename?: 'CandidateSearchJobseekerStatusAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type CandidateSearchJobseekerWillingnessToTravelAggregation = {
  __typename?: 'CandidateSearchJobseekerWillingnessToTravelAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CandidateSearchJobseekerWorkingHoursAggregation = {
  __typename?: 'CandidateSearchJobseekerWorkingHoursAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CandidateSearchJobseekerWorkplaceAggregation = {
  __typename?: 'CandidateSearchJobseekerWorkplaceAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CandidateSearchLanguagesAggregation = {
  __typename?: 'CandidateSearchLanguagesAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type CandidateSearchLanguagesWithLevelAggregation = {
  __typename?: 'CandidateSearchLanguagesWithLevelAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type CandidateSearchPreviousCompanyAggregation = {
  __typename?: 'CandidateSearchPreviousCompanyAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  name?: Maybe<Scalars['String']>;
};

/** Available queries for candidate search. The difference between queries and filters is that queries is a free text search with support of boolean operators. */
export type CandidateSearchQueriesInput = {
  keywords?: Maybe<Scalars['String']>;
};

export type CandidateSearchResultItem = {
  __typename?: 'CandidateSearchResultItem';
  /** Unique identifier of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Identifier of the entry (same as id) */
  itemId?: Maybe<Scalars['ID']>;
  /**
   * #rest(batched) #virtual
   *
   *  The profile information for the candidate
   */
  profile?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  profileAdditionalDetails?: Maybe<ProfileAdditionalDetails>;
  /** Highlights of found keywords */
  highlight?: Maybe<CandidateSearchHighlight>;
  /** Xtm Glances */
  xtmGlances?: Maybe<XtmGlances>;
  /**
   * #rest(batched) #virtual
   *
   *  If is possible to send messages to the candidate
   */
  canSendMessageTo?: Maybe<Scalars['Boolean']>;
  /**
   * #rest(batched) #virtual
   *
   *  Willingness To Change Job of the candidate
   */
  wtcj?: Maybe<WillingnessToChangeJob>;
  /** Tracking token */
  trackingToken?: Maybe<Scalars['String']>;
  /** 0-based position in suggestion list */
  position?: Maybe<Scalars['Int']>;
  /** score of item in suggestion list */
  score?: Maybe<Scalars['Float']>;
  /** urn of the item */
  urn?: Maybe<Scalars['GlobalID']>;
};

export type CandidateSearchSkillsAggregation = {
  __typename?: 'CandidateSearchSkillsAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
  /** #virtual */
  skill?: Maybe<OntologyEntityLabel>;
};

export enum CandidateSearchStatus {
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type CandidateSearchTitleAggregation = {
  __typename?: 'CandidateSearchTitleAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  label?: Maybe<Scalars['String']>;
};

export type CandidateSearchWtcjAggregation = {
  __typename?: 'CandidateSearchWTCJAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type CandidateSearchWorkExperienceAggregation = {
  __typename?: 'CandidateSearchWorkExperienceAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type Candidates = {
  __typename?: 'Candidates';
  id?: Maybe<Scalars['ID']>;
  trackingToken?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Float']>;
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type CareerHubArticle = {
  __typename?: 'CareerHubArticle';
  /**
   * #logged-out #soft-logged-in
   * @deprecated [ACQ-980]Should represent CareerHubArticle.id
   */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  resourceType: CareerHubArticleType;
  /** #logged-out #soft-logged-in */
  urn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  url: Scalars['URL'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Title of the article
   */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  description: Scalars['String'];
  /** #logged-out #soft-logged-in */
  image: CareerHubArticleImage;
  /** #logged-out #soft-logged-in */
  actorUrn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  pageUrl: Scalars['URL'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Title of the page/author of the article
   */
  pageTitle: Scalars['String'];
  /** #logged-out #soft-logged-in */
  pageLogos: CareerHubArticlePageLogo;
};

export type CareerHubArticleImage = {
  __typename?: 'CareerHubArticleImage';
  /** #logged-out #soft-logged-in */
  srcSquare?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcSquare2x?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcWide?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcWide2x?: Maybe<Scalars['URL']>;
};

export type CareerHubArticlePageLogo = {
  __typename?: 'CareerHubArticlePageLogo';
  /** #logged-out #soft-logged-in */
  original?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  web?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square32?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square48?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square64?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square96?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square128?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square144?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square256?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square384?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square1024?: Maybe<Scalars['URL']>;
};

export enum CareerHubArticleType {
  ContentFulltextArticle = 'CONTENT_FULLTEXT_ARTICLE',
  ContentVideoArticle = 'CONTENT_VIDEO_ARTICLE',
  ArticlesArticle = 'ARTICLES_ARTICLE'
}

export type CareerHubGlossaryArticle = {
  __typename?: 'CareerHubGlossaryArticle';
  /** #logged-out #soft-logged-in */
  url: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
};

export type CareerHubGlossaryCollection = {
  __typename?: 'CareerHubGlossaryCollection';
  /**
   * #logged-out #soft-logged-in
   *
   *  Index letter
   */
  letter?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in #expand
   *
   *  Articles inside the index letter
   */
  articles: Array<Maybe<CareerHubGlossaryArticle>>;
};

export type CareerHubGlossaryResponse = {
  __typename?: 'CareerHubGlossaryResponse';
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<CareerHubGlossaryCollection>>;
};

export type CareerHubTopic = {
  __typename?: 'CareerHubTopic';
  /**
   * #logged-out #soft-logged-in
   *
   *  Topic name
   */
  title: Scalars['String'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Topic description
   */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  key: Scalars['String'];
  /**
   * #logged-out #soft-logged-in
   *
   *  URN of the evergreen article from Articles backend
   */
  evergreenArticleUrn: Scalars['GlobalID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Articles inside the topic
   */
  articles: Array<Maybe<CareerHubArticle>>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Topic tracking key
   */
  trackingKey: Scalars['String'];
};

export type CareerHubTopicPageResponse = {
  __typename?: 'CareerHubTopicPageResponse';
  /**
   * #logged-out #soft-logged-in
   *
   *  Topic title name
   */
  title: Scalars['String'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Evergreen title name
   */
  evergreenTitle: Scalars['String'];
  /** #logged-out #soft-logged-in */
  introduction: Array<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  evergreenArticleUrn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  articles: Array<Maybe<CareerHubArticle>>;
};

export type CareerHubTopicsResponse = {
  __typename?: 'CareerHubTopicsResponse';
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<CareerHubTopic>>;
};

export type CareerLevel = Localizable & {
  __typename?: 'CareerLevel';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
};

export type CareerLevelElement = {
  __typename?: 'CareerLevelElement';
  careerLevelId: Scalars['ID'];
  /** #rest(batched) #virtual */
  careerLevel?: Maybe<CareerLevel>;
  total: Scalars['Int'];
};

/** CareerLevelPreference Type */
export type CareerLevelPreference = {
  __typename?: 'CareerLevelPreference';
  /** #logged-out #soft-logged-in */
  minimum?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  maximum?: Maybe<Scalars['Int']>;
};

export type CareerLevelPreferenceDataState = {
  __typename?: 'CareerLevelPreferenceDataState';
  state: JobPreferencesDataStateStatus;
  minCareerLevel: JobPreferencesDataStateStatus;
  maxCareerLevel: JobPreferencesDataStateStatus;
};

/** Button that triggers the conversation via Messenger */
export type CareerSettingsConversationStarter = {
  __typename?: 'CareerSettingsConversationStarter';
  title: Scalars['String'];
  messengerContextId?: Maybe<MessengerContextId>;
};

/** Profile Module CareerSettings */
export type CareerSettingsModule = ModuleInterface & {
  __typename?: 'CareerSettingsModule';
  title: Scalars['String'];
  order: Scalars['Int'];
  /** #rest #virtual */
  jobSeeker?: Maybe<JobSeeker>;
  /** #rest #virtual */
  conversationStarters?: Maybe<Array<CareerSettingsConversationStarter>>;
  /** #rest #virtual */
  projobsWishesOther?: Maybe<ProjobsWishes>;
  /** #rest #virtual */
  projobsSettingsOther?: Maybe<ProjobsSettingsOther>;
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type CategoryAggregation = HasAggregationCount & {
  __typename?: 'CategoryAggregation';
  value: Scalars['Int'];
  count: Scalars['Int'];
};

export type ChatsSearch = {
  __typename?: 'ChatsSearch';
  items?: Maybe<Array<Maybe<Item>>>;
  moreItems?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export type CircuitBreaker = {
  __typename?: 'CircuitBreaker';
  /** #soft-logged-in */
  status: Scalars['String'];
};

export type City = {
  __typename?: 'City';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  latitude?: Maybe<Scalars['Float']>;
  /** #logged-out #soft-logged-in */
  longitude?: Maybe<Scalars['Float']>;
  /** #logged-out #soft-logged-in */
  countryCode?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  formattedCountry?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  adminArea?: Maybe<Scalars['String']>;
};

export type ClickReason = {
  __typename?: 'ClickReason';
  code: Scalars['String'];
  profileUrl: Scalars['String'];
  clickReasonSlug: Scalars['String'];
};

export type ClickReasonInput = {
  id: ClickReasonsEnum;
  /** ID of any entity to be used by the Click Reason. */
  entityId?: Maybe<Scalars['ID']>;
};

export enum ClickReasonsEnum {
  MatchSearch = 'MATCH_SEARCH',
  MatchTestimonial = 'MATCH_TESTIMONIAL',
  MatchContactlist = 'MATCH_CONTACTLIST',
  MatchRandomFoaf = 'MATCH_RANDOM_FOAF',
  MatchLatest = 'MATCH_LATEST',
  MatchLoggedin = 'MATCH_LOGGEDIN',
  MatchVisitedmycp = 'MATCH_VISITEDMYCP',
  MatchRandom = 'MATCH_RANDOM',
  MatchNearby = 'MATCH_NEARBY',
  MatchMessages = 'MATCH_MESSAGES',
  MatchFriendpath = 'MATCH_FRIENDPATH',
  MatchContactlistOf = 'MATCH_CONTACTLIST_OF',
  MatchGuestbookOf = 'MATCH_GUESTBOOK_OF',
  MatchWeeklyStats = 'MATCH_WEEKLY_STATS',
  MatchContactRecommendation = 'MATCH_CONTACT_RECOMMENDATION',
  MatchInvitation = 'MATCH_INVITATION',
  MatchNetworkModerator = 'MATCH_NETWORK_MODERATOR',
  MatchNetworkMember = 'MATCH_NETWORK_MEMBER',
  MatchNetworkArticleAuthor = 'MATCH_NETWORK_ARTICLE_AUTHOR',
  MatchOutlookComparison = 'MATCH_OUTLOOK_COMPARISON',
  MatchBirthday = 'MATCH_BIRTHDAY',
  MatchRandomHomepage = 'MATCH_RANDOM_HOMEPAGE',
  MatchFoaflist = 'MATCH_FOAFLIST',
  MatchVisitedcp = 'MATCH_VISITEDCP',
  MatchSuggestionmail = 'MATCH_SUGGESTIONMAIL',
  MatchVisitedcompanymatcher = 'MATCH_VISITEDCOMPANYMATCHER',
  MatchVisitedorgamatcher = 'MATCH_VISITEDORGAMATCHER',
  MatchVisitededumatcher = 'MATCH_VISITEDEDUMATCHER',
  MatchCompanyUrl = 'MATCH_COMPANY_URL',
  MatchExcompanyUrl = 'MATCH_EXCOMPANY_URL',
  MatchHomepage = 'MATCH_HOMEPAGE',
  MatchHavesWantsMatcher = 'MATCH_HAVES_WANTS_MATCHER',
  MatchWantsHavesMatcher = 'MATCH_WANTS_HAVES_MATCHER',
  MatchKnownUsers = 'MATCH_KNOWN_USERS',
  MatchChangedContacts = 'MATCH_CHANGED_CONTACTS',
  MatchPassedBirthday = 'MATCH_PASSED_BIRTHDAY',
  MatchMarketplace = 'MATCH_MARKETPLACE',
  MatchSuccessStory = 'MATCH_SUCCESS_STORY',
  MatchGroupsOfContacts = 'MATCH_GROUPS_OF_CONTACTS',
  MatchFriendshipStory = 'MATCH_FRIENDSHIP_STORY',
  MatchSameGroups = 'MATCH_SAME_GROUPS',
  MatchEventsGuestlist = 'MATCH_EVENTS_GUESTLIST',
  MatchEventsMyContactsGoTo = 'MATCH_EVENTS_MY_CONTACTS_GO_TO',
  MatchEventsSearchResults = 'MATCH_EVENTS_SEARCH_RESULTS',
  MatchEventPage = 'MATCH_EVENT_PAGE',
  MatchMembersYouMayKnow = 'MATCH_MEMBERS_YOU_MAY_KNOW',
  MatchCompanyProfile = 'MATCH_COMPANY_PROFILE',
  MatchCompanyProfileFriendpath = 'MATCH_COMPANY_PROFILE_FRIENDPATH',
  MatchMembersAlsoVisited = 'MATCH_MEMBERS_ALSO_VISITED',
  MatchCompanyProfileUpdateLiker = 'MATCH_COMPANY_PROFILE_UPDATE_LIKER',
  MatchCompanyProfileFollower = 'MATCH_COMPANY_PROFILE_FOLLOWER',
  MatchOutlookConnector = 'MATCH_OUTLOOK_CONNECTOR',
  MatchXingBrowserToolbar = 'MATCH_XING_BROWSER_TOOLBAR',
  MatchJobsMatching = 'MATCH_JOBS_MATCHING',
  MatchActivityboxContactlist = 'MATCH_ACTIVITYBOX_CONTACTLIST',
  MatchActivityboxMessages = 'MATCH_ACTIVITYBOX_MESSAGES',
  MatchActivityboxEvents = 'MATCH_ACTIVITYBOX_EVENTS',
  MatchActivityboxNewsletters = 'MATCH_ACTIVITYBOX_NEWSLETTERS',
  MatchKnowInCompany = 'MATCH_KNOW_IN_COMPANY',
  MatchAppMobile = 'MATCH_APP_MOBILE',
  MatchAppDesktop = 'MATCH_APP_DESKTOP',
  MatchAppWidget = 'MATCH_APP_WIDGET',
  MatchJobSearch = 'MATCH_JOB_SEARCH',
  MatchGroupSearch = 'MATCH_GROUP_SEARCH',
  MatchEventSearch = 'MATCH_EVENT_SEARCH',
  MatchNetworkOverviewAuthor = 'MATCH_NETWORK_OVERVIEW_AUTHOR',
  MatchNetworkStartpageAuthor = 'MATCH_NETWORK_STARTPAGE_AUTHOR',
  MatchProfileOf = 'MATCH_PROFILE_OF',
  MatchTopicsStartpage = 'MATCH_TOPICS_STARTPAGE',
  MatchTopicsTopicpage = 'MATCH_TOPICS_TOPICPAGE',
  MatchTopicsPost = 'MATCH_TOPICS_POST',
  MatchProjects = 'MATCH_PROJECTS',
  MatchPoll = 'MATCH_POLL',
  MatchSameIndustry = 'MATCH_SAME_INDUSTRY',
  MatchSameInterests = 'MATCH_SAME_INTERESTS',
  MatchContactLoggedin = 'MATCH_CONTACT_LOGGEDIN',
  MatchVisitedMyPortfolio = 'MATCH_VISITED_MY_PORTFOLIO',
  MatchCurrentColleagues = 'MATCH_CURRENT_COLLEAGUES',
  MatchSimilarProfiles = 'MATCH_SIMILAR_PROFILES',
  MatchProfileChangeJobTitle = 'MATCH_PROFILE_CHANGE_JOB_TITLE',
  MatchProfileChangeCompany = 'MATCH_PROFILE_CHANGE_COMPANY',
  MatchProfileChangeAddress = 'MATCH_PROFILE_CHANGE_ADDRESS',
  MatchTalentmanager = 'MATCH_TALENTMANAGER',
  MatchLinkRecommended = 'MATCH_LINK_RECOMMENDED',
  MatchCommunitiesMembersList = 'MATCH_COMMUNITIES_MEMBERS_LIST',
  MatchCommunitiesPost = 'MATCH_COMMUNITIES_POST',
  MatchCommunitiesPostLiker = 'MATCH_COMMUNITIES_POST_LIKER',
  MatchCommunitiesPostComment = 'MATCH_COMMUNITIES_POST_COMMENT',
  MatchCommunitiesPostCommentLiker = 'MATCH_COMMUNITIES_POST_COMMENT_LIKER',
  MatchFuturemeProfession = 'MATCH_FUTUREME_PROFESSION',
  MatchXasAd = 'MATCH_XAS_AD',
  MatchIncrementalSearchList = 'MATCH_INCREMENTAL_SEARCH_LIST',
  MatchContent = 'MATCH_CONTENT',
  MatchEventsMobileApp = 'MATCH_EVENTS_MOBILE_APP',
  MatchReferences = 'MATCH_REFERENCES',
  MatchSameName = 'MATCH_SAME_NAME',
  MatchContentKlartext = 'MATCH_CONTENT_KLARTEXT',
  MatchBiggerSearchTopHave = 'MATCH_BIGGER_SEARCH_TOP_HAVE',
  MatchCommunitiesClassified = 'MATCH_COMMUNITIES_CLASSIFIED',
  MatchCommunitiesClassifiedLiker = 'MATCH_COMMUNITIES_CLASSIFIED_LIKER',
  MatchCommunitiesClassifiedComment = 'MATCH_COMMUNITIES_CLASSIFIED_COMMENT',
  MatchCommunitiesClassifiedCommentLiker = 'MATCH_COMMUNITIES_CLASSIFIED_COMMENT_LIKER',
  MatchCommunitiesGroupInvitation = 'MATCH_COMMUNITIES_GROUP_INVITATION',
  MatchXbpVombpList = 'MATCH_XBP_VOMBP_LIST',
  MatchXbpContactPersonModule = 'MATCH_XBP_CONTACT_PERSON_MODULE',
  MatchEmails = 'MATCH_EMAILS',
  MatchMyprojobsRecruiterClick = 'MATCH_MYPROJOBS_RECRUITER_CLICK',
  MatchContentInsiderFollowersClick = 'MATCH_CONTENT_INSIDER_FOLLOWERS_CLICK',
  MatchContentInsiderClick = 'MATCH_CONTENT_INSIDER_CLICK',
  MatchContentArticleInteractionClick = 'MATCH_CONTENT_ARTICLE_INTERACTION_CLICK',
  MatchProjobsProfileClickInXtm = 'MATCH_PROJOBS_PROFILE_CLICK_IN_XTM',
  MatchOutlookAddinReadProfileClick = 'MATCH_OUTLOOK_ADDIN_READ_PROFILE_CLICK',
  CrUnkown = 'CR_UNKOWN',
  CrWebStory = 'CR_WEB_STORY',
  CrWebStoryMentioning = 'CR_WEB_STORY_MENTIONING',
  CrWebConversationStarter = 'CR_WEB_CONVERSATION_STARTER',
  CrWebContactRequestReceived = 'CR_WEB_CONTACT_REQUEST_RECEIVED',
  CrWebContactRequestSent = 'CR_WEB_CONTACT_REQUEST_SENT',
  CrWebOwnContactList = 'CR_WEB_OWN_CONTACT_LIST',
  CrWebBirthdayList = 'CR_WEB_BIRTHDAY_LIST',
  CrWebAroundYouList = 'CR_WEB_AROUND_YOU_LIST',
  CrWebMymkContacts = 'CR_WEB_MYMK_CONTACTS',
  CrWebMymk = 'CR_WEB_MYMK',
  CrWebNetworkHomeMessage = 'CR_WEB_NETWORK_HOME_MESSAGE',
  CrWebChatview = 'CR_WEB_CHATVIEW',
  CrWebMessenger = 'CR_WEB_MESSENGER',
  CrWebNetupdtDiscoOtherPostComment = 'CR_WEB_NETUPDT_DISCO_OTHER_POST_COMMENT',
  CrWebNetupdtDiscoOtherJobPostComment = 'CR_WEB_NETUPDT_DISCO_OTHER_JOB_POST_COMMENT',
  CrWebNetupdtDiscoOtherEventPostComment = 'CR_WEB_NETUPDT_DISCO_OTHER_EVENT_POST_COMMENT',
  CrWebNetupdtDiscoOtherArticlePostComment = 'CR_WEB_NETUPDT_DISCO_OTHER_ARTICLE_POST_COMMENT',
  CrWebNetupdtDiscoOwnPostComment = 'CR_WEB_NETUPDT_DISCO_OWN_POST_COMMENT',
  CrWebNetupdtDiscoOwnJobPostComment = 'CR_WEB_NETUPDT_DISCO_OWN_JOB_POST_COMMENT',
  CrWebNetupdtDiscoOwnEventPostComment = 'CR_WEB_NETUPDT_DISCO_OWN_EVENT_POST_COMMENT',
  CrWebNetupdtDiscoOwnArticlePostComment = 'CR_WEB_NETUPDT_DISCO_OWN_ARTICLE_POST_COMMENT',
  CrWebNetupdtDiscoOtherPostLike = 'CR_WEB_NETUPDT_DISCO_OTHER_POST_LIKE',
  CrWebNetupdtDiscoOtherJobPostLike = 'CR_WEB_NETUPDT_DISCO_OTHER_JOB_POST_LIKE',
  CrWebNetupdtDiscoOtherEventPostLike = 'CR_WEB_NETUPDT_DISCO_OTHER_EVENT_POST_LIKE',
  CrWebNetupdtDiscoOtherArticlePostLike = 'CR_WEB_NETUPDT_DISCO_OTHER_ARTICLE_POST_LIKE',
  CrWebNetupdtDiscoPostShared = 'CR_WEB_NETUPDT_DISCO_POST_SHARED',
  CrWebNetupdtDiscoJobPostShared = 'CR_WEB_NETUPDT_DISCO_JOB_POST_SHARED',
  CrWebNetupdtDiscoEventPostShared = 'CR_WEB_NETUPDT_DISCO_EVENT_POST_SHARED',
  CrWebNetupdtDiscoEventArticleShared = 'CR_WEB_NETUPDT_DISCO_EVENT_ARTICLE_SHARED',
  CrWebNetupdtDiscoOwnPost = 'CR_WEB_NETUPDT_DISCO_OWN_POST',
  CrWebNetupdtDiscoOwnJobPost = 'CR_WEB_NETUPDT_DISCO_OWN_JOB_POST',
  CrWebNetupdtDiscoOwnEventPost = 'CR_WEB_NETUPDT_DISCO_OWN_EVENT_POST',
  CrWebNetupdtDiscoOwnArticlePost = 'CR_WEB_NETUPDT_DISCO_OWN_ARTICLE_POST',
  CrWebNetupdtDiscoFollowing = 'CR_WEB_NETUPDT_DISCO_FOLLOWING',
  CrWebNetupdtDiscoProfileUpdate = 'CR_WEB_NETUPDT_DISCO_PROFILE_UPDATE',
  CrWebNetupdtDiscoProfilePictUpdate = 'CR_WEB_NETUPDT_DISCO_PROFILE_PICT_UPDATE',
  CrWebNetupdtDiscoBusinessCardUpdate = 'CR_WEB_NETUPDT_DISCO_BUSINESS_CARD_UPDATE',
  CrWebNetupdtDiscoPersonalUpdate = 'CR_WEB_NETUPDT_DISCO_PERSONAL_UPDATE',
  CrWebNetupdtDiscoWorkExpUpdate = 'CR_WEB_NETUPDT_DISCO_WORK_EXP_UPDATE',
  CrWebNetupdtDiscoHeaderImgUpdate = 'CR_WEB_NETUPDT_DISCO_HEADER_IMG_UPDATE',
  CrWebNetupdtDiscoContactReco = 'CR_WEB_NETUPDT_DISCO_CONTACT_RECO',
  CrWebNetupdtDiscoNewContactUpdate = 'CR_WEB_NETUPDT_DISCO_NEW_CONTACT_UPDATE',
  CrWebNetupdtDiscoSharedContacts = 'CR_WEB_NETUPDT_DISCO_SHARED_CONTACTS',
  CrWebNetupdtDiscoInterestingJobs = 'CR_WEB_NETUPDT_DISCO_INTERESTING_JOBS',
  CrWebNetupdtDiscoAnniversary = 'CR_WEB_NETUPDT_DISCO_ANNIVERSARY',
  CrWebNetupdtDiscoGroupCreation = 'CR_WEB_NETUPDT_DISCO_GROUP_CREATION',
  CrWebNetupdtDiscoGroupJoined = 'CR_WEB_NETUPDT_DISCO_GROUP_JOINED',
  CrWebNetupdtDiscoEventCreation = 'CR_WEB_NETUPDT_DISCO_EVENT_CREATION',
  CrWebNetupdtDiscoEventAttending = 'CR_WEB_NETUPDT_DISCO_EVENT_ATTENDING',
  CrWebExploreDiscoOtherPostComment = 'CR_WEB_EXPLORE_DISCO_OTHER_POST_COMMENT',
  CrWebExploreDiscoOtherJobPostComment = 'CR_WEB_EXPLORE_DISCO_OTHER_JOB_POST_COMMENT',
  CrWebExploreDiscoOtherEventPostComment = 'CR_WEB_EXPLORE_DISCO_OTHER_EVENT_POST_COMMENT',
  CrWebExploreDiscoOtherArticlePostComment = 'CR_WEB_EXPLORE_DISCO_OTHER_ARTICLE_POST_COMMENT',
  CrWebExploreDiscoOwnPostComment = 'CR_WEB_EXPLORE_DISCO_OWN_POST_COMMENT',
  CrWebExploreDiscoOwnJobPostComment = 'CR_WEB_EXPLORE_DISCO_OWN_JOB_POST_COMMENT',
  CrWebExploreDiscoOwnEventPostComment = 'CR_WEB_EXPLORE_DISCO_OWN_EVENT_POST_COMMENT',
  CrWebExploreDiscoOwnArticlePostComment = 'CR_WEB_EXPLORE_DISCO_OWN_ARTICLE_POST_COMMENT',
  CrWebExploreDiscoOtherPostLike = 'CR_WEB_EXPLORE_DISCO_OTHER_POST_LIKE',
  CrWebExploreDiscoOtherJobPostLike = 'CR_WEB_EXPLORE_DISCO_OTHER_JOB_POST_LIKE',
  CrWebExploreDiscoOtherEventPostLike = 'CR_WEB_EXPLORE_DISCO_OTHER_EVENT_POST_LIKE',
  CrWebExploreDiscoOtherArticlePostLike = 'CR_WEB_EXPLORE_DISCO_OTHER_ARTICLE_POST_LIKE',
  CrWebExploreDiscoPostShared = 'CR_WEB_EXPLORE_DISCO_POST_SHARED',
  CrWebExploreDiscoJobPostShared = 'CR_WEB_EXPLORE_DISCO_JOB_POST_SHARED',
  CrWebExploreDiscoEventPostShared = 'CR_WEB_EXPLORE_DISCO_EVENT_POST_SHARED',
  CrWebExploreDiscoArticlePostShared = 'CR_WEB_EXPLORE_DISCO_ARTICLE_POST_SHARED',
  CrWebExploreDiscoOwnPost = 'CR_WEB_EXPLORE_DISCO_OWN_POST',
  CrWebExploreDiscoOwnJobPost = 'CR_WEB_EXPLORE_DISCO_OWN_JOB_POST',
  CrWebExploreDiscoOwnEventPost = 'CR_WEB_EXPLORE_DISCO_OWN_EVENT_POST',
  CrWebExploreDiscoOwnArticlePost = 'CR_WEB_EXPLORE_DISCO_OWN_ARTICLE_POST',
  CrWebExploreDiscoFollowing = 'CR_WEB_EXPLORE_DISCO_FOLLOWING',
  CrWebExploreDiscoProfileUpdate = 'CR_WEB_EXPLORE_DISCO_PROFILE_UPDATE',
  CrWebExploreDiscoProfilePictUpdate = 'CR_WEB_EXPLORE_DISCO_PROFILE_PICT_UPDATE',
  CrWebExploreDiscoBusinessCardUpdate = 'CR_WEB_EXPLORE_DISCO_BUSINESS_CARD_UPDATE',
  CrWebExploreDiscoPersonalUpdate = 'CR_WEB_EXPLORE_DISCO_PERSONAL_UPDATE',
  CrWebExploreDiscoWorkExpUpdate = 'CR_WEB_EXPLORE_DISCO_WORK_EXP_UPDATE',
  CrWebExploreDiscoHeaderImageUpdate = 'CR_WEB_EXPLORE_DISCO_HEADER_IMAGE_UPDATE',
  CrWebExploreDiscoContactReco = 'CR_WEB_EXPLORE_DISCO_CONTACT_RECO',
  CrWebExploreDiscoNewContactUpdate = 'CR_WEB_EXPLORE_DISCO_NEW_CONTACT_UPDATE',
  CrWebExploreDiscoSharedContacts = 'CR_WEB_EXPLORE_DISCO_SHARED_CONTACTS',
  CrWebExploreDiscoInterestingJobs = 'CR_WEB_EXPLORE_DISCO_INTERESTING_JOBS',
  CrWebExploreDiscoAnniversary = 'CR_WEB_EXPLORE_DISCO_ANNIVERSARY',
  CrWebExploreDiscoGroupCreation = 'CR_WEB_EXPLORE_DISCO_GROUP_CREATION',
  CrWebExploreDiscoGroupJoined = 'CR_WEB_EXPLORE_DISCO_GROUP_JOINED',
  CrWebExploreDiscoEventCreation = 'CR_WEB_EXPLORE_DISCO_EVENT_CREATION',
  CrWebExploreDiscoEventAttending = 'CR_WEB_EXPLORE_DISCO_EVENT_ATTENDING',
  CrWebEntitypageDiscoCompanyPage = 'CR_WEB_ENTITYPAGE_DISCO_COMPANY_PAGE',
  CrWebDiscoSearch = 'CR_WEB_DISCO_SEARCH',
  CrWebDiscoMemberSearch = 'CR_WEB_DISCO_MEMBER_SEARCH',
  CrWebTopicDiscoChannelFollowing = 'CR_WEB_TOPIC_DISCO_CHANNEL_FOLLOWING',
  CrWebTopicDiscoOtherPostComment = 'CR_WEB_TOPIC_DISCO_OTHER_POST_COMMENT',
  CrWebTopicDiscoOtherJobPostComment = 'CR_WEB_TOPIC_DISCO_OTHER_JOB_POST_COMMENT',
  CrWebTopicDiscoOtherEventPostComment = 'CR_WEB_TOPIC_DISCO_OTHER_EVENT_POST_COMMENT',
  CrWebTopicDiscoOtherArticlePostComment = 'CR_WEB_TOPIC_DISCO_OTHER_ARTICLE_POST_COMMENT',
  CrWebTopicDiscoOwnPostComment = 'CR_WEB_TOPIC_DISCO_OWN_POST_COMMENT',
  CrWebTopicDiscoOwnJobPostComment = 'CR_WEB_TOPIC_DISCO_OWN_JOB_POST_COMMENT',
  CrWebTopicDiscoOwnEventPostComment = 'CR_WEB_TOPIC_DISCO_OWN_EVENT_POST_COMMENT',
  CrWebTopicDiscoOwnArticlePostComment = 'CR_WEB_TOPIC_DISCO_OWN_ARTICLE_POST_COMMENT',
  CrWebTopicDiscoOtherPostLike = 'CR_WEB_TOPIC_DISCO_OTHER_POST_LIKE',
  CrWebTopicDiscoOtherJobPostLike = 'CR_WEB_TOPIC_DISCO_OTHER_JOB_POST_LIKE',
  CrWebTopicDiscoOtherEventPostLike = 'CR_WEB_TOPIC_DISCO_OTHER_EVENT_POST_LIKE',
  CrWebTopicDiscoOtherArticlePostLike = 'CR_WEB_TOPIC_DISCO_OTHER_ARTICLE_POST_LIKE',
  CrWebTopicDiscoPostShared = 'CR_WEB_TOPIC_DISCO_POST_SHARED',
  CrWebTopicDiscoJobPostShared = 'CR_WEB_TOPIC_DISCO_JOB_POST_SHARED',
  CrWebTopicDiscoEventPostShared = 'CR_WEB_TOPIC_DISCO_EVENT_POST_SHARED',
  CrWebTopicDiscoArticlePostShared = 'CR_WEB_TOPIC_DISCO_ARTICLE_POST_SHARED',
  CrWebTopicDiscoOwnPost = 'CR_WEB_TOPIC_DISCO_OWN_POST',
  CrWebTopicDiscoOwnJobPost = 'CR_WEB_TOPIC_DISCO_OWN_JOB_POST',
  CrWebTopicDiscoOwnEventPost = 'CR_WEB_TOPIC_DISCO_OWN_EVENT_POST',
  CrWebTopicDiscoOwnArticlePost = 'CR_WEB_TOPIC_DISCO_OWN_ARTICLE_POST',
  CrWebTopicDiscoFollowing = 'CR_WEB_TOPIC_DISCO_FOLLOWING',
  CrWebTopicDiscoContactReco = 'CR_WEB_TOPIC_DISCO_CONTACT_RECO',
  CrWebTopicDiscoNewContactUpdate = 'CR_WEB_TOPIC_DISCO_NEW_CONTACT_UPDATE',
  CrWebTopicDiscoSharedContacts = 'CR_WEB_TOPIC_DISCO_SHARED_CONTACTS',
  CrWebTopicDiscoInterestingJobs = 'CR_WEB_TOPIC_DISCO_INTERESTING_JOBS',
  CrWebTopicDiscoGroupCreation = 'CR_WEB_TOPIC_DISCO_GROUP_CREATION',
  CrWebTopicDiscoGroupJoined = 'CR_WEB_TOPIC_DISCO_GROUP_JOINED',
  CrWebTopicDiscoEventCreation = 'CR_WEB_TOPIC_DISCO_EVENT_CREATION',
  CrWebTopicDiscoEventAttending = 'CR_WEB_TOPIC_DISCO_EVENT_ATTENDING',
  CrWebMehubVomp = 'CR_WEB_MEHUB_VOMP',
  CrWebMehubContactsList = 'CR_WEB_MEHUB_CONTACTS_LIST',
  CrWebVompPage = 'CR_WEB_VOMP_PAGE',
  CrWebVompPageCommonContacts = 'CR_WEB_VOMP_PAGE_COMMON_CONTACTS',
  CrWebJobsCompanyContacts = 'CR_WEB_JOBS_COMPANY_CONTACTS',
  CrWebJobsCompanyContactsContact = 'CR_WEB_JOBS_COMPANY_CONTACTS_CONTACT',
  CrWebJobsCompanyContactsCommonContact = 'CR_WEB_JOBS_COMPANY_CONTACTS_COMMON_CONTACT',
  CrWebEventsGuestList = 'CR_WEB_EVENTS_GUEST_LIST',
  CrWebEventsOrganizer = 'CR_WEB_EVENTS_ORGANIZER',
  CrWebEventsContactPerson = 'CR_WEB_EVENTS_CONTACT_PERSON',
  CrWebEventsSpeaker = 'CR_WEB_EVENTS_SPEAKER',
  CrWebEventsComment = 'CR_WEB_EVENTS_COMMENT',
  CrWebNewsComment = 'CR_WEB_NEWS_COMMENT',
  CrWebNewsLike = 'CR_WEB_NEWS_LIKE',
  CrWebNewsAuthor = 'CR_WEB_NEWS_AUTHOR',
  CrWebNewsAuthorFollowers = 'CR_WEB_NEWS_AUTHOR_FOLLOWERS',
  CrWebNewsFollowers = 'CR_WEB_NEWS_FOLLOWERS',
  CrWebKlartextComment = 'CR_WEB_KLARTEXT_COMMENT',
  CrWebKlartextCommentLike = 'CR_WEB_KLARTEXT_COMMENT_LIKE',
  CrWebKlartextApprovedList = 'CR_WEB_KLARTEXT_APPROVED_LIST',
  CrWebKlartextAuthor = 'CR_WEB_KLARTEXT_AUTHOR',
  CrWebGroupsMembersList = 'CR_WEB_GROUPS_MEMBERS_LIST',
  CrWebGroupsDiscussions = 'CR_WEB_GROUPS_DISCUSSIONS',
  CrWebCompaniesEmployeeList = 'CR_WEB_COMPANIES_EMPLOYEE_LIST',
  CrWebCompaniesFollowersList = 'CR_WEB_COMPANIES_FOLLOWERS_LIST',
  CrWebCompaniesContacts = 'CR_WEB_COMPANIES_CONTACTS',
  CrWebProfileContactsList = 'CR_WEB_PROFILE_CONTACTS_LIST',
  CrWebProfileSharedContacts = 'CR_WEB_PROFILE_SHARED_CONTACTS',
  CrWebOnboardingContactsReco = 'CR_WEB_ONBOARDING_CONTACTS_RECO',
  CrWebUpboardingContactsReco = 'CR_WEB_UPBOARDING_CONTACTS_RECO',
  CrWebTalentManager = 'CR_WEB_TALENT_MANAGER',
  CrWebProjobsRecruiterReco = 'CR_WEB_PROJOBS_RECRUITER_RECO',
  CrWebProjobsVomp = 'CR_WEB_PROJOBS_VOMP',
  CrWebProjobs = 'CR_WEB_PROJOBS',
  CrWebProbusinessContacts = 'CR_WEB_PROBUSINESS_CONTACTS',
  CrWebProbusinessSearch = 'CR_WEB_PROBUSINESS_SEARCH',
  CrWebProbusinessAdvancedSearch = 'CR_WEB_PROBUSINESS_ADVANCED_SEARCH',
  CrWebTalentService = 'CR_WEB_TALENT_SERVICE',
  CrWebJobsFutureColleaguesModule = 'CR_WEB_JOBS_FUTURE_COLLEAGUES_MODULE',
  CrWebJobsFutureColleaguesList = 'CR_WEB_JOBS_FUTURE_COLLEAGUES_LIST',
  CrWebEventsLikes = 'CR_WEB_EVENTS_LIKES',
  CrWebPublisherSocialProofHeader = 'CR_WEB_PUBLISHER_SOCIAL_PROOF_HEADER',
  CrWebPublisherEmployeesModule = 'CR_WEB_PUBLISHER_EMPLOYEES_MODULE',
  CrWebPublisherEventsModule = 'CR_WEB_PUBLISHER_EVENTS_MODULE',
  CrWebPublisherContactsModule = 'CR_WEB_PUBLISHER_CONTACTS_MODULE',
  CrWebPublisherComments = 'CR_WEB_PUBLISHER_COMMENTS',
  CrWebPublisherLikesComment = 'CR_WEB_PUBLISHER_LIKES_COMMENT',
  CrWebPublisherLikesPost = 'CR_WEB_PUBLISHER_LIKES_POST',
  CrWebGroupsSocialProofHeaderMembers = 'CR_WEB_GROUPS_SOCIAL_PROOF_HEADER_MEMBERS',
  CrWebGroupsModerators = 'CR_WEB_GROUPS_MODERATORS',
  CrWebCompaniesCompanyContactList = 'CR_WEB_COMPANIES_COMPANY_CONTACT_LIST',
  CrWebSocialMentionComment = 'CR_WEB_SOCIAL_MENTION_COMMENT',
  CrWebSocialMentionPost = 'CR_WEB_SOCIAL_MENTION_POST',
  CrWebClickedInOnlyfy = 'CR_WEB_CLICKED_IN_ONLYFY',
  CrWebClickedInRecruiterRecommendations = 'CR_WEB_CLICKED_IN_RECRUITER_RECOMMENDATIONS',
  CrWebDreamMachineView = 'CR_WEB_DREAM_MACHINE_VIEW',
  CrWebDreamMachineSearchSwipeView = 'CR_WEB_DREAM_MACHINE_SEARCH_SWIPE_VIEW',
  CrWebNetworkSearchSwipeView = 'CR_WEB_NETWORK_SEARCH_SWIPE_VIEW',
  CrAndroidStory = 'CR_ANDROID_STORY',
  CrAndroidStoryMentioning = 'CR_ANDROID_STORY_MENTIONING',
  CrAndroidConversationStarter = 'CR_ANDROID_CONVERSATION_STARTER',
  CrAndroidContactRequestReceived = 'CR_ANDROID_CONTACT_REQUEST_RECEIVED',
  CrAndroidContactRequestSent = 'CR_ANDROID_CONTACT_REQUEST_SENT',
  CrAndroidOwnContactList = 'CR_ANDROID_OWN_CONTACT_LIST',
  CrAndroidBirthdayList = 'CR_ANDROID_BIRTHDAY_LIST',
  CrAndroidAroundYouList = 'CR_ANDROID_AROUND_YOU_LIST',
  CrAndroidMymkContacts = 'CR_ANDROID_MYMK_CONTACTS',
  CrAndroidMymk = 'CR_ANDROID_MYMK',
  CrAndroidNetworkHomeMessage = 'CR_ANDROID_NETWORK_HOME_MESSAGE',
  CrAndroidChatview = 'CR_ANDROID_CHATVIEW',
  CrAndroidMessenger = 'CR_ANDROID_MESSENGER',
  CrAndroidNetupdtDiscoOtherPostComment = 'CR_ANDROID_NETUPDT_DISCO_OTHER_POST_COMMENT',
  CrAndroidNetupdtDiscoOtherJobPostComment = 'CR_ANDROID_NETUPDT_DISCO_OTHER_JOB_POST_COMMENT',
  CrAndroidNetupdtDiscoOtherEventPostComment = 'CR_ANDROID_NETUPDT_DISCO_OTHER_EVENT_POST_COMMENT',
  CrAndroidNetupdtDiscoOtherArticlePostComment = 'CR_ANDROID_NETUPDT_DISCO_OTHER_ARTICLE_POST_COMMENT',
  CrAndroidNetupdtDiscoOwnPostComment = 'CR_ANDROID_NETUPDT_DISCO_OWN_POST_COMMENT',
  CrAndroidNetupdtDiscoOwnJobPostComment = 'CR_ANDROID_NETUPDT_DISCO_OWN_JOB_POST_COMMENT',
  CrAndroidNetupdtDiscoOwnEventPostComment = 'CR_ANDROID_NETUPDT_DISCO_OWN_EVENT_POST_COMMENT',
  CrAndroidNetupdtDiscoOwnArticlePostComment = 'CR_ANDROID_NETUPDT_DISCO_OWN_ARTICLE_POST_COMMENT',
  CrAndroidNetupdtDiscoOtherPostLike = 'CR_ANDROID_NETUPDT_DISCO_OTHER_POST_LIKE',
  CrAndroidNetupdtDiscoOtherJobPostLike = 'CR_ANDROID_NETUPDT_DISCO_OTHER_JOB_POST_LIKE',
  CrAndroidNetupdtDiscoOtherEventPostLike = 'CR_ANDROID_NETUPDT_DISCO_OTHER_EVENT_POST_LIKE',
  CrAndroidNetupdtDiscoOtherArticlePostLike = 'CR_ANDROID_NETUPDT_DISCO_OTHER_ARTICLE_POST_LIKE',
  CrAndroidNetupdtDiscoPostShared = 'CR_ANDROID_NETUPDT_DISCO_POST_SHARED',
  CrAndroidNetupdtDiscoJobPostShared = 'CR_ANDROID_NETUPDT_DISCO_JOB_POST_SHARED',
  CrAndroidNetupdtDiscoEventPostShared = 'CR_ANDROID_NETUPDT_DISCO_EVENT_POST_SHARED',
  CrAndroidNetupdtDiscoEventArticleShared = 'CR_ANDROID_NETUPDT_DISCO_EVENT_ARTICLE_SHARED',
  CrAndroidNetupdtDiscoOwnPost = 'CR_ANDROID_NETUPDT_DISCO_OWN_POST',
  CrAndroidNetupdtDiscoOwnJobPost = 'CR_ANDROID_NETUPDT_DISCO_OWN_JOB_POST',
  CrAndroidNetupdtDiscoOwnEventPost = 'CR_ANDROID_NETUPDT_DISCO_OWN_EVENT_POST',
  CrAndroidNetupdtDiscoOwnArticlePost = 'CR_ANDROID_NETUPDT_DISCO_OWN_ARTICLE_POST',
  CrAndroidNetupdtDiscoFollowing = 'CR_ANDROID_NETUPDT_DISCO_FOLLOWING',
  CrAndroidNetupdtDiscoProfileUpdate = 'CR_ANDROID_NETUPDT_DISCO_PROFILE_UPDATE',
  CrAndroidNetupdtDiscoProfilePictUpdate = 'CR_ANDROID_NETUPDT_DISCO_PROFILE_PICT_UPDATE',
  CrAndroidNetupdtDiscoBusinessCardUpdate = 'CR_ANDROID_NETUPDT_DISCO_BUSINESS_CARD_UPDATE',
  CrAndroidNetupdtDiscoPersonalUpdate = 'CR_ANDROID_NETUPDT_DISCO_PERSONAL_UPDATE',
  CrAndroidNetupdtDiscoWorkExpUpdate = 'CR_ANDROID_NETUPDT_DISCO_WORK_EXP_UPDATE',
  CrAndroidNetupdtDiscoHeaderImgUpdate = 'CR_ANDROID_NETUPDT_DISCO_HEADER_IMG_UPDATE',
  CrAndroidNetupdtDiscoContactReco = 'CR_ANDROID_NETUPDT_DISCO_CONTACT_RECO',
  CrAndroidNetupdtDiscoNewContactUpdate = 'CR_ANDROID_NETUPDT_DISCO_NEW_CONTACT_UPDATE',
  CrAndroidNetupdtDiscoSharedContacts = 'CR_ANDROID_NETUPDT_DISCO_SHARED_CONTACTS',
  CrAndroidNetupdtDiscoInterestingJobs = 'CR_ANDROID_NETUPDT_DISCO_INTERESTING_JOBS',
  CrAndroidNetupdtDiscoAnniversary = 'CR_ANDROID_NETUPDT_DISCO_ANNIVERSARY',
  CrAndroidNetupdtDiscoGroupCreation = 'CR_ANDROID_NETUPDT_DISCO_GROUP_CREATION',
  CrAndroidNetupdtDiscoGroupJoined = 'CR_ANDROID_NETUPDT_DISCO_GROUP_JOINED',
  CrAndroidNetupdtDiscoEventCreation = 'CR_ANDROID_NETUPDT_DISCO_EVENT_CREATION',
  CrAndroidNetupdtDiscoEventAttending = 'CR_ANDROID_NETUPDT_DISCO_EVENT_ATTENDING',
  CrAndroidExploreDiscoOtherPostComment = 'CR_ANDROID_EXPLORE_DISCO_OTHER_POST_COMMENT',
  CrAndroidExploreDiscoOtherJobPostComment = 'CR_ANDROID_EXPLORE_DISCO_OTHER_JOB_POST_COMMENT',
  CrAndroidExploreDiscoOtherEventPostComment = 'CR_ANDROID_EXPLORE_DISCO_OTHER_EVENT_POST_COMMENT',
  CrAndroidExploreDiscoOtherArticlePostComment = 'CR_ANDROID_EXPLORE_DISCO_OTHER_ARTICLE_POST_COMMENT',
  CrAndroidExploreDiscoOwnPostComment = 'CR_ANDROID_EXPLORE_DISCO_OWN_POST_COMMENT',
  CrAndroidExploreDiscoOwnJobPostComment = 'CR_ANDROID_EXPLORE_DISCO_OWN_JOB_POST_COMMENT',
  CrAndroidExploreDiscoOwnEventPostComment = 'CR_ANDROID_EXPLORE_DISCO_OWN_EVENT_POST_COMMENT',
  CrAndroidExploreDiscoOwnArticlePostComment = 'CR_ANDROID_EXPLORE_DISCO_OWN_ARTICLE_POST_COMMENT',
  CrAndroidExploreDiscoOtherPostLike = 'CR_ANDROID_EXPLORE_DISCO_OTHER_POST_LIKE',
  CrAndroidExploreDiscoOtherJobPostLike = 'CR_ANDROID_EXPLORE_DISCO_OTHER_JOB_POST_LIKE',
  CrAndroidExploreDiscoOtherEventPostLike = 'CR_ANDROID_EXPLORE_DISCO_OTHER_EVENT_POST_LIKE',
  CrAndroidExploreDiscoOtherArticlePostLike = 'CR_ANDROID_EXPLORE_DISCO_OTHER_ARTICLE_POST_LIKE',
  CrAndroidExploreDiscoPostShared = 'CR_ANDROID_EXPLORE_DISCO_POST_SHARED',
  CrAndroidExploreDiscoJobPostShared = 'CR_ANDROID_EXPLORE_DISCO_JOB_POST_SHARED',
  CrAndroidExploreDiscoEventPostShared = 'CR_ANDROID_EXPLORE_DISCO_EVENT_POST_SHARED',
  CrAndroidExploreDiscoArticlePostShared = 'CR_ANDROID_EXPLORE_DISCO_ARTICLE_POST_SHARED',
  CrAndroidExploreDiscoOwnPost = 'CR_ANDROID_EXPLORE_DISCO_OWN_POST',
  CrAndroidExploreDiscoOwnJobPost = 'CR_ANDROID_EXPLORE_DISCO_OWN_JOB_POST',
  CrAndroidExploreDiscoOwnEventPost = 'CR_ANDROID_EXPLORE_DISCO_OWN_EVENT_POST',
  CrAndroidExploreDiscoOwnArticlePost = 'CR_ANDROID_EXPLORE_DISCO_OWN_ARTICLE_POST',
  CrAndroidExploreDiscoFollowing = 'CR_ANDROID_EXPLORE_DISCO_FOLLOWING',
  CrAndroidExploreDiscoProfileUpdate = 'CR_ANDROID_EXPLORE_DISCO_PROFILE_UPDATE',
  CrAndroidExploreDiscoProfilePictUpdate = 'CR_ANDROID_EXPLORE_DISCO_PROFILE_PICT_UPDATE',
  CrAndroidExploreDiscoBusinessCardUpdate = 'CR_ANDROID_EXPLORE_DISCO_BUSINESS_CARD_UPDATE',
  CrAndroidExploreDiscoPersonalUpdate = 'CR_ANDROID_EXPLORE_DISCO_PERSONAL_UPDATE',
  CrAndroidExploreDiscoWorkExpUpdate = 'CR_ANDROID_EXPLORE_DISCO_WORK_EXP_UPDATE',
  CrAndroidExploreDiscoHeaderImageUpdate = 'CR_ANDROID_EXPLORE_DISCO_HEADER_IMAGE_UPDATE',
  CrAndroidExploreDiscoContactReco = 'CR_ANDROID_EXPLORE_DISCO_CONTACT_RECO',
  CrAndroidExploreDiscoNewContactUpdate = 'CR_ANDROID_EXPLORE_DISCO_NEW_CONTACT_UPDATE',
  CrAndroidExploreDiscoSharedContacts = 'CR_ANDROID_EXPLORE_DISCO_SHARED_CONTACTS',
  CrAndroidExploreDiscoInterestingJobs = 'CR_ANDROID_EXPLORE_DISCO_INTERESTING_JOBS',
  CrAndroidExploreDiscoAnniversary = 'CR_ANDROID_EXPLORE_DISCO_ANNIVERSARY',
  CrAndroidExploreDiscoGroupCreation = 'CR_ANDROID_EXPLORE_DISCO_GROUP_CREATION',
  CrAndroidExploreDiscoGroupJoined = 'CR_ANDROID_EXPLORE_DISCO_GROUP_JOINED',
  CrAndroidExploreDiscoEventCreation = 'CR_ANDROID_EXPLORE_DISCO_EVENT_CREATION',
  CrAndroidExploreDiscoEventAttending = 'CR_ANDROID_EXPLORE_DISCO_EVENT_ATTENDING',
  CrAndroidEntitypageDiscoCompanyPage = 'CR_ANDROID_ENTITYPAGE_DISCO_COMPANY_PAGE',
  CrAndroidDiscoSearch = 'CR_ANDROID_DISCO_SEARCH',
  CrAndroidDiscoMemberSearch = 'CR_ANDROID_DISCO_MEMBER_SEARCH',
  CrAndroidTopicDiscoChannelFollowing = 'CR_ANDROID_TOPIC_DISCO_CHANNEL_FOLLOWING',
  CrAndroidTopicDiscoOtherPostComment = 'CR_ANDROID_TOPIC_DISCO_OTHER_POST_COMMENT',
  CrAndroidTopicDiscoOtherJobPostComment = 'CR_ANDROID_TOPIC_DISCO_OTHER_JOB_POST_COMMENT',
  CrAndroidTopicDiscoOtherEventPostComment = 'CR_ANDROID_TOPIC_DISCO_OTHER_EVENT_POST_COMMENT',
  CrAndroidTopicDiscoOtherArticlePostComment = 'CR_ANDROID_TOPIC_DISCO_OTHER_ARTICLE_POST_COMMENT',
  CrAndroidTopicDiscoOwnPostComment = 'CR_ANDROID_TOPIC_DISCO_OWN_POST_COMMENT',
  CrAndroidTopicDiscoOwnJobPostComment = 'CR_ANDROID_TOPIC_DISCO_OWN_JOB_POST_COMMENT',
  CrAndroidTopicDiscoOwnEventPostComment = 'CR_ANDROID_TOPIC_DISCO_OWN_EVENT_POST_COMMENT',
  CrAndroidTopicDiscoOwnArticlePostComment = 'CR_ANDROID_TOPIC_DISCO_OWN_ARTICLE_POST_COMMENT',
  CrAndroidTopicDiscoOtherPostLike = 'CR_ANDROID_TOPIC_DISCO_OTHER_POST_LIKE',
  CrAndroidTopicDiscoOtherJobPostLike = 'CR_ANDROID_TOPIC_DISCO_OTHER_JOB_POST_LIKE',
  CrAndroidTopicDiscoOtherEventPostLike = 'CR_ANDROID_TOPIC_DISCO_OTHER_EVENT_POST_LIKE',
  CrAndroidTopicDiscoOtherArticlePostLike = 'CR_ANDROID_TOPIC_DISCO_OTHER_ARTICLE_POST_LIKE',
  CrAndroidTopicDiscoPostShared = 'CR_ANDROID_TOPIC_DISCO_POST_SHARED',
  CrAndroidTopicDiscoJobPostShared = 'CR_ANDROID_TOPIC_DISCO_JOB_POST_SHARED',
  CrAndroidTopicDiscoEventPostShared = 'CR_ANDROID_TOPIC_DISCO_EVENT_POST_SHARED',
  CrAndroidTopicDiscoArticlePostShared = 'CR_ANDROID_TOPIC_DISCO_ARTICLE_POST_SHARED',
  CrAndroidTopicDiscoOwnPost = 'CR_ANDROID_TOPIC_DISCO_OWN_POST',
  CrAndroidTopicDiscoOwnJobPost = 'CR_ANDROID_TOPIC_DISCO_OWN_JOB_POST',
  CrAndroidTopicDiscoOwnEventPost = 'CR_ANDROID_TOPIC_DISCO_OWN_EVENT_POST',
  CrAndroidTopicDiscoOwnArticlePost = 'CR_ANDROID_TOPIC_DISCO_OWN_ARTICLE_POST',
  CrAndroidTopicDiscoFollowing = 'CR_ANDROID_TOPIC_DISCO_FOLLOWING',
  CrAndroidTopicDiscoContactReco = 'CR_ANDROID_TOPIC_DISCO_CONTACT_RECO',
  CrAndroidTopicDiscoNewContactUpdate = 'CR_ANDROID_TOPIC_DISCO_NEW_CONTACT_UPDATE',
  CrAndroidTopicDiscoSharedContacts = 'CR_ANDROID_TOPIC_DISCO_SHARED_CONTACTS',
  CrAndroidTopicDiscoInterestingJobs = 'CR_ANDROID_TOPIC_DISCO_INTERESTING_JOBS',
  CrAndroidTopicDiscoGroupCreation = 'CR_ANDROID_TOPIC_DISCO_GROUP_CREATION',
  CrAndroidTopicDiscoGroupJoined = 'CR_ANDROID_TOPIC_DISCO_GROUP_JOINED',
  CrAndroidTopicDiscoEventCreation = 'CR_ANDROID_TOPIC_DISCO_EVENT_CREATION',
  CrAndroidTopicDiscoEventAttending = 'CR_ANDROID_TOPIC_DISCO_EVENT_ATTENDING',
  CrAndroidMehubVomp = 'CR_ANDROID_MEHUB_VOMP',
  CrAndroidMehubContactsList = 'CR_ANDROID_MEHUB_CONTACTS_LIST',
  CrAndroidVompPage = 'CR_ANDROID_VOMP_PAGE',
  CrAndroidVompPageCommonContacts = 'CR_ANDROID_VOMP_PAGE_COMMON_CONTACTS',
  CrAndroidJobsCompanyContacts = 'CR_ANDROID_JOBS_COMPANY_CONTACTS',
  CrAndroidJobsCompanyContactsContact = 'CR_ANDROID_JOBS_COMPANY_CONTACTS_CONTACT',
  CrAndroidJobsCompanyContactsCommonContact = 'CR_ANDROID_JOBS_COMPANY_CONTACTS_COMMON_CONTACT',
  CrAndroidEventsGuestList = 'CR_ANDROID_EVENTS_GUEST_LIST',
  CrAndroidEventsOrganizer = 'CR_ANDROID_EVENTS_ORGANIZER',
  CrAndroidEventsContactPerson = 'CR_ANDROID_EVENTS_CONTACT_PERSON',
  CrAndroidEventsSpeaker = 'CR_ANDROID_EVENTS_SPEAKER',
  CrAndroidEventsComment = 'CR_ANDROID_EVENTS_COMMENT',
  CrAndroidNewsComment = 'CR_ANDROID_NEWS_COMMENT',
  CrAndroidNewsLike = 'CR_ANDROID_NEWS_LIKE',
  CrAndroidNewsAuthor = 'CR_ANDROID_NEWS_AUTHOR',
  CrAndroidNewsAuthorFollowers = 'CR_ANDROID_NEWS_AUTHOR_FOLLOWERS',
  CrAndroidNewsFollowers = 'CR_ANDROID_NEWS_FOLLOWERS',
  CrAndroidKlartextComment = 'CR_ANDROID_KLARTEXT_COMMENT',
  CrAndroidKlartextCommentLike = 'CR_ANDROID_KLARTEXT_COMMENT_LIKE',
  CrAndroidKlartextApprovedList = 'CR_ANDROID_KLARTEXT_APPROVED_LIST',
  CrAndroidKlartextAuthor = 'CR_ANDROID_KLARTEXT_AUTHOR',
  CrAndroidGroupsMembersList = 'CR_ANDROID_GROUPS_MEMBERS_LIST',
  CrAndroidGroupsDiscussions = 'CR_ANDROID_GROUPS_DISCUSSIONS',
  CrAndroidCompaniesEmployeeList = 'CR_ANDROID_COMPANIES_EMPLOYEE_LIST',
  CrAndroidCompaniesFollowersList = 'CR_ANDROID_COMPANIES_FOLLOWERS_LIST',
  CrAndroidCompaniesContacts = 'CR_ANDROID_COMPANIES_CONTACTS',
  CrAndroidProfileContactsList = 'CR_ANDROID_PROFILE_CONTACTS_LIST',
  CrAndroidProfileSharedContacts = 'CR_ANDROID_PROFILE_SHARED_CONTACTS',
  CrAndroidOnboardingContactsReco = 'CR_ANDROID_ONBOARDING_CONTACTS_RECO',
  CrAndroidUpboardingContactsReco = 'CR_ANDROID_UPBOARDING_CONTACTS_RECO',
  CrAndroidTalentManager = 'CR_ANDROID_TALENT_MANAGER',
  CrAndroidProjobsRecruiterReco = 'CR_ANDROID_PROJOBS_RECRUITER_RECO',
  CrAndroidProjobsVomp = 'CR_ANDROID_PROJOBS_VOMP',
  CrAndroidProjobs = 'CR_ANDROID_PROJOBS',
  CrAndroidProbusinessContacts = 'CR_ANDROID_PROBUSINESS_CONTACTS',
  CrAndroidProbusinessSearch = 'CR_ANDROID_PROBUSINESS_SEARCH',
  CrAndroidProbusinessAdvancedSearch = 'CR_ANDROID_PROBUSINESS_ADVANCED_SEARCH',
  CrAndroidTalentService = 'CR_ANDROID_TALENT_SERVICE',
  CrAndroidJobsFutureColleaguesModule = 'CR_ANDROID_JOBS_FUTURE_COLLEAGUES_MODULE',
  CrAndroidJobsFutureColleaguesList = 'CR_ANDROID_JOBS_FUTURE_COLLEAGUES_LIST',
  CrAndroidEventsLikes = 'CR_ANDROID_EVENTS_LIKES',
  CrAndroidPublisherSocialProofHeader = 'CR_ANDROID_PUBLISHER_SOCIAL_PROOF_HEADER',
  CrAndroidPublisherEmployeesModule = 'CR_ANDROID_PUBLISHER_EMPLOYEES_MODULE',
  CrAndroidPublisherEventsModule = 'CR_ANDROID_PUBLISHER_EVENTS_MODULE',
  CrAndroidPublisherContactsModule = 'CR_ANDROID_PUBLISHER_CONTACTS_MODULE',
  CrAndroidPublisherComments = 'CR_ANDROID_PUBLISHER_COMMENTS',
  CrAndroidPublisherLikesComment = 'CR_ANDROID_PUBLISHER_LIKES_COMMENT',
  CrAndroidPublisherLikesPost = 'CR_ANDROID_PUBLISHER_LIKES_POST',
  CrAndroidGroupsSocialProofHeaderMembers = 'CR_ANDROID_GROUPS_SOCIAL_PROOF_HEADER_MEMBERS',
  CrAndroidGroupsModerators = 'CR_ANDROID_GROUPS_MODERATORS',
  CrAndroidCompaniesCompanyContactList = 'CR_ANDROID_COMPANIES_COMPANY_CONTACT_LIST',
  CrAndroidSocialMentionComment = 'CR_ANDROID_SOCIAL_MENTION_COMMENT',
  CrAndroidSocialMentionPost = 'CR_ANDROID_SOCIAL_MENTION_POST',
  CrAndroidClickedInOnlyfy = 'CR_ANDROID_CLICKED_IN_ONLYFY',
  CrAndroidClickedInRecruiterRecommendations = 'CR_ANDROID_CLICKED_IN_RECRUITER_RECOMMENDATIONS',
  CrAndroidDreamMachineView = 'CR_ANDROID_DREAM_MACHINE_VIEW',
  CrAndroidDreamMachineSearchSwipeView = 'CR_ANDROID_DREAM_MACHINE_SEARCH_SWIPE_VIEW',
  CrAndroidNetworkSearchSwipeView = 'CR_ANDROID_NETWORK_SEARCH_SWIPE_VIEW',
  CrIosStory = 'CR_IOS_STORY',
  CrIosStoryMentioning = 'CR_IOS_STORY_MENTIONING',
  CrIosConversationStarter = 'CR_IOS_CONVERSATION_STARTER',
  CrIosContactRequestReceived = 'CR_IOS_CONTACT_REQUEST_RECEIVED',
  CrIosContactRequestSent = 'CR_IOS_CONTACT_REQUEST_SENT',
  CrIosOwnContactList = 'CR_IOS_OWN_CONTACT_LIST',
  CrIosBirthdayList = 'CR_IOS_BIRTHDAY_LIST',
  CrIosAroundYouList = 'CR_IOS_AROUND_YOU_LIST',
  CrIosMymkContacts = 'CR_IOS_MYMK_CONTACTS',
  CrIosMymk = 'CR_IOS_MYMK',
  CrIosNetworkHomeMessage = 'CR_IOS_NETWORK_HOME_MESSAGE',
  CrIosChatview = 'CR_IOS_CHATVIEW',
  CrIosMessenger = 'CR_IOS_MESSENGER',
  CrIosNetupdtDiscoOtherPostComment = 'CR_IOS_NETUPDT_DISCO_OTHER_POST_COMMENT',
  CrIosNetupdtDiscoOtherJobPostComment = 'CR_IOS_NETUPDT_DISCO_OTHER_JOB_POST_COMMENT',
  CrIosNetupdtDiscoOtherEventPostComment = 'CR_IOS_NETUPDT_DISCO_OTHER_EVENT_POST_COMMENT',
  CrIosNetupdtDiscoOtherArticlePostComment = 'CR_IOS_NETUPDT_DISCO_OTHER_ARTICLE_POST_COMMENT',
  CrIosNetupdtDiscoOwnPostComment = 'CR_IOS_NETUPDT_DISCO_OWN_POST_COMMENT',
  CrIosNetupdtDiscoOwnJobPostComment = 'CR_IOS_NETUPDT_DISCO_OWN_JOB_POST_COMMENT',
  CrIosNetupdtDiscoOwnEventPostComment = 'CR_IOS_NETUPDT_DISCO_OWN_EVENT_POST_COMMENT',
  CrIosNetupdtDiscoOwnArticlePostComment = 'CR_IOS_NETUPDT_DISCO_OWN_ARTICLE_POST_COMMENT',
  CrIosNetupdtDiscoOtherPostLike = 'CR_IOS_NETUPDT_DISCO_OTHER_POST_LIKE',
  CrIosNetupdtDiscoOtherJobPostLike = 'CR_IOS_NETUPDT_DISCO_OTHER_JOB_POST_LIKE',
  CrIosNetupdtDiscoOtherEventPostLike = 'CR_IOS_NETUPDT_DISCO_OTHER_EVENT_POST_LIKE',
  CrIosNetupdtDiscoOtherArticlePostLike = 'CR_IOS_NETUPDT_DISCO_OTHER_ARTICLE_POST_LIKE',
  CrIosNetupdtDiscoPostShared = 'CR_IOS_NETUPDT_DISCO_POST_SHARED',
  CrIosNetupdtDiscoJobPostShared = 'CR_IOS_NETUPDT_DISCO_JOB_POST_SHARED',
  CrIosNetupdtDiscoEventPostShared = 'CR_IOS_NETUPDT_DISCO_EVENT_POST_SHARED',
  CrIosNetupdtDiscoEventArticleShared = 'CR_IOS_NETUPDT_DISCO_EVENT_ARTICLE_SHARED',
  CrIosNetupdtDiscoOwnPost = 'CR_IOS_NETUPDT_DISCO_OWN_POST',
  CrIosNetupdtDiscoOwnJobPost = 'CR_IOS_NETUPDT_DISCO_OWN_JOB_POST',
  CrIosNetupdtDiscoOwnEventPost = 'CR_IOS_NETUPDT_DISCO_OWN_EVENT_POST',
  CrIosNetupdtDiscoOwnArticlePost = 'CR_IOS_NETUPDT_DISCO_OWN_ARTICLE_POST',
  CrIosNetupdtDiscoFollowing = 'CR_IOS_NETUPDT_DISCO_FOLLOWING',
  CrIosNetupdtDiscoProfileUpdate = 'CR_IOS_NETUPDT_DISCO_PROFILE_UPDATE',
  CrIosNetupdtDiscoProfilePictUpdate = 'CR_IOS_NETUPDT_DISCO_PROFILE_PICT_UPDATE',
  CrIosNetupdtDiscoBusinessCardUpdate = 'CR_IOS_NETUPDT_DISCO_BUSINESS_CARD_UPDATE',
  CrIosNetupdtDiscoPersonalUpdate = 'CR_IOS_NETUPDT_DISCO_PERSONAL_UPDATE',
  CrIosNetupdtDiscoWorkExpUpdate = 'CR_IOS_NETUPDT_DISCO_WORK_EXP_UPDATE',
  CrIosNetupdtDiscoHeaderImgUpdate = 'CR_IOS_NETUPDT_DISCO_HEADER_IMG_UPDATE',
  CrIosNetupdtDiscoContactReco = 'CR_IOS_NETUPDT_DISCO_CONTACT_RECO',
  CrIosNetupdtDiscoNewContactUpdate = 'CR_IOS_NETUPDT_DISCO_NEW_CONTACT_UPDATE',
  CrIosNetupdtDiscoSharedContacts = 'CR_IOS_NETUPDT_DISCO_SHARED_CONTACTS',
  CrIosNetupdtDiscoInterestingJobs = 'CR_IOS_NETUPDT_DISCO_INTERESTING_JOBS',
  CrIosNetupdtDiscoAnniversary = 'CR_IOS_NETUPDT_DISCO_ANNIVERSARY',
  CrIosNetupdtDiscoGroupCreation = 'CR_IOS_NETUPDT_DISCO_GROUP_CREATION',
  CrIosNetupdtDiscoGroupJoined = 'CR_IOS_NETUPDT_DISCO_GROUP_JOINED',
  CrIosNetupdtDiscoEventCreation = 'CR_IOS_NETUPDT_DISCO_EVENT_CREATION',
  CrIosNetupdtDiscoEventAttending = 'CR_IOS_NETUPDT_DISCO_EVENT_ATTENDING',
  CrIosExploreDiscoOtherPostComment = 'CR_IOS_EXPLORE_DISCO_OTHER_POST_COMMENT',
  CrIosExploreDiscoOtherJobPostComment = 'CR_IOS_EXPLORE_DISCO_OTHER_JOB_POST_COMMENT',
  CrIosExploreDiscoOtherEventPostComment = 'CR_IOS_EXPLORE_DISCO_OTHER_EVENT_POST_COMMENT',
  CrIosExploreDiscoOtherArticlePostComment = 'CR_IOS_EXPLORE_DISCO_OTHER_ARTICLE_POST_COMMENT',
  CrIosExploreDiscoOwnPostComment = 'CR_IOS_EXPLORE_DISCO_OWN_POST_COMMENT',
  CrIosExploreDiscoOwnJobPostComment = 'CR_IOS_EXPLORE_DISCO_OWN_JOB_POST_COMMENT',
  CrIosExploreDiscoOwnEventPostComment = 'CR_IOS_EXPLORE_DISCO_OWN_EVENT_POST_COMMENT',
  CrIosExploreDiscoOwnArticlePostComment = 'CR_IOS_EXPLORE_DISCO_OWN_ARTICLE_POST_COMMENT',
  CrIosExploreDiscoOtherPostLike = 'CR_IOS_EXPLORE_DISCO_OTHER_POST_LIKE',
  CrIosExploreDiscoOtherJobPostLike = 'CR_IOS_EXPLORE_DISCO_OTHER_JOB_POST_LIKE',
  CrIosExploreDiscoOtherEventPostLike = 'CR_IOS_EXPLORE_DISCO_OTHER_EVENT_POST_LIKE',
  CrIosExploreDiscoOtherArticlePostLike = 'CR_IOS_EXPLORE_DISCO_OTHER_ARTICLE_POST_LIKE',
  CrIosExploreDiscoPostShared = 'CR_IOS_EXPLORE_DISCO_POST_SHARED',
  CrIosExploreDiscoJobPostShared = 'CR_IOS_EXPLORE_DISCO_JOB_POST_SHARED',
  CrIosExploreDiscoEventPostShared = 'CR_IOS_EXPLORE_DISCO_EVENT_POST_SHARED',
  CrIosExploreDiscoArticlePostShared = 'CR_IOS_EXPLORE_DISCO_ARTICLE_POST_SHARED',
  CrIosExploreDiscoOwnPost = 'CR_IOS_EXPLORE_DISCO_OWN_POST',
  CrIosExploreDiscoOwnJobPost = 'CR_IOS_EXPLORE_DISCO_OWN_JOB_POST',
  CrIosExploreDiscoOwnEventPost = 'CR_IOS_EXPLORE_DISCO_OWN_EVENT_POST',
  CrIosExploreDiscoOwnArticlePost = 'CR_IOS_EXPLORE_DISCO_OWN_ARTICLE_POST',
  CrIosExploreDiscoFollowing = 'CR_IOS_EXPLORE_DISCO_FOLLOWING',
  CrIosExploreDiscoProfileUpdate = 'CR_IOS_EXPLORE_DISCO_PROFILE_UPDATE',
  CrIosExploreDiscoProfilePictUpdate = 'CR_IOS_EXPLORE_DISCO_PROFILE_PICT_UPDATE',
  CrIosExploreDiscoBusinessCardUpdate = 'CR_IOS_EXPLORE_DISCO_BUSINESS_CARD_UPDATE',
  CrIosExploreDiscoPersonalUpdate = 'CR_IOS_EXPLORE_DISCO_PERSONAL_UPDATE',
  CrIosExploreDiscoWorkExpUpdate = 'CR_IOS_EXPLORE_DISCO_WORK_EXP_UPDATE',
  CrIosExploreDiscoHeaderImageUpdate = 'CR_IOS_EXPLORE_DISCO_HEADER_IMAGE_UPDATE',
  CrIosExploreDiscoContactReco = 'CR_IOS_EXPLORE_DISCO_CONTACT_RECO',
  CrIosExploreDiscoNewContactUpdate = 'CR_IOS_EXPLORE_DISCO_NEW_CONTACT_UPDATE',
  CrIosExploreDiscoSharedContacts = 'CR_IOS_EXPLORE_DISCO_SHARED_CONTACTS',
  CrIosExploreDiscoInterestingJobs = 'CR_IOS_EXPLORE_DISCO_INTERESTING_JOBS',
  CrIosExploreDiscoAnniversary = 'CR_IOS_EXPLORE_DISCO_ANNIVERSARY',
  CrIosExploreDiscoGroupCreation = 'CR_IOS_EXPLORE_DISCO_GROUP_CREATION',
  CrIosExploreDiscoGroupJoined = 'CR_IOS_EXPLORE_DISCO_GROUP_JOINED',
  CrIosExploreDiscoEventCreation = 'CR_IOS_EXPLORE_DISCO_EVENT_CREATION',
  CrIosExploreDiscoEventAttending = 'CR_IOS_EXPLORE_DISCO_EVENT_ATTENDING',
  CrIosEntitypageDiscoCompanyPage = 'CR_IOS_ENTITYPAGE_DISCO_COMPANY_PAGE',
  CrIosDiscoSearch = 'CR_IOS_DISCO_SEARCH',
  CrIosDiscoMemberSearch = 'CR_IOS_DISCO_MEMBER_SEARCH',
  CrIosTopicDiscoChannelFollowing = 'CR_IOS_TOPIC_DISCO_CHANNEL_FOLLOWING',
  CrIosTopicDiscoOtherPostComment = 'CR_IOS_TOPIC_DISCO_OTHER_POST_COMMENT',
  CrIosTopicDiscoOtherJobPostComment = 'CR_IOS_TOPIC_DISCO_OTHER_JOB_POST_COMMENT',
  CrIosTopicDiscoOtherEventPostComment = 'CR_IOS_TOPIC_DISCO_OTHER_EVENT_POST_COMMENT',
  CrIosTopicDiscoOtherArticlePostComment = 'CR_IOS_TOPIC_DISCO_OTHER_ARTICLE_POST_COMMENT',
  CrIosTopicDiscoOwnPostComment = 'CR_IOS_TOPIC_DISCO_OWN_POST_COMMENT',
  CrIosTopicDiscoOwnJobPostComment = 'CR_IOS_TOPIC_DISCO_OWN_JOB_POST_COMMENT',
  CrIosTopicDiscoOwnEventPostComment = 'CR_IOS_TOPIC_DISCO_OWN_EVENT_POST_COMMENT',
  CrIosTopicDiscoOwnArticlePostComment = 'CR_IOS_TOPIC_DISCO_OWN_ARTICLE_POST_COMMENT',
  CrIosTopicDiscoOtherPostLike = 'CR_IOS_TOPIC_DISCO_OTHER_POST_LIKE',
  CrIosTopicDiscoOtherJobPostLike = 'CR_IOS_TOPIC_DISCO_OTHER_JOB_POST_LIKE',
  CrIosTopicDiscoOtherEventPostLike = 'CR_IOS_TOPIC_DISCO_OTHER_EVENT_POST_LIKE',
  CrIosTopicDiscoOtherArticlePostLike = 'CR_IOS_TOPIC_DISCO_OTHER_ARTICLE_POST_LIKE',
  CrIosTopicDiscoPostShared = 'CR_IOS_TOPIC_DISCO_POST_SHARED',
  CrIosTopicDiscoJobPostShared = 'CR_IOS_TOPIC_DISCO_JOB_POST_SHARED',
  CrIosTopicDiscoEventPostShared = 'CR_IOS_TOPIC_DISCO_EVENT_POST_SHARED',
  CrIosTopicDiscoArticlePostShared = 'CR_IOS_TOPIC_DISCO_ARTICLE_POST_SHARED',
  CrIosTopicDiscoOwnPost = 'CR_IOS_TOPIC_DISCO_OWN_POST',
  CrIosTopicDiscoOwnJobPost = 'CR_IOS_TOPIC_DISCO_OWN_JOB_POST',
  CrIosTopicDiscoOwnEventPost = 'CR_IOS_TOPIC_DISCO_OWN_EVENT_POST',
  CrIosTopicDiscoOwnArticlePost = 'CR_IOS_TOPIC_DISCO_OWN_ARTICLE_POST',
  CrIosTopicDiscoFollowing = 'CR_IOS_TOPIC_DISCO_FOLLOWING',
  CrIosTopicDiscoContactReco = 'CR_IOS_TOPIC_DISCO_CONTACT_RECO',
  CrIosTopicDiscoNewContactUpdate = 'CR_IOS_TOPIC_DISCO_NEW_CONTACT_UPDATE',
  CrIosTopicDiscoSharedContacts = 'CR_IOS_TOPIC_DISCO_SHARED_CONTACTS',
  CrIosTopicDiscoInterestingJobs = 'CR_IOS_TOPIC_DISCO_INTERESTING_JOBS',
  CrIosTopicDiscoGroupCreation = 'CR_IOS_TOPIC_DISCO_GROUP_CREATION',
  CrIosTopicDiscoGroupJoined = 'CR_IOS_TOPIC_DISCO_GROUP_JOINED',
  CrIosTopicDiscoEventCreation = 'CR_IOS_TOPIC_DISCO_EVENT_CREATION',
  CrIosTopicDiscoEventAttending = 'CR_IOS_TOPIC_DISCO_EVENT_ATTENDING',
  CrIosMehubVomp = 'CR_IOS_MEHUB_VOMP',
  CrIosMehubContactsList = 'CR_IOS_MEHUB_CONTACTS_LIST',
  CrIosVompPage = 'CR_IOS_VOMP_PAGE',
  CrIosVompPageCommonContacts = 'CR_IOS_VOMP_PAGE_COMMON_CONTACTS',
  CrIosJobsCompanyContacts = 'CR_IOS_JOBS_COMPANY_CONTACTS',
  CrIosJobsCompanyContactsContact = 'CR_IOS_JOBS_COMPANY_CONTACTS_CONTACT',
  CrIosJobsCompanyContactsCommonContact = 'CR_IOS_JOBS_COMPANY_CONTACTS_COMMON_CONTACT',
  CrIosEventsGuestList = 'CR_IOS_EVENTS_GUEST_LIST',
  CrIosEventsOrganizer = 'CR_IOS_EVENTS_ORGANIZER',
  CrIosEventsContactPerson = 'CR_IOS_EVENTS_CONTACT_PERSON',
  CrIosEventsSpeaker = 'CR_IOS_EVENTS_SPEAKER',
  CrIosEventsComment = 'CR_IOS_EVENTS_COMMENT',
  CrIosNewsComment = 'CR_IOS_NEWS_COMMENT',
  CrIosNewsLike = 'CR_IOS_NEWS_LIKE',
  CrIosNewsAuthor = 'CR_IOS_NEWS_AUTHOR',
  CrIosNewsAuthorFollowers = 'CR_IOS_NEWS_AUTHOR_FOLLOWERS',
  CrIosNewsFollowers = 'CR_IOS_NEWS_FOLLOWERS',
  CrIosKlartextComment = 'CR_IOS_KLARTEXT_COMMENT',
  CrIosKlartextCommentLike = 'CR_IOS_KLARTEXT_COMMENT_LIKE',
  CrIosKlartextApprovedList = 'CR_IOS_KLARTEXT_APPROVED_LIST',
  CrIosKlartextAuthor = 'CR_IOS_KLARTEXT_AUTHOR',
  CrIosGroupsMembersList = 'CR_IOS_GROUPS_MEMBERS_LIST',
  CrIosGroupsDiscussions = 'CR_IOS_GROUPS_DISCUSSIONS',
  CrIosCompaniesEmployeeList = 'CR_IOS_COMPANIES_EMPLOYEE_LIST',
  CrIosCompaniesFollowersList = 'CR_IOS_COMPANIES_FOLLOWERS_LIST',
  CrIosCompaniesContacts = 'CR_IOS_COMPANIES_CONTACTS',
  CrIosProfileContactsList = 'CR_IOS_PROFILE_CONTACTS_LIST',
  CrIosProfileSharedContacts = 'CR_IOS_PROFILE_SHARED_CONTACTS',
  CrIosOnboardingContactsReco = 'CR_IOS_ONBOARDING_CONTACTS_RECO',
  CrIosUpboardingContactsReco = 'CR_IOS_UPBOARDING_CONTACTS_RECO',
  CrIosTalentManager = 'CR_IOS_TALENT_MANAGER',
  CrIosProjobsRecruiterReco = 'CR_IOS_PROJOBS_RECRUITER_RECO',
  CrIosProjobsVomp = 'CR_IOS_PROJOBS_VOMP',
  CrIosProjobs = 'CR_IOS_PROJOBS',
  CrIosProbusinessContacts = 'CR_IOS_PROBUSINESS_CONTACTS',
  CrIosProbusinessSearch = 'CR_IOS_PROBUSINESS_SEARCH',
  CrIosProbusinessAdvancedSearch = 'CR_IOS_PROBUSINESS_ADVANCED_SEARCH',
  CrIosTalentService = 'CR_IOS_TALENT_SERVICE',
  CrIosJobsFutureColleaguesModule = 'CR_IOS_JOBS_FUTURE_COLLEAGUES_MODULE',
  CrIosJobsFutureColleaguesList = 'CR_IOS_JOBS_FUTURE_COLLEAGUES_LIST',
  CrIosEventsLikes = 'CR_IOS_EVENTS_LIKES',
  CrIosPublisherSocialProofHeader = 'CR_IOS_PUBLISHER_SOCIAL_PROOF_HEADER',
  CrIosPublisherEmployeesModule = 'CR_IOS_PUBLISHER_EMPLOYEES_MODULE',
  CrIosPublisherEventsModule = 'CR_IOS_PUBLISHER_EVENTS_MODULE',
  CrIosPublisherContactsModule = 'CR_IOS_PUBLISHER_CONTACTS_MODULE',
  CrIosPublisherComments = 'CR_IOS_PUBLISHER_COMMENTS',
  CrIosPublisherLikesComment = 'CR_IOS_PUBLISHER_LIKES_COMMENT',
  CrIosPublisherLikesPost = 'CR_IOS_PUBLISHER_LIKES_POST',
  CrIosGroupsSocialProofHeaderMembers = 'CR_IOS_GROUPS_SOCIAL_PROOF_HEADER_MEMBERS',
  CrIosGroupsModerators = 'CR_IOS_GROUPS_MODERATORS',
  CrIosCompaniesCompanyContactList = 'CR_IOS_COMPANIES_COMPANY_CONTACT_LIST',
  CrIosSocialMentionComment = 'CR_IOS_SOCIAL_MENTION_COMMENT',
  CrIosSocialMentionPost = 'CR_IOS_SOCIAL_MENTION_POST',
  CrIosClickedInOnlyfy = 'CR_IOS_CLICKED_IN_ONLYFY',
  CrIosClickedInRecruiterRecommendations = 'CR_IOS_CLICKED_IN_RECRUITER_RECOMMENDATIONS',
  CrIosDreamMachineView = 'CR_IOS_DREAM_MACHINE_VIEW',
  CrIosDreamMachineSearchSwipeView = 'CR_IOS_DREAM_MACHINE_SEARCH_SWIPE_VIEW',
  CrIosNetworkSearchSwipeView = 'CR_IOS_NETWORK_SEARCH_SWIPE_VIEW',
  CrEmailVomp = 'CR_EMAIL_VOMP',
  CrEmailContactRequest = 'CR_EMAIL_CONTACT_REQUEST',
  CrEmailContactUpdate = 'CR_EMAIL_CONTACT_UPDATE',
  CrEmailContactMessage = 'CR_EMAIL_CONTACT_MESSAGE',
  CrEmailBirthdayList = 'CR_EMAIL_BIRTHDAY_LIST'
}

/** Client billing address */
export type ClientBillingAddress = {
  __typename?: 'ClientBillingAddress';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<TextSetting>;
  addressAddition?: Maybe<TextSetting>;
  street?: Maybe<TextSetting>;
  postcode?: Maybe<TextSetting>;
  city?: Maybe<TextSetting>;
  country?: Maybe<SelectSetting>;
  taxId?: Maybe<TextSetting>;
  email?: Maybe<TextSetting>;
  language?: Maybe<SelectSetting>;
  ccEmail?: Maybe<TextSetting>;
};

/** Input for client billing address */
export type ClientBillingAddressInput = {
  name: TextSettingInput;
  addressAddition?: Maybe<TextSettingInput>;
  street: TextSettingInput;
  postcode: TextSettingInput;
  city: TextSettingInput;
  country: SelectSettingInput;
  taxId?: Maybe<TextSettingInput>;
  email: TextSettingInput;
  language: SelectSettingInput;
  ccEmail?: Maybe<TextSettingInput>;
};

/** Client overview for settings */
export type ClientOverview = {
  __typename?: 'ClientOverview';
  clientId?: Maybe<Scalars['ID']>;
  /** ProductGroups of the client's available products */
  productGroups?: Maybe<Array<Maybe<PaymentClientProductGroup>>>;
  /** Preview for the User's payment information */
  paymentInfo?: Maybe<Scalars['String']>;
  /** URL of the iFrame where the client can select their payment method */
  paymentIframeUrl?: Maybe<Scalars['URL']>;
};

/** Client Invoice Detail */
export type ClientPaymentInvoice = {
  __typename?: 'ClientPaymentInvoice';
  id: Scalars['ID'];
  /** Invoice date visible to the customer. */
  date: Scalars['Date'];
  /** An array of the product groups of the products related in the invoice */
  productGroups?: Maybe<Array<PaymentClientProductGroup>>;
  /** Invoice identifier, visible to the customer. */
  number: Scalars['String'];
  /** Price with the ISO currency code and the amount in cents; not decimal */
  amount: PaymentPrice;
  /** Invoice Status from HeidelPay */
  status: ClientPaymentInvoiceStatus;
  /** Set to true if the invoice is created from a cancellation */
  isCancellation: Scalars['Boolean'];
  /** URL to download the invoice PDF */
  downloadUrl: Scalars['String'];
};

export enum ClientPaymentInvoiceStatus {
  Open = 'OPEN',
  Paid = 'PAID',
  Cancelled = 'CANCELLED',
  Issued = 'ISSUED',
  FirstReminder = 'FIRST_REMINDER',
  SecondReminder = 'SECOND_REMINDER',
  Encashment = 'ENCASHMENT'
}

export type ClientPaymentInvoices = {
  __typename?: 'ClientPaymentInvoices';
  collection?: Maybe<Array<Maybe<ClientPaymentInvoice>>>;
};

export type CollapsedModule = HasNwtTrackingToken & HasNewWorkTrackingToken & {
  __typename?: 'CollapsedModule';
  userId: Scalars['ID'];
  moduleName: Scalars['String'];
  /** @deprecated Replaced by HasNewWorkTrackingToken to not confuse with another field with same name */
  trackingToken?: Maybe<Scalars['String']>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type CollapsedModuleError = {
  __typename?: 'CollapsedModuleError';
  error: Scalars['String'];
};

export type CollapsedModuleResult = CollapsedModuleSuccess | CollapsedModuleError;

export type CollapsedModuleSuccess = {
  __typename?: 'CollapsedModuleSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Represents commonalities collection.
 * Contains information about all commonalities among users.
 */
export type Commonalities = {
  __typename?: 'Commonalities';
  userB: Scalars['ID'];
  /** @deprecated Groups have been shutdown. This returns null */
  groups?: Maybe<Array<Maybe<Community>>>;
  /** @deprecated Groups have been shutdown. This returns null */
  communities?: Maybe<Array<Maybe<Community>>>;
  companies?: Maybe<CommonalitiesCompanies>;
  /** #rest(batched) #virtual */
  contacts?: Maybe<Array<Maybe<XingId>>>;
  events?: Maybe<CommonalitiesEvents>;
  jobroles?: Maybe<CommonalitiesJobRoles>;
  skills?: Maybe<CommonalitiesSkills>;
  education?: Maybe<CommonalitiesEducation>;
  industries?: Maybe<CommonalitiesIndustries>;
};

/**
 * Represents companies.
 * Contains information about companies in common among users.
 */
export type CommonalitiesCompanies = {
  __typename?: 'CommonalitiesCompanies';
  /** #rest(batched) #virtual */
  currentAToCurrentBIds?: Maybe<Array<Maybe<Company>>>;
  /** #rest(batched) #virtual */
  currentAToPastBIds?: Maybe<Array<Maybe<Company>>>;
  /** #rest(batched) #virtual */
  pastAToCurrentBIds?: Maybe<Array<Maybe<Company>>>;
  /** #rest(batched) #virtual */
  pastAToPastBIds?: Maybe<Array<Maybe<Company>>>;
};

/**
 * Represents education.
 * Contains information about education in common among users.
 */
export type CommonalitiesEducation = {
  __typename?: 'CommonalitiesEducation';
  universities: Array<Scalars['String']>;
  fieldsOfStudy: Array<Scalars['String']>;
};

/**
 * Represents events.
 * Contains information about events in common among users.
 */
export type CommonalitiesEvents = {
  __typename?: 'CommonalitiesEvents';
  pastEventIds?: Maybe<Array<Maybe<Event>>>;
  futureEventIds?: Maybe<Array<Maybe<Event>>>;
};

/**
 * Represents industries.
 * Contains information about industries in common among users.
 */
export type CommonalitiesIndustries = {
  __typename?: 'CommonalitiesIndustries';
  /** #rest(batched) #virtual */
  currentAToCurrentBIds?: Maybe<Array<Maybe<Industry>>>;
  /** #rest(batched) #virtual */
  currentAToPastBIds?: Maybe<Array<Maybe<Industry>>>;
  /** #rest(batched) #virtual */
  pastAToCurrentBIds?: Maybe<Array<Maybe<Industry>>>;
  /** #rest(batched) #virtual */
  pastAToPastBIds?: Maybe<Array<Maybe<Industry>>>;
};

/**
 * Represents job roles.
 * Contains information about job roles in common among users.
 */
export type CommonalitiesJobRoles = {
  __typename?: 'CommonalitiesJobRoles';
  currentAToCurrentB: Array<Scalars['String']>;
  currentAToPastB: Array<Scalars['String']>;
  pastAToCurrentB: Array<Scalars['String']>;
  pastAToPastB: Array<Scalars['String']>;
};

/** Profile Module Commonalities */
export type CommonalitiesModule = ModuleInterface & {
  __typename?: 'CommonalitiesModule';
  title: Scalars['String'];
  order: Scalars['Int'];
  /** #rest #virtual */
  commonalities?: Maybe<Commonalities>;
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

/**
 * Represents skills.
 * Contains information about skills in common among users.
 */
export type CommonalitiesSkills = {
  __typename?: 'CommonalitiesSkills';
  wantsAToWantsB: Array<Scalars['String']>;
  wantsAToHavesB: Array<Scalars['String']>;
  wantsAToInterestsB: Array<Scalars['String']>;
  havesAToWantsB: Array<Scalars['String']>;
  havesAToHavesB: Array<Scalars['String']>;
  havesAToInterestsB: Array<Scalars['String']>;
  interestsAToWantsB: Array<Scalars['String']>;
  interestsAToHavesB: Array<Scalars['String']>;
  interestsAToInterestsB: Array<Scalars['String']>;
};

export type CommunitiesConnection = HasCursorPagination & {
  __typename?: 'CommunitiesConnection';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
  /** #logged-out #soft-logged-in */
  edges?: Maybe<Array<Maybe<CommunitiesEdge>>>;
};

export type CommunitiesEdge = PaginationEdge & {
  __typename?: 'CommunitiesEdge';
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
  /** #logged-out #soft-logged-in */
  node: Community;
};

export type Community = {
  __typename?: 'Community';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  owner?: Maybe<XingId>;
  /** #logged-out #soft-logged-in */
  claim?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  links?: Maybe<CommunityLinks>;
  /** #logged-out #soft-logged-in */
  memberCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  logo: CommunityLogos;
  permissions?: Maybe<CommunityPermissions>;
  interactions?: Maybe<Array<Maybe<CommunityInteraction>>>;
  /** #logged-out #soft-logged-in */
  isMeetup: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  mode: GroupMode;
  /** #logged-out #soft-logged-in */
  hasAboutPage: Scalars['Boolean'];
  cityId?: Maybe<Scalars['Int']>;
  /** #rest(batched) #virtual */
  city?: Maybe<City>;
  meetupFrequency?: Maybe<CommunityMeetupFrequency>;
  /** #logged-out #soft-logged-in */
  type: CommunityStatus;
  currentMemberState?: Maybe<CommunityMemberState>;
  createdAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  postCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  commentCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  ownerUrn: Scalars['URN'];
  unreadPostsCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  hasImprint: Scalars['Boolean'];
  pendingMembersCount?: Maybe<Scalars['Int']>;
  category?: Maybe<CommunityCategory>;
  marketplace?: Maybe<CommunityMarketplace>;
  /** #logged-out #soft-logged-in */
  lastPostDate?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  location?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  canonicalUrl?: Maybe<Scalars['URL']>;
  hasNewContent?: Maybe<Scalars['Boolean']>;
};

export enum CommunityCategory {
  RegionalAmbassador = 'REGIONAL_AMBASSADOR',
  XpertAmbassador = 'XPERT_AMBASSADOR',
  Themen = 'THEMEN',
  Partnered = 'PARTNERED',
  Franchised = 'FRANCHISED',
  OwnedAndOperated = 'OWNED_AND_OPERATED'
}

export type CommunityInteraction = {
  __typename?: 'CommunityInteraction';
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CommunityInterationType>;
  url?: Maybe<Scalars['URL']>;
  method?: Maybe<CommunityInterationMethod>;
  dialog?: Maybe<CommunityInteractionDialog>;
};

export type CommunityInteractionDialog = {
  __typename?: 'CommunityInteractionDialog';
  type?: Maybe<CommunityInterationDialogType>;
  title?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum CommunityInterationDialogType {
  Message = 'MESSAGE',
  Confirmation = 'CONFIRMATION'
}

export enum CommunityInterationMethod {
  Post = 'POST',
  Delete = 'DELETE'
}

export enum CommunityInterationType {
  Primary = 'PRIMARY'
}

export type CommunityLinks = {
  __typename?: 'CommunityLinks';
  /** #logged-out #soft-logged-in */
  public?: Maybe<Scalars['URL']>;
};

export type CommunityLogoUrls = {
  __typename?: 'CommunityLogoUrls';
  /** #logged-out #soft-logged-in */
  original?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  small?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  medium?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  large?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  main?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  size96?: Maybe<Scalars['URL']>;
};

export type CommunityLogos = {
  __typename?: 'CommunityLogos';
  id?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  urls?: Maybe<CommunityLogoUrls>;
  meta?: Maybe<Scalars['String']>;
};

export type CommunityMarketplace = {
  __typename?: 'CommunityMarketplace';
  isNew?: Maybe<Scalars['Boolean']>;
  unreadClassifiedsCount?: Maybe<Scalars['Int']>;
};

export enum CommunityMeetupFrequency {
  Once = 'ONCE',
  TwoOrThreeTimes = 'TWO_OR_THREE_TIMES',
  FourOrFiveTimes = 'FOUR_OR_FIVE_TIMES',
  SixOrMoreTimes = 'SIX_OR_MORE_TIMES'
}

export enum CommunityMemberState {
  Owner = 'OWNER',
  Moderator = 'MODERATOR',
  Blocked = 'BLOCKED',
  Member = 'MEMBER',
  Pending = 'PENDING',
  Kicked = 'KICKED'
}

export enum CommunityMigrationState {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  GroupDeleted = 'GROUP_DELETED',
  Error = 'ERROR',
  MigrationCompleted = 'MIGRATION_COMPLETED',
  ContentMigrationInProgress = 'CONTENT_MIGRATION_IN_PROGRESS'
}

export type CommunityPermissions = {
  __typename?: 'CommunityPermissions';
  canRead?: Maybe<Scalars['Boolean']>;
  canUpdate?: Maybe<Scalars['Boolean']>;
  canDelete?: Maybe<Scalars['Boolean']>;
  canCreatePost?: Maybe<Scalars['Boolean']>;
  canReadMembers?: Maybe<Scalars['Boolean']>;
  canReadForums?: Maybe<Scalars['Boolean']>;
  canJoin?: Maybe<Scalars['Boolean']>;
};

export enum CommunityStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export enum CommunityTileStates {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum CommunityTileTypes {
  Texttile = 'TEXTTILE',
  Imagetile = 'IMAGETILE',
  Pdftile = 'PDFTILE',
  Videotile = 'VIDEOTILE'
}

export type CommunityTopic = {
  __typename?: 'CommunityTopic';
  id: Scalars['ID'];
  title: Scalars['String'];
  searchText: Scalars['String'];
  recentlyAdded: Scalars['Boolean'];
  cityId?: Maybe<Scalars['Int']>;
  images: CommunityTopicImages;
  filterType?: Maybe<Scalars['String']>;
  filterValue?: Maybe<Scalars['String']>;
};

export type CommunityTopicImages = {
  __typename?: 'CommunityTopicImages';
  large1x?: Maybe<Scalars['URL']>;
  large2x?: Maybe<Scalars['URL']>;
  large3x?: Maybe<Scalars['URL']>;
};

export type CommunityTopics = {
  __typename?: 'CommunityTopics';
  collection?: Maybe<Array<Maybe<CommunityTopic>>>;
};

export type CompactTrackingInput = {
  consumer: Scalars['String'];
  service: Scalars['String'];
  userId: Scalars['ID'];
  view?: Maybe<Array<Scalars['String']>>;
  viewed?: Maybe<Array<Scalars['String']>>;
  add?: Maybe<Array<Scalars['String']>>;
  added?: Maybe<Array<Scalars['String']>>;
  show?: Maybe<Array<Scalars['String']>>;
  shown?: Maybe<Array<Scalars['String']>>;
  select?: Maybe<Array<Scalars['String']>>;
  bookmark?: Maybe<Array<Scalars['String']>>;
  delete?: Maybe<Array<Scalars['String']>>;
  messageSent?: Maybe<Array<Scalars['String']>>;
  noteAdded?: Maybe<Array<Scalars['String']>>;
  shared?: Maybe<Array<Scalars['String']>>;
};

export type CompaniesArticlesCollection = {
  __typename?: 'CompaniesArticlesCollection';
  /** #logged-out #soft-logged-in */
  collection?: Maybe<Array<Maybe<CompanyArticle>>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export type CompaniesByIndustryCollection = {
  __typename?: 'CompaniesByIndustryCollection';
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<CompanyByIndustry>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export type CompaniesIndustriesCollection = {
  __typename?: 'CompaniesIndustriesCollection';
  /** #expand #logged-out #soft-logged-in */
  collection: Array<Maybe<CompaniesIndustry>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export enum CompaniesIndustriesSortOptions {
  Id = 'ID',
  Total = 'TOTAL'
}

export type CompaniesIndustry = {
  __typename?: 'CompaniesIndustry';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  industry?: Maybe<Industry>;
  /** #logged-out #soft-logged-in */
  bgColor: Scalars['String'];
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export enum CompaniesRecentlyClaimedOrder {
  IdDesc = 'ID_DESC',
  Random = 'RANDOM'
}

export type CompaniesSegmentsCollection = {
  __typename?: 'CompaniesSegmentsCollection';
  /** #expand #logged-out #soft-logged-in */
  collection: Array<Maybe<CompaniesIndustry>>;
};

export type Company = AiCompanyEnrichment & {
  __typename?: 'Company';
  createdAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  address?: Maybe<CompanyAddress>;
  /** #paginated #logged-out #soft-logged-in #rest #virtual */
  affiliates?: Maybe<CompanyAffiliatesConnection>;
  b2bClientId?: Maybe<Scalars['Int']>;
  commentsEnabled?: Maybe<Scalars['Boolean']>;
  companyInsights?: Maybe<CompanyInsights>;
  /** #logged-out #soft-logged-in */
  companyName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companySize?: Maybe<Scalars['String']>;
  companySizeId?: Maybe<Scalars['ID']>;
  companyUrl?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companySizeRange?: Maybe<CompanySizeRange>;
  /** #rest #virtual */
  demographics?: Maybe<CompanyDemographics>;
  employeesCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  jobsCount?: Maybe<Scalars['Int']>;
  /**
   * #rest #virtual
   *
   *  Returns a collection with the feeds of the company.
   * They are splitted in two groups, the rss_feeds and the twitter_feeds.
   * If the `rid` is not an editor for the company, then the backing endpoint will
   * generate a 401 error and the resolution will fail.
   */
  feedsSettings?: Maybe<CompanyFeedsSettings>;
  /** #paginated #logged-out #soft-logged-in #rest #virtual */
  employees?: Maybe<CompanyEmployeesConnection>;
  /** #logged-out #soft-logged-in */
  entityPageId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  entityPage?: Maybe<EntityPage>;
  /** #rest #virtual */
  followers?: Maybe<CompanyFollowersCollection>;
  hasXamAccount?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  idealEmployerEnabled?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  industry?: Maybe<Industry>;
  inPublicationWorkflow?: Maybe<Scalars['Boolean']>;
  isMerged?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  kununuData?: Maybe<CompanyKununuData>;
  /** #logged-out #soft-logged-in */
  links?: Maybe<CompanyLinks>;
  /** #logged-out #soft-logged-in */
  logos?: Maybe<CompanyLogos>;
  /** #preview */
  notifyAutoMigrated?: Maybe<Scalars['Boolean']>;
  orgTypeId?: Maybe<Scalars['Int']>;
  /** @deprecated please use `contractPackageName` instead as it comes with an ENUM. Checked on 10.03.2023, still used by unkown Web version */
  packageName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  contractPackageName?: Maybe<CompanyContractPackage>;
  phone?: Maybe<Scalars['String']>;
  /**
   * #rest #virtual
   *
   *  Tells if company is a child one
   */
  proJobs?: Maybe<CompanyProJobsData>;
  publicProfile?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  relatedCompanies?: Maybe<CompanyRelatedCompaniesCollection>;
  /** #paginated #logged-out #soft-logged-in #rest #virtual */
  reviews?: Maybe<CompanyKununuReviewConnection>;
  slug?: Maybe<Scalars['String']>;
  /** #rest #virtual */
  updateEditors?: Maybe<CompanyUpdateEditorsCollection>;
  /** #rest #virtual */
  updates?: Maybe<CompanyUpdatesCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Shows the aboutUs description text
   * @deprecated use aboutUsBatched
   */
  aboutUs?: Maybe<AboutEntityResult>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Shows the list of aboutUs description text by entity_page_id
   */
  aboutUsBatched?: Maybe<AboutEntityResult>;
  urn?: Maybe<Scalars['GlobalID']>;
  /** #expand */
  userContext?: Maybe<CompanyUserContext>;
  /** #rest #virtual */
  visitors?: Maybe<CompanyVisitorsCollection>;
  /** #logged-out #soft-logged-in */
  autogenerated: Scalars['Boolean'];
  isAiEnriched?: Maybe<Scalars['Boolean']>;
};


export type CompanyAffiliatesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


export type CompanyDemographicsArgs = {
  kpi?: Maybe<CompanyDemographicsKpi>;
};


export type CompanyEmployeesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  query: CompanyEmployeesQueryInput;
};


export type CompanyFollowersArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


export type CompanyReviewsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


export type CompanyUpdateEditorsArgs = {
  filter?: Maybe<CompanyUpdateEditorsFilter>;
};


export type CompanyUpdatesArgs = {
  filter?: Maybe<CompanyUpdatesFilter>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  order?: Maybe<CompanyUpdateOrder>;
};


export type CompanyVisitorsArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};

export type CompanyAboutUsFacts = {
  __typename?: 'CompanyAboutUsFacts';
  /** #logged-out #soft-logged-in */
  imprint?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  properties?: Maybe<AboutUsFactsProperties>;
  /** #logged-out #soft-logged-in */
  websiteUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  foundingYear?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  companyData?: Maybe<Company>;
};

export type CompanyAddress = Addressable & {
  __typename?: 'CompanyAddress';
  /** #logged-out #soft-logged-in */
  city?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  street?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  zip?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  country?: Maybe<Country>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  province?: Maybe<Province>;
};

export type CompanyAffiliate = {
  __typename?: 'CompanyAffiliate';
  /**
   * #logged-out #soft-logged-in
   * @deprecated This attribute will be removed in favor of categoryId and localization values. WILL BE REMOVED ...
   */
  category: CompanyAffiliateCategory;
  /** #logged-out #soft-logged-in */
  affiliateCategory?: Maybe<CompanyAffiliationCategory>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  affiliateCompany?: Maybe<Company>;
};

export enum CompanyAffiliateCategory {
  Parent = 'PARENT',
  Subsidiary = 'SUBSIDIARY',
  Associate = 'ASSOCIATE',
  Partner = 'PARTNER',
  Client = 'CLIENT',
  ServiceProvider = 'SERVICE_PROVIDER',
  JointVenture = 'JOINT_VENTURE',
  Franchise = 'FRANCHISE',
  RegionalBranch = 'REGIONAL_BRANCH'
}

export type CompanyAffiliatesConnection = HasCursorPagination & {
  __typename?: 'CompanyAffiliatesConnection';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
  /** #logged-out #soft-logged-in */
  edges?: Maybe<Array<Maybe<CompanyAffiliatesEdge>>>;
};

export type CompanyAffiliatesEdge = PaginationEdge & {
  __typename?: 'CompanyAffiliatesEdge';
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
  /** #logged-out #soft-logged-in */
  node?: Maybe<CompanyAffiliate>;
};

export type CompanyAffiliatesMutationError = {
  __typename?: 'CompanyAffiliatesMutationError';
  index?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
};

export type CompanyAffiliatesMutationErrorCollection = {
  __typename?: 'CompanyAffiliatesMutationErrorCollection';
  collection?: Maybe<Array<Maybe<CompanyAffiliatesMutationError>>>;
};

export type CompanyAffiliatesMutationResult = {
  __typename?: 'CompanyAffiliatesMutationResult';
  error?: Maybe<CompanyAffiliatesMutationErrorCollection>;
};

export type CompanyAffiliationCategories = {
  __typename?: 'CompanyAffiliationCategories';
  collection?: Maybe<Array<Maybe<CompanyAffiliationCategoryItem>>>;
};

export type CompanyAffiliationCategory = {
  __typename?: 'CompanyAffiliationCategory';
  id?: Maybe<Scalars['Int']>;
  localizationKey?: Maybe<Scalars['String']>;
  localizationValue?: Maybe<Scalars['String']>;
};

export type CompanyAffiliationCategoryItem = Localizable & {
  __typename?: 'CompanyAffiliationCategoryItem';
  id?: Maybe<Scalars['Int']>;
  localizationKey: Scalars['String'];
  localizationValue: Scalars['String'];
};

export type CompanyAggregations = {
  __typename?: 'CompanyAggregations';
  industry?: Maybe<Array<Maybe<IndustryAggregation>>>;
  offerStatus?: Maybe<Array<Maybe<OfferStatusAggregation>>>;
  size?: Maybe<Array<Maybe<CompanySizeAggregation>>>;
};

/**
 * Available aggregations for company search. It's expecting the number of aggregation to return in a String format.
 * For performance reasons it should never be greater than 20. 10 is a normal value.
 */
export type CompanyAggregationsInput = {
  industry?: Maybe<Scalars['String']>;
  offerStatus?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
};

export type CompanyAnniversaryStory = {
  __typename?: 'CompanyAnniversaryStory';
  id: Scalars['ID'];
  userId: Scalars['ID'];
  years: Scalars['Int'];
  companyId: Scalars['ID'];
  occupationId: Scalars['ID'];
  createdAt: Scalars['Date'];
  urn: Scalars['GlobalID'];
  startpageImages: CompanyAnniversaryStoryImagesByLanguage;
  fumlImages: CompanyAnniversaryStoryImagesByLanguage;
  objectUrn: Scalars['String'];
  actorUrn: Scalars['String'];
  actorData?: Maybe<CompanyAnniversaryStoryActorData>;
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
};

export type CompanyAnniversaryStoryActorData = {
  __typename?: 'CompanyAnniversaryStoryActorData';
  companyName?: Maybe<Scalars['String']>;
  companyTitle?: Maybe<Scalars['String']>;
};

export type CompanyAnniversaryStoryImagesByLanguage = {
  __typename?: 'CompanyAnniversaryStoryImagesByLanguage';
  de: CompanyAnniversaryStoryImagesBySize;
  en: CompanyAnniversaryStoryImagesBySize;
  fr: CompanyAnniversaryStoryImagesBySize;
  es: CompanyAnniversaryStoryImagesBySize;
  it: CompanyAnniversaryStoryImagesBySize;
};

export type CompanyAnniversaryStoryImagesBySize = {
  __typename?: 'CompanyAnniversaryStoryImagesBySize';
  imageSquare48: Scalars['String'];
  imageSquare64: Scalars['String'];
  imageSquare96: Scalars['String'];
  imageSquare128: Scalars['String'];
  imageSquare192: Scalars['String'];
  imageSquare1024: Scalars['String'];
};

export type CompanyArticle = {
  __typename?: 'CompanyArticle';
  /** #logged-out #soft-logged-in */
  objectUrn?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  readingTime?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  bgColor?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  details?: Maybe<CompanyArticleDetails>;
};

export type CompanyArticleDetails = {
  __typename?: 'CompanyArticleDetails';
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  image?: Maybe<CompanyArticleImage>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
};

export type CompanyArticleImage = {
  __typename?: 'CompanyArticleImage';
  /** #logged-out #soft-logged-in */
  srcSquare?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcSquare2x?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcWide?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcWide2x?: Maybe<Scalars['URL']>;
};

export type CompanyByIndustry = {
  __typename?: 'CompanyByIndustry';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
};

export type CompanyCityAggregation = {
  __typename?: 'CompanyCityAggregation';
  count?: Maybe<Scalars['Int']>;
  /** #rest(batched) #virtual */
  city?: Maybe<City>;
};

export type CompanyClaimed = {
  __typename?: 'CompanyClaimed';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
};

export type CompanyClaimedCollection = {
  __typename?: 'CompanyClaimedCollection';
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<CompanyClaimed>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export type CompanyCollection = {
  __typename?: 'CompanyCollection';
  collection?: Maybe<Array<Maybe<Company>>>;
};

export enum CompanyContractPackage {
  None = 'NONE',
  Basic = 'BASIC',
  Ebp = 'EBP',
  Plus = 'PLUS',
  Standard = 'STANDARD'
}

export type CompanyCreateAffiliatesInput = {
  id: Scalars['ID'];
  affiliates?: Maybe<Array<Maybe<CompanyCreateAffiliatesInputItem>>>;
};

export type CompanyCreateAffiliatesInputItem = {
  companyId: Scalars['ID'];
  categoryId?: Maybe<Scalars['Int']>;
};

export type CompanyCreateFeedError = {
  __typename?: 'CompanyCreateFeedError';
  localizedMessage?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<CompanyCreateFeedErrorType>;
};

export enum CompanyCreateFeedErrorType {
  RssUrlInvalid = 'RSS_URL_INVALID',
  RssFeedNotValid = 'RSS_FEED_NOT_VALID',
  TwitterTagInvalid = 'TWITTER_TAG_INVALID',
  TwitterFeedNotValid = 'TWITTER_FEED_NOT_VALID'
}

export type CompanyCreateFeedInput = {
  feedType: CompanyFeedType;
  source: Scalars['String'];
  companyId: Scalars['SlugOrID'];
};

export type CompanyCreateFeedResult = {
  __typename?: 'CompanyCreateFeedResult';
  success?: Maybe<CompanyFeed>;
  error?: Maybe<CompanyCreateFeedError>;
};

export type CompanyDefaultLogos = {
  __typename?: 'CompanyDefaultLogos';
  /** #logged-out #soft-logged-in */
  logo32px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo48px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo64px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo96px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo128px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo192px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo256px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo512px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo1024px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  imagecacheUuid?: Maybe<Scalars['UUID']>;
};

export type CompanyDeleteFeedError = {
  __typename?: 'CompanyDeleteFeedError';
  message?: Maybe<Scalars['String']>;
};

export type CompanyDeleteFeedInput = {
  feedId: Scalars['ID'];
  feedType: CompanyFeedType;
  companyId: Scalars['SlugOrID'];
};

export type CompanyDeleteFeedResult = {
  __typename?: 'CompanyDeleteFeedResult';
  error?: Maybe<CompanyDeleteFeedError>;
};

export type CompanyDemographics = {
  __typename?: 'CompanyDemographics';
  byAge?: Maybe<Array<Maybe<AgeGroupElement>>>;
  byCareerLevel?: Maybe<Array<Maybe<CareerLevelElement>>>;
  byTopCompanies?: Maybe<Array<Maybe<TopCompaniesElement>>>;
  byTopIndustries?: Maybe<Array<Maybe<TopIndustriesElement>>>;
};

export enum CompanyDemographicsKpi {
  Visitors = 'VISITORS',
  Followers = 'FOLLOWERS'
}

export type CompanyEmployeesConnection = HasCursorPagination & {
  __typename?: 'CompanyEmployeesConnection';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
  /** #logged-out #soft-logged-in */
  edges?: Maybe<Array<Maybe<CompanyEmployeesEdge>>>;
};

export enum CompanyEmployeesContactLevel {
  ConnectionNone = 'CONNECTION_NONE',
  Connection_1 = 'CONNECTION_1',
  Connection_2 = 'CONNECTION_2',
  Connection_2_1 = 'CONNECTION_2_1'
}

export type CompanyEmployeesEdge = PaginationEdge & {
  __typename?: 'CompanyEmployeesEdge';
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
  /** #logged-out #soft-logged-in */
  node?: Maybe<Employee>;
};

export type CompanyEmployeesFacetsInput = {
  /**
   * city: Maximum number of distinct values to be returned by this aggregation
   * discipline: Maximum number of distinct values to be returned by this aggregation.
   * lastNameInitial: Maximum number of distinct values to be returned by this aggregation.
   * level: Maximum number of distinct values to be returned by this aggregation.
   */
  city?: Maybe<Scalars['Int']>;
  discipline?: Maybe<Scalars['Int']>;
  lastNameInitial?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
};

export type CompanyEmployeesFiltersInput = {
  cityCode?: Maybe<Scalars['ID']>;
  contactLevel?: Maybe<CompanyEmployeesContactLevel>;
  disciplineId?: Maybe<Scalars['ID']>;
  hasPhoto?: Maybe<Scalars['Boolean']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  lastNameInitial?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['ID']>;
};

export type CompanyEmployeesNumber = Localizable & {
  __typename?: 'CompanyEmployeesNumber';
  /** #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #soft-logged-in */
  localizationValue: Scalars['String'];
};

export type CompanyEmployeesQueryInput = {
  consumer: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  filters?: Maybe<CompanyEmployeesFiltersInput>;
  facets?: Maybe<CompanyEmployeesFacetsInput>;
  sort?: Maybe<CompanyEmployeesSort>;
  timeout?: Maybe<Scalars['Int']>;
};

export enum CompanyEmployeesSort {
  LastName = 'LAST_NAME',
  ConnectionDegree = 'CONNECTION_DEGREE'
}

export type CompanyFeed = {
  id: Scalars['ID'];
  source: Scalars['String'];
};

export enum CompanyFeedType {
  Rss = 'RSS',
  Twitter = 'TWITTER'
}

export type CompanyFeedsSettings = {
  __typename?: 'CompanyFeedsSettings';
  rssFeeds?: Maybe<Array<Maybe<CompanyRssFeed>>>;
  twitterFeeds?: Maybe<Array<Maybe<CompanyTwitterFeed>>>;
};

/** Available filters for company search. If there is no special indication even if the type is a String it's waiting for the key for filtering (sometimes a string code and others and int). The possible values for each filter are the one listed as values in the corresponding aggregation */
export type CompanyFiltersInput = {
  /** industry should be a valid id for type Industry */
  industry?: Maybe<Scalars['String']>;
  /** location can be the id of a city, a province or a country */
  location?: Maybe<Scalars['String']>;
  /** This filter companies with or without vacancies */
  offerStatus?: Maybe<CompanyOffers>;
  /** size should be a valid id for CompanyEmployeesNumber */
  size?: Maybe<Scalars['String']>;
};

export type CompanyFollowState = {
  __typename?: 'CompanyFollowState';
  isFollowing?: Maybe<Scalars['Boolean']>;
};

/**
 * Returns a collection with the followers for the parent company.
 *
 * If the `rid` is not an editor for the company, then the backing endpoint will generate a 403 error and the resolution will fail.
 */
export type CompanyFollowersCollection = {
  __typename?: 'CompanyFollowersCollection';
  total: Scalars['Int'];
};

export type CompanyIdAggregation = HasAggregationCount & {
  __typename?: 'CompanyIdAggregation';
  /** #soft-logged-in */
  count: Scalars['Int'];
  /** #soft-logged-in */
  value?: Maybe<Scalars['Int']>;
  /** #soft-logged-in #rest(batched) #virtual */
  label?: Maybe<Company>;
};

export type CompanyInsights = {
  __typename?: 'CompanyInsights';
  visitors: CompanyInsightsVisitors;
  followers: CompanyInsightsFollowers;
  idealEmployers: CompanyInsightsIdealEmployers;
  /** #rest #virtual */
  report?: Maybe<CompanyInsightsReport>;
};


export type CompanyInsightsReportArgs = {
  timePeriod: CompanyInsightsTimePeriodInput;
  locale?: Maybe<Scalars['String']>;
};

export type CompanyInsightsFollowers = {
  __typename?: 'CompanyInsightsFollowers';
  /** #rest #virtual */
  totals?: Maybe<CompanyInsightsKpiTotals>;
  /** #rest #virtual */
  histogram?: Maybe<CompanyInsightsKpiHistogram>;
};


export type CompanyInsightsFollowersTotalsArgs = {
  timePeriod: CompanyInsightsTimePeriodInput;
};


export type CompanyInsightsFollowersHistogramArgs = {
  timePeriod: CompanyInsightsTimePeriodInput;
  granularity: CompanyInsightsGranularity;
};

export enum CompanyInsightsGranularity {
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH'
}

export type CompanyInsightsIdealEmployers = {
  __typename?: 'CompanyInsightsIdealEmployers';
  /** #rest #virtual */
  totals?: Maybe<CompanyInsightsKpiTotals>;
  /** #rest #virtual */
  histogram?: Maybe<CompanyInsightsKpiHistogram>;
};


export type CompanyInsightsIdealEmployersTotalsArgs = {
  timePeriod: CompanyInsightsTimePeriodInput;
};


export type CompanyInsightsIdealEmployersHistogramArgs = {
  timePeriod: CompanyInsightsTimePeriodInput;
  granularity: CompanyInsightsGranularity;
};

export type CompanyInsightsKpiHistogram = {
  __typename?: 'CompanyInsightsKpiHistogram';
  granularity: CompanyInsightsGranularity;
  collection: Array<CompanyInsightsKpiHistogramEntry>;
};

export type CompanyInsightsKpiHistogramEntry = {
  __typename?: 'CompanyInsightsKpiHistogramEntry';
  timestamp: Scalars['Date'];
  total: Scalars['Int'];
  added: Scalars['Int'];
  removed: Scalars['Int'];
};

export type CompanyInsightsKpiTotals = {
  __typename?: 'CompanyInsightsKpiTotals';
  periodTotal: Scalars['Int'];
  overallTotal: Scalars['Int'];
};

export type CompanyInsightsReport = {
  __typename?: 'CompanyInsightsReport';
  zipName: Scalars['String'];
  zipFile: Scalars['String'];
};

export type CompanyInsightsTimePeriodInput = {
  /** An iso8601 encoded UTC datetime, it can't have a + sign */
  from: Scalars['Date'];
  /** An iso8601 encoded UTC datetime, it can't have a + sign */
  to: Scalars['Date'];
};

export type CompanyInsightsVisitorReferer = {
  __typename?: 'CompanyInsightsVisitorReferer';
  total: Scalars['Int'];
  collection?: Maybe<Array<CompanyInsightsVisitorRefererValue>>;
};

export type CompanyInsightsVisitorRefererValue = {
  __typename?: 'CompanyInsightsVisitorRefererValue';
  referer: Scalars['String'];
  percentage: Scalars['Float'];
};

export type CompanyInsightsVisitorReferers = {
  __typename?: 'CompanyInsightsVisitorReferers';
  xing: CompanyInsightsVisitorReferer;
  searchEngines: CompanyInsightsVisitorReferer;
  websiteLinks: CompanyInsightsVisitorReferer;
  other: CompanyInsightsVisitorReferer;
};

export type CompanyInsightsVisitors = {
  __typename?: 'CompanyInsightsVisitors';
  /** #rest #virtual */
  totals?: Maybe<CompanyInsightsKpiTotals>;
  /** #rest #virtual */
  histogram?: Maybe<CompanyInsightsVisitorsHistogram>;
  /** #rest #virtual */
  referers?: Maybe<CompanyInsightsVisitorReferers>;
};


export type CompanyInsightsVisitorsTotalsArgs = {
  timePeriod: CompanyInsightsTimePeriodInput;
  onlyLoggedIn?: Maybe<Scalars['Boolean']>;
  onlyLoggedOut?: Maybe<Scalars['Boolean']>;
};


export type CompanyInsightsVisitorsHistogramArgs = {
  timePeriod: CompanyInsightsTimePeriodInput;
  granularity: CompanyInsightsGranularity;
  onlyLoggedIn?: Maybe<Scalars['Boolean']>;
  onlyLoggedOut?: Maybe<Scalars['Boolean']>;
};


export type CompanyInsightsVisitorsReferersArgs = {
  timePeriod: CompanyInsightsTimePeriodInput;
  topReferersLimit: Scalars['Int'];
  onlyLoggedIn?: Maybe<Scalars['Boolean']>;
  onlyLoggedOut?: Maybe<Scalars['Boolean']>;
};

export type CompanyInsightsVisitorsHistogram = {
  __typename?: 'CompanyInsightsVisitorsHistogram';
  granularity: CompanyInsightsGranularity;
  collection: Array<CompanyInsightsVisitorsHistogramEntry>;
};

export type CompanyInsightsVisitorsHistogramEntry = {
  __typename?: 'CompanyInsightsVisitorsHistogramEntry';
  timestamp: Scalars['Date'];
  total: Scalars['Int'];
  organic: Scalars['Int'];
  promotions: Scalars['Int'];
};

export type CompanyKununuBadge = {
  __typename?: 'CompanyKununuBadge';
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  awardUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in #virtual */
  image?: Maybe<Array<ScaledImage>>;
};


export type CompanyKununuBadgeImageArgs = {
  dimensions: Array<ScaledImageDimension>;
};

export type CompanyKununuCulture = {
  __typename?: 'CompanyKununuCulture';
  /** #logged-out #soft-logged-in */
  updatedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  link?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  completedSubmissionsCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  cultureCompass?: Maybe<CompanyKununuCultureDimension>;
  /** #logged-out #soft-logged-in */
  dimensions?: Maybe<CompanyKununuCultureDimensions>;
};

export type CompanyKununuCultureDimension = {
  __typename?: 'CompanyKununuCultureDimension';
  /** #logged-out #soft-logged-in */
  profile?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  industry?: Maybe<Scalars['Int']>;
};

export type CompanyKununuCultureDimensions = {
  __typename?: 'CompanyKununuCultureDimensions';
  /** #logged-out #soft-logged-in */
  workingTogether?: Maybe<CompanyKununuCultureDimension>;
  /** #logged-out #soft-logged-in */
  leadership?: Maybe<CompanyKununuCultureDimension>;
  /** #logged-out #soft-logged-in */
  strategicDirection?: Maybe<CompanyKununuCultureDimension>;
  /** #logged-out #soft-logged-in */
  worklifeBalance?: Maybe<CompanyKununuCultureDimension>;
};

export type CompanyKununuData = {
  __typename?: 'CompanyKununuData';
  /** #logged-out #soft-logged-in */
  profileUuid?: Maybe<Scalars['UUID']>;
  /** #logged-out #soft-logged-in */
  badges?: Maybe<Array<Maybe<CompanyKununuBadge>>>;
  /** #logged-out #soft-logged-in */
  badgesCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  companyProfileUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  mappedBenefits?: Maybe<Array<Maybe<CompanyMappedBenefit>>>;
  /** #logged-out #soft-logged-in */
  ratingCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  employerRatingsCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  ratingAverage?: Maybe<Scalars['Float']>;
  /** #logged-out #soft-logged-in */
  recommendationRate?: Maybe<Scalars['Float']>;
  /** #logged-out #soft-logged-in */
  reviewProfileUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  kununuCommentsUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  evaluateProfileUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  culture?: Maybe<CompanyKununuCulture>;
};

export type CompanyKununuReview = {
  __typename?: 'CompanyKununuReview';
  /** #logged-out #soft-logged-in */
  ratingAvg?: Maybe<Scalars['Float']>;
  /** #logged-out #soft-logged-in */
  created?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  jobStatus?: Maybe<CompanyKununuReviewJobStatus>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
};

export type CompanyKununuReviewConnection = HasCursorPagination & {
  __typename?: 'CompanyKununuReviewConnection';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  edges: Array<Maybe<CompanyKununuReviewEdge>>;
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
};

export type CompanyKununuReviewEdge = PaginationEdge & {
  __typename?: 'CompanyKununuReviewEdge';
  /** #logged-out #soft-logged-in */
  node?: Maybe<CompanyKununuReview>;
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
};

export enum CompanyKununuReviewJobStatus {
  Current = 'CURRENT',
  Internship = 'INTERNSHIP',
  Previous = 'PREVIOUS',
  NotSpecified = 'NOT_SPECIFIED'
}

export type CompanyLinks = {
  __typename?: 'CompanyLinks';
  default?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  public?: Maybe<Scalars['URL']>;
};

export type CompanyLogos = {
  __typename?: 'CompanyLogos';
  /** #logged-out #soft-logged-in */
  logo32px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo48px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo64px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo96px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo128px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo192px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo256px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo512px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  logo1024px?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  imagecacheUuid?: Maybe<Scalars['UUID']>;
};

export type CompanyMappedBenefit = {
  __typename?: 'CompanyMappedBenefit';
  /** #logged-out #soft-logged-in */
  type: CompanyMappedBenefitType;
  /** #logged-out #soft-logged-in */
  approvals: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  percentage?: Maybe<Scalars['Int']>;
};

export enum CompanyMappedBenefitType {
  Flexitime = 'FLEXITIME',
  HomeOffice = 'HOME_OFFICE',
  Canteen = 'CANTEEN',
  RestaurantTickets = 'RESTAURANT_TICKETS',
  Childcare = 'CHILDCARE',
  CompanyPension = 'COMPANY_PENSION',
  Accessibility = 'ACCESSIBILITY',
  HealthInTheWorkplace = 'HEALTH_IN_THE_WORKPLACE',
  CompanyDoctor = 'COMPANY_DOCTOR',
  Training = 'TRAINING',
  CarPark = 'CAR_PARK',
  ConvenientTransportLinks = 'CONVENIENT_TRANSPORT_LINKS',
  DiscountsSpecialOffers = 'DISCOUNTS_SPECIAL_OFFERS',
  CompanyCar = 'COMPANY_CAR',
  MobileDevice = 'MOBILE_DEVICE',
  ProfitSharing = 'PROFIT_SHARING',
  EventsForEmployees = 'EVENTS_FOR_EMPLOYEES',
  PrivateInternetUse = 'PRIVATE_INTERNET_USE',
  DogsWelcome = 'DOGS_WELCOME'
}

export enum CompanyMembership {
  /** Only users who currently work in the posting's company. */
  Current = 'CURRENT',
  /** Users who formerly worked in the posting's company, and they no longer work there. */
  Previous = 'PREVIOUS'
}

export enum CompanyOffers {
  WithPostings = 'WITH_POSTINGS',
  WithoutPostings = 'WITHOUT_POSTINGS'
}

export type CompanyPageCreateError = {
  __typename?: 'CompanyPageCreateError';
  errorType: Scalars['String'];
  errorCode: Scalars['Int'];
  errorsList?: Maybe<Array<Maybe<CompanyPageCreateErrorDetail>>>;
};

export type CompanyPageCreateErrorDetail = Localizable & {
  __typename?: 'CompanyPageCreateErrorDetail';
  field: Scalars['String'];
  localizationKey: Scalars['String'];
  localizationValue: Scalars['String'];
};

export type CompanyPageCreateInput = {
  companyName: Scalars['String'];
  industryId: Scalars['ID'];
  sizeId: Scalars['ID'];
};

export type CompanyPageCreatePayload = {
  __typename?: 'CompanyPageCreatePayload';
  error?: Maybe<CompanyPageCreateError>;
  success?: Maybe<CompanyPageCreateSuccess>;
};

export type CompanyPageCreateSuccess = {
  __typename?: 'CompanyPageCreateSuccess';
  entityPageId?: Maybe<Scalars['ID']>;
};

export type CompanyPreviewMetadata = PreviewMetadata & {
  __typename?: 'CompanyPreviewMetadata';
  urn: Scalars['GlobalID'];
  sourceActor?: Maybe<LinkPreviewSourceActor>;
};

export type CompanyProJobsData = {
  __typename?: 'CompanyProJobsData';
  idealEmployer?: Maybe<Scalars['Boolean']>;
};

export type CompanyProfileInsight = {
  __typename?: 'CompanyProfileInsight';
  name: Scalars['String'];
  tag: Scalars['String'];
  employeesRange: Scalars['String'];
  industry?: Maybe<IndustryInsight>;
  publicUrl: Scalars['URL'];
  logoUrl: Scalars['URL'];
  kununuRatingAverage?: Maybe<Scalars['Float']>;
  kununuRatingCount?: Maybe<Scalars['Int']>;
};

/** Available queries for company search. The difference between queries and filters is that queries is a free text search */
export type CompanyQueriesInput = {
  city?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CompanyRecommendation = {
  __typename?: 'CompanyRecommendation';
  /** #rest(batched) #virtual */
  company?: Maybe<Company>;
  reasonCode?: Maybe<Scalars['String']>;
  recommendationTracking?: Maybe<Scalars['String']>;
  dismissible?: Maybe<Scalars['Boolean']>;
  recommendationContacts?: Maybe<RecommendationContactsCollection>;
  reason?: Maybe<LocalizedCompanyRecommendationReason>;
};

export type CompanyRecommendationConnection = HasCursorPagination & {
  __typename?: 'CompanyRecommendationConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<CompanyRecommendationEdge>>>;
};

export type CompanyRecommendationEdge = PaginationEdge & {
  __typename?: 'CompanyRecommendationEdge';
  cursor: Scalars['String'];
  node?: Maybe<CompanyRecommendation>;
};

export type CompanyRelatedCompaniesCollection = {
  __typename?: 'CompanyRelatedCompaniesCollection';
  /** #logged-out #soft-logged-in */
  collection?: Maybe<Array<Maybe<RelatedCompany>>>;
};

export type CompanyRssFeed = CompanyFeed & {
  __typename?: 'CompanyRssFeed';
  id: Scalars['ID'];
  source: Scalars['String'];
};

export type CompanySearchConnection = HasCursorPagination & {
  __typename?: 'CompanySearchConnection';
  edges: Array<CompanySearchEdge>;
  aggs?: Maybe<CompanyAggregations>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type CompanySearchEdge = PaginationEdge & {
  __typename?: 'CompanySearchEdge';
  node?: Maybe<UniversalSearchCompanyResult>;
  /** #virtual */
  cursor: Scalars['String'];
};

export type CompanySizeAggregation = HasAggregationCount & {
  __typename?: 'CompanySizeAggregation';
  value: Scalars['Int'];
  /** #rest(batched) #virtual */
  label?: Maybe<CompanyEmployeesNumber>;
  count: Scalars['Int'];
};

export type CompanySizeRange = {
  __typename?: 'CompanySizeRange';
  /** #logged-out #soft-logged-in */
  min: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  max?: Maybe<Scalars['Int']>;
};

export type CompanyTwitterFeed = CompanyFeed & {
  __typename?: 'CompanyTwitterFeed';
  id: Scalars['ID'];
  source: Scalars['String'];
};

export type CompanyUpdate = {
  __typename?: 'CompanyUpdate';
  /** #rest(batched) #virtual */
  poster?: Maybe<XingId>;
  body?: Maybe<Scalars['String']>;
  body_html?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
  urn: Scalars['GlobalID'];
  activityStreamId?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  urlDescription?: Maybe<Scalars['URL']>;
  urlProvider?: Maybe<Scalars['URL']>;
  createdAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  links?: Maybe<CompanyUpdateLinks>;
  /** #rest(batched) #virtual */
  promotions?: Maybe<CompanyUpdateAds>;
  /** #rest(batched) #virtual */
  interactions?: Maybe<CompanyUpdateInteractions>;
};

export type CompanyUpdateAd = {
  __typename?: 'CompanyUpdateAd';
  id?: Maybe<Scalars['ID']>;
  adType?: Maybe<Scalars['String']>;
  adUrl?: Maybe<Scalars['URL']>;
  name?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['Date']>;
  stats?: Maybe<CompanyUpdateAdStatistics>;
  /** @deprecated Deprecated in favour of the plain string adStatus attribute */
  status?: Maybe<CompanyUpdateAdStatus>;
  adStatus?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated in favour of campaignId attribute */
  customerLightCampaignId?: Maybe<Scalars['Int']>;
  campaignId?: Maybe<Scalars['ID']>;
};

export type CompanyUpdateAdStatistics = {
  __typename?: 'CompanyUpdateAdStatistics';
  budget?: Maybe<Scalars['String']>;
  clicks?: Maybe<Scalars['Int']>;
  impressions?: Maybe<Scalars['Int']>;
  totalSpend?: Maybe<Scalars['String']>;
};

export enum CompanyUpdateAdStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED',
  TakenDown = 'TAKEN_DOWN',
  TakenDownCompletely = 'TAKEN_DOWN_COMPLETELY',
  Terminated = 'TERMINATED'
}

export type CompanyUpdateAds = {
  __typename?: 'CompanyUpdateAds';
  ads?: Maybe<Array<Maybe<CompanyUpdateAd>>>;
};

/**
 * The update editors of a company, ie: the editors of a company that
 * have posted at least one update in the company profile.
 */
export type CompanyUpdateEditor = {
  __typename?: 'CompanyUpdateEditor';
  userId: Scalars['ID'];
  userUrn: Scalars['GlobalID'];
  totalUpdates: Scalars['Int'];
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
};

export type CompanyUpdateEditorsCollection = {
  __typename?: 'CompanyUpdateEditorsCollection';
  collection?: Maybe<Array<Maybe<CompanyUpdateEditor>>>;
};

export type CompanyUpdateEditorsFilter = {
  types?: Maybe<Scalars['String']>;
  withPromotions?: Maybe<Scalars['Boolean']>;
  limitByPerformanceData?: Maybe<Scalars['Boolean']>;
};

export type CompanyUpdateInformationError = {
  __typename?: 'CompanyUpdateInformationError';
  localizedMessage?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<CompanyUpdateInformationErrorType>;
};

export enum CompanyUpdateInformationErrorType {
  SlugInvalid = 'SLUG_INVALID'
}

export type CompanyUpdateInformationInput = {
  companyId: Scalars['ID'];
  idealEmployerEnabled?: Maybe<Scalars['Boolean']>;
  commentsEnabled?: Maybe<Scalars['Boolean']>;
  publicProfile?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  industryId?: Maybe<Scalars['ID']>;
  sizeId?: Maybe<Scalars['ID']>;
};

export type CompanyUpdateInformationPayload = {
  __typename?: 'CompanyUpdateInformationPayload';
  error?: Maybe<CompanyUpdateInformationError>;
  success?: Maybe<Company>;
};

export type CompanyUpdateInteractions = {
  __typename?: 'CompanyUpdateInteractions';
  click?: Maybe<CompanyUpdateInteractionsDetails>;
  comment?: Maybe<CompanyUpdateInteractionsDetails>;
  like?: Maybe<CompanyUpdateInteractionsDetails>;
  share?: Maybe<CompanyUpdateInteractionsDetails>;
  view?: Maybe<CompanyUpdateInteractionsDetails>;
  impression?: Maybe<CompanyUpdateInteractionsDetails>;
};

export type CompanyUpdateInteractionsDetails = {
  __typename?: 'CompanyUpdateInteractionsDetails';
  aggregatedQty?: Maybe<Scalars['Int']>;
};

export type CompanyUpdateLinks = {
  __typename?: 'CompanyUpdateLinks';
  self?: Maybe<Scalars['URL']>;
  company?: Maybe<Scalars['URL']>;
  public?: Maybe<Scalars['URL']>;
  image?: Maybe<Scalars['URL']>;
  thumbnail?: Maybe<Scalars['URL']>;
};

export enum CompanyUpdateOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/**
 * Returns a collection with the updates of the company.
 *
 * If the `rid` is not an editor for the company, then the backing endpoint will generate a 403 error and the resolution will fail.
 */
export type CompanyUpdatesCollection = {
  __typename?: 'CompanyUpdatesCollection';
  total: Scalars['Int'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  collection?: Maybe<Array<Maybe<CompanyUpdate>>>;
};

export type CompanyUpdatesDeleteError = {
  __typename?: 'CompanyUpdatesDeleteError';
  message?: Maybe<Scalars['String']>;
};

export type CompanyUpdatesDeleteInput = {
  companyId: Scalars['ID'];
  updateId: Scalars['ID'];
};

export type CompanyUpdatesDeleteResult = {
  __typename?: 'CompanyUpdatesDeleteResult';
  error?: Maybe<CompanyUpdatesDeleteError>;
};

export type CompanyUpdatesFilter = {
  types?: Maybe<Scalars['String']>;
  editors?: Maybe<Scalars['String']>;
  withPromotions?: Maybe<Scalars['Boolean']>;
  limitByPerformanceData?: Maybe<Scalars['Boolean']>;
  includePages?: Maybe<Scalars['Boolean']>;
};

export type CompanyUserContext = {
  __typename?: 'CompanyUserContext';
  /** #rest(batched) #virtual */
  followState?: Maybe<CompanyFollowState>;
  userRole?: Maybe<CompanyUserRole>;
};

export enum CompanyUserRole {
  AdditionalAdmin = 'ADDITIONAL_ADMIN',
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  XingCsAdmin = 'XING_CS_ADMIN'
}

export type CompanyVisitor = {
  __typename?: 'CompanyVisitor';
  userId: Scalars['ID'];
  lastVisitedAt: Scalars['Date'];
  visitCount: Scalars['Int'];
  /** #rest(batched) #virtual */
  profileDetails?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  sharedContacts?: Maybe<SharedContacts>;
  /** #rest(batched) #virtual */
  contactDistance?: Maybe<ContactDistance>;
  /** #rest(batched) #virtual */
  networkRelationship?: Maybe<NetworkRelationship>;
};

/**
 * Returns a collection with the visitors of the parent company.
 *
 * If the `rid` is not an editor for the company, then the backing endpoint will generate a 403 error and the resolution will fail.
 */
export type CompanyVisitorsCollection = {
  __typename?: 'CompanyVisitorsCollection';
  total: Scalars['Int'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  collection?: Maybe<Array<Maybe<CompanyVisitor>>>;
};

export type CompanyYouFollowJobNotification = Notification & {
  __typename?: 'CompanyYouFollowJobNotification';
  /** #rest(batched) #virtual */
  object?: Maybe<JobResult>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type ComplaintReason = {
  __typename?: 'ComplaintReason';
  /** #logged-out #soft-logged-in */
  key?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  needsUserComment?: Maybe<Scalars['Boolean']>;
};

export type ComplaintsCreateContentReportError = {
  __typename?: 'ComplaintsCreateContentReportError';
  /** #logged-out #soft-logged-in */
  targetSnapshot?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComplaintsCreateContentReportErrors = {
  __typename?: 'ComplaintsCreateContentReportErrors';
  /** #logged-out #soft-logged-in */
  errors?: Maybe<ComplaintsCreateContentReportError>;
};

export type ComplaintsCreateContentReportInput = {
  authorUrn?: Maybe<Scalars['GlobalID']>;
  targetUrn: Scalars['GlobalID'];
};

export type ComplaintsCreateContentReportResult = {
  __typename?: 'ComplaintsCreateContentReportResult';
  /** #logged-out #soft-logged-in */
  success?: Maybe<ComplaintsCreateContentReportSuccess>;
  /** #logged-out #soft-logged-in */
  error?: Maybe<ComplaintsCreateContentReportErrors>;
};

export type ComplaintsCreateContentReportSuccess = {
  __typename?: 'ComplaintsCreateContentReportSuccess';
  /** #logged-out #soft-logged-in */
  report?: Maybe<ComplaintsReport>;
};

export type ComplaintsCreateProfileReportError = {
  __typename?: 'ComplaintsCreateProfileReportError';
  targetSnapshot?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComplaintsCreateProfileReportErrors = {
  __typename?: 'ComplaintsCreateProfileReportErrors';
  errors?: Maybe<ComplaintsCreateProfileReportError>;
};

export type ComplaintsCreateProfileReportInput = {
  id: Scalars['ID'];
};

export type ComplaintsCreateProfileReportResult = {
  __typename?: 'ComplaintsCreateProfileReportResult';
  success?: Maybe<ComplaintsCreateProfileReportSuccess>;
  error?: Maybe<ComplaintsCreateProfileReportErrors>;
  /**
   * #rest
   *
   *  XingIdModule of the user added as a lead
   */
  xingIdModule?: Maybe<XingIdModule>;
};


export type ComplaintsCreateProfileReportResultXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

export type ComplaintsCreateProfileReportSuccess = {
  __typename?: 'ComplaintsCreateProfileReportSuccess';
  report?: Maybe<ComplaintsReport>;
};

export type ComplaintsReport = {
  __typename?: 'ComplaintsReport';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  authorUrn?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in */
  targetUrn?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in */
  reporterUrn?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in */
  userReverted?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  userComment?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  completed?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  reasonKey?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  loggedInReporter?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  isCancellable?: Maybe<Scalars['Boolean']>;
};

export type ComplaintsReportInput = {
  id: Scalars['ID'];
};

export type CompleteReport403Error = {
  __typename?: 'CompleteReport403Error';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
};

export type CompleteReportResponse = {
  __typename?: 'CompleteReportResponse';
  /** #logged-out #soft-logged-in */
  report?: Maybe<ComplaintsReport>;
};

export type CompleteReportResult = CompleteReportResponse | CompleteReport403Error;

export type ConfirmEmailReport403Error = {
  __typename?: 'ConfirmEmailReport403Error';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
};

export type ConfirmEmailReport404Error = {
  __typename?: 'ConfirmEmailReport404Error';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type ConfirmEmailReportInput = {
  id: Scalars['ID'];
  reporterEmail: Scalars['String'];
};

export type ConfirmEmailReportResult = ConfirmEmailReport403Error | ConfirmEmailReport404Error | ConfirmEmailReportSuccess;

export type ConfirmEmailReportSuccess = {
  __typename?: 'ConfirmEmailReportSuccess';
  /** #logged-out #soft-logged-in */
  success: Scalars['Boolean'];
};

export type ConnectionLevelResponse = {
  __typename?: 'ConnectionLevelResponse';
  /** #soft-logged-in */
  lowConnected?: Maybe<Scalars['Boolean']>;
};

export type Contact = {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  option?: Maybe<Scalars['String']>;
  recaptcha?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ContactDistance = {
  __typename?: 'ContactDistance';
  /**
   * #soft-logged-in
   *
   *  Id of the user we are querying the distance between them and the current user
   */
  userId: Scalars['ID'];
  /**
   * #soft-logged-in
   *
   *  The distance itself, possible values are 0, 1 and 2
   * 0: no relation exists between users
   * 1: the user is a first degree contact (direct contact) to the caller of the query
   * 2: the user is a second degree contact (connected through a common contact) to the caller of the query
   */
  distance: Scalars['Int'];
};

export type ContactError = {
  __typename?: 'ContactError';
  /** #logged-out #soft-logged-in */
  errors?: Maybe<ContactErrorMessages>;
};

export type ContactErrorMessages = {
  __typename?: 'ContactErrorMessages';
  /** #logged-out #soft-logged-in */
  email?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  topic?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  subject?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  option?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  recaptcha?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  files?: Maybe<Scalars['String']>;
};

export type ContactPositiveResponse = {
  __typename?: 'ContactPositiveResponse';
  /** #logged-out #soft-logged-in */
  emailAttached?: Maybe<Scalars['Boolean']>;
};

export type ContactPostResult = ContactPositiveResponse | ContactError;

export type ContactRecommendationSignal = NetworkUpdatesStackItem & {
  __typename?: 'ContactRecommendationSignal';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  object?: Maybe<PeopleStoryGeneratorMymkRecommendation>;
  /** #rest(batched) #virtual */
  sharedContacts?: Maybe<SharedContacts>;
  id: Scalars['ID'];
  stackId: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type ContactRecommendationStack = SignalsStack & {
  __typename?: 'ContactRecommendationStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type ContactRecommendationStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type ContactRequestConversationStarter = ConversationStarter & {
  __typename?: 'ContactRequestConversationStarter';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type ContactRequestReceived = {
  __typename?: 'ContactRequestReceived';
  /** #soft-logged-in */
  id: Scalars['ID'];
  /** #soft-logged-in */
  createdAt: Scalars['Date'];
  /** #soft-logged-in */
  createdAtWithTimezone: Scalars['Date'];
  reason?: Maybe<Scalars['String']>;
  /** #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  sharedContacts?: Maybe<SharedContacts>;
};

export type ContactRequestSent = {
  __typename?: 'ContactRequestSent';
  /** #soft-logged-in */
  id: Scalars['ID'];
  /** #soft-logged-in */
  createdAt: Scalars['Date'];
  /** #soft-logged-in */
  createdAtWithTimezone: Scalars['Date'];
  /** #soft-logged-in */
  recipientId?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  /** #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type ContactRequestSentEdge = PaginationEdge & {
  __typename?: 'ContactRequestSentEdge';
  cursor: Scalars['String'];
  node: ContactRequestSent;
};

export type ContactRequestStack = SignalsStack & {
  __typename?: 'ContactRequestStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type ContactRequestStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type ContactRequestsConfirmError = {
  __typename?: 'ContactRequestsConfirmError';
  message?: Maybe<Scalars['String']>;
};

export type ContactRequestsConfirmInput = {
  otherId: Scalars['ID'];
  requestAnswer?: Maybe<Scalars['String']>;
};

export type ContactRequestsConfirmResult = {
  __typename?: 'ContactRequestsConfirmResult';
  error?: Maybe<ContactRequestsConfirmError>;
};

export type ContactRequestsDeclineError = {
  __typename?: 'ContactRequestsDeclineError';
  message: Scalars['String'];
};

export type ContactRequestsDeclineInput = {
  otherId: Scalars['ID'];
};

export type ContactRequestsDeclineResult = {
  __typename?: 'ContactRequestsDeclineResult';
  error?: Maybe<ContactRequestsDeclineError>;
};

export type ContactRequestsMarkSeenError = {
  __typename?: 'ContactRequestsMarkSeenError';
  message?: Maybe<Scalars['String']>;
};

export type ContactRequestsMarkSeenInput = {
  untilDatetime: Scalars['Date'];
};

export type ContactRequestsMarkSeenResult = {
  __typename?: 'ContactRequestsMarkSeenResult';
  /** #soft-logged-in */
  error?: Maybe<ContactRequestsMarkSeenError>;
};

export type ContactRequestsOneClickToken = {
  __typename?: 'ContactRequestsOneClickToken';
  /** #soft-logged-in */
  tokenPayload?: Maybe<ContactRequestsOneClickTokenPayload>;
};

export type ContactRequestsOneClickTokenPayload = {
  __typename?: 'ContactRequestsOneClickTokenPayload';
  /** #soft-logged-in */
  userId?: Maybe<Scalars['ID']>;
  /** #soft-logged-in */
  recipientId?: Maybe<Scalars['ID']>;
  /** #soft-logged-in #rest(batched) #virtual */
  recipient?: Maybe<XingId>;
};

/**
 * Collections of unfenced and fenced contact requests.
 * If user is premium or if no fenced elements are available fencedCollection will be null, not a collection.
 */
export type ContactRequestsReceived = {
  __typename?: 'ContactRequestsReceived';
  /** #soft-logged-in */
  total: Scalars['Int'];
  /** #soft-logged-in */
  collection: Array<ContactRequestReceived>;
  /** #soft-logged-in */
  fencedCollection?: Maybe<Array<ContactRequestReceived>>;
};

export type ContactRequestsRevokeError = {
  __typename?: 'ContactRequestsRevokeError';
  message?: Maybe<Scalars['String']>;
};

export type ContactRequestsRevokeInput = {
  recipientId: Scalars['ID'];
};

export type ContactRequestsRevokeResult = {
  __typename?: 'ContactRequestsRevokeResult';
  error?: Maybe<ContactRequestsRevokeError>;
};

export type ContactRequestsSendError = {
  __typename?: 'ContactRequestsSendError';
  /** #soft-logged-in */
  message?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  errors?: Maybe<ContactRequestsSendErrorErrors>;
};

export type ContactRequestsSendErrorErrors = {
  __typename?: 'ContactRequestsSendErrorErrors';
  /** #soft-logged-in */
  reason?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ContactRequestsSendInput = {
  recipientId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export type ContactRequestsSendMultipleError = {
  __typename?: 'ContactRequestsSendMultipleError';
  /** #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type ContactRequestsSendMultipleInput = {
  recipientIds: Array<Scalars['ID']>;
};

export type ContactRequestsSendMultipleResult = {
  __typename?: 'ContactRequestsSendMultipleResult';
  /** #soft-logged-in */
  success?: Maybe<ContactRequestsSendMultipleSuccess>;
  /** #soft-logged-in */
  error?: Maybe<ContactRequestsSendMultipleError>;
};

export type ContactRequestsSendMultipleSuccess = {
  __typename?: 'ContactRequestsSendMultipleSuccess';
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<ContactRequestsSendMultipleSuccessItem>>>;
  /** #soft-logged-in */
  total: Scalars['Int'];
};

export type ContactRequestsSendMultipleSuccessItem = {
  __typename?: 'ContactRequestsSendMultipleSuccessItem';
  /** #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #soft-logged-in */
  error?: Maybe<Scalars['String']>;
};

export type ContactRequestsSendResult = {
  __typename?: 'ContactRequestsSendResult';
  /** #soft-logged-in */
  success?: Maybe<ContactRequestsSendSuccess>;
  /** #soft-logged-in */
  error?: Maybe<ContactRequestsSendError>;
};

export type ContactRequestsSendSuccess = {
  __typename?: 'ContactRequestsSendSuccess';
  /** #soft-logged-in #rest #virtual */
  contactRequestsSent?: Maybe<ContactRequestsSent>;
  /** #soft-logged-in #rest #virtual */
  userFeatures?: Maybe<UserFeatures>;
};

export type ContactRequestsSent = {
  __typename?: 'ContactRequestsSent';
  /** #soft-logged-in */
  total: Scalars['Int'];
  /** #soft-logged-in */
  collection: Array<ContactRequestSent>;
  /** #soft-logged-in #rest #virtual */
  userFeatures?: Maybe<UserFeatures>;
};

export type ContactRequestsSentConnection = HasCursorPagination & {
  __typename?: 'ContactRequestsSentConnection';
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
  edges: Array<Maybe<ContactRequestSentEdge>>;
};

export type ContactRequestsSpamReportError = {
  __typename?: 'ContactRequestsSpamReportError';
  message?: Maybe<Scalars['String']>;
};

export type ContactRequestsSpamReportInput = {
  otherId: Scalars['ID'];
  spamMessage: Scalars['String'];
};

export type ContactRequestsSpamReportResult = {
  __typename?: 'ContactRequestsSpamReportResult';
  error?: Maybe<ContactRequestsSpamReportError>;
  /** #expand */
  success?: Maybe<ContactRequestsSpamReportSuccess>;
};

export type ContactRequestsSpamReportSuccess = {
  __typename?: 'ContactRequestsSpamReportSuccess';
  spammerId?: Maybe<Scalars['ID']>;
};

export type ContactRequestsTokenConfirmError = {
  __typename?: 'ContactRequestsTokenConfirmError';
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type ContactRequestsTokenConfirmInput = {
  token?: Maybe<Scalars['String']>;
};

export type ContactRequestsTokenConfirmResult = {
  __typename?: 'ContactRequestsTokenConfirmResult';
  /** #logged-out #soft-logged-in */
  error?: Maybe<ContactRequestsTokenConfirmError>;
  /** #expand #logged-out #soft-logged-in */
  success?: Maybe<ContactRequestsTokenConfirmSuccess>;
};

export type ContactRequestsTokenConfirmSuccess = {
  __typename?: 'ContactRequestsTokenConfirmSuccess';
  /** @deprecated Clients should use the messenger API instead in order to create a chat. Checked on 14.11.2023 - still used a lot by Mobile */
  chatId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  hasReason?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  recipientTrackingId?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  recipient?: Maybe<XingId>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  sender?: Maybe<XingId>;
};

export type ContactTopicsResponse = {
  __typename?: 'ContactTopicsResponse';
  user?: Maybe<User>;
  /** #logged-out #soft-logged-in */
  topics?: Maybe<Array<Maybe<Topics>>>;
};

export type ContactUsersCatalogueItemInput = {
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
  deleted?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['ID']>;
};

export type ContactWithBirthday = {
  __typename?: 'ContactWithBirthday';
  /** #rest(batched) #virtual */
  personalDetails?: Maybe<PersonalDetails>;
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type ContactWithBirthdayConnection = HasCursorPagination & {
  __typename?: 'ContactWithBirthdayConnection';
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<ContactWithBirthdayEdge>>>;
};

export type ContactWithBirthdayEdge = PaginationEdge & {
  __typename?: 'ContactWithBirthdayEdge';
  cursor: Scalars['String'];
  node: ContactWithBirthday;
};

/** Which city to filter for */
export type ContactsCityArguments = {
  names: Array<Scalars['String']>;
};

/** Which company to filter for */
export type ContactsCompanyArguments = {
  names: Array<Scalars['String']>;
};

export type ContactsContactConfirmedNotification = Notification & {
  __typename?: 'ContactsContactConfirmedNotification';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type ContactsContactRecommendationNotification = Notification & {
  __typename?: 'ContactsContactRecommendationNotification';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  object?: Maybe<PeopleStoryGeneratorMymkRecommendation>;
  /** #rest(batched) #virtual */
  sharedContacts?: Maybe<SharedContacts>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type ContactsContactRequestNotification = Notification & {
  __typename?: 'ContactsContactRequestNotification';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

/** Count of active contact requests */
export type ContactsCount = {
  __typename?: 'ContactsCount';
  /** #soft-logged-in */
  count: Scalars['Int'];
};

export type ContactsDeleteError = {
  __typename?: 'ContactsDeleteError';
  message?: Maybe<Scalars['String']>;
};

export type ContactsDeleteInput = {
  friendId: Scalars['ID'];
};

export type ContactsDeleteResult = {
  __typename?: 'ContactsDeleteResult';
  error?: Maybe<ContactsDeleteError>;
};

/** Filters for contacts */
export type ContactsFilters = {
  tagged?: Maybe<ContactsTaggedArguments>;
  match?: Maybe<ContactsMatchArguments>;
  city?: Maybe<ContactsCityArguments>;
  company?: Maybe<ContactsCompanyArguments>;
};

export type ContactsJobUpdateNotification = Notification & {
  __typename?: 'ContactsJobUpdateNotification';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  object?: Maybe<ProfileWorkExperienceUpdate>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

/** Contact element in list of contacts */
export type ContactsListContact = {
  __typename?: 'ContactsListContact';
  /** #soft-logged-in */
  id: Scalars['ID'];
  /** #soft-logged-in */
  contactCreatedAt?: Maybe<Scalars['Date']>;
  memo?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  urn?: Maybe<Scalars['URN']>;
  tagList?: Maybe<Array<NetworkTag>>;
  /** #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /** #soft-logged-in */
  normalizedInitialOfFirstName?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  normalizedInitialOfLastName?: Maybe<Scalars['String']>;
};

export type ContactsListContactEdge = PaginationEdge & {
  __typename?: 'ContactsListContactEdge';
  cursor: Scalars['String'];
  node: ContactsListContact;
};

/** Ordering of the contacts list */
export enum ContactsListOrderBy {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  ContactCreatedAt = 'CONTACT_CREATED_AT'
}

/** Search functionality */
export type ContactsMatchArguments = {
  field: ContactsMatchField;
  value: Scalars['String'];
};

/** Which field to search in */
export enum ContactsMatchField {
  Name = 'NAME'
}

/** Contacts Module */
export type ContactsModule = ModuleInterface & {
  __typename?: 'ContactsModule';
  order: Scalars['Int'];
  title: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

/** List of contacts, can be filtered */
export type ContactsNetwork = {
  __typename?: 'ContactsNetwork';
  /** #soft-logged-in */
  total?: Maybe<Scalars['Int']>;
  /** #soft-logged-in */
  collection?: Maybe<Array<ContactsListContact>>;
};

export type ContactsNetworkByCursorConnection = HasCursorPagination & {
  __typename?: 'ContactsNetworkByCursorConnection';
  /** #soft-logged-in */
  total: Scalars['Int'];
  /** #soft-logged-in */
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<ContactsListContactEdge>>>;
};

export type ContactsRecruiterRecommendationNotification = Notification & {
  __typename?: 'ContactsRecruiterRecommendationNotification';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

/** Count of same city contact */
export type ContactsSameCityCount = {
  __typename?: 'ContactsSameCityCount';
  total: Scalars['Int'];
};

export type ContactsSearchAggregationsInput = {
  city?: Maybe<Scalars['Int']>;
  company?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
};

export type ContactsSearchConnection = HasCursorPagination & {
  __typename?: 'ContactsSearchConnection';
  /** #virtual */
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<ContactsSearchEdge>>;
};

export type ContactsSearchEdge = PaginationEdge & {
  __typename?: 'ContactsSearchEdge';
  cursor: Scalars['String'];
  node: ContactsSearchResult;
};

export type ContactsSearchFiltersInput = {
  /**
   * Available filters for contact search
   * city: Filter results which match the city
   * company: filter results by the user current company
   * title: filter results by the user current job title
   */
  city?: Maybe<Scalars['Int']>;
  company?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
};

export type ContactsSearchResult = {
  __typename?: 'ContactsSearchResult';
  /** Unique identifier of the entity */
  id?: Maybe<Scalars['ID']>;
  /**
   * #rest(batched) #virtual
   *
   *  The profile information for the user
   */
  xingId?: Maybe<XingId>;
  trackingToken?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
};

/** Which tags to filter for */
export type ContactsTaggedArguments = {
  ids: Array<Scalars['ID']>;
};

export type ContentArticle = ContentArticleInterface & HasGlobalId & {
  __typename?: 'ContentArticle';
  /** #logged-out #soft-logged-in */
  editUrl: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  metadata: ContentArticleMetadata;
  /**
   * #logged-out #soft-logged-in
   * @deprecated `social` was renamed to `interactions`. Will be removed after NDIST-517, NDIST-518
   */
  social: ContentArticleSocial;
  /** #logged-out #soft-logged-in */
  interactions: ContentArticleInteractions;
  /** #logged-out #soft-logged-in */
  resourceFeatures: ContentArticleFeatures;
  /**
   * #logged-out #soft-logged-in
   *
   *  The URN to be used when integrating social interactions into this article
   */
  socialInteractionTargetUrn?: Maybe<Scalars['GlobalID']>;
  /** #rest(batched) #virtual */
  socialInteractionTarget?: Maybe<SocialInteractionTarget>;
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Unique identifier for a ContentArticle (i.e. URN)
   */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  pageId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  pageGlobalId?: Maybe<Scalars['GlobalID']>;
  /**
   * #rest(batched) #virtual
   *
   *  This only resolves pages for contentInsiderArticles for now and returns null for othe page types
   */
  page?: Maybe<ContentPageInterface>;
  /**
   * #logged-out #soft-logged-in
   *
   *  URN of the object which this article refers to (if any). This is NOT the URN of the ContentArticle!
   */
  objectUrn?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  introductoryText?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  publishedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  updatedAt: Scalars['Date'];
  /** #logged-out #soft-logged-in */
  source?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  shareUrl: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  hasVideo: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isSponsored: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isExternal: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isFeatured: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated moved to `isPremium`. Will be removed after NDIST-515, NDIST-517 and NDIST-518
   */
  isNewsPlus: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isPremium: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated moved to `resourceFeatures`. Will be removed after NDIST-518
   */
  isCommentable: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  image: ContentArticleImage;
  /** #logged-out #soft-logged-in */
  status: ContentArticleStatus;
  /** #logged-out #soft-logged-in */
  resourceType: ContentResourceType;
  /** #logged-out #soft-logged-in */
  abilities: ContentArticleAbilities;
  /** #logged-out #soft-logged-in */
  reportingData: ContentArticleReportingData;
};

export type ContentArticleAbilities = {
  __typename?: 'ContentArticleAbilities';
  /** #logged-out #soft-logged-in */
  canDeleteArticle: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canEditArticle: Scalars['Boolean'];
};

export type ContentArticleDeletionResult = ContentDeletionResultInteface & {
  __typename?: 'ContentArticleDeletionResult';
  /** #rest #virtual */
  page?: Maybe<ContentInsiderPageInterface>;
  /** #rest #virtual */
  featuredArticles?: Maybe<ContentArticlesResponse>;
  error?: Maybe<ContentError>;
};

export type ContentArticleEdge = PaginationEdge & {
  __typename?: 'ContentArticleEdge';
  node: ContentArticleInterface;
  /** #virtual */
  cursor: Scalars['String'];
};

export type ContentArticleFeatures = ContentBaseArticleFeatures & {
  __typename?: 'ContentArticleFeatures';
  /** #logged-out #soft-logged-in */
  isStarable: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  areCommentsDisplayedExternally: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isCommentable: Scalars['Boolean'];
};

export type ContentArticleImage = {
  __typename?: 'ContentArticleImage';
  /** #logged-out #soft-logged-in */
  srcSquare?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcSquare2x?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcWide?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcWide2x?: Maybe<Scalars['URL']>;
};

export type ContentArticleInteractions = ContentBaseArticleInteractions & {
  __typename?: 'ContentArticleInteractions';
  /** #logged-out #soft-logged-in */
  isStarred: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isBookmarked: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isCommented: Scalars['Boolean'];
};

export type ContentArticleInterface = {
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Unique identifier for a ContentArticle (i.e. URN)
   */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  pageId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  pageGlobalId?: Maybe<Scalars['GlobalID']>;
  /**
   * #rest(batched) #virtual
   *
   *  This only resolves pages for contentInsiderArticles for now and returns null for othe page types
   */
  page?: Maybe<ContentPageInterface>;
  /**
   * #logged-out #soft-logged-in
   *
   *  URN of the object which this article refers to (if any). This is NOT the URN of the ContentArticle!
   */
  objectUrn?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  introductoryText?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  publishedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  updatedAt: Scalars['Date'];
  /** #logged-out #soft-logged-in */
  source?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  shareUrl: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  hasVideo: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isSponsored: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isExternal: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isFeatured: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated moved to `isPremium`. Will be removed after NDIST-515, NDIST-517 and NDIST-518
   */
  isNewsPlus: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isPremium: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated moved to `resourceFeatures`. Will be removed after NDIST-518
   */
  isCommentable: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  image: ContentArticleImage;
  /** #logged-out #soft-logged-in */
  interactions: ContentBaseArticleInteractions;
  /**
   * #logged-out #soft-logged-in
   * @deprecated `social` was renamed to `interactions`. Will be removed after NDIST-517, NDIST-518
   */
  social: ContentBaseArticleSocial;
  /** #logged-out #soft-logged-in */
  metadata: ContentBaseArticleMetadata;
  /** #logged-out #soft-logged-in */
  resourceFeatures: ContentBaseArticleFeatures;
  /** #logged-out #soft-logged-in */
  status: ContentArticleStatus;
  /** #logged-out #soft-logged-in */
  resourceType: ContentResourceType;
  /** #logged-out #soft-logged-in */
  abilities: ContentArticleAbilities;
  /** #logged-out #soft-logged-in */
  reportingData: ContentArticleReportingData;
};

export type ContentArticleMetadata = ContentBaseArticleMetadata & {
  __typename?: 'ContentArticleMetadata';
  /**
   * #logged-out #soft-logged-in
   * @deprecated Moved to SocialInteractionTarget.reactionsCount
   */
  starsCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  readCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated Moved to SocialInteractionTarget.commentsCount
   */
  commentsCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  clicksCount should be null for legacy articles, unless its a new article, in that case it wont be null
   */
  clicksCount?: Maybe<Scalars['Int']>;
};

export type ContentArticleMutationResult = {
  __typename?: 'ContentArticleMutationResult';
  /** #rest #virtual */
  page?: Maybe<ContentInsiderPageInterface>;
  /** #rest #virtual */
  featuredArticles?: Maybe<ContentArticlesResponse>;
  success?: Maybe<ContentArticleInterface>;
  error?: Maybe<ContentError>;
};

export type ContentArticlePurchase = ContentPurchaseInterface & HasDerivedGlobalId & {
  __typename?: 'ContentArticlePurchase';
  teaser: ContentArticle;
  id: Scalars['ID'];
  priceCents: Scalars['Int'];
  /** Globally unique id for this instance based on typename and id */
  globalId: Scalars['GlobalID'];
};

export type ContentArticleReportingData = {
  __typename?: 'ContentArticleReportingData';
  /** #logged-out #soft-logged-in */
  authorGlobalId?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in */
  targetGlobalId: Scalars['GlobalID'];
};

export type ContentArticleSocial = ContentBaseArticleSocial & {
  __typename?: 'ContentArticleSocial';
  /** #logged-out #soft-logged-in */
  isStarred: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isBookmarked: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isCommented: Scalars['Boolean'];
};

export enum ContentArticleStatus {
  Published = 'PUBLISHED',
  Draft = 'DRAFT',
  Scheduled = 'SCHEDULED',
  Disabled = 'DISABLED'
}

export type ContentArticlesConnection = HasCursorPagination & {
  __typename?: 'ContentArticlesConnection';
  edges: Array<Maybe<ContentArticleEdge>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type ContentArticlesResponse = {
  __typename?: 'ContentArticlesResponse';
  total: Scalars['Int'];
  collection: Array<Maybe<ContentArticleInterface>>;
};

export type ContentBaseArticleFeatures = {
  /** #logged-out #soft-logged-in */
  areCommentsDisplayedExternally: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isCommentable: Scalars['Boolean'];
};

export type ContentBaseArticleInteractions = {
  /** #logged-out #soft-logged-in */
  isBookmarked: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isCommented: Scalars['Boolean'];
};

export type ContentBaseArticleMetadata = {
  /** #logged-out #soft-logged-in */
  readCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated Moved to SocialInteractionTarget.commentsCount
   */
  commentsCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  clicksCount should be null for legacy articles, unless its a new article, in that case it wont be null
   */
  clicksCount?: Maybe<Scalars['Int']>;
};

export type ContentBaseArticleSocial = {
  /** #logged-out #soft-logged-in */
  isBookmarked: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isCommented: Scalars['Boolean'];
};

export type ContentBookmarkEdge = PaginationEdge & {
  __typename?: 'ContentBookmarkEdge';
  node: ContentBookmarkable;
  /** #virtual */
  cursor: Scalars['String'];
};

export type ContentBookmarkInput = {
  bookmarkableGlobalId: Scalars['GlobalID'];
};

export type ContentBookmarkable = ContentKlartextKlarticle | ContentArticle;

export type ContentBookmarkableMutationResult = {
  __typename?: 'ContentBookmarkableMutationResult';
  success?: Maybe<ContentArticleInterface>;
  /** @deprecated use success field instead. Will be removed after NDIST-515 */
  result?: Maybe<ContentArticleInterface>;
  error?: Maybe<ContentError>;
};

export type ContentBookmarksConnection = HasCursorPagination & {
  __typename?: 'ContentBookmarksConnection';
  edges: Array<Maybe<ContentBookmarkEdge>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type ContentBundleArticle = {
  __typename?: 'ContentBundleArticle';
  title: Scalars['String'];
  url: Scalars['URL'];
  isPurchased: Scalars['Boolean'];
  isFree: Scalars['Boolean'];
};

export type ContentBundlePurchase = ContentPurchaseInterface & HasDerivedGlobalId & {
  __typename?: 'ContentBundlePurchase';
  teaser: ContentPage;
  totalCount: Scalars['Int'];
  purchasedCount: Scalars['Int'];
  articles?: Maybe<Array<Maybe<ContentBundleArticle>>>;
  id: Scalars['ID'];
  priceCents: Scalars['Int'];
  /** Globally unique id for this instance based on typename and id */
  globalId: Scalars['GlobalID'];
};

export type ContentCancelSubscriptionResult = {
  __typename?: 'ContentCancelSubscriptionResult';
  /** @deprecated use success field instead. */
  result?: Maybe<ContentSubscriptionPurchase>;
  success?: Maybe<ContentSubscriptionPurchase>;
  error?: Maybe<ContentError>;
};

export type ContentCategory = {
  __typename?: 'ContentCategory';
  name: Scalars['String'];
};

export type ContentCategoryCollection = {
  __typename?: 'ContentCategoryCollection';
  collection: Array<ContentCategory>;
  total: Scalars['Int'];
};

/** Represents a channel for content which can be news items, jobs, ... etc, the naming "Channel" is still WIP */
export type ContentChannel = {
  __typename?: 'ContentChannel';
  title: Scalars['String'];
  id: Scalars['ID'];
  globalId: Scalars['GlobalID'];
  image: ContentChannelImage;
  followersCount: Scalars['Int'];
  sourcesCount: Scalars['Int'];
  viewerFollowState?: Maybe<ContentChannelFollowState>;
};

export type ContentChannelCollection = {
  __typename?: 'ContentChannelCollection';
  collection: Array<ContentChannel>;
};

/** Since following channels comes also with email subscription, this is presented by three states */
export enum ContentChannelFollowState {
  /** User is following the channel and subscribed to it's newsletter */
  FollowedWithEmail = 'FOLLOWED_WITH_EMAIL',
  /** User is following the channel but not subscribed to it's newsletter */
  FollowedWithoutEmail = 'FOLLOWED_WITHOUT_EMAIL',
  /** User is not following the channel and not subscribed to it's newsletter */
  Unfollowed = 'UNFOLLOWED'
}

export type ContentChannelImage = {
  __typename?: 'ContentChannelImage';
  size68x68: Scalars['URL'];
  size136x136: Scalars['URL'];
};

export type ContentComment = HasGlobalId & {
  __typename?: 'ContentComment';
  id: Scalars['ID'];
  message: Scalars['String'];
  authorId: Scalars['ID'];
  /** #rest(batched) #virtual */
  author?: Maybe<XingId>;
  /** #rest #virtual */
  commentable?: Maybe<ContentArticleInterface>;
  createdAt: Scalars['Date'];
  abilities?: Maybe<ContentCommentAbilities>;
  /** Globally unique id for this instance */
  globalId: Scalars['GlobalID'];
};

export type ContentCommentAbilities = {
  __typename?: 'ContentCommentAbilities';
  canHideComment?: Maybe<Scalars['Boolean']>;
};

export type ContentCommentCreateInput = {
  commentableGlobalId: Scalars['GlobalID'];
  message: Scalars['String'];
};

export type ContentCommentEdge = PaginationEdge & {
  __typename?: 'ContentCommentEdge';
  node: ContentComment;
  /** #virtual */
  cursor: Scalars['String'];
};

export type ContentCommentHideInput = {
  commentGlobalId: Scalars['GlobalID'];
};

export type ContentCommentMutationResult = {
  __typename?: 'ContentCommentMutationResult';
  success?: Maybe<ContentComment>;
  /** @deprecated use success field instead. WILL BE REMOVED ... */
  result?: Maybe<ContentComment>;
  error?: Maybe<ContentError>;
};

export type ContentCommentsConnection = HasCursorPagination & {
  __typename?: 'ContentCommentsConnection';
  /** #rest #virtual */
  commentable?: Maybe<ContentArticleInterface>;
  edges?: Maybe<Array<Maybe<ContentCommentEdge>>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type ContentCreateLinkShareImageInput = {
  linkShareGlobalId: Scalars['GlobalID'];
};

export type ContentCreateLinkShareImageResult = ContentLinkShareImageSettings | ContentError;

export type ContentCreateLinkShareInput = {
  contextGlobalId: Scalars['GlobalID'];
  link?: Maybe<Scalars['URL']>;
  comment?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['URL']>;
};

export type ContentDaypass365Purchase = ContentPurchaseInterface & ContentSubscriptionPurchaseInterface & HasDerivedGlobalId & {
  __typename?: 'ContentDaypass365Purchase';
  stub?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  priceCents: Scalars['Int'];
  teaser: ContentPage;
  expiresAt?: Maybe<Scalars['Date']>;
  /** Globally unique id for this instance based on typename and id */
  globalId: Scalars['GlobalID'];
};

export type ContentDaypassPurchase = ContentPurchaseInterface & ContentSubscriptionPurchaseInterface & HasDerivedGlobalId & {
  __typename?: 'ContentDaypassPurchase';
  stub?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  priceCents: Scalars['Int'];
  teaser: ContentPage;
  expiresAt?: Maybe<Scalars['Date']>;
  /** Globally unique id for this instance based on typename and id */
  globalId: Scalars['GlobalID'];
};

export type ContentDeleteArticleInput = {
  globalId?: Maybe<Scalars['GlobalID']>;
};

export type ContentDeletionResultInteface = {
  error?: Maybe<ContentError>;
};

export type ContentDisableArticleInput = {
  globalId?: Maybe<Scalars['GlobalID']>;
};

export type ContentEnableArticleInput = {
  globalId?: Maybe<Scalars['GlobalID']>;
};

export type ContentError = {
  __typename?: 'ContentError';
  message?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ContentFeatureArticleInput = {
  globalId?: Maybe<Scalars['GlobalID']>;
};

export type ContentFollower = ContentSubscriberInterface & {
  __typename?: 'ContentFollower';
  followedAt?: Maybe<Scalars['Date']>;
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type ContentFollowerEdge = PaginationEdge & {
  __typename?: 'ContentFollowerEdge';
  node: ContentFollower;
  /** #virtual */
  cursor: Scalars['String'];
};

/** Profile Module ContentInsider */
export type ContentInsiderModule = ModuleInterface & ContentPageInterface & ContentInsiderPageInterface & {
  __typename?: 'ContentInsiderModule';
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  order: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  metadata: ContentPageMetadata;
  /** #rest #virtual */
  topArticles?: Maybe<ContentArticlesResponse>;
  active?: Maybe<Scalars['Boolean']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page Id
   */
  id: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Brief Page description
   */
  tagline?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page description
   */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  interactions?: Maybe<ContentPageInteractions>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Does the current user follow the page
   * @deprecated was moved to interactions.
   */
  isFollowed: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page articles
   * @deprecated was moved to metadata.
   */
  articleCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page followers
   * @deprecated was moved to metadata.
   */
  followersCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Page specific data when displayed in Armstrong
   */
  inArmstrong?: Maybe<ContentPageInArmstrong>;
  /** #logged-out #soft-logged-in */
  entityPageId?: Maybe<Scalars['ID']>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Allows access to the hosting Entity Page of a Content Page
   */
  entityPage?: Maybe<EntityPage>;
  /**
   * #logged-out #soft-logged-in
   *
   *  User id of insider
   */
  userId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated This should not be needed and will be removed as soon as it isn't anymore. Will be removed after NDIST-515
   */
  subscriberId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated renamed to abilities.
   */
  features: ContentPageAbilities;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /** #rest #virtual */
  featuredArticles?: Maybe<ContentArticlesResponse>;
  /**
   * #rest #virtual
   *
   *  Either featured article or latest article
   * @deprecated Use topArticles(limit: 1) instead.
   */
  topArticle?: Maybe<ContentArticleInterface>;
  /** #paginated #rest #virtual */
  articles?: Maybe<ContentArticlesConnection>;
  /** #paginated #rest #virtual */
  followersWithinContacts?: Maybe<ContentInsiderPageFollowersWithinContactsConnection>;
  /** #logged-out #soft-logged-in */
  topics: ContentTopicCollection;
};


/** Profile Module ContentInsider */
export type ContentInsiderModuleTopArticlesArgs = {
  limit?: Maybe<Scalars['Int']>;
};


/** Profile Module ContentInsider */
export type ContentInsiderModuleArticlesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Profile Module ContentInsider */
export type ContentInsiderModuleFollowersWithinContactsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type ContentInsiderPage = ContentPageInterface & ContentInsiderPageInterface & HasGlobalId & ArticlesContextInterface & {
  __typename?: 'ContentInsiderPage';
  /**
   * #logged-out #soft-logged-in
   *
   *  Abilities of current user for page
   */
  abilities: ContentPageAbilities;
  /** #logged-out #soft-logged-in */
  metadata: ContentPageMetadata;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page Id
   */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Brief Page description
   */
  tagline?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page description
   */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  interactions?: Maybe<ContentPageInteractions>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Does the current user follow the page
   * @deprecated was moved to interactions.
   */
  isFollowed: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page articles
   * @deprecated was moved to metadata.
   */
  articleCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page followers
   * @deprecated was moved to metadata.
   */
  followersCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Page specific data when displayed in Armstrong
   */
  inArmstrong?: Maybe<ContentPageInArmstrong>;
  /** #logged-out #soft-logged-in */
  entityPageId?: Maybe<Scalars['ID']>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Allows access to the hosting Entity Page of a Content Page
   */
  entityPage?: Maybe<EntityPage>;
  /**
   * #logged-out #soft-logged-in
   *
   *  User id of insider
   */
  userId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated This should not be needed and will be removed as soon as it isn't anymore. Will be removed after NDIST-515
   */
  subscriberId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated renamed to abilities.
   */
  features: ContentPageAbilities;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /** #rest #virtual */
  featuredArticles?: Maybe<ContentArticlesResponse>;
  /**
   * #rest #virtual
   *
   *  Either featured article or latest article
   * @deprecated Use topArticles(limit: 1) instead.
   */
  topArticle?: Maybe<ContentArticleInterface>;
  /**
   * #rest #virtual
   *
   *  Featured article or latest articles
   */
  topArticles?: Maybe<ContentArticlesResponse>;
  /** #paginated #rest #virtual */
  articles?: Maybe<ContentArticlesConnection>;
  /** #paginated #rest #virtual */
  followersWithinContacts?: Maybe<ContentInsiderPageFollowersWithinContactsConnection>;
  /** #logged-out #soft-logged-in */
  topics: ContentTopicCollection;
};


export type ContentInsiderPageTopArticlesArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type ContentInsiderPageArticlesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


export type ContentInsiderPageFollowersWithinContactsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type ContentInsiderPageFollowersConnection = HasCursorPagination & ContentInsiderPageFollowersInterface & {
  __typename?: 'ContentInsiderPageFollowersConnection';
  edges: Array<Maybe<ContentFollowerEdge>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
  userId: Scalars['ID'];
  pageGlobalId: Scalars['URN'];
  newFollowersCount: Scalars['Int'];
  /** When did the owner last check her followers */
  newFollowersLastCheckedAt?: Maybe<Scalars['Date']>;
};

export type ContentInsiderPageFollowersInterface = {
  userId: Scalars['ID'];
  pageGlobalId: Scalars['URN'];
  newFollowersCount: Scalars['Int'];
  /** When did the owner last check her followers */
  newFollowersLastCheckedAt?: Maybe<Scalars['Date']>;
};

export type ContentInsiderPageFollowersWithinContactsConnection = HasCursorPagination & {
  __typename?: 'ContentInsiderPageFollowersWithinContactsConnection';
  userId?: Maybe<Scalars['ID']>;
  pageId: Scalars['ID'];
  edges: Array<Maybe<ContentFollowerEdge>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type ContentInsiderPageInterface = {
  /**
   * #logged-out #soft-logged-in
   *
   *  User id of insider
   */
  userId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated This should not be needed and will be removed as soon as it isn't anymore. Will be removed after NDIST-515
   */
  subscriberId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated renamed to abilities.
   */
  features: ContentPageAbilities;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /** #rest #virtual */
  featuredArticles?: Maybe<ContentArticlesResponse>;
  /**
   * #rest #virtual
   *
   *  Either featured article or latest article
   * @deprecated Use topArticles(limit: 1) instead.
   */
  topArticle?: Maybe<ContentArticleInterface>;
  /**
   * #rest #virtual
   *
   *  Featured article or latest articles
   */
  topArticles?: Maybe<ContentArticlesResponse>;
  /** #paginated #rest #virtual */
  articles?: Maybe<ContentArticlesConnection>;
  /** #paginated #rest #virtual */
  followersWithinContacts?: Maybe<ContentInsiderPageFollowersWithinContactsConnection>;
  /** #logged-out #soft-logged-in */
  topics: ContentTopicCollection;
};


export type ContentInsiderPageInterfaceTopArticlesArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type ContentInsiderPageInterfaceArticlesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


export type ContentInsiderPageInterfaceFollowersWithinContactsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type ContentInsiderPageLastFollowersSeen = ContentInsiderPageFollowersInterface & {
  __typename?: 'ContentInsiderPageLastFollowersSeen';
  stub?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  pageGlobalId: Scalars['URN'];
  newFollowersCount: Scalars['Int'];
  /** When did the owner last check her followers */
  newFollowersLastCheckedAt?: Maybe<Scalars['Date']>;
};

export type ContentInsiderPageLastFollowersSeenInput = {
  userId: Scalars['SlugOrID'];
};

export type ContentInsiderPageLastFollowersSeenResult = {
  __typename?: 'ContentInsiderPageLastFollowersSeenResult';
  success?: Maybe<ContentInsiderPageLastFollowersSeen>;
  /** @deprecated use success field instead. Still used, to be removed after NDIST-515 */
  result?: Maybe<ContentInsiderPageLastFollowersSeen>;
  error?: Maybe<ContentError>;
};

export type ContentKlartextAgreeError = {
  __typename?: 'ContentKlartextAgreeError';
  message?: Maybe<Scalars['String']>;
};

export type ContentKlartextAgreeResult = {
  __typename?: 'ContentKlartextAgreeResult';
  success?: Maybe<ContentKlartextKlarticle>;
  error?: Maybe<ContentKlartextAgreeError>;
};

export type ContentKlartextFeatures = ContentBaseArticleFeatures & {
  __typename?: 'ContentKlartextFeatures';
  /** #logged-out #soft-logged-in */
  isAgreeable: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  areCommentsDisplayedExternally: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isCommentable: Scalars['Boolean'];
};

export type ContentKlartextInteractions = ContentBaseArticleInteractions & {
  __typename?: 'ContentKlartextInteractions';
  /** #logged-out #soft-logged-in */
  isAgreed?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  isBookmarked: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isCommented: Scalars['Boolean'];
};

export type ContentKlartextKlarticle = ContentArticleInterface & HasGlobalId & {
  __typename?: 'ContentKlartextKlarticle';
  /** #logged-out #soft-logged-in */
  metadata: ContentKlartextMetadata;
  /**
   * #logged-out #soft-logged-in
   * @deprecated `social` was renamed to `interactions`. Will be removed after NDIST-517, NDIST-518
   */
  social: ContentKlartextSocial;
  /** #logged-out #soft-logged-in */
  interactions: ContentKlartextInteractions;
  /** #logged-out #soft-logged-in */
  resourceFeatures: ContentKlartextFeatures;
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Unique identifier for a ContentArticle (i.e. URN)
   */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  pageId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  pageGlobalId?: Maybe<Scalars['GlobalID']>;
  /**
   * #rest(batched) #virtual
   *
   *  This only resolves pages for contentInsiderArticles for now and returns null for othe page types
   */
  page?: Maybe<ContentPageInterface>;
  /**
   * #logged-out #soft-logged-in
   *
   *  URN of the object which this article refers to (if any). This is NOT the URN of the ContentArticle!
   */
  objectUrn?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  introductoryText?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  publishedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  updatedAt: Scalars['Date'];
  /** #logged-out #soft-logged-in */
  source?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  shareUrl: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  hasVideo: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isSponsored: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isExternal: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isFeatured: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated moved to `isPremium`. Will be removed after NDIST-515, NDIST-517 and NDIST-518
   */
  isNewsPlus: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isPremium: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated moved to `resourceFeatures`. Will be removed after NDIST-518
   */
  isCommentable: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  image: ContentArticleImage;
  /** #logged-out #soft-logged-in */
  status: ContentArticleStatus;
  /** #logged-out #soft-logged-in */
  resourceType: ContentResourceType;
  /** #logged-out #soft-logged-in */
  abilities: ContentArticleAbilities;
  /** #logged-out #soft-logged-in */
  reportingData: ContentArticleReportingData;
};

export type ContentKlartextMetadata = ContentBaseArticleMetadata & {
  __typename?: 'ContentKlartextMetadata';
  /** #logged-out #soft-logged-in */
  agreesCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  readCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated Moved to SocialInteractionTarget.commentsCount
   */
  commentsCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  clicksCount should be null for legacy articles, unless its a new article, in that case it wont be null
   */
  clicksCount?: Maybe<Scalars['Int']>;
};

export type ContentKlartextSocial = ContentBaseArticleSocial & {
  __typename?: 'ContentKlartextSocial';
  /** #logged-out #soft-logged-in */
  isAgreed?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  isBookmarked: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isCommented: Scalars['Boolean'];
};

export type ContentKlartextUnagreeResult = {
  __typename?: 'ContentKlartextUnagreeResult';
  success?: Maybe<ContentKlartextKlarticle>;
  error?: Maybe<ContentKlartextAgreeError>;
};

export type ContentLinkData = {
  __typename?: 'ContentLinkData';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['URL']>;
  source: Scalars['String'];
};

export type ContentLinkShare = HasGlobalId & {
  __typename?: 'ContentLinkShare';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Unique identifier for the Link Share (i.e. URN)
   */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  link?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  comment?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  headline?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  excerpt?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  imageUrl?: Maybe<Scalars['URL']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  The date of publication. null indicates it's a draft.
   */
  publishedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  status: ContentArticleStatus;
  /** #logged-out #soft-logged-in */
  slug: Scalars['SlugOrID'];
  /** #logged-out #soft-logged-in */
  visitUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  source?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  updatedAt: Scalars['Date'];
};

export type ContentLinkShareImageSettings = {
  __typename?: 'ContentLinkShareImageSettings';
  uploadUrl: Scalars['String'];
  downloadUrl: Scalars['String'];
};

export type ContentLinkShareResult = ContentLinkShare | ContentError;

export type ContentManagedInsiderPage = ContentPageInterface & ContentInsiderPageInterface & HasGlobalId & {
  __typename?: 'ContentManagedInsiderPage';
  /**
   * #logged-out #soft-logged-in
   * @deprecated This should not be needed and will be removed as soon as it isn't anymore. Will be removed after NDIST-515
   */
  subscriberId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Page manager abilities of current user for page
   */
  abilities: ContentManagedPageAbilities;
  /** #logged-out #soft-logged-in */
  metadata: ContentManagedPageMetadata;
  /** #logged-out #soft-logged-in */
  areTermsAndConditionsAccepted: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Page Id
   */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Brief Page description
   */
  tagline?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page description
   */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  interactions?: Maybe<ContentPageInteractions>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Does the current user follow the page
   * @deprecated was moved to interactions.
   */
  isFollowed: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page articles
   * @deprecated was moved to metadata.
   */
  articleCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page followers
   * @deprecated was moved to metadata.
   */
  followersCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Page specific data when displayed in Armstrong
   */
  inArmstrong?: Maybe<ContentPageInArmstrong>;
  /** #logged-out #soft-logged-in */
  entityPageId?: Maybe<Scalars['ID']>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Allows access to the hosting Entity Page of a Content Page
   */
  entityPage?: Maybe<EntityPage>;
  /**
   * #logged-out #soft-logged-in
   *
   *  User id of insider
   */
  userId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated renamed to abilities.
   */
  features: ContentPageAbilities;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /** #rest #virtual */
  featuredArticles?: Maybe<ContentArticlesResponse>;
  /**
   * #rest #virtual
   *
   *  Either featured article or latest article
   * @deprecated Use topArticles(limit: 1) instead.
   */
  topArticle?: Maybe<ContentArticleInterface>;
  /**
   * #rest #virtual
   *
   *  Featured article or latest articles
   */
  topArticles?: Maybe<ContentArticlesResponse>;
  /** #paginated #rest #virtual */
  articles?: Maybe<ContentArticlesConnection>;
  /** #paginated #rest #virtual */
  followersWithinContacts?: Maybe<ContentInsiderPageFollowersWithinContactsConnection>;
  /** #logged-out #soft-logged-in */
  topics: ContentTopicCollection;
};


export type ContentManagedInsiderPageTopArticlesArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type ContentManagedInsiderPageArticlesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


export type ContentManagedInsiderPageFollowersWithinContactsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type ContentManagedPage = ContentPageInterface & HasGlobalId & {
  __typename?: 'ContentManagedPage';
  metadata?: Maybe<ContentManagedPageMetadata>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page Id
   */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Brief Page description
   */
  tagline?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page description
   */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  interactions?: Maybe<ContentPageInteractions>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Does the current user follow the page
   * @deprecated was moved to interactions.
   */
  isFollowed: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page articles
   * @deprecated was moved to metadata.
   */
  articleCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page followers
   * @deprecated was moved to metadata.
   */
  followersCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Page specific data when displayed in Armstrong
   */
  inArmstrong?: Maybe<ContentPageInArmstrong>;
  /** #logged-out #soft-logged-in */
  entityPageId?: Maybe<Scalars['ID']>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Allows access to the hosting Entity Page of a Content Page
   */
  entityPage?: Maybe<EntityPage>;
};

export type ContentManagedPageAbilities = ContentPageAbilitiesInterface & {
  __typename?: 'ContentManagedPageAbilities';
  /** #logged-out #soft-logged-in */
  canCreateVideoArticle: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canActivatePage: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  true if a user can edit this page's articles. Required by the articles service
   */
  canEdit: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canEditPage: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canFollowPage: Scalars['Boolean'];
};

export type ContentManagedPageMetadata = ContentPageMetadataInterface & {
  __typename?: 'ContentManagedPageMetadata';
  /** #logged-out #soft-logged-in */
  commentsCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  unreviewedCommentsCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  articleClicksCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  draftArticlesCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  scheduledArticlesCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  disabledArticlesCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated renamed to publishedArticlesCount.
   */
  articleCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  publishedArticlesCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  followersCount: Scalars['Int'];
  /** #paginated #rest #virtual */
  followersWithinContacts?: Maybe<ContentPageFollowersWithinContactsConnection>;
  /** #rest(batched) #virtual */
  firstFourFollowersWithinContactsBatched?: Maybe<ContentPageFollowersWithinContactsBatched>;
};


export type ContentManagedPageMetadataFollowersWithinContactsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type ContentPage = ContentPageInterface & HasGlobalId & ArticlesContextInterface & {
  __typename?: 'ContentPage';
  /** #logged-out #soft-logged-in */
  headerImage?: Maybe<ContentPageHeaderImage>;
  /** #logged-out #soft-logged-in */
  logoImage?: Maybe<ContentPageLogoImage>;
  /** @deprecated renamed to abilities. */
  features?: Maybe<ContentPageAbilities>;
  /** #logged-out #soft-logged-in */
  abilities: ContentPageAbilities;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page Id
   */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Brief Page description
   */
  tagline?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page description
   */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  interactions?: Maybe<ContentPageInteractions>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Does the current user follow the page
   * @deprecated was moved to interactions.
   */
  isFollowed: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page articles
   * @deprecated was moved to metadata.
   */
  articleCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page followers
   * @deprecated was moved to metadata.
   */
  followersCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  metadata?: Maybe<ContentPageMetadataInterface>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page specific data when displayed in Armstrong
   */
  inArmstrong?: Maybe<ContentPageInArmstrong>;
  /** #logged-out #soft-logged-in */
  entityPageId?: Maybe<Scalars['ID']>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Allows access to the hosting Entity Page of a Content Page
   */
  entityPage?: Maybe<EntityPage>;
};

export type ContentPageAbilities = ContentPageAbilitiesInterface & ArticlesAbilitiesInterface & {
  __typename?: 'ContentPageAbilities';
  stub?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  true if a user can edit this page's articles. Required by the articles service
   */
  canEdit: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canEditPage: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canFollowPage: Scalars['Boolean'];
};

export type ContentPageAbilitiesInterface = {
  /**
   * #logged-out #soft-logged-in
   *
   *  true if a user can edit this page's articles. Required by the articles service
   */
  canEdit: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canEditPage: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canFollowPage: Scalars['Boolean'];
};

export type ContentPageArticle = {
  __typename?: 'ContentPageArticle';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  object: ContentPageArticleObject;
  /** #logged-out #soft-logged-in */
  metadata: ContentArticleMetadata;
  /** #logged-out #soft-logged-in */
  isFeatured: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  status: ContentArticleStatus;
};

export type ContentPageArticleEdge = PaginationEdge & {
  __typename?: 'ContentPageArticleEdge';
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
  /** #logged-out #soft-logged-in */
  node: ContentPageArticle;
};

/** ContentArticle objects will be video articles and link shares. Video articles will be migrated to ArticlesArticle. Future of link shares is unknown. */
export type ContentPageArticleObject = ContentArticle | ArticlesArticle;

export type ContentPageArticlesConnection = HasCursorPagination & {
  __typename?: 'ContentPageArticlesConnection';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
  /** #logged-out #soft-logged-in */
  edges: Array<Maybe<ContentPageArticleEdge>>;
};

export type ContentPageEdge = PaginationEdge & {
  __typename?: 'ContentPageEdge';
  /** #logged-out #soft-logged-in */
  node: ContentPageInterface;
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
};

export type ContentPageFollowInput = {
  pageId: Scalars['ID'];
  hasSubscription?: Maybe<Scalars['Boolean']>;
};

export type ContentPageFollowersWithinContactsBatched = {
  __typename?: 'ContentPageFollowersWithinContactsBatched';
  pageUrn: Scalars['GlobalID'];
  total: Scalars['Int'];
  followers: Array<ContentFollower>;
};

export type ContentPageFollowersWithinContactsConnection = HasCursorPagination & {
  __typename?: 'ContentPageFollowersWithinContactsConnection';
  edges: Array<Maybe<ContentFollowerEdge>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type ContentPageHeaderImage = {
  __typename?: 'ContentPageHeaderImage';
  /** #logged-out #soft-logged-in */
  original?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  small?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  iphone?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  mobile?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  bannerLarge1968?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  bannerLarge984?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  bannerSmall958?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  bannerSmall479?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  banner1968?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  banner984?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square728?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square364?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square230?: Maybe<Scalars['URL']>;
};

export type ContentPageInArmstrong = {
  __typename?: 'ContentPageInArmstrong';
  /**
   * #logged-out #soft-logged-in
   *
   *  Header of the page when displayed in Armstrong, note it's not available for all types of pages
   */
  header?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Sub-header of the page when displayed in Armstrong, note it's not available for all types of pages
   */
  subHeader?: Maybe<Scalars['String']>;
};

export type ContentPageInteractions = {
  __typename?: 'ContentPageInteractions';
  isFollowed: Scalars['Boolean'];
};

export type ContentPageInterface = {
  /**
   * #logged-out #soft-logged-in
   *
   *  Page Id
   */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Brief Page description
   */
  tagline?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page description
   */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  interactions?: Maybe<ContentPageInteractions>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Does the current user follow the page
   * @deprecated was moved to interactions.
   */
  isFollowed: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page articles
   * @deprecated was moved to metadata.
   */
  articleCount: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Count of page followers
   * @deprecated was moved to metadata.
   */
  followersCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  metadata?: Maybe<ContentPageMetadataInterface>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Page specific data when displayed in Armstrong
   */
  inArmstrong?: Maybe<ContentPageInArmstrong>;
  /** #logged-out #soft-logged-in */
  entityPageId?: Maybe<Scalars['ID']>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Allows access to the hosting Entity Page of a Content Page
   */
  entityPage?: Maybe<EntityPage>;
};

export type ContentPageList = {
  __typename?: 'ContentPageList';
  collection: Array<Maybe<ContentPageInterface>>;
  total: Scalars['Int'];
};

export type ContentPageLogoImage = {
  __typename?: 'ContentPageLogoImage';
  /** #logged-out #soft-logged-in */
  original?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  web?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square32?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square48?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square64?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square96?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square128?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square144?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square192?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square256?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square384?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square1024?: Maybe<Scalars['URL']>;
};

export type ContentPageMetadata = ContentPageMetadataInterface & {
  __typename?: 'ContentPageMetadata';
  stub?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated renamed to publishedArticlesCount.
   */
  articleCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  publishedArticlesCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  followersCount: Scalars['Int'];
  /** #paginated #rest #virtual */
  followersWithinContacts?: Maybe<ContentPageFollowersWithinContactsConnection>;
  /** #rest(batched) #virtual */
  firstFourFollowersWithinContactsBatched?: Maybe<ContentPageFollowersWithinContactsBatched>;
};


export type ContentPageMetadataFollowersWithinContactsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type ContentPageMetadataInterface = {
  /**
   * #logged-out #soft-logged-in
   * @deprecated renamed to publishedArticlesCount.
   */
  articleCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  publishedArticlesCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  followersCount: Scalars['Int'];
  /** #paginated #rest #virtual */
  followersWithinContacts?: Maybe<ContentPageFollowersWithinContactsConnection>;
  /** #rest(batched) #virtual */
  firstFourFollowersWithinContactsBatched?: Maybe<ContentPageFollowersWithinContactsBatched>;
};


export type ContentPageMetadataInterfaceFollowersWithinContactsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type ContentPageMutationResult = {
  __typename?: 'ContentPageMutationResult';
  success?: Maybe<ContentPageInterface>;
  /** @deprecated use success field instead. */
  result?: Maybe<ContentPageInterface>;
  error?: Maybe<ContentError>;
};

export type ContentPageRecommendation = Recommendation & {
  __typename?: 'ContentPageRecommendation';
  /** #rest(batched) #virtual */
  page?: Maybe<ContentPageInterface>;
  trackingToken: Scalars['String'];
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
};

export type ContentPageRecommendationEdge = PaginationEdge & {
  __typename?: 'ContentPageRecommendationEdge';
  node: ContentPageRecommendation;
  /** #virtual */
  cursor: Scalars['String'];
};

export type ContentPageRecommenderConnection = RecommenderResponse & HasCursorPagination & {
  __typename?: 'ContentPageRecommenderConnection';
  edges: Array<Maybe<ContentPageRecommendationEdge>>;
  requestTrackingToken: Scalars['String'];
  service: Scalars['String'];
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

/** Specifies the field to sort by */
export enum ContentPageSortField {
  CreatedAt = 'created_at',
  PageFollowsCount = 'page_follows_count',
  Title = 'title',
  DateFollowed = 'date_followed'
}

export enum ContentPageType {
  Insider = 'insider',
  Industry = 'industry',
  PressReview = 'press_review',
  Topic = 'topic',
  Publisher = 'publisher'
}

export type ContentPageUnfollowInput = {
  pageId: Scalars['ID'];
};

export type ContentPageUsers = {
  __typename?: 'ContentPageUsers';
  id: Scalars['ID'];
  globalId: Scalars['GlobalID'];
  /** #rest(batched) #virtual */
  owner?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  editors?: Maybe<Array<Maybe<XingId>>>;
};

export type ContentPagesConnection = HasCursorPagination & {
  __typename?: 'ContentPagesConnection';
  /** #logged-out #soft-logged-in */
  edges: Array<Maybe<ContentPageEdge>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
};

export type ContentPagesRecommended = {
  __typename?: 'ContentPagesRecommended';
  /** #logged-out #soft-logged-in */
  key: ReducedContentPageType;
  /** #logged-out #soft-logged-in */
  totalPages: Scalars['Int'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  pages: Array<ContentPageInterface>;
};

export type ContentPagesRecommendedCollection = {
  __typename?: 'ContentPagesRecommendedCollection';
  /** #logged-out #soft-logged-in */
  collection: Array<ContentPagesRecommended>;
};

export type ContentPublishLinkShareInput = {
  linkShareGlobalId: Scalars['GlobalID'];
};

export type ContentPurchaseInterface = {
  id: Scalars['ID'];
  priceCents: Scalars['Int'];
};

export type ContentPurchaseList = {
  __typename?: 'ContentPurchaseList';
  collection?: Maybe<Array<Maybe<ContentPurchaseInterface>>>;
};

export enum ContentPurchaseType {
  All = 'ALL',
  Article = 'ARTICLE',
  Bundle = 'BUNDLE',
  Subscription = 'SUBSCRIPTION',
  Daypass = 'DAYPASS',
  Daypass365 = 'DAYPASS365'
}

export enum ContentResourceType {
  ContentFulltextArticle = 'CONTENT_FULLTEXT_ARTICLE',
  ContentVideoArticle = 'CONTENT_VIDEO_ARTICLE',
  ContentLinkShareArticle = 'CONTENT_LINK_SHARE_ARTICLE',
  ContentKlarticle = 'CONTENT_KLARTICLE',
  ContentPageArticle = 'CONTENT_PAGE_ARTICLE',
  ArticlesArticle = 'ARTICLES_ARTICLE'
}

/** Representation of a generic piece of content */
export type ContentServiceContent = HasGlobalId & {
  __typename?: 'ContentServiceContent';
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  header?: Maybe<ArticleHeader>;
  /** #logged-out #soft-logged-in */
  blocks: Array<ArticleBlock>;
  /** #logged-out #soft-logged-in */
  content?: Maybe<Scalars['JSON']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Most recent version of the content; used for optimistic locking
   */
  lockVersion: Scalars['Int'];
  /**
   * #logged-out #soft-logged-in
   *
   *  URN to be used when integrating social interactions with this content
   */
  socialInteractionTargetUrn?: Maybe<Scalars['GlobalID']>;
};

export type ContentServiceCreateContentInput = {
  contextGlobalId: Scalars['GlobalID'];
  header?: Maybe<ArticlesCreateArticleHeaderInput>;
  blocks?: Maybe<Array<ArticlesCreateArticleBlocksInput>>;
  supportedBlockTypes?: Maybe<Array<ArticleSupportedBlockTypes>>;
  content?: Maybe<Scalars['JSON']>;
};

export type ContentServiceError = {
  __typename?: 'ContentServiceError';
  /** explains what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  details?: Maybe<Array<Scalars['String']>>;
};

export type ContentServiceSaveContentResult = {
  __typename?: 'ContentServiceSaveContentResult';
  success?: Maybe<ContentServiceContent>;
  error?: Maybe<ContentServiceError>;
};

export type ContentServiceUpdateContentInput = {
  lockVersion: Scalars['Int'];
  contentGlobalId: Scalars['GlobalID'];
  header?: Maybe<ArticlesCreateArticleHeaderInput>;
  blocks?: Maybe<Array<ArticlesCreateArticleBlocksInput>>;
  supportedBlockTypes?: Maybe<Array<ArticleSupportedBlockTypes>>;
  content?: Maybe<Scalars['JSON']>;
};

/** Specifies the sort direction (asc/desc) */
export enum ContentSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type ContentStarInput = {
  starableGlobalId: Scalars['GlobalID'];
};

export type ContentStarableMutationResult = {
  __typename?: 'ContentStarableMutationResult';
  success?: Maybe<ContentArticle>;
  /** @deprecated use success field instead. Will be removed after NDIST-515 */
  result?: Maybe<ContentArticle>;
  error?: Maybe<ContentError>;
};

export type ContentStarableStarrersConnection = HasCursorPagination & {
  __typename?: 'ContentStarableStarrersConnection';
  starableGlobalId: Scalars['GlobalID'];
  /** XingIds of starrers in my contacts */
  edges: Array<ContentStarrerEdge>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type ContentStarrer = ContentSubscriberInterface & {
  __typename?: 'ContentStarrer';
  stub?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type ContentStarrerEdge = PaginationEdge & {
  __typename?: 'ContentStarrerEdge';
  node: ContentStarrer;
  /** #virtual */
  cursor: Scalars['String'];
};

export type ContentSubscriberInterface = {
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type ContentSubscriptionPurchase = ContentPurchaseInterface & ContentSubscriptionPurchaseInterface & HasDerivedGlobalId & {
  __typename?: 'ContentSubscriptionPurchase';
  renewalDate?: Maybe<Scalars['Date']>;
  canceledAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  priceCents: Scalars['Int'];
  teaser: ContentPage;
  expiresAt?: Maybe<Scalars['Date']>;
  /** Globally unique id for this instance based on typename and id */
  globalId: Scalars['GlobalID'];
};

export type ContentSubscriptionPurchaseInterface = {
  teaser: ContentPage;
  expiresAt?: Maybe<Scalars['Date']>;
};

export type ContentTopic = {
  __typename?: 'ContentTopic';
  /** #logged-out #soft-logged-in */
  name: Scalars['String'];
};

export type ContentTopicCollection = {
  __typename?: 'ContentTopicCollection';
  /** #logged-out #soft-logged-in */
  collection: Array<ContentTopic>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export type ContentTopicInput = {
  name: Scalars['String'];
};

export type ContentUnbookmarkInput = {
  bookmarkableGlobalId: Scalars['GlobalID'];
};

export type ContentUnfeatureArticleInput = {
  globalId?: Maybe<Scalars['GlobalID']>;
};

export type ContentUnstarInput = {
  starableGlobalId: Scalars['GlobalID'];
};

export type ContentUpdateEmailSubscriptionInput = {
  pageId: Scalars['ID'];
  hasEmail?: Maybe<Scalars['Boolean']>;
};

export type ContentUpdateEmailSubscriptionPayload = {
  error?: Maybe<ContentError>;
  response?: Maybe<EmailSubscription>;
};

export type ContentUpdateEmailSubscriptionPayloadError = ContentUpdateEmailSubscriptionPayload & {
  __typename?: 'ContentUpdateEmailSubscriptionPayloadError';
  error?: Maybe<ContentError>;
  response?: Maybe<EmailSubscription>;
};

export type ContentUpdateEmailSubscriptionPayloadSuccess = ContentUpdateEmailSubscriptionPayload & {
  __typename?: 'ContentUpdateEmailSubscriptionPayloadSuccess';
  error?: Maybe<ContentError>;
  response?: Maybe<EmailSubscription>;
};

export type ContentUpdateLinkShareInput = {
  linkShareGlobalId: Scalars['GlobalID'];
  link?: Maybe<Scalars['URL']>;
  comment?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['URL']>;
  publishedAt?: Maybe<Scalars['Date']>;
};

export type ContentUpdatePageInput = {
  globalId: Scalars['GlobalID'];
  description?: Maybe<Scalars['String']>;
  acceptTermsAndConditions?: Maybe<Scalars['Boolean']>;
  topics?: Maybe<Array<Maybe<ContentTopicInput>>>;
};

export type ConversationStarter = {
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type ConversationStarterEdge = PaginationEdge & {
  __typename?: 'ConversationStarterEdge';
  cursor: Scalars['String'];
  node: ConversationStarter;
};

export type ConversationStartersConnection = HasCursorPagination & {
  __typename?: 'ConversationStartersConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<ConversationStarterEdge>>;
};

export enum ConversionType {
  EmailType = 'EMAIL_TYPE',
  UrlTypeWithDescriptionEmail = 'URL_TYPE_WITH_DESCRIPTION_EMAIL',
  ApplicationManagementAtsPaid = 'APPLICATION_MANAGEMENT_ATS_PAID',
  ApplicationManagementAtsUnpaid = 'APPLICATION_MANAGEMENT_ATS_UNPAID',
  NotConverted = 'NOT_CONVERTED'
}

export type ConvertedReplySettingsJob = {
  __typename?: 'ConvertedReplySettingsJob';
  /** #logged-out #soft-logged-in */
  id: Scalars['Long'];
  /** #logged-out #soft-logged-in */
  replyEmail?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  converted: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  conversionType: ConversionType;
};

/** Settings stored in user properties */
export type CoreSettings = {
  __typename?: 'CoreSettings';
  /** User data should be deleted and not inherited after death */
  deleteUserDataAfterDecease?: Maybe<ToggleSetting>;
  /** XING recommendations (e.g. interesting groups, jobs and Industry News) */
  marketingNlXingRecos?: Maybe<ToggleSetting>;
  /** Events you may be interested in */
  marketingNlEvents?: Maybe<ToggleSetting>;
  /** Freelance offers you may be interested in */
  marketingNlFreelancerOffers?: Maybe<ToggleSetting>;
  /** Local events you may be interested in */
  marketingNlLocalEvents?: Maybe<ToggleSetting>;
  /** Updates and handy hints about XING features */
  marketingNlXingFeatures?: Maybe<ToggleSetting>;
  /** We value your opinion: XING surveys */
  marketingNlSurveys?: Maybe<ToggleSetting>;
  /** Information about XING partner offers */
  marketingNlXingPartners?: Maybe<ToggleSetting>;
  /** Information about XING special offers and prize draws */
  marketingNlXingPromotions?: Maybe<ToggleSetting>;
  /** Premium membership and ProBusiness add-on details and offers */
  marketingNlPremiumOffers?: Maybe<ToggleSetting>;
  /** ProJobs add-on details and offers */
  marketingNlProjobsOffers?: Maybe<ToggleSetting>;
  /** Details and offers about specific XING memberships and add-ons (e.g. ProCoach or Executive) */
  marketingNlProcoachOffers?: Maybe<ToggleSetting>;
  /** For employers and recruiters: Invitation to XING recruiting events */
  marketingNlRecruitingEvents?: Maybe<ToggleSetting>;
  /** For organisers: Event tips and offers on XING */
  marketingNlEventsOffers?: Maybe<ToggleSetting>;
  /** For XING Premium and ProBusiness: Information about new features and special offers */
  marketingNlPremiumInfos?: Maybe<ToggleSetting>;
  /** For ProCoach members: Details and offers */
  marketingNlProjobsInfos?: Maybe<ToggleSetting>;
  /** Details and offers for ProCoach and Executives members */
  marketingNlProcoachInfos?: Maybe<ToggleSetting>;
  /** For group moderators: Groups information and tips on XING */
  marketingNlModerator?: Maybe<ToggleSetting>;
  /** For employers and recruiters: Tips and information */
  marketingNlRecruiter?: Maybe<ToggleSetting>;
  /** For new members: Getting started on XING (in the first few weeks after joining) */
  marketingNlNewMembers?: Maybe<ToggleSetting>;
  /** Job search and career details */
  marketingNlJobCareer?: Maybe<ToggleSetting>;
  /** Information about finding employers and the new world of work */
  marketingNlNewWork?: Maybe<ToggleSetting>;
  /** For advertisers: XING marketing and advertising updates */
  marketingNlSalesAdvertising?: Maybe<ToggleSetting>;
  /** I'd like to receive useful information about creating ads on XING. */
  marketingNlXasDraftReminder?: Maybe<ToggleSetting>;
  /** I'm interested in receiving information and offers by post. */
  printMailing?: Maybe<ToggleSetting>;
  /** When someone sends me a XING message */
  notifyOnPrivateMessage?: Maybe<ToggleSetting>;
  /** When I have not replied to a message */
  notifyOnUnansweredMessage?: Maybe<ToggleSetting>;
  /** When someone comments on something I posted, commented on or liked (updates and topics) */
  notifyOnActivityComment?: Maybe<ToggleSetting>;
  /** When someone likes something I posted */
  notifyOnActivityLike?: Maybe<ToggleSetting>;
  /** When someone shares something I posted */
  notifyOnSocialShare?: Maybe<ToggleSetting>;
  /** When someone mentions me */
  notifyOnSocialMention?: Maybe<ToggleSetting>;
  /** When I receive new contact requests */
  notifyOnContactRequest?: Maybe<ToggleSetting>;
  /** If I have any pending contact requests */
  notifyUnconfirmedContactReminder?: Maybe<ToggleSetting>;
  /** When someone I've invited joins XING */
  notifyInviteComplete?: Maybe<ToggleSetting>;
  /** When there are updates to my Jobs account */
  marketPlaceExpirationMsg?: Maybe<ToggleSetting>;
  /** When a contact of mine has a new position or employer */
  notifyOnContactsWorkexperienceChange?: Maybe<ToggleSetting>;
  /** I'd like to receive a weekly newsletter with my personal statistics */
  weeklyNewsletter?: Maybe<ToggleSetting>;
  /** I'd like to receive a daily e-mail informing me of my contacts' birthdays (never miss a birthday again)! */
  notifyOnBirthdays?: Maybe<ToggleSetting>;
  /** I'd like to receive regular contact suggestions regarding interesting members (recommended). */
  notifyMemberRecommendations?: Maybe<ToggleSetting>;
  /** I'd like to receive a weekly e-mail with personal job recommendations if I state in my profile that I'm interested in career opportunities (recommended). */
  weeklyRecoJobs?: Maybe<ToggleSetting>;
  /** ProJobs only: I'd like receive e-mail notifications if recruiters visit my profile (recommended). */
  projobsNewsletter?: Maybe<ToggleSetting>;
  /** I'd like to receive invitations to apply for a job. */
  receiveInvitationsJobs?: Maybe<ToggleSetting>;
  /** I'd like to receive an e-mail about similar job recos. */
  similarJobRecoEmail?: Maybe<ToggleSetting>;
  /** I'd like to receive an e-mail about my bookmarked jobs. */
  bookmarkReminderEmail?: Maybe<ToggleSetting>;
  /** Whether user should be tracked by external marketing partners */
  trackingThirdpartyMarketing?: Maybe<ToggleSetting>;
  /** Whether user should be tracked by external statistical partners */
  trackingThirdpartyStatistical?: Maybe<ToggleSetting>;
  /** Whether user should be tracked by external partners */
  trackingThirdpartyExternal?: Maybe<ToggleSetting>;
  /** Whether user wants to recieve baller league newsletter or not */
  marketingNlBallerLeague?: Maybe<ToggleSetting>;
  /** Whether user wants to use focus mode or not */
  sixtFocusmodeState?: Maybe<ToggleSetting>;
  /** Whether the user is a part of an experiment and has SIXT focus mode available */
  sixtFocusmodeAvailable?: Maybe<ToggleSetting>;
  /** Whether the user wants to receive LinkedIn data import emails */
  linkedinDataImportEmail?: Maybe<ToggleSetting>;
};

export type CoreSettingsInput = {
  /** User data should be deleted and not inherited after death */
  deleteUserDataAfterDecease?: Maybe<ToggleSettingInput>;
  /** XING recommendations (e.g. interesting groups, jobs and Industry News) */
  marketingNlXingRecos?: Maybe<ToggleSettingInput>;
  /** Events you may be interested in */
  marketingNlEvents?: Maybe<ToggleSettingInput>;
  /** Freelance offers you may be interested in */
  marketingNlFreelancerOffers?: Maybe<ToggleSettingInput>;
  /** Local events you may be interested in */
  marketingNlLocalEvents?: Maybe<ToggleSettingInput>;
  /** Updates and handy hints about XING features */
  marketingNlXingFeatures?: Maybe<ToggleSettingInput>;
  /** We value your opinion: XING surveys */
  marketingNlSurveys?: Maybe<ToggleSettingInput>;
  /** Information about XING partner offers */
  marketingNlXingPartners?: Maybe<ToggleSettingInput>;
  /** Information about XING special offers and prize draws */
  marketingNlXingPromotions?: Maybe<ToggleSettingInput>;
  /** Premium membership and ProBusiness add-on details and offers */
  marketingNlPremiumOffers?: Maybe<ToggleSettingInput>;
  /** ProJobs add-on details and offers */
  marketingNlProjobsOffers?: Maybe<ToggleSettingInput>;
  /** Details and offers about specific XING memberships and add-ons (e.g. ProCoach or Executive) */
  marketingNlProcoachOffers?: Maybe<ToggleSettingInput>;
  /** For employers and recruiters: Invitation to XING recruiting events */
  marketingNlRecruitingEvents?: Maybe<ToggleSettingInput>;
  /** For organisers: Event tips and offers on XING */
  marketingNlEventsOffers?: Maybe<ToggleSettingInput>;
  /** For XING Premium and ProBusiness: Information about new features and special offers */
  marketingNlPremiumInfos?: Maybe<ToggleSettingInput>;
  /** For ProCoach members: Details and offers */
  marketingNlProjobsInfos?: Maybe<ToggleSettingInput>;
  /** Details and offers for ProCoach and Executives members */
  marketingNlProcoachInfos?: Maybe<ToggleSettingInput>;
  /** For group moderators: Groups information and tips on XING */
  marketingNlModerator?: Maybe<ToggleSettingInput>;
  /** For employers and recruiters: Tips and information */
  marketingNlRecruiter?: Maybe<ToggleSettingInput>;
  /** For new members: Getting started on XING (in the first few weeks after joining) */
  marketingNlNewMembers?: Maybe<ToggleSettingInput>;
  /** Job search and career details */
  marketingNlJobCareer?: Maybe<ToggleSettingInput>;
  /** Information about finding employers and the new world of work */
  marketingNlNewWork?: Maybe<ToggleSettingInput>;
  /** For advertisers: XING marketing and advertising updates */
  marketingNlSalesAdvertising?: Maybe<ToggleSettingInput>;
  /** I'd like to receive useful information about creating ads on XING. */
  marketingNlXasDraftReminder?: Maybe<ToggleSettingInput>;
  /** I'm interested in receiving information and offers by post. */
  printMailing?: Maybe<ToggleSettingInput>;
  /** When someone sends me a XING message */
  notifyOnPrivateMessage?: Maybe<ToggleSettingInput>;
  /** When I have not replied to a message */
  notifyOnUnansweredMessage?: Maybe<ToggleSettingInput>;
  /** When someone comments on something I posted, commented on or liked (updates and topics) */
  notifyOnActivityComment?: Maybe<ToggleSettingInput>;
  /** When someone likes something I posted */
  notifyOnActivityLike?: Maybe<ToggleSettingInput>;
  /** When someone shares something I posted */
  notifyOnSocialShare?: Maybe<ToggleSettingInput>;
  /** When someone mentions me */
  notifyOnSocialMention?: Maybe<ToggleSettingInput>;
  /** When I receive new contact requests */
  notifyOnContactRequest?: Maybe<ToggleSettingInput>;
  /** If I have any pending contact requests */
  notifyUnconfirmedContactReminder?: Maybe<ToggleSettingInput>;
  /** When someone I've invited joins XING */
  notifyInviteComplete?: Maybe<ToggleSettingInput>;
  /** When there are updates to my Jobs account */
  marketPlaceExpirationMsg?: Maybe<ToggleSettingInput>;
  /** When a contact of mine has a new position or employer */
  notifyOnContactsWorkexperienceChange?: Maybe<ToggleSettingInput>;
  /** I'd like to receive a weekly newsletter with my personal statistics */
  weeklyNewsletter?: Maybe<ToggleSettingInput>;
  /** I'd like to receive a daily e-mail informing me of my contacts' birthdays (never miss a birthday again)! */
  notifyOnBirthdays?: Maybe<ToggleSettingInput>;
  /** I'd like to receive regular contact suggestions regarding interesting members (recommended). */
  notifyMemberRecommendations?: Maybe<ToggleSettingInput>;
  /** I'd like to receive a weekly e-mail with personal job recommendations if I state in my profile that I'm interested in career opportunities (recommended). */
  weeklyRecoJobs?: Maybe<ToggleSettingInput>;
  /** ProJobs only: I'd like receive e-mail notifications if recruiters visit my profile (recommended). */
  projobsNewsletter?: Maybe<ToggleSettingInput>;
  /** I'd like to receive invitations to apply for a job. */
  receiveInvitationsJobs?: Maybe<ToggleSettingInput>;
  /** I'd like to receive an e-mail about similar job recos. */
  similarJobRecoEmail?: Maybe<ToggleSettingInput>;
  /** I'd like to receive an e-mail about my bookmarked jobs. */
  bookmarkReminderEmail?: Maybe<ToggleSettingInput>;
  /** Whether user should be tracked by external marketing partners */
  trackingThirdpartyMarketing?: Maybe<ToggleSettingInput>;
  /** Whether user should be tracked by external statistical partners */
  trackingThirdpartyStatistical?: Maybe<ToggleSettingInput>;
  /** Whether user should be tracked by external partners */
  trackingThirdpartyExternal?: Maybe<ToggleSettingInput>;
  /** Whether user wants to recieve baller league newsletter or not */
  marketingNlBallerLeague?: Maybe<ToggleSettingInput>;
  /** Whether user wants to use focus mode or not */
  sixtFocusmodeState?: Maybe<ToggleSettingInput>;
  /** Whether the user is a part of an experiment and has SIXT focus mode available */
  sixtFocusmodeAvailable?: Maybe<ToggleSettingInput>;
  /** Whether the user wants to receive LinkedIn data import emails */
  linkedinDataImportEmail?: Maybe<ToggleSettingInput>;
};

export type CoreSettingsMutationResult = {
  __typename?: 'CoreSettingsMutationResult';
  error?: Maybe<CoreSettings>;
  response?: Maybe<CoreSettings>;
};

export type Country = Localizable & {
  __typename?: 'Country';
  /** #logged-out #soft-logged-in */
  countryCode: CountryCodesAlpha2;
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
  /** #logged-out #soft-logged-in */
  provinces: Array<Province>;
};

export type CountryAggregation = HasAggregationCount & {
  __typename?: 'CountryAggregation';
  /** #soft-logged-in */
  count: Scalars['Int'];
  /** #soft-logged-in */
  value?: Maybe<Scalars['String']>;
  /** #soft-logged-in #rest(batched) #virtual */
  label?: Maybe<Country>;
};

/** [ISO-3166-1](https://en.wikipedia.org/wiki/ISO_3166-1) Alpha 2 country codes */
export enum CountryCodesAlpha2 {
  /** Afghanistan */
  Af = 'AF',
  /** Åland Islands */
  Ax = 'AX',
  /** Albania */
  Al = 'AL',
  /** Algeria */
  Dz = 'DZ',
  /** American Samoa */
  As = 'AS',
  /** Andorra */
  Ad = 'AD',
  /** Netherlands Antilles - Transitionally reserved (deprecated) - https://en.wikipedia.org/wiki/ISO_3166-2:AN */
  An = 'AN',
  /** Angola */
  Ao = 'AO',
  /** Anguilla */
  Ai = 'AI',
  /** Antarctica */
  Aq = 'AQ',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Argentina */
  Ar = 'AR',
  /** Armenia */
  Am = 'AM',
  /** Aruba */
  Aw = 'AW',
  /** Australia */
  Au = 'AU',
  /** Austria */
  At = 'AT',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bahamas */
  Bs = 'BS',
  /** Bahrain */
  Bh = 'BH',
  /** Bangladesh */
  Bd = 'BD',
  /** Barbados */
  Bb = 'BB',
  /** Belarus */
  By = 'BY',
  /** Belgium */
  Be = 'BE',
  /** Belize */
  Bz = 'BZ',
  /** Benin */
  Bj = 'BJ',
  /** Bermuda */
  Bm = 'BM',
  /** Bhutan */
  Bt = 'BT',
  /** Bolivia, Plurinational State of */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq = 'BQ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Botswana */
  Bw = 'BW',
  /** Bouvet Island */
  Bv = 'BV',
  /** Brazil */
  Br = 'BR',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Brunei Darussalam */
  Bn = 'BN',
  /** Bulgaria */
  Bg = 'BG',
  /** Burkina Faso */
  Bf = 'BF',
  /** Burundi */
  Bi = 'BI',
  /** Cambodia */
  Kh = 'KH',
  /** Cameroon */
  Cm = 'CM',
  /** Canada */
  Ca = 'CA',
  /** Cape Verde */
  Cv = 'CV',
  /** Cayman Islands */
  Ky = 'KY',
  /** Central African Republic */
  Cf = 'CF',
  /** Chad */
  Td = 'TD',
  /** Chile */
  Cl = 'CL',
  /** China */
  Cn = 'CN',
  /** Christmas Island */
  Cx = 'CX',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** Colombia */
  Co = 'CO',
  /** Comoros */
  Km = 'KM',
  /** Congo */
  Cg = 'CG',
  /** Congo, the Democratic Republic of the */
  Cd = 'CD',
  /** Cook Islands */
  Ck = 'CK',
  /** Costa Rica */
  Cr = 'CR',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Croatia */
  Hr = 'HR',
  /** Cuba */
  Cu = 'CU',
  /** Curaçao */
  Cw = 'CW',
  /** Cyprus */
  Cy = 'CY',
  /** Czech Republic */
  Cz = 'CZ',
  /** Denmark */
  Dk = 'DK',
  /** Djibouti */
  Dj = 'DJ',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Ecuador */
  Ec = 'EC',
  /** Egypt */
  Eg = 'EG',
  /** El Salvador */
  Sv = 'SV',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Eritrea */
  Er = 'ER',
  /** Estonia */
  Ee = 'EE',
  /** Ethiopia */
  Et = 'ET',
  /** Falkland Islands (Malvinas) */
  Fk = 'FK',
  /** Faroe Islands */
  Fo = 'FO',
  /** Fiji */
  Fj = 'FJ',
  /** Finland */
  Fi = 'FI',
  /** France */
  Fr = 'FR',
  /** French Guiana */
  Gf = 'GF',
  /** French Polynesia */
  Pf = 'PF',
  /** French Southern Territories */
  Tf = 'TF',
  /** Gabon */
  Ga = 'GA',
  /** Gambia */
  Gm = 'GM',
  /** Georgia */
  Ge = 'GE',
  /** Germany */
  De = 'DE',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greece */
  Gr = 'GR',
  /** Greenland */
  Gl = 'GL',
  /** Grenada */
  Gd = 'GD',
  /** Guadeloupe */
  Gp = 'GP',
  /** Guam */
  Gu = 'GU',
  /** Guatemala */
  Gt = 'GT',
  /** Guernsey */
  Gg = 'GG',
  /** Guinea */
  Gn = 'GN',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Haiti */
  Ht = 'HT',
  /** Heard Island and McDonald Islands */
  Hm = 'HM',
  /** Holy See (Vatican City State) */
  Va = 'VA',
  /** Honduras */
  Hn = 'HN',
  /** Hong Kong */
  Hk = 'HK',
  /** Hungary */
  Hu = 'HU',
  /** Iceland */
  Is = 'IS',
  /** India */
  In = 'IN',
  /** Indonesia */
  Id = 'ID',
  /** Iran, Islamic Republic of */
  Ir = 'IR',
  /** Iraq */
  Iq = 'IQ',
  /** Ireland */
  Ie = 'IE',
  /** Isle of Man */
  Im = 'IM',
  /** Israel */
  Il = 'IL',
  /** Italy */
  It = 'IT',
  /** Jamaica */
  Jm = 'JM',
  /** Japan */
  Jp = 'JP',
  /** Jersey */
  Je = 'JE',
  /** Jordan */
  Jo = 'JO',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Kenya */
  Ke = 'KE',
  /** Kiribati */
  Ki = 'KI',
  /** Korea, Democratic People's Republic of */
  Kp = 'KP',
  /** Korea, Republic of */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Lao People's Democratic Republic */
  La = 'LA',
  /** Latvia */
  Lv = 'LV',
  /** Lebanon */
  Lb = 'LB',
  /** Lesotho */
  Ls = 'LS',
  /** Liberia */
  Lr = 'LR',
  /** Libya */
  Ly = 'LY',
  /** Liechtenstein */
  Li = 'LI',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Macao */
  Mo = 'MO',
  /** Macedonia, the Former Yugoslav Republic of */
  Mk = 'MK',
  /** Madagascar */
  Mg = 'MG',
  /** Malawi */
  Mw = 'MW',
  /** Malaysia */
  My = 'MY',
  /** Maldives */
  Mv = 'MV',
  /** Mali */
  Ml = 'ML',
  /** Malta */
  Mt = 'MT',
  /** Marshall Islands */
  Mh = 'MH',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Mauritius */
  Mu = 'MU',
  /** Mayotte */
  Yt = 'YT',
  /** Mexico */
  Mx = 'MX',
  /** Micronesia, Federated States of */
  Fm = 'FM',
  /** Moldova, Republic of */
  Md = 'MD',
  /** Monaco */
  Mc = 'MC',
  /** Mongolia */
  Mn = 'MN',
  /** Montenegro */
  Me = 'ME',
  /** Montserrat */
  Ms = 'MS',
  /** Morocco */
  Ma = 'MA',
  /** Mozambique */
  Mz = 'MZ',
  /** Myanmar */
  Mm = 'MM',
  /** Namibia */
  Na = 'NA',
  /** Nauru */
  Nr = 'NR',
  /** Nepal */
  Np = 'NP',
  /** Netherlands */
  Nl = 'NL',
  /** New Caledonia */
  Nc = 'NC',
  /** New Zealand */
  Nz = 'NZ',
  /** Nicaragua */
  Ni = 'NI',
  /** Niger */
  Ne = 'NE',
  /** Nigeria */
  Ng = 'NG',
  /** Niue */
  Nu = 'NU',
  /** Norfolk Island */
  Nf = 'NF',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Norway */
  No = 'NO',
  /** Oman */
  Om = 'OM',
  /** Pakistan */
  Pk = 'PK',
  /** Palau */
  Pw = 'PW',
  /** Palestine, State of */
  Ps = 'PS',
  /** Panama */
  Pa = 'PA',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Paraguay */
  Py = 'PY',
  /** Peru */
  Pe = 'PE',
  /** Philippines */
  Ph = 'PH',
  /** Pitcairn */
  Pn = 'PN',
  /** Poland */
  Pl = 'PL',
  /** Portugal */
  Pt = 'PT',
  /** Puerto Rico */
  Pr = 'PR',
  /** Qatar */
  Qa = 'QA',
  /** Réunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Russian Federation */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saint Barthélemy */
  Bl = 'BL',
  /** Saint Helena, Ascension and Tristan da Cunha */
  Sh = 'SH',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** Saint Lucia */
  Lc = 'LC',
  /** Saint Martin (French part) */
  Mf = 'MF',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Samoa */
  Ws = 'WS',
  /** San Marino */
  Sm = 'SM',
  /** Sao Tome and Principe */
  St = 'ST',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Senegal */
  Sn = 'SN',
  /** Serbia */
  Rs = 'RS',
  /** Seychelles */
  Sc = 'SC',
  /** Sierra Leone */
  Sl = 'SL',
  /** Singapore */
  Sg = 'SG',
  /** Sint Maarten (Dutch part) */
  Sx = 'SX',
  /** Slovakia */
  Sk = 'SK',
  /** Slovenia */
  Si = 'SI',
  /** Solomon Islands */
  Sb = 'SB',
  /** Somalia */
  So = 'SO',
  /** South Africa */
  Za = 'ZA',
  /** South Georgia and the South Sandwich Islands */
  Gs = 'GS',
  /** South Sudan */
  Ss = 'SS',
  /** Spain */
  Es = 'ES',
  /** Sri Lanka */
  Lk = 'LK',
  /** Sudan */
  Sd = 'SD',
  /** Suriname */
  Sr = 'SR',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Swaziland */
  Sz = 'SZ',
  /** Sweden */
  Se = 'SE',
  /** Switzerland */
  Ch = 'CH',
  /** Syrian Arab Republic */
  Sy = 'SY',
  /** Taiwan, Province of China */
  Tw = 'TW',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tanzania, United Republic of */
  Tz = 'TZ',
  /** Thailand */
  Th = 'TH',
  /** Timor-Leste */
  Tl = 'TL',
  /** Togo */
  Tg = 'TG',
  /** Tokelau */
  Tk = 'TK',
  /** Tonga */
  To = 'TO',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tunisia */
  Tn = 'TN',
  /** Turkey */
  Tr = 'TR',
  /** Turkmenistan */
  Tm = 'TM',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Tuvalu */
  Tv = 'TV',
  /** Uganda */
  Ug = 'UG',
  /** Ukraine */
  Ua = 'UA',
  /** United Arab Emirates */
  Ae = 'AE',
  /** United Kingdom */
  Gb = 'GB',
  /** United States */
  Us = 'US',
  /** United States Minor Outlying Islands */
  Um = 'UM',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Vanuatu */
  Vu = 'VU',
  /** Venezuela, Bolivarian Republic of */
  Ve = 'VE',
  /** Viet Nam */
  Vn = 'VN',
  /** Virgin Islands, British */
  Vg = 'VG',
  /** Virgin Islands, U.S. */
  Vi = 'VI',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** Western Sahara */
  Eh = 'EH',
  /** Yemen */
  Ye = 'YE',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW',
  /** Kosovo */
  Xk = 'XK'
}

export enum CountryFilter {
  Top = 'TOP',
  Other = 'OTHER',
  All = 'ALL'
}

export type CoverImageUpdate = {
  __typename?: 'CoverImageUpdate';
  urn: Scalars['GlobalID'];
  createdAt: Scalars['Date'];
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
  id: Scalars['ID'];
  url: Scalars['URL'];
  imageUuid: Scalars['UUID'];
};

export type CreateBriefingError = {
  __typename?: 'CreateBriefingError';
  message: Scalars['String'];
  errors: Array<Maybe<Scalars['String']>>;
};

export type CreateBriefingResult = CreateBriefingSuccess | CreateBriefingError;

export type CreateBriefingSuccess = {
  __typename?: 'CreateBriefingSuccess';
  briefing: Briefing;
};

export type CreateCandidateSearchError = {
  __typename?: 'CreateCandidateSearchError';
  message: Scalars['String'];
  errors: Array<Maybe<Scalars['String']>>;
};

export type CreateCandidateSearchResult = CreateCandidateSearchSuccess | CreateCandidateSearchError;

export type CreateCandidateSearchSuccess = {
  __typename?: 'CreateCandidateSearchSuccess';
  candidateSearch: CandidateSearch;
};

export type CreateCvUploadParsedCvResult = CvUploadParsedCv | CvUploadError;

export type CreateLinkedInOAuthFlowTokenError = {
  __typename?: 'CreateLinkedInOAuthFlowTokenError';
  error: Scalars['String'];
  message: Scalars['String'];
};

export type CreateLinkedInOAuthFlowTokenResult = CreateLinkedInOAuthFlowTokenSuccess | CreateLinkedInOAuthFlowTokenError;

export type CreateLinkedInOAuthFlowTokenSuccess = {
  __typename?: 'CreateLinkedInOAuthFlowTokenSuccess';
  token: Scalars['String'];
  expiresAt: Scalars['Date'];
};

export type CreateMessengerAttachmentConfirmation = {
  __typename?: 'CreateMessengerAttachmentConfirmation';
  message: Scalars['String'];
};

export type CreateMessengerAttachmentMessageInput = {
  chatId: Scalars['ID'];
  /** A unique identifier generated by the client application in order to avoid creating duplicates in retry mechanisms */
  clientId: Scalars['UUID'];
  /** The context_id that controls things like QuickMessages */
  contextId?: Maybe<Scalars['String']>;
  /** The upload_id received when uploading the image to the messenger bypassed upload server. */
  uploadToken?: Maybe<Scalars['String']>;
};

export type CreateMessengerAttachmentMessageResult = CreateMessengerAttachmentConfirmation | CreateMessengerMessageError;

export type CreateMessengerChat = {
  participants: Array<Scalars['ID']>;
  contextId?: Maybe<Scalars['String']>;
};

export type CreateMessengerChatBySlugOrId = {
  participants: Array<Scalars['SlugOrID']>;
  contextId?: Maybe<Scalars['String']>;
};

export type CreateMessengerChatError = {
  __typename?: 'CreateMessengerChatError';
  message: Scalars['String'];
};

export type CreateMessengerChatResult = {
  __typename?: 'CreateMessengerChatResult';
  success?: Maybe<MessengerChat>;
  error?: Maybe<CreateMessengerChatError>;
};

export type CreateMessengerImageConfirmation = {
  __typename?: 'CreateMessengerImageConfirmation';
  message: Scalars['String'];
};

export type CreateMessengerImageMessageInput = {
  chatId: Scalars['ID'];
  /** A unique identifier generated by the client application in order to avoid creating duplicates in retry mechanisms */
  clientId: Scalars['UUID'];
  /** The context_id that controls things like QuickMessages */
  contextId?: Maybe<Scalars['String']>;
  /** The upload_id received when uploading the image to the messenger bypassed upload server. */
  uploadToken?: Maybe<Scalars['String']>;
  /** The initiator_urn contains the urn of the object that was clicked to reach the messenger. */
  initiatorUrn?: Maybe<Scalars['URN']>;
};

export type CreateMessengerImageMessageResult = CreateMessengerImageConfirmation | CreateMessengerMessageError;

export type CreateMessengerMessageError = {
  __typename?: 'CreateMessengerMessageError';
  message: Scalars['String'];
};

export type CreateMessengerMessageInput = {
  chatId: Scalars['ID'];
  /** The text body of the message */
  body: Scalars['String'];
  /** A unique identifier generated by the client application in order to avoid creating duplicates in retry mechanisms */
  clientId: Scalars['UUID'];
  /** The context_id that controls things like QuickMessages */
  contextId?: Maybe<Scalars['String']>;
  /** A reply reference */
  replyId?: Maybe<Scalars['String']>;
  /** The reference_urn used to create the system message when a user replies to stories, etc. */
  referenceUrn?: Maybe<Scalars['URN']>;
  /** The initiator_urn contains the urn of the object that was clicked to reach the messenger. */
  initiatorUrn?: Maybe<Scalars['URN']>;
};

export type CreateMessengerMessageResult = {
  __typename?: 'CreateMessengerMessageResult';
  success?: Maybe<MessengerMessage>;
  error?: Maybe<CreateMessengerMessageError>;
};

export type CreateMessengerMessageTemplateError = {
  __typename?: 'CreateMessengerMessageTemplateError';
  message: Scalars['String'];
};

export type CreateMessengerMessageTemplateInput = {
  title: Scalars['String'];
  body: Scalars['String'];
};

export type CreateMessengerMessageTemplateResult = CreateMessengerMessageTemplateSuccess | CreateMessengerMessageTemplateError;

export type CreateMessengerMessageTemplateSuccess = {
  __typename?: 'CreateMessengerMessageTemplateSuccess';
  success: MessengerMessageTemplatesInterface;
};

export type CreateMessengerOneClickSystemReplyMessageSuccess = {
  __typename?: 'CreateMessengerOneClickSystemReplyMessageSuccess';
  chatId: Scalars['ID'];
  replyId: Scalars['String'];
};

export type CreateMessengerSystemReplyMessageError = {
  __typename?: 'CreateMessengerSystemReplyMessageError';
  message: Scalars['String'];
};

export type CreateMessengerSystemReplyMessageInput = {
  chatId: Scalars['ID'];
  /** A unique identifier generated by the client application in order to avoid creating duplicates in retry mechanisms */
  clientId: Scalars['UUID'];
  /** A reply reference */
  replyId: Scalars['String'];
  /** The context_id that controls things like QuickMessages */
  contextId?: Maybe<Scalars['String']>;
  /** The list of items missing */
  missingInfoItems?: Maybe<Array<Maybe<MissingInfoItem>>>;
};

export type CreateMessengerSystemReplyMessageResult = CreateMessengerSystemReplyMessageSuccess | CreateMessengerSystemReplyMessageError;

export type CreateMessengerSystemReplyMessageSuccess = {
  __typename?: 'CreateMessengerSystemReplyMessageSuccess';
  success?: Maybe<MessengerMessage>;
};

export type CreateMessengerUserReplyMessageError = {
  __typename?: 'CreateMessengerUserReplyMessageError';
  message: Scalars['String'];
};

export type CreateMessengerUserReplyMessageInput = {
  chatId: Scalars['ID'];
  /** A unique identifier generated by the client application in order to avoid creating duplicates in retry mechanisms */
  clientId: Scalars['UUID'];
  /** A reply reference */
  replyId: Scalars['String'];
  /** The context_id that controls things like QuickMessages */
  contextId?: Maybe<Scalars['String']>;
};

export type CreateMessengerUserReplyMessageResult = CreateMessengerUserReplyMessageSuccess | CreateMessengerUserReplyMessageError;

export type CreateMessengerUserReplyMessageSuccess = {
  __typename?: 'CreateMessengerUserReplyMessageSuccess';
  success: Scalars['Boolean'];
};

export type CreatePaymentsB2bClientIdError = {
  __typename?: 'CreatePaymentsB2bClientIdError';
  /** #logged-out #soft-logged-in */
  error: Scalars['String'];
  /** #logged-out #soft-logged-in */
  message: Scalars['String'];
};

export type CreatePaymentsB2bClientIdInput = {
  name: Scalars['String'];
  street: Scalars['String'];
  postcode: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  vatId: Scalars['String'];
  email: Scalars['String'];
  idempotencyUuid: Scalars['String'];
  salesforceId?: Maybe<Scalars['String']>;
};

export type CreatePaymentsB2bClientIdResult = CreatePaymentsB2bClientIdSuccess | CreatePaymentsB2bClientIdError;

export type CreatePaymentsB2bClientIdSuccess = {
  __typename?: 'CreatePaymentsB2bClientIdSuccess';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
};

export type CreateSearchAlertByQueryNewInput = {
  search: JobSearchInput;
  origin?: Maybe<SearchAlertOrigin>;
};

export type CreateUserError = {
  __typename?: 'CreateUserError';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Array<Maybe<CreateUserErrorFields>>>;
};

export type CreateUserErrorFields = {
  __typename?: 'CreateUserErrorFields';
  /** #logged-out #soft-logged-in */
  field?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
};

export type CreateUserInput = {
  signupMinireg?: Maybe<CreateUserInputFields>;
};

export type CreateUserInputFields = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  tandcCheck?: Maybe<Scalars['String']>;
  signupChannel?: Maybe<Scalars['String']>;
  cvSource?: Maybe<Scalars['GlobalID']>;
  parsedCvId?: Maybe<Scalars['ID']>;
  cvUploadId?: Maybe<Scalars['String']>;
};

export type CreateUserMutationResult = CreateUserSuccess | CreateUserError;

export type CreateUserSuccess = {
  __typename?: 'CreateUserSuccess';
  /** #logged-out #soft-logged-in */
  success?: Maybe<CreateUserSuccessFields>;
};

export type CreateUserSuccessFields = {
  __typename?: 'CreateUserSuccessFields';
  /** #logged-out #soft-logged-in */
  hashedUserId: Scalars['String'];
};

/** Input types for cover letter creation */
export type CreateVitaCoverLetterInput = {
  token?: Maybe<Scalars['String']>;
  theme?: Maybe<CreateVitaDocumentThemeInput>;
  personalInformation?: Maybe<CreateVitaDocumentCvPersonalInformationInput>;
  professionalExperience?: Maybe<Array<Maybe<CreateVitaDocumentCvProfessionalExperienceInput>>>;
  educationExperience?: Maybe<Array<Maybe<CreateVitaDocumentCvEducationExperienceInput>>>;
  skills?: Maybe<Array<Maybe<CreateVitaDoucmentCvSkillInput>>>;
  jobDetails?: Maybe<VitaJobDetailsInput>;
  addressTo?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
  fileAttachments?: Maybe<CreateVitaDocumentFileAttachmentsInput>;
  content?: Maybe<Array<VitaCoverLetterContentInput>>;
  origin?: Maybe<VitaDocumentOrigin>;
  language?: Maybe<VitaDocumentLanguage>;
};

export type CreateVitaDocumentCvEducationExperienceInput = {
  courseOfStudy: Scalars['String'];
  degree?: Maybe<Scalars['String']>;
  institution?: Maybe<Scalars['String']>;
  startDate: Scalars['Date'];
  endDate?: Maybe<Scalars['Date']>;
  isStillStudy: Scalars['Boolean'];
};

export type CreateVitaDocumentCvInput = {
  personalInformation?: Maybe<CreateVitaDocumentCvPersonalInformationInput>;
  professionalExperience?: Maybe<Array<Maybe<CreateVitaDocumentCvProfessionalExperienceInput>>>;
  educationExperience?: Maybe<Array<Maybe<CreateVitaDocumentCvEducationExperienceInput>>>;
  skills?: Maybe<Array<Maybe<CreateVitaDoucmentCvSkillInput>>>;
  aboutMe?: Maybe<Scalars['String']>;
  preferences?: Maybe<CreateVitaDocumentCvPreferencesInput>;
};

export type CreateVitaDocumentCvPersonalInformationInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  birthdate?: Maybe<Scalars['String']>;
  birthplace?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  email: Scalars['String'];
};

export type CreateVitaDocumentCvPreferencesInput = {
  seekingStatus: SeekingStatus;
  seekingReason?: Maybe<VitaSeekingReason>;
  otherSeekingReason?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<CreateVitaDocumentCvPreferencesLocationInput>>>;
  homeOffice?: Maybe<Scalars['Boolean']>;
  targetPosition?: Maybe<Scalars['String']>;
};

export type CreateVitaDocumentCvPreferencesLocationInput = {
  cityId: Scalars['Int'];
  cityIdWithScrambling?: Maybe<Scalars['String']>;
  cityName: Scalars['String'];
};

export type CreateVitaDocumentCvProfessionalExperienceDescriptionInput = {
  description?: Maybe<Scalars['String']>;
};

export type CreateVitaDocumentCvProfessionalExperienceDisciplineInput = {
  id: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type CreateVitaDocumentCvProfessionalExperienceIndustryInput = {
  id: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type CreateVitaDocumentCvProfessionalExperienceInput = {
  occupation: Scalars['String'];
  company: Scalars['String'];
  industry: CreateVitaDocumentCvProfessionalExperienceIndustryInput;
  discipline: CreateVitaDocumentCvProfessionalExperienceDisciplineInput;
  jobLevel: CreateVitaDocumentCvProfessionalExperienceJobLevelInput;
  descriptions?: Maybe<Array<Maybe<CreateVitaDocumentCvProfessionalExperienceDescriptionInput>>>;
  startDate: Scalars['Date'];
  endDate?: Maybe<Scalars['Date']>;
  isCurrentEmployer: Scalars['Boolean'];
};

export type CreateVitaDocumentCvProfessionalExperienceJobLevelInput = {
  id: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type CreateVitaDocumentError = {
  __typename?: 'CreateVitaDocumentError';
  /** #logged-out #soft-logged-in */
  message: Scalars['String'];
};

export type CreateVitaDocumentFileAttachmentInput = {
  uploadId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  delete?: Maybe<Scalars['Boolean']>;
};

export type CreateVitaDocumentFileAttachmentsInput = {
  profileImage?: Maybe<CreateVitaDocumentFileAttachmentInput>;
};

export type CreateVitaDocumentImportInput = {
  personalInformation?: Maybe<VitaImportDocumentPersonalInformationInput>;
  educationExperience?: Maybe<VitaProfileEducationCollectionInput>;
  professionalExperience?: Maybe<VitaProfileWorkExperienceCollectionInput>;
  skills?: Maybe<VitaProfileSkillsInput>;
  aboutMe?: Maybe<VitaProfileAboutMeInput>;
};

export type CreateVitaDocumentInput = {
  theme?: Maybe<CreateVitaDocumentThemeInput>;
  cv?: Maybe<CreateVitaDocumentCvInput>;
  id?: Maybe<Scalars['UUID']>;
  token?: Maybe<Scalars['String']>;
  fileAttachments?: Maybe<CreateVitaDocumentFileAttachmentsInput>;
  origin?: Maybe<VitaDocumentOrigin>;
  language?: Maybe<VitaDocumentLanguage>;
};

export type CreateVitaDocumentResult = VitaDocument | VitaCoverLetter | CreateVitaDocumentError;

export type CreateVitaDocumentThemeInput = {
  color?: Maybe<VitaDocumentThemeColor>;
  template?: Maybe<VitaDocumentThemeTemplate>;
};

export type CreateVitaDoucmentCvSkillInput = {
  skill?: Maybe<Scalars['String']>;
};

/**
 * INPUTS to create vita document from Profile imports - ONLY
 * Is used to pass in data: the response from `vitaProfileImport` viewer
 *
 * Inputs are vita specific and describes equivalent types from Profiles, AccountSettings
 * and XingIdContactDetails.
 */
export type CreateVitaProfileImportInput = {
  theme?: Maybe<CreateVitaDocumentThemeInput>;
  data?: Maybe<CreateVitaDocumentImportInput>;
  token?: Maybe<Scalars['String']>;
  origin?: Maybe<VitaDocumentOrigin>;
  language?: Maybe<VitaDocumentLanguage>;
};

export type CreateWebPushSubscriptionError = {
  __typename?: 'CreateWebPushSubscriptionError';
  /** #logged-out #soft-logged-in */
  message: Scalars['String'];
};

export type CreateWebPushSubscriptionInput = {
  notificationEnv: Scalars['String'];
  visitorId: Scalars['String'];
  jobId: Scalars['ID'];
  locale: Scalars['String'];
};

export type CreateWebPushSubscriptionResult = WebPushSubscription | CreateWebPushSubscriptionError;

export type CreateWorkExperienceInput = {
  profileId: Scalars['ID'];
  companyName: Scalars['String'];
  companyId?: Maybe<Scalars['String']>;
  jobTitle: Scalars['String'];
  statusId: Scalars['ID'];
  levelId?: Maybe<Scalars['ID']>;
  disciplineId?: Maybe<Scalars['ID']>;
  industryId: Scalars['ID'];
  beginDate: ProfileInputYearAndMonth;
  endDate?: Maybe<ProfileInputYearAndMonth>;
};

export type CreditCardData = BpayPaymentMethodData & {
  __typename?: 'CreditCardData';
  brand?: Maybe<Scalars['String']>;
  maskedNumber?: Maybe<Scalars['String']>;
  holder?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  clientName: Scalars['String'];
};

export type CreditCardUrl = {
  __typename?: 'CreditCardUrl';
  /**
   * #soft-logged-in
   *
   *  url for creditcard payment flow / pop-up
   */
  url?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  errors?: Maybe<Array<Maybe<PaymentsAttributeMessage>>>;
};

export type CulturalAssessmentProposalSignal = NetworkUpdatesStackItem & {
  __typename?: 'CulturalAssessmentProposalSignal';
  /** #rest #virtual */
  object?: Maybe<MoveonCompanyCulturePreferencesAssessmentDataResult>;
  id: Scalars['ID'];
  stackId: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type CulturalAssessmentProposalStack = SignalsStack & {
  __typename?: 'CulturalAssessmentProposalStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type CulturalAssessmentProposalStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

/** Represents [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) currency codes. */
export enum Currency {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bov = 'BOV',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Usn = 'USN',
  Uyi = 'UYI',
  Uyu = 'UYU',
  Uyw = 'UYW',
  Uzs = 'UZS',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xba = 'XBA',
  Xbb = 'XBB',
  Xbc = 'XBC',
  Xbd = 'XBD',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xof = 'XOF',
  Xpd = 'XPD',
  Xpf = 'XPF',
  Xpt = 'XPT',
  Xsu = 'XSU',
  Xts = 'XTS',
  Xua = 'XUA',
  Xxx = 'XXX',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL'
}

export type CurrentCompaniesInsight = {
  __typename?: 'CurrentCompaniesInsight';
  companies: Array<Maybe<CurrentCompanyInsight>>;
  xtmUrl: Scalars['URL'];
  candidatesCount: Scalars['Int'];
};

export type CurrentCompanyInsight = {
  __typename?: 'CurrentCompanyInsight';
  company: CompanyProfileInsight;
  growth?: Maybe<Scalars['Float']>;
  destinations?: Maybe<Array<Maybe<CompanyProfileInsight>>>;
  candidatesCount: Scalars['Int'];
  avatars?: Maybe<Array<Maybe<Scalars['URL']>>>;
  xtmUrl: Scalars['URL'];
};

export type Customer = {
  __typename?: 'Customer';
  id: Scalars['ID'];
  name: Scalars['String'];
  agencyId: Scalars['Int'];
};

export type CvUploadAddress = {
  __typename?: 'CvUploadAddress';
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  subRegion?: Maybe<CvUploadCode>;
  region?: Maybe<CvUploadCode>;
  country?: Maybe<CvUploadCode>;
};

export type CvUploadCode = {
  __typename?: 'CvUploadCode';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CvUploadCourse = {
  __typename?: 'CvUploadCourse';
  courseName?: Maybe<Scalars['String']>;
  institute?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  country?: Maybe<CvUploadCode>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};

export type CvUploadCurrentWorkField = {
  __typename?: 'CvUploadCurrentWorkField';
  workFieldCode?: Maybe<Scalars['String']>;
  workFieldDescription?: Maybe<Scalars['String']>;
  experienceLevelCode?: Maybe<Scalars['String']>;
  experienceLevelDescription?: Maybe<Scalars['String']>;
};

export type CvUploadDegree = {
  __typename?: 'CvUploadDegree';
  degreeName?: Maybe<Scalars['String']>;
  localCode?: Maybe<Scalars['String']>;
  localDescription?: Maybe<Scalars['String']>;
  internationalCode?: Maybe<Scalars['String']>;
  inernationalDescription?: Maybe<Scalars['String']>;
  institute?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  country?: Maybe<CvUploadCode>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  diplomaCode?: Maybe<Scalars['String']>;
  diplomaDescription?: Maybe<Scalars['String']>;
  gradePointAverage?: Maybe<Scalars['String']>;
};

export type CvUploadDriversLicense = {
  __typename?: 'CvUploadDriversLicense';
  name?: Maybe<Scalars['String']>;
};

export type CvUploadEducationHistory = {
  __typename?: 'CvUploadEducationHistory';
  degrees?: Maybe<Array<Maybe<CvUploadDegree>>>;
  courses?: Maybe<Array<Maybe<CvUploadCourse>>>;
};

export type CvUploadEmail = {
  __typename?: 'CvUploadEmail';
  /** #logged-out #soft-logged-in */
  email?: Maybe<Scalars['String']>;
};

export type CvUploadEmploymentHistory = {
  __typename?: 'CvUploadEmploymentHistory';
  jobTitle?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  country?: Maybe<CvUploadCode>;
  professionCode?: Maybe<Scalars['String']>;
  professionDescription?: Maybe<Scalars['String']>;
  professionGroupCode?: Maybe<Scalars['String']>;
  professionGroupDescription?: Maybe<Scalars['String']>;
  professionClassCode?: Maybe<Scalars['String']>;
  professionClassDescription?: Maybe<Scalars['String']>;
  oNET2019Code?: Maybe<Scalars['String']>;
  oNET2019Description?: Maybe<Scalars['String']>;
  iSCO2008Code?: Maybe<Scalars['String']>;
  iSCO2008Description?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  years?: Maybe<Scalars['String']>;
  months?: Maybe<Scalars['String']>;
  isLatestExperience?: Maybe<Scalars['String']>;
  isCurrentExperience?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CvUploadError = {
  __typename?: 'CvUploadError';
  message?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CvUploadHighestDegree = {
  __typename?: 'CvUploadHighestDegree';
  localCode?: Maybe<Scalars['String']>;
  localDescription?: Maybe<Scalars['String']>;
  internationalCode?: Maybe<Scalars['String']>;
  internationalDescription?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};

export type CvUploadHobby = {
  __typename?: 'CvUploadHobby';
  hobby?: Maybe<Scalars['String']>;
};

export type CvUploadLanguageSkill = {
  __typename?: 'CvUploadLanguageSkill';
  skillCode?: Maybe<Scalars['String']>;
  skillDescription?: Maybe<Scalars['String']>;
  levelCode?: Maybe<Scalars['String']>;
  levelDescription?: Maybe<Scalars['String']>;
  years?: Maybe<Scalars['String']>;
  lastUsed?: Maybe<Scalars['String']>;
};

export type CvUploadOther = {
  __typename?: 'CvUploadOther';
  hobbies?: Maybe<Array<Maybe<CvUploadHobby>>>;
  profilePicture?: Maybe<CvUploadProfilePicture>;
};

export type CvUploadParsedCv = {
  __typename?: 'CvUploadParsedCv';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this parsed_cv originates from */
  source?: Maybe<Scalars['URN']>;
  /** A string identifying the conceptual user flow from which a parsed_cv originates. While one job-posting could be the source (See above), there might be different used-flows that lead to the creation of a parsed_cv. */
  flowIdentifier?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  textkernelPayload?: Maybe<CvUploadParsedCvTextkernelPayload>;
};

export type CvUploadParsedCvTextkernelPayload = {
  __typename?: 'CvUploadParsedCvTextkernelPayload';
  lang?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  personal?: Maybe<CvUploadPersonal>;
  summary?: Maybe<CvUploadSummary>;
  educationHistory?: Maybe<CvUploadEducationHistory>;
  employmentHistory?: Maybe<Array<Maybe<CvUploadEmploymentHistory>>>;
  skills?: Maybe<CvUploadSkills>;
  other?: Maybe<CvUploadOther>;
};

export type CvUploadPersonal = {
  __typename?: 'CvUploadPersonal';
  /** #logged-out #soft-logged-in */
  firstName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  middleName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  lastName?: Maybe<Scalars['String']>;
  completeName?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  nationality?: Maybe<CvUploadCode>;
  gender?: Maybe<CvUploadCode>;
  driversLicenses?: Maybe<Array<Maybe<CvUploadDriversLicense>>>;
  address?: Maybe<CvUploadAddress>;
  phones?: Maybe<Array<Maybe<CvUploadPhone>>>;
  /** #logged-out #soft-logged-in */
  emails?: Maybe<Array<Maybe<CvUploadEmail>>>;
  personalUrls?: Maybe<Array<Maybe<CvUploadPersonalUrl>>>;
};

export type CvUploadPersonalUrl = {
  __typename?: 'CvUploadPersonalUrl';
  url?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CvUploadPhone = {
  __typename?: 'CvUploadPhone';
  number?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CvUploadProfilePicture = {
  __typename?: 'CvUploadProfilePicture';
  base64Content?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
};

export type CvUploadSkill = {
  __typename?: 'CvUploadSkill';
  skill?: Maybe<Scalars['String']>;
  skillCode?: Maybe<Scalars['String']>;
  skillDescription?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  years?: Maybe<Scalars['String']>;
  lastUsed?: Maybe<Scalars['String']>;
};

export type CvUploadSkills = {
  __typename?: 'CvUploadSkills';
  computerSkills?: Maybe<Array<Maybe<CvUploadSkill>>>;
  languageSkills?: Maybe<Array<Maybe<CvUploadLanguageSkill>>>;
  softSkills?: Maybe<Array<Maybe<CvUploadSkill>>>;
  otherSkills?: Maybe<Array<Maybe<CvUploadSkill>>>;
};

export type CvUploadSummary = {
  __typename?: 'CvUploadSummary';
  totalExperienceYears?: Maybe<Scalars['String']>;
  totalExperienceMonths?: Maybe<Scalars['String']>;
  currentJob?: Maybe<Scalars['String']>;
  currentEmployer?: Maybe<Scalars['String']>;
  currentWorkField?: Maybe<CvUploadCurrentWorkField>;
  highestDegree?: Maybe<CvUploadHighestDegree>;
  summaryAmbitionSection?: Maybe<Scalars['String']>;
  extraCurricularSection?: Maybe<Scalars['String']>;
};

export type DataScienceCompactTrackingInput = {
  source: TrackingSource;
  messages: Array<CompactTrackingInput>;
};

export type DataScienceFullTrackingInput = {
  source: TrackingSource;
  messages: Array<FullTrackingInput>;
};

export type DataSharingExclusionInput = {
  id: Scalars['ID'];
  type: DataSharingExclusionType;
};

export type DataSharingExclusionMutationError = {
  __typename?: 'DataSharingExclusionMutationError';
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type DataSharingExclusionMutationResult = {
  __typename?: 'DataSharingExclusionMutationResult';
  error?: Maybe<DataSharingExclusionMutationError>;
  response?: Maybe<DataSharingVisibilityExclusion>;
};

export enum DataSharingExclusionType {
  PrivateData = 'PRIVATE_DATA',
  BusinessData = 'BUSINESS_DATA',
  DateOfBirth = 'DATE_OF_BIRTH'
}

export type DataSharingSettings = {
  __typename?: 'DataSharingSettings';
  /** User setting for visibility of private profile data for other users */
  privateDataVisibility?: Maybe<SelectSetting>;
  /** User setting for visibility of business profile data for other users */
  businessDataVisibility?: Maybe<SelectSetting>;
  /** User setting for visibility of birth date for other users */
  dateOfBirthVisibility?: Maybe<SelectSetting>;
  /** User setting for visibility of year of birth (= age) for other users */
  yearOfBirthVisibility?: Maybe<ToggleSetting>;
  /**
   * #rest #virtual
   *
   *  Blacklist of contacts for visibility of private profile data
   */
  privateDataVisibilityExclusions?: Maybe<DataSharingVisibilityExclusions>;
  /**
   * #rest #virtual
   *
   *  Blacklist of contacts for visibility of business profile data
   */
  businessDataVisibilityExclusions?: Maybe<DataSharingVisibilityExclusions>;
  /**
   * #rest #virtual
   *
   *  Blacklist of contacts for visibility of birth date
   */
  birthDateVisibilityExclusions?: Maybe<DataSharingVisibilityExclusions>;
};

export type DataSharingSettingsInput = {
  privateDataVisibility?: Maybe<SelectSettingInput>;
  businessDataVisibility?: Maybe<SelectSettingInput>;
  dateOfBirthVisibility?: Maybe<SelectSettingInput>;
  yearOfBirthVisibility?: Maybe<ToggleSettingInput>;
};

export type DataSharingSettingsMutationResult = {
  __typename?: 'DataSharingSettingsMutationResult';
  error?: Maybe<DataSharingSettings>;
  response?: Maybe<DataSharingSettings>;
};

export type DataSharingVisibilityExclusion = {
  __typename?: 'DataSharingVisibilityExclusion';
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type DataSharingVisibilityExclusions = {
  __typename?: 'DataSharingVisibilityExclusions';
  collection?: Maybe<Array<DataSharingVisibilityExclusion>>;
};


export type DateCustomQuestion = BaseApplyQuestion & {
  __typename?: 'DateCustomQuestion';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

export type DateRange = {
  __typename?: 'DateRange';
  /** #logged-out #soft-logged-in */
  to?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  from: Scalars['Date'];
};

export type DeactivationSetting = {
  __typename?: 'DeactivationSetting';
  errors?: Maybe<Array<Scalars['String']>>;
};

export type DeactivationSettingInput = {
  passwordToken: Scalars['String'];
  /** when the deactivated account should be automatically reactivated */
  reactivateAfter: Scalars['Date'];
};

export type DeleteCareerLevelPreferenceError = {
  __typename?: 'DeleteCareerLevelPreferenceError';
  /**
   * #logged-out #soft-logged-in
   *
   *  tells what went wrong
   */
  message?: Maybe<Scalars['String']>;
};

/** Result type for deleting career level preference that returns 200 on success */
export type DeleteCareerLevelPreferenceResult = DeleteCareerLevelPreferenceSuccess | DeleteCareerLevelPreferenceError;

export type DeleteCareerLevelPreferenceSuccess = {
  __typename?: 'DeleteCareerLevelPreferenceSuccess';
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['String']>;
};

export type DeleteCompanyRecommendationError = {
  __typename?: 'DeleteCompanyRecommendationError';
  message?: Maybe<Scalars['String']>;
};

export type DeleteCompanyRecommendationInput = {
  companyId: Scalars['ID'];
};

export type DeleteCompanyRecommendationResult = {
  __typename?: 'DeleteCompanyRecommendationResult';
  error?: Maybe<DeleteCompanyRecommendationError>;
};

export type DeleteLocationsPreferenceError = {
  __typename?: 'DeleteLocationsPreferenceError';
  /**
   * #logged-out #soft-logged-in
   *
   *  tells what went wrong
   */
  message?: Maybe<Scalars['String']>;
};

/** Result type for deleting locations preference that returns 200 on success */
export type DeleteLocationsPreferenceResult = DeleteLocationsPreferenceSuccess | DeleteLocationsPreferenceError;

export type DeleteLocationsPreferenceSuccess = {
  __typename?: 'DeleteLocationsPreferenceSuccess';
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['String']>;
};

export type DeleteLoginSessionError = {
  __typename?: 'DeleteLoginSessionError';
  message?: Maybe<Scalars['String']>;
};

export type DeleteLoginSessionInput = {
  sessionId: Scalars['ID'];
};

export type DeleteLoginSessionPayload = {
  __typename?: 'DeleteLoginSessionPayload';
  error?: Maybe<DeleteLoginSessionError>;
};

export type DeleteMessengerChatInput = {
  id: Scalars['ID'];
};

export type DeleteMessengerChatParticipantError = {
  __typename?: 'DeleteMessengerChatParticipantError';
  message: Scalars['String'];
};

export type DeleteMessengerChatParticipantInput = {
  userId: Scalars['ID'];
  chatId: Scalars['ID'];
};

export type DeleteMessengerChatParticipantResult = DeleteMessengerChatParticipantSuccess | DeleteMessengerChatParticipantError;

export type DeleteMessengerChatParticipantSuccess = {
  __typename?: 'DeleteMessengerChatParticipantSuccess';
  success: Scalars['Boolean'];
};

export type DeleteMessengerChatResult = {
  __typename?: 'DeleteMessengerChatResult';
  error?: Maybe<DeleteMessengerChatResultError>;
};

export type DeleteMessengerChatResultError = {
  __typename?: 'DeleteMessengerChatResultError';
  message: Scalars['String'];
};

export type DeleteMessengerMessageTemplateError = {
  __typename?: 'DeleteMessengerMessageTemplateError';
  message: Scalars['String'];
};

export type DeleteMessengerMessageTemplateInput = {
  id: Scalars['ID'];
};

export type DeleteMessengerMessageTemplateResult = DeleteMessengerMessageTemplateSuccess | DeleteMessengerMessageTemplateError;

export type DeleteMessengerMessageTemplateSuccess = {
  __typename?: 'DeleteMessengerMessageTemplateSuccess';
  success: Scalars['Boolean'];
};

export type DeletePendingEmailPayload = {
  __typename?: 'DeletePendingEmailPayload';
  error?: Maybe<Scalars['String']>;
};

export type DeletePendingPhonePayload = {
  __typename?: 'DeletePendingPhonePayload';
  error?: Maybe<Scalars['String']>;
};

export type DeleteSalaryExpectationsPreferenceError = {
  __typename?: 'DeleteSalaryExpectationsPreferenceError';
  /**
   * #logged-out #soft-logged-in
   *
   *  tells what went wrong
   */
  message?: Maybe<Scalars['String']>;
};

/** Result type for deleting salary expectations preference that returns 200 on success */
export type DeleteSalaryExpectationsPreferenceResult = DeleteSalaryExpectationsPreferenceSuccess | DeleteSalaryExpectationsPreferenceError;

export type DeleteSalaryExpectationsPreferenceSuccess = {
  __typename?: 'DeleteSalaryExpectationsPreferenceSuccess';
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['String']>;
};

export type DeleteScheduledMessageInput = {
  id: Scalars['ID'];
};

export type DeleteUserConnectionsResult = {
  __typename?: 'DeleteUserConnectionsResult';
  error?: Maybe<ErrorResponse>;
};

export type DeleteXwsSessionError = {
  __typename?: 'DeleteXwsSessionError';
  message?: Maybe<Scalars['String']>;
};

export type DeleteXwsSessionInput = {
  id: Scalars['ID'];
};

export type DeleteXwsSessionPayload = {
  __typename?: 'DeleteXwsSessionPayload';
  error?: Maybe<DeleteXwsSessionError>;
};

export type DeletedUserConnectionData = {
  __typename?: 'DeletedUserConnectionData';
  deleted: Scalars['Boolean'];
};

export type DeletionReasonSettingInput = {
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
};

export type DeletionReasons = {
  __typename?: 'DeletionReasons';
  id: Scalars['ID'];
  isTextField: Scalars['Boolean'];
  label: Scalars['String'];
  orderId: Scalars['ID'];
  placeHolder?: Maybe<Scalars['String']>;
};

export type DeletionSetting = {
  __typename?: 'DeletionSetting';
  errors?: Maybe<Array<Scalars['String']>>;
};

export type DeletionSettingInput = {
  /** To prevent accidental deletion of the wrong user, we also pass the id of the user to delete manually */
  userId: Scalars['ID'];
  /** user needs to confirm the action using password. see createPasswordProtectedSettingToken in login.graphql */
  passwordToken: Scalars['String'];
  /** list of reasons the user is closing their account */
  reasons?: Maybe<Array<Maybe<DeletionReasonSettingInput>>>;
  /** optionally, user can give his email upon deletion to facilitate the communication with user care */
  goodbyeEmail?: Maybe<Scalars['Email']>;
};

export type DeviceTrackingInput = {
  /** Represents unique mobile device id, such as IMEI but not limited to. */
  id: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type DirectConection = {
  __typename?: 'DirectConection';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /** #logged-out #soft-logged-in */
  recruiterInsights?: Maybe<NetworkRecruiterInsights>;
};

export type DirectConnectionsCollection = {
  __typename?: 'DirectConnectionsCollection';
  /** #logged-out #soft-logged-in */
  collection?: Maybe<Array<Maybe<DirectConection>>>;
};

export type DirectDebitData = BpayPaymentMethodData & {
  __typename?: 'DirectDebitData';
  maskedIban?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  holder?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  clientName: Scalars['String'];
};

export type DirectDebitDataError = {
  __typename?: 'DirectDebitDataError';
  iban?: Maybe<TextSetting>;
  accountHolder?: Maybe<TextSetting>;
  tandc?: Maybe<ToggleSetting>;
};

/** Discipline localized */
export type Discipline = Localizable & {
  __typename?: 'Discipline';
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
};

/** DisciplinesPreference Type */
export type DisciplinesPreference = {
  __typename?: 'DisciplinesPreference';
  disciplineIds: Array<Maybe<Scalars['ID']>>;
};

export type DiscoActivitiesEdge = PaginationEdge & {
  __typename?: 'DiscoActivitiesEdge';
  node?: Maybe<DiscoActivity>;
  /** #virtual */
  cursor: Scalars['String'];
};

export type DiscoActivity = HasOperationalDataTrackingTokens & HasNewWorkTrackingToken & {
  __typename?: 'DiscoActivity';
  activityId: Scalars['ID'];
  activityType: Scalars['String'];
  createdAt: Scalars['Date'];
  message?: Maybe<Scalars['String']>;
  share?: Maybe<Scalars['Boolean']>;
  reshare?: Maybe<Scalars['Boolean']>;
  targetUrn?: Maybe<Scalars['GlobalID']>;
  /** @deprecated WILL BE REMOVED ... Use permissions.repotable */
  reportable?: Maybe<Scalars['Boolean']>;
  permissions?: Maybe<DiscoActivityPermissions>;
  contextUrn?: Maybe<Scalars['GlobalID']>;
  contextId?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  actor?: Maybe<DiscoActor>;
  /** #rest #virtual */
  object?: Maybe<DiscoObject>;
  /** #rest(batched) #virtual */
  interactionTarget?: Maybe<SocialInteractionTarget>;
  shareableUrl?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  socialShare?: Maybe<SocialShareResult>;
  /** #rest #virtual */
  socialProofComment?: Maybe<SocialCommentResult>;
  /** @deprecated [DISCO-2204] Deprecated, use `preHeader` instead. */
  discoSocialPreheader?: Maybe<DiscoItemPreheader>;
  preHeader?: Maybe<DiscoItemGenericPreHeader>;
  metaHeadline?: Maybe<DiscoMetaHeadline>;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type DiscoActivityCollection = {
  __typename?: 'DiscoActivityCollection';
  collection?: Maybe<Array<Maybe<DiscoActivity>>>;
};

export type DiscoActivityConnection = HasCursorPagination & {
  __typename?: 'DiscoActivityConnection';
  edges?: Maybe<Array<Maybe<DiscoActivitiesEdge>>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type DiscoActivityPermissions = {
  __typename?: 'DiscoActivityPermissions';
  reportable?: Maybe<Scalars['Boolean']>;
  deletable?: Maybe<Scalars['Boolean']>;
  editable?: Maybe<Scalars['Boolean']>;
};

/** This union enlists the actor types supported by disco-modules */
export type DiscoActor = Company | ContentInsiderPage | ContentPage | EntityPage | XingId | Community | GroupsGroup;

export type DiscoBasicHeader = DiscoModuleInfo & {
  __typename?: 'DiscoBasicHeader';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  routingUrn?: Maybe<Scalars['GlobalID']>;
  topicId?: Maybe<Scalars['ID']>;
};

export type DiscoCompaniesInTopicModule = DiscoModule & {
  __typename?: 'DiscoCompaniesInTopicModule';
  dataSource: Scalars['String'];
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoCompaniesInTopicModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

export type DiscoCompaniesModule = DiscoModule & HasOperationalDataTrackingTokens & HasNewWorkTrackingToken & {
  __typename?: 'DiscoCompaniesModule';
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoCompaniesModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

export type DiscoCompanyRecommendation = Recommendation & {
  __typename?: 'DiscoCompanyRecommendation';
  trackingToken: Scalars['String'];
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
  /** #rest(batched) #virtual */
  company?: Maybe<Company>;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type DiscoDeleteActivityError = {
  __typename?: 'DiscoDeleteActivityError';
  message?: Maybe<Scalars['String']>;
};

export type DiscoDeleteActivityInput = {
  id: Scalars['ID'];
};

export type DiscoDeleteActivityResult = DiscoDeleteActivitySuccess | DiscoDeleteActivityError;

export type DiscoDeleteActivitySuccess = {
  __typename?: 'DiscoDeleteActivitySuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type DiscoEntityStreamModule = DiscoModule & HasOperationalDataTrackingTokens & HasNewWorkTrackingToken & {
  __typename?: 'DiscoEntityStreamModule';
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoEntityStreamModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/**
 * It provides `DiscoModules` for Disco Entity Page Stream Page
 * based on their `rendering_types` and supports pagination. Use `first`, `first & after`, `last & before`
 * for forward/backward pagination.
 */
export type DiscoEntityStreamPage = {
  __typename?: 'DiscoEntityStreamPage';
  /** #paginated #rest #virtual */
  discoModulesPaginated?: Maybe<DiscoModulesConnection>;
};


/**
 * It provides `DiscoModules` for Disco Entity Page Stream Page
 * based on their `rendering_types` and supports pagination. Use `first`, `first & after`, `last & before`
 * for forward/backward pagination.
 */
export type DiscoEntityStreamPageDiscoModulesPaginatedArgs = {
  renderingTypes: Array<DiscoModuleRenderingType>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type DiscoEventRecoModule = DiscoModule & HasOperationalDataTrackingTokens & {
  __typename?: 'DiscoEventRecoModule';
  /**
   * #paginated
   * @deprecated Product not supported anymore
   */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoEventRecoModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/** List of supported `features` clients can ask for. */
export enum DiscoFeature {
  MultipleModulesOnNu = 'Multiple_Modules_on_NU',
  DiscoJobRecoType = 'DISCO_JOB_RECO_TYPE',
  JobRecoModule = 'JOB_RECO_MODULE',
  MultipleModulesOnInsights = 'MULTIPLE_MODULES_ON_INSIGHTS'
}

export type DiscoFollowerHeader = DiscoModuleInfo & {
  __typename?: 'DiscoFollowerHeader';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  routingUrn?: Maybe<Scalars['GlobalID']>;
  topicId?: Maybe<Scalars['ID']>;
};

/** **DiscoFromYourContactsModule** Returns activities which your contacts interacted with. */
export type DiscoFromYourContactsModule = DiscoModule & HasOperationalDataTrackingTokens & {
  __typename?: 'DiscoFromYourContactsModule';
  /**
   * #paginated
   * @deprecated [GC-1738] Product not supported anymore
   */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


/** **DiscoFromYourContactsModule** Returns activities which your contacts interacted with. */
export type DiscoFromYourContactsModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

export type DiscoHighlightsForYouModule = DiscoModule & HasOperationalDataTrackingTokens & {
  __typename?: 'DiscoHighlightsForYouModule';
  /**
   * #paginated
   * @deprecated [GC-1738] Product not supported anymore
   */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoHighlightsForYouModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

export type DiscoIndustryPageRecommendation = Recommendation & {
  __typename?: 'DiscoIndustryPageRecommendation';
  trackingToken: Scalars['String'];
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
  /** #rest(batched) #virtual */
  discoPage?: Maybe<ContentPage>;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type DiscoInsiderPageRecommendation = Recommendation & {
  __typename?: 'DiscoInsiderPageRecommendation';
  trackingToken: Scalars['String'];
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
  /** #rest(batched) #virtual */
  discoPage?: Maybe<ContentInsiderPage>;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type DiscoInsidersInTopicModule = DiscoModule & {
  __typename?: 'DiscoInsidersInTopicModule';
  dataSource: Scalars['String'];
  /**
   * #paginated
   * @deprecated [GC-1738] Product not supported anymore
   */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoInsidersInTopicModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

export type DiscoInterestingInTopicModule = DiscoModule & HasOperationalDataTrackingTokens & {
  __typename?: 'DiscoInterestingInTopicModule';
  /**
   * #paginated
   * @deprecated [GC-1738] Product not supported anymore
   */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoInterestingInTopicModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/** List of supported items for `discoModules`. */
export type DiscoItem = DiscoJobRecommendation | JobRecommendation | EventRecommendation | MymkRecommendation | PersonMakeFriend | DiscoNewsArticleRecommendation | DiscoPublicPostRecommendation | DiscoTopicInfo | DiscoActivity | AuctionAdPlaceholder | DiscoCompanyRecommendation | DiscoPublisherPageRecommendation | DiscoInsiderPageRecommendation | DiscoIndustryPageRecommendation | DiscoProfileVisit | InsightsNavigationItem;

export type DiscoItemGenericPreHeader = DiscoPreHeaderUserLiker | DiscoPreHeaderUserCommenter | DiscoPreHeaderFollowedTopic | DiscoPreHeaderStaticHeader;

export type DiscoItemPreheader = UserLiker | UserCommenter;

/** `DiscoItemsConnection` is used to map `disco-modules` with pagination */
export type DiscoItemsConnection = HasCursorPagination & {
  __typename?: 'DiscoItemsConnection';
  total: Scalars['Int'];
  requestTrackingToken?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<DiscoItemsEdge>>>;
  /** @deprecated [DISCO-2371][GC-1723] Will be removed after 01.10.2022. Use DiscoNetworkUpdatePage.discoModulesPaginated.adPositions */
  adPositions?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type DiscoItemsEdge = PaginationEdge & {
  __typename?: 'DiscoItemsEdge';
  cursor: Scalars['String'];
  node: DiscoItem;
};

export type DiscoJobRecoModule = DiscoModule & HasOperationalDataTrackingTokens & {
  __typename?: 'DiscoJobRecoModule';
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoJobRecoModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

export type DiscoJobRecommendation = Recommendation & {
  __typename?: 'DiscoJobRecommendation';
  /** ITJFM (Is This Job For Me) score */
  itjfmScore?: Maybe<IsThisJobForMeScore>;
  /** #rest(batched) #virtual */
  job?: Maybe<JobResult>;
  /** #rest(batched) #virtual */
  interactionTarget?: Maybe<SocialInteractionTarget>;
  reportable?: Maybe<Scalars['Boolean']>;
  preHeader?: Maybe<DiscoItemGenericPreHeader>;
  trackingToken: Scalars['String'];
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
};

export type DiscoLogging = {
  __typename?: 'DiscoLogging';
  status?: Maybe<Scalars['String']>;
};

export type DiscoLoggingInput = {
  platform?: Maybe<DiscoPlatform>;
  payload?: Maybe<Array<Maybe<DiscoLoggingPayload>>>;
};

export type DiscoLoggingPayload = {
  reason: DiscoLoggingReason;
  disco_section: Scalars['String'];
  disco_module: Scalars['String'];
  unsupported_type?: Maybe<Scalars['String']>;
  item_urn?: Maybe<Scalars['String']>;
  nullable_field?: Maybe<Scalars['String']>;
  consumer?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export enum DiscoLoggingReason {
  NullableField = 'NULLABLE_FIELD',
  NullableModule = 'NULLABLE_MODULE',
  UnsupportedType = 'UNSUPPORTED_TYPE'
}

export type DiscoMeFeedModule = DiscoModule & HasOperationalDataTrackingTokens & HasNewWorkTrackingToken & {
  __typename?: 'DiscoMeFeedModule';
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoMeFeedModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/**
 * It provides `DiscoModules` for Disco Me Feed Page
 * based on their `rendering_types` and supports pagination. Use `first`, `first & after`, `last & before`
 * for forward/backward pagination.
 */
export type DiscoMeFeedPage = {
  __typename?: 'DiscoMeFeedPage';
  /** #paginated #rest #virtual */
  discoModulesPaginated?: Maybe<DiscoModulesConnection>;
};


/**
 * It provides `DiscoModules` for Disco Me Feed Page
 * based on their `rendering_types` and supports pagination. Use `first`, `first & after`, `last & before`
 * for forward/backward pagination.
 */
export type DiscoMeFeedPageDiscoModulesPaginatedArgs = {
  renderingTypes: Array<DiscoModuleRenderingType>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type DiscoMetaHeadline = {
  __typename?: 'DiscoMetaHeadline';
  routingUrn?: Maybe<Scalars['GlobalID']>;
  text: Scalars['String'];
};

/**
 * **DiscoModule** interface describes the list of supported `rendering_types`.
 * `rendering_types` required modules types. `info` inforation about the module.
 * `items` is a collection with data for different modules.
 */
export type DiscoModule = {
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
  /** #paginated */
  paginatedItems?: Maybe<DiscoItemsConnection>;
};


/**
 * **DiscoModule** interface describes the list of supported `rendering_types`.
 * `rendering_types` required modules types. `info` inforation about the module.
 * `items` is a collection with data for different modules.
 */
export type DiscoModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/** **DiscoModuleInfo** consists of the title and the description of `discoModule` */
export type DiscoModuleInfo = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  routingUrn?: Maybe<Scalars['GlobalID']>;
  topicId?: Maybe<Scalars['ID']>;
};

/** List of supported `rendering_types`. */
export enum DiscoModuleRenderingType {
  TypeA = 'Type_A',
  TypeB = 'Type_B',
  TypeC = 'Type_C'
}

export type DiscoModulesConnection = HasCursorPagination & {
  __typename?: 'DiscoModulesConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  requestTrackingToken?: Maybe<Scalars['String']>;
  edges?: Maybe<Array<Maybe<DiscoModulesEdge>>>;
  adPositions?: Maybe<Array<Maybe<Scalars['Int']>>>;
  adTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DiscoModulesEdge = PaginationEdge & {
  __typename?: 'DiscoModulesEdge';
  cursor: Scalars['String'];
  node: DiscoModule;
};

export type DiscoMymkRecoModule = DiscoModule & HasOperationalDataTrackingTokens & {
  __typename?: 'DiscoMymkRecoModule';
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoMymkRecoModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

export type DiscoNetworkNewsModule = DiscoModule & HasOperationalDataTrackingTokens & HasNewWorkTrackingToken & {
  __typename?: 'DiscoNetworkNewsModule';
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoNetworkNewsModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/**
 * It provides `DiscoModules` for Disco Network Update Page
 * based on their `rendering_types` and supports pagination. Use `first`, `first & after`, `last & before`
 * for forward/backward pagination.
 */
export type DiscoNetworkUpdatePage = {
  __typename?: 'DiscoNetworkUpdatePage';
  /** #paginated #rest #virtual */
  discoModulesPaginated?: Maybe<DiscoModulesConnection>;
};


/**
 * It provides `DiscoModules` for Disco Network Update Page
 * based on their `rendering_types` and supports pagination. Use `first`, `first & after`, `last & before`
 * for forward/backward pagination.
 */
export type DiscoNetworkUpdatePageDiscoModulesPaginatedArgs = {
  renderingTypes: Array<DiscoModuleRenderingType>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

export type DiscoNetworkUpdateWidget = {
  __typename?: 'DiscoNetworkUpdateWidget';
  items?: Maybe<DiscoActivityCollection>;
  /** #paginated */
  paginatedItems?: Maybe<DiscoActivityConnection>;
};


export type DiscoNetworkUpdateWidgetPaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type DiscoNewsArticleRecommendation = Recommendation & {
  __typename?: 'DiscoNewsArticleRecommendation';
  trackingToken: Scalars['String'];
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
  /** #rest(batched) #virtual */
  contentArticle?: Maybe<ContentArticle>;
  /** #rest(batched) #virtual */
  interactionTarget?: Maybe<SocialInteractionTarget>;
  activityId: Scalars['ID'];
  targetUrn?: Maybe<Scalars['GlobalID']>;
  reportable?: Maybe<Scalars['Boolean']>;
  /** @deprecated [DISCO-2888] Feedy-styled detailed view url will be gone in Jan 2023 */
  shareableUrl?: Maybe<Scalars['String']>;
  /** @deprecated [DISCO-2204] Deprecated, use `preHeader` instead. */
  discoSocialPreheader?: Maybe<DiscoItemPreheader>;
  preHeader?: Maybe<DiscoItemGenericPreHeader>;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type DiscoNewsArticlesModule = DiscoModule & HasOperationalDataTrackingTokens & HasNewWorkTrackingToken & {
  __typename?: 'DiscoNewsArticlesModule';
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoNewsArticlesModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/** **DiscoNewsInsidersModule** can return DiscoInsiderPageRecommendation. */
export type DiscoNewsInsidersModule = DiscoModule & HasOperationalDataTrackingTokens & HasNewWorkTrackingToken & {
  __typename?: 'DiscoNewsInsidersModule';
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


/** **DiscoNewsInsidersModule** can return DiscoInsiderPageRecommendation. */
export type DiscoNewsInsidersModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/**
 * **DiscoNewsPublisherModule** can return DiscoIndustryPageRecommendation,
 * DiscoInsiderPageRecommendation and DiscoPublisherPageRecommendation depending on what
 * is passed in pageTypes field e.g. insider, industry, press_review, topic and publisher.
 */
export type DiscoNewsPublisherModule = DiscoModule & HasOperationalDataTrackingTokens & HasNewWorkTrackingToken & {
  __typename?: 'DiscoNewsPublisherModule';
  /**
   * #paginated #rest #virtual
   * @deprecated use field `paginatedItems`. WILL BE REMOVED: 1 Dec 2022
   */
  pages?: Maybe<DiscoItemsConnection>;
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


/**
 * **DiscoNewsPublisherModule** can return DiscoIndustryPageRecommendation,
 * DiscoInsiderPageRecommendation and DiscoPublisherPageRecommendation depending on what
 * is passed in pageTypes field e.g. insider, industry, press_review, topic and publisher.
 */
export type DiscoNewsPublisherModulePagesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
  pageTypes?: Maybe<Array<Maybe<ContentPageType>>>;
};


/**
 * **DiscoNewsPublisherModule** can return DiscoIndustryPageRecommendation,
 * DiscoInsiderPageRecommendation and DiscoPublisherPageRecommendation depending on what
 * is passed in pageTypes field e.g. insider, industry, press_review, topic and publisher.
 */
export type DiscoNewsPublisherModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/** **DiscoNewsPublishersTopicsModule** can return DiscoIndustryPageRecommendation and DiscoPublisherPageRecommendation. */
export type DiscoNewsPublishersTopicsModule = DiscoModule & HasOperationalDataTrackingTokens & HasNewWorkTrackingToken & {
  __typename?: 'DiscoNewsPublishersTopicsModule';
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


/** **DiscoNewsPublishersTopicsModule** can return DiscoIndustryPageRecommendation and DiscoPublisherPageRecommendation. */
export type DiscoNewsPublishersTopicsModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/** This union enlists the object types supported by disco-modules */
export type DiscoObject = DiscoSharedObject | ArticlesArticle | ContentArticle | EntityPage | Event | PostingsPosting | SocialExternalLinkResult | VisibleJob | DiscoXingIdObject | ProfileUpdatePhoto | ProfileHavesUpdate | ProfileUpdateStatus | ProfileWorkExperienceUpdate | CompanyAnniversaryStory | CoverImageUpdate;

export type DiscoPersonMakeFriendModule = DiscoModule & HasOperationalDataTrackingTokens & {
  __typename?: 'DiscoPersonMakeFriendModule';
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoPersonMakeFriendModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

export enum DiscoPlatform {
  Web = 'WEB',
  Android = 'ANDROID',
  Ios = 'IOS',
  Unknown = 'UNKNOWN'
}

export type DiscoPreHeaderFollowedTopic = {
  __typename?: 'DiscoPreHeaderFollowedTopic';
  preHeaderType: Scalars['String'];
  routingUrn?: Maybe<Scalars['GlobalID']>;
  topicId: Scalars['ID'];
  /** @deprecated [DISCO-2647] Product not supported anymore */
  discoTopicMetadata?: Maybe<DiscoTopicMetadata>;
};

export type DiscoPreHeaderStaticHeader = {
  __typename?: 'DiscoPreHeaderStaticHeader';
  preHeaderType: Scalars['String'];
  routingUrn?: Maybe<Scalars['GlobalID']>;
  headerText: Scalars['String'];
};

export type DiscoPreHeaderUserCommenter = {
  __typename?: 'DiscoPreHeaderUserCommenter';
  preHeaderType: Scalars['String'];
  routingUrn?: Maybe<Scalars['GlobalID']>;
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
};

export type DiscoPreHeaderUserLiker = {
  __typename?: 'DiscoPreHeaderUserLiker';
  preHeaderType: Scalars['String'];
  routingUrn?: Maybe<Scalars['GlobalID']>;
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
};

export type DiscoProfileCompletion = HasOperationalDataTrackingTokens & {
  __typename?: 'DiscoProfileCompletion';
  showBanner: Scalars['Boolean'];
  targetUrl: Scalars['URL'];
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * Represents a visit of a profile.
 * Contains information about the user, reason and time of the visit
 */
export type DiscoProfileVisit = HasNewWorkTrackingToken & {
  __typename?: 'DiscoProfileVisit';
  /** ID of the profile visit. */
  id: Scalars['ID'];
  /** ID of the user who visited the profile. 0 for logged-out visits. */
  visitorId?: Maybe<Scalars['ID']>;
  /**
   * #rest(batched) #virtual
   *
   *  Fenced XingId representation of the profile visitor
   */
  profileVisitor?: Maybe<ProfileVisitor>;
  /** ISO 8601 Timestamp when the profile was visited. */
  viewedAt?: Maybe<Scalars['Date']>;
  /** Number of times the visitor visited the profile. */
  numberOfVisits?: Maybe<Scalars['Int']>;
  /**
   * Click reason (translation language complies with the first two letters of an Accept-Language request header,
   * which in Rails/Rack is internally represented as HTTP_ACCEPT_LANGUAGE and must be one of the valid languages
   * of a XING platform, falling back to German otherwise)
   */
  reasonHtml?: Maybe<Scalars['String']>;
  /** New VOMP message which contains click reason text resources and/or prioritized commonality text resource */
  label?: Maybe<Scalars['String']>;
  /** Additional payload of a profile visit containing information about recruiter status, company name and job title */
  payload: ProfileVisitPayload;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type DiscoPublicPostRecommendation = Recommendation & {
  __typename?: 'DiscoPublicPostRecommendation';
  /** #rest(batched) #virtual */
  actor?: Maybe<DiscoActor>;
  /** #rest(batched) #virtual */
  posting?: Maybe<PostingsPosting>;
  /** #rest(batched) #virtual */
  interactionTarget?: Maybe<SocialInteractionTarget>;
  activityId: Scalars['ID'];
  targetUrn?: Maybe<Scalars['GlobalID']>;
  reportable?: Maybe<Scalars['Boolean']>;
  /** @deprecated [DISCO-2888] Feedy-styled detailed view url will be gone in Jan 2023 */
  shareableUrl?: Maybe<Scalars['String']>;
  /** @deprecated [DISCO-2204] Deprecated, use `preHeader` instead. */
  discoSocialPreheader?: Maybe<DiscoItemPreheader>;
  preHeader?: Maybe<DiscoItemGenericPreHeader>;
  trackingToken: Scalars['String'];
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
};

export type DiscoPublisherPageRecommendation = Recommendation & {
  __typename?: 'DiscoPublisherPageRecommendation';
  trackingToken: Scalars['String'];
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
  /** #rest(batched) #virtual */
  discoPage?: Maybe<ContentPage>;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type DiscoPublishersInTopicModule = DiscoModule & {
  __typename?: 'DiscoPublishersInTopicModule';
  dataSource: Scalars['String'];
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoPublishersInTopicModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/** Disco representation of shared object from activities.. */
export type DiscoSharedObject = {
  __typename?: 'DiscoSharedObject';
  id?: Maybe<Scalars['ID']>;
  activityId?: Maybe<Scalars['ID']>;
  /** @deprecated renamed to activityId */
  originActivityId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  share?: Maybe<Scalars['Boolean']>;
  reshare?: Maybe<Scalars['Boolean']>;
  /** #rest(batched) #virtual */
  actor?: Maybe<DiscoActor>;
  /** #rest #virtual */
  object?: Maybe<DiscoObject>;
  /** #rest(batched) #virtual */
  interactionTarget?: Maybe<SocialInteractionTarget>;
  shareableUrl?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  socialShare?: Maybe<SocialShareResult>;
};

export type DiscoSimilarToTopicModule = DiscoModule & HasOperationalDataTrackingTokens & {
  __typename?: 'DiscoSimilarToTopicModule';
  /**
   * #paginated
   * @deprecated [GC-1738] Product not supported anymore
   */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoSimilarToTopicModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

export type DiscoTopicInfo = HasOperationalDataTrackingTokens & {
  __typename?: 'DiscoTopicInfo';
  topicId: Scalars['ID'];
  urn: Scalars['GlobalID'];
  /** @deprecated [DISCO-2647] Product not supported anymore */
  discoTopicMetadata?: Maybe<DiscoTopicMetadata>;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DiscoTopicMetadata = {
  __typename?: 'DiscoTopicMetadata';
  /** Topic metadata information in the user language */
  id: Scalars['ID'];
  abTestName?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  description: Scalars['String'];
  urn: Scalars['GlobalID'];
  /** #paginated #rest #virtual */
  followers?: Maybe<FollowersConnection>;
};


export type DiscoTopicMetadataFollowersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type DiscoTrendingObjectsModule = DiscoModule & HasOperationalDataTrackingTokens & {
  __typename?: 'DiscoTrendingObjectsModule';
  /**
   * #paginated
   * @deprecated [GC-1738] Product not supported anymore
   */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoTrendingObjectsModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

export type DiscoVompUpsellModule = DiscoModule & HasOperationalDataTrackingTokens & HasNewWorkTrackingToken & {
  __typename?: 'DiscoVompUpsellModule';
  /** #paginated #rest #virtual */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type DiscoVompUpsellModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/**
 * It is a proxy object which has the data of user (XingId) and shared contacts of
 * the requested user with the logged-in user. Used for users:user|share|users:user
 * activity type use case.
 */
export type DiscoXingIdObject = {
  __typename?: 'DiscoXingIdObject';
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  sharedContacts?: Maybe<SharedContacts>;
};

export type DismissCompanyAutoNotificationError = {
  __typename?: 'DismissCompanyAutoNotificationError';
  message?: Maybe<Scalars['String']>;
};

export type DismissCompanyAutoNotificationInput = {
  companyId: Scalars['SlugOrID'];
};

export type DismissCompanyAutoNotificationResult = {
  __typename?: 'DismissCompanyAutoNotificationResult';
  error?: Maybe<DismissCompanyAutoNotificationError>;
};

/** Display AD Module */
export type DisplayAdModule = ModuleInterface & {
  __typename?: 'DisplayAdModule';
  order: Scalars['Int'];
  title: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

/** Available legacy Display Flags */
export enum DisplayFlag {
  /** A user with Premium moderator membership */
  ModeratorPremium = 'MODERATOR_PREMIUM',
  /** A user with ProCoach membership */
  Procoach = 'PROCOACH',
  /** A user with premium membership */
  Premium = 'PREMIUM',
  /** A user with executive membership */
  Executive = 'EXECUTIVE',
  /** A user with insider role */
  Insider = 'INSIDER',
  /** A user with moderator role */
  Moderator = 'MODERATOR',
  /** A user with ambassador role */
  Ambassador = 'AMBASSADOR',
  /** Default user role and membership */
  Basic = 'BASIC'
}


export type DreamJobConsentInput = {
  consentTaken?: Maybe<Scalars['Boolean']>;
};

export type DreamJobDiscipline = {
  __typename?: 'DreamJobDiscipline';
  id?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
};

export type DreamJobIndusty = {
  __typename?: 'DreamJobIndusty';
  id?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
};

export type DreamJobInteractionInput = {
  jobId?: Maybe<Scalars['ID']>;
  jobType?: Maybe<DreamJobType>;
  interactionType?: Maybe<DreamJobInteractionType>;
};

export type DreamJobInteractionResult = {
  __typename?: 'DreamJobInteractionResult';
  jobId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['String']>;
};

export enum DreamJobInteractionType {
  Like = 'LIKE',
  Dislike = 'DISLIKE',
  Super = 'SUPER'
}

export type DreamJobItem = OccupiedJob | AvailableJob | TakenJob;

export type DreamJobSimilarMembers = {
  __typename?: 'DreamJobSimilarMembers';
  userId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  user?: Maybe<XingId>;
};

export type DreamJobSkills = {
  __typename?: 'DreamJobSkills';
  skill?: Maybe<Scalars['String']>;
};

export enum DreamJobType {
  Taken = 'TAKEN',
  Available = 'AVAILABLE'
}

export type DreamJobsCollection = {
  __typename?: 'DreamJobsCollection';
  userId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<DreamJobItem>>;
};

export type DreamJobsConsentFetchSuccess = {
  __typename?: 'DreamJobsConsentFetchSuccess';
  consentTaken?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['ID']>;
};

export type DreamJobsConsentSetSuccess = {
  __typename?: 'DreamJobsConsentSetSuccess';
  userId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type DreamJobsDeleteSuccess = {
  __typename?: 'DreamJobsDeleteSuccess';
  jobId?: Maybe<Scalars['ID']>;
  deletedAt?: Maybe<Scalars['String']>;
};

export type DreamJobsError = {
  __typename?: 'DreamJobsError';
  message?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['JSON']>;
};

export type DreamJobsOperationResult = DreamJobsDeleteSuccess | DreamJobsStoreSuccess | DreamJobsConsentFetchSuccess | DreamJobsConsentSetSuccess | DreamJobsError;

export type DreamJobsStoreSuccess = {
  __typename?: 'DreamJobsStoreSuccess';
  jobId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['String']>;
};

export type EasyApplication = {
  __typename?: 'EasyApplication';
  /**
   * #soft-logged-in
   * @deprecated Field no longer supported
   */
  easyApplyCallback?: Maybe<Scalars['URL']>;
};

export type EcommCompanyDetails = {
  __typename?: 'EcommCompanyDetails';
  /** #rest(batched) #virtual */
  company?: Maybe<Company>;
  companyId: Scalars['ID'];
  industryId: Scalars['ID'];
  countryCode: Scalars['String'];
};

export type EcommCompanyDetailsMutationInput = {
  companyId: Scalars['ID'];
  industryId: Scalars['ID'];
  countryCode: Scalars['String'];
};

export type EcommConfirmOrder = {
  __typename?: 'EcommConfirmOrder';
  isConfirmed: Scalars['Boolean'];
};

export type EcommContactDetails = {
  __typename?: 'EcommContactDetails';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  address: Scalars['String'];
  postcode: Scalars['Int'];
  city: Scalars['String'];
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  vatId?: Maybe<Scalars['String']>;
};

export type EcommContactDetailsMutationInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  address: Scalars['String'];
  postcode: Scalars['Int'];
  city: Scalars['String'];
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  vatId?: Maybe<Scalars['String']>;
};

export enum EcommCurrency {
  Eur = 'EUR',
  Chf = 'CHF'
}

export type EcommOrder = {
  __typename?: 'EcommOrder';
  /** #rest #virtual */
  product?: Maybe<EcommProduct>;
  productId: Scalars['ID'];
  productVariationId: Scalars['ID'];
  priceId: Scalars['ID'];
  quantity: Scalars['Int'];
  contractTerm: Scalars['Int'];
  totalAmountInCents: Scalars['Int'];
};

export type EcommOrderMutationInput = {
  productId: Scalars['String'];
  productVariationId: Scalars['String'];
  priceId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type EcommPaymentStatus = {
  __typename?: 'EcommPaymentStatus';
  isPaymentSet: Scalars['Boolean'];
};

export type EcommPreviousClient = {
  __typename?: 'EcommPreviousClient';
  b2bClientId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  address: Scalars['String'];
  postcode: Scalars['Int'];
  city: Scalars['String'];
  email: Scalars['String'];
  vatId?: Maybe<Scalars['String']>;
  clientName: Scalars['String'];
  country: Scalars['String'];
};

export type EcommPrice = {
  __typename?: 'EcommPrice';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  productVariationId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  valueInCents: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  currency: EcommCurrency;
};

export type EcommProduct = {
  __typename?: 'EcommProduct';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  recruiterType: EcommRecruiterType;
  /** #logged-out #soft-logged-in */
  paymentsProductIdentifier: EcommProductIdentifier;
  /** #logged-out #soft-logged-in */
  productVariations: Array<EcommProductVariation>;
};

export enum EcommProductIdentifier {
  XtmPro = 'XTM_PRO',
  XtmProStaffing = 'XTM_PRO_STAFFING',
  XtmStandard = 'XTM_STANDARD',
  XtmStandardStaffing = 'XTM_STANDARD_STAFFING'
}

export type EcommProductVariation = {
  __typename?: 'EcommProductVariation';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  productId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  companySize: Scalars['String'];
  /** #logged-out #soft-logged-in */
  prices: Array<EcommPrice>;
};

export enum EcommRecruiterType {
  Corporate = 'CORPORATE',
  Staffing = 'STAFFING'
}


export type EmailApplication = {
  __typename?: 'EmailApplication';
  /** #soft-logged-in */
  applyEmail?: Maybe<Scalars['Email']>;
};

export enum EmailFrequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

/** Active and pending email addresses */
export type EmailSetting = HasGlobalId & {
  __typename?: 'EmailSetting';
  /** current email address of the user */
  active?: Maybe<Scalars['Email']>;
  /** new email the user has submitted, not verified yet */
  pending?: Maybe<Scalars['Email']>;
  errors?: Maybe<Array<Scalars['String']>>;
  /** Globally unique id for this instance */
  globalId: Scalars['GlobalID'];
};

/** Used to set new email address */
export type EmailSettingInput = {
  /** new email address, will need to be verified */
  pending?: Maybe<Scalars['Email']>;
  /** token to confirm new email address, received via email */
  activationCode?: Maybe<Scalars['String']>;
  passwordToken?: Maybe<Scalars['String']>;
};

export type EmailSubscription = {
  __typename?: 'EmailSubscription';
  pageTitle?: Maybe<Scalars['String']>;
  pageId: Scalars['ID'];
  hasEmail?: Maybe<Scalars['Boolean']>;
};

export type EmailSubscriptions = {
  __typename?: 'EmailSubscriptions';
  collection?: Maybe<Array<Maybe<EmailSubscription>>>;
};

/** Embedding applications */
export enum EmbeddedBy {
  Ebp = 'EBP'
}

export type Employee = {
  __typename?: 'Employee';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  profileDetails?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  sharedContacts?: Maybe<SharedContacts>;
  /** #rest(batched) #virtual */
  contactDistance?: Maybe<ContactDistance>;
  /** #rest(batched) #virtual */
  networkRelationship?: Maybe<NetworkRelationship>;
};

/** EmployersPreference Type */
export type EmployersPreference = {
  __typename?: 'EmployersPreference';
  /** #rest(batched) #virtual */
  companies: Array<Maybe<Company>>;
};

/** Employment type localized */
export type EmploymentType = Localizable & {
  __typename?: 'EmploymentType';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
};

export type Empty = {
  __typename?: 'Empty';
  stub?: Maybe<Scalars['String']>;
};

export type EmptyOrErrorResponse = Empty | SearchAlertErrorResponse;

export type EntityCustomer = {
  __typename?: 'EntityCustomer';
  id: Scalars['ID'];
  customerId: Scalars['Int'];
  entityType: Scalars['String'];
  urn: Scalars['GlobalID'];
  /** #rest(batched) #virtual */
  customer?: Maybe<Customer>;
};

export type EntityCustomers = {
  __typename?: 'EntityCustomers';
  total?: Maybe<Scalars['Int']>;
  collection: Array<Maybe<EntityCustomer>>;
};

export type EntityDocument = {
  __typename?: 'EntityDocument';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  description: Scalars['String'];
  /** #logged-out #soft-logged-in */
  position: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  documentUrl: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  filename: Scalars['String'];
};

export type EntityDocumentConnection = HasCursorPagination & {
  __typename?: 'EntityDocumentConnection';
  /** #logged-out #soft-logged-in */
  edges?: Maybe<Array<Maybe<EntityDocumentEdge>>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
};

export type EntityDocumentEdge = PaginationEdge & {
  __typename?: 'EntityDocumentEdge';
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
  /** #logged-out #soft-logged-in */
  node: EntityDocument;
};

export type EntityDocumentResult = EntityDocumentConnection | EntityPageError;

export type EntityExternalVideo = {
  __typename?: 'EntityExternalVideo';
  /**
   * #logged-out #soft-logged-in
   *
   *  The signed URL of the scaled image
   */
  url?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  externalLink: Scalars['URL'];
};

export type EntityMedia = {
  __typename?: 'EntityMedia';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  enabled: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  position: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  media?: Maybe<EntityPageMedia>;
};


export type EntityMediaMediaArgs = {
  maxWidth?: Maybe<Scalars['Int']>;
  maxHeight?: Maybe<Scalars['Int']>;
};

export type EntityMediaConnection = HasCursorPagination & {
  __typename?: 'EntityMediaConnection';
  /** #logged-out #soft-logged-in */
  edges?: Maybe<Array<Maybe<EntityMediaEdge>>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
};

export type EntityMediaEdge = PaginationEdge & {
  __typename?: 'EntityMediaEdge';
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
  /** #logged-out #soft-logged-in */
  node: EntityMedia;
};

export type EntityMediaGalleryItemInput = {
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Boolean']>;
};

export type EntityMediaItemResult = EntityMedia | EntityPageError;

export type EntityMediaResult = EntityMediaConnection | EntityPageError;

export enum EntityMediaType {
  Image = 'IMAGE'
}

/** Entity Page representation */
export type EntityPage = HasGlobalId & {
  __typename?: 'EntityPage';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  slug: Scalars['String'];
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #expand #logged-out #soft-logged-in */
  contract: EntityPageContract;
  /** #logged-out #soft-logged-in #rest #virtual */
  modules?: Maybe<EntityPageModules>;
  /** #logged-out #soft-logged-in */
  focusType?: Maybe<EntityPageFocusType>;
  /** #logged-out #soft-logged-in */
  publicationStatus: EntityPagePublicationStatus;
  /** #expand #logged-out #soft-logged-in */
  context?: Maybe<EntityPageContext>;
  /** #logged-out #soft-logged-in */
  externalIds?: Maybe<Scalars['JSON']>;
  /** #logged-out #soft-logged-in */
  slogan?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   * @deprecated EntityPages no longer store information about the entity's owner. Use permissions for access control instead of roles
   */
  owner?: Maybe<XingId>;
  visibility?: Maybe<EntityPageVisibility>;
  /** #logged-out #soft-logged-in */
  links: EntityPageLinks;
  /** #logged-out #soft-logged-in #virtual */
  coverImage?: Maybe<Array<ScaledImage>>;
  /** #logged-out #soft-logged-in #virtual */
  originalCoverImage?: Maybe<Array<ScaledImage>>;
  /** #logged-out #soft-logged-in #virtual */
  logoImage?: Maybe<Array<ScaledImage>>;
  /** #logged-out #soft-logged-in #virtual */
  originalLogoImage?: Maybe<Array<ScaledImage>>;
  /**
   * #paginated #logged-out #soft-logged-in #rest #virtual
   *
   *  The list of the entity page followers
   * @deprecated The list of followers will now be accessible on the HeaderModule's content. Checked on 13.03.2023 still used by Unknown Web version and old mobile vertions a lot
   */
  followers?: Maybe<FollowersConnection>;
  /**
   * #rest #virtual
   *
   *  The list of the entity page visitors
   */
  visitors?: Maybe<EntityPageVisitorsCollection>;
  /** #expand */
  userPageContext?: Maybe<EntityPageUserContext>;
  /** #logged-out #soft-logged-in #rest #virtual */
  newsFeed?: Maybe<EntityPageContentFeedCollection>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Properties that can be used to control the rendering of the entity page
   */
  properties: EntityPageProperties;
  /**
   * #expand
   *
   *  Entity page insights
   */
  insights?: Maybe<EntityPageInsights>;
  /**
   * #rest(batched) #virtual
   *
   *  Entity page entity customer relation on AdManager
   */
  adManagerEntityCustomers?: Maybe<EntityCustomer>;
  entityGlobalId?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  entity?: Maybe<EntityPageEntity>;
};


/** Entity Page representation */
export type EntityPageCoverImageArgs = {
  dimensions: Array<ScaledImageDimension>;
};


/** Entity Page representation */
export type EntityPageOriginalCoverImageArgs = {
  dimensions: Array<ScaledImageDimension>;
};


/** Entity Page representation */
export type EntityPageLogoImageArgs = {
  dimensions: Array<ScaledImageDimension>;
};


/** Entity Page representation */
export type EntityPageOriginalLogoImageArgs = {
  dimensions: Array<ScaledImageDimension>;
};


/** Entity Page representation */
export type EntityPageFollowersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Entity Page representation */
export type EntityPageVisitorsArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


/** Entity Page representation */
export type EntityPageNewsFeedArgs = {
  limit?: Maybe<Scalars['Int']>;
  until?: Maybe<Scalars['String']>;
  since?: Maybe<Scalars['String']>;
  filter?: Maybe<PostingPublicationState>;
  includePinned?: Maybe<Scalars['Boolean']>;
  supportedObjectTypes?: Array<EntityPageSupportedContentObjectTypes>;
};

export type EntityPageAboutContentMutationInput = {
  pageId: Scalars['SlugOrID'];
  aboutArticleReference?: Maybe<Scalars['GlobalID']>;
  aboutHeadline?: Maybe<Scalars['String']>;
  aboutSummary?: Maybe<Scalars['String']>;
  foundingYear?: Maybe<Scalars['Int']>;
  groupRulesArticleReference?: Maybe<Scalars['GlobalID']>;
  imprint?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['URL']>;
};

/** AboutUs module, includes module properties */
export type EntityPageAboutUsModule = EntityPageModule & {
  __typename?: 'EntityPageAboutUsModule';
  /** #logged-out #soft-logged-in */
  properties: AboutUsProperties;
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
  /** #logged-out #soft-logged-in */
  enabled: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  globalId?: Maybe<Scalars['GlobalID']>;
  permissions?: Maybe<EntityPageModulePermissions>;
};

export type EntityPageCompanyHeaderContent = {
  __typename?: 'EntityPageCompanyHeaderContent';
  /** #paginated #logged-out #soft-logged-in #rest #virtual */
  followers?: Maybe<FollowersConnection>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
};


export type EntityPageCompanyHeaderContentFollowersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type EntityPageConfigInput = {
  pageId: Scalars['SlugOrID'];
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  focusType?: Maybe<EntityPageFocusType>;
  contractType?: Maybe<EntityPageContractType>;
  slogan?: Maybe<Scalars['String']>;
  about?: Maybe<AboutEntityMutationInput>;
  visibility?: Maybe<EntityPageVisibility>;
};

export type EntityPageConfigUpdateResult = {
  __typename?: 'EntityPageConfigUpdateResult';
  error?: Maybe<EntityPagesMutationError>;
  /** #rest #virtual */
  entityPage?: Maybe<EntityPage>;
};

export type EntityPageContactUser = {
  __typename?: 'EntityPageContactUser';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  label?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  position?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /** #logged-out #soft-logged-in */
  enabled?: Maybe<Scalars['Boolean']>;
};

/** Result type for ContactUser mutations that returns the new entity representation on success */
export type EntityPageContactUserMutationResult = {
  __typename?: 'EntityPageContactUserMutationResult';
  error?: Maybe<EntityPagesMutationError>;
  success?: Maybe<EntityPageContactUser>;
};

export type EntityPageContactUsers = {
  __typename?: 'EntityPageContactUsers';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  collection: Array<EntityPageContactUser>;
};

export type EntityPageContacts = {
  __typename?: 'EntityPageContacts';
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Locations where this entity is present (only one may be highlighted)
   * @deprecated Removed from the ContactsModule. Please use the dedicated entityPageLocations query. Checked on 23.02.2023 - still used a bit on Web and old Mobile vertions
   */
  locations?: Maybe<EntityPageLocations>;
  /** #logged-out #soft-logged-in #rest #virtual */
  contactUsers?: Maybe<EntityPageContactUsers>;
};


export type EntityPageContactsLocationsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type EntityPageContactsContactUsersArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  includeDisabled?: Maybe<Scalars['Boolean']>;
};

export type EntityPageContentFeedActor = EntityPage | EntityPageContentPageActor;

export type EntityPageContentFeedArticlePost = {
  __typename?: 'EntityPageContentFeedArticlePost';
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  comment?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  permalink?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  provider?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  video?: Maybe<EntityPageContentVideo>;
  /** #logged-out #soft-logged-in */
  image?: Maybe<EntityPageContentFeedUpdateImage>;
};

export type EntityPageContentFeedArticlesArticlePost = {
  __typename?: 'EntityPageContentFeedArticlesArticlePost';
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  summary?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #virtual */
  images?: Maybe<Array<ScaledImage>>;
  /** #logged-out #soft-logged-in */
  coverImageUrl?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  coverVideo?: Maybe<VideoV2>;
  /** #logged-out #soft-logged-in */
  visitUrl?: Maybe<Scalars['URL']>;
};


export type EntityPageContentFeedArticlesArticlePostImagesArgs = {
  dimensions: Array<ScaledImageDimension>;
};

export type EntityPageContentFeedCollection = {
  __typename?: 'EntityPageContentFeedCollection';
  /** #logged-out #soft-logged-in */
  collection?: Maybe<Array<EntityPageContentFeedUpdate>>;
  metadata?: Maybe<EntityPageContentFeedCollectionMetadata>;
};

export type EntityPageContentFeedCollectionMetadata = {
  __typename?: 'EntityPageContentFeedCollectionMetadata';
  draftTotal: Scalars['Int'];
  scheduledTotal: Scalars['Int'];
  hiddenTotal: Scalars['Int'];
};

export type EntityPageContentFeedCompanyArticlePost = {
  __typename?: 'EntityPageContentFeedCompanyArticlePost';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  comment?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  permalink?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  provider?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  image with the original image size. We probably don't need it, since we can get any size we want from image cache
   */
  imageUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in #virtual */
  images?: Maybe<Array<ScaledImage>>;
  /** #logged-out #soft-logged-in */
  video?: Maybe<EntityPageContentVideo>;
};


export type EntityPageContentFeedCompanyArticlePostImagesArgs = {
  dimensions: Array<ScaledImageDimension>;
};

export type EntityPageContentFeedMetadata = {
  __typename?: 'EntityPageContentFeedMetadata';
  /** #logged-out #soft-logged-in */
  likesCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  commentsCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  isCommentable: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isLikeable: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isRecommendable: Scalars['Boolean'];
};

export type EntityPageContentFeedObject = EntityPageContentFeedPostingPost | EntityPageContentFeedPlainTextPostingPost | EntityPageContentFeedArticlePost | EntityPageContentFeedCompanyArticlePost | EntityPageContentFeedArticlesArticlePost;

export type EntityPageContentFeedPlainTextPostingPost = {
  __typename?: 'EntityPageContentFeedPlainTextPostingPost';
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  comment?: Maybe<Scalars['String']>;
};

export type EntityPageContentFeedPostingPost = {
  __typename?: 'EntityPageContentFeedPostingPost';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  comment?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  createdAt: Scalars['Date'];
  /**
   * When a posting will be published.
   * Only set for postings that have not been published yet
   * but are scheduled for publication.
   * For published postings query `EntityPageContentFeedUpdate.publishedAt` instead
   */
  publishAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  publicationState: PostingPublicationState;
  /** #logged-out #soft-logged-in */
  attachment?: Maybe<PostingsAttachment>;
};

export type EntityPageContentFeedUpdate = {
  __typename?: 'EntityPageContentFeedUpdate';
  /**
   * #logged-out #soft-logged-in
   *
   *  a missing globalId indicates an unpublished posting
   */
  globalId?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in */
  publishedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  metadata?: Maybe<EntityPageContentFeedMetadata>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   * @deprecated Please only use the `EntityPage` type as the actor; EntityPageContentPageActor is deprecated. Checked 28.03.2023 still used by unknown Web version
   */
  actor?: Maybe<EntityPageContentFeedActor>;
  /** #logged-out #soft-logged-in */
  object?: Maybe<EntityPageContentFeedObject>;
  /** #rest(batched) #virtual */
  socialProof?: Maybe<XingId>;
  /**
   * #logged-out #soft-logged-in
   *
   *  limited to one per stream; pinned indicates that the record is hoisted to the top of the feed instead of its original position
   */
  isPinned: Scalars['Boolean'];
};

export type EntityPageContentFeedUpdateImage = {
  __typename?: 'EntityPageContentFeedUpdateImage';
  /** #logged-out #soft-logged-in */
  srcWidth1232?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcWidth776?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcWidth516?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcWidth347?: Maybe<Scalars['URL']>;
};

export type EntityPageContentPageActor = {
  __typename?: 'EntityPageContentPageActor';
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  permalink?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  logo?: Maybe<EntityPageContentPageActorLogo>;
};

export type EntityPageContentPageActorLogo = {
  __typename?: 'EntityPageContentPageActorLogo';
  /** #logged-out #soft-logged-in */
  original?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  web?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square32?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square48?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square64?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square96?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square128?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square144?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square192?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square256?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square384?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  square1024?: Maybe<Scalars['URL']>;
};

export type EntityPageContentVideo = {
  __typename?: 'EntityPageContentVideo';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  urn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  links?: Maybe<EntityPageContentVideoLinks>;
};

export type EntityPageContentVideoLinks = {
  __typename?: 'EntityPageContentVideoLinks';
  /** #logged-out #soft-logged-in */
  iframeUrl?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  thumbnailsUrls?: Maybe<Array<Scalars['String']>>;
};

export type EntityPageContext = {
  __typename?: 'EntityPageContext';
  /** #logged-out #soft-logged-in */
  companyId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  cppId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  groupPageId?: Maybe<Scalars['ID']>;
};

export type EntityPageContract = {
  __typename?: 'EntityPageContract';
  /** #logged-out #soft-logged-in */
  type: EntityPageContractType;
};

export enum EntityPageContractType {
  None = 'NONE',
  Free = 'FREE',
  Paid = 'PAID',
  PaidPlus = 'PAID_PLUS'
}

export enum EntityPageCoverMediaType {
  Image = 'IMAGE'
}

export type EntityPageCreateContactUserInput = {
  pageId: Scalars['SlugOrID'];
  userId: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
};

export type EntityPageCreateDocumentMutationInput = {
  pageId: Scalars['SlugOrID'];
  uploadReference: Scalars['UploadId'];
  filename: Scalars['String'];
  description: Scalars['String'];
};

export type EntityPageCreateLocationInput = {
  pageId: Scalars['SlugOrID'];
  label: Scalars['String'];
  city: Scalars['String'];
  cityId?: Maybe<Scalars['ID']>;
  address: Scalars['String'];
  addressSuffix?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  countryIsoCode: CountryCodesAlpha2;
  email?: Maybe<Scalars['String']>;
  phoneNumberCountryCode?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  faxNumberCountryCode?: Maybe<Scalars['Int']>;
  faxNumber?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  highlighted?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type EntityPageCreateMediaMutationInput = {
  pageId: Scalars['SlugOrID'];
  mediaType: EntityMediaType;
  mediaReference?: Maybe<Scalars['UUID']>;
  uploadId?: Maybe<Scalars['UploadId']>;
  description?: Maybe<Scalars['String']>;
};

export type EntityPageCreateVideoMediaMutationInput = {
  pageId: Scalars['SlugOrID'];
  description?: Maybe<Scalars['String']>;
  videoData: VideoDataInput;
};

export type EntityPageDeleteContactUserMutationInput = {
  pageId: Scalars['SlugOrID'];
  contactId: Scalars['ID'];
};

export type EntityPageDeleteCoverMutationInput = {
  entityPageId: Scalars['SlugOrID'];
};

export type EntityPageDeleteDocumentMutationInput = {
  pageId: Scalars['SlugOrID'];
  documentId: Scalars['ID'];
};

export type EntityPageDeleteInput = {
  pageId: Scalars['SlugOrID'];
};

export type EntityPageDeleteLocationMutationInput = {
  pageId: Scalars['SlugOrID'];
  locationId: Scalars['ID'];
};

export type EntityPageDeleteMediaMutationInput = {
  pageId: Scalars['SlugOrID'];
  mediaId: Scalars['ID'];
};

export type EntityPageDemographics = {
  __typename?: 'EntityPageDemographics';
  byAge?: Maybe<Array<Maybe<AgeGroupElement>>>;
  byCareerLevel?: Maybe<Array<Maybe<CareerLevelElement>>>;
  byTopCompanies?: Maybe<Array<Maybe<TopCompaniesElement>>>;
  byTopIndustries?: Maybe<Array<Maybe<TopIndustriesElement>>>;
};

export enum EntityPageDemographicsKpi {
  Followers = 'FOLLOWERS',
  Visitors = 'VISITORS'
}

/** Result type for Document mutations that returns the new entity representation on success */
export type EntityPageDocumentMutationResult = {
  __typename?: 'EntityPageDocumentMutationResult';
  error?: Maybe<EntityPagesMutationError>;
  success?: Maybe<EntityDocument>;
};

export type EntityPageEntity = ContentPage | ContentInsiderPage;

/** Representation of an error when making a request to entity pages */
export type EntityPageError = {
  __typename?: 'EntityPageError';
  /** #logged-out #soft-logged-in */
  errorType: Scalars['String'];
  /** #logged-out #soft-logged-in */
  errorCode: Scalars['Int'];
};

export type EntityPageFallbackHeaderContent = {
  __typename?: 'EntityPageFallbackHeaderContent';
  /** #logged-out #soft-logged-in */
  message: Scalars['String'];
};

export enum EntityPageFocusType {
  Company = 'COMPANY',
  IndustryPage = 'INDUSTRY_PAGE',
  Publisher = 'PUBLISHER',
  TopicPage = 'TOPIC_PAGE',
  GroupPage = 'GROUP_PAGE',
  Insider = 'INSIDER',
  PremiumPage = 'PREMIUM_PAGE'
}

/** Entity page followers graphics representation */
export type EntityPageFollowers = {
  __typename?: 'EntityPageFollowers';
  /** #rest #virtual */
  totals?: Maybe<EntityPageInsightsKpiTotals>;
  /** #rest #virtual */
  totalsWithUnfollows?: Maybe<EntityPageInsightsFollowersTotals>;
  /** #rest #virtual */
  histogram?: Maybe<EntityPageInsightsKpiHistogram>;
};


/** Entity page followers graphics representation */
export type EntityPageFollowersTotalsArgs = {
  timePeriod: EntityPageInsightsTimePeriodInput;
};


/** Entity page followers graphics representation */
export type EntityPageFollowersTotalsWithUnfollowsArgs = {
  timePeriod: EntityPageInsightsTimePeriodInput;
};


/** Entity page followers graphics representation */
export type EntityPageFollowersHistogramArgs = {
  timePeriod: EntityPageInsightsTimePeriodInput;
  granularity: EntityPageInsightsGranularity;
};

export type EntityPageFollowersMutationInput = {
  followedId: Scalars['ID'];
};

/** Generic module that just has a +type+ field */
export type EntityPageGenericModule = EntityPageModule & {
  __typename?: 'EntityPageGenericModule';
  /** #logged-out #soft-logged-in */
  properties?: Maybe<Scalars['JSON']>;
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
  /** #logged-out #soft-logged-in */
  enabled: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  globalId?: Maybe<Scalars['GlobalID']>;
  permissions?: Maybe<EntityPageModulePermissions>;
};

export type EntityPageGroupPageHeaderContent = {
  __typename?: 'EntityPageGroupPageHeaderContent';
  /** #logged-out #soft-logged-in */
  group?: Maybe<EntityPageGroupPageHeaderData>;
};

export type EntityPageGroupPageHeaderData = {
  __typename?: 'EntityPageGroupPageHeaderData';
  /**
   * #logged-out #soft-logged-in
   * @deprecated Groups are going to be shutdown at the end of 2022. This field will stop working on 01/10/2022.
   */
  group?: Maybe<GroupsGroup>;
  /**
   * #paginated #logged-out #soft-logged-in
   * @deprecated Groups are going to be shutdown at the end of 2022. This field will stop working on 01/10/2022.
   */
  groupsMemberships?: Maybe<GroupsMembershipsConnection>;
};


export type EntityPageGroupPageHeaderDataGroupsMembershipsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type EntityPageHeaderContent = EntityPageCompanyHeaderContent | EntityPageGroupPageHeaderContent | EntityPagePublisherHeaderContent | EntityPageTopicPageHeaderContent | EntityPageInsiderHeaderContent | EntityPagePremiumPageHeaderContent | EntityPageFallbackHeaderContent;

/** Header module, includes header specific data */
export type EntityPageHeaderModule = EntityPageModule & {
  __typename?: 'EntityPageHeaderModule';
  /** #logged-out #soft-logged-in */
  content?: Maybe<EntityPageHeaderContent>;
  /** #logged-out #soft-logged-in */
  properties?: Maybe<Scalars['JSON']>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Deprecated in favour of 'content'. WILL BE REMOVED ...
   */
  data?: Maybe<EntityPageHeaderModuleData>;
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
  /** #logged-out #soft-logged-in */
  enabled: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  globalId?: Maybe<Scalars['GlobalID']>;
  permissions?: Maybe<EntityPageModulePermissions>;
};

export type EntityPageHeaderModuleData = {
  __typename?: 'EntityPageHeaderModuleData';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
};

export type EntityPageInsiderHeaderContent = {
  __typename?: 'EntityPageInsiderHeaderContent';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  followersCount?: Maybe<FollowersCount>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  contentInsiderPage?: Maybe<ContentInsiderPage>;
};

export type EntityPageInsights = {
  __typename?: 'EntityPageInsights';
  /** #rest #virtual */
  demographics?: Maybe<EntityPageDemographics>;
  /** #expand */
  followers?: Maybe<EntityPageFollowers>;
  /** #expand */
  visitors?: Maybe<EntityPageVisitors>;
};


export type EntityPageInsightsDemographicsArgs = {
  kpi?: Maybe<EntityPageDemographicsKpi>;
};

export type EntityPageInsightsFollowersTotals = {
  __typename?: 'EntityPageInsightsFollowersTotals';
  periodTotal?: Maybe<Scalars['Int']>;
  overallTotal?: Maybe<Scalars['Int']>;
  periodTotalUnfollows?: Maybe<Scalars['Int']>;
  overallTotalUnfollows?: Maybe<Scalars['Int']>;
};

export enum EntityPageInsightsGranularity {
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH'
}

export type EntityPageInsightsKpiHistogram = {
  __typename?: 'EntityPageInsightsKpiHistogram';
  granularity: EntityPageInsightsGranularity;
  collection: Array<EntityPageInsightsKpiHistogramEntry>;
};

export type EntityPageInsightsKpiHistogramEntry = {
  __typename?: 'EntityPageInsightsKpiHistogramEntry';
  timestamp: Scalars['Date'];
  total: Scalars['Int'];
  added: Scalars['Int'];
  removed: Scalars['Int'];
};

export type EntityPageInsightsKpiTotals = {
  __typename?: 'EntityPageInsightsKpiTotals';
  periodTotal: Scalars['Int'];
  overallTotal: Scalars['Int'];
};

export type EntityPageInsightsTimePeriodInput = {
  /** An iso8601 encoded UTC datetime, it can't have a + sign */
  from: Scalars['Date'];
  /** An iso8601 encoded UTC datetime, it can't have a + sign */
  to: Scalars['Date'];
};

export type EntityPageLinks = {
  __typename?: 'EntityPageLinks';
  /** #logged-out #soft-logged-in */
  self: Scalars['URL'];
};

export type EntityPageLocation = {
  __typename?: 'EntityPageLocation';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  label: Scalars['String'];
  /** #logged-out #soft-logged-in */
  city: Scalars['String'];
  /** #logged-out #soft-logged-in */
  address: Scalars['String'];
  /** #logged-out #soft-logged-in */
  addressSuffix?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  postcode: Scalars['String'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  country?: Maybe<Country>;
  /** #logged-out #soft-logged-in */
  email?: Maybe<Scalars['Email']>;
  /** #logged-out #soft-logged-in */
  phoneNumber?: Maybe<EntityPagePhoneNumber>;
  /** #logged-out #soft-logged-in */
  faxNumber?: Maybe<EntityPagePhoneNumber>;
  /** #logged-out #soft-logged-in */
  websiteURL?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  highlighted: Scalars['Boolean'];
  /** #logged-out #soft-logged-in #expand */
  coordinates?: Maybe<GpsCoordinates>;
};

/** Result type for Locations mutations that returns the new entity representation on success */
export type EntityPageLocationMutationResult = {
  __typename?: 'EntityPageLocationMutationResult';
  error?: Maybe<EntityPagesMutationError>;
  success?: Maybe<EntityPageLocation>;
};

export type EntityPageLocations = {
  __typename?: 'EntityPageLocations';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  collection: Array<EntityPageLocation>;
};

export type EntityPageMedia = EntityExternalVideo | EntityVideo | ScaledImage;

/** Result type for Media mutations that returns the new entity representation on success */
export type EntityPageMediaMutationResult = {
  __typename?: 'EntityPageMediaMutationResult';
  error?: Maybe<EntityPagesMutationError>;
  success?: Maybe<EntityMedia>;
};

export type EntityPageModule = {
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
  /** #logged-out #soft-logged-in */
  enabled: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  globalId?: Maybe<Scalars['GlobalID']>;
  permissions?: Maybe<EntityPageModulePermissions>;
};

export type EntityPageModuleConfig = {
  type: Scalars['String'];
  enabled: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
};

export type EntityPageModuleConfigInput = {
  pageId: Scalars['ID'];
  collection: Array<EntityPageModuleConfig>;
};

export type EntityPageModuleConfigUpdateResult = {
  __typename?: 'EntityPageModuleConfigUpdateResult';
  error?: Maybe<EntityPagesMutationError>;
  /** #rest #virtual */
  modules?: Maybe<EntityPageModules>;
};

/** Racpac permissions of the module, already resolved for the current user */
export type EntityPageModulePermissions = {
  __typename?: 'EntityPageModulePermissions';
  canRead: Scalars['Boolean'];
};

export type EntityPageModules = {
  __typename?: 'EntityPageModules';
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<EntityPageModule>>;
};

/** Used when the slug requested is not the current one for the entity page */
export type EntityPageMoved = {
  __typename?: 'EntityPageMoved';
  /** #logged-out #soft-logged-in */
  links: EntityPageLinks;
  /** #logged-out #soft-logged-in */
  slug: Scalars['String'];
};

/** Basic result type for mutations that don't return data on success */
export type EntityPageMutationResult = {
  __typename?: 'EntityPageMutationResult';
  error?: Maybe<EntityPagesMutationError>;
};

export enum EntityPageParentPage {
  CompaniesLandingPage = 'COMPANIES_LANDING_PAGE',
  NewsLandingPage = 'NEWS_LANDING_PAGE',
  GroupPagesLandingPage = 'GROUP_PAGES_LANDING_PAGE'
}

/** Racpac permissions of the entity page, already resolved for the current user */
export type EntityPagePermissions = {
  __typename?: 'EntityPagePermissions';
  /**
   * Grants permission to edit the vast majority of things that can be edited on a
   * page. Notable exception: The page title.
   */
  canEdit: Scalars['Boolean'];
  /**
   * Admin permissions include changing a page's title. Only available for selected
   * New Work employees, such as Customer Success.
   */
  canAdmin: Scalars['Boolean'];
};

export type EntityPagePhoneNumber = {
  __typename?: 'EntityPagePhoneNumber';
  /** #logged-out #soft-logged-in */
  number: Scalars['String'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Numeric country prefix (without leading `0` or `+`)
   */
  countryCode: Scalars['Int'];
};

export type EntityPagePremiumPageHeaderContent = {
  __typename?: 'EntityPagePremiumPageHeaderContent';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  followersCount?: Maybe<FollowersCount>;
};

export type EntityPageProperties = {
  __typename?: 'EntityPageProperties';
  /** #logged-out #soft-logged-in */
  condensedHeader: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  parentPage: EntityPageParentPage;
};

export enum EntityPagePublicationStatus {
  Created = 'CREATED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type EntityPagePublicationStatusInput = {
  pageId: Scalars['SlugOrID'];
  publicationStatus: EntityPagePublicationStatus;
};

export type EntityPagePublisherHeaderContent = {
  __typename?: 'EntityPagePublisherHeaderContent';
  /** #paginated #logged-out #soft-logged-in #rest #virtual */
  followers?: Maybe<FollowersConnection>;
  /** #logged-out #soft-logged-in */
  publisher: Scalars['String'];
};


export type EntityPagePublisherHeaderContentFollowersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type EntityPageResult = EntityPage | EntityPageMoved | EntityPageError;

export type EntityPageSocialProof = {
  __typename?: 'EntityPageSocialProof';
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type EntityPageSocialProofConnection = HasCursorPagination & {
  __typename?: 'EntityPageSocialProofConnection';
  proofType?: Maybe<EntityPageSocialProofType>;
  edges: Array<Maybe<EntityPageSocialProofEdge>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type EntityPageSocialProofEdge = PaginationEdge & {
  __typename?: 'EntityPageSocialProofEdge';
  node?: Maybe<EntityPageSocialProof>;
  /** #virtual */
  cursor: Scalars['String'];
};

export enum EntityPageSocialProofType {
  Followers = 'FOLLOWERS',
  Employees = 'EMPLOYEES',
  Members = 'MEMBERS'
}

export enum EntityPageSupportedContentObjectTypes {
  PlainTextPosting = 'PLAIN_TEXT_POSTING',
  ArticlePosting = 'ARTICLE_POSTING',
  ImagePosting = 'IMAGE_POSTING',
  LinkSharePosting = 'LINK_SHARE_POSTING',
  VideoPosting = 'VIDEO_POSTING',
  ContentPageArticle = 'CONTENT_PAGE_ARTICLE',
  CompanyPageArticle = 'COMPANY_PAGE_ARTICLE',
  ArticlesArticle = 'ARTICLES_ARTICLE'
}

export type EntityPageTopicPageHeaderContent = {
  __typename?: 'EntityPageTopicPageHeaderContent';
  /** #paginated #logged-out #soft-logged-in #rest #virtual */
  followers?: Maybe<FollowersConnection>;
  /** #logged-out #soft-logged-in */
  publisher: Scalars['String'];
};


export type EntityPageTopicPageHeaderContentFollowersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type EntityPageTrackVisitorInput = {
  referer?: Maybe<Scalars['String']>;
  requestUri?: Maybe<Scalars['String']>;
  /** This IP field is currently resolved using the ctx.clientId directive, so values added manually will be ignored */
  remoteAddr?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
  /** This IP field is currently resolved using the ctx.clientId directive, so values added manually will be ignored */
  forwardedFor?: Maybe<Scalars['String']>;
  adId?: Maybe<Scalars['String']>;
  platform?: Maybe<EntityPageTrackVisitorPlatform>;
  platformVersion?: Maybe<Scalars['String']>;
  appVersion?: Maybe<Scalars['String']>;
  visitorId?: Maybe<Scalars['String']>;
};

export type EntityPageTrackVisitorMutationInput = {
  pageId: Scalars['SlugOrID'];
  trackingData: EntityPageTrackVisitorInput;
};

export enum EntityPageTrackVisitorPlatform {
  Web = 'WEB',
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type EntityPageUpdateContactUserInput = {
  pageId: Scalars['SlugOrID'];
  contactId: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type EntityPageUpdateContactUsersCatalogueMutationInput = {
  pageId: Scalars['SlugOrID'];
  contacts: Array<ContactUsersCatalogueItemInput>;
};

export type EntityPageUpdateCoverMutationInput = {
  entityPageId: Scalars['SlugOrID'];
  coverMediaType: EntityPageCoverMediaType;
  coverMediaReference?: Maybe<Scalars['UUID']>;
  originalCoverMediaReference?: Maybe<Scalars['UUID']>;
  coverMediaUploadId?: Maybe<Scalars['UploadId']>;
  originalCoverMediaUploadId?: Maybe<Scalars['UploadId']>;
};

export type EntityPageUpdateDocumentMutationInput = {
  pageId: Scalars['SlugOrID'];
  documentId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
};

export type EntityPageUpdateLocationInput = {
  pageId: Scalars['SlugOrID'];
  locationId: Scalars['ID'];
  label: Scalars['String'];
  city: Scalars['String'];
  cityId?: Maybe<Scalars['ID']>;
  address: Scalars['String'];
  addressSuffix?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  countryIsoCode: CountryCodesAlpha2;
  email?: Maybe<Scalars['String']>;
  phoneNumberCountryCode?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  faxNumberCountryCode?: Maybe<Scalars['Int']>;
  faxNumber?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  highlighted?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type EntityPageUpdateLogoMutationInput = {
  entityPageId: Scalars['SlugOrID'];
  logoUuid?: Maybe<Scalars['UUID']>;
  originalLogoUuid?: Maybe<Scalars['UUID']>;
  logoUploadId?: Maybe<Scalars['UploadId']>;
  originalLogoUploadId?: Maybe<Scalars['UploadId']>;
};

export type EntityPageUpdateMediaGalleryMutationInput = {
  pageId: Scalars['SlugOrID'];
  mediaItems: Array<EntityMediaGalleryItemInput>;
};

export type EntityPageUpdateMediaMutationInput = {
  pageId: Scalars['SlugOrID'];
  mediaId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
};

export type EntityPageUpdateVideoMediaMutationInput = {
  pageId: Scalars['SlugOrID'];
  mediaId: Scalars['ID'];
  videoData?: Maybe<VideoUpdateDataInput>;
};

export type EntityPageUserContext = {
  __typename?: 'EntityPageUserContext';
  userInteractions?: Maybe<EntityPageUserInteractionContext>;
  /**
   * #rest(batched) #virtual
   * @deprecated This attribute was moved to userInteractions, as we're now using fragments to distinguish between follow and join action. WILL BE REMOVED ...
   */
  followState?: Maybe<FollowContext>;
  permissions: EntityPagePermissions;
  /** @deprecated Groups are going to be shutdown at the end of 2022. This field only returns static `false` values. */
  groupPermissions?: Maybe<GroupsAllowedActionsOnGroup>;
  /** @deprecated Entity Pages no longer store information about the user's role for the page's entity. Use permissions for access control instead of roles */
  userRole?: Maybe<EntityPageUserRole>;
  /**
   * #paginated #rest #virtual
   *
   *  The social proof for the entity page
   */
  socialProof?: Maybe<EntityPageSocialProofConnection>;
};


export type EntityPageUserContextSocialProofArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type EntityPageUserInteractionContext = EntityPageUserInteractionFollow | EntityPageUserInteractionJoin | EntityPageUserInteractionFallback;

export type EntityPageUserInteractionFallback = {
  __typename?: 'EntityPageUserInteractionFallback';
  /** #logged-out #soft-logged-in */
  message: Scalars['String'];
};

export type EntityPageUserInteractionFollow = {
  __typename?: 'EntityPageUserInteractionFollow';
  /** #rest(batched) #virtual */
  followState?: Maybe<FollowContext>;
};

export type EntityPageUserInteractionJoin = {
  __typename?: 'EntityPageUserInteractionJoin';
  /**
   * #paginated
   * @deprecated Groups are going to be shutdown at the end of 2022. This field will stop working on 01/10/2022.
   */
  groupsMemberships?: Maybe<GroupsMembershipsConnection>;
};


export type EntityPageUserInteractionJoinGroupsMembershipsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export enum EntityPageUserRole {
  Administrator = 'ADMINISTRATOR',
  Editor = 'EDITOR',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

/** Result type for Video Media mutations that returns the signed url to be used to upload the video */
export type EntityPageVideoMediaMutationResult = {
  __typename?: 'EntityPageVideoMediaMutationResult';
  error?: Maybe<EntityPagesMutationError>;
  success?: Maybe<EntityVideoUploadResponse>;
};

export enum EntityPageVisibility {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type EntityPageVisitor = {
  __typename?: 'EntityPageVisitor';
  userId: Scalars['ID'];
  lastVisitedAt: Scalars['Date'];
  visitCount: Scalars['Int'];
  /** #rest(batched) #virtual */
  profileDetails?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  sharedContacts?: Maybe<SharedContacts>;
  /** #rest(batched) #virtual */
  contactDistance?: Maybe<ContactDistance>;
  /** #rest(batched) #virtual */
  networkRelationship?: Maybe<NetworkRelationship>;
};

export type EntityPageVisitors = {
  __typename?: 'EntityPageVisitors';
  /** #rest #virtual */
  totals?: Maybe<EntityPageInsightsKpiTotals>;
  /** #rest #virtual */
  histogram?: Maybe<EntityPageVisitorsInsightsKpiHistogram>;
  /** #rest #virtual */
  referers?: Maybe<EntityPagesVisitorReferers>;
};


export type EntityPageVisitorsTotalsArgs = {
  timePeriod: EntityPageInsightsTimePeriodInput;
  onlyLoggedIn?: Maybe<Scalars['Boolean']>;
  onlyLoggedOut?: Maybe<Scalars['Boolean']>;
  onlyFollowers?: Maybe<Scalars['Boolean']>;
};


export type EntityPageVisitorsHistogramArgs = {
  timePeriod: EntityPageInsightsTimePeriodInput;
  granularity: EntityPageInsightsGranularity;
  onlyLoggedIn?: Maybe<Scalars['Boolean']>;
  onlyLoggedOut?: Maybe<Scalars['Boolean']>;
  onlyFollowers?: Maybe<Scalars['Boolean']>;
};


export type EntityPageVisitorsReferersArgs = {
  timePeriod: EntityPageInsightsTimePeriodInput;
  topReferersLimit: Scalars['Int'];
  onlyLoggedIn?: Maybe<Scalars['Boolean']>;
  onlyLoggedOut?: Maybe<Scalars['Boolean']>;
};

/**
 * Returns a collection with the visitors of the entity page.
 *
 * If the `rid` is not an editor for the entity page, then the backing endpoint will generate a 403 error and the resolution will fail.
 */
export type EntityPageVisitorsCollection = {
  __typename?: 'EntityPageVisitorsCollection';
  total: Scalars['Int'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  collection: Array<Maybe<EntityPageVisitor>>;
};

export type EntityPageVisitorsInsightsKpiHistogram = {
  __typename?: 'EntityPageVisitorsInsightsKpiHistogram';
  granularity: EntityPageInsightsGranularity;
  collection: Array<EntityPageVisitorsInsightsKpiHistogramEntry>;
};

export type EntityPageVisitorsInsightsKpiHistogramEntry = {
  __typename?: 'EntityPageVisitorsInsightsKpiHistogramEntry';
  timestamp: Scalars['Date'];
  total: Scalars['Int'];
  organic: Scalars['Int'];
  promotions: Scalars['Int'];
};

export type EntityPagesMutationError = {
  __typename?: 'EntityPagesMutationError';
  /** #logged-out #soft-logged-in */
  errorType: Scalars['String'];
  /** #logged-out #soft-logged-in */
  errorCode: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  errors?: Maybe<Scalars['JSON']>;
};

export type EntityPagesVisitorReferer = {
  __typename?: 'EntityPagesVisitorReferer';
  total: Scalars['Int'];
  collection: Array<EntityPagesVisitorRefererValue>;
};

export type EntityPagesVisitorRefererValue = {
  __typename?: 'EntityPagesVisitorRefererValue';
  referer: Scalars['String'];
  percentage: Scalars['Float'];
};

export type EntityPagesVisitorReferers = {
  __typename?: 'EntityPagesVisitorReferers';
  xing: EntityPagesVisitorReferer;
  searchEngines: EntityPagesVisitorReferer;
  websiteLinks: EntityPagesVisitorReferer;
  other: EntityPagesVisitorReferer;
};

export type EntityTypeAggregation = HasAggregationCount & {
  __typename?: 'EntityTypeAggregation';
  value: EntityTypeValue;
  count: Scalars['Int'];
};

export enum EntityTypeValue {
  Page = 'PAGE',
  Insider = 'INSIDER',
  Article = 'ARTICLE'
}

export type EntityVideo = {
  __typename?: 'EntityVideo';
  /**
   * #logged-out #soft-logged-in
   * @deprecated Dropped in favour of videoReferenceV2. WILL BE REMOVED ...
   */
  videoReference: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  videoReferenceV2: Scalars['SlugOrID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  videoDetailsV2?: Maybe<VideoV2>;
};

export type EntityVideoUploadResponse = VideoUploadResponse & {
  __typename?: 'EntityVideoUploadResponse';
  id: Scalars['ID'];
  videoDetails?: Maybe<VideoUploadDetails>;
};

export type ErecruitingSourcingServiceArchiveResult = {
  __typename?: 'ErecruitingSourcingServiceArchiveResult';
  error?: Maybe<ErecruitingSourcingServiceMutationError>;
};

export type ErecruitingSourcingServiceArchiveStatusInput = {
  briefingId: Scalars['ID'];
  archived?: Maybe<Scalars['Boolean']>;
};

export type ErecruitingSourcingServiceBadRequestError = {
  __typename?: 'ErecruitingSourcingServiceBadRequestError';
  message?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErecruitingSourcingServiceValidationError>>>;
};

/**
 * Note: Though types like Discipline, Industry exist in X1
 *       the usage here is merely for persisting & reading the actual value
 *       and not for rendering the associated resolvers.
 *
 *       i.e. They are to be used by the Position Details Form which
 *       has it's own backend for frontend service that provides this
 *       data for autocompleters in the form.
 */
export type ErecruitingSourcingServiceBriefing = {
  __typename?: 'ErecruitingSourcingServiceBriefing';
  id: Scalars['ID'];
  archived?: Maybe<Scalars['Boolean']>;
  businessEmail: Scalars['Email'];
  businessPhoneNumber: Scalars['String'];
  careerLevelId: Scalars['Int'];
  /** #rest(batched) #virtual */
  careerLevel?: Maybe<CareerLevel>;
  /** #rest(batched) #virtual */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['ID']>;
  companyName: Scalars['String'];
  companyNotes?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  creatorId: Scalars['ID'];
  /** #rest(batched) #virtual */
  creator?: Maybe<XingId>;
  currencyCode?: Maybe<Currency>;
  disciplineId: Scalars['Int'];
  /** #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
  education?: Maybe<Scalars['String']>;
  courseOfStudy?: Maybe<Scalars['String']>;
  degree?: Maybe<Scalars['String']>;
  industryId: Scalars['Int'];
  /** #rest(batched) #virtual */
  industry?: Maybe<Industry>;
  jobDescription: Scalars['String'];
  jobLocationId: Scalars['Int'];
  /** #rest(batched) #virtual */
  jobLocation?: Maybe<City>;
  jobPostCode?: Maybe<Scalars['String']>;
  jobroleId?: Maybe<Scalars['Int']>;
  jobTitle: Scalars['String'];
  jobType: Scalars['String'];
  leadershipResponsibility?: Maybe<Scalars['String']>;
  linkedRecordId?: Maybe<Scalars['Int']>;
  linkedRecordSource?: Maybe<Scalars['URL']>;
  linkedRecordType?: Maybe<Scalars['String']>;
  previousJobroleId?: Maybe<Scalars['Int']>;
  previousPosition?: Maybe<Scalars['String']>;
  referenceProfileId?: Maybe<Scalars['ID']>;
  /** #rest(batched) #virtual */
  referenceProfile?: Maybe<XingId>;
  /** #rest #virtual */
  reports?: Maybe<ErecruitingSourcingServiceBriefingReportsCollectionResponse>;
  requiredLanguages?: Maybe<Array<Maybe<ErecruitingSourcingServiceLanguage>>>;
  requiredSkills?: Maybe<Array<Maybe<Scalars['String']>>>;
  salaryRange?: Maybe<ErecruitingSourcingServiceSalaryRange>;
  updatedAt?: Maybe<Scalars['Date']>;
  workExperienceId?: Maybe<Scalars['Int']>;
  xtmProjectId?: Maybe<Scalars['ID']>;
  isShared?: Maybe<Scalars['Boolean']>;
  workflowStatus?: Maybe<Scalars['String']>;
  /** @deprecated Field no longer supported */
  productType?: Maybe<ErecruitingSourcingServiceProductType>;
  productTypeNew?: Maybe<ErecruitingSourcingServiceProductTypeLowCase>;
  fullRemote?: Maybe<Scalars['Boolean']>;
  positionCountryCode?: Maybe<Scalars['String']>;
  positionLocationIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  positionLocationCoordinates?: Maybe<Array<Maybe<ErecruitingSourcingServiceBriefingCoordinates>>>;
  positionLocationCities?: Maybe<Array<Maybe<Scalars['String']>>>;
  positionRadius?: Maybe<Scalars['Int']>;
  jobLocationCity?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceBriefingCandidate = {
  __typename?: 'ErecruitingSourcingServiceBriefingCandidate';
  briefingId: Scalars['ID'];
  /** #rest #virtual */
  briefing?: Maybe<ErecruitingSourcingServiceBriefingResponse>;
  candidateId: Scalars['ID'];
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user: XingId;
  /** #rest(batched) #virtual */
  creator: XingId;
  clientStatus?: Maybe<BriefingCandidateClientStatus>;
  /** #rest(batched) #virtual */
  candidateNotes?: Maybe<ErecruitingSourcingServiceCandidateNote>;
  creatorId: Scalars['ID'];
  createdAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  urn: Scalars['GlobalID'];
};

export enum ErecruitingSourcingServiceBriefingCandidateLastDaysActive {
  All = 'ALL',
  LastMonth = 'LAST_MONTH',
  LastTwoMonths = 'LAST_TWO_MONTHS',
  LastThreeMonths = 'LAST_THREE_MONTHS',
  LastYear = 'LAST_YEAR'
}

export type ErecruitingSourcingServiceBriefingCandidateListResponse = {
  __typename?: 'ErecruitingSourcingServiceBriefingCandidateListResponse';
  total: Scalars['Int'];
  collection: Array<ErecruitingSourcingServiceBriefingCandidate>;
};

export type ErecruitingSourcingServiceBriefingCandidateMutationResult = {
  __typename?: 'ErecruitingSourcingServiceBriefingCandidateMutationResult';
  success?: Maybe<ErecruitingSourcingServiceBriefingCandidateResponse>;
  error?: Maybe<Array<Maybe<ErecruitingSourcingServiceFieldMutationError>>>;
};

export type ErecruitingSourcingServiceBriefingCandidateResponse = {
  __typename?: 'ErecruitingSourcingServiceBriefingCandidateResponse';
  briefingCandidate?: Maybe<ErecruitingSourcingServiceBriefingCandidate>;
  isFirstCandidate: Scalars['Boolean'];
};

export type ErecruitingSourcingServiceBriefingCandidateUpdateResult = {
  __typename?: 'ErecruitingSourcingServiceBriefingCandidateUpdateResult';
  error?: Maybe<ErecruitingSourcingServiceFieldMutationError>;
};

export type ErecruitingSourcingServiceBriefingCoordinates = {
  __typename?: 'ErecruitingSourcingServiceBriefingCoordinates';
  longitude: Scalars['Float'];
  latitude: Scalars['Float'];
};

export type ErecruitingSourcingServiceBriefingCoordinatesInput = {
  longitude: Scalars['Float'];
  latitude: Scalars['Float'];
};

export type ErecruitingSourcingServiceBriefingListResponse = {
  __typename?: 'ErecruitingSourcingServiceBriefingListResponse';
  total: Scalars['Int'];
  collection: Array<ErecruitingSourcingServiceBriefing>;
};

export type ErecruitingSourcingServiceBriefingMetadata = {
  __typename?: 'ErecruitingSourcingServiceBriefingMetadata';
  additionalInfoSortOrder?: Maybe<Array<Maybe<Scalars['String']>>>;
  candidatesSortOrder?: Maybe<Array<Maybe<Scalars['Int']>>>;
  candidatesLastActiveDays?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceBriefingMetadataFieldsInput = {
  additionalInfoSortOrder?: Maybe<Array<Maybe<Scalars['String']>>>;
  candidatesSortOrder?: Maybe<Array<Maybe<Scalars['Int']>>>;
  candidatesLastActiveDays?: Maybe<ErecruitingSourcingServiceBriefingCandidateLastDaysActive>;
};

export type ErecruitingSourcingServiceBriefingMetadataInput = {
  briefingId: Scalars['ID'];
  briefingMetadata?: Maybe<ErecruitingSourcingServiceBriefingMetadataFieldsInput>;
};

export type ErecruitingSourcingServiceBriefingMetadataResponse = {
  __typename?: 'ErecruitingSourcingServiceBriefingMetadataResponse';
  briefingMetadata: ErecruitingSourcingServiceBriefingMetadata;
};

export type ErecruitingSourcingServiceBriefingMetadataUpdateResult = {
  __typename?: 'ErecruitingSourcingServiceBriefingMetadataUpdateResult';
  success?: Maybe<ErecruitingSourcingServiceBriefingMetadataResponse>;
  error?: Maybe<Array<Maybe<ErecruitingSourcingServiceFieldMutationError>>>;
};

/** Types for XTS Briefing Reports */
export type ErecruitingSourcingServiceBriefingReport = {
  __typename?: 'ErecruitingSourcingServiceBriefingReport';
  id: Scalars['ID'];
  briefingId: Scalars['ID'];
  projectId: Scalars['ID'];
  consultantNotes?: Maybe<Scalars['String']>;
  nextStepsNotes?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  reportDateStart?: Maybe<Scalars['Date']>;
  reportDateEnd?: Maybe<Scalars['Date']>;
  sentAt?: Maybe<Scalars['Date']>;
  resentAt?: Maybe<Array<Maybe<Scalars['Date']>>>;
  createdAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ErecruitingSourcingServiceBriefingReportCreateResult = ErecruitingSourcingServiceBriefingReportResponse | ErecruitingSourcingServiceMutationError | ErecruitingSourcingServiceBadRequestError;

export type ErecruitingSourcingServiceBriefingReportResponse = {
  __typename?: 'ErecruitingSourcingServiceBriefingReportResponse';
  briefingReport: ErecruitingSourcingServiceBriefingReport;
};

export type ErecruitingSourcingServiceBriefingReportsCollectionResponse = {
  __typename?: 'ErecruitingSourcingServiceBriefingReportsCollectionResponse';
  total: Scalars['Int'];
  collection: Array<Maybe<ErecruitingSourcingServiceBriefingReport>>;
};

export type ErecruitingSourcingServiceBriefingResponse = {
  __typename?: 'ErecruitingSourcingServiceBriefingResponse';
  briefing?: Maybe<ErecruitingSourcingServiceBriefing>;
};

/** Types for Xing Sourcing Service Candidate Notes */
export type ErecruitingSourcingServiceCandidateNote = {
  __typename?: 'ErecruitingSourcingServiceCandidateNote';
  id: Scalars['ID'];
  candidateId: Scalars['ID'];
  candidateIdentityId: Scalars['ID'];
  /** #rest #virtual */
  briefing?: Maybe<ErecruitingSourcingServiceBriefingResponse>;
  consultantNotes?: Maybe<Scalars['String']>;
  clientNotes?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  creator?: Maybe<XingId>;
  creatorId: Scalars['ID'];
  noticePeriodId?: Maybe<Scalars['Int']>;
  salaryExpectationId?: Maybe<Scalars['Int']>;
  willingnessToRelocate?: Maybe<Scalars['Boolean']>;
  willingnessToTravelId?: Maybe<Scalars['Int']>;
  noticePeriodLocalizationKey?: Maybe<Scalars['String']>;
  salaryExpectationLocalizationKey?: Maybe<Scalars['String']>;
  willingnessToTravelLocalizationKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  urn: Scalars['GlobalID'];
};

export type ErecruitingSourcingServiceCandidateNoteListResponse = {
  __typename?: 'ErecruitingSourcingServiceCandidateNoteListResponse';
  total: Scalars['Int'];
  collection: Array<Maybe<ErecruitingSourcingServiceCandidateNote>>;
};

export type ErecruitingSourcingServiceCandidateNoteMutationResult = {
  __typename?: 'ErecruitingSourcingServiceCandidateNoteMutationResult';
  success?: Maybe<ErecruitingSourcingServiceCandidateNoteResponse>;
  error?: Maybe<Array<Maybe<ErecruitingSourcingServiceFieldMutationError>>>;
};

export type ErecruitingSourcingServiceCandidateNoteResponse = {
  __typename?: 'ErecruitingSourcingServiceCandidateNoteResponse';
  candidateNote?: Maybe<ErecruitingSourcingServiceCandidateNote>;
};

export type ErecruitingSourcingServiceCandidateRecommendationDiscardMutationResult = {
  __typename?: 'ErecruitingSourcingServiceCandidateRecommendationDiscardMutationResult';
  error?: Maybe<ErecruitingSourcingServiceMutationError>;
};

export type ErecruitingSourcingServiceCandidateRecommendationsDiscardInput = {
  xtmProjectId: Scalars['ID'];
  candidateUserId: Scalars['ID'];
};

export type ErecruitingSourcingServiceCandidateRecommendationsEntry = {
  __typename?: 'ErecruitingSourcingServiceCandidateRecommendationsEntry';
  position?: Maybe<Scalars['Int']>;
  highlights?: Maybe<Array<Maybe<Scalars['String']>>>;
  recoQuality?: Maybe<Scalars['String']>;
  urn?: Maybe<Scalars['String']>;
  trackingToken?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** #rest(batched) #virtual */
  profile: XingId;
  score?: Maybe<Scalars['Float']>;
  originalRecoQuality?: Maybe<Scalars['String']>;
  originalScore?: Maybe<Scalars['Float']>;
};

export type ErecruitingSourcingServiceCandidateRecommendationsOrderInput = {
  projectId: Scalars['ID'];
  candidateIds: Array<Maybe<Scalars['ID']>>;
};

export type ErecruitingSourcingServiceCandidateRecommendationsOrderResponse = {
  __typename?: 'ErecruitingSourcingServiceCandidateRecommendationsOrderResponse';
  entries: Array<Maybe<Scalars['ID']>>;
};

export type ErecruitingSourcingServiceCandidateRecommendationsResponse = {
  __typename?: 'ErecruitingSourcingServiceCandidateRecommendationsResponse';
  currentPage?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  totalResults?: Maybe<Scalars['Int']>;
  entries?: Maybe<Array<Maybe<ErecruitingSourcingServiceCandidateRecommendationsEntry>>>;
};

export type ErecruitingSourcingServiceChangeBriefingOwnerError = {
  __typename?: 'ErecruitingSourcingServiceChangeBriefingOwnerError';
  error?: Maybe<ErecruitingSourcingServiceMutationError>;
};

export type ErecruitingSourcingServiceChangeBriefingOwnerInput = {
  briefingId: Scalars['ID'];
  creatorId: Scalars['ID'];
  email?: Maybe<Scalars['Email']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ErecruitingSourcingServiceCreateBriefingCandidateInput = {
  briefingId: Scalars['Int'];
  candidateId: Scalars['Int'];
  userId: Scalars['Int'];
  briefingStatusId?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceCreateBriefingInput = {
  businessEmail: Scalars['Email'];
  businessPhoneNumber: Scalars['String'];
  careerLevelId: Scalars['Int'];
  companyId?: Maybe<Scalars['ID']>;
  companyName: Scalars['String'];
  companyNotes?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Currency>;
  disciplineId: Scalars['Int'];
  education?: Maybe<Scalars['String']>;
  courseOfStudy?: Maybe<Scalars['String']>;
  degree?: Maybe<Scalars['String']>;
  industryId: Scalars['Int'];
  jobDescription: Scalars['String'];
  jobLocationId: Scalars['Int'];
  jobPostCode?: Maybe<Scalars['String']>;
  jobroleId?: Maybe<Scalars['Int']>;
  jobTitle: Scalars['String'];
  jobType: Scalars['String'];
  leadershipResponsibility?: Maybe<Scalars['String']>;
  linkedRecordId?: Maybe<Scalars['Int']>;
  linkedRecordSource?: Maybe<Scalars['URL']>;
  linkedRecordType?: Maybe<Scalars['String']>;
  previousJobroleId?: Maybe<Scalars['Int']>;
  previousPosition?: Maybe<Scalars['String']>;
  referenceProfileId?: Maybe<Scalars['ID']>;
  requiredLanguages?: Maybe<Array<Maybe<ErecruitingSourcingServiceLanguageInput>>>;
  requiredSkills?: Maybe<Array<Maybe<Scalars['String']>>>;
  salaryRange?: Maybe<ErecruitingSourcingServiceSalaryRangeInput>;
  workExperienceId?: Maybe<Scalars['Int']>;
  productType?: Maybe<ErecruitingSourcingServiceProductType>;
  fullRemote?: Maybe<Scalars['Boolean']>;
  positionCountryCode?: Maybe<Scalars['String']>;
  positionLocationIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  positionLocationCoordinates?: Maybe<Array<Maybe<ErecruitingSourcingServiceBriefingCoordinatesInput>>>;
  positionLocationCities?: Maybe<Array<Maybe<Scalars['String']>>>;
  positionRadius?: Maybe<Scalars['Int']>;
  jobLocationCity?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceCreateBriefingReportInput = {
  briefingId: Scalars['ID'];
  projectId: Scalars['ID'];
  reportDateStart: Scalars['Date'];
  reportDateEnd: Scalars['Date'];
  consultantNotes?: Maybe<Scalars['String']>;
  nextStepsNotes: Scalars['String'];
  sentAt?: Maybe<Scalars['Date']>;
};

export type ErecruitingSourcingServiceCreateCandidateNoteInput = {
  briefingId: Scalars['Int'];
  candidateId: Scalars['Int'];
  candidateIdentityId: Scalars['Int'];
  consultantNotes: Scalars['String'];
  noticePeriodId?: Maybe<Scalars['Int']>;
  salaryExpectationId?: Maybe<Scalars['Int']>;
  willingnessToRelocate?: Maybe<Scalars['Boolean']>;
  willingnessToTravelId?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceCreateClientCandidateNoteInput = {
  briefingId: Scalars['ID'];
  candidateId: Scalars['ID'];
  candidateIdentityId: Scalars['ID'];
  clientNotes: Scalars['String'];
};

export type ErecruitingSourcingServiceDeleteBriefingCandidateInput = {
  briefingId: Scalars['Int'];
  candidateId: Scalars['Int'];
};

export type ErecruitingSourcingServiceDeleteBriefingCandidateMutationResult = {
  __typename?: 'ErecruitingSourcingServiceDeleteBriefingCandidateMutationResult';
  error?: Maybe<ErecruitingSourcingServiceMutationError>;
};

export type ErecruitingSourcingServiceDeleteMessageReminderInput = {
  id: Scalars['ID'];
};

export type ErecruitingSourcingServiceE2EUsersDeleteError = {
  __typename?: 'ErecruitingSourcingServiceE2EUsersDeleteError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Result type for deleting a document from user that returns 200 on success */
export type ErecruitingSourcingServiceE2EUsersDeleteResult = ErecruitingSourcingServiceE2EUsersDeleteSuccess | ErecruitingSourcingServiceE2EUsersDeleteError;

export type ErecruitingSourcingServiceE2EUsersDeleteSuccess = {
  __typename?: 'ErecruitingSourcingServiceE2EUsersDeleteSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ErecruitingSourcingServiceFieldMutationError = {
  __typename?: 'ErecruitingSourcingServiceFieldMutationError';
  field?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErecruitingSourcingServiceMutationError>>>;
};

export type ErecruitingSourcingServiceLanguage = {
  __typename?: 'ErecruitingSourcingServiceLanguage';
  code: Scalars['String'];
  levelId?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceLanguageInput = {
  code: Scalars['String'];
  levelId?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceMessageReminder = {
  __typename?: 'ErecruitingSourcingServiceMessageReminder';
  chatId: Scalars['ID'];
  briefingId: Scalars['ID'];
  projectId: Scalars['ID'];
  consultantId: Scalars['ID'];
  /** #rest(batched) #virtual */
  candidate?: Maybe<XingId>;
  firstReminder?: Maybe<ErecruitingSourcingServiceMessageReminderPartial>;
  secondReminder?: Maybe<ErecruitingSourcingServiceMessageReminderPartial>;
};

export type ErecruitingSourcingServiceMessageReminderMetadataMutationResult = {
  __typename?: 'ErecruitingSourcingServiceMessageReminderMetadataMutationResult';
  success?: Maybe<ErecruitingSourcingServiceMessageReminderMetadataResponse>;
  error?: Maybe<ErecruitingSourcingServiceMutationError>;
};

/** Types for Xing Sourcing Service Message Reminders */
export type ErecruitingSourcingServiceMessageReminderMetadataResponse = {
  __typename?: 'ErecruitingSourcingServiceMessageReminderMetadataResponse';
  briefingId: Scalars['ID'];
  projectId: Scalars['ID'];
  tone?: Maybe<ErecruitingSourcingServiceMessageTone>;
  enabled?: Maybe<Scalars['Boolean']>;
  /** #rest #virtual */
  firstReminder?: Maybe<XtmMessageTemplateResponse>;
  /** #rest #virtual */
  secondReminder?: Maybe<XtmMessageTemplateResponse>;
};

export type ErecruitingSourcingServiceMessageReminderPartial = {
  __typename?: 'ErecruitingSourcingServiceMessageReminderPartial';
  id: Scalars['ID'];
  /** @deprecated Field no longer supported */
  sent?: Maybe<Scalars['Boolean']>;
  type?: Maybe<ErecruitingSourcingServiceMessageReminderType>;
  status?: Maybe<ErecruitingSourcingServiceMessageReminderStatus>;
  expiresAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  sentAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

/** Types for Xing Sourcing Service Message Reminders */
export enum ErecruitingSourcingServiceMessageReminderStatus {
  Pending = 'PENDING',
  Sent = 'SENT',
  Failed = 'FAILED',
  MissingTemplate = 'MISSING_TEMPLATE'
}

export enum ErecruitingSourcingServiceMessageReminderType {
  FirstReminder = 'FIRST_REMINDER',
  SecondReminder = 'SECOND_REMINDER'
}

export type ErecruitingSourcingServiceMessageRemindersListResponse = {
  __typename?: 'ErecruitingSourcingServiceMessageRemindersListResponse';
  total: Scalars['Int'];
  collection: Array<Maybe<ErecruitingSourcingServiceMessageReminder>>;
};

export enum ErecruitingSourcingServiceMessageTone {
  Formal = 'FORMAL',
  Informal = 'INFORMAL'
}

export type ErecruitingSourcingServiceMutationError = Localizable & {
  __typename?: 'ErecruitingSourcingServiceMutationError';
  localizationKey: Scalars['String'];
  localizationValue: Scalars['String'];
};

export type ErecruitingSourcingServiceMutationResult = {
  __typename?: 'ErecruitingSourcingServiceMutationResult';
  success?: Maybe<ErecruitingSourcingServiceBriefingResponse>;
  error?: Maybe<Array<Maybe<ErecruitingSourcingServiceFieldMutationError>>>;
};

export type ErecruitingSourcingServiceNoticePeriod = {
  __typename?: 'ErecruitingSourcingServiceNoticePeriod';
  id: Scalars['Int'];
  localizationKey: Scalars['String'];
};

export type ErecruitingSourcingServiceNoticePeriodsListResponse = {
  __typename?: 'ErecruitingSourcingServiceNoticePeriodsListResponse';
  total: Scalars['Int'];
  collection: Array<Maybe<ErecruitingSourcingServiceNoticePeriod>>;
};

export enum ErecruitingSourcingServiceProductType {
  Shortlist = 'SHORTLIST',
  Longlist = 'LONGLIST'
}

export enum ErecruitingSourcingServiceProductTypeLowCase {
  Shortlist = 'shortlist',
  Longlist = 'longlist'
}

export type ErecruitingSourcingServiceSalaryExpectation = {
  __typename?: 'ErecruitingSourcingServiceSalaryExpectation';
  id: Scalars['Int'];
  localizationKey: Scalars['String'];
  value: Scalars['Int'];
};

export type ErecruitingSourcingServiceSalaryExpectationsListResponse = {
  __typename?: 'ErecruitingSourcingServiceSalaryExpectationsListResponse';
  total: Scalars['Int'];
  collection: Array<Maybe<ErecruitingSourcingServiceSalaryExpectation>>;
};

/** Types for Xing Sourcing Service Briefings */
export type ErecruitingSourcingServiceSalaryRange = {
  __typename?: 'ErecruitingSourcingServiceSalaryRange';
  minimum?: Maybe<Scalars['Int']>;
  maximum?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceSalaryRangeInput = {
  minimum?: Maybe<Scalars['Int']>;
  maximum?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceShareBriefingInput = {
  briefingId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type ErecruitingSourcingServiceShareResult = {
  __typename?: 'ErecruitingSourcingServiceShareResult';
  error?: Maybe<Array<Maybe<ErecruitingSourcingServiceFieldMutationError>>>;
};

export type ErecruitingSourcingServiceUpdateBriefingCandidateStatusInput = {
  userId: Scalars['Int'];
  briefingId: Scalars['Int'];
  candidateStatus: BriefingCandidateClientStatus;
};

export type ErecruitingSourcingServiceUpdateCandidateNoteInput = {
  briefingId: Scalars['Int'];
  candidateId: Scalars['Int'];
  candidateIdentityId?: Maybe<Scalars['Int']>;
  consultantNotes?: Maybe<Scalars['String']>;
  noticePeriodId?: Maybe<Scalars['Int']>;
  salaryExpectationId?: Maybe<Scalars['Int']>;
  willingnessToRelocate?: Maybe<Scalars['Boolean']>;
  willingnessToTravelId?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceUpdateClientCandidateNoteInput = {
  candidateNoteId: Scalars['ID'];
  clientNotes?: Maybe<Scalars['String']>;
};

export type ErecruitingSourcingServiceUpdateMessageReminderMetadataInput = {
  briefingId: Scalars['ID'];
  enableReminderMessages: Scalars['Boolean'];
  reminderMessagesTone?: Maybe<ErecruitingSourcingServiceMessageTone>;
  firstTemplateId?: Maybe<Scalars['ID']>;
  secondTemplateId?: Maybe<Scalars['ID']>;
};

export type ErecruitingSourcingServiceValidationError = {
  __typename?: 'ErecruitingSourcingServiceValidationError';
  path?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type ErecruitingSourcingServiceWillingnessToTravel = {
  __typename?: 'ErecruitingSourcingServiceWillingnessToTravel';
  id: Scalars['Int'];
  localizationKey: Scalars['String'];
  value: Scalars['Int'];
};

export type ErecruitingSourcingServiceWillingnessToTravelListResponse = {
  __typename?: 'ErecruitingSourcingServiceWillingnessToTravelListResponse';
  total: Scalars['Int'];
  collection: Array<Maybe<ErecruitingSourcingServiceWillingnessToTravel>>;
};

export type ErecruitingSourcingServiceXtmConversations = {
  __typename?: 'ErecruitingSourcingServiceXTMConversations';
  /** #rest #virtual */
  started?: Maybe<ErecruitingSourcingServiceXtmConversationsStarted>;
  /** #rest #virtual */
  responseRate?: Maybe<ErecruitingSourcingServiceXtmConversationsResponseRate>;
};

export type ErecruitingSourcingServiceXtmConversationsResponseRate = {
  __typename?: 'ErecruitingSourcingServiceXTMConversationsResponseRate';
  total?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceXtmConversationsStarted = {
  __typename?: 'ErecruitingSourcingServiceXTMConversationsStarted';
  total?: Maybe<Scalars['Int']>;
  histogram?: Maybe<Array<Maybe<ErecruitingSourcingServiceXtmHistogramResult>>>;
};

export type ErecruitingSourcingServiceXtmHistogramResult = {
  __typename?: 'ErecruitingSourcingServiceXTMHistogramResult';
  timestamp?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type ErecruitingSourcingServiceXtmProject = {
  __typename?: 'ErecruitingSourcingServiceXTMProject';
  id: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  consultant?: Maybe<XingId>;
  candidatesPreview?: Maybe<ErecruitingSourcingServiceXtmProjectCandidates>;
};

/** Types for XTM Projects (accessed specifically by XSS) */
export type ErecruitingSourcingServiceXtmProjectCandidate = {
  __typename?: 'ErecruitingSourcingServiceXTMProjectCandidate';
  id: Scalars['ID'];
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
};

export type ErecruitingSourcingServiceXtmProjectCandidates = {
  __typename?: 'ErecruitingSourcingServiceXTMProjectCandidates';
  total: Scalars['Int'];
  collection: Array<Maybe<ErecruitingSourcingServiceXtmProjectCandidate>>;
};

export type ErecruitingSourcingServiceXtmProjectResponse = {
  __typename?: 'ErecruitingSourcingServiceXTMProjectResponse';
  /** #expand */
  project?: Maybe<ErecruitingSourcingServiceXtmProject>;
};

export type ErecruitingSourcingServiceXtmReportDetails = {
  __typename?: 'ErecruitingSourcingServiceXTMReportDetails';
  /** #rest #virtual */
  statistics?: Maybe<ErecruitingSourcingServiceXtmReportDetailsStatistics>;
  conversations?: Maybe<ErecruitingSourcingServiceXtmConversations>;
};


export type ErecruitingSourcingServiceXtmReportDetailsStatisticsArgs = {
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};


export type ErecruitingSourcingServiceXtmReportDetailsConversationsArgs = {
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};

export type ErecruitingSourcingServiceXtmReportDetailsStatistics = {
  __typename?: 'ErecruitingSourcingServiceXTMReportDetailsStatistics';
  candidates?: Maybe<ErecruitingSourcingServiceXtmReportDetailsStatisticsCandidates>;
  candidatesPerStatus?: Maybe<Array<Maybe<ErecruitingSourcingServiceXtmStatusResult>>>;
  reviews?: Maybe<ErecruitingSourcingServiceXtmReportDetailsStatisticsReviews>;
};

export type ErecruitingSourcingServiceXtmReportDetailsStatisticsCandidates = {
  __typename?: 'ErecruitingSourcingServiceXTMReportDetailsStatisticsCandidates';
  total?: Maybe<Scalars['Int']>;
  histogram?: Maybe<Array<Maybe<ErecruitingSourcingServiceXtmHistogramResult>>>;
};

export type ErecruitingSourcingServiceXtmReportDetailsStatisticsReviews = {
  __typename?: 'ErecruitingSourcingServiceXTMReportDetailsStatisticsReviews';
  pendingCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  candidateCount?: Maybe<Scalars['Int']>;
  histogram?: Maybe<Array<Maybe<ErecruitingSourcingServiceXtmHistogramResult>>>;
};

export type ErecruitingSourcingServiceXtmStatusResult = {
  __typename?: 'ErecruitingSourcingServiceXTMStatusResult';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  /** #rest(batched) #virtual */
  candidates?: Maybe<Array<Maybe<XingId>>>;
};

export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  message: Scalars['String'];
};

export type Event = {
  __typename?: 'Event';
  /** #logged-out #soft-logged-in */
  agenda?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  agendaWithoutHtml?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  bookmarked?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  callToAction?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  callToActionLink?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  canBeShared?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  category?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  creator?: Maybe<XingId>;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  endsAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  endsAtTimeGiven?: Maybe<Scalars['Boolean']>;
  /** @deprecated Events is being shutdown on the 31-12-2022. Do not remove calls before this day. */
  eventLatestMessage?: Maybe<EventUserMessage>;
  /** #logged-out #soft-logged-in */
  eventPlus: Scalars['Boolean'];
  /** #soft-logged-in */
  externalLink?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  htmlDescription?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  language?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  latitude?: Maybe<Scalars['Float']>;
  /** #logged-out #soft-logged-in */
  linkedEvent: Scalars['Boolean'];
  /** #soft-logged-in */
  linkToExternalPage?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  linkToTicketingIframe?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  links: EventLinks;
  /** #logged-out #soft-logged-in */
  locationCity?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  locationCountry?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  locationName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  locationPostalCode?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  locationRegion?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  locationStreet?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  longitude?: Maybe<Scalars['Float']>;
  /** #logged-out #soft-logged-in */
  maxParticipants?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  meetup?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  online?: Maybe<Scalars['Boolean']>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Events is being shutdown on the 31-12-2022. Do not remove calls before this day.
   */
  organizer?: Maybe<EventOrganizer>;
  /** #logged-out #soft-logged-in */
  organizerType: Scalars['String'];
  /** #logged-out #soft-logged-in */
  participantsBatched?: Maybe<EventBatchedParticipants>;
  /** #logged-out #soft-logged-in */
  partnerType: Scalars['String'];
  /** #logged-out #soft-logged-in */
  registrationDeadlineAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  registrationDeadlineAtTimeGiven?: Maybe<Scalars['Boolean']>;
  reportable?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   * @deprecated Events is being shutdown on the 31-12-2022. Do not remove calls before this day.
   */
  rsvp?: Maybe<EventRsvp>;
  /** #logged-out #soft-logged-in */
  seatsAvailable?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  shortDescription?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  showTicketPrices?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  slug: Scalars['String'];
  /** #logged-out #soft-logged-in */
  startsAt: Scalars['Date'];
  /** #logged-out #soft-logged-in */
  startsAtTimeGiven: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  ticketCurrency?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  ticketPriceEnd?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  ticketPriceStart?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  ticketSoldAmount?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   * @deprecated Events is being shutdown on the 31-12-2022. Do not remove calls before this day.
   */
  tickets?: Maybe<EventTickets>;
  /** #logged-out #soft-logged-in */
  timeZone?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  targetUrn?: Maybe<Scalars['GlobalID']>;
  /** #soft-logged-in */
  updatedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  urn: Scalars['GlobalID'];
  /** #soft-logged-in */
  visibility?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  wideBannerUploaded: Scalars['Boolean'];
};


export type EventParticipantsBatchedArgs = {
  input: EventParticipantsBatchedQueryInput;
};

export type EventAdNetworkParticipants = {
  __typename?: 'EventAdNetworkParticipants';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<EventAdParticipant>>;
};

export type EventAdParticipant = {
  __typename?: 'EventAdParticipant';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  photoUrl: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  fullName: Scalars['String'];
};

export type EventBatchedParticipants = {
  __typename?: 'EventBatchedParticipants';
  /** #logged-out #soft-logged-in */
  total?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  collection: Array<EventParticipant>;
};

export enum EventContextFilter {
  Organized = 'ORGANIZED',
  SaidYes = 'SAID_YES',
  SaidMaybe = 'SAID_MAYBE',
  MyEvents = 'MY_EVENTS',
  ProfileVisible = 'PROFILE_VISIBLE'
}

export enum EventDraftFilter {
  /** Returns both draft and active events */
  All = 'ALL',
  /** Returns only active events. This is default option on backend if this filter is omitted */
  ExcludeDraftEvents = 'EXCLUDE_DRAFT_EVENTS',
  /** Returns only draft events */
  OnlyDraftEvents = 'ONLY_DRAFT_EVENTS'
}

export type EventGroupContainer = {
  __typename?: 'EventGroupContainer';
  groupId: Scalars['ID'];
  /** @deprecated Groups are going to be shutdown at the end of 2022. This field will stop working on 01/01/2023. */
  group?: Maybe<Community>;
};

/** Deprecated: Renamed to EventUserMessageReason */
export enum EventInvitationReason {
  Visitor = 'VISITOR',
  Group = 'GROUP',
  PastAttendees = 'PAST_ATTENDEES'
}

export type EventInvitationSignal = NetworkUpdatesStackItem & {
  __typename?: 'EventInvitationSignal';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  object?: Maybe<EventUserInvitation>;
  target?: Maybe<Event>;
  id: Scalars['ID'];
  stackId: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type EventInvitationStack = SignalsStack & {
  __typename?: 'EventInvitationStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type EventInvitationStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type EventLinks = {
  __typename?: 'EventLinks';
  /** #logged-out #soft-logged-in */
  public: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  wideBanner: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  wideBannerSmall: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  imageSquare48: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  imageSquare96: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  imageSquare128: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  imageSquare192: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  image: Scalars['URL'];
};

export type EventLocation = {
  __typename?: 'EventLocation';
  /** #logged-out #soft-logged-in */
  city?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  country?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  online: Scalars['Boolean'];
};

export type EventMyEventsQueryInput = {
  timeFilter?: Maybe<EventTimeFilter>;
  contextFilter?: Maybe<EventContextFilter>;
  draftFilter?: Maybe<EventDraftFilter>;
  ticketingFilter?: Maybe<EventTicketingFilter>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};

export enum EventNoRsvpReason {
  PastEvent = 'PAST_EVENT',
  DeadlinePassed = 'DEADLINE_PASSED',
  SoldOut = 'SOLD_OUT'
}

export type EventOrganizer = Community | Company | XingId | EventOrganizerName | GroupsGroup;

export type EventOrganizerName = {
  __typename?: 'EventOrganizerName';
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
};

/**
 * Query for the participants of an event.
 * The value of participations determines if you query for users who said yes or maybe or both.
 * The contactsCount field returns the info how many of your contacts are joining the event.
 * Please note that you can only query for contactsCount if you set participations to YES only.
 */
export type EventParticipant = {
  __typename?: 'EventParticipant';
  /** #logged-out #soft-logged-in */
  participation?: Maybe<EventParticipationKind>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  user?: Maybe<XingId>;
  /** #soft-logged-in #rest(batched) #virtual */
  contactDistance?: Maybe<ContactDistance>;
  /** #soft-logged-in #rest(batched) #virtual */
  networkRelationship?: Maybe<NetworkRelationship>;
  new?: Maybe<Scalars['Boolean']>;
};

export type EventParticipants = {
  __typename?: 'EventParticipants';
  /** #logged-out #soft-logged-in */
  total?: Maybe<Scalars['Int']>;
  /** #soft-logged-in */
  contactsCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  collection: Array<EventParticipant>;
  /** only returned for organizer */
  participantsCount?: Maybe<ParticipantsCount>;
};

export type EventParticipantsBatchedQueryInput = {
  participation: EventParticipationKind;
};

export enum EventParticipantsOrder {
  RegistrationDate = 'REGISTRATION_DATE'
}

export type EventParticipantsQueryInput = {
  participations?: Maybe<Array<EventParticipationKind>>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  order?: Maybe<EventParticipantsOrder>;
};

export enum EventParticipationKind {
  /** The user is participating in the event */
  Yes = 'YES',
  No = 'NO',
  Maybe = 'MAYBE',
  Unanswered = 'UNANSWERED'
}

export type EventRecommendation = Recommendation & {
  __typename?: 'EventRecommendation';
  event?: Maybe<Event>;
  trackingToken: Scalars['String'];
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
};

export type EventRsvp = {
  __typename?: 'EventRsvp';
  /** #soft-logged-in */
  options?: Maybe<EventRsvpOptions>;
  /** #soft-logged-in */
  noRsvpReason?: Maybe<EventNoRsvpReason>;
};

export enum EventRsvpOptionState {
  Selected = 'SELECTED',
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type EventRsvpOptions = {
  __typename?: 'EventRsvpOptions';
  /** #soft-logged-in */
  yes?: Maybe<EventRsvpOptionState>;
  /** #soft-logged-in */
  no?: Maybe<EventRsvpOptionState>;
  /** #soft-logged-in */
  maybe?: Maybe<EventRsvpOptionState>;
  /** #soft-logged-in */
  buyTicket?: Maybe<EventRsvpOptionState>;
};

/** Settings related to events */
export type EventSettings = {
  __typename?: 'EventSettings';
  /** Get people to meet mail */
  peopleToMeetMail?: Maybe<ToggleSetting>;
  /** Get insights mail */
  insightsMail?: Maybe<ToggleSetting>;
  /** Get past attendees invitation */
  pastAttendeesInvitation?: Maybe<ToggleSetting>;
  /** Get new comment mail */
  newCommentMail?: Maybe<ToggleSetting>;
  /** Get new visitors of my event mail */
  newVomesMail?: Maybe<ToggleSetting>;
  /** Get RSVP change mail */
  rsvpChangeMail?: Maybe<ToggleSetting>;
  /** Get visitors of my event invitation */
  vomeInvitation?: Maybe<ToggleSetting>;
  /** Get event changed mail */
  eventChangedMail?: Maybe<ToggleSetting>;
  /** Get contact invitation */
  contactInvitation?: Maybe<ToggleSetting>;
  /** Get mail about next steps */
  nextStepsMail?: Maybe<ToggleSetting>;
};

export type EventTicket = {
  __typename?: 'EventTicket';
  /** #soft-logged-in */
  displayId?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  firstName?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  lastName?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  ticketCategory?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  qrCodeUrl?: Maybe<Scalars['URL']>;
};

export enum EventTicketingFilter {
  /** Returns both ticketing and non-ticketing events. This is default option on backend if this filter is omitted */
  All = 'ALL',
  /** Returns only non-ticketing events */
  ExcludeTicketingEvents = 'EXCLUDE_TICKETING_EVENTS',
  /** Returns only ticketing events */
  OnlyTicketingEvents = 'ONLY_TICKETING_EVENTS'
}

export type EventTickets = {
  __typename?: 'EventTickets';
  /** #expand #soft-logged-in */
  tickets: Array<EventTicket>;
};

export enum EventTimeFilter {
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type EventUserEvent = {
  __typename?: 'EventUserEvent';
  eventId: Scalars['ID'];
  event?: Maybe<Event>;
};

export type EventUserEvents = {
  __typename?: 'EventUserEvents';
  total?: Maybe<Scalars['Int']>;
  collection: Array<EventUserEvent>;
};

export type EventUserInvitation = {
  __typename?: 'EventUserInvitation';
  collection: Array<Invitation>;
};

export type EventUserInvitations = {
  __typename?: 'EventUserInvitations';
  total: Scalars['Int'];
  unreadCount: Scalars['Int'];
  collection: Array<Invitation>;
};

export type EventUserInvitationsQueryInput = {
  timeFilter: EventTimeFilter;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};

export type EventUserMessage = {
  id: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  reason?: Maybe<EventUserMessageReason>;
  createdAt?: Maybe<Scalars['Date']>;
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  senderId: Scalars['ID'];
  /** #rest(batched) #virtual */
  sender?: Maybe<XingId>;
  group?: Maybe<EventGroupContainer>;
  /** #rest(batched) #virtual */
  source?: Maybe<Source>;
  eventId: Scalars['ID'];
  event?: Maybe<Event>;
};

export type EventUserMessageCancellation = EventUserMessage & {
  __typename?: 'EventUserMessageCancellation';
  id: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  reason?: Maybe<EventUserMessageReason>;
  createdAt?: Maybe<Scalars['Date']>;
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  senderId: Scalars['ID'];
  /** #rest(batched) #virtual */
  sender?: Maybe<XingId>;
  group?: Maybe<EventGroupContainer>;
  /** #rest(batched) #virtual */
  source?: Maybe<Source>;
  eventId: Scalars['ID'];
  event?: Maybe<Event>;
};

export type EventUserMessageDisinvite = EventUserMessage & {
  __typename?: 'EventUserMessageDisinvite';
  id: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  reason?: Maybe<EventUserMessageReason>;
  createdAt?: Maybe<Scalars['Date']>;
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  senderId: Scalars['ID'];
  /** #rest(batched) #virtual */
  sender?: Maybe<XingId>;
  group?: Maybe<EventGroupContainer>;
  /** #rest(batched) #virtual */
  source?: Maybe<Source>;
  eventId: Scalars['ID'];
  event?: Maybe<Event>;
};

export type EventUserMessageGuestlist = EventUserMessage & {
  __typename?: 'EventUserMessageGuestlist';
  id: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  reason?: Maybe<EventUserMessageReason>;
  createdAt?: Maybe<Scalars['Date']>;
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  senderId: Scalars['ID'];
  /** #rest(batched) #virtual */
  sender?: Maybe<XingId>;
  group?: Maybe<EventGroupContainer>;
  /** #rest(batched) #virtual */
  source?: Maybe<Source>;
  eventId: Scalars['ID'];
  event?: Maybe<Event>;
};

export type EventUserMessageInvitation = EventUserMessage & {
  __typename?: 'EventUserMessageInvitation';
  id: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  reason?: Maybe<EventUserMessageReason>;
  createdAt?: Maybe<Scalars['Date']>;
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  senderId: Scalars['ID'];
  /** #rest(batched) #virtual */
  sender?: Maybe<XingId>;
  group?: Maybe<EventGroupContainer>;
  /** #rest(batched) #virtual */
  source?: Maybe<Source>;
  eventId: Scalars['ID'];
  event?: Maybe<Event>;
};

export type EventUserMessageModification = EventUserMessage & {
  __typename?: 'EventUserMessageModification';
  id: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  reason?: Maybe<EventUserMessageReason>;
  createdAt?: Maybe<Scalars['Date']>;
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  senderId: Scalars['ID'];
  /** #rest(batched) #virtual */
  sender?: Maybe<XingId>;
  group?: Maybe<EventGroupContainer>;
  /** #rest(batched) #virtual */
  source?: Maybe<Source>;
  eventId: Scalars['ID'];
  event?: Maybe<Event>;
};

export enum EventUserMessageReason {
  Visitor = 'VISITOR',
  Group = 'GROUP',
  PastAttendees = 'PAST_ATTENDEES'
}

export type EventUserMessageRescheduling = EventUserMessage & {
  __typename?: 'EventUserMessageRescheduling';
  id: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  reason?: Maybe<EventUserMessageReason>;
  createdAt?: Maybe<Scalars['Date']>;
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  senderId: Scalars['ID'];
  /** #rest(batched) #virtual */
  sender?: Maybe<XingId>;
  group?: Maybe<EventGroupContainer>;
  /** #rest(batched) #virtual */
  source?: Maybe<Source>;
  eventId: Scalars['ID'];
  event?: Maybe<Event>;
};

export type Events = {
  __typename?: 'Events';
  /** #logged-out #soft-logged-in */
  total?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  collection: Array<EventsItem>;
};

export type EventsGroupsGroupCounters = {
  __typename?: 'EventsGroupsGroupCounters';
  /** #logged-out #soft-logged-in */
  upcomingEvents: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pastEvents: Scalars['Int'];
};

export type EventsItem = {
  __typename?: 'EventsItem';
  /** #logged-out #soft-logged-in */
  event?: Maybe<Event>;
};

export type ExposeMatch = {
  __typename?: 'ExposeMatch';
  type: Scalars['String'];
  match: ExposeMatchType;
  label: Scalars['String'];
};

export enum ExposeMatchType {
  Yes = 'YES',
  No = 'NO',
  Uprise = 'UPRISE'
}


export type ExternalEducationalExperience = {
  __typename?: 'ExternalEducationalExperience';
  globalId: Scalars['GlobalID'];
  schoolName?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  degree?: Maybe<Scalars['String']>;
  schoolNotes?: Maybe<Scalars['String']>;
  beginDate?: Maybe<ProfileYearAndMonth>;
  endDate?: Maybe<ProfileYearAndMonth>;
  localizedTimeString?: Maybe<Scalars['String']>;
};

export type ExternalUpdate = {
  id: Scalars['ID'];
  objectUrn: Scalars['GlobalID'];
};

export type ExternalUpdateEducation = ExternalUpdate & {
  __typename?: 'ExternalUpdateEducation';
  details: ExternalEducationalExperience;
  id: Scalars['ID'];
  objectUrn: Scalars['GlobalID'];
};

export type ExternalUpdateMutationError = {
  __typename?: 'ExternalUpdateMutationError';
  message?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['JSON']>;
};

export type ExternalUpdateMutationResult = ExternalUpdateMutationSuccess | ExternalUpdateMutationError;

export type ExternalUpdateMutationSuccess = {
  __typename?: 'ExternalUpdateMutationSuccess';
  message?: Maybe<Scalars['String']>;
};

export type ExternalUpdateWorkExperience = ExternalUpdate & {
  __typename?: 'ExternalUpdateWorkExperience';
  details: ExternalWorkExperience;
  id: Scalars['ID'];
  objectUrn: Scalars['GlobalID'];
};

export type ExternalUpdatesApplyInput = {
  globalIds?: Maybe<Array<Maybe<Scalars['GlobalID']>>>;
};

export type ExternalUpdatesCollection = {
  __typename?: 'ExternalUpdatesCollection';
  collection: Array<ExternalUpdate>;
};

export type ExternalUrlDescription = {
  __typename?: 'ExternalUrlDescription';
  /** #logged-out #soft-logged-in */
  htmlContent: Scalars['String'];
  /** #logged-out #soft-logged-in */
  url: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  proxyUrl: Scalars['URL'];
};

/** VOMP External Type */
export type ExternalVomp = VompVisit & {
  __typename?: 'ExternalVomp';
  visitorId: Scalars['ID'];
  type: Scalars['String'];
  viewedAt: Scalars['Date'];
};

export type ExternalVompError = {
  __typename?: 'ExternalVompError';
  /** Tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** Contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ExternalVompInput = {
  visitor: ExternalVompVisitor;
  visitee: ExternalVompVisitee;
  visit: ExternalVompVisit;
};

/** Result type for external VOMP creation that returns 204 on success */
export type ExternalVompResult = {
  __typename?: 'ExternalVompResult';
  error?: Maybe<ExternalVompError>;
  success?: Maybe<ExternalVompSuccess>;
};

export type ExternalVompSuccess = {
  __typename?: 'ExternalVompSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ExternalVompVisit = {
  platform: VompPlatformEnum;
  referer: Scalars['String'];
};

export type ExternalVompVisitee = {
  pageName: Scalars['String'];
};

export type ExternalVompVisitor = {
  ipAddress: Scalars['String'];
};

export type ExternalWorkExperience = {
  __typename?: 'ExternalWorkExperience';
  globalId: Scalars['GlobalID'];
  jobTitle: Scalars['String'];
  levelId?: Maybe<Scalars['ID']>;
  disciplineId?: Maybe<Scalars['ID']>;
  companyName?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  industryId?: Maybe<Scalars['ID']>;
  statusId?: Maybe<Scalars['ID']>;
  beginDate?: Maybe<ProfileYearAndMonth>;
  endDate?: Maybe<ProfileYearAndMonth>;
  localizedTimeString?: Maybe<Scalars['String']>;
};

export type ExtraData = {
  __typename?: 'ExtraData';
  /**
   * #soft-logged-in
   *
   *  This ExtraData is the result data as we get from the datasource (ElasticSearch for incremental results) without request entity info though others X1 APIS.
   * Ideally it's better to get entity data from REST APIS (for consistency) but as it's much slower you can use directly this. All entity types are treated like a unified result type with title, subtitle and thumbnail. For any other information you need extend the result to call entities X1 APIS
   */
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['URL']>;
  url?: Maybe<Scalars['URL']>;
};

export enum FabiBackgroundJobStatus {
  InProgress = 'IN_PROGRESS',
  Ok = 'OK',
  Error = 'ERROR'
}

export type FabiBadRequest = {
  __typename?: 'FabiBadRequest';
  /** #logged-out #soft-logged-in */
  message: Scalars['String'];
};

export type FabiGeneratedQuery = {
  __typename?: 'FabiGeneratedQuery';
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  query: Scalars['String'];
};

export enum FabiJobSearchContentType {
  Markdown = 'MARKDOWN'
}

export type FabiJobSearchInput = {
  consumer: Scalars['String'];
  queryText: Scalars['String'];
  supportedContentTypes: Array<FabiJobSearchContentType>;
  supportedResponseStyles: Array<FabiResponseStyle>;
};

export type FabiJobSearchMatchingReason = {
  __typename?: 'FabiJobSearchMatchingReason';
  /** #logged-out #soft-logged-in */
  jobPostingId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  markdown: Scalars['String'];
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
};

export type FabiJobSearchMatchingReasonsPollResponse = {
  __typename?: 'FabiJobSearchMatchingReasonsPollResponse';
  /** #logged-out #soft-logged-in */
  status: FabiBackgroundJobStatus;
  /** #logged-out #soft-logged-in */
  result?: Maybe<FabiJobSearchMatchingReasonsResult>;
  /** #logged-out #soft-logged-in */
  errorMessage?: Maybe<Scalars['String']>;
};

export type FabiJobSearchMatchingReasonsResult = {
  __typename?: 'FabiJobSearchMatchingReasonsResult';
  /** #logged-out #soft-logged-in */
  matchingReasons: Array<FabiJobSearchMatchingReason>;
};

export type FabiJobSearchMessage = {
  __typename?: 'FabiJobSearchMessage';
  /** #logged-out #soft-logged-in */
  providerId: Scalars['String'];
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  content: FabiJobSearchMessageContent;
  /** #logged-out #soft-logged-in */
  includeFeedback: Scalars['Boolean'];
};

export type FabiJobSearchMessageContent = FabiMarkdown;

export type FabiJobSearchQueryGenerationEarnMoreSpecific = {
  __typename?: 'FabiJobSearchQueryGenerationEarnMoreSpecific';
  /** #logged-out #soft-logged-in */
  salaryPreferencePresent: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  avgJobRoleSalary?: Maybe<Scalars['Int']>;
};

export type FabiJobSearchQueryGenerationInput = {
  consumer: Scalars['String'];
  useCase: FabiJobSearchQueryGenerationUseCase;
  userQuery?: Maybe<Scalars['String']>;
  dryRun?: Maybe<Scalars['Boolean']>;
};

export type FabiJobSearchQueryGenerationResponse = FabiJobSearchQueryGenerationResult | FabiBadRequest;

export type FabiJobSearchQueryGenerationResult = {
  __typename?: 'FabiJobSearchQueryGenerationResult';
  /** #logged-out #soft-logged-in */
  requestTrackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  queries: Array<Maybe<FabiGeneratedQuery>>;
  /** #logged-out #soft-logged-in */
  enoughProfileData: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  earnMoreSpecific?: Maybe<FabiJobSearchQueryGenerationEarnMoreSpecific>;
};

export enum FabiJobSearchQueryGenerationUseCase {
  SearchWithProfile = 'SEARCH_WITH_PROFILE',
  SearchWithSkills = 'SEARCH_WITH_SKILLS',
  EarnMore = 'EARN_MORE'
}

export type FabiJobSearchResponse = FabiJobSearchResult | FabiBadRequest;

export type FabiJobSearchResult = {
  __typename?: 'FabiJobSearchResult';
  /** #logged-out #soft-logged-in */
  requestTrackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  queryText: Scalars['String'];
  /** #logged-out #soft-logged-in */
  responseStyle: FabiResponseStyle;
  /** #logged-out #soft-logged-in */
  messages: Array<FabiJobSearchMessage>;
};

export type FabiMarkdown = {
  __typename?: 'FabiMarkdown';
  /** #logged-out #soft-logged-in */
  markdown: Scalars['String'];
};

export enum FabiResponseStyle {
  Loud = 'LOUD',
  Quiet = 'QUIET'
}

export type FallbackAboutUsFacts = {
  __typename?: 'FallbackAboutUsFacts';
  /** #logged-out #soft-logged-in */
  message: Scalars['String'];
};

export type FallbackAddress = {
  __typename?: 'FallbackAddress';
  city?: Maybe<Scalars['String']>;
};

export type FallbackCompany = {
  __typename?: 'FallbackCompany';
  companyName?: Maybe<Scalars['String']>;
  address?: Maybe<FallbackAddress>;
};

/** Platform features for the requesting user */
export type Feature = {
  __typename?: 'Feature';
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer is a Xing employee
   */
  isXingEmployee?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer is a jobs poster
   */
  isJobsPoster?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer is an admaster
   */
  isAdmasterUser?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer is a brand page collaborator
   */
  isBrandPageCollaborator?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer is a basic user
   */
  isBasic?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer is a premium user
   */
  isPremium?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer is an executive
   */
  isExecutive?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer is a sales user
   */
  isSales?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer has ProJobs membership
   */
  hasProJobsMembership?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer has xtm user rights. Use this feature to identify an XTM user membership
   */
  isCraUser?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer has xtp user rights. Use this feature to identify an XTP user membership
   */
  isXtpUser?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag shows if the viewer is a seat manager admin
   */
  isSeatManagerAdmin?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag to show ProBusiness navigation
   */
  showProbusinessInNavigation?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag to show if the viewer is a Benefits Plus user
   */
  isBenefitsPlus?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag to show if the viewer is a Pro Freelancer user
   */
  isProFreelancer?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag to show the upsell hint for paying premium and branded startpage premium users
   */
  showUpsellHint?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag to show JobSeeker boneyard upsell hint
   */
  showJobSeekerBoneyardUpsellHint?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag to show upsell hint for premium members
   */
  showPremiumBoneyardUpsellHint?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag to use campus prominent position
   */
  isCampusProminentPosition?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag to show if the viewer has coach profile
   */
  hasCoachProfile?: Maybe<Scalars['Boolean']>;
  /** Flag to show whether the viewer has the 2018 settings already */
  hasNewSettings?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Flag to use campus normal position
   */
  isCampusNormalPosition?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Indicates that the user can access the Xing BrandManager (XBM)
   */
  isBrandManagerEditor?: Maybe<Scalars['Boolean']>;
};

export type FeatureSwitchesExperiment = {
  __typename?: 'FeatureSwitchesExperiment';
  /** #logged-out #soft-logged-in */
  name: Scalars['String'];
  /** #logged-out #soft-logged-in */
  variant: Scalars['String'];
};

export type FeatureSwitchesExperimentsCollection = {
  __typename?: 'FeatureSwitchesExperimentsCollection';
  /** #logged-out #soft-logged-in */
  collection: Array<FeatureSwitchesExperiment>;
};

export type FeatureSwitchesExperimentsForceVariantErrorResult = {
  __typename?: 'FeatureSwitchesExperimentsForceVariantErrorResult';
  message?: Maybe<Scalars['String']>;
};

export type FeatureSwitchesExperimentsForceVariantInput = {
  name: Scalars['String'];
  variant: Scalars['String'];
};

export type FeatureSwitchesExperimentsForceVariantResult = {
  __typename?: 'FeatureSwitchesExperimentsForceVariantResult';
  success?: Maybe<FeatureSwitchesExperimentsForceVariantSuccessResult>;
  error?: Maybe<FeatureSwitchesExperimentsForceVariantErrorResult>;
};

export type FeatureSwitchesExperimentsForceVariantSuccessResult = {
  __typename?: 'FeatureSwitchesExperimentsForceVariantSuccessResult';
  experiment: FeatureSwitchesExperiment;
};

export type FeatureSwitchesNewNotificationCenterMutationError = {
  __typename?: 'FeatureSwitchesNewNotificationCenterMutationError';
  error?: Maybe<NewNotificationCenterMutationError>;
};

export type FeatureSwitchesNewNotificationCenterMutationResult = FeatureSwitchesNewNotificationCenterMutationSuccess | FeatureSwitchesNewNotificationCenterMutationError;

export type FeatureSwitchesNewNotificationCenterMutationSuccess = {
  __typename?: 'FeatureSwitchesNewNotificationCenterMutationSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type FeatureSwitchesVerticalNavigationMutationError = {
  __typename?: 'FeatureSwitchesVerticalNavigationMutationError';
  error?: Maybe<VerticalNavigationMutationError>;
};

export type FeatureSwitchesVerticalNavigationMutationResult = FeatureSwitchesVerticalNavigationMutationSuccess | FeatureSwitchesVerticalNavigationMutationError;

export type FeatureSwitchesVerticalNavigationMutationSuccess = {
  __typename?: 'FeatureSwitchesVerticalNavigationMutationSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type FeedyPreviewMetadata = PreviewMetadata & {
  __typename?: 'FeedyPreviewMetadata';
  objectUrn: Scalars['GlobalID'];
  sourceActor?: Maybe<LinkPreviewSourceActor>;
};

/** Fenced representation of a user at XING */
export type FencedProfileVisitor = {
  __typename?: 'FencedProfileVisitor';
  /** #rest #virtual */
  userFlags?: Maybe<UserFlags>;
  profileImage?: Maybe<Array<Maybe<ProfileImage>>>;
  /** #rest(batched) #virtual */
  profileOccupation?: Maybe<FencedProfileVisitorOccupation>;
  /**
   * #rest(batched) #virtual
   *
   *  Request Click Reason data by its ID.
   */
  clickReasonProfileUrl?: Maybe<ClickReason>;
  /**
   * #rest(batched) #virtual
   *
   *  Request Click Reason data by its ID from a specific Entity.
   * SourceEntityId is basically the ID of the entity where the profile URL was seen and clicked.
   * For instance, if you see a profile link in a group, the sourceEntityId will be the group ID.
   */
  clickReasonProfileUrlFromEntity?: Maybe<ClickReason>;
};


/** Fenced representation of a user at XING */
export type FencedProfileVisitorProfileImageArgs = {
  size: Array<ProfileImageSize>;
};


/** Fenced representation of a user at XING */
export type FencedProfileVisitorClickReasonProfileUrlArgs = {
  clickReasonId: ClickReasonsEnum;
};


/** Fenced representation of a user at XING */
export type FencedProfileVisitorClickReasonProfileUrlFromEntityArgs = {
  clickReasonId: ClickReasonsEnum;
  sourceEntityId: Scalars['SlugOrID'];
};

/** Fenced representation of the user occupation */
export type FencedProfileVisitorOccupation = {
  __typename?: 'FencedProfileVisitorOccupation';
  occupationTitle?: Maybe<Scalars['String']>;
};

/** Fenced Qualified VOMP's visitor */
export type FencedQualifiedVompVisitor = {
  __typename?: 'FencedQualifiedVompVisitor';
  /** #logged-out #soft-logged-in */
  profileImage?: Maybe<Array<Maybe<ProfileImage>>>;
};


/** Fenced Qualified VOMP's visitor */
export type FencedQualifiedVompVisitorProfileImageArgs = {
  size: Array<ProfileImageSize>;
};

/** VOMP Fenced Type */
export type FencedVomp = VompVisit & {
  __typename?: 'FencedVomp';
  /** #rest(batched) #virtual */
  actor?: Maybe<FencedProfileVisitor>;
  visitorId: Scalars['ID'];
  type: Scalars['String'];
  viewedAt: Scalars['Date'];
};

export type FetchComplaintsReportResult = {
  __typename?: 'FetchComplaintsReportResult';
  /** #logged-out #soft-logged-in */
  report?: Maybe<ComplaintsReport>;
};

export type FileCustomQuestion = BaseApplyQuestion & {
  __typename?: 'FileCustomQuestion';
  /** #logged-out #soft-logged-in */
  maxSizeInBytes?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  supportedTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

export type FollowContext = {
  __typename?: 'FollowContext';
  isFollowing: Scalars['Boolean'];
};

export type FollowedCompanies = {
  __typename?: 'FollowedCompanies';
  /** #rest(batched) #virtual */
  company?: Maybe<Company>;
};

export type FollowedCompaniesConnection = HasCursorPagination & {
  __typename?: 'FollowedCompaniesConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<FollowedCompaniesEdge>>>;
};

export type FollowedCompaniesEdge = PaginationEdge & {
  __typename?: 'FollowedCompaniesEdge';
  cursor: Scalars['String'];
  node?: Maybe<FollowedCompanies>;
};

/** Specifies the field to sort by */
export enum FollowedCompaniesSortField {
  CreatedAt = 'created_at',
  Name = 'name',
  FollowersCount = 'followers_count',
  DateFollowed = 'date_followed'
}

/** Specifies the sort direction (asc/desc) */
export enum FollowedCompaniesSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

/** Denotes a follower of an entity */
export type Follower = {
  __typename?: 'Follower';
  /** #logged-out #soft-logged-in */
  userId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  updatedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  profile?: Maybe<XingId>;
};

export type FollowersConnection = HasCursorPagination & {
  __typename?: 'FollowersConnection';
  /** #logged-out #soft-logged-in */
  edges: Array<Maybe<FollowersEdge>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
};

export type FollowersCount = {
  __typename?: 'FollowersCount';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  count: Scalars['Int'];
};

export type FollowersEdge = PaginationEdge & {
  __typename?: 'FollowersEdge';
  /** #logged-out #soft-logged-in */
  node?: Maybe<Follower>;
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
};

export type FollowersFollowError = {
  __typename?: 'FollowersFollowError';
  message?: Maybe<Scalars['String']>;
};

export type FollowersFollowingCollection = {
  __typename?: 'FollowersFollowingCollection';
  total?: Maybe<Scalars['Int']>;
  collection?: Maybe<Array<Maybe<Follower>>>;
};

export enum FollowersFollowingNamespace {
  Companies = 'COMPANIES',
  Disco = 'DISCO',
  Entitypages = 'ENTITYPAGES'
}

export enum FollowersFollowingOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum FollowersFollowingSort {
  UserId = 'USER_ID',
  UpdatedAt = 'UPDATED_AT'
}

export enum FollowersFollowingType {
  Company = 'COMPANY',
  Topic = 'TOPIC',
  Page = 'PAGE'
}

export type FollowersMutationInput = {
  followedUrn: Scalars['GlobalID'];
};

export type FollowersMutationResult = {
  __typename?: 'FollowersMutationResult';
  error?: Maybe<FollowersFollowError>;
};

export type Form = {
  __typename?: 'Form';
  /** #logged-out #soft-logged-in */
  type?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  placeholder?: Maybe<Scalars['String']>;
};

export type FormExternalDocuments = {
  __typename?: 'FormExternalDocuments';
  /** #logged-out #soft-logged-in */
  externalDocuments: Array<Maybe<JobApplicationFormExternalDoc>>;
};

export type FormSettings = {
  __typename?: 'FormSettings';
  /** #logged-out #soft-logged-in */
  maxAdditionalDocuments: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  disableAdditionalComments: Scalars['Boolean'];
};

export type FullTrackingInput = {
  consumer: Scalars['String'];
  service: Scalars['String'];
  trackingToken: Scalars['String'];
  interactionType: Scalars['String'];
  userId?: Maybe<Scalars['ID']>;
  position?: Maybe<Scalars['Int']>;
  receivedTimestamp?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
};

/** This type represents a GPS coordinate pair that enforces both members to be present */
export type GpsCoordinates = {
  __typename?: 'GPSCoordinates';
  /** #logged-out #soft-logged-in */
  latitude: Scalars['Float'];
  /** #logged-out #soft-logged-in */
  longitude: Scalars['Float'];
};

/** Available genders. The `NONE` value indicates the user has not specified their gender. */
export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
  Other = 'OTHER',
  None = 'NONE'
}

export type GenericLocalizable = Localizable & {
  __typename?: 'GenericLocalizable';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
};

export enum GetWillingnessToTravelEnum {
  None = 'NONE',
  Occasional = 'OCCASIONAL',
  Frequent = 'FREQUENT'
}


export type GroupAggregations = {
  __typename?: 'GroupAggregations';
  category?: Maybe<Array<Maybe<Aggregation>>>;
  memberCount?: Maybe<Array<Maybe<Aggregation>>>;
  mode?: Maybe<Array<Maybe<Aggregation>>>;
};

export type GroupAggregationsInput = {
  /**
   * category: Maximum number of distinct values to be returned by this aggregation
   * memberCount: Maximum number of distinct values to be returned by this aggregation
   * mode: Maximum number of distinct values to be returned by this aggregation.
   */
  category?: Maybe<Scalars['String']>;
  memberCount?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
};

/** Deprecated: Renamed to EventGroupContainer */
export type GroupContainer = {
  __typename?: 'GroupContainer';
  groupId: Scalars['ID'];
  /** @deprecated Groups are going to be shutdown at the end of 2022. This field will stop working on 01/01/2023. */
  group?: Maybe<Community>;
};

export type GroupFiltersInput = {
  /**
   * Available filters for group search
   * category: Filter results which match ANY of the given values(comma separated).
   *           Example of categories used:
   *             'offizielle_xing_regional_ambassador_gruppen', 'offizielle_xing_xpert_ambassador_gruppen',
   *             'offizielle_xing_themen_gruppen'
   * approved: true or false. True by default
   * deleted: true or false. False by default
   * memberCount: Defines range(comma separated) for member_count for filtering results.
   *              Supported formats are:
   *                123/456: values larger than 123 but smaller than 456
   *                /456: values smaller than 456
   *                123/: values larger than 123
   *                Date ranges are also supported, using the format yyyy-MM-ddThh:mm:ssZ
   *                Example values: '0/200,201/500,501/1000,1001/5000,5001'
   * xing_internal: Filter results which match ANY of the given values(comma separated)
   * mode: Local if the group is a meetup, Online if it is a normal group
   */
  approved?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['String']>;
  memberCount?: Maybe<Scalars['String']>;
  xingInternal?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
};

export enum GroupMode {
  Local = 'LOCAL',
  Online = 'ONLINE'
}

export type GroupSearchConnection = HasCursorPagination & {
  __typename?: 'GroupSearchConnection';
  edges: Array<GroupSearchEdge>;
  aggs?: Maybe<GroupAggregations>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type GroupSearchEdge = PaginationEdge & {
  __typename?: 'GroupSearchEdge';
  node?: Maybe<UniversalSearchGroupResult>;
  /** #virtual */
  cursor: Scalars['String'];
};

/** Settings of the user which apply to a single individual group */
export type GroupSetting = {
  __typename?: 'GroupSetting';
  groupName: Scalars['String'];
  groupId: Scalars['ID'];
  /** Group has classifieds */
  hasMarketplace: Scalars['Boolean'];
  /** User wants to receive the notifications about new posts */
  newPosts: Scalars['Boolean'];
  /** User wants to receive the notifications about moderator news */
  moderatorNews: Scalars['Boolean'];
  /** User wants to be receive event invitations */
  eventInvitations: Scalars['Boolean'];
  /** User wants to receive the notifications about new classifieds */
  newClassifieds?: Maybe<Scalars['Boolean']>;
  /** Shows membership of the group */
  visible: Scalars['Boolean'];
};

export type GroupsAboutUsFacts = {
  __typename?: 'GroupsAboutUsFacts';
  /** #logged-out #soft-logged-in */
  imprint?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  properties?: Maybe<AboutUsFactsProperties>;
  /** #logged-out #soft-logged-in */
  groupData?: Maybe<GroupsAboutUsFactsData>;
};

export type GroupsAboutUsFactsData = {
  __typename?: 'GroupsAboutUsFactsData';
  /**
   * #logged-out #soft-logged-in
   * @deprecated Groups are going to be shutdown at the end of 2022. This field will stop working on 01/10/2022.
   */
  group?: Maybe<GroupsGroup>;
};

export type GroupsAllowedActionsOnGroup = {
  __typename?: 'GroupsAllowedActionsOnGroup';
  canJoin?: Maybe<Scalars['Boolean']>;
  canLeave?: Maybe<Scalars['Boolean']>;
  canModerate?: Maybe<Scalars['Boolean']>;
  canCreatePost?: Maybe<Scalars['Boolean']>;
};

export type GroupsAllowedActionsOnMembership = {
  __typename?: 'GroupsAllowedActionsOnMembership';
  canBlock?: Maybe<Scalars['Boolean']>;
  canUnblock?: Maybe<Scalars['Boolean']>;
  canExclude?: Maybe<Scalars['Boolean']>;
  canSetModerator?: Maybe<Scalars['Boolean']>;
  canUnsetModerator?: Maybe<Scalars['Boolean']>;
  canApprove?: Maybe<Scalars['Boolean']>;
};

export type GroupsCategoriesConnection = HasCursorPagination & {
  __typename?: 'GroupsCategoriesConnection';
  /** #logged-out #soft-logged-in */
  edges: Array<Maybe<GroupsCategoryEdge>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #virtual #logged-out #soft-logged-in */
  pageInfo: PageInfo;
};

export type GroupsCategory = {
  __typename?: 'GroupsCategory';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  createdAt: Scalars['Date'];
  /** #logged-out #soft-logged-in */
  updatedAt: Scalars['Date'];
  /** #logged-out #soft-logged-in */
  ontologyEntityId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  ontologyEntityUrn: Scalars['URN'];
  /** #logged-out #soft-logged-in #virtual */
  ontologyEntity?: Maybe<OntologyEntityLabel>;
};

export type GroupsCategoryEdge = PaginationEdge & {
  __typename?: 'GroupsCategoryEdge';
  /** #logged-out #soft-logged-in */
  node: GroupsCategory;
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
};

export type GroupsGroup = {
  __typename?: 'GroupsGroup';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  createdAt: Scalars['Date'];
  /** #logged-out #soft-logged-in */
  updatedAt: Scalars['Date'];
  /** #logged-out #soft-logged-in */
  state: GroupsGroupState;
  /** #logged-out #soft-logged-in */
  visibility: GroupsGroupVisibility;
  /** #logged-out #soft-logged-in */
  eventFrequency?: Maybe<GroupsGroupEventFrequency>;
  /** #logged-out #soft-logged-in */
  membersCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  entityPageId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  entityPage?: Maybe<EntityPage>;
  /** #logged-out #soft-logged-in #rest #virtual */
  aboutUs?: Maybe<AboutEntityResult>;
  /** #logged-out #soft-logged-in */
  cityId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  city?: Maybe<City>;
  /** #paginated #logged-out #soft-logged-in */
  memberships?: Maybe<GroupsMembershipsConnection>;
  /** #logged-out #soft-logged-in */
  events?: Maybe<Events>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Events is being shutdown on the 31-12-2022. Do not remove calls before this day
   */
  eventsCounter?: Maybe<EventsGroupsGroupCounters>;
  /** #paginated #logged-out #soft-logged-in */
  categories?: Maybe<GroupsCategoriesConnection>;
  /** @deprecated Groups are going to be shutdown at the end of 2022. This field only returns static `false` values. */
  allowedActions?: Maybe<GroupsAllowedActionsOnGroup>;
};


export type GroupsGroupMembershipsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  userIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  tagIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  states?: Maybe<Array<Maybe<GroupsMembershipState>>>;
  roles?: Maybe<Array<Maybe<GroupsMembershipRole>>>;
};


export type GroupsGroupEventsArgs = {
  input: GroupsGroupEventsQueryInput;
};


export type GroupsGroupCategoriesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  ontologyEntityUrns?: Maybe<Array<Maybe<Scalars['URN']>>>;
  ontologyEntityIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export enum GroupsGroupEventFrequency {
  Once = 'ONCE',
  TwoOrThreeTimes = 'TWO_OR_THREE_TIMES',
  FourOrFiveTimes = 'FOUR_OR_FIVE_TIMES',
  SixOrMoreTimes = 'SIX_OR_MORE_TIMES'
}

export enum GroupsGroupEventsOrderBy {
  Id = 'ID',
  StartsAt = 'STARTS_AT'
}

export type GroupsGroupEventsQueryInput = {
  timeFilter?: Maybe<EventTimeFilter>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  orderBy?: Maybe<GroupsGroupEventsOrderBy>;
  descending?: Maybe<Scalars['Int']>;
};

export enum GroupsGroupState {
  Incomplete = 'INCOMPLETE',
  PendingApproval = 'PENDING_APPROVAL',
  Approved = 'APPROVED'
}

export enum GroupsGroupVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type GroupsMembership = {
  __typename?: 'GroupsMembership';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  createdAt: Scalars['Date'];
  /** #logged-out #soft-logged-in */
  updatedAt: Scalars['Date'];
  /** #logged-out #soft-logged-in */
  role: GroupsMembershipRole;
  /** #logged-out #soft-logged-in */
  state: GroupsMembershipState;
  /** #logged-out #soft-logged-in */
  userId: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  user?: Maybe<XingId>;
  /** #logged-out #soft-logged-in */
  groupId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  group?: Maybe<GroupsGroup>;
  membershipReason?: Maybe<GroupsMembershipReason>;
  /** @deprecated Groups are going to be shutdown at the end of 2022. This field only returns static `false` values. */
  allowedActions?: Maybe<GroupsAllowedActionsOnMembership>;
  /** #rest(batched) #virtual */
  sharedContacts?: Maybe<SharedContacts>;
  /** #rest(batched) #virtual */
  contactDistance?: Maybe<ContactDistance>;
  /** #rest(batched) #virtual */
  networkRelationship?: Maybe<NetworkRelationship>;
};

export type GroupsMembershipEdge = PaginationEdge & {
  __typename?: 'GroupsMembershipEdge';
  /** #logged-out #soft-logged-in */
  node: GroupsMembership;
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
};

export type GroupsMembershipReason = {
  __typename?: 'GroupsMembershipReason';
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export enum GroupsMembershipRole {
  Owner = 'OWNER',
  Moderator = 'MODERATOR',
  Member = 'MEMBER'
}

export enum GroupsMembershipState {
  Blocked = 'BLOCKED',
  Excluded = 'EXCLUDED',
  Pending = 'PENDING',
  Approved = 'APPROVED'
}

export type GroupsMembershipsConnection = HasCursorPagination & {
  __typename?: 'GroupsMembershipsConnection';
  /** #logged-out #soft-logged-in */
  edges: Array<Maybe<GroupsMembershipEdge>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #virtual #logged-out #soft-logged-in */
  pageInfo: PageInfo;
};

/** Settings related to groups */
export type GroupsSettings = {
  __typename?: 'GroupsSettings';
  /** Shows membership by default when joining a new group */
  defaultVisibility?: Maybe<ToggleSetting>;
  /** Allows other users to invite to join a group */
  wantInvitations?: Maybe<ToggleSetting>;
  /** Container for the individual group settings */
  collection?: Maybe<Array<Maybe<GroupSetting>>>;
};


export type HasAggregationCount = {
  count: Scalars['Int'];
};

/**
 * Defines common fields for cursor pagination. Cursor pagination types must implement this interface
 * and define an `edges` field.
 * Check [Schema Design Principles (Pagination)](https://one.nwse.io/docs/how-to/develop/design-a-schema#pagination)
 * for more info.
 */
export type HasCursorPagination = {
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

/**
 * Provides a single non-null field called `globalId` that
 * collapses type information and identity into a single scalar value.
 *
 * `GlobalID`s can be used in different scenarios:
 *
 * - For one thing they enable collecting objects of different types in a Hash-like structure
 * (like a client side cache for example).
 * - They can also be used as identifiers for `GraphQL` field arguments if type information
 * needs to be transported to the backend in addition to the normal `ID`
 *
 * `New Work One` provides two interface: `HasDerivedGlobalId` and `HasGlobalId`. The
 * difference between the two is the following:
 *
 * - `HasGlobalId` simply provides the field definition, but requests it as a normal field
 * from the internal API.
 * - `HasDerivedGlobalId` provides the field definition and an implementation which
 * requests the `id` from the internal API and combines it with the name of the parent GraphQL type.
 *
 * Independent of the interface, a `GlobalID` is expected to be an URN. If it's served by
 * the backend, the URN is expected to follow the conventions outlined by
 * the [URN guidelines](https://new-work.atlassian.net/wiki/spaces/SOLAR/pages/45912687/Internal+URNs).
 * In both cases cases the naming portions of the URN are expected to be in "snake_case".
 *
 * In the mobile channel `New Work One` will automatically take care of scrambling the
 * numeric portions of the URN. In that case the `urn:` prefix is also changed to `surn:` to
 * match the expectations of existing clients.
 */
export type HasDerivedGlobalId = {
  /** Globally unique id for this instance based on typename and id */
  globalId: Scalars['GlobalID'];
};

/**
 * Provides a single non-null field called `globalId` that
 * collapses type information and identity into a single scalar value.
 *
 * `GlobalID`s can be used in different scenarios:
 *
 * - For one thing they enable collecting objects of different types in a Hash-like structure
 * (like a client side cache for example).
 * - They can also be used as identifiers for `GraphQL` field arguments if type information
 * needs to be transported to the backend in addition to the normal `ID`
 *
 * `New Work One` provides two interface: `HasDerivedGlobalId` and `HasGlobalId`. The
 * difference between the two is the following:
 *
 * - `HasGlobalId` simply provides the field definition, but requests it as a normal field
 * from the internal API.
 * - `HasDerivedGlobalId` provides the field definition and an implementation which
 * requests the `id` from the internal API and combines it with the name of the parent GraphQL type.
 *
 * Independent of the interface, a `GlobalID` is expected to be an URN. If it's served by
 * the backend, the URN is expected to follow the conventions outlined by
 * the [URN guidelines](https://new-work.atlassian.net/wiki/spaces/SOLAR/pages/45912687/Internal+URNs).
 * In both cases the naming portions of the URN are expected to be in "snake_case".
 *
 * In the mobile channel `New Work One` will automatically take care of scrambling the
 * numeric portions of the URN. In that case the `urn:` prefix is also changed to `surn:` to
 * match the expectations of existing clients.
 */
export type HasGlobalId = {
  /** Globally unique id for this instance */
  globalId: Scalars['GlobalID'];
};

export type HasNwtTrackingToken = {
  /** @deprecated Replaced by HasNewWorkTrackingToken to not confuse with another field with same name */
  trackingToken?: Maybe<Scalars['String']>;
};

/**
 * To be used for adding New work tracking field at result level
 * See https://source.xing.com/pages/data-solutions/nw-tracking/ for more information
 */
export type HasNewWorkTrackingToken = {
  nwTrackingToken?: Maybe<Scalars['String']>;
};

/**
 * To be used for adding Operational Data tracking field at result level
 * See https://operational-tracking.xing.io/ for implementation details
 */
export type HasOperationalDataTrackingTokens = {
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HasSeenResponse = {
  __typename?: 'HasSeenResponse';
  seen?: Maybe<Scalars['Boolean']>;
};

export enum HasSeenSource {
  Xtm = 'XTM'
}

export type HasTrackingToken = {
  /**
   * #soft-logged-in
   *
   *  Tracking token generated by predictive search service to track responses. Used for DS tracking
   */
  trackingToken: Scalars['String'];
};

/** Header image for XING ID */
export type HeaderImage = Referenceable & UniformResourceLocatable & {
  __typename?: 'HeaderImage';
  /** #logged-out #soft-logged-in */
  reference: Scalars['String'];
  /** #logged-out #soft-logged-in */
  url: Scalars['URL'];
};

/** Highlight parameters */
export type HighlightInput = {
  /** Enable or disable highlighting */
  enable?: Maybe<Scalars['Boolean']>;
  /** Defines left boundary element of a highlight snippet */
  preTag?: Maybe<Scalars['String']>;
  /** Defines right bounday element of a highlight snippet */
  postTag?: Maybe<Scalars['String']>;
  /** Specifies how the highlighted entries should be encoded(possible values are default and *html) */
  encoder?: Maybe<Scalars['String']>;
  /** Specifies how the highlighted entries should be sorted(currently only score is supported) */
  order?: Maybe<Scalars['String']>;
};

export type HighlightResult = {
  __typename?: 'HighlightResult';
  /** #soft-logged-in */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  wants?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  currentTitle?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  previousTitle?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  haves?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  currentCompany?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  education?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  organizations?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  qualifications?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  awards?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  province?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  city?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  country?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  zipCode?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  currentNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  previousCompany?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  portfolioTilesTitle?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  portfolioTilesPlainContent?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  currentIndustries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  previousIndustries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  birthName?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  webProfiles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  currentCompanyNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  previousCompanyNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HighlightResultCompany = {
  __typename?: 'HighlightResultCompany';
  description?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HighlightResultMessengerMessage = {
  __typename?: 'HighlightResultMessengerMessage';
  body?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HiringCities = {
  __typename?: 'HiringCities';
  /** #logged-out #soft-logged-in */
  collection?: Maybe<Array<Maybe<HiringCity>>>;
};

export type HiringCity = {
  __typename?: 'HiringCity';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  city?: Maybe<City>;
};

export type HiringCompanies = {
  __typename?: 'HiringCompanies';
  /** #logged-out #soft-logged-in */
  collection?: Maybe<Array<Maybe<HiringCompany>>>;
};

export type HiringCompany = {
  __typename?: 'HiringCompany';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
};

export type HiringDiscipline = {
  __typename?: 'HiringDiscipline';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
  /** #logged-out #soft-logged-in */
  isTop?: Maybe<Scalars['Boolean']>;
};

export type HiringDisciplines = {
  __typename?: 'HiringDisciplines';
  /** #logged-out #soft-logged-in */
  collection?: Maybe<Array<Maybe<HiringDiscipline>>>;
};

export type HiringEntityInput = {
  entityId?: Maybe<Scalars['ID']>;
};

export type HiringHighlightsModule = ModuleInterface & {
  __typename?: 'HiringHighlightsModule';
  /** #soft-logged-in */
  title: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #rest #virtual */
  content?: Maybe<HiringProfile>;
  active?: Maybe<Scalars['Boolean']>;
};

export type HiringJobPosting = {
  __typename?: 'HiringJobPosting';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  job?: Maybe<JobResult>;
};

export type HiringJobRole = {
  __typename?: 'HiringJobRole';
  /** #logged-out #soft-logged-in #virtual */
  jobRole?: Maybe<OntologyEntityLabel>;
  /** #logged-out #soft-logged-in */
  label?: Maybe<Scalars['String']>;
};

export type HiringJobRolesInput = {
  entityId?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
};

export type HiringProfile = {
  __typename?: 'HiringProfile';
  /** #logged-out #soft-logged-in */
  hiring?: Maybe<Scalars['Boolean']>;
  showHiringQuestion?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  hiringQuestionTimestamp?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  hiringSkills?: Maybe<Array<Maybe<HiringSkill>>>;
  /** #logged-out #soft-logged-in */
  hiringDisciplines?: Maybe<Array<Maybe<HiringDiscipline>>>;
  /** #logged-out #soft-logged-in */
  hiringCities?: Maybe<Array<Maybe<HiringCity>>>;
  /** #logged-out #soft-logged-in */
  hiringCompanies?: Maybe<Array<Maybe<HiringCompany>>>;
  /** #logged-out #soft-logged-in */
  hiringJobPostings?: Maybe<Array<Maybe<HiringJobPosting>>>;
  /** #logged-out #soft-logged-in */
  hiringJobRoles?: Maybe<Array<Maybe<HiringJobRole>>>;
  /** #logged-out #soft-logged-in */
  hiringSpotlightSummary?: Maybe<HiringSpotlightSummary>;
  /** #logged-out #soft-logged-in */
  hiringWorkplace?: Maybe<HiringWorkplace>;
};

export type HiringSkill = {
  __typename?: 'HiringSkill';
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['String']>;
};

export type HiringSkillsInput = {
  value: Scalars['String'];
};

export type HiringSpotLightSummaryInput = {
  value: Scalars['String'];
};

export type HiringSpotlightSummary = {
  __typename?: 'HiringSpotlightSummary';
  value?: Maybe<Scalars['String']>;
};

export type HiringWorkplace = {
  __typename?: 'HiringWorkplace';
  /** #logged-out #soft-logged-in */
  fullRemote?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  hybrid?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  onsite?: Maybe<Scalars['Boolean']>;
};

export type HiringWorkplaceInput = {
  fullRemote?: Maybe<Scalars['Boolean']>;
  hybrid?: Maybe<Scalars['Boolean']>;
  onsite?: Maybe<Scalars['Boolean']>;
};

export type Hotlead = {
  __typename?: 'Hotlead';
  itemId: Scalars['ID'];
  urn: Scalars['GlobalID'];
  score: Scalars['Float'];
  reason?: Maybe<Array<Maybe<Scalars['String']>>>;
  interactions: HotleadInteraction;
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  profileAdditionalDetails?: Maybe<ProfileAdditionalDetails>;
  /** #rest(batched) #virtual */
  canSendMessageTo?: Maybe<Scalars['Boolean']>;
  xtmGlances?: Maybe<XtmGlances>;
  trackingToken?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  /** #rest(batched) #virtual */
  xtmHotleadMetadata?: Maybe<HotleadMetadata>;
  postingType?: Maybe<Scalars['String']>;
  overlappingSkills?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HotleadInteraction = {
  __typename?: 'HotleadInteraction';
  clicked?: Maybe<Scalars['Long']>;
  unbookmarked?: Maybe<Scalars['Long']>;
  bookmarked?: Maybe<Scalars['Long']>;
  intended?: Maybe<Scalars['Long']>;
  jobDetailViewed?: Maybe<Scalars['Long']>;
  applied?: Maybe<Scalars['Long']>;
  enteredViewport?: Maybe<Scalars['Long']>;
  liked?: Maybe<Scalars['Long']>;
  discarded?: Maybe<Scalars['Long']>;
  /** This on is not present on the apidoc */
  view?: Maybe<Scalars['Long']>;
};

export type HotleadMatchingReason = {
  __typename?: 'HotleadMatchingReason';
  invite: Scalars['Boolean'];
  reasons: Array<Scalars['String']>;
};

export type HotleadMatchingReasonPoll = {
  __typename?: 'HotleadMatchingReasonPoll';
  userId: Scalars['ID'];
  urn: Scalars['String'];
  name: Scalars['String'];
  invite: Scalars['Boolean'];
  reasons: Array<Scalars['String']>;
};

export type HotleadMetadata = {
  __typename?: 'HotleadMetadata';
  firstSeenAt: Scalars['String'];
};

export type HotleadsCollection = {
  __typename?: 'HotleadsCollection';
  requestTrackingToken: Scalars['String'];
  total: Scalars['Int'];
  collection: Array<Maybe<Hotlead>>;
  service: Scalars['String'];
};

export type HotleadsMatchingReasonsPollResponse = {
  __typename?: 'HotleadsMatchingReasonsPollResponse';
  status: HotleadsReasonPollStatus;
  result?: Maybe<HotleadsMatchingReasonsResult>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type HotleadsMatchingReasonsResult = {
  __typename?: 'HotleadsMatchingReasonsResult';
  jobTitle: Scalars['String'];
  companyName: Scalars['String'];
  collection: Array<HotleadMatchingReasonPoll>;
};

export type HotleadsMatchingReasonsSubmitInput = {
  postingId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};

export type HotleadsMatchingReasonsSubmitResponse = {
  __typename?: 'HotleadsMatchingReasonsSubmitResponse';
  backgroundJobId: Scalars['String'];
};

export enum HotleadsReasonPollStatus {
  InProgress = 'IN_PROGRESS',
  Ok = 'OK',
  Error = 'ERROR'
}

export type HtmlDescription = {
  __typename?: 'HtmlDescription';
  /** #logged-out #soft-logged-in */
  content?: Maybe<Scalars['String']>;
};

export type IdentifyCityQueryInput = {
  /** Two-letter lowercase format (ISO 639-1 Code) */
  language: Scalars['String'];
  /** name of the city to be identified if available */
  cityName?: Maybe<Scalars['String']>;
  /** country code (recommended) or country name */
  country?: Maybe<Scalars['String']>;
  /** administrative area 1, in case of structured query */
  region?: Maybe<Scalars['String']>;
  /** street name (it will need google api to geolocate) */
  streetName?: Maybe<Scalars['String']>;
  /** postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** google maps unstructured query */
  query?: Maybe<Scalars['String']>;
  /** if set to true then the alternate names of the results will be retrieved */
  includeAlternateNames?: Maybe<Scalars['Boolean']>;
  /** if set to true then administrative areas are also allowed in response */
  includeAdminArea?: Maybe<Scalars['Boolean']>;
  /** if set to true then the alternate names of the country and admin area are retrieved */
  otherAlternateNames?: Maybe<Scalars['Boolean']>;
  /** if set to true then only local ES index will be used for resolution. Otherwise it will also use GoogleAPIs (which costs money for each call). Your consumer needs to be added to a whitelist. */
  resolveLocal?: Maybe<Scalars['Boolean']>;
  /** if set, limits the number of results returned */
  limit?: Maybe<Scalars['Int']>;
  /** relax Google query (= remove fields from query) empty Google results in order to resolve a city ID at the risk of not resolving a ROOFTOP address */
  relax?: Maybe<Scalars['Boolean']>;
};

export type ImageOptions = {
  width: Scalars['Int'];
  height: Scalars['Int'];
  reference: Scalars['String'];
};

/** Industries Type */
export type IndustriesPreference = {
  __typename?: 'IndustriesPreference';
  /** #rest(batched) #virtual */
  industries: Array<Maybe<Industry>>;
  openToOtherIndustries?: Maybe<Scalars['Boolean']>;
};

/** Industry localized */
export type Industry = Localizable & {
  __typename?: 'Industry';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  segments: Array<IndustrySegment>;
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
  /** #logged-out #soft-logged-in */
  seoName?: Maybe<Scalars['String']>;
};

export type IndustryAggregation = HasAggregationCount & {
  __typename?: 'IndustryAggregation';
  /** #soft-logged-in */
  count: Scalars['Int'];
  /** #soft-logged-in */
  value?: Maybe<Scalars['Int']>;
  /** #soft-logged-in #rest(batched) #virtual */
  label?: Maybe<Industry>;
};

export type IndustryInsight = {
  __typename?: 'IndustryInsight';
  id?: Maybe<Scalars['ID']>;
  translationKey?: Maybe<Scalars['String']>;
};

/** Industry Segment localized */
export type IndustrySegment = Localizable & {
  __typename?: 'IndustrySegment';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
  /** #logged-out #soft-logged-in */
  seoName?: Maybe<Scalars['String']>;
};

export type InitialTalentsSearchSummary = {
  __typename?: 'InitialTalentsSearchSummary';
  totalTalentsMatching: Scalars['Int'];
};

export type Insights = {
  __typename?: 'Insights';
  /**
   * #rest #virtual
   *
   *  Salary expectation data
   *
   * ```
   * query SalaryExpectations {
   *   recruiterInsights {
   *     insights(projectId: "5669", locationId: "2643123", jobLabel: "Manager") {
   *       salaryExpectationInsight {
   *         medianSalaryExpectation
   *         medianSalaryExpectationCandidates
   *         xtmUrl
   *         stats {
   *           amount
   *           label
   *         }
   *       }
   *     }
   *   }
   * }
   * ```
   */
  salaryExpectationInsight?: Maybe<SalaryExpectationInsight>;
  /**
   * #rest #virtual
   *
   *  Time in current position insights
   *
   * ```
   * query TimeInCurrentPosition {
   *   recruiterInsights {
   *     insights(projectId: "5669", locationId: "2643123", jobLabel: "Manager") {
   *       timeInCurrentPositionInsight {
   *         ...
   *       }
   *     }
   *   }
   * }
   * ```
   */
  timeInCurrentPositionInsight?: Maybe<TimeInCurrentPositionInsight>;
  /**
   * #rest #virtual
   *
   *  Insights about current companies matching the filters
   *
   * ```
   * query CurrentCompaniesInsight {
   *   recruiterInsights {
   *     insights(projectId: "5669", locationId: "2643123", jobLabel: "Manager") {
   *       currentCompaniesInsight {
   *         ...
   *       }
   *     }
   *   }
   * }
   * ```
   */
  currentCompaniesInsight?: Maybe<CurrentCompaniesInsight>;
  /**
   * #rest #virtual
   *
   *  Jobseeker status insights
   *
   * ```
   * query JobSeekerStatusInsight {
   *   recruiterInsights {
   *     insights(projectId: "5669", locationId: "2643123", jobLabel: "Manager") {
   *       jobSeekerStatusInsight {
   *         ...
   *       }
   *     }
   *   }
   * }
   * ```
   */
  jobSeekerStatusInsight?: Maybe<JobSeekerStatusInsight>;
};


export type InsightsCurrentCompaniesInsightArgs = {
  destinations?: Maybe<Scalars['Boolean']>;
};

export type InsightsArticle = {
  __typename?: 'InsightsArticle';
  /** #logged-out #soft-logged-in */
  objectUrn?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  readingTime?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  category?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  bgColor?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  details?: Maybe<InsightsArticleDetails>;
};

export type InsightsArticleDetails = {
  __typename?: 'InsightsArticleDetails';
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  image?: Maybe<InsightsArticleImage>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
};

export type InsightsArticleImage = {
  __typename?: 'InsightsArticleImage';
  /** #logged-out #soft-logged-in */
  srcSquare?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcSquare2x?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcWide?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  srcWide2x?: Maybe<Scalars['URL']>;
};

export type InsightsArticlesCollection = {
  __typename?: 'InsightsArticlesCollection';
  /** #logged-out #soft-logged-in */
  articles?: Maybe<Array<Maybe<InsightsArticle>>>;
};

export type InsightsNavigationItem = {
  __typename?: 'InsightsNavigationItem';
  id: Scalars['ID'];
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  urn: Scalars['URN'];
  headline: Scalars['String'];
  subline: Scalars['String'];
  navigationType: InsightsNavigationType;
  url?: Maybe<Scalars['URL']>;
};

export type InsightsNavigationModule = DiscoModule & HasOperationalDataTrackingTokens & {
  __typename?: 'InsightsNavigationModule';
  /** #paginated */
  paginatedItems?: Maybe<DiscoItemsConnection>;
  renderingType: DiscoModuleRenderingType;
  x1Limit: Scalars['Int'];
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['String']>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  info?: Maybe<DiscoModuleInfo>;
};


export type InsightsNavigationModulePaginatedItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<DiscoFeature>>>;
};

/** List of supported navigationType. */
export enum InsightsNavigationType {
  Companies = 'COMPANIES',
  CareerHub = 'CAREER_HUB',
  JobAndCareer = 'JOB_AND_CAREER',
  Industries = 'INDUSTRIES',
  Insiders = 'INSIDERS'
}

export type InsightsPushAudio = {
  __typename?: 'InsightsPushAudio';
  type: Scalars['String'];
  quality: Scalars['String'];
  url: Scalars['URL'];
};

export type InsightsPushSource = {
  __typename?: 'InsightsPushSource';
  websiteName: Scalars['String'];
  logoImage: ContentPageLogoImage;
  url: Scalars['URL'];
};

export type InsightsPushSummary = {
  __typename?: 'InsightsPushSummary';
  longText: Scalars['Markdown'];
  generatedAt: Scalars['Date'];
  audios: Array<Maybe<InsightsPushAudio>>;
  sources: Array<Maybe<InsightsPushSource>>;
  topics: Array<Maybe<SimplifiedInsightsPushTopic>>;
};

export type InsightsPushSummaryNotification = Notification & {
  __typename?: 'InsightsPushSummaryNotification';
  object?: Maybe<InsightsPushSummary>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type IntCustomQuestion = BaseApplyQuestion & {
  __typename?: 'IntCustomQuestion';
  /** #logged-out #soft-logged-in */
  min?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  max?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

/** VOMP Internal Type */
export type InternalVomp = VompVisit & {
  __typename?: 'InternalVomp';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  visitorId: Scalars['ID'];
  type: Scalars['String'];
  viewedAt: Scalars['Date'];
};

export type InternalVompError = {
  __typename?: 'InternalVompError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type InternalVompInput = {
  visitor?: Maybe<InternalVompVisitor>;
  visitee: InternalVompVisitee;
  visit: InternalVompVisit;
};

/** "Result type for internal VOMP creation that returns 204 on success" */
export type InternalVompResult = {
  __typename?: 'InternalVompResult';
  error?: Maybe<InternalVompError>;
  success?: Maybe<InternalVompSuccess>;
};

export type InternalVompSuccess = {
  __typename?: 'InternalVompSuccess';
  value?: Maybe<Scalars['String']>;
};

export type InternalVompVisit = {
  platform: VompPlatformEnum;
  referer?: Maybe<Scalars['String']>;
  clickReason: VompClickReason;
};

export type InternalVompVisitee = {
  id?: Maybe<Scalars['ID']>;
  pageName?: Maybe<Scalars['String']>;
};

export type InternalVompVisitor = {
  ipAddress?: Maybe<Scalars['String']>;
};

/** Deprecated: Renamed to EventUserMessage */
export type Invitation = {
  __typename?: 'Invitation';
  id: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  urn: Scalars['GlobalID'];
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  senderId: Scalars['ID'];
  /** #rest(batched) #virtual */
  sender?: Maybe<XingId>;
  group?: Maybe<GroupContainer>;
  /**
   * #rest(batched) #virtual
   * @deprecated Events is being shutdown on the 31-12-2022. Do not remove calls before this day
   */
  source?: Maybe<Source>;
  eventId: Scalars['ID'];
  event?: Maybe<Event>;
  reason?: Maybe<EventInvitationReason>;
};

export type InvoiceData = BpayPaymentMethodData & {
  __typename?: 'InvoiceData';
  type: Scalars['String'];
  clientName: Scalars['String'];
};

export type IsThisJobForMeScore = {
  __typename?: 'IsThisJobForMeScore';
  scoreRaw: Scalars['Float'];
  scoreRounded: Scalars['Float'];
  estimatedRating: Scalars['Int'];
  rating?: Maybe<Scalars['Int']>;
};

export type Item = {
  __typename?: 'Item';
  /** #rest(batched) #virtual */
  chat?: Maybe<MessengerChat>;
};


/** Generic type that is used to resolve the aggregations from search-proxy */
export type JobAggregationBenefit = {
  __typename?: 'JobAggregationBenefit';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  count: Scalars['Int'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  benefit?: Maybe<KununuBenefit>;
};

export type JobAggregationCareerLevels = {
  __typename?: 'JobAggregationCareerLevels';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  count: Scalars['Int'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  careerLevel?: Maybe<CareerLevel>;
};

export type JobAggregationCity = {
  __typename?: 'JobAggregationCity';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  count: Scalars['Int'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  city?: Maybe<City>;
};

export type JobAggregationCountry = {
  __typename?: 'JobAggregationCountry';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  count: Scalars['Int'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  country?: Maybe<Country>;
};

export type JobAggregationDiscipline = {
  __typename?: 'JobAggregationDiscipline';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  count: Scalars['Int'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
};

export type JobAggregationEmploymentType = {
  __typename?: 'JobAggregationEmploymentType';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  count: Scalars['Int'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  employmentType?: Maybe<EmploymentType>;
};

export type JobAggregationIndustry = {
  __typename?: 'JobAggregationIndustry';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  count: Scalars['Int'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  industry?: Maybe<Industry>;
};

export type JobAggregationRemoteOption = {
  __typename?: 'JobAggregationRemoteOption';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest #virtual */
  remoteOption?: Maybe<JobRemoteOption>;
};

/** Type that groups all the different aggregations that can be returned by search-proxy */
export type JobAggregationResult = {
  __typename?: 'JobAggregationResult';
  /** #logged-out #soft-logged-in */
  benefits?: Maybe<Array<Maybe<JobAggregationBenefit>>>;
  /** #logged-out #soft-logged-in */
  benefitsEmployeePerk?: Maybe<Array<Maybe<JobAggregationBenefit>>>;
  /** #logged-out #soft-logged-in */
  benefitsWorkingCulture?: Maybe<Array<Maybe<JobAggregationBenefit>>>;
  /** #logged-out #soft-logged-in */
  careerLevels?: Maybe<Array<Maybe<JobAggregationCareerLevels>>>;
  /** #logged-out #soft-logged-in */
  cities?: Maybe<Array<Maybe<JobAggregationCity>>>;
  /** #logged-out #soft-logged-in */
  countries?: Maybe<Array<Maybe<JobAggregationCountry>>>;
  /** #logged-out #soft-logged-in */
  disciplines?: Maybe<Array<Maybe<JobAggregationDiscipline>>>;
  /** #logged-out #soft-logged-in */
  employmentTypes?: Maybe<Array<Maybe<JobAggregationEmploymentType>>>;
  /** #logged-out #soft-logged-in */
  remoteOptions?: Maybe<Array<Maybe<JobAggregationRemoteOption>>>;
  /** #logged-out #soft-logged-in */
  industries?: Maybe<Array<Maybe<JobAggregationIndustry>>>;
  /** #logged-out #soft-logged-in */
  roles?: Maybe<Array<Maybe<JobAggregationRole>>>;
};

export type JobAggregationRole = {
  __typename?: 'JobAggregationRole';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  count: Scalars['Int'];
  /** #logged-out #soft-logged-in #virtual */
  role?: Maybe<JobRoleLabel>;
};

export type JobApplication = UrlApplication | EmailApplication | MessageApplication | EasyApplication | JobXingApplication | JobXingCustomApplication;

export type JobApplicationAnswerInput = {
  id: Scalars['String'];
  /** Use when you need to send a single value */
  value?: Maybe<Scalars['String']>;
  /** Use when you need to send multiple values */
  values?: Maybe<Array<Scalars['String']>>;
};

export type JobApplicationCvDataInput = {
  sectorExperience: Scalars['String'];
  workExperience?: Maybe<JobApplicationExperienceInput>;
  education: JobApplicationExperienceInput;
};

export type JobApplicationCvLessInput = {
  competencies?: Maybe<Array<Maybe<JobApplicationCvLessQuestionnaireInput>>>;
  skills?: Maybe<Array<Maybe<JobApplicationCvLessQuestionnaireInput>>>;
};

export type JobApplicationCvLessQuestionnaireInput = {
  checked: Scalars['Boolean'];
  item: Scalars['String'];
};

export type JobApplicationError = {
  __typename?: 'JobApplicationError';
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type JobApplicationExperienceInput = {
  subject: Scalars['String'];
  center: Scalars['String'];
  from: Scalars['String'];
  to?: Maybe<Scalars['String']>;
};

export type JobApplicationFormExternalDoc = {
  __typename?: 'JobApplicationFormExternalDoc';
  /** #logged-out #soft-logged-in */
  url: Scalars['String'];
  /** #logged-out #soft-logged-in */
  type: JobApplicationFormExternalDocType;
};

export enum JobApplicationFormExternalDocType {
  PrivacyPolicy = 'PRIVACY_POLICY',
  TermsAndConditions = 'TERMS_AND_CONDITIONS'
}

export type JobApplicationFormFieldInput = {
  label?: Maybe<JobApplicationFormFieldLabel>;
  value: Array<Scalars['String']>;
};

export enum JobApplicationFormFieldLabel {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Comments = 'COMMENTS',
  Attachments = 'ATTACHMENTS',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  UserCv = 'USER_CV'
}

export type JobApplicationMutationInput = {
  jobId: Scalars['ID'];
  formData: Array<Maybe<JobApplicationFormFieldInput>>;
  platform: JobInteractionPlatform;
  cvData?: Maybe<JobApplicationCvDataInput>;
  questionnaire?: Maybe<JobApplicationCvLessInput>;
};

export type JobApplicationMutationResult = {
  __typename?: 'JobApplicationMutationResult';
  /** #logged-out #soft-logged-in */
  error?: Maybe<JobApplicationError>;
};

export type JobAppliedExtractedFilter = {
  __typename?: 'JobAppliedExtractedFilter';
  /** #logged-out #soft-logged-in */
  disabled?: Maybe<Array<Maybe<JobExtractedFilterDisabledCollection>>>;
  /** #logged-out #soft-logged-in */
  enabled?: Maybe<Array<Maybe<JobExtractedFilterEnabledCollection>>>;
};

export type JobAppliedFilter = {
  __typename?: 'JobAppliedFilter';
  /** #logged-out #soft-logged-in */
  state: JobAppliedFilterState;
  /** #logged-out #soft-logged-in */
  filter: AllJobFilterCollection;
};

export type JobAppliedFilterResult = {
  __typename?: 'JobAppliedFilterResult';
  /** #logged-out #soft-logged-in */
  filterCollection?: Maybe<Array<Maybe<JobAppliedFilter>>>;
  /** #logged-out #soft-logged-in */
  location?: Maybe<JobSearchQueryLocation>;
  /** #logged-out #soft-logged-in */
  extractedFilters?: Maybe<JobAppliedExtractedFilter>;
};

export enum JobAppliedFilterState {
  AiEnabled = 'AI_ENABLED',
  AiDisabled = 'AI_DISABLED',
  UserEnabled = 'USER_ENABLED'
}

export type JobBanner = {
  __typename?: 'JobBanner';
  /** #logged-out #soft-logged-in */
  image936x200?: Maybe<Scalars['URL']>;
};

export type JobBookmark = {
  __typename?: 'JobBookmark';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  job?: Maybe<JobResult>;
  /** #logged-out #soft-logged-in */
  state: JobBookmarkState;
  /** #logged-out #soft-logged-in */
  updatedAt?: Maybe<Scalars['Date']>;
};

export type JobBookmarkEdge = PaginationEdge & {
  __typename?: 'JobBookmarkEdge';
  /** #logged-out #soft-logged-in */
  node: JobBookmark;
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
};

export type JobBookmarkMutationInput = {
  jobId: Scalars['ID'];
};

export type JobBookmarkMutationResult = {
  __typename?: 'JobBookmarkMutationResult';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  job?: Maybe<JobResult>;
  /** #logged-out #soft-logged-in */
  error?: Maybe<JobDefaultError>;
};

export enum JobBookmarkState {
  NotBookmarked = 'NOT_BOOKMARKED',
  Saved = 'SAVED',
  Applied = 'APPLIED',
  InterviewSet = 'INTERVIEW_SET'
}

export type JobBookmarkUpsertMutationInput = {
  jobId: Scalars['ID'];
  state: JobBookmarkState;
};

export type JobBookmarkUpsertMutationResult = JobBookmark | JobDefaultError;

export type JobBookmarksConnection = HasCursorPagination & {
  __typename?: 'JobBookmarksConnection';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
  /** #logged-out #soft-logged-in */
  edges?: Maybe<Array<Maybe<JobBookmarkEdge>>>;
};

export type JobCompanyInfo = {
  __typename?: 'JobCompanyInfo';
  /**
   * #logged-out #soft-logged-in
   *
   *  Contains the company name stored in jobs DB and overrides the name of company, if it exists
   */
  companyNameOverride: Scalars['String'];
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Company is resolved by companies team with their info
   */
  company?: Maybe<Company>;
};

export type JobContactRole = Localizable & {
  __typename?: 'JobContactRole';
  /** #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #soft-logged-in */
  localizationValue: Scalars['String'];
};

export type JobCreateReportInput = {
  jobId: Scalars['ID'];
  reason: JobReportReason;
  wrongFields?: Maybe<Array<Maybe<JobReportableField>>>;
  comment?: Maybe<Scalars['String']>;
};

export type JobCreateReportResult = {
  __typename?: 'JobCreateReportResult';
  /** #rest(batched) #virtual */
  job?: Maybe<JobResult>;
  error?: Maybe<JobDefaultError>;
};

export type JobDefaultError = {
  __typename?: 'JobDefaultError';
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type JobDeleteVisitError = {
  __typename?: 'JobDeleteVisitError';
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type JobDeleteVisitInput = {
  jobVisitId: Scalars['ID'];
};

export type JobDescription = HtmlDescription | ExternalUrlDescription | PdfDescription | TemplateData;

export type JobDetailsConnection = HasCursorPagination & {
  __typename?: 'JobDetailsConnection';
  /** #soft-logged-in */
  total: Scalars['Int'];
  /** #soft-logged-in */
  edges: Array<JobDetailsEdge>;
  /** #soft-logged-in */
  pageInfo: PageInfo;
};

export type JobDetailsContact = JobDetailsContactInterface & {
  __typename?: 'JobDetailsContact';
  /** #soft-logged-in #rest(batched) #virtual */
  user?: Maybe<XingId>;
  /** #soft-logged-in */
  position: Scalars['Int'];
  /** #soft-logged-in */
  trackingToken: Scalars['String'];
};

export type JobDetailsContactInterface = {
  /** #soft-logged-in #rest(batched) #virtual */
  user?: Maybe<XingId>;
  /** #soft-logged-in */
  position: Scalars['Int'];
  /** #soft-logged-in */
  trackingToken: Scalars['String'];
};

export type JobDetailsEdge = PaginationEdge & {
  __typename?: 'JobDetailsEdge';
  /** #soft-logged-in */
  node?: Maybe<JobDetailsContact>;
  /** #soft-logged-in */
  cursor: Scalars['String'];
};

export type JobDetailsFutureColleagueOccupation = {
  __typename?: 'JobDetailsFutureColleagueOccupation';
  /** #soft-logged-in */
  companyInfo: JobCompanyInfo;
  /** #soft-logged-in */
  role?: Maybe<Scalars['String']>;
};

export type JobDetailsFutureColleaguesConnection = HasCursorPagination & {
  __typename?: 'JobDetailsFutureColleaguesConnection';
  /** #soft-logged-in */
  total: Scalars['Int'];
  /** #soft-logged-in */
  edges: Array<JobDetailsFutureColleaguesEdge>;
  /** #soft-logged-in */
  pageInfo: PageInfo;
};

export type JobDetailsFutureColleaguesContact = JobDetailsContactInterface & {
  __typename?: 'JobDetailsFutureColleaguesContact';
  /** #soft-logged-in */
  previousOccupation?: Maybe<JobDetailsFutureColleagueOccupation>;
  /** #soft-logged-in */
  currentOccupation: JobDetailsFutureColleagueOccupation;
  /** #soft-logged-in */
  school?: Maybe<Scalars['String']>;
  /** #soft-logged-in #rest(batched) #virtual */
  user?: Maybe<XingId>;
  /** #soft-logged-in */
  position: Scalars['Int'];
  /** #soft-logged-in */
  trackingToken: Scalars['String'];
};

export type JobDetailsFutureColleaguesEdge = PaginationEdge & {
  __typename?: 'JobDetailsFutureColleaguesEdge';
  /** #soft-logged-in */
  node?: Maybe<JobDetailsFutureColleaguesContact>;
  /** #soft-logged-in */
  cursor: Scalars['String'];
};

export type JobDetailsSecondDegreeConnection = HasCursorPagination & {
  __typename?: 'JobDetailsSecondDegreeConnection';
  /** #soft-logged-in */
  total: Scalars['Int'];
  /** #soft-logged-in */
  edges: Array<JobDetailsSecondDegreeEdge>;
  /** #soft-logged-in */
  pageInfo: PageInfo;
};

export type JobDetailsSecondDegreeContact = JobDetailsContactInterface & {
  __typename?: 'JobDetailsSecondDegreeContact';
  /** #soft-logged-in */
  connectedBy: Array<JobDetailsContact>;
  /** #soft-logged-in #rest(batched) #virtual */
  user?: Maybe<XingId>;
  /** #soft-logged-in */
  position: Scalars['Int'];
  /** #soft-logged-in */
  trackingToken: Scalars['String'];
};

export type JobDetailsSecondDegreeEdge = PaginationEdge & {
  __typename?: 'JobDetailsSecondDegreeEdge';
  /** #soft-logged-in */
  node?: Maybe<JobDetailsSecondDegreeContact>;
  /** #soft-logged-in */
  cursor: Scalars['String'];
};

export type JobExtractedFilterDisabledCollection = JobFilterBenefit | JobFilterBenefitEmployeePerk | JobFilterBenefitWorkingCulture | JobFilterCareerLevel | JobFilterCountry | JobFilterDiscipline | JobFilterEmploymentType | JobFilterIndustry | JobFilterCity | JobFilterDisabledSalary | JobFilterRemoteOption | JobFilterCompany | JobFilterLocation;

export type JobExtractedFilterEnabledCollection = JobFilterBenefit | JobFilterBenefitEmployeePerk | JobFilterBenefitWorkingCulture | JobFilterCareerLevel | JobFilterCountry | JobFilterDiscipline | JobFilterEmploymentType | JobFilterIndustry | JobFilterCity | JobFilterSalary | JobFilterRemoteOption | JobFilterCompany | JobFilterLocation;

export type JobFeatures = {
  __typename?: 'JobFeatures';
  /**
   * #soft-logged-in
   * @deprecated All jobs are now reportable and this field is hard-coded to `true`. Please stop using the field.
   */
  report: Scalars['Boolean'];
  upsellUrl?: Maybe<Scalars['URL']>;
  manageUrl?: Maybe<Scalars['URL']>;
};

export type JobFilterBenefit = {
  __typename?: 'JobFilterBenefit';
  /** #logged-out #soft-logged-in */
  entityId: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  benefit?: Maybe<KununuBenefit>;
};

export type JobFilterBenefitEmployeePerk = {
  __typename?: 'JobFilterBenefitEmployeePerk';
  /** #logged-out #soft-logged-in */
  entityId: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  benefitEmployeePerk?: Maybe<KununuBenefit>;
};

export type JobFilterBenefitWorkingCulture = {
  __typename?: 'JobFilterBenefitWorkingCulture';
  /** #logged-out #soft-logged-in */
  entityId: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  benefitWorkingCulture?: Maybe<KununuBenefit>;
};

export type JobFilterCareerLevel = {
  __typename?: 'JobFilterCareerLevel';
  /** #logged-out #soft-logged-in */
  entityId: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  careerLevel?: Maybe<CareerLevel>;
};

export type JobFilterCity = {
  __typename?: 'JobFilterCity';
  /** #logged-out #soft-logged-in */
  entityId: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  city?: Maybe<City>;
};

export type JobFilterCollection = JobFilterBenefit | JobFilterBenefitEmployeePerk | JobFilterBenefitWorkingCulture | JobFilterCareerLevel | JobFilterCountry | JobFilterDiscipline | JobFilterEmploymentType | JobFilterIndustry | JobFilterCity | JobFilterSalary | JobFilterProjob | JobFilterPublishToCompany | JobFilterRemote | JobFilterRemoteOption | JobFilterCompany | JobFilterPaidOnly;

export type JobFilterCompany = {
  __typename?: 'JobFilterCompany';
  /** #logged-out #soft-logged-in */
  entityId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  company?: Maybe<Company>;
};

export type JobFilterCountry = {
  __typename?: 'JobFilterCountry';
  /** #logged-out #soft-logged-in */
  entityId: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  country?: Maybe<Country>;
};

export type JobFilterDisabledSalary = {
  __typename?: 'JobFilterDisabledSalary';
  /** #logged-out #soft-logged-in */
  salary?: Maybe<Scalars['Boolean']>;
};

export type JobFilterDiscipline = {
  __typename?: 'JobFilterDiscipline';
  /** #logged-out #soft-logged-in */
  entityId: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
};

export type JobFilterEmploymentType = {
  __typename?: 'JobFilterEmploymentType';
  /** #logged-out #soft-logged-in */
  entityId: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  employmentType?: Maybe<EmploymentType>;
};

export type JobFilterIndustry = {
  __typename?: 'JobFilterIndustry';
  /** #logged-out #soft-logged-in */
  entityId: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  industry?: Maybe<Industry>;
};

export type JobFilterLocation = {
  __typename?: 'JobFilterLocation';
  /** #logged-out #soft-logged-in */
  location?: Maybe<Location>;
};

export type JobFilterPaidOnly = {
  __typename?: 'JobFilterPaidOnly';
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['Boolean']>;
};

export type JobFilterProjob = {
  __typename?: 'JobFilterProjob';
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['Boolean']>;
};

export type JobFilterPublishToCompany = {
  __typename?: 'JobFilterPublishToCompany';
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['Boolean']>;
};

export type JobFilterRemote = {
  __typename?: 'JobFilterRemote';
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['Boolean']>;
};

export type JobFilterRemoteOption = {
  __typename?: 'JobFilterRemoteOption';
  /** #logged-out #soft-logged-in */
  entityId: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest #virtual */
  remoteOption?: Maybe<JobRemoteOption>;
};

export type JobFilterSalary = {
  __typename?: 'JobFilterSalary';
  /** #logged-out #soft-logged-in */
  min?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  max?: Maybe<Scalars['Int']>;
};

export type JobFromYourNetworkCompanyNotification = Notification & {
  __typename?: 'JobFromYourNetworkCompanyNotification';
  /** #rest(batched) #virtual */
  object?: Maybe<JobResult>;
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type JobHighlight = {
  __typename?: 'JobHighlight';
  /** #logged-out #soft-logged-in */
  localization: JobHighlightLocalizable;
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
};

export type JobHighlightLocalizable = Localizable & {
  __typename?: 'JobHighlightLocalizable';
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
};

export type JobHiringContact = {
  __typename?: 'JobHiringContact';
  /** #soft-logged-in #rest(batched) #virtual */
  user?: Maybe<XingId>;
  /** #soft-logged-in #rest(batched) #virtual */
  role?: Maybe<JobContactRole>;
};

export enum JobInteractionPlatform {
  Web = 'WEB',
  Mobile = 'MOBILE',
  Ios = 'IOS',
  Android = 'ANDROID'
}

export type JobInterest = {
  __typename?: 'JobInterest';
  /**
   * #soft-logged-in
   * @deprecated Interest feature is deprecated
   */
  showedInterest: Scalars['Boolean'];
};

/** Item that represents the response from search proxy */
export type JobItemResult = {
  __typename?: 'JobItemResult';
  /** #logged-out #soft-logged-in */
  postingId: Scalars['String'];
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  position: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  descriptionHighlight?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  jobDetail?: Maybe<JobResult>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  matchingHighlights?: Maybe<JobMatchingHighlights>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  matchingHighlightsV2?: Maybe<JobMatchingHighlightsV2>;
};

export type JobKeyfact = JobKeyfactSalary | JobKeyfactEmploymentType;

export type JobKeyfactEmploymentType = {
  __typename?: 'JobKeyfactEmploymentType';
  /** #logged-out #soft-logged-in */
  value: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localization: EmploymentType;
};

export type JobKeyfactSalary = {
  __typename?: 'JobKeyfactSalary';
  /** #logged-out #soft-logged-in */
  value: JobSalary;
};

export type JobLocation = {
  __typename?: 'JobLocation';
  /** #logged-out #soft-logged-in */
  city?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  cityId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  country?: Maybe<Country>;
  /** #logged-out #soft-logged-in */
  region?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  street?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  zipCode?: Maybe<Scalars['String']>;
};

export type JobMatchingHighlights = {
  __typename?: 'JobMatchingHighlights';
  /** #logged-out #soft-logged-in */
  token: Scalars['String'];
  /** #logged-out #soft-logged-in */
  highlight?: Maybe<JobHighlight>;
  /** #logged-out #soft-logged-in */
  matchingFacts: Array<JobKeyfact>;
  /** #logged-out #soft-logged-in */
  nonMatchingFacts: Array<JobKeyfact>;
};

export enum JobMatchingHighlightsContext {
  Postings = 'postings',
  Search = 'search',
  Recommendations = 'recommendations'
}

export type JobMatchingHighlightsJobHighlightV2 = {
  __typename?: 'JobMatchingHighlightsJobHighlightV2';
  /** #logged-out #soft-logged-in */
  localization: JobMatchingHighlightsLocalizableV2;
  /** #logged-out #soft-logged-in */
  localizationA11y?: Maybe<JobMatchingHighlightsLocalizableV2>;
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
};

export type JobMatchingHighlightsJobKeyfactIntV2 = JobMatchingHighlightsJobKeyfactV2 & {
  __typename?: 'JobMatchingHighlightsJobKeyfactIntV2';
  /** #logged-out #soft-logged-in */
  value: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  localization: JobMatchingHighlightsLocalizableV2;
  /** #logged-out #soft-logged-in */
  localizationA11y?: Maybe<JobMatchingHighlightsLocalizableV2>;
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
};

export type JobMatchingHighlightsJobKeyfactSalaryV2 = JobMatchingHighlightsJobKeyfactV2 & {
  __typename?: 'JobMatchingHighlightsJobKeyfactSalaryV2';
  /** #logged-out #soft-logged-in */
  value: JobSalary;
  /** #logged-out #soft-logged-in */
  localization: JobMatchingHighlightsLocalizableV2;
  /** #logged-out #soft-logged-in */
  localizationA11y?: Maybe<JobMatchingHighlightsLocalizableV2>;
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
};

export type JobMatchingHighlightsJobKeyfactStringV2 = JobMatchingHighlightsJobKeyfactV2 & {
  __typename?: 'JobMatchingHighlightsJobKeyfactStringV2';
  /** #logged-out #soft-logged-in */
  value: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localization: JobMatchingHighlightsLocalizableV2;
  /** #logged-out #soft-logged-in */
  localizationA11y?: Maybe<JobMatchingHighlightsLocalizableV2>;
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
};

export enum JobMatchingHighlightsJobKeyfactType {
  JobKeyfactSalary = 'JOB_KEYFACT_SALARY',
  JobKeyfactEmploymentType = 'JOB_KEYFACT_EMPLOYMENT_TYPE',
  JobKeyfactPreferredEmployer = 'JOB_KEYFACT_PREFERRED_EMPLOYER',
  JobKeyfactPreferredDiscipline = 'JOB_KEYFACT_PREFERRED_DISCIPLINE',
  JobKeyfactPreferredIndustry = 'JOB_KEYFACT_PREFERRED_INDUSTRY',
  JobKeyfactCareerLevel = 'JOB_KEYFACT_CAREER_LEVEL'
}

export type JobMatchingHighlightsJobKeyfactV2 = {
  /** #logged-out #soft-logged-in */
  localization: JobMatchingHighlightsLocalizableV2;
  /** #logged-out #soft-logged-in */
  localizationA11y?: Maybe<JobMatchingHighlightsLocalizableV2>;
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
};

export type JobMatchingHighlightsLocalizableV2 = {
  __typename?: 'JobMatchingHighlightsLocalizableV2';
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
};

export type JobMatchingHighlightsV2 = {
  __typename?: 'JobMatchingHighlightsV2';
  /** #logged-out #soft-logged-in */
  token: Scalars['String'];
  /** #logged-out #soft-logged-in */
  highlight?: Maybe<JobMatchingHighlightsJobHighlightV2>;
  /** #logged-out #soft-logged-in */
  matchingFacts: Array<JobMatchingHighlightsJobKeyfactV2>;
  /** #logged-out #soft-logged-in */
  nonMatchingFacts: Array<JobMatchingHighlightsJobKeyfactV2>;
};

export type JobPostingJobRoleMatches = {
  __typename?: 'JobPostingJobRoleMatches';
  matchedJobRoles?: Maybe<Array<Maybe<OntologyLocalizedJobRole>>>;
  notMatchedJobRoles?: Maybe<Array<Maybe<OntologyLocalizedJobRole>>>;
};

export type JobPostingSkillMatches = {
  __typename?: 'JobPostingSkillMatches';
  matchedSkills?: Maybe<Array<Maybe<OntologyLocalizedJobPostingSkill>>>;
  notMatchedSkills?: Maybe<Array<Maybe<OntologyLocalizedJobPostingSkill>>>;
};

/** Job Preference User Flag Type */
export type JobPreferenceUserFlags = {
  __typename?: 'JobPreferenceUserFlags';
  serpBannerHidden: Scalars['Boolean'];
};

export type JobPreferencesDataState = {
  __typename?: 'JobPreferencesDataState';
  careerLevel: CareerLevelPreferenceDataState;
  disciplines: JobPreferencesDataStateStatus;
  idealEmployers: JobPreferencesDataStateStatus;
  industries: JobPreferencesDataStateStatus;
  jobTitles: JobTitlesPreferenceDataState;
  locations: LocationsPreferenceDataState;
  salaryExpectations: JobPreferencesDataStateStatus;
  workingHours: JobPreferencesDataStateStatus;
  workplaces: JobPreferencesDataStateStatus;
};

export type JobPreferencesDataStateInfo = {
  __typename?: 'JobPreferencesDataStateInfo';
  dataStates: JobPreferencesDataState;
  filledPreferences: Scalars['Int'];
  totalPreferences: Scalars['Int'];
};

export enum JobPreferencesDataStateStatus {
  Undefined = 'UNDEFINED',
  Filled = 'FILLED',
  Empty = 'EMPTY'
}

/** JobPreferencesJobSeekerStatus Type */
export type JobPreferencesJobSeekerStatus = {
  __typename?: 'JobPreferencesJobSeekerStatus';
  status?: Maybe<PreferenceSeekingStatus>;
};

export type JobPreviewMetadata = PreviewMetadata & {
  __typename?: 'JobPreviewMetadata';
  urn: Scalars['GlobalID'];
  sourceActor?: Maybe<LinkPreviewSourceActor>;
};

export type JobRecentSearchCollectionJs = {
  __typename?: 'JobRecentSearchCollectionJS';
  /** #logged-out #soft-logged-in */
  searches?: Maybe<Array<JobSearchQuery>>;
  /** #logged-out #soft-logged-in */
  userInfo: UserInfoJs;
};

export type JobRecoDeclineRecommendationError = {
  __typename?: 'JobRecoDeclineRecommendationError';
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type JobRecoDeclineRecommendationResult = {
  __typename?: 'JobRecoDeclineRecommendationResult';
  success?: Maybe<JobRecoDeclineRecommendationSuccess>;
  error?: Maybe<JobRecoDeclineRecommendationError>;
};

export type JobRecoDeclineRecommendationSuccess = {
  __typename?: 'JobRecoDeclineRecommendationSuccess';
  message?: Maybe<Scalars['String']>;
};

export type JobRecoFeedBackResult = {
  __typename?: 'JobRecoFeedBackResult';
  /** #soft-logged-in */
  success?: Maybe<JobRecoFeedBackSuccess>;
  /** #soft-logged-in */
  error?: Maybe<JobRecoFeedbackError>;
};

export type JobRecoFeedBackSuccess = {
  __typename?: 'JobRecoFeedBackSuccess';
  /** #soft-logged-in */
  success?: Maybe<Scalars['Boolean']>;
};

export type JobRecoFeedbackError = {
  __typename?: 'JobRecoFeedbackError';
  /** #soft-logged-in */
  success?: Maybe<Scalars['Boolean']>;
  /** #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type JobRecoFeedbackInput = {
  rating: Scalars['Int'];
  consumer: Scalars['String'];
  topic: Scalars['String'];
  itemId: Scalars['Int'];
};

export type JobRecoOntologySetting = {
  id: Scalars['ID'];
  label: Scalars['String'];
  isPositive: Scalars['Boolean'];
};

export type JobRecoOntologySettingDiscipline = JobRecoOntologySetting & {
  __typename?: 'JobRecoOntologySettingDiscipline';
  id: Scalars['ID'];
  label: Scalars['String'];
  isPositive: Scalars['Boolean'];
};

export type JobRecoOntologySettingJobrole = JobRecoOntologySetting & {
  __typename?: 'JobRecoOntologySettingJobrole';
  id: Scalars['ID'];
  label: Scalars['String'];
  isPositive: Scalars['Boolean'];
};

export type JobRecoOntologySettingSkill = JobRecoOntologySetting & {
  __typename?: 'JobRecoOntologySettingSkill';
  id: Scalars['ID'];
  label: Scalars['String'];
  isPositive: Scalars['Boolean'];
};

export type JobRecoUserSettings = {
  __typename?: 'JobRecoUserSettings';
  skills: Array<JobRecoOntologySettingSkill>;
  jobroles: Array<JobRecoOntologySettingJobrole>;
  disciplines: Array<JobRecoOntologySettingDiscipline>;
  maxDistance?: Maybe<Scalars['Int']>;
  minCareerLevel?: Maybe<Scalars['Int']>;
  maxCareerLevel?: Maybe<Scalars['Int']>;
};

export type JobRecommendation = Recommendation & {
  __typename?: 'JobRecommendation';
  /** ITJFM (Is This Job For Me) score */
  itjfmScore?: Maybe<IsThisJobForMeScore>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  job?: Maybe<JobResult>;
  /** #rest(batched) #virtual */
  interactionTarget?: Maybe<SocialInteractionTarget>;
  /** #rest(batched) #virtual */
  matchingHighlights?: Maybe<JobMatchingHighlights>;
  /** #rest(batched) #virtual */
  matchingHighlightsV2?: Maybe<JobMatchingHighlightsV2>;
  /** #logged-out #soft-logged-in */
  itemId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  position: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  urn: Scalars['URN'];
  /** #logged-out #soft-logged-in */
  score: Scalars['Float'];
  /** #logged-out #soft-logged-in */
  reason: Array<Scalars['String']>;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type JobRecommendationAggregatedNotification = Notification & AggregatedNotification & {
  __typename?: 'JobRecommendationAggregatedNotification';
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  bucketPreview?: Maybe<Array<Maybe<Notification>>>;
  total: Scalars['Int'];
};

export type JobRecommendationEdge = PaginationEdge & {
  __typename?: 'JobRecommendationEdge';
  /** #logged-out #soft-logged-in */
  node: JobRecommendation;
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
};

export type JobRecommendationNotification = Notification & {
  __typename?: 'JobRecommendationNotification';
  /** #rest(batched) #virtual */
  object?: Maybe<JobResult>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type JobRecommendationSignal = ConversationStarter & {
  __typename?: 'JobRecommendationSignal';
  /** #rest(batched) #virtual */
  object?: Maybe<JobResult>;
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type JobRecommendationStack = SignalsStack & {
  __typename?: 'JobRecommendationStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type JobRecommendationStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type JobRecommendationsCategories = RecommenderResponse & {
  __typename?: 'JobRecommendationsCategories';
  collection: Array<JobRecommendation>;
  categories: JobRecommendationsCategoryList;
  requestTrackingToken: Scalars['String'];
  service: Scalars['String'];
  total: Scalars['Int'];
};

export type JobRecommendationsCategoryList = {
  __typename?: 'JobRecommendationsCategoryList';
  general: JobRecommendationsCategoryRecos;
  new: JobRecommendationsCategoryRecos;
  mlt: JobRecommendationsCategoryRecos;
  profile: JobRecommendationsCategoryRecos;
  collaborative: JobRecommendationsCategoryRecos;
  suggestedOrder: Array<Scalars['String']>;
};

export type JobRecommendationsCategoryRecos = {
  __typename?: 'JobRecommendationsCategoryRecos';
  total: Scalars['Int'];
  items: Array<Scalars['ID']>;
};

export type JobRecommendationsSimilarJob = {
  __typename?: 'JobRecommendationsSimilarJob';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  job?: Maybe<JobResult>;
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  position: Scalars['Int'];
};

export type JobRecommendationsSimilarJobs = RecommenderResponse & {
  __typename?: 'JobRecommendationsSimilarJobs';
  /** #logged-out #soft-logged-in */
  collection: Array<JobRecommendationsSimilarJob>;
  /** #logged-out #soft-logged-in */
  requestTrackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  service: Scalars['String'];
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export type JobRecommenderConnection = RecommenderResponse & HasCursorPagination & {
  __typename?: 'JobRecommenderConnection';
  /** #logged-out #soft-logged-in */
  edges: Array<JobRecommendationEdge>;
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  requestTrackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  service: Scalars['String'];
};

export type JobRegisterVisitInput = {
  jobId: Scalars['ID'];
  referer?: Maybe<Scalars['String']>;
  originalUrl?: Maybe<Scalars['String']>;
};

export type JobRegisterVisitResult = {
  __typename?: 'JobRegisterVisitResult';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  job?: Maybe<JobResult>;
  /** #logged-out #soft-logged-in */
  error?: Maybe<JobDefaultError>;
};

/** Remote Option localized */
export type JobRemoteOption = Localizable & {
  __typename?: 'JobRemoteOption';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
};

export enum JobRemoteOptionValue {
  FullRemote = 'FULL_REMOTE',
  PartlyRemote = 'PARTLY_REMOTE',
  NonRemote = 'NON_REMOTE'
}

export enum JobReportReason {
  NoJobAd = 'NO_JOB_AD',
  IllegalContent = 'ILLEGAL_CONTENT',
  WrongInformation = 'WRONG_INFORMATION'
}

export enum JobReportableField {
  Location = 'LOCATION',
  CompanyName = 'COMPANY_NAME',
  EmploymentType = 'EMPLOYMENT_TYPE',
  CareerLevel = 'CAREER_LEVEL',
  Other = 'OTHER'
}

export type JobResult = VisibleJob | UnauthorizedJob;

/** JobRole localized */
export type JobRole = {
  __typename?: 'JobRole';
  /** The name localized based on the `Accept-Language` header */
  name: Scalars['String'];
};

export type JobRoleLabel = {
  __typename?: 'JobRoleLabel';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  label: Scalars['String'];
};

export type JobRoles = Recommendation & {
  __typename?: 'JobRoles';
  localizedLabel: Scalars['String'];
  trackingToken: Scalars['String'];
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
};

export type JobRolesCollection = {
  __typename?: 'JobRolesCollection';
  collection: Array<Maybe<JobRoles>>;
};

export type JobSalary = Salary | SalaryRange | SalaryEstimate | SalaryUnauthorized;

export type JobSearchAggregationsFilter = {
  benefit?: Maybe<JobSearchQueryAggregationsFilterInput>;
  benefitWorkingCulture?: Maybe<JobSearchQueryAggregationsFilterInput>;
  benefitEmployeePerk?: Maybe<JobSearchQueryAggregationsFilterInput>;
  city?: Maybe<JobSearchQueryAggregationsFilterInput>;
  country?: Maybe<JobSearchQueryAggregationsFilterInput>;
  discipline?: Maybe<JobSearchQueryAggregationsFilterInput>;
  employmentType?: Maybe<JobSearchQueryAggregationsFilterInput>;
  industry?: Maybe<JobSearchQueryAggregationsFilterInput>;
  level?: Maybe<JobSearchQueryAggregationsFilterInput>;
  role?: Maybe<JobSearchQueryAggregationsFilterInput>;
  remoteOption?: Maybe<JobSearchQueryAggregationsFilterInput>;
};

export type JobSearchAlertAggregatedNotification = Notification & AggregatedNotification & {
  __typename?: 'JobSearchAlertAggregatedNotification';
  /** #rest(batched) #virtual */
  target?: Maybe<SearchAlert>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  bucketPreview?: Maybe<Array<Maybe<Notification>>>;
  total: Scalars['Int'];
};

export type JobSearchAlertNewIdResponse = JobSearchAlertNewIdSuccessResponse | SearchAlertErrorResponse;

export type JobSearchAlertNewIdSuccessResponse = {
  __typename?: 'JobSearchAlertNewIdSuccessResponse';
  id: Scalars['ID'];
};

export type JobSearchAlertNotification = Notification & {
  __typename?: 'JobSearchAlertNotification';
  /** #rest(batched) #virtual */
  object?: Maybe<JobResult>;
  /** #rest(batched) #virtual */
  target?: Maybe<SearchAlert>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type JobSearchAlertSignal = NetworkUpdatesStackItem & {
  __typename?: 'JobSearchAlertSignal';
  /** #rest(batched) #virtual */
  object?: Maybe<JobResult>;
  /** #rest(batched) #virtual */
  target?: Maybe<SearchAlert>;
  id: Scalars['ID'];
  stackId: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type JobSearchAlertStack = SignalsStack & {
  __typename?: 'JobSearchAlertStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type JobSearchAlertStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export enum JobSearchAlertsDomainError {
  Unknown = 'UNKNOWN',
  NoDomainError = 'NO_DOMAIN_ERROR',
  AlertLimitReached = 'ALERT_LIMIT_REACHED',
  AlertExistsAlready = 'ALERT_EXISTS_ALREADY',
  AlertNotFound = 'ALERT_NOT_FOUND',
  AlertDoesNotBelongToUser = 'ALERT_DOES_NOT_BELONG_TO_USER',
  UserNotFound = 'USER_NOT_FOUND'
}

export type JobSearchFlagInput = {
  name: Scalars['String'];
  value: JobSearchFlagValue;
};

export enum JobSearchFlagValue {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  True = 'TRUE',
  False = 'FALSE'
}

export type JobSearchInput = {
  query: JobSearchQueryInput;
  searchMode: SearchMode;
};

/** Job SearchQuery Inspiration */
export type JobSearchInspiration = {
  __typename?: 'JobSearchInspiration';
  /** #logged-out #soft-logged-in */
  searchQueryGuid: Scalars['String'];
  /** #logged-out #soft-logged-in */
  theme: JobSearchInspirationTheme;
  /** #logged-out #soft-logged-in #rest #virtual */
  title?: Maybe<GenericLocalizable>;
  /** #logged-out #soft-logged-in #rest #virtual */
  description?: Maybe<GenericLocalizable>;
  /** #logged-out #soft-logged-in */
  icon: JobSearchInspirationIcon;
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
};

export type JobSearchInspirationErrorResponse = {
  __typename?: 'JobSearchInspirationErrorResponse';
  /** #logged-out #soft-logged-in */
  timestamp?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  status?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  path?: Maybe<Scalars['String']>;
};

export enum JobSearchInspirationIcon {
  Rocket = 'ROCKET',
  Clock = 'CLOCK',
  Home = 'HOME',
  Sync = 'SYNC',
  Salary = 'SALARY',
  Public = 'PUBLIC',
  Industries = 'INDUSTRIES',
  Stroller = 'STROLLER',
  DashedClock = 'DASHED_CLOCK',
  Dog = 'DOG',
  Heart = 'HEART'
}

export type JobSearchInspirationResponse = JobSearchInspirationSuccessResponse | JobSearchInspirationErrorResponse;

/** Job Search Inspiration */
export type JobSearchInspirationSuccessResponse = {
  __typename?: 'JobSearchInspirationSuccessResponse';
  /** #logged-out #soft-logged-in */
  collection: Array<JobSearchInspiration>;
};

export enum JobSearchInspirationTheme {
  Theme_1 = 'THEME_1',
  Theme_2 = 'THEME_2',
  Theme_3 = 'THEME_3'
}

export type JobSearchNeedsRefinementInput = {
  queryId: Scalars['SlugOrID'];
};

export type JobSearchNeedsRefinementResponse = JobSearchNeedsRefinementSuccessResponse | SearchAlertErrorResponse;

export type JobSearchNeedsRefinementSuccessResponse = {
  __typename?: 'JobSearchNeedsRefinementSuccessResponse';
  needsRefinement: Scalars['Boolean'];
  suggestions: Array<JobSearchRefinementSuggestion>;
};

/** Search query result */
export type JobSearchQuery = {
  __typename?: 'JobSearchQuery';
  /** #logged-out #soft-logged-in */
  body?: Maybe<JobSearchQueryBody>;
  /** #logged-out #soft-logged-in */
  guid: Scalars['SlugOrID'];
  /** #logged-out #soft-logged-in */
  searchMode: SearchMode;
};

export type JobSearchQueryAggregationsFilterInput = {
  limit?: Maybe<Scalars['Int']>;
};

/** Main fields in job search query */
export type JobSearchQueryBody = {
  __typename?: 'JobSearchQueryBody';
  /** #logged-out #soft-logged-in */
  keywords?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  filterCollection?: Maybe<Array<Maybe<JobFilterCollection>>>;
  /** #logged-out #soft-logged-in */
  filter?: Maybe<JobSearchQueryFilter>;
  /** #logged-out #soft-logged-in */
  location?: Maybe<JobSearchQueryLocation>;
  /** #logged-out #soft-logged-in */
  extractedFilter?: Maybe<JobSearchQueryExtractedFilter>;
};

export type JobSearchQueryExtractedFilter = {
  __typename?: 'JobSearchQueryExtractedFilter';
  /** #logged-out #soft-logged-in */
  disabled?: Maybe<JobSearchQueryExtractedFilterDisabled>;
};

export type JobSearchQueryExtractedFilterDisabled = {
  __typename?: 'JobSearchQueryExtractedFilterDisabled';
  /** #logged-out #soft-logged-in */
  employmentType?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  careerLevel?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  discipline?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  industry?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  city?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  country?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  company?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  benefit?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  benefitEmployeePerk?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  benefitWorkingCulture?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  salary?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  remoteOption?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  location?: Maybe<JobSearchQueryLocationsByName>;
};

export type JobSearchQueryExtractedFilterDisabledInput = {
  employmentType?: Maybe<JobSearchQueryIdentifiableInput>;
  careerLevel?: Maybe<JobSearchQueryIdentifiableInput>;
  discipline?: Maybe<JobSearchQueryIdentifiableInput>;
  industry?: Maybe<JobSearchQueryIdentifiableInput>;
  city?: Maybe<JobSearchQueryIdentifiableInput>;
  country?: Maybe<JobSearchQueryIdentifiableInput>;
  company?: Maybe<JobSearchQueryIdentifiableInput>;
  benefit?: Maybe<JobSearchQueryIdentifiableInput>;
  benefitEmployeePerk?: Maybe<JobSearchQueryIdentifiableInput>;
  benefitWorkingCulture?: Maybe<JobSearchQueryIdentifiableInput>;
  salary?: Maybe<Scalars['Boolean']>;
  remoteOption?: Maybe<JobSearchQueryIdentifiableInput>;
  location?: Maybe<JobSearchQueryLocationsByNameInput>;
};

export type JobSearchQueryExtractedFilterInput = {
  disabled?: Maybe<JobSearchQueryExtractedFilterDisabledInput>;
};

export type JobSearchQueryFilter = {
  __typename?: 'JobSearchQueryFilter';
  /** #logged-out #soft-logged-in */
  employmentType?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  careerLevel?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  discipline?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  industry?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  city?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  country?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  company?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  benefit?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  benefitEmployeePerk?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  benefitWorkingCulture?: Maybe<JobSearchQueryIdentifiable>;
  /** #logged-out #soft-logged-in */
  paidOnly?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  projob?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  publishToCompany?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  salary?: Maybe<JobSearchQuerySalary>;
  /** #logged-out #soft-logged-in */
  remote?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  remoteOption?: Maybe<JobSearchQueryIdentifiable>;
};

export type JobSearchQueryFilterInput = {
  employmentType?: Maybe<JobSearchQueryIdentifiableInput>;
  careerLevel?: Maybe<JobSearchQueryIdentifiableInput>;
  discipline?: Maybe<JobSearchQueryIdentifiableInput>;
  industry?: Maybe<JobSearchQueryIdentifiableInput>;
  city?: Maybe<JobSearchQueryIdentifiableInput>;
  country?: Maybe<JobSearchQueryIdentifiableInput>;
  company?: Maybe<JobSearchQueryIdentifiableInput>;
  benefit?: Maybe<JobSearchQueryIdentifiableInput>;
  benefitEmployeePerk?: Maybe<JobSearchQueryIdentifiableInput>;
  benefitWorkingCulture?: Maybe<JobSearchQueryIdentifiableInput>;
  paidOnly?: Maybe<Scalars['Boolean']>;
  projob?: Maybe<Scalars['Boolean']>;
  publishToCompany?: Maybe<Scalars['Boolean']>;
  salary?: Maybe<JobSearchQuerySalaryInput>;
  remote?: Maybe<Scalars['Boolean']>;
  remoteOption?: Maybe<JobSearchQueryIdentifiableInput>;
};

export type JobSearchQueryIdentifiable = {
  __typename?: 'JobSearchQueryIdentifiable';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type JobSearchQueryIdentifiableInput = {
  id: Array<Maybe<Scalars['ID']>>;
};

export type JobSearchQueryInput = {
  keywords?: Maybe<Scalars['String']>;
  filter?: Maybe<JobSearchQueryFilterInput>;
  location?: Maybe<JobSearchQueryLocationInput>;
  extractedFilter?: Maybe<JobSearchQueryExtractedFilterInput>;
};

/** Location params used in a job search query */
export type JobSearchQueryLocation = {
  __typename?: 'JobSearchQueryLocation';
  /** #logged-out #soft-logged-in */
  cityId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  city?: Maybe<City>;
  /** #logged-out #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  radius?: Maybe<Scalars['Int']>;
};

export type JobSearchQueryLocationInput = {
  cityId?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
  radius?: Maybe<Scalars['Int']>;
};

export type JobSearchQueryLocationsByName = {
  __typename?: 'JobSearchQueryLocationsByName';
  /** #logged-out #soft-logged-in */
  name?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type JobSearchQueryLocationsByNameInput = {
  name: Array<Maybe<Scalars['String']>>;
};

export type JobSearchQuerySalary = {
  __typename?: 'JobSearchQuerySalary';
  /** #logged-out #soft-logged-in */
  min?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  max?: Maybe<Scalars['Int']>;
};

export type JobSearchQuerySalaryInput = {
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
};

export enum JobSearchRefinementSuggestion {
  Filters = 'FILTERS',
  Location = 'LOCATION'
}

/** Job search count result */
export type JobSearchResult = {
  __typename?: 'JobSearchResult';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  searchQuery: JobSearchQuery;
  /** #logged-out #soft-logged-in */
  appliedFilters?: Maybe<JobAppliedFilterResult>;
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<JobItemResult>>;
  /** #logged-out #soft-logged-in */
  aggregations?: Maybe<JobAggregationResult>;
  /** #logged-out #soft-logged-in */
  matchingReasons?: Maybe<MatchingReasonsResult>;
  /** #logged-out #soft-logged-in */
  trackingToken?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  boundedTotal?: Maybe<BoundedTotal>;
};

/** JobSeeker is a User seeking for Jobs */
export type JobSeeker = {
  id: Scalars['ID'];
  /** #paginated #rest #virtual */
  idealEmployers?: Maybe<ProJobsIdealEmployersConnection>;
  isPendingFirstEdit: Scalars['Boolean'];
  seekingStatus: SeekingStatus;
  salaryExpectation?: Maybe<Salary>;
};


/** JobSeeker is a User seeking for Jobs */
export type JobSeekerIdealEmployersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

/** Public JobSeeker's data of non-ProJobs users */
export type JobSeekerBasicOthers = JobSeeker & {
  __typename?: 'JobSeekerBasicOthers';
  id: Scalars['ID'];
  /** #paginated #rest #virtual */
  idealEmployers?: Maybe<ProJobsIdealEmployersConnection>;
  isPendingFirstEdit: Scalars['Boolean'];
  seekingStatus: SeekingStatus;
  salaryExpectation?: Maybe<Salary>;
};


/** Public JobSeeker's data of non-ProJobs users */
export type JobSeekerBasicOthersIdealEmployersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

/** Private (only for user herself) JobSeeker's data of non-ProJobs users */
export type JobSeekerBasicSelf = JobSeeker & JobSeekerVisibilityFields & {
  __typename?: 'JobSeekerBasicSelf';
  id: Scalars['ID'];
  /** #paginated #rest #virtual */
  idealEmployers?: Maybe<ProJobsIdealEmployersConnection>;
  isPendingFirstEdit: Scalars['Boolean'];
  seekingStatus: SeekingStatus;
  salaryExpectation?: Maybe<Salary>;
  visibility?: Maybe<JobSeekerVisibility>;
};


/** Private (only for user herself) JobSeeker's data of non-ProJobs users */
export type JobSeekerBasicSelfIdealEmployersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

/** JobSeeker Guidance Type */
export type JobSeekerGuidance = {
  __typename?: 'JobSeekerGuidance';
  header: Scalars['String'];
  collection: Array<JobSeekerGuidanceSection>;
};

export type JobSeekerGuidanceAction = JobSeekerGuidanceActionWeb | JobSeekerGuidanceActionNative;

export type JobSeekerGuidanceActionNative = {
  __typename?: 'JobSeekerGuidanceActionNative';
  id: Scalars['ID'];
  header: Scalars['String'];
  body: Scalars['String'];
  urn: Scalars['String'];
  value: JobSeekerGuidanceActionValue;
  trackingId: Scalars['String'];
  fenced: Scalars['Boolean'];
};

export type JobSeekerGuidanceActionValue = {
  __typename?: 'JobSeekerGuidanceActionValue';
  completed: Scalars['Boolean'];
};

/** Types of JobSeekerGuidanceAction */
export type JobSeekerGuidanceActionWeb = {
  __typename?: 'JobSeekerGuidanceActionWeb';
  id: Scalars['ID'];
  header: Scalars['String'];
  body: Scalars['String'];
  url: Scalars['String'];
  value: JobSeekerGuidanceActionValue;
  trackingId: Scalars['String'];
  fenced: Scalars['Boolean'];
};

export type JobSeekerGuidanceSection = {
  __typename?: 'JobSeekerGuidanceSection';
  header: Scalars['String'];
  collection: Array<JobSeekerGuidanceAction>;
};

export type JobSeekerGuidanceUpdateActionError = {
  __typename?: 'JobSeekerGuidanceUpdateActionError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type JobSeekerGuidanceUpdateActionInput = {
  actionId: Scalars['ID'];
  completed?: Maybe<Scalars['Boolean']>;
};

/** Result type for updating the JobSeeker Guidance Action */
export type JobSeekerGuidanceUpdateActionResult = JobSeekerGuidanceUpdateActionSuccess | JobSeekerGuidanceUpdateActionError;

export type JobSeekerGuidanceUpdateActionSuccess = {
  __typename?: 'JobSeekerGuidanceUpdateActionSuccess';
  userId: Scalars['ID'];
  actionId: Scalars['ID'];
  completed: Scalars['Boolean'];
};

export enum JobSeekerPlatform {
  Ios = 'IOS',
  Android = 'ANDROID',
  Web = 'WEB'
}

/** Fields only for ProJobs users */
export type JobSeekerProJobsFields = {
  /** #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
  targetPositions?: Maybe<Array<Maybe<JobRole>>>;
  willingnessToTravelPercentage?: Maybe<Scalars['Int']>;
  /** #rest #virtual */
  projobsWishes?: Maybe<ProjobsWishes>;
};

/** Public JobSeeker's data of ProJobs users */
export type JobSeekerProJobsOthers = JobSeeker & JobSeekerProJobsFields & {
  __typename?: 'JobSeekerProJobsOthers';
  id: Scalars['ID'];
  /** #paginated #rest #virtual */
  idealEmployers?: Maybe<ProJobsIdealEmployersConnection>;
  isPendingFirstEdit: Scalars['Boolean'];
  seekingStatus: SeekingStatus;
  salaryExpectation?: Maybe<Salary>;
  /** #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
  targetPositions?: Maybe<Array<Maybe<JobRole>>>;
  willingnessToTravelPercentage?: Maybe<Scalars['Int']>;
  /** #rest #virtual */
  projobsWishes?: Maybe<ProjobsWishes>;
};


/** Public JobSeeker's data of ProJobs users */
export type JobSeekerProJobsOthersIdealEmployersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

/** Private (only for user herself) JobSeeker's data of ProJobs users */
export type JobSeekerProJobsSelf = JobSeeker & JobSeekerProJobsFields & JobSeekerVisibilityFields & {
  __typename?: 'JobSeekerProJobsSelf';
  id: Scalars['ID'];
  /** #paginated #rest #virtual */
  idealEmployers?: Maybe<ProJobsIdealEmployersConnection>;
  isPendingFirstEdit: Scalars['Boolean'];
  seekingStatus: SeekingStatus;
  salaryExpectation?: Maybe<Salary>;
  /** #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
  targetPositions?: Maybe<Array<Maybe<JobRole>>>;
  willingnessToTravelPercentage?: Maybe<Scalars['Int']>;
  /** #rest #virtual */
  projobsWishes?: Maybe<ProjobsWishes>;
  visibility?: Maybe<JobSeekerVisibility>;
};


/** Private (only for user herself) JobSeeker's data of ProJobs users */
export type JobSeekerProJobsSelfIdealEmployersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type JobSeekerStatus = {
  __typename?: 'JobSeekerStatus';
  xtmUrl: Scalars['URL'];
  count: Scalars['Int'];
};

export type JobSeekerStatusInsight = {
  __typename?: 'JobSeekerStatusInsight';
  xtmUrl: Scalars['URL'];
  seeking: JobSeekerStatus;
  interested: JobSeekerStatus;
  notSeeking: JobSeekerStatus;
};

/** JobSeeker visibility to data */
export type JobSeekerVisibility = {
  __typename?: 'JobSeekerVisibility';
  displayMessage: Scalars['String'];
};

/** JobSeekerVisibility */
export type JobSeekerVisibilityFields = {
  visibility?: Maybe<JobSeekerVisibility>;
};

export enum JobSeekerWillingnessToTravel {
  None = 'NONE',
  Occasional = 'OCCASIONAL',
  Frequent = 'FREQUENT'
}

export type JobSeekerWorkingHours = {
  __typename?: 'JobSeekerWorkingHours';
  partTime: Scalars['Boolean'];
  fullTime: Scalars['Boolean'];
};

export type JobSummary = {
  __typename?: 'JobSummary';
  trackingToken: Scalars['String'];
  content: JobSummaryContent;
};

export type JobSummaryContent = {
  __typename?: 'JobSummaryContent';
  introduction: Scalars['String'];
  keyResponsibilities: Array<Scalars['String']>;
  qualifications: Array<Scalars['String']>;
};

export type JobTitleItem = {
  __typename?: 'JobTitleItem';
  id: Scalars['ID'];
  label: Scalars['String'];
};

/** JobTitleSuggestionsPreference Type */
export type JobTitleSuggestionsPreference = {
  __typename?: 'JobTitleSuggestionsPreference';
  jobTitleSuggestions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** JobTitlesPreference Type */
export type JobTitlesPreference = {
  __typename?: 'JobTitlesPreference';
  targetPositions: Array<Maybe<Scalars['String']>>;
  unpreferredPositions: Array<Maybe<JobTitleItem>>;
};

export type JobTitlesPreferenceDataState = {
  __typename?: 'JobTitlesPreferenceDataState';
  state: JobPreferencesDataStateStatus;
  target: JobPreferencesDataStateStatus;
  excluded: JobPreferencesDataStateStatus;
};

export type JobTitlesUnpreferredPositionsInput = {
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type JobUserApplication = JobUserXingApplication;

export type JobUserApplyIntentionInput = {
  jobId: Scalars['ID'];
  platform: JobInteractionPlatform;
};

export type JobUserApplyIntentionResult = {
  __typename?: 'JobUserApplyIntentionResult';
  /** #logged-out #soft-logged-in */
  error?: Maybe<JobDefaultError>;
};

export type JobUserInteractions = {
  __typename?: 'JobUserInteractions';
  /** #rest #virtual */
  application?: Maybe<JobUserApplication>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  bookmark?: Maybe<JobBookmark>;
  /**
   * #soft-logged-in
   * @deprecated Interest feature is deprecated
   */
  interest?: Maybe<JobInterest>;
};

export type JobUserScore = {
  __typename?: 'JobUserScore';
  scoreRaw?: Maybe<Scalars['Float']>;
  scoreRounded?: Maybe<Scalars['Float']>;
  estimatedRating?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Float']>;
};

export type JobUserXingApplication = {
  __typename?: 'JobUserXingApplication';
  createdAt: Scalars['Date'];
  status: JobUserXingApplicationStatus;
};

export enum JobUserXingApplicationStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Undelivered = 'UNDELIVERED'
}

export type JobVideo = {
  __typename?: 'JobVideo';
  /** #logged-out #soft-logged-in */
  url: Scalars['URL'];
};

export type JobVisit = {
  __typename?: 'JobVisit';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  job?: Maybe<JobResult>;
  /** #logged-out #soft-logged-in */
  lastViewedAt?: Maybe<Scalars['Date']>;
};

export type JobVisitEdge = PaginationEdge & {
  __typename?: 'JobVisitEdge';
  /** #logged-out #soft-logged-in */
  node: JobVisit;
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
};

export type JobVisitsConnection = HasCursorPagination & {
  __typename?: 'JobVisitsConnection';
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
  /** #logged-out #soft-logged-in */
  edges?: Maybe<Array<Maybe<JobVisitEdge>>>;
};

/** JobWishesPreference Type */
export type JobWishesPreference = {
  __typename?: 'JobWishesPreference';
  /** #rest(batched) #virtual */
  idealEmployers: Array<Maybe<Company>>;
  salaryExpectations?: Maybe<Scalars['Int']>;
  openToOtherIndustries: Scalars['Boolean'];
  /** #rest(batched) #virtual */
  industries: Array<Maybe<Industry>>;
  /** @deprecated This field is not longer used neither populated. Will be removed soon */
  willingnessToMove: Scalars['Boolean'];
  /** #rest(batched) #virtual */
  cities: Array<Maybe<City>>;
  minCareerLevel?: Maybe<Scalars['Int']>;
  maxCareerLevel?: Maybe<Scalars['Int']>;
  willingnessToTravel?: Maybe<WillingnessToTravelPreference>;
  workingHours?: Maybe<WorkingHoursPreference>;
  statusVisibility?: Maybe<StatusVisibility>;
  seekingStatus: PreferenceSeekingStatus;
  maxDistance?: Maybe<Scalars['Int']>;
};

/** Profile Module for the entry point to the Job Wishes Preferences */
export type JobWishesPreferenceModule = ModuleInterface & {
  __typename?: 'JobWishesPreferenceModule';
  title: Scalars['String'];
  order: Scalars['Int'];
  /** #rest #virtual */
  data?: Maybe<JobWishesPreference>;
  /** #rest #virtual */
  dataStates?: Maybe<JobPreferencesDataState>;
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type JobXingApplication = {
  __typename?: 'JobXingApplication';
  /** #logged-out #soft-logged-in */
  formExternalDocuments?: Maybe<FormExternalDocuments>;
  /** #logged-out #soft-logged-in #rest #virtual */
  replySettings?: Maybe<ConvertedReplySettingsJob>;
  /** #logged-out #soft-logged-in #rest #virtual */
  formSettings?: Maybe<FormSettings>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  applyServiceSettings?: Maybe<ApplyServiceSettings>;
};

export type JobXingCustomApplication = {
  __typename?: 'JobXingCustomApplication';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  schemaVersion?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  formExternalDocuments?: Maybe<FormExternalDocuments>;
  /** #logged-out #soft-logged-in */
  fallbackUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  scrambledFallbackUrl?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest #virtual */
  replySettings?: Maybe<ConvertedReplySettingsJob>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  applyServiceSettings?: Maybe<ApplyServiceSettings>;
  /** #logged-out #soft-logged-in #rest #virtual */
  applyCustomQuestions?: Maybe<Array<Maybe<BaseApplyQuestion>>>;
};

export type JobXingCustomApplicationError = {
  __typename?: 'JobXingCustomApplicationError';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
};

export type JobXingCustomApplicationInput = {
  jobId: Scalars['ID'];
  customFormData: Array<JobApplicationAnswerInput>;
  platform: JobInteractionPlatform;
};

export enum JobsB2bApplyOptions {
  InstantApply = 'INSTANT_APPLY',
  OnlineForm = 'ONLINE_FORM',
  Other = 'OTHER'
}

export type JobsB2bCandidate = {
  __typename?: 'JobsB2bCandidate';
  id?: Maybe<Scalars['ID']>;
  urn?: Maybe<Scalars['URN']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  profile?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  profileAdditionalDetails?: Maybe<XjmProfileAdditionalDetails>;
};

export type JobsB2bCandidateActionsQueryInput = {
  jobUuid: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<Scalars['String']>;
  sortDir?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  showAllResults?: Maybe<Scalars['Boolean']>;
};

export type JobsB2bCandidateActionsResult = {
  __typename?: 'JobsB2bCandidateActionsResult';
  collection?: Maybe<Array<Maybe<JobsB2bCandidateActionsResultItem>>>;
  metadata?: Maybe<JobsB2bCandidatesMetadata>;
  errors?: Maybe<JobsB2bCandidatesError>;
};

export type JobsB2bCandidateActionsResultItem = {
  __typename?: 'JobsB2bCandidateActionsResultItem';
  candidate?: Maybe<JobsB2bCandidate>;
  jobApplyType?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
};

export enum JobsB2bCandidateApplicationType {
  InstantApply = 'INSTANT_APPLY',
  EasyApply = 'EASY_APPLY',
  Email = 'EMAIL',
  Url = 'URL',
  PrivateMessage = 'PRIVATE_MESSAGE',
  Unknown = 'UNKNOWN'
}

export type JobsB2bCandidatesError = {
  __typename?: 'JobsB2bCandidatesError';
  statusCode?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type JobsB2bCandidatesMetadata = {
  __typename?: 'JobsB2bCandidatesMetadata';
  total?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
};

export type JobsB2bCandidatesQueryInput = {
  jobUuid: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  showAllResults?: Maybe<Scalars['Boolean']>;
};

export type JobsB2bCandidatesResult = {
  __typename?: 'JobsB2bCandidatesResult';
  collection?: Maybe<Array<Maybe<JobsB2bCandidatesResultItem>>>;
  metadata?: Maybe<JobsB2bCandidatesMetadata>;
  errors?: Maybe<JobsB2bCandidatesError>;
};

export type JobsB2bCandidatesResultItem = {
  __typename?: 'JobsB2bCandidatesResultItem';
  candidate?: Maybe<JobsB2bCandidate>;
  uniqueApplyIntents?: Maybe<Array<Maybe<JobsB2bCandidateApplicationType>>>;
  totalApplyIntents?: Maybe<Scalars['Int']>;
  latestEventDate?: Maybe<Scalars['Date']>;
};

export enum JobsB2bCurrency {
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD',
  Chf = 'CHF'
}

export enum JobsB2bInterval {
  Yearly = 'YEARLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Hourly = 'HOURLY'
}

export type JobsB2bJob = {
  __typename?: 'JobsB2bJob';
  data?: Maybe<JobsB2bJobData>;
};

export type JobsB2bJobData = {
  __typename?: 'JobsB2bJobData';
  id: Scalars['String'];
  title: Scalars['String'];
  jobRoleId?: Maybe<Scalars['Int']>;
  jobTypeCode: Scalars['String'];
  careerLevelId: Scalars['Int'];
  disciplineId: Scalars['Int'];
  industryId: Scalars['Int'];
  workExperienceId?: Maybe<Scalars['Int']>;
  jobLocation: JobsB2bJobLocation;
  locations?: Maybe<Array<Maybe<JobsB2bLocation>>>;
  skills?: Maybe<Scalars['String']>;
  jobSalary?: Maybe<JobsB2bJobSalary>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  xingJobAds?: Maybe<Array<Maybe<JobsB2bXingJobAd>>>;
  creatorId: Scalars['String'];
  accountId: Scalars['String'];
  remoteType?: Maybe<JobsB2bRemote>;
  lastPublishedAt?: Maybe<Scalars['Date']>;
};

export type JobsB2bJobError = {
  __typename?: 'JobsB2bJobError';
  statusCode?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type JobsB2bJobLocation = {
  __typename?: 'JobsB2bJobLocation';
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  countryCode: Scalars['String'];
};

export type JobsB2bJobMetricsDetails = {
  __typename?: 'JobsB2bJobMetricsDetails';
  active?: Maybe<Scalars['Boolean']>;
  applyOption?: Maybe<JobsB2bApplyOptions>;
  /** #rest #virtual */
  job?: Maybe<JobsB2bJob>;
  data?: Maybe<JobsB2bJobMetricsDetailsData>;
};

export type JobsB2bJobMetricsDetailsData = {
  __typename?: 'JobsB2bJobMetricsDetailsData';
  impressions?: Maybe<Scalars['Int']>;
  visits?: Maybe<Scalars['Int']>;
  uniqueVisitors?: Maybe<Scalars['Int']>;
  bookmarks?: Maybe<Scalars['Int']>;
  applyIntentions?: Maybe<Scalars['Int']>;
  externalApplicationClicks?: Maybe<Scalars['Int']>;
  instantApplyClicks?: Maybe<Scalars['Int']>;
  instantApplications?: Maybe<Scalars['Int']>;
};

export type JobsB2bJobMetricsError = {
  __typename?: 'JobsB2bJobMetricsError';
  statusCode?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type JobsB2bJobMetricsResult = JobsB2bJobMetricsDetails | JobsB2bJobMetricsError;

export type JobsB2bJobResult = JobsB2bJob | JobsB2bJobError;

export type JobsB2bJobSalary = {
  __typename?: 'JobsB2bJobSalary';
  min: Scalars['Int'];
  max: Scalars['Int'];
  interval: JobsB2bInterval;
  currency: JobsB2bCurrency;
};

export type JobsB2bLocation = {
  __typename?: 'JobsB2bLocation';
  city: Scalars['String'];
  countryCode: Scalars['String'];
  order: Scalars['Int'];
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export enum JobsB2bRemote {
  FullyRemote = 'FULLY_REMOTE',
  PartiallyRemote = 'PARTIALLY_REMOTE',
  NonRemote = 'NON_REMOTE'
}

export type JobsB2bXingJobAd = {
  __typename?: 'JobsB2bXingJobAd';
  id: Scalars['String'];
  contactPersonXingId?: Maybe<Scalars['String']>;
  applyOption?: Maybe<JobsB2bApplyOptions>;
  companyProfileUrl?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  onlineApplicationFormUrl?: Maybe<Scalars['String']>;
};

export type JobsDeleteRecommendationsResult = {
  __typename?: 'JobsDeleteRecommendationsResult';
  error?: Maybe<JobDefaultError>;
};

export type JobsEasyCreateAiJob = {
  __typename?: 'JobsEasyCreateAIJob';
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  jobRoleId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  careerLevelId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  jobTypeCode?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  disciplineId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  industryId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  workExperienceId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  skills?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  remoteType?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  jobDescription?: Maybe<JobsEasyCreateAiJobDescription>;
  /** #logged-out #soft-logged-in */
  jobLocation?: Maybe<JobsEasyCreateAiJobLocation>;
  /** #logged-out #soft-logged-in */
  jobSalary?: Maybe<JobsEasyCreateAiJobSalary>;
  /** #logged-out #soft-logged-in */
  jobMedia?: Maybe<JobsEasyCreateAiJobMedia>;
  /** #logged-out #soft-logged-in */
  jobSocialMediaLinks?: Maybe<JobsEasyCreateAiJobSocialMediaLinks>;
};

export type JobsEasyCreateAiJobDescription = {
  __typename?: 'JobsEasyCreateAIJobDescription';
  /** #logged-out #soft-logged-in */
  aboutUsTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  aboutUs?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  tasksTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  tasks?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  profileTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  profile?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  weOfferTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  weOffer?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  contactInfoTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  contactInfo?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateAiJobGenerationError = {
  __typename?: 'JobsEasyCreateAIJobGenerationError';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export enum JobsEasyCreateAiJobGenerationPollStatus {
  Pending = 'PENDING',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND'
}

export type JobsEasyCreateAiJobGenerationSuccess = {
  __typename?: 'JobsEasyCreateAIJobGenerationSuccess';
  /** #logged-out #soft-logged-in */
  job?: Maybe<JobsEasyCreateAiJob>;
  /** #logged-out #soft-logged-in */
  addContactPerson?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  contactPersonXingId?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  applyOption?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  onlineApplicationFormUrl?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companyProfileUrl?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companyName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  publishToCompany?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  companyId?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  createdAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  updatedAt?: Maybe<Scalars['Date']>;
};

export type JobsEasyCreateAiJobLocation = {
  __typename?: 'JobsEasyCreateAIJobLocation';
  /** #logged-out #soft-logged-in */
  street?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  zipCode?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  city?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  countryCode?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateAiJobMedia = {
  __typename?: 'JobsEasyCreateAIJobMedia';
  /** #logged-out #soft-logged-in */
  headerImage?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  footerImage?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  video?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  headingColor?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateAiJobSalary = {
  __typename?: 'JobsEasyCreateAIJobSalary';
  /** #logged-out #soft-logged-in */
  min?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  max?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  interval?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  currency?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateAiJobSocialMediaLinks = {
  __typename?: 'JobsEasyCreateAIJobSocialMediaLinks';
  /** #logged-out #soft-logged-in */
  linkType?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  linkData?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateDirectPublishPollResult = {
  __typename?: 'JobsEasyCreateDirectPublishPollResult';
  /** #logged-out #soft-logged-in */
  state?: Maybe<JobsEasyCreateDirectPublishStates>;
  /** #logged-out #soft-logged-in */
  softLoginUrl?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  jobDraftId?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  jobPostingUrl?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  reason?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateDirectPublishPollingResponse = {
  __typename?: 'JobsEasyCreateDirectPublishPollingResponse';
  /** #logged-out #soft-logged-in */
  status: JobsEasyCreateEcomPurchasePollStatus;
  /** #logged-out #soft-logged-in */
  jobId: Scalars['String'];
  /** #logged-out #soft-logged-in */
  result?: Maybe<JobsEasyCreateDirectPublishPollResult>;
};

export enum JobsEasyCreateDirectPublishStates {
  JobPublished = 'JOB_PUBLISHED',
  JobDraftCreated = 'JOB_DRAFT_CREATED'
}

export type JobsEasyCreateDirectPublishTriggerError = {
  __typename?: 'JobsEasyCreateDirectPublishTriggerError';
  /** #logged-out #soft-logged-in */
  status: Scalars['String'];
  /** #logged-out #soft-logged-in */
  error: Scalars['String'];
  /** #logged-out #soft-logged-in */
  exception: Scalars['String'];
};

export type JobsEasyCreateDirectPublishTriggerInput = {
  orderNumber: Scalars['String'];
  productType: JobsEasyCreateProductType;
  jobDraft: JobsEasyCreateJobDraft;
  clientId?: Maybe<Scalars['ID']>;
  variant?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateDirectPublishTriggerResponse = {
  __typename?: 'JobsEasyCreateDirectPublishTriggerResponse';
  /** #logged-out #soft-logged-in */
  jobId: Scalars['String'];
};

export type JobsEasyCreateDirectPublishTriggerUnion = TriggerJobsEasyCreateEcomPurchaseSuccess | JobsEasyCreateDirectPublishTriggerError;

export type JobsEasyCreateEcomPurchaseError = {
  __typename?: 'JobsEasyCreateEcomPurchaseError';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export enum JobsEasyCreateEcomPurchasePollStatus {
  Pending = 'PENDING',
  Completed = 'COMPLETED',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND',
  BadRequest = 'BAD_REQUEST'
}

export type JobsEasyCreateEcomPurchaseSuccess = {
  __typename?: 'JobsEasyCreateEcomPurchaseSuccess';
  /** #logged-out #soft-logged-in */
  recruiterAccountHandle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  userUuid?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  softLoginUrl?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateJobDraft = {
  job: JobsEasyCreateJobDraftJob;
  addContactPerson?: Maybe<Scalars['Boolean']>;
  contactPersonXingId?: Maybe<Scalars['String']>;
  applyOption?: Maybe<Scalars['String']>;
  onlineApplicationFormUrl?: Maybe<Scalars['String']>;
  companyProfileUrl?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  publishToCompany?: Maybe<Scalars['Boolean']>;
  companyId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateJobDraftDescription = {
  aboutUsTitle?: Maybe<Scalars['String']>;
  aboutUs?: Maybe<Scalars['String']>;
  tasksTitle?: Maybe<Scalars['String']>;
  tasks?: Maybe<Scalars['String']>;
  profileTitle?: Maybe<Scalars['String']>;
  profile?: Maybe<Scalars['String']>;
  weOfferTitle?: Maybe<Scalars['String']>;
  weOffer?: Maybe<Scalars['String']>;
  contactInfoTitle?: Maybe<Scalars['String']>;
  contactInfo?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateJobDraftJob = {
  title?: Maybe<Scalars['String']>;
  jobRoleId?: Maybe<Scalars['Int']>;
  careerLevelId?: Maybe<Scalars['Int']>;
  jobTypeCode?: Maybe<Scalars['String']>;
  disciplineId?: Maybe<Scalars['Int']>;
  industryId?: Maybe<Scalars['Int']>;
  workExperienceId?: Maybe<Scalars['Int']>;
  jobLocation?: Maybe<JobsEasyCreateJobDraftLocation>;
  skills?: Maybe<Scalars['String']>;
  jobSalary?: Maybe<JobsEasyCreateJobDraftSalary>;
  jobDescription?: Maybe<JobsEasyCreateJobDraftDescription>;
  jobMedia?: Maybe<JobsEasyCreateJobDraftMedia>;
  jobSocialMediaLinks?: Maybe<JobsEasyCreateJobDraftSocialMediaLinks>;
  remoteType?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateJobDraftLocation = {
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateJobDraftMedia = {
  headerImage?: Maybe<Scalars['String']>;
  footerImage?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  headingColor?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateJobDraftSalary = {
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateJobDraftSocialMediaLinks = {
  linkType?: Maybe<Scalars['String']>;
  linkData?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateJobsDraftError = {
  __typename?: 'JobsEasyCreateJobsDraftError';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type JobsEasyCreateJobsDraftInput = {
  recruiterAccountHandle: Scalars['String'];
  userUuid: Scalars['UUID'];
  jobDraft: JobsEasyCreateJobDraft;
};

export type JobsEasyCreateJobsDraftResult = JobsEasyCreateJobsDraftSuccess | JobsEasyCreateJobsDraftError;

export type JobsEasyCreateJobsDraftSuccess = {
  __typename?: 'JobsEasyCreateJobsDraftSuccess';
  /** #logged-out #soft-logged-in */
  jobId: Scalars['UUID'];
};

export enum JobsEasyCreateProductType {
  Core = 'CORE',
  Core15 = 'CORE15',
  Core30 = 'CORE30',
  Pro = 'PRO',
  Ultimate = 'ULTIMATE',
  Free = 'FREE'
}

export type JobsLinkBoxJobRole = {
  __typename?: 'JobsLinkBoxJobRole';
  /** #logged-out #soft-logged-in */
  seoName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
};

export type JobsLinkBoxJobRoleInput = {
  /** Job role SEO name */
  jobRole: Scalars['String'];
};

export type JobsLinkBoxLocation = {
  __typename?: 'JobsLinkBoxLocation';
  /** #logged-out #soft-logged-in */
  seoName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  location?: Maybe<JobsLinkBoxLocationLocation>;
  /** #logged-out #soft-logged-in */
  jobCount?: Maybe<Scalars['Int']>;
};

export type JobsLinkBoxLocationLocation = {
  __typename?: 'JobsLinkBoxLocationLocation';
  /** #logged-out #soft-logged-in */
  cityId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
};

export type JobsLinkBoxSkill = {
  __typename?: 'JobsLinkBoxSkill';
  /** #logged-out #soft-logged-in */
  seoName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
};

export type JobsLinkBoxSkillInput = {
  /** Skill SEO name */
  skill: Scalars['String'];
};

export type JobsLinkBoxTopLocationsNearbyInput = {
  /** Nearby city SEO name */
  city: Scalars['String'];
};

export type JobsMarkRecommendationsAsSeenInput = {
  jobIds?: Maybe<Array<Scalars['ID']>>;
};

export type JobsMarkRecommendationsAsSeenResult = {
  __typename?: 'JobsMarkRecommendationsAsSeenResult';
  /** #soft-logged-in */
  error?: Maybe<JobDefaultError>;
};

export type JobsMtncVoucher = {
  __typename?: 'JobsMtncVoucher';
  id: Scalars['ID'];
  code: Scalars['String'];
  isRedeemed: Scalars['Boolean'];
  isExpired: Scalars['Boolean'];
  expirationDate: Scalars['Date'];
  messagesExpirationDate?: Maybe<Scalars['Date']>;
  messagesExpirationInDays: Scalars['Int'];
};

export type JobsMtncVoucherRedemptionError = {
  __typename?: 'JobsMtncVoucherRedemptionError';
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type JobsMtncVoucherRedemptionInput = {
  code: Scalars['String'];
};

export type JobsMtncVoucherRedemptionResult = JobsMtncVoucherRedemptionSuccess | JobsMtncVoucherRedemptionError;

export type JobsMtncVoucherRedemptionSuccess = {
  __typename?: 'JobsMtncVoucherRedemptionSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type JobsMtncVoucherResponse = {
  __typename?: 'JobsMtncVoucherResponse';
  jobId: Scalars['ID'];
  jobTitle: Scalars['String'];
  voucher: JobsMtncVoucher;
};

export type KununuBenefit = Localizable & {
  __typename?: 'KununuBenefit';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
};

export type LoSearchAlertConfirmationInput = {
  token: Scalars['String'];
};

export type LoSearchAlertMessage = {
  __typename?: 'LOSearchAlertMessage';
  /** #logged-out #soft-logged-in */
  level?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  body?: Maybe<Scalars['String']>;
};

export type LoSearchAlertResponse = {
  /** #logged-out #soft-logged-in */
  code?: Maybe<LoSearchAlertStatusCode>;
  /** #logged-out #soft-logged-in */
  searchMode: SearchModeAlertLo;
  /** #logged-out #soft-logged-in */
  query: JobSearchQueryBody;
  /** #logged-out #soft-logged-in */
  message: LoSearchAlertMessage;
};

export enum LoSearchAlertStatusCode {
  Ok = 'OK',
  Conflict = 'CONFLICT',
  NotFound = 'NOT_FOUND'
}

export type LoSearchAlertUnsubscribeInput = {
  token: Scalars['String'];
};

export type LoSearchConflictAlertResponse = LoSearchAlertResponse & {
  __typename?: 'LOSearchConflictAlertResponse';
  /** #logged-out #soft-logged-in */
  code?: Maybe<LoSearchAlertStatusCode>;
  /** #logged-out #soft-logged-in */
  searchMode: SearchModeAlertLo;
  /** #logged-out #soft-logged-in */
  query: JobSearchQueryBody;
  /** #logged-out #soft-logged-in */
  message: LoSearchAlertMessage;
};

export type LoSearchNotFoundAlertResponse = LoSearchAlertResponse & {
  __typename?: 'LOSearchNotFoundAlertResponse';
  /** #logged-out #soft-logged-in */
  code?: Maybe<LoSearchAlertStatusCode>;
  /** #logged-out #soft-logged-in */
  searchMode: SearchModeAlertLo;
  /** #logged-out #soft-logged-in */
  query: JobSearchQueryBody;
  /** #logged-out #soft-logged-in */
  message: LoSearchAlertMessage;
};

export type LoSearchOkAlertResponse = LoSearchAlertResponse & {
  __typename?: 'LOSearchOkAlertResponse';
  /** #logged-out #soft-logged-in */
  code?: Maybe<LoSearchAlertStatusCode>;
  /** #logged-out #soft-logged-in */
  searchMode: SearchModeAlertLo;
  /** #logged-out #soft-logged-in */
  query: JobSearchQueryBody;
  /** #logged-out #soft-logged-in */
  message: LoSearchAlertMessage;
};

export enum LanguageCode {
  De = 'de',
  En = 'en'
}

export type LeadAdForm = {
  __typename?: 'LeadAdForm';
  id: Scalars['ID'];
  urn: Scalars['GlobalID'];
  /** @deprecated ODT shutdown */
  odtTrackingToken?: Maybe<Scalars['String']>;
  headline: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  actionCopy: Scalars['String'];
  buttonCopy: Scalars['String'];
  image: Scalars['URL'];
  thanksTitle: Scalars['String'];
  thanksText?: Maybe<Scalars['String']>;
  thanksButtonUrl?: Maybe<Scalars['URL']>;
  thanksButtonCopy?: Maybe<Scalars['String']>;
  formSections?: Maybe<Array<LeadAdFormSection>>;
  /** @deprecated clean code, use thanksTitle and thanksText instead. */
  thanksPage: LeadAdFormThanksPage;
  sender: LeadAdFormSender;
};

export type LeadAdFormField = {
  __typename?: 'LeadAdFormField';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: LeadAdFormFields;
  optional?: Maybe<Scalars['Boolean']>;
  prefilledValue?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['URL']>;
  linkTextCopy?: Maybe<Scalars['String']>;
};

export enum LeadAdFormFields {
  Numeric = 'numeric',
  Boolean = 'boolean',
  Text = 'text',
  Address = 'address',
  Email = 'email',
  PhoneNumber = 'phone_number',
  Information = 'information',
  Date = 'date'
}

export type LeadAdFormSection = {
  __typename?: 'LeadAdFormSection';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: LeadAdFormSections;
  fields?: Maybe<Array<LeadAdFormField>>;
};

export enum LeadAdFormSections {
  Address = 'address',
  CustomFields = 'custom_fields',
  TermsAndConditions = 'terms_and_conditions'
}

export type LeadAdFormSender = {
  __typename?: 'LeadAdFormSender';
  image: Scalars['URL'];
  name: Scalars['String'];
  urn: Scalars['GlobalID'];
  type: AdSenderTypes;
  link: Scalars['String'];
};

export type LeadAdFormSubmissionAttribute = {
  formFieldId: Scalars['ID'];
  value: Scalars['String'];
};

export type LeadAdFormSubmissionCreateError = {
  __typename?: 'LeadAdFormSubmissionCreateError';
  errors?: Maybe<Scalars['JSON']>;
};

export type LeadAdFormSubmissionCreateInput = {
  id: Scalars['ID'];
  leadAdFormSubmissionAttributes?: Maybe<Array<LeadAdFormSubmissionAttribute>>;
  leadAdFormSubmissionTermsAndConditionsAttributes?: Maybe<Array<LeadAdFormSubmissionTermsAndConditionsAttribute>>;
};

export type LeadAdFormSubmissionCreateResult = LeadAdFormSubmissionCreateSuccess | LeadAdFormSubmissionCreateError;

export type LeadAdFormSubmissionCreateSuccess = {
  __typename?: 'LeadAdFormSubmissionCreateSuccess';
  status?: Maybe<Scalars['String']>;
};

export type LeadAdFormSubmissionTermsAndConditionsAttribute = {
  termsAndConditionsFieldId: Scalars['ID'];
  accepted: Scalars['Boolean'];
};

export type LeadAdFormThanksPage = {
  __typename?: 'LeadAdFormThanksPage';
  thanksTitle: Scalars['String'];
  thanksText?: Maybe<Scalars['String']>;
  thanksButtonCopy: Scalars['String'];
};

/**
 * LegacyAboutUsProperties and the resolvers were created to keep compatibility with the old module properties
 * while using the new endpoint to fetch a single module
 * They should be deleted as soon we're able to remove the "properties" attribute from the AboutEntity type
 */
export type LegacyAboutUsProperties = {
  __typename?: 'LegacyAboutUsProperties';
  /** #logged-out #soft-logged-in */
  hasSubpage: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  hasGallery: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  hasDocuments: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  hasAffiliates: Scalars['Boolean'];
};

/** Legal Imprint Module */
export type LegalImprintModule = ModuleInterface & {
  __typename?: 'LegalImprintModule';
  order: Scalars['Int'];
  title: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type LegalInformationInput = {
  id: Scalars['ID'];
  content: Scalars['String'];
};

/** Legal Information Module */
export type LegalInformationModule = ModuleInterface & {
  __typename?: 'LegalInformationModule';
  /** #rest #virtual */
  content?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  title: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type LegalInformationUpdateError = {
  __typename?: 'LegalInformationUpdateError';
  message?: Maybe<Scalars['String']>;
  errors?: Maybe<LegalInformationUpdateErrors>;
};

export type LegalInformationUpdateErrors = {
  __typename?: 'LegalInformationUpdateErrors';
  content?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Legal page */
export type LegalPage = {
  __typename?: 'LegalPage';
  /**
   * #logged-out #soft-logged-in
   *
   *  Name of the legal page
   */
  name?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Slug of the legal page for example 'talentmanager'
   */
  slug: Scalars['String'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Group name of the legal page for example 'terms_and_conditions' or 'legal_notices'
   */
  groupName: Scalars['String'];
};

/** Legal page content */
export type LegalPageContent = {
  __typename?: 'LegalPageContent';
  /**
   * #logged-out #soft-logged-in
   *
   *  Name of the legal page
   */
  name?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Content of the legal page
   */
  content?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  iso8601 encoded UTC datetime when the content was published
   */
  liveDate: Scalars['Date'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Table of contents for the content
   */
  tableOfContents?: Maybe<Array<Maybe<TableOfContent>>>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Flag for showing the nested counter list
   */
  nestedCounterList: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Flag for hiding the table of content
   */
  hideToc: Scalars['Boolean'];
};

/** List of all legal pages for the user. */
export type LegalPages = {
  __typename?: 'LegalPages';
  /** #logged-out #soft-logged-in */
  collection?: Maybe<Array<Maybe<LegalPage>>>;
};

export type LevelAggregation = HasAggregationCount & {
  __typename?: 'LevelAggregation';
  /** #soft-logged-in */
  count: Scalars['Int'];
  /** #soft-logged-in */
  value?: Maybe<Scalars['Int']>;
  /** #soft-logged-in #rest(batched) #virtual */
  label?: Maybe<CareerLevel>;
};

export type LinkPreview = {
  __typename?: 'LinkPreview';
  uniqueId: Scalars['String'];
  url: Scalars['URL'];
  canonicalUrl: Scalars['URL'];
  sourceDomain?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['URL']>;
  cachedImageUrl?: Maybe<Scalars['URL']>;
  metadata: PreviewMetadata;
  isExternal?: Maybe<Scalars['Boolean']>;
};

export type LinkPreviewError = {
  __typename?: 'LinkPreviewError';
  message?: Maybe<Scalars['String']>;
};

export type LinkPreviewMetadata = PreviewMetadata & {
  __typename?: 'LinkPreviewMetadata';
  sourceActor?: Maybe<LinkPreviewSourceActor>;
};

export type LinkPreviewResult = {
  __typename?: 'LinkPreviewResult';
  success?: Maybe<LinkPreview>;
  error?: Maybe<LinkPreviewError>;
};

export type LinkPreviewSourceActor = {
  __typename?: 'LinkPreviewSourceActor';
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['URL']>;
  message?: Maybe<Scalars['String']>;
};

export type LinkedInImportStatus = {
  __typename?: 'LinkedInImportStatus';
  profileId: Scalars['ID'];
  status: LinkedInImportStatusState;
  percentage: Scalars['Float'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
};

export enum LinkedInImportStatusState {
  Pending = 'PENDING',
  FetchingProfile = 'FETCHING_PROFILE',
  FetchingEducation = 'FETCHING_EDUCATION',
  FetchingOccupations = 'FETCHING_OCCUPATIONS',
  ProcessingData = 'PROCESSING_DATA',
  Saving = 'SAVING',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type LlmGatewayAboutMeSuggestion = {
  __typename?: 'LlmGatewayAboutMeSuggestion';
  /** #logged-out #soft-logged-in */
  language?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  aboutMe?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  trackingToken?: Maybe<Scalars['String']>;
};

export type LlmGatewayCoverLetterJobId = {
  __typename?: 'LlmGatewayCoverLetterJobId';
  /** #logged-out #soft-logged-in */
  jobId?: Maybe<Scalars['String']>;
};

export type LlmGatewayCoverLetterSuggestion = {
  __typename?: 'LlmGatewayCoverLetterSuggestion';
  /** #logged-out #soft-logged-in */
  jobId?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  status?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  progress?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  stagesOutput?: Maybe<Array<Maybe<LlmGatewayStages>>>;
  /** #logged-out #soft-logged-in */
  language?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  content?: Maybe<Array<Maybe<VitaCoverLetterContent>>>;
  /** #logged-out #soft-logged-in */
  trackingToken?: Maybe<Scalars['String']>;
};

export type LlmGatewayCvLessApplyQuestions = {
  __typename?: 'LlmGatewayCvLessApplyQuestions';
  /** #logged-out #soft-logged-in */
  jobId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  competencies?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #logged-out #soft-logged-in */
  skills?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #logged-out #soft-logged-in */
  trackingToken?: Maybe<Scalars['String']>;
};

export type LlmGatewayCvLessApplyQuestionsInput = {
  jobId: Scalars['Int'];
};

export type LlmGatewayError = {
  __typename?: 'LlmGatewayError';
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type LlmGatewayGenerateAboutMeResult = LlmGatewayAboutMeSuggestion | LlmGatewayError;

export type LlmGatewayGenerateCoverLetterResult = LlmGatewayCoverLetterSuggestion | LlmGatewayError;

export type LlmGatewayGenerateCvLessApplyQuestionsResult = LlmGatewayCvLessApplyQuestions | LlmGatewayError;

export type LlmGatewayInteractionTrackingInput = {
  consumer: Scalars['String'];
  trackingToken: Scalars['String'];
  interactionType: LlmGatewayInteractionType;
  userInput?: Maybe<Scalars['String']>;
};

export type LlmGatewayInteractionTrackingResult = {
  __typename?: 'LlmGatewayInteractionTrackingResult';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
};

export enum LlmGatewayInteractionType {
  Like = 'LIKE',
  Dislike = 'DISLIKE',
  Submit = 'SUBMIT'
}

export type LlmGatewayStages = {
  __typename?: 'LlmGatewayStages';
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  output?: Maybe<Scalars['String']>;
};

export type LlmGatewayTriggerCoverLetterResult = LlmGatewayCoverLetterJobId | LlmGatewayError;

export type LoPreviewCommunity = {
  __typename?: 'LoPreviewCommunity';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  links?: Maybe<CommunityLinks>;
  /** #logged-out #soft-logged-in */
  memberCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  logo: CommunityLogos;
  /** #logged-out #soft-logged-in */
  postCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  commentCount: Scalars['Int'];
};

export type LoPreviewGroupMembershipsCollection = {
  __typename?: 'LoPreviewGroupMembershipsCollection';
  /**
   * #logged-out #soft-logged-in
   * @deprecated Due to groups shutdown, will return empty collection after 1.12.2022
   */
  collection?: Maybe<Array<Maybe<LoPreviewCommunity>>>;
};

export type LoPreviewProfileWorkExperienceCollection = {
  __typename?: 'LoPreviewProfileWorkExperienceCollection';
  collection?: Maybe<Array<Maybe<LoPreviewWorkexperience>>>;
};

export type LoPreviewWorkexperience = {
  __typename?: 'LoPreviewWorkexperience';
  /** #logged-out #soft-logged-in */
  currentCompany?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  primaryJob?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  beginDate?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  duration?: Maybe<ProfileWorkExperienceDuration>;
  /** #logged-out #soft-logged-in */
  endDate?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companyName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companyUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
  /** #logged-out #soft-logged-in */
  normalizedName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  jobTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
  /** #rest(batched) #virtual */
  workExperienceStatus?: Maybe<WorkExperienceStatus>;
  /** #logged-out #soft-logged-in */
  orgTypeId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  localizedTimeString?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companyNotes?: Maybe<Scalars['String']>;
};

export type LoProfile = {
  __typename?: 'LoProfile';
  /** #rest #virtual */
  xingId?: Maybe<XingIdOrError>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profileAboutMe?: Maybe<ProfileAboutMe>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profilePageMeta?: Maybe<ProfilePageMetaOrError>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profileStructuredData?: Maybe<ProfileStructuredData>;
  /** #paginated #logged-out #soft-logged-in #rest #virtual */
  peopleUserBag?: Maybe<PeopleUserBagConnection>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profileSkills?: Maybe<ProfileSkills>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profileWorkExperience?: Maybe<LoPreviewProfileWorkExperienceCollection>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profileEducation?: Maybe<ProfileEducationCollection>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profileModuleStoreItems?: Maybe<Array<Maybe<ProfileModuleStoreItem>>>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profileLanguageSkills?: Maybe<LoggedOutProfileLanguageCollection>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profileWants?: Maybe<ProfileWants>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profileWantsCollection?: Maybe<ProfileWants2>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profileInterests?: Maybe<ProfileInterests>;
  /** #logged-out #soft-logged-in */
  profilePublicGroupMemberships?: Maybe<LoPreviewGroupMembershipsCollection>;
  /** #logged-out #soft-logged-in #rest #virtual */
  similarProfiles?: Maybe<RelatedProfileCollection>;
};


export type LoProfilePeopleUserBagArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

/**
 * Interface for localizable object types.
 *
 * New Work One needs to support a mixed model,
 * because localization strategies differ between
 * Hops and Malt and the native mobile apps.
 *
 * While the former would like to do localization
 * mostly on the client side, the latter prefers
 * flexible localization on the backend (based on the `Accept-Language` header).
 * We're using `GraphQL` to allow both:
 *
 * * If you're interested in only the translation key, you'd request `localizationKey`.
 * * If you want to have the localized value, please request `localizationValue`.
 *
 * The locales for this are all coming from the `website` project in `Phraseapp`.
 * You can find them by searching for the `all_platforms` tag.
 */
export type Localizable = {
  /** The raw text resource key from Phraseapp */
  localizationKey: Scalars['String'];
  /** The value localized based on the `Accept-Language` header */
  localizationValue: Scalars['String'];
};

export type LocalizedCompanyRecommendationReason = Localizable & {
  __typename?: 'LocalizedCompanyRecommendationReason';
  localizationValue: Scalars['String'];
  localizationKey: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
  /** #logged-out #soft-logged-in */
  radius?: Maybe<Scalars['Int']>;
};

/** LocationsPreference Type */
export type LocationsPreference = {
  __typename?: 'LocationsPreference';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  cities: Array<Maybe<City>>;
  /** #logged-out #soft-logged-in */
  maxDistance?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  willingnessToTravel?: Maybe<GetWillingnessToTravelEnum>;
};

export type LocationsPreferenceDataState = {
  __typename?: 'LocationsPreferenceDataState';
  state: JobPreferencesDataStateStatus;
  cities: JobPreferencesDataStateStatus;
  maxDistance: JobPreferencesDataStateStatus;
  willingnessToTravel: JobPreferencesDataStateStatus;
};

export type LoggedInProfileLanguage = {
  __typename?: 'LoggedInProfileLanguage';
  language?: Maybe<Scalars['String']>;
  skillLevelId?: Maybe<Scalars['Int']>;
};

export type LoggedInProfileLanguageCollection = {
  __typename?: 'LoggedInProfileLanguageCollection';
  languageSkills?: Maybe<LoggedInProfileLanguageSkills>;
};

export type LoggedInProfileLanguageSkills = {
  __typename?: 'LoggedInProfileLanguageSkills';
  languages?: Maybe<Array<Maybe<LoggedInProfileLanguage>>>;
  additionalLanguages?: Maybe<Scalars['String']>;
};

export type LoggedOutProfileLanguageCollection = {
  __typename?: 'LoggedOutProfileLanguageCollection';
  /** #logged-out #soft-logged-in */
  collection?: Maybe<Array<Maybe<LoggedOutProfileLanguageSkills>>>;
};

export type LoggedOutProfileLanguageSkills = {
  __typename?: 'LoggedOutProfileLanguageSkills';
  /** #logged-out #soft-logged-in */
  language?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  skillLevelId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  displayLanguage?: Maybe<Scalars['String']>;
};

/** Reason why the security issue was raised */
export enum LoginSecurityIssueReason {
  /** manually created, for testing purposes mostly */
  Manual = 'MANUAL',
  /** EIDI project detected compromised credentials */
  Eidi = 'EIDI',
  /** password version is deprecated */
  OldVersion = 'OLD_VERSION',
  /** user has not logged in since some years ago */
  LongInactive = 'LONG_INACTIVE',
  /** email has been bounced */
  EmailBounced = 'EMAIL_BOUNCED',
  /** reminder to set up the TFA */
  NoTwoFactorAuth = 'NO_TWO_FACTOR_AUTH'
}

/** Web sessions */
export type LoginSession = {
  __typename?: 'LoginSession';
  id: Scalars['ID'];
  active?: Maybe<Scalars['Boolean']>;
  lastAccess?: Maybe<Scalars['Date']>;
  location?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  isp?: Maybe<Scalars['String']>;
  browser?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
};

/** Login related settings, currently support only password */
export type LoginSettings = {
  __typename?: 'LoginSettings';
  password?: Maybe<PasswordSetting>;
};

export type LoginSettingsError = {
  __typename?: 'LoginSettingsError';
  errors?: Maybe<Array<Scalars['String']>>;
};

/**
 * Login related settings which need to be updated.
 * Currently supports only setting the password.
 */
export type LoginSettingsInput = {
  password?: Maybe<PasswordSettingInput>;
};

export type LoginSettingsMutationResult = {
  __typename?: 'LoginSettingsMutationResult';
  error?: Maybe<LoginSettings>;
  response?: Maybe<LoginSettings>;
};

/** Current user login state */
export enum LoginState {
  LoggedIn = 'LOGGED_IN',
  LoggedOut = 'LOGGED_OUT',
  SoftLoggedIn = 'SOFT_LOGGED_IN'
}

/** Pending security issue of a user (e.g. password compromised, tfa recommended, email bounced) */
export type LoginUserSecurityIssue = {
  __typename?: 'LoginUserSecurityIssue';
  /** Unique ID of the security issue */
  id: Scalars['ID'];
  /** Reason why the issue was raised */
  reason: LoginSecurityIssueReason;
};

/** List of pending security issues for a user (e.g. password compromised, tfa recommended, email bounced) */
export type LoginUserSecurityIssues = {
  __typename?: 'LoginUserSecurityIssues';
  collection: Array<LoginUserSecurityIssue>;
};

export type LoginUserSecurityIssuesAcknowledgeMutationError = {
  __typename?: 'LoginUserSecurityIssuesAcknowledgeMutationError';
  message?: Maybe<Scalars['String']>;
};

export type LoginUserSecurityIssuesAcknowledgeMutationInput = {
  /** Unique ID of the security issue */
  id: Scalars['ID'];
  /** should the issue be resolved (primary action clicked) */
  resolve: Scalars['Boolean'];
};

export type LoginUserSecurityIssuesAcknowledgeMutationResult = {
  __typename?: 'LoginUserSecurityIssuesAcknowledgeMutationResult';
  error?: Maybe<LoginUserSecurityIssuesAcknowledgeMutationError>;
};


export type ManagedCompanies = {
  __typename?: 'ManagedCompanies';
  /** #rest(batched) #virtual */
  company?: Maybe<Company>;
};

export type ManagedCompaniesConnection = HasCursorPagination & {
  __typename?: 'ManagedCompaniesConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<ManagedCompaniesEdge>>>;
};

export type ManagedCompaniesEdge = PaginationEdge & {
  __typename?: 'ManagedCompaniesEdge';
  cursor: Scalars['String'];
  node?: Maybe<ManagedCompanies>;
};

export type MarkAllChatsAsReadError = {
  __typename?: 'MarkAllChatsAsReadError';
  message?: Maybe<Scalars['String']>;
};

export type MarkAllChatsAsReadPopupAsShownError = {
  __typename?: 'MarkAllChatsAsReadPopupAsShownError';
  message?: Maybe<Scalars['String']>;
};

export type MarkAllChatsAsReadPopupAsShownResult = MarkAllChatsAsReadPopupAsShownSuccess | MarkAllChatsAsReadPopupAsShownError;

export type MarkAllChatsAsReadPopupAsShownSuccess = {
  __typename?: 'MarkAllChatsAsReadPopupAsShownSuccess';
  success: Scalars['Boolean'];
};

export type MarkAllChatsAsReadResult = MarkAllChatsAsReadSuccess | MarkAllChatsAsReadError;

export type MarkAllChatsAsReadSuccess = {
  __typename?: 'MarkAllChatsAsReadSuccess';
  success: Scalars['Boolean'];
};

export type MarkAsReadMessengerChatError = {
  __typename?: 'MarkAsReadMessengerChatError';
  message?: Maybe<Scalars['String']>;
};

export type MarkAsReadMessengerChatInput = {
  id: Scalars['ID'];
};

export type MarkAsReadMessengerChatResult = {
  __typename?: 'MarkAsReadMessengerChatResult';
  success?: Maybe<MessengerChat>;
  error?: Maybe<MarkAsReadMessengerChatError>;
};

export type MarkAsSeenInput = {
  urn: Scalars['String'];
  source: HasSeenSource;
};

export type MarkAsSeenMutationResult = {
  __typename?: 'MarkAsSeenMutationResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type MarkAsUnreadMessengerChatInput = {
  id: Scalars['ID'];
};

export type MarkAsUnreadMessengerChatResult = {
  __typename?: 'MarkAsUnreadMessengerChatResult';
  success?: Maybe<MessengerChat>;
  error?: Maybe<MarkAsUnreadMessengerChatResultError>;
};

export type MarkAsUnreadMessengerChatResultError = {
  __typename?: 'MarkAsUnreadMessengerChatResultError';
  message: Scalars['String'];
};


export type MasterDirectoryEntry = {
  __typename?: 'MasterDirectoryEntry';
  /** #logged-out #soft-logged-in */
  displayName: Scalars['String'];
  /** #logged-out #soft-logged-in */
  jobCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  url: Scalars['String'];
};

export type MasterDirectoryEntryList = {
  __typename?: 'MasterDirectoryEntryList';
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<MasterDirectoryEntry>>;
};

export enum MasterDirectoryEntryType {
  JobRole = 'JOB_ROLE',
  Company = 'COMPANY',
  Location = 'LOCATION'
}

export type MatchingReasonsResult = {
  __typename?: 'MatchingReasonsResult';
  /** #logged-out #soft-logged-in */
  backgroundJobId: Scalars['String'];
  /** #logged-out #soft-logged-in */
  jobPostingIds: Array<Scalars['ID']>;
};

export type MeetingRoomAddAttendeeInput = {
  sessionId: Scalars['String'];
};

export type MeetingRoomAddAttendeeResult = {
  __typename?: 'MeetingRoomAddAttendeeResult';
  error?: Maybe<MeetingRoomAddAttendeeResultError>;
  success?: Maybe<MeetingRoomAttendee>;
};

export type MeetingRoomAddAttendeeResultError = {
  __typename?: 'MeetingRoomAddAttendeeResultError';
  errors?: Maybe<Array<Scalars['String']>>;
};

export type MeetingRoomAttendee = {
  __typename?: 'MeetingRoomAttendee';
  /** #rest(batched) #virtual */
  user: XingId;
  token: Scalars['String'];
};

export type MemberAggregations = {
  __typename?: 'MemberAggregations';
  /** #soft-logged-in */
  city?: Maybe<Array<Maybe<MemberSearchAggregation>>>;
  /** #soft-logged-in */
  companyId?: Maybe<Array<Maybe<CompanyIdAggregation>>>;
  /** #soft-logged-in */
  companySize?: Maybe<Array<Maybe<MemberSearchAggregation>>>;
  /** #soft-logged-in */
  country?: Maybe<Array<Maybe<CountryAggregation>>>;
  /** #soft-logged-in */
  currentStart?: Maybe<Array<Maybe<MemberSearchAggregation>>>;
  /** #soft-logged-in */
  currentStatusCode?: Maybe<Array<Maybe<MemberSearchAggregation>>>;
  /** #soft-logged-in */
  executive?: Maybe<Array<Maybe<MemberSearchAggregation>>>;
  /** #soft-logged-in */
  industry?: Maybe<Array<Maybe<IndustryAggregation>>>;
  /** #soft-logged-in */
  language?: Maybe<Array<Maybe<MemberSearchAggregation>>>;
  /** #soft-logged-in */
  level?: Maybe<Array<Maybe<LevelAggregation>>>;
  /** #soft-logged-in */
  public?: Maybe<Array<Maybe<MemberSearchAggregation>>>;
  /** #soft-logged-in */
  title?: Maybe<Array<Maybe<MemberSearchAggregation>>>;
  /** #soft-logged-in */
  zipCode?: Maybe<Array<Maybe<MemberSearchAggregation>>>;
};

/**
 * Aggregations/facets for members search. Maximum number of distinct values to be returned by this aggregation
 * Usual one is 10, as calculating aggregations is a really costly operation do not require more than 20 as general rule.
 */
export type MemberAggregationsInput = {
  city?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  companySize?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  currentStart?: Maybe<Scalars['String']>;
  currentStatusCode?: Maybe<Scalars['String']>;
  executive?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

/**
 * Available filters for members search.
 * In general filters results which match ANY of the given values (comma separated except special
 * cases documented individually).
 */
export type MemberFiltersInput = {
  active?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  companySize?: Maybe<Scalars['String']>;
  /**
   * CompletedAt: Defines range(comma separated) for completed_at for filtering results.
   * Supported formats are:
   * 123/456: values larger than 123 but smaller than 456
   * /456: values smaller than 456
   * 123/: values larger than 123
   * Date ranges are also supported, using the format yyyy-MM-ddThh:mm:ssZ
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   * ConnectionLevel:
   * 1- 1st degree connections (direct connections)
   * 2 - 2nd degree connections(connections of a direct connection who are not a 1st degree connection)
   * 3 - 3rd+ degree connections(all other profiles)
   */
  connectionLevel?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  currentStart?: Maybe<Scalars['String']>;
  currentStatusCode?: Maybe<Scalars['String']>;
  discipline?: Maybe<Scalars['String']>;
  executive?: Maybe<Scalars['String']>;
  features?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  /**
   * ContactLevel:
   * Filters results based on its connection level from the requesting user. Possible values are:
   * non: non connections
   * 1: direct connections
   * 2: direct connections and connections of connections
   * 2-1: non direct connections(only connections of connections)
   */
  level?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type MemberPredictiveSearchItem = PredictiveSearchItem & {
  __typename?: 'MemberPredictiveSearchItem';
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /** #soft-logged-in */
  data: Scalars['String'];
  /** #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #soft-logged-in */
  payload?: Maybe<ExtraData>;
};

/** Free text search for the following fields */
export type MemberQueriesInput = {
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  education?: Maybe<Scalars['String']>;
  employer?: Maybe<Scalars['String']>;
  haves?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  interests?: Maybe<Scalars['String']>;
  jobrole?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizations?: Maybe<Scalars['String']>;
  previousCompany?: Maybe<Scalars['String']>;
  previousTitle?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  wants?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type MemberSearchAggregation = HasAggregationCount & {
  __typename?: 'MemberSearchAggregation';
  /** #soft-logged-in */
  count: Scalars['Int'];
  /** #soft-logged-in */
  value: Scalars['String'];
};

export type MembersSearchConnection = HasCursorPagination & {
  __typename?: 'MembersSearchConnection';
  /** #soft-logged-in */
  edges: Array<MembersSearchEdge>;
  /** #soft-logged-in */
  service: Scalars['String'];
  /** #soft-logged-in */
  totalShown: Scalars['Int'];
  /** #soft-logged-in */
  aggs?: Maybe<MemberAggregations>;
  /** #soft-logged-in */
  zeroSearch: Scalars['Boolean'];
  /** #soft-logged-in */
  total: Scalars['Int'];
  /** #soft-logged-in */
  pageInfo: PageInfo;
};

export type MembersSearchEdge = PaginationEdge & {
  __typename?: 'MembersSearchEdge';
  /** #soft-logged-in */
  node?: Maybe<MembersSearchResult>;
  /** #soft-logged-in */
  cursor: Scalars['String'];
};

export type MembersSearchFencedItem = MembersSearchItem & {
  __typename?: 'MembersSearchFencedItem';
  /** #soft-logged-in #rest(batched) #virtual */
  fencedXingId?: Maybe<MembersSearchFencedXingId>;
  /** #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #soft-logged-in */
  position: Scalars['Int'];
  /** #soft-logged-in */
  score?: Maybe<Scalars['Float']>;
  /** #soft-logged-in */
  showType: Scalars['String'];
};

export type MembersSearchFencedXingId = {
  __typename?: 'MembersSearchFencedXingId';
  /** #soft-logged-in */
  profileImage?: Maybe<Array<Maybe<ProfileImage>>>;
};


export type MembersSearchFencedXingIdProfileImageArgs = {
  size: Array<ProfileImageSize>;
};

export type MembersSearchHitReason = {
  __typename?: 'MembersSearchHitReason';
  /** #soft-logged-in */
  title: Scalars['String'];
  /** #soft-logged-in */
  reason: Scalars['String'];
};

export type MembersSearchItem = {
  /** #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #soft-logged-in */
  position: Scalars['Int'];
  /** #soft-logged-in */
  score?: Maybe<Scalars['Float']>;
  /** #soft-logged-in */
  showType: Scalars['String'];
};

/** Available params for members search */
export type MembersSearchQueryInput = {
  /** Request consumer, used for tracking and analisis purposes */
  consumer: Scalars['String'];
  /** Free text search for keywords */
  keywords?: Maybe<Scalars['String']>;
  queries?: Maybe<MemberQueriesInput>;
  highlight?: Maybe<HighlightInput>;
  filters?: Maybe<MemberFiltersInput>;
  aggregations?: Maybe<MemberAggregationsInput>;
  /** Timeout for Elasticsearch call */
  timeout?: Maybe<Scalars['Int']>;
  /** Choses the criteria by which the collection should be sorted. Available options are: relevance, newest */
  sort?: Maybe<Scalars['String']>;
};

export type MembersSearchResult = MembersSearchUnfencedItem | MembersSearchFencedItem;

export type MembersSearchUnfencedItem = MembersSearchItem & {
  __typename?: 'MembersSearchUnfencedItem';
  /** #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /** #soft-logged-in */
  showAddContact: Scalars['Boolean'];
  /** #soft-logged-in */
  highlight?: Maybe<HighlightResult>;
  /** #soft-logged-in */
  contains?: Maybe<Array<Scalars['String']>>;
  /** #soft-logged-in */
  missing?: Maybe<Array<Scalars['String']>>;
  /** #soft-logged-in */
  hitReasons?: Maybe<Array<MembersSearchHitReason>>;
  /** #rest(batched) #virtual */
  sharedContacts?: Maybe<SharedContacts>;
  /** #rest(batched) #virtual */
  contactsCount?: Maybe<BatchContactsCount>;
  /** #soft-logged-in #rest(batched) #virtual */
  profileSkills?: Maybe<ProfileSkills>;
  /** #soft-logged-in #rest(batched) #virtual */
  networkRelationship?: Maybe<NetworkRelationship>;
  /** #soft-logged-in #rest(batched) #virtual */
  contactDistance?: Maybe<ContactDistance>;
  /** #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #soft-logged-in */
  position: Scalars['Int'];
  /** #soft-logged-in */
  score?: Maybe<Scalars['Float']>;
  /** #soft-logged-in */
  showType: Scalars['String'];
};

export type MessageApplication = {
  __typename?: 'MessageApplication';
  /** #soft-logged-in */
  contactUserId?: Maybe<Scalars['ID']>;
};

export type MessageConversationStarter = ConversationStarter & {
  __typename?: 'MessageConversationStarter';
  /** #rest(batched) #virtual */
  actor?: Maybe<MessengerParticipant>;
  /** #rest(batched) #virtual */
  object?: Maybe<MessengerMessage>;
  /** #rest(batched) #virtual */
  target?: Maybe<MessengerChat>;
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type MessageEdge = PaginationEdge & {
  __typename?: 'MessageEdge';
  cursor: Scalars['String'];
  node: MessengerMessage;
};

/** It defines the supported messages' types. */
export enum MessageType {
  Attachment = 'ATTACHMENT',
  ChatUpdated = 'CHAT_UPDATED',
  ContactConfirmed = 'CONTACT_CONFIRMED',
  ContactRequestCreated = 'CONTACT_REQUEST_CREATED',
  ContactRequestDeclined = 'CONTACT_REQUEST_DECLINED',
  Html = 'HTML',
  Image = 'IMAGE',
  Object = 'OBJECT',
  ParticipantAdded = 'PARTICIPANT_ADDED',
  ParticipantJoined = 'PARTICIPANT_JOINED',
  ParticipantBirthday = 'PARTICIPANT_BIRTHDAY',
  ParticipantKicked = 'PARTICIPANT_KICKED',
  ParticipantLeft = 'PARTICIPANT_LEFT',
  PositionShare = 'POSITION_SHARE',
  Preview = 'PREVIEW',
  ScheduledMessageCreated = 'SCHEDULED_MESSAGE_CREATED',
  ScheduledMessageDeleted = 'SCHEDULED_MESSAGE_DELETED',
  StoryReference = 'STORY_REFERENCE',
  Secret = 'SECRET',
  Text = 'TEXT',
  TextLocalised = 'TEXT_LOCALISED',
  SystemReply = 'SYSTEM_REPLY',
  AutoDeclined = 'AUTO_DECLINED'
}

export type MessagesSearch = {
  __typename?: 'MessagesSearch';
  items?: Maybe<Array<Maybe<SearchResultMessage>>>;
  moreItems?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export type MessengerAttachment = {
  __typename?: 'MessengerAttachment';
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mimeType?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export type MessengerAttachmentMessagePayload = {
  __typename?: 'MessengerAttachmentMessagePayload';
  attachments?: Maybe<Array<Maybe<MessengerAttachment>>>;
};

export type MessengerAutoDeclinedMessagePayload = {
  __typename?: 'MessengerAutoDeclinedMessagePayload';
  body?: Maybe<Scalars['String']>;
};

export type MessengerBanner = {
  __typename?: 'MessengerBanner';
  show: Scalars['Boolean'];
};

export enum MessengerBannerAction {
  Shown = 'SHOWN',
  ShowLater = 'SHOW_LATER'
}

export enum MessengerBannerType {
  CollectFeedback = 'COLLECT_FEEDBACK',
  CollectFeedbackIndividualRms = 'COLLECT_FEEDBACK_INDIVIDUAL_RMS',
  CollectPreferences = 'COLLECT_PREFERENCES',
  NudgeTalentResponse = 'NUDGE_TALENT_RESPONSE'
}

export type MessengerBotReplyQuickAction = MessengerQuickActionInterface & {
  __typename?: 'MessengerBotReplyQuickAction';
  replyId: Scalars['String'];
  body: Scalars['String'];
  type: Scalars['String'];
  textResourceId?: Maybe<Scalars['String']>;
};

export type MessengerChat = {
  __typename?: 'MessengerChat';
  id: Scalars['ID'];
  type: MessengerChatType;
  layout: MessengerChatLayout;
  creatorId?: Maybe<Scalars['ID']>;
  topic: Scalars['String'];
  subtitle: Scalars['String'];
  /**
   * #rest(batched) #virtual
   * @deprecated Lacks support for Messenger's system users. Use messengerParticipants instead.
   */
  participants?: Maybe<Array<Maybe<XingId>>>;
  messengerParticipants?: Maybe<Array<Maybe<ResolvedParticipantUserUrn>>>;
  messengerModerators?: Maybe<Array<Maybe<ResolvedParticipantUserUrn>>>;
  /** #rest(batched) #virtual */
  lastMessage?: Maybe<MessengerMessage>;
  unreadMessagesCount?: Maybe<Scalars['Int']>;
  maxAllowedChatParticipants: Scalars['Int'];
  /** @deprecated use abilities.canCreateMessage instead. */
  forbidSendingMessages: Scalars['Boolean'];
  /** #rest(batched) #virtual */
  abilities?: Maybe<MessengerChatAbilities>;
  description: Scalars['String'];
  deleted: Scalars['Boolean'];
  listedAt: Scalars['Date'];
  touchedAt: Scalars['Date'];
  imageUrls: MessengerImage;
  preview: MessengerChatPreview;
  /** @deprecated use participants.id instead. WILL BE REMOVED ... */
  participantUserIds: Array<Maybe<Scalars['ID']>>;
};

export type MessengerChatAbilities = {
  __typename?: 'MessengerChatAbilities';
  canCreateMessage: Scalars['Boolean'];
  canSeeComposeView: Scalars['Boolean'];
  canEditChatTopic: Scalars['Boolean'];
  canCreateImageMessage: Scalars['Boolean'];
  canCreateAttachmentMessage: Scalars['Boolean'];
  canOpenChatDetails: Scalars['Boolean'];
  canAddChatParticipants: Scalars['Boolean'];
  canDeleteChatParticipants: Scalars['Boolean'];
  canDeleteChat: Scalars['Boolean'];
  /** @deprecated this ability is not needed as this chat is no longer used */
  canOpenXingGuideSettings: Scalars['Boolean'];
  canUseMessageTemplates: Scalars['Boolean'];
  canOpenSendCv: Scalars['Boolean'];
};

export type MessengerChatEdge = PaginationEdge & {
  __typename?: 'MessengerChatEdge';
  cursor: Scalars['String'];
  node: MessengerChat;
};

export enum MessengerChatLayout {
  Group = 'GROUP',
  OneOnOne = 'ONE_ON_ONE'
}

export type MessengerChatMessagesConnection = HasCursorPagination & {
  __typename?: 'MessengerChatMessagesConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<MessageEdge>>;
};

export type MessengerChatPreview = {
  __typename?: 'MessengerChatPreview';
  sender: Scalars['String'];
  text: Scalars['String'];
};

export enum MessengerChatType {
  BroadcastChat = 'BROADCAST_CHAT',
  GroupChat = 'GROUP_CHAT',
  KickedChat = 'KICKED_CHAT',
  LegacyChat = 'LEGACY_CHAT',
  OneOnOneChat = 'ONE_ON_ONE_CHAT',
  SecretOneOnOneChat = 'SECRET_ONE_ON_ONE_CHAT',
  SystemChat = 'SYSTEM_CHAT',
  XbpChat = 'XBP_CHAT',
  XingGuideChat = 'XING_GUIDE_CHAT',
  XtmChat = 'XTM_CHAT',
  AiAgentChat = 'AI_AGENT_CHAT',
  AiAgentTppChat = 'AI_AGENT_TPP_CHAT'
}

/** This type is just a stub. Real implementation will come later. */
export type MessengerChatUpdatedSystemMessagePayload = {
  __typename?: 'MessengerChatUpdatedSystemMessagePayload';
  body?: Maybe<Scalars['String']>;
};

export type MessengerChatsConnection = HasCursorPagination & {
  __typename?: 'MessengerChatsConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<MessengerChatEdge>>;
};

export enum MessengerChatsFilterTypes {
  All = 'ALL',
  Unread = 'UNREAD',
  Recruiter = 'RECRUITER'
}

export type MessengerContact = {
  __typename?: 'MessengerContact';
  id: Scalars['ID'];
  displayName: Scalars['String'];
  pageName: Scalars['String'];
  photoUrls: MessengerImage;
  occupationTitle: Scalars['String'];
  occupationOrg: Scalars['String'];
};

/** This type is just a stub. Real implementation will come later. */
export type MessengerContactConfirmedSystemMessagePayload = {
  __typename?: 'MessengerContactConfirmedSystemMessagePayload';
  body?: Maybe<Scalars['String']>;
};

/** This type is just a stub. Real implementation will come later. */
export type MessengerContactRequestCreatedSystemMessagePayload = {
  __typename?: 'MessengerContactRequestCreatedSystemMessagePayload';
  body?: Maybe<Scalars['String']>;
};

/** This type is just a stub. Real implementation will come later. */
export type MessengerContactRequestDeclinedSystemMessagePayload = {
  __typename?: 'MessengerContactRequestDeclinedSystemMessagePayload';
  body?: Maybe<Scalars['String']>;
};

export type MessengerContactsConnection = HasCursorPagination & {
  __typename?: 'MessengerContactsConnection';
  edges?: Maybe<Array<Maybe<MessengerContactsEdge>>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type MessengerContactsEdge = PaginationEdge & {
  __typename?: 'MessengerContactsEdge';
  node?: Maybe<MessengerContact>;
  /** #virtual */
  cursor: Scalars['String'];
};

/** It defines in which context a user might have gotten into the chat. */
export enum MessengerContextId {
  RecruiterOfferjob = 'RECRUITER_OFFERJOB',
  RecruiterInterest = 'RECRUITER_INTEREST',
  Birthday = 'BIRTHDAY',
  ConversationStarter = 'CONVERSATION_STARTER',
  Profile = 'PROFILE',
  ChnjWelcome = 'CHNJ_WELCOME',
  ChnjMeet = 'CHNJ_MEET',
  ChnjCongrats = 'CHNJ_CONGRATS',
  ChnjGoodbye = 'CHNJ_GOODBYE',
  CoworkerWelcome = 'COWORKER_WELCOME',
  CoworkerMeet = 'COWORKER_MEET'
}

export type MessengerControls = {
  __typename?: 'MessengerControls';
  showMarkAllChatsAsReadPopup: Scalars['Boolean'];
};

export type MessengerDeclineReasonQuickAction = MessengerQuickActionInterface & {
  __typename?: 'MessengerDeclineReasonQuickAction';
  replyId: Scalars['String'];
  body: Scalars['String'];
  type: Scalars['String'];
  textResourceId?: Maybe<Scalars['String']>;
};

export type MessengerExecuteOneClickActionError = {
  __typename?: 'MessengerExecuteOneClickActionError';
  message: Scalars['String'];
  errors?: Maybe<Scalars['String']>;
};

export type MessengerExecuteOneClickActionInput = {
  /** The token provided by the backend holding the encoded action and params */
  token: Scalars['String'];
};

export type MessengerExecuteOneClickActionResult = MessengerExecuteOneClickActionSuccess | MessengerExecuteOneClickActionError;

export type MessengerExecuteOneClickActionSuccess = {
  __typename?: 'MessengerExecuteOneClickActionSuccess';
  result: MessengerExecuteOneClickActionSuccessPayload;
};

export type MessengerExecuteOneClickActionSuccessPayload = MessengerOneClickActionForwardToChat | CreateMessengerOneClickSystemReplyMessageSuccess;

/** This type is just a stub. Real implementation will come later. */
export type MessengerHtmlMessagePayload = {
  __typename?: 'MessengerHTMLMessagePayload';
  body?: Maybe<Scalars['String']>;
};

export type MessengerImage = {
  __typename?: 'MessengerImage';
  size64x64: Scalars['URL'];
  size96x96: Scalars['URL'];
  size128x128: Scalars['URL'];
  size192x192: Scalars['URL'];
  size256x256: Scalars['URL'];
};

export type MessengerImageMessagePayload = {
  __typename?: 'MessengerImageMessagePayload';
  originalImage?: Maybe<MessengerOriginalImage>;
  /** #virtual */
  scaledImages?: Maybe<Array<ScaledImage>>;
  /** @deprecated Moved to inside the originalImage field. Please use it instead. */
  filesize?: Maybe<Scalars['Int']>;
  /** @deprecated Moved to inside the originalImage field. Please use it instead. */
  height?: Maybe<Scalars['Int']>;
  /** @deprecated Moved to inside the originalImage field. Please use it instead. */
  width?: Maybe<Scalars['Int']>;
  /**
   * #virtual
   * @deprecated Renamed. Use the scaledImages field please.
   */
  images?: Maybe<Array<ScaledImage>>;
  /** @deprecated Not needed anymore. Use the images field please. */
  uuid?: Maybe<Scalars['UUID']>;
};


export type MessengerImageMessagePayloadScaledImagesArgs = {
  dimensions: Array<ScaledImageDimension>;
};


export type MessengerImageMessagePayloadImagesArgs = {
  dimensions: Array<ScaledImageDimension>;
};

export type MessengerJobExpose = {
  __typename?: 'MessengerJobExpose';
  /** #rest(batched) #virtual */
  job: VisibleJob;
  matches: Array<ExposeMatch>;
};

export type MessengerMessage = {
  __typename?: 'MessengerMessage';
  author?: Maybe<ResolvedParticipantUserUrn>;
  chatId: Scalars['ID'];
  /** A unique identifier generated by the client application in order to avoid creating duplicates in retry mechanisms */
  clientId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Date']>;
  fallbackBody?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  payload: MessengerMessagePayload;
  preview?: Maybe<MessengerMessagePreview>;
  read: Scalars['Boolean'];
  /**
   * #rest(batched) #virtual
   * @deprecated Lacks support for Messenger's system users. Use author instead.
   */
  sender?: Maybe<XingId>;
  type: MessageType;
  urn: Scalars['GlobalID'];
  userMessageStatusId?: Maybe<Scalars['ID']>;
};

export type MessengerMessageObject = XingId | VisibleJob | UnauthorizedJob | MessengerJobExpose;

export type MessengerMessagePayload = MessengerAttachmentMessagePayload | MessengerChatUpdatedSystemMessagePayload | MessengerContactConfirmedSystemMessagePayload | MessengerContactRequestCreatedSystemMessagePayload | MessengerContactRequestDeclinedSystemMessagePayload | MessengerHtmlMessagePayload | MessengerImageMessagePayload | MessengerObjectMessagePayload | MessengerParticipantAddedSystemMessagePayload | MessengerParticipantJoinedSystemMessagePayload | MessengerParticipantBirthdaySystemMessagePayload | MessengerParticipantKickedSystemMessagePayload | MessengerParticipantLeftSystemMessagePayload | MessengerPositionShareMessagePayload | MessengerPreviewMessagePayload | MessengerSecretMessagePayload | MessengerTextLocalisedSystemMessagePayload | MessengerTextMessagePayload | MessengerSystemReplyMessagePayload | MessengerAutoDeclinedMessagePayload;

export type MessengerMessagePreview = {
  __typename?: 'MessengerMessagePreview';
  sender?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type MessengerMessageSearchConnection = HasCursorPagination & {
  __typename?: 'MessengerMessageSearchConnection';
  edges?: Maybe<Array<MessengerMessageSearchEdge>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type MessengerMessageSearchEdge = PaginationEdge & {
  __typename?: 'MessengerMessageSearchEdge';
  node?: Maybe<MessengerMessageSearchResult>;
  /** #virtual */
  cursor: Scalars['String'];
};

export type MessengerMessageSearchFiltersInput = {
  lastSeen?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type MessengerMessageSearchQueryInput = {
  /** Request consumer, used for tracking and analysis purposes */
  consumer: Scalars['String'];
  /** Free text search for keywords */
  keywords?: Maybe<Scalars['String']>;
  /** Params expected for highlight input are documented in HighlightInput field */
  highlight?: Maybe<HighlightInput>;
  filters?: Maybe<MessengerMessageSearchFiltersInput>;
  /** timeout for Elasticsearch call */
  timeout?: Maybe<Scalars['Int']>;
};

export type MessengerMessageSearchResult = {
  __typename?: 'MessengerMessageSearchResult';
  trackingToken: Scalars['String'];
  position: Scalars['Int'];
  score?: Maybe<Scalars['Float']>;
  /** #rest(batched) #virtual */
  message?: Maybe<MessengerMessage>;
  highlight?: Maybe<HighlightResultMessengerMessage>;
};

export type MessengerMessageTemplates = {
  __typename?: 'MessengerMessageTemplates';
  /** #expand */
  templates?: Maybe<Array<Maybe<MessengerMessageTemplatesInterface>>>;
  /** #virtual */
  maxAllowedMessageTemplates: Scalars['Int'];
  /** #virtual */
  total: Scalars['Int'];
};

export type MessengerMessageTemplatesInterface = {
  id: Scalars['ID'];
  title: Scalars['String'];
  body: Scalars['String'];
  /** used only for tracking purposes */
  topic: Scalars['String'];
  type: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
};

export type MessengerMessageTextTemplate = MessengerMessageTemplatesInterface & {
  __typename?: 'MessengerMessageTextTemplate';
  id: Scalars['ID'];
  title: Scalars['String'];
  body: Scalars['String'];
  /** used only for tracking purposes */
  topic: Scalars['String'];
  type: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
};

export type MessengerMessageXingTemplate = MessengerMessageTemplatesInterface & {
  __typename?: 'MessengerMessageXingTemplate';
  id: Scalars['ID'];
  title: Scalars['String'];
  body: Scalars['String'];
  /** used only for tracking purposes */
  topic: Scalars['String'];
  type: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
};

/** This type represents the actionable chat object message type. It resolves a union for object and actions. */
export type MessengerObjectMessagePayload = {
  __typename?: 'MessengerObjectMessagePayload';
  /** #rest(batched) #virtual */
  object?: Maybe<MessengerMessageObject>;
  /** #rest #virtual */
  actions?: Maybe<Array<Maybe<ObjectActions>>>;
  trackingToken?: Maybe<Scalars['String']>;
};

export type MessengerOneClickActionForwardToChat = {
  __typename?: 'MessengerOneClickActionForwardToChat';
  chatId: Scalars['ID'];
};

export type MessengerOpenProfileAction = ObjectActions & {
  __typename?: 'MessengerOpenProfileAction';
  trackingToken?: Maybe<Scalars['String']>;
};

export type MessengerOriginalImage = {
  __typename?: 'MessengerOriginalImage';
  filesize?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type MessengerParticipant = XingId | MessengerUser;

/** This type is just a stub. Real implementation will come later. */
export type MessengerParticipantAddedSystemMessagePayload = {
  __typename?: 'MessengerParticipantAddedSystemMessagePayload';
  body?: Maybe<Scalars['String']>;
};

/** This type is just a stub. Real implementation will come later. */
export type MessengerParticipantBirthdaySystemMessagePayload = {
  __typename?: 'MessengerParticipantBirthdaySystemMessagePayload';
  body?: Maybe<Scalars['String']>;
};

export type MessengerParticipantJoinedSystemMessagePayload = {
  __typename?: 'MessengerParticipantJoinedSystemMessagePayload';
  body?: Maybe<Scalars['String']>;
};

/** This type is just a stub. Real implementation will come later. */
export type MessengerParticipantKickedSystemMessagePayload = {
  __typename?: 'MessengerParticipantKickedSystemMessagePayload';
  body?: Maybe<Scalars['String']>;
};

/** This type is just a stub. Real implementation will come later. */
export type MessengerParticipantLeftSystemMessagePayload = {
  __typename?: 'MessengerParticipantLeftSystemMessagePayload';
  body?: Maybe<Scalars['String']>;
};

/** This type is just a stub. Real implementation will come later. */
export type MessengerPositionShareMessagePayload = {
  __typename?: 'MessengerPositionShareMessagePayload';
  body?: Maybe<Scalars['String']>;
};

/** Link preview message type payload. */
export type MessengerPreviewMessagePayload = {
  __typename?: 'MessengerPreviewMessagePayload';
  /** @deprecated Use the fallbackBody field in the MessengerMessage instead. */
  body?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  sourceDomain?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  scalableImageUrl?: Maybe<Scalars['String']>;
  isExternal?: Maybe<Scalars['Boolean']>;
  trackingToken?: Maybe<Scalars['String']>;
};

export type MessengerQuickAction = MessengerQuickActionInterface & {
  __typename?: 'MessengerQuickAction';
  textResourceId?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  type: Scalars['String'];
};

export type MessengerQuickActionInterface = {
  body: Scalars['String'];
  type: Scalars['String'];
  textResourceId?: Maybe<Scalars['String']>;
};

export type MessengerQuickActions = {
  __typename?: 'MessengerQuickActions';
  actions?: Maybe<Array<Maybe<MessengerQuickActionInterface>>>;
  actionsReason?: Maybe<Scalars['String']>;
};

/** This type is just a stub. Real implementation will come later. */
export type MessengerSecretMessagePayload = {
  __typename?: 'MessengerSecretMessagePayload';
  body?: Maybe<Scalars['String']>;
};

/** Messenger related settings */
export type MessengerSettings = {
  __typename?: 'MessengerSettings';
  /** who can send you messages: [all_members, direct_contacts_only, contacts_of_your_contacts] */
  distanceForPm?: Maybe<SelectSetting>;
  /** enable your contacts to see if you have read their messages: true/false */
  readReceipt?: Maybe<ToggleSetting>;
  /** enable the auto decline for recruiter messages older than 10 days */
  autoDecline?: Maybe<ToggleSetting>;
};

export type MessengerSettingsInput = {
  distanceForPm?: Maybe<SelectSettingInput>;
  readReceipt?: Maybe<ToggleSettingInput>;
  autoDecline?: Maybe<ToggleSettingInput>;
};

export type MessengerSettingsMutationResult = {
  __typename?: 'MessengerSettingsMutationResult';
  error?: Maybe<MessengerSettings>;
  response?: Maybe<MessengerSettings>;
};

export type MessengerSystemReplyMessagePayload = {
  __typename?: 'MessengerSystemReplyMessagePayload';
  body?: Maybe<Scalars['String']>;
};

export type MessengerSystemReplyQuickAction = MessengerQuickActionInterface & {
  __typename?: 'MessengerSystemReplyQuickAction';
  replyId: Scalars['String'];
  body: Scalars['String'];
  type: Scalars['String'];
  textResourceId?: Maybe<Scalars['String']>;
};

/** This type is just a stub. Real implementation will come later. */
export type MessengerTextLocalisedSystemMessagePayload = {
  __typename?: 'MessengerTextLocalisedSystemMessagePayload';
  body?: Maybe<Scalars['String']>;
};

export type MessengerTextMessagePayload = {
  __typename?: 'MessengerTextMessagePayload';
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  trackingToken?: Maybe<Scalars['String']>;
};

export type MessengerTppReplyQuickAction = MessengerQuickActionInterface & {
  __typename?: 'MessengerTppReplyQuickAction';
  replyId: Scalars['String'];
  /** #rest(batched) #virtual */
  jobPosting?: Maybe<VisibleJob>;
  body: Scalars['String'];
  type: Scalars['String'];
  textResourceId?: Maybe<Scalars['String']>;
};

export type MessengerUploadRequestInput = {
  /** The application that this upload is intended for */
  application: UploadApplication;
  /** The size of the uploaded file in bytes */
  fileSize: Scalars['Long'];
  /** The MIME type of the file */
  fileType?: Maybe<Scalars['String']>;
  /** The file name */
  fileName?: Maybe<Scalars['String']>;
  /** The chat intended for this file */
  chatId: Scalars['ID'];
};

export type MessengerUploadResult = Upload | UploadRequestError;

export type MessengerUser = {
  __typename?: 'MessengerUser';
  id: Scalars['ID'];
  displayName: Scalars['String'];
  profileImage?: Maybe<Array<Maybe<ProfileImage>>>;
};


export type MessengerUserProfileImageArgs = {
  size: Array<ProfileImageSize>;
};

export type MissingFieldsCollection = {
  __typename?: 'MissingFieldsCollection';
  collection?: Maybe<Array<Maybe<NeffiCardDataSectionField>>>;
};

export enum MissingInfoItem {
  JobTitle = 'JOB_TITLE',
  SalaryRange = 'SALARY_RANGE',
  NeededSkills = 'NEEDED_SKILLS',
  Location = 'LOCATION',
  Discipline = 'DISCIPLINE',
  Industry = 'INDUSTRY',
  EmploymentType = 'EMPLOYMENT_TYPE',
  RemoteOptions = 'REMOTE_OPTIONS',
  CompanyName = 'COMPANY_NAME',
  CompanySize = 'COMPANY_SIZE',
  CompanyCulture = 'COMPANY_CULTURE',
  EmployeeRating = 'EMPLOYEE_RATING',
  ApplicationProcess = 'APPLICATION_PROCESS'
}

export type MobileOfferProduct = {
  __typename?: 'MobileOfferProduct';
  productId: Scalars['String'];
  highlighted: Scalars['Boolean'];
};

export type ModuleInterface = {
  order: Scalars['Int'];
  title: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type ModuleSettingsInput = {
  moduleName: Scalars['String'];
  collapsed: Scalars['Boolean'];
};

export type MostVisitedCompaniesCollection = {
  __typename?: 'MostVisitedCompaniesCollection';
  /** #expand #logged-out #soft-logged-in */
  collection: Array<Maybe<MostVisitedCompany>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export enum MostVisitedCompaniesOrder {
  VisitsCountDesc = 'VISITS_COUNT_DESC',
  Random = 'RANDOM'
}

export type MostVisitedCompany = {
  __typename?: 'MostVisitedCompany';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
};

export type MoveonArticle = {
  __typename?: 'MoveonArticle';
  articleId: Scalars['Int'];
  /** #rest(batched) #virtual */
  content?: Maybe<ContentArticle>;
  /** #rest(batched) #virtual */
  socialInteraction?: Maybe<SocialInteractionTarget>;
};

export type MoveonArticleRecommendation = {
  __typename?: 'MoveonArticleRecommendation';
  articleId: Scalars['Int'];
};

export type MoveonArticleRecommendations = {
  __typename?: 'MoveonArticleRecommendations';
  total: Scalars['Int'];
  collection: Array<MoveonArticleRecommendation>;
};

export type MoveonArticlesResult = {
  __typename?: 'MoveonArticlesResult';
  articles?: Maybe<Array<Maybe<MoveonArticle>>>;
};

export enum MoveonAssessmentProcessingStatus {
  Queued = 'QUEUED',
  Processing = 'PROCESSING',
  Completed = 'COMPLETED'
}

export type MoveonCompanyCulturePreferencesAssessmentDataResult = MoveonCompanyCulturePreferencesDataResultSuccess | MoveonCompanyCulturePreferencesDataResultFailure;

export type MoveonCompanyCulturePreferencesDataResultFailure = {
  __typename?: 'MoveonCompanyCulturePreferencesDataResultFailure';
  errors?: Maybe<Array<Maybe<MoveonCompanyCulturePreferencesResultError>>>;
};

export type MoveonCompanyCulturePreferencesDataResultSuccess = {
  __typename?: 'MoveonCompanyCulturePreferencesDataResultSuccess';
  assessmentId: Scalars['Int'];
  userId: Scalars['Int'];
  processingStatus: MoveonAssessmentProcessingStatus;
  completedAt?: Maybe<Scalars['Date']>;
  companyRecommendationsFeedback?: Maybe<MoveonCompanyRecommendationsFeedback>;
  topPositiveFactors?: Maybe<Array<Maybe<MoveonKununuFactor>>>;
  topNegativeFactors?: Maybe<Array<Maybe<MoveonKununuFactor>>>;
  positiveFactors?: Maybe<Array<Maybe<MoveonKununuFactor>>>;
  negativeFactors?: Maybe<Array<Maybe<MoveonKununuFactor>>>;
  /** #rest #virtual */
  dashboard?: Maybe<MoveonDashboard>;
};

export type MoveonCompanyCulturePreferencesResultError = {
  __typename?: 'MoveonCompanyCulturePreferencesResultError';
  status?: Maybe<Scalars['Int']>;
  detail?: Maybe<Scalars['String']>;
};

export type MoveonCompanyRecommendation = {
  __typename?: 'MoveonCompanyRecommendation';
  companyId: Scalars['Int'];
  score: Scalars['Float'];
  numberOfSubmissions: Scalars['Int'];
  topPositiveFactorsMatch?: Maybe<Array<Maybe<MoveonFactorMatchingCompany>>>;
  matchRating: MoveonCompanyRecommendationMatchRating;
  /** #rest(batched) #virtual */
  company?: Maybe<Company>;
};

export type MoveonCompanyRecommendationEdge = PaginationEdge & {
  __typename?: 'MoveonCompanyRecommendationEdge';
  node?: Maybe<MoveonCompanyRecommendation>;
  /** #virtual */
  cursor: Scalars['String'];
};

export enum MoveonCompanyRecommendationMatchRating {
  Ok = 'OK',
  Good = 'GOOD',
  Excellent = 'EXCELLENT'
}

export type MoveonCompanyRecommendations = {
  __typename?: 'MoveonCompanyRecommendations';
  total?: Maybe<Scalars['Int']>;
  collection?: Maybe<Array<Maybe<MoveonCompanyRecommendation>>>;
};

export type MoveonCompanyRecommendationsConnection = HasCursorPagination & {
  __typename?: 'MoveonCompanyRecommendationsConnection';
  edges: Array<Maybe<MoveonCompanyRecommendationEdge>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export enum MoveonCompanyRecommendationsFeedback {
  Positive = 'POSITIVE',
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Unknown = 'UNKNOWN'
}

export type MoveonCompanyRecommendationsFeedbackInput = {
  feedback?: Maybe<MoveonCompanyRecommendationsFeedback>;
};

export type MoveonCompanyRecommendationsJobSearch = {
  __typename?: 'MoveonCompanyRecommendationsJobSearch';
  companyIds?: Maybe<Array<Scalars['ID']>>;
  /** #rest #virtual */
  jobSearchResult?: Maybe<JobSearchResult>;
};

export type MoveonCreateAssessmentInput = {
  topPositiveFactors: Array<Scalars['String']>;
  topNegativeFactors: Array<Scalars['String']>;
  positiveFactors: Array<Scalars['String']>;
  negativeFactors: Array<Scalars['String']>;
};

export type MoveonCreateAssessmentResult = MoveonCreateAssessmentResultSuccess | MoveonCreateAssessmentResultFailure;

export type MoveonCreateAssessmentResultError = {
  __typename?: 'MoveonCreateAssessmentResultError';
  status?: Maybe<Scalars['Int']>;
  detail?: Maybe<Scalars['String']>;
};

export type MoveonCreateAssessmentResultFailure = {
  __typename?: 'MoveonCreateAssessmentResultFailure';
  errors?: Maybe<Array<Maybe<MoveonCreateAssessmentResultError>>>;
};

export type MoveonCreateAssessmentResultSuccess = {
  __typename?: 'MoveonCreateAssessmentResultSuccess';
  id: Scalars['Int'];
};

export type MoveonDashboard = {
  __typename?: 'MoveonDashboard';
  tendencyScore?: Maybe<Scalars['Float']>;
  tendencyCategory?: Maybe<MoveonUserTendencyCategory>;
  dimensionTendencyScores?: Maybe<MoveonDimensionScores>;
  /** @deprecated It will be replaced with paginated resolver */
  companyRecommendations?: Maybe<MoveonCompanyRecommendations>;
  /** @deprecated It will be replaced with query out of viewer */
  articleRecommendations?: Maybe<MoveonArticleRecommendations>;
};

export type MoveonDimensionScores = {
  __typename?: 'MoveonDimensionScores';
  strategicDirection: Scalars['Float'];
  workLife: Scalars['Float'];
  leadership: Scalars['Float'];
  workingTogether: Scalars['Float'];
};

export type MoveonFactorMatchingCompany = {
  __typename?: 'MoveonFactorMatchingCompany';
  key: Scalars['String'];
  value: Scalars['Float'];
};

export type MoveonKununuFactor = {
  __typename?: 'MoveonKununuFactor';
  factorId: Scalars['Int'];
  factorTranslationCode: Scalars['String'];
  traditional: Scalars['Boolean'];
  cultureId: Scalars['Int'];
  cultureTranslationCode: Scalars['String'];
  dimensionId: Scalars['Int'];
  dimensionTranslationCode: Scalars['String'];
};

export type MoveonUpdatedAssessmentResult = {
  __typename?: 'MoveonUpdatedAssessmentResult';
  assessmentId: Scalars['Int'];
  companyRecommendationsFeedback?: Maybe<MoveonCompanyRecommendationsFeedback>;
};

export enum MoveonUserTendencyCategory {
  Traditional = 'TRADITIONAL',
  Neutral = 'NEUTRAL',
  Modern = 'MODERN'
}

export type MultichoiceCustomQuestion = BaseApplyQuestion & {
  __typename?: 'MultichoiceCustomQuestion';
  /** #logged-out #soft-logged-in */
  minimumChoicesAllowed?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  maximumChoicesAllowed?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  options?: Maybe<Array<Maybe<SelectCustomQuestionOption>>>;
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

/** The root mutation type */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Dummy mutation field
   * @deprecated Makes GraphiQL happy
   */
  dummy?: Maybe<Scalars['String']>;
  /**
   * #rest #virtual
   *
   *  Delete profile academic title update
   */
  profileAcademicTitleUpdateDelete?: Maybe<ProfileUpdateDeleteResult>;
  /**
   * #rest #virtual
   *
   *  Delete profile haves update
   */
  profileHavesUpdateDelete?: Maybe<ProfileUpdateDeleteResult>;
  /**
   * #rest #virtual
   *
   *  Delete profile wants update
   */
  profileWantsUpdateDelete?: Maybe<ProfileUpdateDeleteResult>;
  /**
   * #rest #virtual
   *
   *  Delete profile business contact update
   */
  profileBusinessContactUpdateDelete?: Maybe<ProfileUpdateDeleteResult>;
  /**
   * #rest #virtual
   *
   *  Delete profile work experience update
   */
  profileWorkExperienceUpdateDelete?: Maybe<ProfileUpdateDeleteResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Send Data Science tracking full format
   * @deprecated use odt tracking instead https://operational-tracking.xing.io/
   */
  dataScienceTrackingFullFormat?: Maybe<TrackingResult>;
  /**
   * #rest #virtual
   *
   *  Send Data Science tracking compact format
   * @deprecated use odt tracking instead https://operational-tracking.xing.io/
   */
  dataScienceTrackingCompactFormat?: Maybe<TrackingResult>;
  /**
   * #rest #virtual
   *
   *  DEPRECATED: Send like/dislike/superlike interaction by card
   * @deprecated use dreamJobStoreInteraction
   */
  dreamJobsInteract?: Maybe<DreamJobInteractionResult>;
  /**
   * #rest #virtual
   *
   *  Send like/dislike/superlike interatction by card
   */
  dreamJobStoreInteraction?: Maybe<DreamJobsOperationResult>;
  /**
   * #rest #virtual
   *
   *  Delete interaction from Activity Basket
   */
  dreamJobDeleteInteraction?: Maybe<DreamJobsOperationResult>;
  /**
   * #rest #virtual
   *
   *  DEPRECATED: Update interaction by card
   * @deprecated use dreamJobUpdateInteraction
   */
  dreamJobsUpdateInteraction?: Maybe<DreamJobInteractionResult>;
  /**
   * #rest #virtual
   *
   *  Update interaction by card
   */
  dreamJobUpdateInteraction?: Maybe<DreamJobsOperationResult>;
  /**
   * #rest #virtual
   *
   *  Take VOMP consent
   */
  dreamJobsSetConsentDetails?: Maybe<DreamJobsOperationResult>;
  /**
   * #rest #virtual
   *
   *  Disable an article
   */
  articlesDisableArticle?: Maybe<ArticlesDisableArticleResult>;
  /**
   * #rest #virtual
   *
   *  Unpublish an article
   */
  articlesUnpublishArticle?: Maybe<ArticlesUnpublishArticleResult>;
  /**
   * #rest #virtual
   *
   *  Update article
   */
  articlesUpdateArticle?: Maybe<ArticlesSaveArticleResult>;
  /**
   * #rest #virtual
   *
   *  Update SEO settings, bypassing the locking mechanism
   */
  articlesUpdateArticleSettings?: Maybe<ArticlesSaveArticleResult>;
  /**
   * #rest #virtual
   *
   *  Publish an article
   */
  articlesPublishArticle?: Maybe<ArticlesPublishArticleResult>;
  /**
   * #rest #virtual
   *
   *  Enable an article
   */
  articlesEnableArticle?: Maybe<ArticlesEnableArticleResult>;
  /**
   * #rest #virtual
   *
   *  Create an article
   */
  articlesCreateArticleImage?: Maybe<ArticlesCreateArticleImageResult>;
  /**
   * #rest #virtual
   *
   *  Create an article
   */
  articlesCreateArticle?: Maybe<ArticlesSaveArticleResult>;
  /**
   * #rest #virtual
   *
   *  Delete an article
   */
  articlesDeleteArticle?: Maybe<ArticlesDeleteArticleResult>;
  /**
   * #rest #virtual
   *
   *  Redeem a jobs voucher
   */
  redeemJobsMtncVoucher?: Maybe<JobsMtncVoucherRedemptionResult>;
  /**
   * #rest #virtual
   *
   *  Creates a job report based on the current user and the jobId
   *
   * ```
   * mutation JobCreateReport {
   *   jobCreateReport(input: { jobId: "2.24d1f6", reason: NO_JOB_AD, wrongFields: [LOCATION, COMPANY_NAME], comment: "Nice comment"}) {
   *     job {
   *       __typename
   *       ...on VisibleJob {
   *         id
   *         title
   *       }
   *     }
   *     error {
   *       message
   *     }
   *   }
   * }
   * ```
   */
  jobCreateReport?: Maybe<JobCreateReportResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Registers a job visit
   */
  jobRegisterVisit?: Maybe<JobRegisterVisitResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Deletes a job visit
   */
  jobDeleteVisit?: Maybe<JobDeleteVisitError>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Creates a job bookmark based on the current user and the jobId
   *
   * ```
   * mutation JobCreateBookmark {
   *   jobCreateBookmark(input: { jobId: 1 }) {
   *     error {
   *       message
   *     }
   *   }
   * }
   * ```
   * @deprecated Use jobUpsertBookmark with desired bookmark state
   */
  jobCreateBookmark?: Maybe<JobBookmarkMutationResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Creates or updates a bookmark for the input jobId
   *
   * ```
   * mutation JobUpsertBookmark {
   *   jobUpsertBookmark(input: { jobId: 1, state: "INTERVIEW_SET" }) {
   *     error {
   *       message
   *     }
   *   }
   * }
   * ```
   */
  jobUpsertBookmark?: Maybe<JobBookmarkUpsertMutationResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Deletes a job bookmark based on the current user and the jobId
   *
   * ```
   * mutation JobDeleteBookmark {
   *   jobDeleteBookmark(input: { jobId: 1 }) {
   *     error {
   *       message
   *     }
   *   }
   * }
   * ```
   */
  jobDeleteBookmark?: Maybe<JobBookmarkMutationResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This mutation generates a reminder to a user to continue an unfinished application
   */
  userRemindJobApplication?: Maybe<UserRemindApplicationError>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This mutation submits a job application for the current user to a certain job
   */
  jobSubmitJobApplication?: Maybe<JobApplicationMutationResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This mutation submits a Xing custom job application for the current user to a certain job
   */
  jobSubmitXingCustomApplication?: Maybe<JobXingCustomApplicationError>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Create a job apply intention based on the current user and job
   *
   * ```
   * mutation JobCreateApplyIntention {
   *   jobCreateApplyIntention(input: { jobId: 1, platform: WEB }) {
   *     error {
   *       message
   *     }
   *   }
   * }
   * ```
   * @deprecated job-user-interest is deprecated. We now rely on NWT for these events.
   */
  jobCreateApplyIntention?: Maybe<JobUserApplyIntentionResult>;
  /**
   * #rest #virtual
   *
   *  Create a search alert. You must have the query id from job-searches.
   */
  createSearchAlert?: Maybe<SearchAlertCreationResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Create a search alert for LO.
   */
  createSearchAlertForLO?: Maybe<SearchAlertForLoCreationResult>;
  /**
   * #rest #virtual
   *
   *  Create a search alert using a query
   * @deprecated This doesn't allow specifying a search mode nor origin. Use createSearchAlertByQueryNew instead.
   */
  createSearchAlertByQuery?: Maybe<SearchAlertCreationResult>;
  /**
   * #rest #virtual
   *
   *  Create a search alert using a search.
   */
  createSearchAlertByQueryNew?: Maybe<SearchAlertCreationResult>;
  /**
   * #rest #virtual
   *
   *  Delete a search alert using its id.
   */
  deleteSearchAlert?: Maybe<EmptyOrErrorResponse>;
  /**
   * #rest #virtual
   *
   *  Visit a search alert using its id.
   */
  visitSearchAlert?: Maybe<EmptyOrErrorResponse>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Confirms a token belonging to a logged out search alert.
   */
  confirmLOSearchAlert?: Maybe<LoSearchAlertResponse>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Unsubscribe a token belonging to a logged out search alert.
   */
  unsubscribeLOSearchAlert?: Maybe<LoSearchAlertResponse>;
  /**
   * #rest #virtual
   *
   *  Updates the search alert settings for the current user. If they don't exist, they are created.
   */
  updateSearchAlertSettings?: Maybe<Empty>;
  /**
   * #rest #virtual
   *
   *  Delete all push recommendations based on the current user.
   *
   * ```
   * mutation JobsDeleteRecommendations {
   *   jobsDeleteRecommendations {
   *     error {
   *       message
   *     }
   *   }
   * }
   * ```
   */
  jobsDeleteRecommendations?: Maybe<JobsDeleteRecommendationsResult>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Mark jobs push recommendations as seen based on the current user.
   *
   * ```
   * mutation JobsMarkRecommendationsAsSeen {
   *   jobsMarkRecommendationsAsSeen(input: { jobIds: [1, 2, 3] } ) {
   *     error {
   *       message
   *     }
   *   }
   * }
   * ```
   */
  jobsMarkRecommendationsAsSeen?: Maybe<JobsMarkRecommendationsAsSeenResult>;
  /**
   * #rest #virtual
   *
   *  This mutation saves User feedback about outdated fields
   */
  saveUserFeedbackOnOutdatedFields?: Maybe<UserFeebackOnOutdatedFieldsResponse>;
  /**
   * #rest #virtual
   *
   *  User accepts counter offer instead of cancelling
   */
  upsellCancellationAcceptCounterOffer?: Maybe<UpsellCancellationAcceptCounterOfferResult>;
  /**
   * #rest #virtual
   *
   *  Request cancellation of web contracts
   */
  upsellCancellationRequest?: Maybe<UpsellCancellationRequestResult>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Make a purchase web order
   */
  purchaseWebOrder?: Maybe<PurchaseWebOrder>;
  /**
   * #rest #virtual
   *
   *  Create purchase campaign
   */
  purchaseCreateCampaign?: Maybe<PurchaseCreateCampaignResult>;
  /**
   * #rest #virtual
   *
   *  allow enable/disable a platform campaign
   */
  purchaseEnablePlatform?: Maybe<PurchaseEnablePlatformResult>;
  /**
   * #rest #virtual
   *
   *  used to enable/disable a campaign group
   */
  purchaseRestoreCampaignGroupResolver?: Maybe<PurchaseRestoreCampaignGroupResult>;
  /**
   * #rest #virtual
   *
   *  Updates a campaign group
   */
  purchaseUpdateCampaignGroup?: Maybe<PurchaseUpdateCampaignGroupResult>;
  /**
   * #rest #virtual
   *
   *  used to delete a campaign group
   */
  purchaseDeleteCampaignGroup?: Maybe<PurchaseDeleteCampaignGroupResult>;
  /**
   * #rest #virtual
   *
   *  Update purchase campaign
   */
  purchaseUpdateCampaign?: Maybe<PurchaseUpdateCampaignResult>;
  /**
   * #rest #virtual
   *
   *  allow enable/disable a platform group
   */
  purchasePublishCampaign?: Maybe<PurchasePublishCampaignResult>;
  /**
   * #rest #virtual
   *
   *  Create a campaign group
   */
  purchaseCreateCampaignGroup?: Maybe<PurchaseCreateCampaignGroupResult>;
  /**
   * #rest #virtual
   *
   *  Create briefing
   */
  createBriefing?: Maybe<CreateBriefingResult>;
  /**
   * #rest #virtual
   *
   *  Create candidate search
   */
  createCandidateSearch?: Maybe<CreateCandidateSearchResult>;
  /**
   * #rest #virtual
   *
   *  Update briefing
   */
  updateBriefing?: Maybe<UpdateBriefingResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Request to create a file upload at the upload service. On success a representation of
   * the upload is returned containing all necessary information to push data to the upload
   * and process it later in the backend.
   */
  uploadRequest?: Maybe<UploadRequestPayload>;
  /**
   * #rest #virtual
   *
   *  This mutation acknowledges a security issue, typically when a notification is dismissed by the user
   */
  loginUserSecurityIssuesAcknowledge?: Maybe<LoginUserSecurityIssuesAcknowledgeMutationResult>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Creates partner code for users
   */
  partnerCreateCode?: Maybe<PartnerCreateCodeMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update profile birthName or birthDate
   */
  profilePersonalDetailsUpdate?: Maybe<PersonalDetailsUpdateResult>;
  /**
   * Update user wants
   * @deprecated The wants will be removed in favor of job-preferences: PROFILE-10484.
   */
  profileWantsUpdate?: Maybe<ProfileWantsUpdateResult>;
  /**
   * #rest #virtual
   *
   *  Create a workExperience for the profile
   */
  createWorkExperience?: Maybe<WorkExperienceError>;
  /**
   * #rest #virtual
   *
   *  Update user interests
   */
  profileInterestsUpdate?: Maybe<ProfileInterestsUpdateResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Create a parsed cv for a given upload id
   */
  createCvUploadParsedCv?: Maybe<CreateCvUploadParsedCvResult>;
  /**
   * #rest #virtual
   *
   *  Create a parsed CV for a given user ID
   */
  createCvUploadParsedCvByUserId?: Maybe<CreateCvUploadParsedCvResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Delete a parsed CV
   */
  deleteCvUploadParsedCv?: Maybe<CvUploadError>;
  /**
   * #rest #virtual
   *
   *  Create or update the hiring profile of a user
   */
  updateHiringProfile?: Maybe<UpdateHiringProfileResult>;
  /**
   * #rest #virtual
   *
   *  Update legal information
   */
  updateLegalInformation?: Maybe<LegalInformationUpdateError>;
  /**
   * #rest #virtual
   *
   *  Update the personal status shown for example on the business card
   */
  xingIdUpdateStatus?: Maybe<XingIdUpdateStatusPayload>;
  /**
   * #rest #virtual
   *
   *  Update contact details
   */
  xingIdUpdateContactDetails?: Maybe<XingIdUpdateContactDetailsPayload>;
  /**
   * #rest #virtual
   *
   *  Add the user as a contact from profile
   */
  xingIdAddContact?: Maybe<XingIdAddContactPayload>;
  /**
   * #rest #virtual
   *
   *  Confirm contact request from profile
   */
  xingIdConfirmContact?: Maybe<XingIdConfirmContactPayload>;
  /**
   * #rest #virtual
   *
   *  Delete contact
   */
  xingIdDeleteContact?: Maybe<XingIdDeleteContactPayload>;
  /**
   * #rest #virtual
   *
   *  Decline contact request
   */
  xingIdDeclineContactRequest?: Maybe<XingIdDeclineContactRequestPayload>;
  /**
   * #rest #virtual
   *
   *  Follow the user
   */
  xingIdFollow?: Maybe<XingIdFollowPayload>;
  /**
   * #rest #virtual
   *
   *  Unfollow the user
   */
  xingIdUnfollow?: Maybe<XingIdUnfollowPayload>;
  /**
   * #rest #virtual
   *
   *  Update profile picture
   */
  xingIdUpdateProfileImage?: Maybe<XingIdUpdateProfileImagePayload>;
  /**
   * #rest #virtual
   *
   *  Delete profile picture
   */
  xingIdDeleteProfileImage?: Maybe<XingIdDeleteProfileImagePayload>;
  /**
   * #rest #virtual
   *
   *  Update profile header image
   */
  xingIdUpdateHeaderImage?: Maybe<XingIdUpdateHeaderImagePayload>;
  /**
   * #rest #virtual
   *
   *  Delete profile header image
   */
  xingIdDeleteHeaderImage?: Maybe<XingIdDeleteHeaderImagePayload>;
  /**
   * #rest #virtual
   *
   *  Update occupations order
   */
  xingIdReorderOccupations?: Maybe<XingIdReorderOccupationsPayload>;
  /**
   * #rest #virtual
   *
   *  Update user skills
   */
  profileSkillsUpdate?: Maybe<ProfileSkillsUpdateResult>;
  /**
   * #rest #virtual
   *
   *  Add a skill to the user
   */
  profileSkillsAdd?: Maybe<ProfileSkillsUpdateResult>;
  /**
   * #rest #virtual
   *
   *  Create a new entry in Timeline module on Profiles, it returns the timeline module in case of success, except for the order and title of the module so requesting them will lead to errors
   */
  profileTimelineAddEntry?: Maybe<ProfileTimelineEntryPayload>;
  /**
   * #rest #virtual
   *
   *  Edit an entry in the Timeline module on Profiles. Will return the timeline when successful
   */
  profileTimelineEditEntry?: Maybe<ProfileTimelineEntryPayload>;
  /**
   * #rest #virtual
   *
   *  Delete an entry in the Timeline module on Profiles. Will return the timeline when successful
   */
  profileTimelineDeleteEntry?: Maybe<ProfileTimelineDeleteEntryPayload>;
  /**
   * #rest #virtual
   *
   *  Update user wants
   */
  profileLanguagesUpdate?: Maybe<ProfileLanguagesUpdateError>;
  /**
   * #rest #virtual
   *
   *  Update about me description
   */
  profileAboutMeUpdate?: Maybe<ProfileAboutMeUpdateResult>;
  /**
   * #rest #virtual
   *
   *  Creates a new Accomplishment (Award or Qualification)
   */
  accomplishmentCreate?: Maybe<AccomplishmentCreateResult>;
  /**
   * #rest #virtual
   *
   *  Updates an Accomplishment (Award or Qualification)
   */
  accomplishmentUpdate?: Maybe<AccomplishmentUpdateResult>;
  /**
   * #rest #virtual
   *
   *  Deletes an Accomplishment (Award or Qualification)
   */
  accomplishmentDelete?: Maybe<AccomplishmentMutationError>;
  /**
   * #rest #virtual
   *
   *  Applies a external updates
   */
  externalUpdatesApply?: Maybe<ExternalUpdateMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update profile module store items
   */
  updateProfileModuleStoreItems?: Maybe<UpdateProfileModuleStoreItemsResult>;
  /**
   * #rest #virtual
   *
   *  Adds information for badges which site section has been seen by a user, so
   * server can manage that user's badge counters.
   */
  notificationsBadgesSeen?: Maybe<NotificationsBadgesSeenResponse>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Create a web push subscription
   */
  createWebPushSubscription?: Maybe<CreateWebPushSubscriptionResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Update a web push subscription
   */
  updateWebPushSubscription?: Maybe<UpdateWebPushSubscriptionResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Send mobile cookie consent data
   */
  sendMobileConsent?: Maybe<SendConsentRequestError>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Send web cookie consent data
   */
  sendWebConsent?: Maybe<SendConsentRequestError>;
  /**
   * #rest #virtual
   *
   *  Create a new share to startpage
   */
  socialShareToStartpage?: Maybe<SocialShareMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create a new share to groups
   */
  socialShareToGroup?: Maybe<SocialShareMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create a new share to messenger
   */
  socialShareToMessenger?: Maybe<SocialShareMutationResult>;
  /**
   * #rest #virtual
   *
   *  Creates a new external link
   */
  socialCreateExternalLink?: Maybe<SocialExternalLinkMutationResult>;
  /**
   * #rest #virtual
   *
   *  Creates a new reaction
   */
  socialCreateReaction?: Maybe<SocialReactionMutationResult>;
  /**
   * #rest #virtual
   *
   *  Updates an existing reaction
   */
  socialUpdateReaction?: Maybe<SocialReactionMutationResult>;
  /**
   * #rest #virtual
   *
   *  Deletes an existing reaction
   */
  socialDeleteReaction?: Maybe<SocialReactionMutationResult>;
  /**
   * #rest #virtual
   *
   *  Creates a new comment
   */
  socialCreateComment?: Maybe<SocialCommentMutationResult>;
  /**
   * #rest #virtual
   *
   *  Updates an existing comment
   */
  socialUpdateComment?: Maybe<SocialCommentMutationResult>;
  /**
   * #rest #virtual
   *
   *  Deletes an existing comment
   */
  socialDeleteComment?: Maybe<SocialCommentMutationResult>;
  /**
   * #rest #virtual
   *
   *  Deletes mentions of the user within the comment
   */
  socialDeleteCommentMentions?: Maybe<SocialCommentMutationResult>;
  /**
   * #rest #virtual
   *
   *  Logging discarded items
   */
  discoLogging?: Maybe<DiscoLogging>;
  /**
   * #rest #virtual
   *
   *  Delete Activity
   */
  discoDeleteActivity?: Maybe<DiscoDeleteActivityResult>;
  /**
   * #rest #virtual
   *
   *  Collapses or expands a module
   */
  postModuleSettings?: Maybe<CollapsedModuleResult>;
  /**
   * #rest #virtual
   *
   *  Post salary insights
   */
  postSalaryInsights?: Maybe<SalaryInsightsResult>;
  /**
   * #rest #virtual
   *
   *  Blacklist skills
   */
  postBlacklistedSkills?: Maybe<BlacklistedSkillsResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the user's ideal employers
   */
  jobWishesIdealEmployers?: Maybe<UpdateJobWishesIdealEmployersResult>;
  /**
   * #rest #virtual
   *
   *  Triggers an update on user job seeker job wishes
   */
  jobWishesPreference?: Maybe<PreferencesJobWishesResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the user's blocked companies
   * @deprecated Use blockedCompanies instead for queries and mutations
   */
  preferenceSettingsBlockedCompanies?: Maybe<UpdatePreferencesSettingsBlockedCompaniesResult>;
  /**
   * #rest #virtual
   *
   *  Triggers an update on user job seeker status
   */
  preferenceSettings?: Maybe<PreferencesSettingsResult>;
  /**
   * #rest #virtual
   *
   *  Sends moveOn company recommendations feedback
   */
  moveonCompanyRecommendationsFeedbackInput?: Maybe<MoveonUpdatedAssessmentResult>;
  /**
   * #rest #virtual
   *
   *  Creates an assessment
   */
  moveonCreateAssessmentInput?: Maybe<MoveonCreateAssessmentResult>;
  /**
   * #rest #virtual
   *
   *  Update the permissions between a User and a Resource
   */
  updateResourceUser?: Maybe<TeamPermissionsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete the permissions between a User and a Resource
   */
  deleteResourceUser?: Maybe<TeamPermissionsDeleteMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create or Update Ecomm Order
   */
  ecommOrder?: Maybe<EcommOrder>;
  /**
   * #rest #virtual
   *
   *  Save Order Company Details
   */
  ecommCompanyDetails?: Maybe<EcommCompanyDetails>;
  /**
   * #rest #virtual
   *
   *  Set paymentStatus
   */
  ecommPaymentStatus?: Maybe<EcommPaymentStatus>;
  /**
   * #rest #virtual
   *
   *  Delete User Connections
   */
  ecommUserConnectionsData?: Maybe<DeletedUserConnectionData>;
  /**
   * #rest #virtual
   *
   *  Confirm Order
   */
  ecommConfirmOrder?: Maybe<EcommConfirmOrder>;
  /**
   * #rest #virtual
   *
   *  Save Order Contact Details
   */
  ecommContactDetails?: Maybe<EcommContactDetails>;
  /**
   * #rest #virtual
   *
   *  creates a posting
   */
  postingsCreatePosting?: Maybe<PostingsPostingMutationResult>;
  /**
   * #rest #virtual
   *
   *  publishes a posting
   */
  postingsPublishPosting?: Maybe<PostingsPostingMutationResult>;
  /**
   * #rest #virtual
   *
   *  hide a posting
   */
  postingsHidePosting?: Maybe<PostingsPostingMutationResult>;
  /**
   * #rest #virtual
   *
   *  unhide a posting
   */
  postingsUnhidePosting?: Maybe<PostingsPostingMutationResult>;
  /**
   * #rest #virtual
   *
   *  updates a posting
   */
  postingsUpdatePosting?: Maybe<PostingsPostingMutationResult>;
  /**
   * #rest #virtual
   *
   *  deletes a posting
   */
  postingsDeletePosting?: Maybe<PostingsPostingDeleteResult>;
  /**
   * #rest #virtual
   *
   *  deletes any mentions of the requesting user from a posting
   */
  postingsDeleteMyMentions?: Maybe<PostingsPostingMutationResult>;
  /**
   * #rest #virtual
   *
   *  creates a poll vote
   */
  postingsVoteForPollOption?: Maybe<PostingsVoteForPollOptionResult>;
  /** creates a story */
  postingsCreateStory?: Maybe<StoryCreateMutationResult>;
  /** deletes a story */
  postingsDeleteStory?: Maybe<StoryDeleteMutationResult>;
  /**
   * Creates an empty Story Group
   * Required for the creation of video stories
   */
  postingsCreateStoryGroup?: Maybe<StoryGroupMutationResult>;
  /**
   * Populates an empty Story Group
   * Required for the creation of video stories
   */
  postingsPopulateStoryGroup?: Maybe<StoryGroupMutationResult>;
  /**
   * #rest #virtual
   *
   *  Removes currently pinned activity (if one exists) and pins a new one for given entity page
   * @deprecated Use postingsPinActivityByTarget instead
   */
  postingsPinActivity?: Maybe<PostingsPinActivityResult>;
  /**
   * #rest #virtual
   *
   *  Removes pinned actviity for the given entity page
   * @deprecated Use postingsUnpinActivityByTarget instead
   */
  postingsUnpinActivity?: Maybe<PostingsUnpinActivityResult>;
  /**
   * #rest #virtual
   *
   *  Removes currently pinned activity (if one exists) and pins a new one for given targetGlobalId
   */
  postingsPinActivityByTarget?: Maybe<PostingsPinActivityResult>;
  /**
   * #rest #virtual
   *
   *  Removes pinned actviity for the given targetGlobalId
   */
  postingsUnpinActivityByTarget?: Maybe<PostingsUnpinActivityResult>;
  /**
   * #rest #virtual
   *
   *  update the custom fields for a link share
   */
  postingsUpdateLinkShare?: Maybe<PostingsAttachmentMutationResult>;
  /**
   * #rest #virtual
   *
   *  creates a video record for usage in a posting
   */
  postingsCreateVideo?: Maybe<PostingsVideoCreateMutationResult>;
  /**
   * #rest #virtual
   *
   *  creates an RSS importer
   */
  postingsCreateRssImporter?: Maybe<PostingsRssImporterMutationResult>;
  /**
   * #rest #virtual
   *
   *  creates a twitter importer
   */
  postingsCreateTwitterImporter?: Maybe<PostingsTwitterImporterMutationResult>;
  /**
   * #rest #virtual
   *
   *  deletes an RSS importer
   */
  postingsDeleteRssImporter?: Maybe<PostingsPostingDeleteResult>;
  /**
   * #rest #virtual
   *
   *  deletes a twitter importer
   */
  postingsDeleteTwitterImporter?: Maybe<PostingsPostingDeleteResult>;
  /**
   * #rest #virtual
   *
   *  Update Page Logo
   */
  entityPageUpdateLogo?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update Entity Page Module configuration
   */
  entityPageModuleUpdateConfiguration?: Maybe<EntityPageModuleConfigUpdateResult>;
  /**
   * #rest #virtual
   *
   *  Update Entity Page configuration
   */
  entityPageUpdateConfiguration?: Maybe<EntityPageConfigUpdateResult>;
  /**
   * #rest #virtual
   *
   *  Update Entity Page publication status
   */
  entityPageUpdatePublicationStatus?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Follow a given Entity Page
   */
  entityPageFollow?: Maybe<FollowersMutationResult>;
  /**
   * #rest #virtual
   *
   *  UnFollow a given Entity Page
   */
  entityPageUnfollow?: Maybe<FollowersMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete a given Entity Page
   */
  entityPageDelete?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Hard delete a given Entity Page with status created/draft
   */
  entityPageHardDelete?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create new Contact User
   */
  entityPageCreateContactUser?: Maybe<EntityPageContactUserMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update Contact User
   */
  entityPageUpdateContactUser?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update Contact Users Catalogue
   */
  entityPageUpdateContactUsersCatalogue?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete a Contact User
   */
  entityPageDeleteContactUser?: Maybe<EntityPageMutationResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Update Entity Page Visitor tracking
   */
  entityPageTrackVisitor?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update AboutUs content V2
   */
  entityPageUpdateAboutContent?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create new Entity Media
   */
  entityPageCreateMedia?: Maybe<EntityPageMediaMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create new Entity Video Media
   */
  entityPageCreateVideoMedia?: Maybe<EntityPageVideoMediaMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update Entity Media
   */
  entityPageUpdateMedia?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update Entity Media Video
   */
  entityPageUpdateVideoMedia?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update Entity Video Media Gallery
   */
  entityPageUpdateMediaGallery?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete an Entity Media
   */
  entityPageDeleteMedia?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create new Entity Document
   */
  entityPageCreateDocument?: Maybe<EntityPageDocumentMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update Entity Document
   */
  entityPageUpdateDocument?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete an Entity Document
   */
  entityPageDeleteDocument?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create new Location
   */
  entityPageCreateLocation?: Maybe<EntityPageLocationMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update Location
   */
  entityPageUpdateLocation?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete Location
   */
  entityPageDeleteLocation?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update Page Cover
   */
  entityPageUpdateCover?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete Page Cover
   */
  entityPageDeleteCover?: Maybe<EntityPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Creates client for Payment & Billing
   */
  createPayBilClient?: Maybe<PayBilClientMutationResult>;
  /**
   * #rest #virtual
   *
   *  Updates client for Payment & Billing
   */
  updatePayBilClient?: Maybe<PayBilClientMutationResult>;
  /**
   * #rest #virtual
   *
   *  Updates client billing address
   */
  updateClientBillingAddress?: Maybe<UpdateClientBillingAddressResult>;
  /**
   * #rest #virtual
   *
   *  Deletes all user connections between current user and its client
   */
  paymentsDeleteUserConnections?: Maybe<DeleteUserConnectionsResult>;
  /**
   * #rest #virtual
   *
   *  Edit payment method
   */
  updateBpayPaymentMethod?: Maybe<UpdateBpayPaymentMethodResult>;
  /**
   * #rest #virtual
   *
   *  This mutation adds a collection of company affiliates to the current company
   */
  companyCreateAffiliates?: Maybe<CompanyAffiliatesMutationResult>;
  /**
   * #rest #virtual
   *
   *  Deletes a feed of the company.
   * Current user must be editor of the company, and feed with given id and type
   * must belong to editor's company
   */
  companyDeleteFeed?: Maybe<CompanyDeleteFeedResult>;
  /**
   * #rest #virtual
   *
   *  Creates a feed of the company. Current user must be editor of the company.
   */
  companyCreateFeed?: Maybe<CompanyCreateFeedResult>;
  /**
   * #rest #virtual
   *
   *  Create a new company page, both on pages and companies and return the entity page id.
   */
  companyPageCreate?: Maybe<CompanyPageCreatePayload>;
  /**
   * #rest #virtual
   *
   *  This mutation adds the current user as follower to the specified company
   */
  companyFollow?: Maybe<FollowersMutationResult>;
  /**
   * #rest #virtual
   *
   *  This mutation removes the current user as follower to the specified company
   */
  companyUnfollow?: Maybe<FollowersMutationResult>;
  /**
   * #rest #virtual
   *
   *  Dismisses the company -> entity page auto-migration notification
   * for the provided user and company
   */
  dismissCompanyAutoMigrationNotification?: Maybe<DismissCompanyAutoNotificationResult>;
  /**
   * #rest #virtual
   *
   *  Remove a Company from the CompanyRecommendations list
   */
  deleteCompanyRecommendation?: Maybe<DeleteCompanyRecommendationResult>;
  /**
   * #rest #virtual
   *
   *  Deletes an article of the company.
   * Current user must be editor of the company
   */
  companyUpdatesDelete?: Maybe<CompanyUpdatesDeleteResult>;
  /**
   * #rest #virtual
   *
   *  Update company information
   */
  companyUpdateInformation?: Maybe<CompanyUpdateInformationPayload>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Creates a video tracking event
   */
  videoTracking?: Maybe<VideoTrackingMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create video
   */
  videoCreate?: Maybe<VideoMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update video
   */
  videoUpdate?: Maybe<VideoMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete video
   */
  videoDelete?: Maybe<VideoEmptyResult>;
  /**
   * #rest #virtual
   *
   *  Create custom thumbnail
   */
  videoCustomThumbnailCreate?: Maybe<VideoEmptyResult>;
  /**
   * #rest #virtual
   *
   *  Update custom thumbnail
   */
  videoCustomThumbnailUpdate?: Maybe<VideoEmptyResult>;
  /**
   * #rest #virtual
   *
   *  Delete custom thumbnail
   */
  videoCustomThumbnailDelete?: Maybe<VideoEmptyResult>;
  /**
   * #rest #virtual
   *
   *  Create subtitle
   */
  videoSubtitleCreate?: Maybe<VideoEmptyResult>;
  /**
   * #rest #virtual
   *
   *  Update subtitle
   */
  videoSubtitleUpdate?: Maybe<VideoEmptyResult>;
  /**
   * #rest #virtual
   *
   *  Delete subtitle
   */
  videoSubtitleDelete?: Maybe<VideoEmptyResult>;
  /**
   * #rest #virtual
   *
   *  Create video resource
   */
  videoResourceCreate?: Maybe<VideoResourceCreationResult>;
  /**
   * #rest #virtual
   *
   *  Create video image attachment
   */
  videoImageAttachmentCreate?: Maybe<VideoImageAttachmentCreationResult>;
  /**
   * #rest #virtual
   *
   *  Start video encoding
   */
  videoStartEncoding?: Maybe<VideoEmptyResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Submit review for a rejected or accepted report
   */
  submitReview?: Maybe<SubmitReviewPostResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Confirm email for unauthenticated report
   */
  confirmEmailReport?: Maybe<ConfirmEmailReportResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Complete a complaint report
   */
  completeComplaintReport?: Maybe<CompleteReportResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Revert a complaint report
   */
  revertComplaintReport?: Maybe<RevertReportResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Send a complaint report
   */
  complaintsCreateContentReport?: Maybe<ComplaintsCreateContentReportResult>;
  /**
   * #rest #virtual
   *
   *  Send a profile report
   */
  complaintsCreateProfileReport?: Maybe<ComplaintsCreateProfileReportResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Update a report
   */
  updateReport?: Maybe<UpdateReportPutResult>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Creates partner code for users
   * @deprecated Replaced by partnerCreateCode mutation
   */
  premiumPartnerCreateCode?: Maybe<PremiumPartnerCreateCodeMutationResult>;
  /**
   * #rest #virtual
   *
   *  Redeems a standard voucher using voucher code
   */
  redeemVoucher?: Maybe<VoucherRedemptionMutationResult>;
  /**
   * #rest #virtual
   *
   *  Redeems a special voucher using voucher code
   */
  redeemSpecialVoucher?: Maybe<VoucherSpecialRedemptionMutationResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Create new profile visit for a user
   */
  profileVisit?: Maybe<NewProfileVisitResult>;
  /**
   * #rest #virtual
   *
   *  Reset the number of new visits counter
   */
  visitsView?: Maybe<VisitsViewResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Triggers creation for an external VOMP
   */
  externalProfileVisit?: Maybe<ExternalVompResult>;
  /**
   * #rest #virtual
   *
   *  Triggers creation for an internal VOMP
   */
  internalProfileVisit?: Maybe<InternalVompResult>;
  /**
   * #rest #virtual
   *
   *  Creates generic content
   */
  contentServiceCreateContent?: Maybe<ContentServiceSaveContentResult>;
  /**
   * #rest #virtual
   *
   *  Updates generic content
   */
  contentServiceUpdateContent?: Maybe<ContentServiceSaveContentResult>;
  /**
   * #rest #virtual
   *
   *  Mark as opened the notification
   */
  notificationMarkAsOpened?: Maybe<NotificationMarkAsOpenedResult>;
  /**
   * #rest #virtual
   *
   *  Mark all notifications as opened
   */
  notificationsMarkAllAsOpened?: Maybe<NotificationsMarkAllAsOpenedResult>;
  /**
   * #rest #virtual
   *
   *  Creates a Lead
   */
  probusinessCreateLead?: Maybe<ProBusinessCreateLeadResult>;
  /**
   * #rest #virtual
   *
   *  Removes a Lead
   */
  probusinessDeleteLead?: Maybe<ProBusinessDeleteLeadResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Mutation for creating users.
   */
  createUser?: Maybe<CreateUserMutationResult>;
  /**
   * #rest #virtual
   *
   *  Mutation for generating One Time token for the LinkedIn login flow.
   */
  createLinkedInOAuthFlowToken?: Maybe<CreateLinkedInOAuthFlowTokenResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Create a vita document
   */
  createVitaDocument?: Maybe<CreateVitaDocumentResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Trigger the vita document rendering process via token
   */
  requestVitaDocumentTokenRendering?: Maybe<RequestVitaDocumentRenderingResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Retrieve suggestion from LLM Service
   */
  generateVitaAboutMeSuggestion?: Maybe<LlmGatewayGenerateAboutMeResult>;
  /**
   * #rest #virtual
   *
   *  Mutation to creating document from imported data
   * The response - VitaDocument type
   */
  createDocumentFromProfileImport?: Maybe<CreateVitaDocumentResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Create a vita cover letter
   */
  createVitaCoverLetter?: Maybe<CreateVitaDocumentResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Trigger the vita cover letter rendering process
   */
  requestVitaCoverLetterRendering?: Maybe<RequestVitaDocumentRenderingResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Retrieve cover_letter suggestion from LLM Service
   */
  generateVitaCoverLetterSuggestion?: Maybe<LlmGatewayGenerateCoverLetterResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Trigger cover_letter suggestion generation from LLM Service
   */
  triggerVitaCoverLetterSuggestion?: Maybe<LlmGatewayTriggerCoverLetterResult>;
  /**
   * #rest #virtual
   *
   *  Triggers deleting all data for a fake user
   */
  erecruitingSourcingServiceDeleteE2EUser?: Maybe<ErecruitingSourcingServiceE2EUsersDeleteResult>;
  /**
   * #rest #virtual
   *
   *  Delete a Xing TalentService (XTS) message reminder
   */
  deleteErecruitingSourcingServicemessageReminder?: Maybe<ErecruitingSourcingServiceDeleteBriefingCandidateMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create a Xing Talent Service (XTS) Candidate Note By Consultant
   */
  createErecruitingSourcingServiceCandidateNote?: Maybe<ErecruitingSourcingServiceCandidateNoteMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create a Xing Talent Service (XTS) Candidate Note By Client
   */
  createErecruitingSourcingServiceClientCandidateNote?: Maybe<ErecruitingSourcingServiceCandidateNoteMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update a Xing Talent Service (XTS) Candidate Note By Consultant
   */
  updateErecruitingSourcingServiceCandidateNote?: Maybe<ErecruitingSourcingServiceCandidateNoteMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update a Xing Talent Service (XTS) Candidate Note By Client
   */
  updateErecruitingSourcingServiceClientCandidateNote?: Maybe<ErecruitingSourcingServiceCandidateNoteMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update or create a Xing TalentService (XTS) Message Reminder Metadata
   */
  updateErecruitingSourcingServiceMessageRemindersMetadata?: Maybe<ErecruitingSourcingServiceMessageReminderMetadataMutationResult>;
  /**
   * #rest #virtual
   *
   *  Discards a candidate from the long list recommendation (XTM)
   */
  discardErecruitingSourcingServiceCandidateRecommendation?: Maybe<ErecruitingSourcingServiceCandidateRecommendationDiscardMutationResult>;
  /**
   * #rest #virtual
   *
   *  Updates metadata attached to a briefing
   */
  updateErecruitingSourcingServiceBriefingMetadata?: Maybe<ErecruitingSourcingServiceBriefingMetadataUpdateResult>;
  /**
   * #rest #virtual
   *
   *  Create a XTS briefing report
   */
  createErecruitingSourcingServiceBriefingReport?: Maybe<ErecruitingSourcingServiceBriefingReportCreateResult>;
  /**
   * #rest #virtual
   *
   *  Create a Xing Sourcing Service (XSS) briefing
   */
  createErecruitingSourcingServiceBriefing?: Maybe<ErecruitingSourcingServiceMutationResult>;
  /**
   * #rest #virtual
   *
   *  Share a Xing Sourcing Service (XSS) briefing
   */
  shareErecruitingSourcingServiceBriefing?: Maybe<ErecruitingSourcingServiceShareResult>;
  /**
   * #rest #virtual
   *
   *  Archive/unarchive a Xing TalentService (XTS) briefing
   */
  updateErecruitingSourcingServiceBriefingArchiveStatus?: Maybe<ErecruitingSourcingServiceArchiveResult>;
  /**
   * #rest #virtual
   *
   *  Change owner of a Xing TalentService (XTS) briefing
   */
  changeErecruitingSourcingServiceBriefingOwner?: Maybe<ErecruitingSourcingServiceChangeBriefingOwnerError>;
  /**
   * #rest #virtual
   *
   *  Create a Xing TalentService (XTS) Briefing Candidate
   */
  createErecruitingSourcingServiceBriefingCandidate?: Maybe<ErecruitingSourcingServiceBriefingCandidateMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete a Xing TalentService (XTS) Briefing Candidate
   */
  deleteErecruitingSourcingServiceBriefingCandidate?: Maybe<ErecruitingSourcingServiceDeleteBriefingCandidateMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update a Xing Sourcing Service (XSS) Briefing Candidate Status
   */
  erecruitingSourcingServiceUpdateBriefingCandidate?: Maybe<ErecruitingSourcingServiceBriefingCandidateUpdateResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Generate a Job draft using AI
   */
  triggerJobsEasyCreateGenerateJobWithAI?: Maybe<TriggerJobsEasyCreateAiJobGenerationResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Create a Jobs Edition job draft
   */
  jobsEasyCreateJobsDraft?: Maybe<JobsEasyCreateJobsDraftResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Trigger purchasing of a job ad and activating a Jobs B2B Jobs Edition customer
   */
  triggerJobsEasyCreateInstantActivation?: Maybe<TriggerJobsEasyCreateEcomPurchaseResult>;
  /**
   * #rest #virtual
   *
   *  Create a payment B2B client Id
   */
  createPaymentsB2bClientId?: Maybe<CreatePaymentsB2bClientIdResult>;
  /**
   * #rest #virtual
   *
   *  Update a payment B2B client Id
   */
  updatePaymentsB2bClientId?: Maybe<UpdatePaymentsB2bClientIdResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Triggers the direct publish flow for Jobs Easy Create Ecom purchases
   */
  jobsEasyCreateDirectPublishTrigger?: Maybe<JobsEasyCreateDirectPublishTriggerUnion>;
  /**
   * #rest #virtual
   *
   *  Update a users notification settings
   */
  updateNotificationSettings?: Maybe<NotificationSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update activities settings
   */
  updateActivitiesSettings?: Maybe<ActivitiesSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  changes the PremiumSwitch settings
   */
  updatePremiumSwitchSettings?: Maybe<PremiumSwitchSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update account settings
   */
  updateAccountSettings?: Maybe<AccountSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete pending email, in case user wants to abort email change procedure
   */
  deletePendingEmail?: Maybe<DeletePendingEmailPayload>;
  /**
   * #rest #virtual
   *
   *  Delete pending phone, in case user wants to abort phone change procedure
   */
  deletePendingPhone?: Maybe<DeletePendingPhonePayload>;
  /**
   * #rest #virtual
   *
   *  Update login settings
   */
  updateLoginSettings?: Maybe<LoginSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update account deactivation settings
   */
  updateAccountDeactivationSettings?: Maybe<AccountDeactivationSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete account
   */
  updateAccountDeletionSettings?: Maybe<AccountDeletionSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update profile settings
   */
  updateProfileSettings?: Maybe<ProfileSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete login session (Web)
   */
  deleteLoginSession?: Maybe<DeleteLoginSessionPayload>;
  /**
   * #rest #virtual
   *
   *  Warning: XWS sessions are app scoped, deleting them will log the user out on all devices
   */
  deleteXwsSession?: Maybe<DeleteXwsSessionPayload>;
  /**
   * #rest #virtual
   *
   *  Start data inquiry for the user
   */
  startUserDataInquiry?: Maybe<StartUserDataInquiryResult>;
  /**
   * #rest #virtual
   *
   *  User data inquriy temporary download URL
   */
  userDataInquiryTemporaryDownloadUrl?: Maybe<UserDataInquiryTemporaryDownloadUrlResult>;
  /**
   * #rest #virtual
   *
   *  Update messenger settings
   */
  updateMessengerSettings?: Maybe<MessengerSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update core settings
   */
  updateCoreSettings?: Maybe<CoreSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update privacy settings
   */
  updateNetworkSettings?: Maybe<NetworkSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update visibility settings for Profile-Loggedout and LO content
   */
  updateProfilesLoggedoutSettings?: Maybe<ProfilesLoggedoutSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create password protected token
   */
  createPasswordProtectedSettingToken?: Maybe<PasswordProtectedSettingTokenMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update two-factor authentication settings
   */
  updateTwoFaSettings?: Maybe<TwoFaSettingsUpdateResult>;
  /**
   * #rest #virtual
   *
   *  Activate two-factor authentication
   */
  activateTwoFaSettings?: Maybe<TwoFaSettingsActivationResult>;
  /**
   * #rest #virtual
   *
   *  Regenerate backup code for two-factor authentication
   */
  regenerateBackupCodeTwoFaSettings?: Maybe<TwoFaSettingsBackupCodeRegenerationResult>;
  /**
   * #rest #virtual
   *
   *  changes the social settings
   */
  updateSocialSettings?: Maybe<SocialSettingsMutationResult>;
  /** Set Insights banner property value as viewed */
  bannerPropertyDisable?: Maybe<BannerPropertyDisableResult>;
  /** Mark a signals stack seen */
  signalsStackMarkSeen?: Maybe<SignalsStackMarkSeenResult>;
  /** Mark a signal interacted */
  signalMarkInteracted?: Maybe<SignalMarkInteractedResult>;
  /** Delete a signal */
  signalDelete?: Maybe<SignalDeleteResult>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Decline MYMK recommendation
   */
  mymkDeclineRecommendation?: Maybe<MymkDeclineRecommendationResult>;
  /**
   * #preview #rest #virtual
   *
   *  Add attendee to meeting room (hackweek project)
   */
  meetingRoomAddAttendee?: Maybe<MeetingRoomAddAttendeeResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the user's prefered employers
   */
  employersPreference?: Maybe<UpdateEmployersPreferenceResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the user's industries preference
   */
  industriesPreference?: Maybe<UpdateIndustriesPreferenceResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the user's disciplines preference
   */
  disciplinesPreference?: Maybe<UpdateDisciplinesPreferenceResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Triggers updating the user/visitor salary expectations preference
   */
  salaryExpectationsPreference?: Maybe<UpdateSalaryExpectationsPreferenceResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Triggers deleting the user/visitor salary expectations preference
   */
  deleteSalaryExpectationsPreference?: Maybe<DeleteSalaryExpectationsPreferenceResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the list of companies the user does not want to see their preferences
   */
  blockedCompanies?: Maybe<UpdateBlockedCompaniesResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the job preferences user's flags
   */
  jobPreferenceUserFlags?: Maybe<UpdateJobPreferenceUserFlagsResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Triggers updating the user/visitor career level preference
   */
  careerLevelPreference?: Maybe<UpdateCareerLevelPreferenceResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Triggers deleting the user/visitor career level preference
   */
  deleteCareerLevelPreference?: Maybe<DeleteCareerLevelPreferenceResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the user's workplace preference
   */
  workplacePreference?: Maybe<UpdateWorkplacePreferenceResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Triggers updating the user's locations preference
   */
  locationsPreference?: Maybe<UpdateLocationsPreferenceResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Triggers deleting the user/visitor locations preference
   */
  deleteLocationsPreference?: Maybe<DeleteLocationsPreferenceResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the user's working hours preference
   */
  workingHoursPreference?: Maybe<UpdateWorkingHoursPreferenceResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the user's target positions
   */
  jobTitlesTargetPositions?: Maybe<UpdateJobTitlesTargetPositionsPreferenceResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the user's unpreferred positions
   */
  jobTitlesUnpreferredPositions?: Maybe<UpdateJobTitlesUnpreferredPositionsPreferenceResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating the user's job seeker status
   */
  jobPreferencesJobSeekerStatus?: Maybe<UpdateJobPreferencesJobSeekerStatusResult>;
  /**
   * #rest #virtual
   *
   *  Parse the template with the recipient's data
   */
  parseMessageTemplate?: Maybe<ParseMessageTemplateMutationResult>;
  /**
   * #rest #virtual
   *
   *  Create or update a Xing Talent Manager (XTM) project campaign
   */
  xtmProjectCreateUpdateCampaign?: Maybe<XtmProjectCreateUpdateCampaignResult>;
  /**
   * #rest #virtual
   *
   *  Send a Xing Talent Manager (XTM) project campaign
   */
  xtmProjectSendCampaign?: Maybe<XtmProjectSendCampaignResult>;
  /**
   * #rest #virtual
   *
   *  Check the limitatons when creating a Xing Talent Manager (XTM) project campaign
   */
  xtmProjectCampaignLimitations?: Maybe<XtmProjectCampaignLimitationsResult>;
  /**
   * #rest #virtual
   *
   *  Update a XTM project
   */
  updateXTMProject?: Maybe<XtmUpdateProjectResult>;
  /**
   * #rest #virtual
   *
   *  Delete a contact
   */
  networkContactsDelete?: Maybe<ContactsDeleteResult>;
  /**
   * #rest #virtual
   *
   *  Create a new custom tag for this user to tag contacts with
   */
  networkCreateTag?: Maybe<NetworkTagCreateResult>;
  /**
   * #rest #virtual
   *
   *  Delete a custom tag of this user
   */
  networkDeleteTag?: Maybe<NetworkTagDeleteResult>;
  /**
   * #rest #virtual
   *
   *  Assign a tag to a contact
   */
  networkAssignTag?: Maybe<NetworkTagAssignResult>;
  /**
   * #rest #virtual
   *
   *  Unassign a tag from a contact
   */
  networkUnassignTag?: Maybe<NetworkTagUnassignResult>;
  /**
   * #rest #virtual
   *
   *  Set the proximity id for the requesting user for 7 days.
   */
  networkUserProximityIdSet?: Maybe<NetworkUserProximityIdSetResult>;
  /**
   * #rest #virtual
   *
   *  Forget the proximity id for the requesting user immediately.
   */
  networkUserProximityIdForget?: Maybe<NetworkUserProximityIdSetResult>;
  /**
   * #rest #virtual
   *
   *  Sets new settings related to contact data sharing.
   */
  updateDataSharingSettings?: Maybe<DataSharingSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Adds exclusions for contact data sharing settings.
   */
  addDataSharingExclusion?: Maybe<DataSharingExclusionMutationResult>;
  /**
   * #rest #virtual
   *
   *  Removes exclusions for contact data sharing settings.
   */
  deleteDataSharingExclusion?: Maybe<DataSharingExclusionMutationResult>;
  /**
   * #rest #virtual
   *
   *  Set note for the contact
   */
  networkSetNote?: Maybe<SetNotePayload>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Persists a client setting for network apps
   */
  networkClientSettingSet?: Maybe<NetworkClientSettingsSetResult>;
  /**
   * #rest #virtual
   *
   *  Decline a received contact request
   */
  networkContactRequestsDecline?: Maybe<ContactRequestsDeclineResult>;
  /**
   * #rest #virtual
   *
   *  Revoke a sent contact request
   */
  networkContactRequestsRevoke?: Maybe<ContactRequestsRevokeResult>;
  /**
   * #rest #virtual
   *
   *  Confirm a received contact request
   */
  networkContactRequestsConfirm?: Maybe<ContactRequestsConfirmResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Confirm a received contact request instantly with a token
   */
  networkContactRequestsTokenConfirm?: Maybe<ContactRequestsTokenConfirmResult>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Send a contact request
   */
  networkContactRequestsSend?: Maybe<ContactRequestsSendResult>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Send multiple contact requests
   */
  networkContactRequestsSendMultiple?: Maybe<ContactRequestsSendMultipleResult>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Mark received contact requests up until given date as seen
   */
  networkContactRequestsMarkSeen?: Maybe<ContactRequestsMarkSeenResult>;
  /**
   * #rest #virtual
   *
   *  Report a contact request as spam
   */
  networkContactRequestsSpamReport?: Maybe<ContactRequestsSpamReportResult>;
  /**
   * #rest #virtual
   *
   *  Create payment method
   */
  createPaymentAccount?: Maybe<PaymentAccountMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update payment account
   */
  updatePaymentAccount?: Maybe<PaymentAccountMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update payment method
   */
  updatePaymentMethod?: Maybe<PaymentAccountMutationResult>;
  /**
   * #rest #virtual
   *
   *  Regenerate payment invoice
   */
  regenerateInvoices?: Maybe<RegenerateInvoicesMutationResult>;
  /**
   * #rest #virtual
   *
   *  Mark object as seen
   */
  markAsSeen?: Maybe<MarkAsSeenMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update b2b profile settings
   */
  updateB2BProfileSettings?: Maybe<UpdateB2BProfileSettingsMutationResult>;
  /**
   * #rest #virtual
   *
   *  Decline job recommendation
   */
  jobRecoDeclineRecommendation?: Maybe<JobRecoDeclineRecommendationResult>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  User feedback on a job recommendation
   */
  updateJobRecoFeedback?: Maybe<JobRecoFeedBackResult>;
  /**
   * #rest #virtual
   *
   *  Creates a journey
   */
  onboardingCreateJourney?: Maybe<OnboardingJourneyNextScreenResponseType>;
  /**
   * #rest #virtual
   *
   *  Updates a journey
   */
  onboardingUpdateJourney?: Maybe<OnboardingJourneyNextScreenResponseType>;
  /**
   * #rest #virtual
   *
   *  Resumes a journey (if eligible)
   */
  onboardingResumeJourney?: Maybe<OnboardingJourneyType>;
  /**
   * #rest #virtual
   *
   *  Updates a journey (for QA and Dev) only available on Xingbox and Preview
   */
  onboardingDeveloperUpdateJourney?: Maybe<OnboardingJourneyNextScreenResponseType>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Send contact form to support team
   */
  contactSupport?: Maybe<ContactPostResult>;
  /**
   * #rest #virtual
   *
   *  Blocks an entity by urn
   */
  blockingServiceBlock?: Maybe<BlockingServiceBlockResult>;
  /**
   * #rest #virtual
   *
   *  Unblocks an entity by urn
   */
  blockingServiceUnblock?: Maybe<BlockingServiceUnblockResult>;
  /**
   * #rest #virtual
   *
   *  Follow a given generic entity
   */
  followersFollow?: Maybe<FollowersMutationResult>;
  /**
   * #rest #virtual
   *
   *  Unfollow a given generic entity
   */
  followersUnfollow?: Maybe<FollowersMutationResult>;
  /**
   * #rest #virtual
   *
   *  Mark a company as ideal employer
   */
  proJobsMarkAsIdealEmployer?: Maybe<ProJobsIdealEmployerMutationResult>;
  /**
   * #rest #virtual
   *
   *  Unmark a company as ideal employer
   */
  proJobsUnmarkAsIdealEmployer?: Maybe<ProJobsIdealEmployerMutationResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating JobSeeker Guidance Action
   */
  jobSeekerGuidanceUpdateAction?: Maybe<JobSeekerGuidanceUpdateActionResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating salary expectation
   * @deprecated Will be removed at the end of Q4
   */
  projobsSalaryExpectation?: Maybe<ProjobsSalaryExpectationResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating working hours
   * @deprecated Will be removed at the end of Q4
   */
  projobsWorkingHours?: Maybe<ProjobsWorkingHoursResult>;
  /**
   * #rest #virtual
   *
   *  Triggers an update on user job seeker status
   */
  projobsSettingSeekingStatus?: Maybe<ProjobsSeekingStatusResult>;
  /**
   * #rest #virtual
   *
   *  Triggers adding companies to the blocked_companies
   */
  projobsAddBlockedCompanies?: Maybe<ProjobsAddBlockedCompaniesResult>;
  /**
   * #rest #virtual
   *
   *  Triggers adding a user to the blocklist
   */
  projobsAddBlocklistUser?: Maybe<ProjobsAddBlocklistUserResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating discipline
   * @deprecated Will be removed at the end of Q4
   */
  projobsDiscipline?: Maybe<ProjobsDisciplineResult>;
  /**
   * #rest #virtual
   *
   *  Triggers adding a user to the allowlist
   */
  projobsAddAllowlistUser?: Maybe<ProjobsAddAllowlistUserResult>;
  /**
   * #rest #virtual
   *
   *  Triggers removing a user from allowlist
   */
  projobsRemoveAllowlistUser?: Maybe<ProjobsRemoveAllowlistUserResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating avoid
   * @deprecated Will be removed at the end of Q4
   */
  projobsAvoid?: Maybe<ProjobsAvoidResult>;
  /**
   * #rest #virtual
   *
   *  Triggers an update on job seeker contact options
   * @deprecated Will be removed at the end of Q4
   */
  projobsUpdateContactOptions?: Maybe<ProjobsContactOptionsResult>;
  /**
   * #rest #virtual
   *
   *  Triggers deleting a document from user
   */
  projobsDeleteDocument?: Maybe<ProjobsDeleteDocumentResult>;
  /**
   * #rest #virtual
   *
   *  Triggers update user's willingness to travel
   * @deprecated Will be removed at the end of Q4
   */
  projobsWillingnessToTravel?: Maybe<ProjobsWillingnessToTravelResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating positions
   * @deprecated Will be removed at the end of Q4
   */
  projobsPositions?: Maybe<ProjobsPositionsResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updaing industries
   * @deprecated Will be removed at the end of Q4
   */
  projobsIndustries?: Maybe<ProjobsIndustriesResult>;
  /**
   * #rest #virtual
   *
   *  Triggers removing company from the blocked_companies
   */
  projobsRemoveBlockedCompany?: Maybe<ProjobsRemoveBlockedCompanyResult>;
  /**
   * #rest #virtual
   *
   *  Uploads documents to the user's projobs
   */
  projobsUploadDocument?: Maybe<ProjobsUploadDocumentResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating document title
   */
  projobsUpdateDocument?: Maybe<ProjobsUpdateDocumentResult>;
  /**
   * #rest #virtual
   *
   *  Triggers removing a user from blocklist
   */
  projobsRemoveBlocklistUser?: Maybe<ProjobsRemoveBlocklistUserResult>;
  /**
   * #rest #virtual
   *
   *  Triggers updating cities
   * @deprecated Will be removed at the end of Q4
   */
  projobsCities?: Maybe<ProjobsCitiesResult>;
  /**
   * #rest #virtual
   *
   *  Triggers tracking for a notification interaction
   */
  projobsSettingVisibility?: Maybe<ProjobsVisibilityResult>;
  /**
   * #rest #virtual
   *
   *  Triggers adding a company to the target companies
   * @deprecated Will be removed at the end of Q4
   */
  projobsAddIdealEmployers?: Maybe<ProjobsAddIdealEmployersResult>;
  /**
   * #rest #virtual
   *
   *  Blocks a user
   */
  networkBlockedUsersBlock?: Maybe<NetworkBlockedUsersBlockResult>;
  /**
   * #rest #virtual
   *
   *  Unblocks a user
   */
  networkBlockedUsersUnblock?: Maybe<NetworkBlockedUsersUnblockResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This mutation tracks a click for an ad
   */
  adsTrackClick?: Maybe<AdsTrackingResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This mutation tracks an impression for an ad
   */
  adsTrackImpression?: Maybe<AdsTrackingResult>;
  /**
   * #rest #virtual
   *
   *  This mutation creates a FormSubmission for a given LeadAdForm
   */
  leadAdFormSubmissionCreate?: Maybe<LeadAdFormSubmissionCreateResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This mutation tracks a click for an ad
   */
  trackAdClickByIntId?: Maybe<AdsTrackingIntIdResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This mutation tracks an impression for an ad
   */
  trackAdImpressionByIntId?: Maybe<AdsTrackingIntIdResult>;
  /**
   * #rest #virtual
   *
   *  Marks ad as not interesting to user.
   */
  adNegativeFeedbackCreate?: Maybe<AdNegativeFeedbackError>;
  /**
   * #rest #virtual
   *
   *  Mark messenger banner as shown
   */
  updateMessengerBanner?: Maybe<UpdateMessengerBannerResult>;
  /**
   * #rest #virtual
   *
   *  Request to create a file upload at the upload service. On success a representation of
   * the upload is returned containing all necessary information to push data to the upload
   * and process it later in the backend.
   *
   * We are bypasing original `UploadRequestResolver` bacause we are signing the upload id
   * so it cannot be used outside the intended chat by the originating user
   */
  messengerUploadRequest?: Maybe<MessengerUploadResult>;
  /**
   * #rest #virtual
   *
   *  This mutation deletes a scheduled message
   */
  deleteScheduledMessage?: Maybe<ScheduledMessageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Creates a message in a chat
   */
  createMessengerMessage?: Maybe<CreateMessengerMessageResult>;
  /**
   * #rest #virtual
   *
   *  Creates an image message in a chat
   */
  createMessengerImageMessage?: Maybe<CreateMessengerImageMessageResult>;
  /**
   * #rest #virtual
   *
   *  Creates an attachment message in a chat
   */
  createMessengerAttachmentMessage?: Maybe<CreateMessengerAttachmentMessageResult>;
  /**
   * #rest #virtual
   *
   *  Creates a system reply message in a chat
   */
  createMessengerSystemReplyMessage?: Maybe<CreateMessengerSystemReplyMessageResult>;
  /**
   * #rest #virtual
   *
   *  Creates a user reply message in a chat
   */
  createMessengerUserReplyMessage?: Maybe<CreateMessengerUserReplyMessageResult>;
  /**
   * #rest #virtual
   *
   *  Marks the 'Mark-all-as-read' popup as shown
   */
  markAllChatsAsReadPopupAsShown?: Maybe<MarkAllChatsAsReadPopupAsShownResult>;
  /**
   * #rest #virtual
   *
   *  Marks all chats as read
   */
  markAllChatsAsRead?: Maybe<MarkAllChatsAsReadResult>;
  /**
   * #rest #virtual
   *
   *  Creates a chat
   */
  createMessengerChat?: Maybe<CreateMessengerChatResult>;
  /**
   * #rest #virtual
   *
   *  Creates a chat by Slug or ID
   */
  createMessengerChatBySlugOrID?: Maybe<CreateMessengerChatResult>;
  /**
   * #rest #virtual
   *
   *  Marks a chat as read
   */
  markAsReadMessengerChat?: Maybe<MarkAsReadMessengerChatResult>;
  /**
   * #rest #virtual
   *
   *  Deletes a chat for user
   */
  deleteMessengerChat?: Maybe<DeleteMessengerChatResult>;
  /**
   * #rest #virtual
   *
   *  Mark a chat as unread
   */
  markAsUnreadMessengerChat?: Maybe<MarkAsUnreadMessengerChatResult>;
  /**
   * #rest #virtual
   *
   *  Add the specified participants to a chat
   */
  addMessengerChatParticipants?: Maybe<AddMessengerChatParticipantsResult>;
  /**
   * #rest #virtual
   *
   *  Deletes the specified participant from a chat
   */
  deleteMessengerChatParticipant?: Maybe<DeleteMessengerChatParticipantResult>;
  /**
   * #rest #virtual
   *
   *  Create a template
   */
  createMessengerMessageTemplate?: Maybe<CreateMessengerMessageTemplateResult>;
  /**
   * #rest #virtual
   *
   *  Update a template
   */
  updateMessengerMessageTemplate?: Maybe<UpdateMessengerMessageTemplateResult>;
  /**
   * #rest #virtual
   *
   *  Delete a template
   */
  deleteMessengerMessageTemplate?: Maybe<DeleteMessengerMessageTemplateResult>;
  /**
   * #rest #virtual
   *
   *  Executes a one-click-action
   */
  messengerExecuteOneClickAction?: Maybe<MessengerExecuteOneClickActionResult>;
  /**
   * #rest #virtual
   *
   *  This mutation disables New Notification Center for the current user
   */
  featureSwitchesDisableNewNotificationCenter?: Maybe<FeatureSwitchesNewNotificationCenterMutationResult>;
  /**
   * #rest #virtual
   *
   *  This mutation enables New Notification Center for the current user
   */
  featureSwitchesEnableNewNotificationCenter?: Maybe<FeatureSwitchesNewNotificationCenterMutationResult>;
  /**
   * #rest #virtual
   *
   *  This mutation disables Vertical Navigation for the current user
   */
  featureSwitchesDisableVerticalNavigation?: Maybe<FeatureSwitchesVerticalNavigationMutationResult>;
  /**
   * #rest #virtual
   *
   *  This mutation enables Vertical Navigation for the current user
   */
  featureSwitchesEnableVerticalNavigation?: Maybe<FeatureSwitchesVerticalNavigationMutationResult>;
  /**
   * #rest #virtual
   *
   *  Force variant for current user and given experiment name
   */
  featureSwitchesExperimentsForceVariant?: Maybe<FeatureSwitchesExperimentsForceVariantResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Send llm-gateway interaction tracking
   */
  llmGatewayInteractionTracking?: Maybe<LlmGatewayInteractionTrackingResult>;
  /**
   * #rest #virtual
   *
   *  Assign seat mutation
   */
  seatManagerCreateAssignment?: Maybe<SeatManagerCreateAssignmentResponse>;
  /**
   * #rest #virtual
   *
   *  Delete seat assignment mutation
   */
  seatManagerDeleteAssignment?: Maybe<SeatManagerDeleteAssignmentResponse>;
  /**
   * #rest #virtual
   *
   *  Update email subscription
   */
  contentUpdateEmailSubscription?: Maybe<ContentUpdateEmailSubscriptionPayload>;
  /**
   * #rest #virtual
   *
   *  Create a new comment for commentable
   */
  contentCommentCreate?: Maybe<ContentCommentMutationResult>;
  /**
   * #rest #virtual
   *
   *  Hide a comment
   */
  contentCommentHide?: Maybe<ContentCommentMutationResult>;
  /**
   * #rest #virtual
   *
   *  Feature an article
   */
  contentFeatureArticle?: Maybe<ContentArticleMutationResult>;
  /**
   * #rest #virtual
   *
   *  Unfeature an article
   */
  contentUnfeatureArticle?: Maybe<ContentArticleMutationResult>;
  /**
   * #rest #virtual
   *
   *  Disable an article
   */
  contentDisableArticle?: Maybe<ContentArticleMutationResult>;
  /**
   * #rest #virtual
   *
   *  Enable an article
   */
  contentEnableArticle?: Maybe<ContentArticleMutationResult>;
  /**
   * #rest #virtual
   *
   *  Delete an article
   */
  contentDeleteArticle?: Maybe<ContentArticleDeletionResult>;
  /**
   * #rest #virtual
   *
   *  Cancel content subscription
   */
  contentCancelSubscription?: Maybe<ContentCancelSubscriptionResult>;
  /**
   * #rest #virtual
   *
   *  Create a link share image
   */
  contentCreateLinkShareImage?: Maybe<ContentCreateLinkShareImageResult>;
  /**
   * #rest #virtual
   *
   *  Publish a link share
   */
  contentPublishLinkShare?: Maybe<ContentLinkShareResult>;
  /**
   * #rest #virtual
   *
   *  Update a link share
   */
  contentUpdateLinkShare?: Maybe<ContentLinkShareResult>;
  /**
   * #rest #virtual
   *
   *  Create a link share
   */
  contentCreateLinkShare?: Maybe<ContentLinkShareResult>;
  /**
   * #rest #virtual
   *
   *  Agree with Klartext resource
   */
  contentKlartextAgree?: Maybe<ContentKlartextAgreeResult>;
  /**
   * #rest #virtual
   *
   *  Unagree with Klartext resource
   */
  contentKlartextUnagree?: Maybe<ContentKlartextUnagreeResult>;
  /**
   * #rest #virtual
   *
   *  Set lastFollowersSeenAt to the current time
   */
  contentInsiderPageLastFollowersSeen?: Maybe<ContentInsiderPageLastFollowersSeenResult>;
  /**
   * #rest #virtual
   *
   *  Follow page with current user
   */
  contentPageFollow?: Maybe<ContentPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Unfollow page with current user
   */
  contentPageUnfollow?: Maybe<ContentPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Update page description
   */
  contentUpdatePage?: Maybe<ContentPageMutationResult>;
  /**
   * #rest #virtual
   *
   *  Star something starable
   */
  contentStarableStar?: Maybe<ContentStarableMutationResult>;
  /**
   * #rest #virtual
   *
   *  Unstar something starable
   */
  contentStarableUnstar?: Maybe<ContentStarableMutationResult>;
  /**
   * #rest #virtual
   *
   *  Bookmark something bookmarkable
   */
  contentBookmarkableBookmark?: Maybe<ContentBookmarkableMutationResult>;
  /**
   * #rest #virtual
   *
   *  Unbookmark something bookmarkable
   */
  contentBookmarkableUnbookmark?: Maybe<ContentBookmarkableMutationResult>;
};


/** The root mutation type */
export type MutationProfileAcademicTitleUpdateDeleteArgs = {
  input: ProfileUpdateDeleteInput;
};


/** The root mutation type */
export type MutationProfileHavesUpdateDeleteArgs = {
  input: ProfileUpdateDeleteInput;
};


/** The root mutation type */
export type MutationProfileWantsUpdateDeleteArgs = {
  input: ProfileUpdateDeleteInput;
};


/** The root mutation type */
export type MutationProfileBusinessContactUpdateDeleteArgs = {
  input: ProfileUpdateDeleteInput;
};


/** The root mutation type */
export type MutationProfileWorkExperienceUpdateDeleteArgs = {
  input: ProfileUpdateDeleteInput;
};


/** The root mutation type */
export type MutationDataScienceTrackingFullFormatArgs = {
  input: DataScienceFullTrackingInput;
};


/** The root mutation type */
export type MutationDataScienceTrackingCompactFormatArgs = {
  input: DataScienceCompactTrackingInput;
};


/** The root mutation type */
export type MutationDreamJobsInteractArgs = {
  input: DreamJobInteractionInput;
};


/** The root mutation type */
export type MutationDreamJobStoreInteractionArgs = {
  input: DreamJobInteractionInput;
};


/** The root mutation type */
export type MutationDreamJobDeleteInteractionArgs = {
  input?: Maybe<DreamJobInteractionInput>;
};


/** The root mutation type */
export type MutationDreamJobsUpdateInteractionArgs = {
  input: DreamJobInteractionInput;
};


/** The root mutation type */
export type MutationDreamJobUpdateInteractionArgs = {
  input: DreamJobInteractionInput;
};


/** The root mutation type */
export type MutationDreamJobsSetConsentDetailsArgs = {
  input: DreamJobConsentInput;
};


/** The root mutation type */
export type MutationArticlesDisableArticleArgs = {
  input: ArticlesDisableArticleInput;
};


/** The root mutation type */
export type MutationArticlesUnpublishArticleArgs = {
  input: ArticlesUnpublishArticleInput;
};


/** The root mutation type */
export type MutationArticlesUpdateArticleArgs = {
  input: ArticlesUpdateArticleInput;
};


/** The root mutation type */
export type MutationArticlesUpdateArticleSettingsArgs = {
  input: ArticlesUpdateArticleSettingsInput;
};


/** The root mutation type */
export type MutationArticlesPublishArticleArgs = {
  input: ArticlesPublishArticleInput;
};


/** The root mutation type */
export type MutationArticlesEnableArticleArgs = {
  input: ArticlesEnableArticleInput;
};


/** The root mutation type */
export type MutationArticlesCreateArticleImageArgs = {
  input: ArticlesCreateArticleImageInput;
};


/** The root mutation type */
export type MutationArticlesCreateArticleArgs = {
  input: ArticlesCreateArticleInput;
};


/** The root mutation type */
export type MutationArticlesDeleteArticleArgs = {
  input: ArticlesDeleteArticleInput;
};


/** The root mutation type */
export type MutationRedeemJobsMtncVoucherArgs = {
  input: JobsMtncVoucherRedemptionInput;
};


/** The root mutation type */
export type MutationJobCreateReportArgs = {
  input: JobCreateReportInput;
};


/** The root mutation type */
export type MutationJobRegisterVisitArgs = {
  input: JobRegisterVisitInput;
};


/** The root mutation type */
export type MutationJobDeleteVisitArgs = {
  input: JobDeleteVisitInput;
};


/** The root mutation type */
export type MutationJobCreateBookmarkArgs = {
  input: JobBookmarkMutationInput;
};


/** The root mutation type */
export type MutationJobUpsertBookmarkArgs = {
  input: JobBookmarkUpsertMutationInput;
};


/** The root mutation type */
export type MutationJobDeleteBookmarkArgs = {
  input: JobBookmarkMutationInput;
};


/** The root mutation type */
export type MutationUserRemindJobApplicationArgs = {
  input: UserRemindMutationInput;
};


/** The root mutation type */
export type MutationJobSubmitJobApplicationArgs = {
  input: JobApplicationMutationInput;
};


/** The root mutation type */
export type MutationJobSubmitXingCustomApplicationArgs = {
  input: JobXingCustomApplicationInput;
};


/** The root mutation type */
export type MutationJobCreateApplyIntentionArgs = {
  input: JobUserApplyIntentionInput;
};


/** The root mutation type */
export type MutationCreateSearchAlertArgs = {
  input: SearchAlertCreationInput;
};


/** The root mutation type */
export type MutationCreateSearchAlertForLoArgs = {
  input: SearchAlertForLoCreationInput;
};


/** The root mutation type */
export type MutationCreateSearchAlertByQueryArgs = {
  input: JobSearchQueryInput;
};


/** The root mutation type */
export type MutationCreateSearchAlertByQueryNewArgs = {
  input: CreateSearchAlertByQueryNewInput;
};


/** The root mutation type */
export type MutationDeleteSearchAlertArgs = {
  input: SearchAlertId;
};


/** The root mutation type */
export type MutationVisitSearchAlertArgs = {
  input: SearchAlertId;
};


/** The root mutation type */
export type MutationConfirmLoSearchAlertArgs = {
  input: LoSearchAlertConfirmationInput;
};


/** The root mutation type */
export type MutationUnsubscribeLoSearchAlertArgs = {
  input: LoSearchAlertUnsubscribeInput;
};


/** The root mutation type */
export type MutationUpdateSearchAlertSettingsArgs = {
  input: UserSettingsUpdateInput;
};


/** The root mutation type */
export type MutationJobsMarkRecommendationsAsSeenArgs = {
  input: JobsMarkRecommendationsAsSeenInput;
};


/** The root mutation type */
export type MutationSaveUserFeedbackOnOutdatedFieldsArgs = {
  input: UserFeedbackRequest;
};


/** The root mutation type */
export type MutationUpsellCancellationAcceptCounterOfferArgs = {
  input?: Maybe<UpsellCancellationAcceptCounterOfferApplyBonus>;
};


/** The root mutation type */
export type MutationUpsellCancellationRequestArgs = {
  input: UpsellCancellationRequestInput;
};


/** The root mutation type */
export type MutationPurchaseWebOrderArgs = {
  input: WebOrderInput;
};


/** The root mutation type */
export type MutationPurchaseCreateCampaignArgs = {
  input: PurchaseCreateCampaignInput;
};


/** The root mutation type */
export type MutationPurchaseEnablePlatformArgs = {
  input: PurchaseEnablePlatformInput;
};


/** The root mutation type */
export type MutationPurchaseRestoreCampaignGroupResolverArgs = {
  input: PurchaseRestoreCampaignGroup;
};


/** The root mutation type */
export type MutationPurchaseUpdateCampaignGroupArgs = {
  input: PurchaseUpdateCampaignGroupInput;
};


/** The root mutation type */
export type MutationPurchaseDeleteCampaignGroupArgs = {
  input: PurchaseDeleteCampaignGroupInput;
};


/** The root mutation type */
export type MutationPurchaseUpdateCampaignArgs = {
  input: PurchaseUpdateCampaignInput;
};


/** The root mutation type */
export type MutationPurchasePublishCampaignArgs = {
  input: PurchasePublishCampaignInput;
};


/** The root mutation type */
export type MutationPurchaseCreateCampaignGroupArgs = {
  input: PurchaseCreateCampaignGroupInput;
};


/** The root mutation type */
export type MutationCreateBriefingArgs = {
  input: CreateBriefingInput;
};


/** The root mutation type */
export type MutationCreateCandidateSearchArgs = {
  input: CreateCandidateSearchInput;
};


/** The root mutation type */
export type MutationUpdateBriefingArgs = {
  input: UpdateBriefingInput;
};


/** The root mutation type */
export type MutationUploadRequestArgs = {
  input: UploadRequestInput;
};


/** The root mutation type */
export type MutationLoginUserSecurityIssuesAcknowledgeArgs = {
  input: LoginUserSecurityIssuesAcknowledgeMutationInput;
};


/** The root mutation type */
export type MutationPartnerCreateCodeArgs = {
  input: PartnerCreateCodeMutationInput;
};


/** The root mutation type */
export type MutationProfilePersonalDetailsUpdateArgs = {
  input: PersonalDetailsUpdateInput;
};


/** The root mutation type */
export type MutationProfileWantsUpdateArgs = {
  input: ProfileWantsUpdateInput;
};


/** The root mutation type */
export type MutationCreateWorkExperienceArgs = {
  input: CreateWorkExperienceInput;
};


/** The root mutation type */
export type MutationProfileInterestsUpdateArgs = {
  input: ProfileInterestsUpdateInput;
};


/** The root mutation type */
export type MutationCreateCvUploadParsedCvArgs = {
  input?: Maybe<CreateCvUploadParsedCvInput>;
};


/** The root mutation type */
export type MutationCreateCvUploadParsedCvByUserIdArgs = {
  input?: Maybe<CreateCvUploadParsedCvByUserIdInput>;
};


/** The root mutation type */
export type MutationDeleteCvUploadParsedCvArgs = {
  input?: Maybe<DeleteCvUploadParsedCvInput>;
};


/** The root mutation type */
export type MutationUpdateHiringProfileArgs = {
  input?: Maybe<UpdateHiringProfileInput>;
};


/** The root mutation type */
export type MutationUpdateLegalInformationArgs = {
  input: LegalInformationInput;
};


/** The root mutation type */
export type MutationXingIdUpdateStatusArgs = {
  input: XingIdUpdateStatusInput;
};


/** The root mutation type */
export type MutationXingIdUpdateContactDetailsArgs = {
  input: XingIdUpdateContactDetailsInput;
};


/** The root mutation type */
export type MutationXingIdAddContactArgs = {
  input: XingIdAddContactInput;
};


/** The root mutation type */
export type MutationXingIdConfirmContactArgs = {
  input: XingIdConfirmContactInput;
};


/** The root mutation type */
export type MutationXingIdDeleteContactArgs = {
  input: XingIdDeleteContactInput;
};


/** The root mutation type */
export type MutationXingIdDeclineContactRequestArgs = {
  input: XingIdDeclineContactRequestInput;
};


/** The root mutation type */
export type MutationXingIdFollowArgs = {
  input: XingIdFollowInput;
};


/** The root mutation type */
export type MutationXingIdUnfollowArgs = {
  input: XingIdUnfollowInput;
};


/** The root mutation type */
export type MutationXingIdUpdateProfileImageArgs = {
  input: XingIdUpdateProfileImageInput;
};


/** The root mutation type */
export type MutationXingIdUpdateHeaderImageArgs = {
  input: XingIdUpdateHeaderImageInput;
};


/** The root mutation type */
export type MutationXingIdReorderOccupationsArgs = {
  input: XingIdReorderOccupationsInput;
};


/** The root mutation type */
export type MutationProfileSkillsUpdateArgs = {
  input: ProfileSkillsUpdateInput;
};


/** The root mutation type */
export type MutationProfileSkillsAddArgs = {
  input: ProfileSkillsAddInput;
};


/** The root mutation type */
export type MutationProfileTimelineAddEntryArgs = {
  input: ProfileTimelineAddEntryInput;
};


/** The root mutation type */
export type MutationProfileTimelineEditEntryArgs = {
  input: ProfileTimelineEditEntryInput;
};


/** The root mutation type */
export type MutationProfileTimelineDeleteEntryArgs = {
  input: ProfileTimelineDeleteEntryInput;
};


/** The root mutation type */
export type MutationProfileLanguagesUpdateArgs = {
  input: ProfileLanguagesUpdateInput;
};


/** The root mutation type */
export type MutationProfileAboutMeUpdateArgs = {
  input: ProfileAboutMeUpdateInput;
};


/** The root mutation type */
export type MutationAccomplishmentCreateArgs = {
  input: AccomplishmentCreateInput;
};


/** The root mutation type */
export type MutationAccomplishmentUpdateArgs = {
  input: AccomplishmentUpdateInput;
};


/** The root mutation type */
export type MutationAccomplishmentDeleteArgs = {
  input: AccomplishmentDeleteInput;
};


/** The root mutation type */
export type MutationExternalUpdatesApplyArgs = {
  input: ExternalUpdatesApplyInput;
};


/** The root mutation type */
export type MutationUpdateProfileModuleStoreItemsArgs = {
  input: Array<UpdateProfileModuleStoreItemsInput>;
};


/** The root mutation type */
export type MutationNotificationsBadgesSeenArgs = {
  input: NotificationsBadgeNamesInput;
};


/** The root mutation type */
export type MutationCreateWebPushSubscriptionArgs = {
  input: CreateWebPushSubscriptionInput;
};


/** The root mutation type */
export type MutationUpdateWebPushSubscriptionArgs = {
  input: UpdateWebPushSubscriptionInput;
};


/** The root mutation type */
export type MutationSendMobileConsentArgs = {
  input: SendMobileConsentInput;
};


/** The root mutation type */
export type MutationSendWebConsentArgs = {
  input: SendWebConsentInput;
};


/** The root mutation type */
export type MutationSocialShareToStartpageArgs = {
  input: SocialShareToStartpageInput;
};


/** The root mutation type */
export type MutationSocialShareToGroupArgs = {
  input: SocialShareToGroupInput;
};


/** The root mutation type */
export type MutationSocialShareToMessengerArgs = {
  input: SocialShareToMessengerInput;
};


/** The root mutation type */
export type MutationSocialCreateExternalLinkArgs = {
  input: SocialCreateExternalLinkInput;
};


/** The root mutation type */
export type MutationSocialCreateReactionArgs = {
  input: SocialCreateReactionInput;
};


/** The root mutation type */
export type MutationSocialUpdateReactionArgs = {
  input: SocialUpdateReactionInput;
};


/** The root mutation type */
export type MutationSocialDeleteReactionArgs = {
  input: SocialDeleteReactionInput;
};


/** The root mutation type */
export type MutationSocialCreateCommentArgs = {
  input: SocialCreateCommentInput;
};


/** The root mutation type */
export type MutationSocialUpdateCommentArgs = {
  input: SocialUpdateCommentInput;
};


/** The root mutation type */
export type MutationSocialDeleteCommentArgs = {
  input: SocialDeleteCommentInput;
};


/** The root mutation type */
export type MutationSocialDeleteCommentMentionsArgs = {
  input: SocialDeleteCommentMentionsInput;
};


/** The root mutation type */
export type MutationDiscoLoggingArgs = {
  input: DiscoLoggingInput;
};


/** The root mutation type */
export type MutationDiscoDeleteActivityArgs = {
  input: DiscoDeleteActivityInput;
};


/** The root mutation type */
export type MutationPostModuleSettingsArgs = {
  input: ModuleSettingsInput;
};


/** The root mutation type */
export type MutationPostSalaryInsightsArgs = {
  input: SalaryInsightsInput;
};


/** The root mutation type */
export type MutationPostBlacklistedSkillsArgs = {
  input: BlacklistedSkillsInput;
};


/** The root mutation type */
export type MutationJobWishesIdealEmployersArgs = {
  input: UpdateJobWishesIdealEmployersInput;
};


/** The root mutation type */
export type MutationJobWishesPreferenceArgs = {
  input: PreferencesJobWishesInput;
};


/** The root mutation type */
export type MutationPreferenceSettingsBlockedCompaniesArgs = {
  input: UpdatePreferencesSettingsBlockedCompaniesInput;
};


/** The root mutation type */
export type MutationPreferenceSettingsArgs = {
  input: PreferencesSettingsInput;
};


/** The root mutation type */
export type MutationMoveonCompanyRecommendationsFeedbackInputArgs = {
  input: MoveonCompanyRecommendationsFeedbackInput;
};


/** The root mutation type */
export type MutationMoveonCreateAssessmentInputArgs = {
  input: MoveonCreateAssessmentInput;
};


/** The root mutation type */
export type MutationUpdateResourceUserArgs = {
  input: TeamPermissionsUpdateResourceUserInput;
};


/** The root mutation type */
export type MutationDeleteResourceUserArgs = {
  input: TeamPermissionsDeleteResourceUserInput;
};


/** The root mutation type */
export type MutationEcommOrderArgs = {
  input: EcommOrderMutationInput;
};


/** The root mutation type */
export type MutationEcommCompanyDetailsArgs = {
  input: EcommCompanyDetailsMutationInput;
};


/** The root mutation type */
export type MutationEcommContactDetailsArgs = {
  input: EcommContactDetailsMutationInput;
};


/** The root mutation type */
export type MutationPostingsCreatePostingArgs = {
  input: PostingsCreatePostingInput;
};


/** The root mutation type */
export type MutationPostingsPublishPostingArgs = {
  input: PostingsPublishPostingInput;
};


/** The root mutation type */
export type MutationPostingsHidePostingArgs = {
  input: PostingsToggleHiddenPostingInput;
};


/** The root mutation type */
export type MutationPostingsUnhidePostingArgs = {
  input: PostingsToggleHiddenPostingInput;
};


/** The root mutation type */
export type MutationPostingsUpdatePostingArgs = {
  input: PostingsUpdatePostingInput;
};


/** The root mutation type */
export type MutationPostingsDeletePostingArgs = {
  input: PostingsDeletePostingInput;
};


/** The root mutation type */
export type MutationPostingsDeleteMyMentionsArgs = {
  input: PostingsDeleteMyMentionsInput;
};


/** The root mutation type */
export type MutationPostingsVoteForPollOptionArgs = {
  input: PostingsVoteForPollOptionInput;
};


/** The root mutation type */
export type MutationPostingsCreateStoryArgs = {
  input: PostingsCreateStoryInput;
};


/** The root mutation type */
export type MutationPostingsDeleteStoryArgs = {
  input: PostingsDeleteStoryInput;
};


/** The root mutation type */
export type MutationPostingsCreateStoryGroupArgs = {
  input: PostingsCreateStoryGroupInput;
};


/** The root mutation type */
export type MutationPostingsPopulateStoryGroupArgs = {
  input: PostingsPopulateStoryGroupInput;
};


/** The root mutation type */
export type MutationPostingsPinActivityArgs = {
  input: PostingsPinActivityInput;
};


/** The root mutation type */
export type MutationPostingsUnpinActivityArgs = {
  input: PostingsUnpinActivityInput;
};


/** The root mutation type */
export type MutationPostingsPinActivityByTargetArgs = {
  input: PostingsPinActivityByTargetInput;
};


/** The root mutation type */
export type MutationPostingsUnpinActivityByTargetArgs = {
  input: PostingsUnpinActivityByTargetInput;
};


/** The root mutation type */
export type MutationPostingsUpdateLinkShareArgs = {
  input: PostingsUpdateLinkShareInput;
};


/** The root mutation type */
export type MutationPostingsCreateVideoArgs = {
  input: PostingsVideoCreateInput;
};


/** The root mutation type */
export type MutationPostingsCreateRssImporterArgs = {
  input: PostingsCreateRssImporterInput;
};


/** The root mutation type */
export type MutationPostingsCreateTwitterImporterArgs = {
  input: PostingsCreateTwitterImporterInput;
};


/** The root mutation type */
export type MutationPostingsDeleteRssImporterArgs = {
  input?: Maybe<PostingsDeleteImporterInput>;
};


/** The root mutation type */
export type MutationPostingsDeleteTwitterImporterArgs = {
  input?: Maybe<PostingsDeleteImporterInput>;
};


/** The root mutation type */
export type MutationEntityPageUpdateLogoArgs = {
  input: EntityPageUpdateLogoMutationInput;
};


/** The root mutation type */
export type MutationEntityPageModuleUpdateConfigurationArgs = {
  input: EntityPageModuleConfigInput;
};


/** The root mutation type */
export type MutationEntityPageUpdateConfigurationArgs = {
  input: EntityPageConfigInput;
};


/** The root mutation type */
export type MutationEntityPageUpdatePublicationStatusArgs = {
  input: EntityPagePublicationStatusInput;
};


/** The root mutation type */
export type MutationEntityPageFollowArgs = {
  input: EntityPageFollowersMutationInput;
};


/** The root mutation type */
export type MutationEntityPageUnfollowArgs = {
  input: EntityPageFollowersMutationInput;
};


/** The root mutation type */
export type MutationEntityPageDeleteArgs = {
  input: EntityPageDeleteInput;
};


/** The root mutation type */
export type MutationEntityPageHardDeleteArgs = {
  input: EntityPageDeleteInput;
};


/** The root mutation type */
export type MutationEntityPageCreateContactUserArgs = {
  input: EntityPageCreateContactUserInput;
};


/** The root mutation type */
export type MutationEntityPageUpdateContactUserArgs = {
  input: EntityPageUpdateContactUserInput;
};


/** The root mutation type */
export type MutationEntityPageUpdateContactUsersCatalogueArgs = {
  input: EntityPageUpdateContactUsersCatalogueMutationInput;
};


/** The root mutation type */
export type MutationEntityPageDeleteContactUserArgs = {
  input: EntityPageDeleteContactUserMutationInput;
};


/** The root mutation type */
export type MutationEntityPageTrackVisitorArgs = {
  input: EntityPageTrackVisitorMutationInput;
};


/** The root mutation type */
export type MutationEntityPageUpdateAboutContentArgs = {
  input: EntityPageAboutContentMutationInput;
};


/** The root mutation type */
export type MutationEntityPageCreateMediaArgs = {
  input: EntityPageCreateMediaMutationInput;
};


/** The root mutation type */
export type MutationEntityPageCreateVideoMediaArgs = {
  input: EntityPageCreateVideoMediaMutationInput;
};


/** The root mutation type */
export type MutationEntityPageUpdateMediaArgs = {
  input: EntityPageUpdateMediaMutationInput;
};


/** The root mutation type */
export type MutationEntityPageUpdateVideoMediaArgs = {
  input: EntityPageUpdateVideoMediaMutationInput;
};


/** The root mutation type */
export type MutationEntityPageUpdateMediaGalleryArgs = {
  input: EntityPageUpdateMediaGalleryMutationInput;
};


/** The root mutation type */
export type MutationEntityPageDeleteMediaArgs = {
  input: EntityPageDeleteMediaMutationInput;
};


/** The root mutation type */
export type MutationEntityPageCreateDocumentArgs = {
  input: EntityPageCreateDocumentMutationInput;
};


/** The root mutation type */
export type MutationEntityPageUpdateDocumentArgs = {
  input: EntityPageUpdateDocumentMutationInput;
};


/** The root mutation type */
export type MutationEntityPageDeleteDocumentArgs = {
  input: EntityPageDeleteDocumentMutationInput;
};


/** The root mutation type */
export type MutationEntityPageCreateLocationArgs = {
  input: EntityPageCreateLocationInput;
};


/** The root mutation type */
export type MutationEntityPageUpdateLocationArgs = {
  input: EntityPageUpdateLocationInput;
};


/** The root mutation type */
export type MutationEntityPageDeleteLocationArgs = {
  input: EntityPageDeleteLocationMutationInput;
};


/** The root mutation type */
export type MutationEntityPageUpdateCoverArgs = {
  input: EntityPageUpdateCoverMutationInput;
};


/** The root mutation type */
export type MutationEntityPageDeleteCoverArgs = {
  input: EntityPageDeleteCoverMutationInput;
};


/** The root mutation type */
export type MutationCreatePayBilClientArgs = {
  input: PayBilClientMutationInput;
};


/** The root mutation type */
export type MutationUpdatePayBilClientArgs = {
  input: PayBilClientMutationInput;
};


/** The root mutation type */
export type MutationUpdateClientBillingAddressArgs = {
  input: ClientBillingAddressInput;
  productGroup: PaymentClientProductGroup;
};


/** The root mutation type */
export type MutationUpdateBpayPaymentMethodArgs = {
  input: BpayPaymentMethodInput;
};


/** The root mutation type */
export type MutationCompanyCreateAffiliatesArgs = {
  input: CompanyCreateAffiliatesInput;
};


/** The root mutation type */
export type MutationCompanyDeleteFeedArgs = {
  input: CompanyDeleteFeedInput;
};


/** The root mutation type */
export type MutationCompanyCreateFeedArgs = {
  input: CompanyCreateFeedInput;
};


/** The root mutation type */
export type MutationCompanyPageCreateArgs = {
  input: CompanyPageCreateInput;
};


/** The root mutation type */
export type MutationCompanyFollowArgs = {
  input: EntityPageFollowersMutationInput;
};


/** The root mutation type */
export type MutationCompanyUnfollowArgs = {
  input: EntityPageFollowersMutationInput;
};


/** The root mutation type */
export type MutationDismissCompanyAutoMigrationNotificationArgs = {
  input: DismissCompanyAutoNotificationInput;
};


/** The root mutation type */
export type MutationDeleteCompanyRecommendationArgs = {
  input: DeleteCompanyRecommendationInput;
};


/** The root mutation type */
export type MutationCompanyUpdatesDeleteArgs = {
  input: CompanyUpdatesDeleteInput;
};


/** The root mutation type */
export type MutationCompanyUpdateInformationArgs = {
  input: CompanyUpdateInformationInput;
};


/** The root mutation type */
export type MutationVideoTrackingArgs = {
  input: VideoTrackingEventInput;
};


/** The root mutation type */
export type MutationVideoCreateArgs = {
  input: VideoCreationInput;
};


/** The root mutation type */
export type MutationVideoUpdateArgs = {
  input: VideoUpdateInput;
};


/** The root mutation type */
export type MutationVideoDeleteArgs = {
  input: VideoDeletionInput;
};


/** The root mutation type */
export type MutationVideoCustomThumbnailCreateArgs = {
  input: VideoCustomThumbnailCreationInput;
};


/** The root mutation type */
export type MutationVideoCustomThumbnailUpdateArgs = {
  input: VideoCustomThumbnailUpdateInput;
};


/** The root mutation type */
export type MutationVideoCustomThumbnailDeleteArgs = {
  input: VideoCustomThumbnailDeletionInput;
};


/** The root mutation type */
export type MutationVideoSubtitleCreateArgs = {
  input: VideoSubtitleCreationInput;
};


/** The root mutation type */
export type MutationVideoSubtitleUpdateArgs = {
  input: VideoSubtitleUpdateInput;
};


/** The root mutation type */
export type MutationVideoSubtitleDeleteArgs = {
  input: VideoSubtitleDeletionInput;
};


/** The root mutation type */
export type MutationVideoResourceCreateArgs = {
  input: VideoResourceCreationInput;
};


/** The root mutation type */
export type MutationVideoImageAttachmentCreateArgs = {
  input: VideoImageAttachmentCreationInput;
};


/** The root mutation type */
export type MutationVideoStartEncodingArgs = {
  input: VideoStartEncodingInput;
};


/** The root mutation type */
export type MutationSubmitReviewArgs = {
  input?: Maybe<SubmitReviewInput>;
};


/** The root mutation type */
export type MutationConfirmEmailReportArgs = {
  input: ConfirmEmailReportInput;
};


/** The root mutation type */
export type MutationCompleteComplaintReportArgs = {
  input: ComplaintsReportInput;
};


/** The root mutation type */
export type MutationRevertComplaintReportArgs = {
  input: ComplaintsReportInput;
};


/** The root mutation type */
export type MutationComplaintsCreateContentReportArgs = {
  input: ComplaintsCreateContentReportInput;
};


/** The root mutation type */
export type MutationComplaintsCreateProfileReportArgs = {
  input: ComplaintsCreateProfileReportInput;
};


/** The root mutation type */
export type MutationUpdateReportArgs = {
  input?: Maybe<UpdateReportInput>;
};


/** The root mutation type */
export type MutationPremiumPartnerCreateCodeArgs = {
  input: PremiumPartnerCreateCodeMutationInput;
};


/** The root mutation type */
export type MutationRedeemVoucherArgs = {
  input: VoucherRedeemMutationInput;
};


/** The root mutation type */
export type MutationRedeemSpecialVoucherArgs = {
  input: VoucherRedeemMutationInput;
};


/** The root mutation type */
export type MutationProfileVisitArgs = {
  input?: Maybe<ProfileVisitInput>;
};


/** The root mutation type */
export type MutationVisitsViewArgs = {
  input: VisitsViewInput;
};


/** The root mutation type */
export type MutationExternalProfileVisitArgs = {
  input: ExternalVompInput;
};


/** The root mutation type */
export type MutationInternalProfileVisitArgs = {
  input: InternalVompInput;
};


/** The root mutation type */
export type MutationContentServiceCreateContentArgs = {
  input: ContentServiceCreateContentInput;
};


/** The root mutation type */
export type MutationContentServiceUpdateContentArgs = {
  input: ContentServiceUpdateContentInput;
};


/** The root mutation type */
export type MutationNotificationMarkAsOpenedArgs = {
  input: NotificationMarkAsOpenedInput;
};


/** The root mutation type */
export type MutationProbusinessCreateLeadArgs = {
  input: ProbusinessCreateLeadInput;
};


/** The root mutation type */
export type MutationProbusinessDeleteLeadArgs = {
  input?: Maybe<ProbusinessDeleteLeadInput>;
};


/** The root mutation type */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type */
export type MutationCreateVitaDocumentArgs = {
  input: CreateVitaDocumentInput;
};


/** The root mutation type */
export type MutationRequestVitaDocumentTokenRenderingArgs = {
  input: RequestVitaDocumentRenderingInput;
};


/** The root mutation type */
export type MutationGenerateVitaAboutMeSuggestionArgs = {
  input: CreateVitaDocumentInput;
};


/** The root mutation type */
export type MutationCreateDocumentFromProfileImportArgs = {
  input: CreateVitaProfileImportInput;
};


/** The root mutation type */
export type MutationCreateVitaCoverLetterArgs = {
  input: CreateVitaCoverLetterInput;
};


/** The root mutation type */
export type MutationRequestVitaCoverLetterRenderingArgs = {
  input: RequestVitaCoverLetterRenderingInput;
};


/** The root mutation type */
export type MutationGenerateVitaCoverLetterSuggestionArgs = {
  input: CreateVitaCoverLetterInput;
};


/** The root mutation type */
export type MutationTriggerVitaCoverLetterSuggestionArgs = {
  input: CreateVitaCoverLetterInput;
};


/** The root mutation type */
export type MutationDeleteErecruitingSourcingServicemessageReminderArgs = {
  input?: Maybe<ErecruitingSourcingServiceDeleteMessageReminderInput>;
};


/** The root mutation type */
export type MutationCreateErecruitingSourcingServiceCandidateNoteArgs = {
  input?: Maybe<ErecruitingSourcingServiceCreateCandidateNoteInput>;
};


/** The root mutation type */
export type MutationCreateErecruitingSourcingServiceClientCandidateNoteArgs = {
  input?: Maybe<ErecruitingSourcingServiceCreateClientCandidateNoteInput>;
};


/** The root mutation type */
export type MutationUpdateErecruitingSourcingServiceCandidateNoteArgs = {
  input?: Maybe<ErecruitingSourcingServiceUpdateCandidateNoteInput>;
};


/** The root mutation type */
export type MutationUpdateErecruitingSourcingServiceClientCandidateNoteArgs = {
  input?: Maybe<ErecruitingSourcingServiceUpdateClientCandidateNoteInput>;
};


/** The root mutation type */
export type MutationUpdateErecruitingSourcingServiceMessageRemindersMetadataArgs = {
  input?: Maybe<ErecruitingSourcingServiceUpdateMessageReminderMetadataInput>;
};


/** The root mutation type */
export type MutationDiscardErecruitingSourcingServiceCandidateRecommendationArgs = {
  input?: Maybe<ErecruitingSourcingServiceCandidateRecommendationsDiscardInput>;
};


/** The root mutation type */
export type MutationUpdateErecruitingSourcingServiceBriefingMetadataArgs = {
  input?: Maybe<ErecruitingSourcingServiceBriefingMetadataInput>;
};


/** The root mutation type */
export type MutationCreateErecruitingSourcingServiceBriefingReportArgs = {
  input?: Maybe<ErecruitingSourcingServiceCreateBriefingReportInput>;
};


/** The root mutation type */
export type MutationCreateErecruitingSourcingServiceBriefingArgs = {
  input?: Maybe<ErecruitingSourcingServiceCreateBriefingInput>;
};


/** The root mutation type */
export type MutationShareErecruitingSourcingServiceBriefingArgs = {
  input?: Maybe<ErecruitingSourcingServiceShareBriefingInput>;
};


/** The root mutation type */
export type MutationUpdateErecruitingSourcingServiceBriefingArchiveStatusArgs = {
  input?: Maybe<ErecruitingSourcingServiceArchiveStatusInput>;
};


/** The root mutation type */
export type MutationChangeErecruitingSourcingServiceBriefingOwnerArgs = {
  input?: Maybe<ErecruitingSourcingServiceChangeBriefingOwnerInput>;
};


/** The root mutation type */
export type MutationCreateErecruitingSourcingServiceBriefingCandidateArgs = {
  input?: Maybe<ErecruitingSourcingServiceCreateBriefingCandidateInput>;
};


/** The root mutation type */
export type MutationDeleteErecruitingSourcingServiceBriefingCandidateArgs = {
  input?: Maybe<ErecruitingSourcingServiceDeleteBriefingCandidateInput>;
};


/** The root mutation type */
export type MutationErecruitingSourcingServiceUpdateBriefingCandidateArgs = {
  input?: Maybe<ErecruitingSourcingServiceUpdateBriefingCandidateStatusInput>;
};


/** The root mutation type */
export type MutationTriggerJobsEasyCreateGenerateJobWithAiArgs = {
  input: TriggerJobsEasyCreateAiJobGenerationInput;
};


/** The root mutation type */
export type MutationJobsEasyCreateJobsDraftArgs = {
  input: JobsEasyCreateJobsDraftInput;
};


/** The root mutation type */
export type MutationTriggerJobsEasyCreateInstantActivationArgs = {
  input: TriggerJobsEasyCreateEcomPurchaseInput;
};


/** The root mutation type */
export type MutationCreatePaymentsB2bClientIdArgs = {
  input: CreatePaymentsB2bClientIdInput;
};


/** The root mutation type */
export type MutationUpdatePaymentsB2bClientIdArgs = {
  input: UpdatePaymentsB2bClientIdInput;
};


/** The root mutation type */
export type MutationJobsEasyCreateDirectPublishTriggerArgs = {
  input: JobsEasyCreateDirectPublishTriggerInput;
};


/** The root mutation type */
export type MutationUpdateNotificationSettingsArgs = {
  input: NotificationSettingsCollectionInput;
};


/** The root mutation type */
export type MutationUpdateActivitiesSettingsArgs = {
  input: ActivitiesSettingsInput;
};


/** The root mutation type */
export type MutationUpdatePremiumSwitchSettingsArgs = {
  input: PremiumSwitchSettingsInput;
};


/** The root mutation type */
export type MutationUpdateAccountSettingsArgs = {
  input: AccountSettingsInput;
};


/** The root mutation type */
export type MutationUpdateLoginSettingsArgs = {
  input: LoginSettingsInput;
};


/** The root mutation type */
export type MutationUpdateAccountDeactivationSettingsArgs = {
  input: AccountDeactivationSettingsInput;
};


/** The root mutation type */
export type MutationUpdateAccountDeletionSettingsArgs = {
  input: AccountDeletionSettingsInput;
};


/** The root mutation type */
export type MutationUpdateProfileSettingsArgs = {
  input: ProfileSettingsInput;
};


/** The root mutation type */
export type MutationDeleteLoginSessionArgs = {
  input: DeleteLoginSessionInput;
};


/** The root mutation type */
export type MutationDeleteXwsSessionArgs = {
  input: DeleteXwsSessionInput;
};


/** The root mutation type */
export type MutationStartUserDataInquiryArgs = {
  input: UserDataInquiryInput;
};


/** The root mutation type */
export type MutationUserDataInquiryTemporaryDownloadUrlArgs = {
  input: UserDataInquiryInput;
};


/** The root mutation type */
export type MutationUpdateMessengerSettingsArgs = {
  input: MessengerSettingsInput;
};


/** The root mutation type */
export type MutationUpdateCoreSettingsArgs = {
  input: CoreSettingsInput;
};


/** The root mutation type */
export type MutationUpdateNetworkSettingsArgs = {
  input: NetworkSettingsInput;
};


/** The root mutation type */
export type MutationUpdateProfilesLoggedoutSettingsArgs = {
  input: ProfilesLoggedoutSettingsInput;
};


/** The root mutation type */
export type MutationCreatePasswordProtectedSettingTokenArgs = {
  input: PasswordProtectedSettingTokenInput;
};


/** The root mutation type */
export type MutationUpdateTwoFaSettingsArgs = {
  input: TwoFaSettingsUpdateInput;
};


/** The root mutation type */
export type MutationActivateTwoFaSettingsArgs = {
  input: TwoFaSettingsActivationInput;
};


/** The root mutation type */
export type MutationRegenerateBackupCodeTwoFaSettingsArgs = {
  input: TwoFaSettingsBackupCodeRegenerationInput;
};


/** The root mutation type */
export type MutationUpdateSocialSettingsArgs = {
  input: SocialSettingsInput;
};


/** The root mutation type */
export type MutationBannerPropertyDisableArgs = {
  input: BannerPropertyDisableInput;
};


/** The root mutation type */
export type MutationSignalsStackMarkSeenArgs = {
  input: SignalsStackMarkSeenInput;
};


/** The root mutation type */
export type MutationSignalMarkInteractedArgs = {
  input: SignalMarkInteractedInput;
};


/** The root mutation type */
export type MutationSignalDeleteArgs = {
  input: SignalDeleteInput;
};


/** The root mutation type */
export type MutationMymkDeclineRecommendationArgs = {
  recommendationId?: Maybe<Scalars['ID']>;
};


/** The root mutation type */
export type MutationMeetingRoomAddAttendeeArgs = {
  input: MeetingRoomAddAttendeeInput;
};


/** The root mutation type */
export type MutationEmployersPreferenceArgs = {
  input: UpdateEmployersPreferenceInput;
};


/** The root mutation type */
export type MutationIndustriesPreferenceArgs = {
  input: UpdateIndustriesPreferenceInput;
};


/** The root mutation type */
export type MutationDisciplinesPreferenceArgs = {
  input: UpdateDisciplinesPreferenceInput;
};


/** The root mutation type */
export type MutationSalaryExpectationsPreferenceArgs = {
  input: UpdateSalaryExpectationsPreferenceInput;
};


/** The root mutation type */
export type MutationBlockedCompaniesArgs = {
  input: UpdateBlockedCompaniesInput;
};


/** The root mutation type */
export type MutationJobPreferenceUserFlagsArgs = {
  input: UpdateJobPreferenceUserFlagsInput;
};


/** The root mutation type */
export type MutationCareerLevelPreferenceArgs = {
  input: UpdateCareerLevelPreferenceInput;
};


/** The root mutation type */
export type MutationWorkplacePreferenceArgs = {
  input: UpdateWorkplacePreferenceInput;
};


/** The root mutation type */
export type MutationLocationsPreferenceArgs = {
  input: UpdateLocationsPreferenceInput;
};


/** The root mutation type */
export type MutationWorkingHoursPreferenceArgs = {
  input: UpdateWorkingHoursPreferenceInput;
};


/** The root mutation type */
export type MutationJobTitlesTargetPositionsArgs = {
  input: UpdateJobTitlesTargetPositionsPreferenceInput;
};


/** The root mutation type */
export type MutationJobTitlesUnpreferredPositionsArgs = {
  input: UpdateJobTitlesUnpreferredPositionsPreferenceInput;
};


/** The root mutation type */
export type MutationJobPreferencesJobSeekerStatusArgs = {
  input: UpdateJobPreferencesJobSeekerStatusInput;
};


/** The root mutation type */
export type MutationParseMessageTemplateArgs = {
  input: ParseMessageInput;
};


/** The root mutation type */
export type MutationXtmProjectCreateUpdateCampaignArgs = {
  input?: Maybe<XtmProjectCreateUpdateCampaignInput>;
};


/** The root mutation type */
export type MutationXtmProjectSendCampaignArgs = {
  input?: Maybe<XtmProjectSendCampaignInput>;
};


/** The root mutation type */
export type MutationXtmProjectCampaignLimitationsArgs = {
  input?: Maybe<XtmProjectCampaignLimitationsInput>;
};


/** The root mutation type */
export type MutationUpdateXtmProjectArgs = {
  input?: Maybe<XtmUpdateProjectInput>;
};


/** The root mutation type */
export type MutationNetworkContactsDeleteArgs = {
  input: ContactsDeleteInput;
};


/** The root mutation type */
export type MutationNetworkCreateTagArgs = {
  input: NetworkCreateTagInput;
};


/** The root mutation type */
export type MutationNetworkDeleteTagArgs = {
  input: NetworkDeleteTagInput;
};


/** The root mutation type */
export type MutationNetworkAssignTagArgs = {
  input: NetworkTaggingInput;
};


/** The root mutation type */
export type MutationNetworkUnassignTagArgs = {
  input: NetworkTaggingInput;
};


/** The root mutation type */
export type MutationNetworkUserProximityIdSetArgs = {
  input: NetworkUserProximityIdSetInput;
};


/** The root mutation type */
export type MutationUpdateDataSharingSettingsArgs = {
  input: DataSharingSettingsInput;
};


/** The root mutation type */
export type MutationAddDataSharingExclusionArgs = {
  input: DataSharingExclusionInput;
};


/** The root mutation type */
export type MutationDeleteDataSharingExclusionArgs = {
  input: DataSharingExclusionInput;
};


/** The root mutation type */
export type MutationNetworkSetNoteArgs = {
  input: NoteInputType;
};


/** The root mutation type */
export type MutationNetworkClientSettingSetArgs = {
  input: NetworkClientSettingsInput;
};


/** The root mutation type */
export type MutationNetworkContactRequestsDeclineArgs = {
  input: ContactRequestsDeclineInput;
};


/** The root mutation type */
export type MutationNetworkContactRequestsRevokeArgs = {
  input: ContactRequestsRevokeInput;
};


/** The root mutation type */
export type MutationNetworkContactRequestsConfirmArgs = {
  input: ContactRequestsConfirmInput;
};


/** The root mutation type */
export type MutationNetworkContactRequestsTokenConfirmArgs = {
  input: ContactRequestsTokenConfirmInput;
};


/** The root mutation type */
export type MutationNetworkContactRequestsSendArgs = {
  input: ContactRequestsSendInput;
};


/** The root mutation type */
export type MutationNetworkContactRequestsSendMultipleArgs = {
  input: ContactRequestsSendMultipleInput;
};


/** The root mutation type */
export type MutationNetworkContactRequestsMarkSeenArgs = {
  input: ContactRequestsMarkSeenInput;
};


/** The root mutation type */
export type MutationNetworkContactRequestsSpamReportArgs = {
  input: ContactRequestsSpamReportInput;
};


/** The root mutation type */
export type MutationCreatePaymentAccountArgs = {
  input?: Maybe<PaymentAccountInput>;
};


/** The root mutation type */
export type MutationUpdatePaymentAccountArgs = {
  input?: Maybe<PaymentAccountInput>;
};


/** The root mutation type */
export type MutationUpdatePaymentMethodArgs = {
  input?: Maybe<PaymentAccountInput>;
};


/** The root mutation type */
export type MutationRegenerateInvoicesArgs = {
  input: RegenerateInvoicesInput;
};


/** The root mutation type */
export type MutationMarkAsSeenArgs = {
  input?: Maybe<MarkAsSeenInput>;
};


/** The root mutation type */
export type MutationUpdateB2BProfileSettingsArgs = {
  input?: Maybe<B2BProfileSettingsInput>;
};


/** The root mutation type */
export type MutationJobRecoDeclineRecommendationArgs = {
  recommendationId?: Maybe<Scalars['ID']>;
};


/** The root mutation type */
export type MutationUpdateJobRecoFeedbackArgs = {
  input: JobRecoFeedbackInput;
};


/** The root mutation type */
export type MutationOnboardingUpdateJourneyArgs = {
  input?: Maybe<OnboardingJourneyMetadataInput>;
};


/** The root mutation type */
export type MutationOnboardingDeveloperUpdateJourneyArgs = {
  input: OnboardingDeveloperJourneyInput;
};


/** The root mutation type */
export type MutationContactSupportArgs = {
  input?: Maybe<Contact>;
};


/** The root mutation type */
export type MutationBlockingServiceBlockArgs = {
  input: BlockingServiceBlockInput;
};


/** The root mutation type */
export type MutationBlockingServiceUnblockArgs = {
  input: BlockingServiceUnblockInput;
};


/** The root mutation type */
export type MutationFollowersFollowArgs = {
  input: FollowersMutationInput;
};


/** The root mutation type */
export type MutationFollowersUnfollowArgs = {
  input: FollowersMutationInput;
};


/** The root mutation type */
export type MutationProJobsMarkAsIdealEmployerArgs = {
  input?: Maybe<ProJobsIdealEmployerMutationInput>;
};


/** The root mutation type */
export type MutationProJobsUnmarkAsIdealEmployerArgs = {
  input?: Maybe<ProJobsIdealEmployerMutationInput>;
};


/** The root mutation type */
export type MutationJobSeekerGuidanceUpdateActionArgs = {
  input: JobSeekerGuidanceUpdateActionInput;
};


/** The root mutation type */
export type MutationProjobsSalaryExpectationArgs = {
  input: ProjobsSalaryExpectationInput;
};


/** The root mutation type */
export type MutationProjobsWorkingHoursArgs = {
  input: ProjobsWorkingHoursInput;
};


/** The root mutation type */
export type MutationProjobsSettingSeekingStatusArgs = {
  input: ProjobsSeekingStatusInput;
};


/** The root mutation type */
export type MutationProjobsAddBlockedCompaniesArgs = {
  input: ProjobsAddBlockedCompaniesInput;
};


/** The root mutation type */
export type MutationProjobsAddBlocklistUserArgs = {
  input: ProjobsAddBlocklistUserInput;
};


/** The root mutation type */
export type MutationProjobsDisciplineArgs = {
  input: ProjobsDisciplineInput;
};


/** The root mutation type */
export type MutationProjobsAddAllowlistUserArgs = {
  input: ProjobsAddAllowlistUserInput;
};


/** The root mutation type */
export type MutationProjobsRemoveAllowlistUserArgs = {
  input: ProjobsRemoveAllowlistUserInput;
};


/** The root mutation type */
export type MutationProjobsAvoidArgs = {
  input: ProjobsAvoidInput;
};


/** The root mutation type */
export type MutationProjobsUpdateContactOptionsArgs = {
  input: ProjobsContactOptionsInput;
};


/** The root mutation type */
export type MutationProjobsDeleteDocumentArgs = {
  input: ProjobsDeleteDocumentInput;
};


/** The root mutation type */
export type MutationProjobsWillingnessToTravelArgs = {
  input: ProjobsWillingnessToTravelInput;
};


/** The root mutation type */
export type MutationProjobsPositionsArgs = {
  input: ProjobsPositionsInput;
};


/** The root mutation type */
export type MutationProjobsIndustriesArgs = {
  input: ProjobsIndustriesInput;
};


/** The root mutation type */
export type MutationProjobsRemoveBlockedCompanyArgs = {
  input: ProjobsRemoveBlockedCompanyInput;
};


/** The root mutation type */
export type MutationProjobsUploadDocumentArgs = {
  input: ProjobsUploadDocumentInput;
};


/** The root mutation type */
export type MutationProjobsUpdateDocumentArgs = {
  input: ProjobsUpdateDocumentInput;
};


/** The root mutation type */
export type MutationProjobsRemoveBlocklistUserArgs = {
  input: ProjobsRemoveBlocklistUserInput;
};


/** The root mutation type */
export type MutationProjobsCitiesArgs = {
  input: ProjobsCitiesInput;
};


/** The root mutation type */
export type MutationProjobsSettingVisibilityArgs = {
  input: ProjobsVisibilityInput;
};


/** The root mutation type */
export type MutationProjobsAddIdealEmployersArgs = {
  input: ProjobsAddIdealEmployersInput;
};


/** The root mutation type */
export type MutationNetworkBlockedUsersBlockArgs = {
  input: NetworkBlockedUsersBlockInput;
};


/** The root mutation type */
export type MutationNetworkBlockedUsersUnblockArgs = {
  input: NetworkBlockedUsersUnblockInput;
};


/** The root mutation type */
export type MutationAdsTrackClickArgs = {
  input: AdsTrackingInput;
};


/** The root mutation type */
export type MutationAdsTrackImpressionArgs = {
  input: AdsTrackingInput;
};


/** The root mutation type */
export type MutationLeadAdFormSubmissionCreateArgs = {
  input: LeadAdFormSubmissionCreateInput;
};


/** The root mutation type */
export type MutationTrackAdClickByIntIdArgs = {
  input: AdsTrackingIntIdInput;
};


/** The root mutation type */
export type MutationTrackAdImpressionByIntIdArgs = {
  input: AdsTrackingIntIdInput;
};


/** The root mutation type */
export type MutationAdNegativeFeedbackCreateArgs = {
  input: AdNegativeFeedbackInput;
};


/** The root mutation type */
export type MutationUpdateMessengerBannerArgs = {
  input: UpdateMessengerBannerInput;
};


/** The root mutation type */
export type MutationMessengerUploadRequestArgs = {
  input: MessengerUploadRequestInput;
};


/** The root mutation type */
export type MutationDeleteScheduledMessageArgs = {
  input: DeleteScheduledMessageInput;
};


/** The root mutation type */
export type MutationCreateMessengerMessageArgs = {
  message: CreateMessengerMessageInput;
};


/** The root mutation type */
export type MutationCreateMessengerImageMessageArgs = {
  message: CreateMessengerImageMessageInput;
};


/** The root mutation type */
export type MutationCreateMessengerAttachmentMessageArgs = {
  message: CreateMessengerAttachmentMessageInput;
};


/** The root mutation type */
export type MutationCreateMessengerSystemReplyMessageArgs = {
  message: CreateMessengerSystemReplyMessageInput;
};


/** The root mutation type */
export type MutationCreateMessengerUserReplyMessageArgs = {
  message: CreateMessengerUserReplyMessageInput;
};


/** The root mutation type */
export type MutationCreateMessengerChatArgs = {
  chat: CreateMessengerChat;
};


/** The root mutation type */
export type MutationCreateMessengerChatBySlugOrIdArgs = {
  chat: CreateMessengerChatBySlugOrId;
};


/** The root mutation type */
export type MutationMarkAsReadMessengerChatArgs = {
  input: MarkAsReadMessengerChatInput;
};


/** The root mutation type */
export type MutationDeleteMessengerChatArgs = {
  input: DeleteMessengerChatInput;
};


/** The root mutation type */
export type MutationMarkAsUnreadMessengerChatArgs = {
  input: MarkAsUnreadMessengerChatInput;
};


/** The root mutation type */
export type MutationAddMessengerChatParticipantsArgs = {
  input: AddMessengerChatParticipantsInput;
};


/** The root mutation type */
export type MutationDeleteMessengerChatParticipantArgs = {
  input: DeleteMessengerChatParticipantInput;
};


/** The root mutation type */
export type MutationCreateMessengerMessageTemplateArgs = {
  input: CreateMessengerMessageTemplateInput;
};


/** The root mutation type */
export type MutationUpdateMessengerMessageTemplateArgs = {
  input: UpdateMessengerMessageTemplateInput;
};


/** The root mutation type */
export type MutationDeleteMessengerMessageTemplateArgs = {
  input: DeleteMessengerMessageTemplateInput;
};


/** The root mutation type */
export type MutationMessengerExecuteOneClickActionArgs = {
  input: MessengerExecuteOneClickActionInput;
};


/** The root mutation type */
export type MutationFeatureSwitchesExperimentsForceVariantArgs = {
  input: FeatureSwitchesExperimentsForceVariantInput;
};


/** The root mutation type */
export type MutationLlmGatewayInteractionTrackingArgs = {
  input?: Maybe<LlmGatewayInteractionTrackingInput>;
};


/** The root mutation type */
export type MutationSeatManagerCreateAssignmentArgs = {
  input: SeatAssignmentInput;
};


/** The root mutation type */
export type MutationSeatManagerDeleteAssignmentArgs = {
  input: SeatAssignmentInput;
};


/** The root mutation type */
export type MutationContentUpdateEmailSubscriptionArgs = {
  input: ContentUpdateEmailSubscriptionInput;
};


/** The root mutation type */
export type MutationContentCommentCreateArgs = {
  input?: Maybe<ContentCommentCreateInput>;
};


/** The root mutation type */
export type MutationContentCommentHideArgs = {
  input?: Maybe<ContentCommentHideInput>;
};


/** The root mutation type */
export type MutationContentFeatureArticleArgs = {
  input?: Maybe<ContentFeatureArticleInput>;
};


/** The root mutation type */
export type MutationContentUnfeatureArticleArgs = {
  input?: Maybe<ContentUnfeatureArticleInput>;
};


/** The root mutation type */
export type MutationContentDisableArticleArgs = {
  input?: Maybe<ContentDisableArticleInput>;
};


/** The root mutation type */
export type MutationContentEnableArticleArgs = {
  input?: Maybe<ContentEnableArticleInput>;
};


/** The root mutation type */
export type MutationContentDeleteArticleArgs = {
  input?: Maybe<ContentDeleteArticleInput>;
};


/** The root mutation type */
export type MutationContentCancelSubscriptionArgs = {
  id: Scalars['ID'];
};


/** The root mutation type */
export type MutationContentCreateLinkShareImageArgs = {
  input: ContentCreateLinkShareImageInput;
};


/** The root mutation type */
export type MutationContentPublishLinkShareArgs = {
  input?: Maybe<ContentPublishLinkShareInput>;
};


/** The root mutation type */
export type MutationContentUpdateLinkShareArgs = {
  input?: Maybe<ContentUpdateLinkShareInput>;
};


/** The root mutation type */
export type MutationContentCreateLinkShareArgs = {
  input?: Maybe<ContentCreateLinkShareInput>;
};


/** The root mutation type */
export type MutationContentKlartextAgreeArgs = {
  klarticleGlobalId: Scalars['GlobalID'];
};


/** The root mutation type */
export type MutationContentKlartextUnagreeArgs = {
  klarticleGlobalId: Scalars['GlobalID'];
};


/** The root mutation type */
export type MutationContentInsiderPageLastFollowersSeenArgs = {
  input?: Maybe<ContentInsiderPageLastFollowersSeenInput>;
};


/** The root mutation type */
export type MutationContentPageFollowArgs = {
  input?: Maybe<ContentPageFollowInput>;
};


/** The root mutation type */
export type MutationContentPageUnfollowArgs = {
  input?: Maybe<ContentPageUnfollowInput>;
};


/** The root mutation type */
export type MutationContentUpdatePageArgs = {
  input?: Maybe<ContentUpdatePageInput>;
};


/** The root mutation type */
export type MutationContentStarableStarArgs = {
  input?: Maybe<ContentStarInput>;
};


/** The root mutation type */
export type MutationContentStarableUnstarArgs = {
  input?: Maybe<ContentUnstarInput>;
};


/** The root mutation type */
export type MutationContentBookmarkableBookmarkArgs = {
  input?: Maybe<ContentBookmarkInput>;
};


/** The root mutation type */
export type MutationContentBookmarkableUnbookmarkArgs = {
  input?: Maybe<ContentUnbookmarkInput>;
};

/** XING ID Occupations */
export type MyXingIdOccupation = HasDerivedGlobalId & {
  __typename?: 'MyXingIdOccupation';
  id: Scalars['ID'];
  /** Displayable string to represent this Occupation. Plain text */
  summary: Scalars['String'];
  /** Original position in Bucket. 1 is sorted to the top */
  position?: Maybe<Scalars['Int']>;
  /**
   * Original bucket for this occupation. If placed in VISIBLE bucket, this value can be used to sort it back to the correct bucket.
   *
   * Therefore, except when it's placed in VISIBLE bucket, this bucketID will always match its parent Bucket.
   */
  bucketId: XingIdOccupationsBucketType;
  /** URN of the reference */
  referenceUrn?: Maybe<Scalars['GlobalID']>;
  /** Globally unique id for this instance based on typename and id */
  globalId: Scalars['GlobalID'];
};

/** A Bucket of Occupations */
export type MyXingIdOccupationBucket = Localizable & {
  __typename?: 'MyXingIdOccupationBucket';
  id: XingIdOccupationsBucketType;
  /** True if an upsell indicator should be shown */
  isUpsellRequiredForOccupations: Scalars['Boolean'];
  /** Amount of elements which can be added to this bucket. Null equals unlimited elements */
  maxElements?: Maybe<Scalars['Int']>;
  /** List of occupations placed in this bucket */
  occupations: Array<MyXingIdOccupation>;
  /** The raw text resource key from Phraseapp */
  localizationKey: Scalars['String'];
  /** The value localized based on the `Accept-Language` header */
  localizationValue: Scalars['String'];
};

export type MymkBucket = {
  __typename?: 'MymkBucket';
  name: Scalars['String'];
  recommendations: Array<MymkCombinedRecommendation>;
};

export type MymkBucketCollectionsRecommenderConnection = RecommenderResponse & HasCursorPagination & {
  __typename?: 'MymkBucketCollectionsRecommenderConnection';
  buckets?: Maybe<MymkBuckets>;
  edges: Array<MymkCombinedRecommendationEdge>;
  requestTrackingToken: Scalars['String'];
  service: Scalars['String'];
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type MymkBuckets = {
  __typename?: 'MymkBuckets';
  total: Scalars['Int'];
  collection: Array<MymkBucket>;
};

export type MymkCombinedRecommendation = MymkRecommendation | MymkInviteRecommendation;

export type MymkCombinedRecommendationEdge = PaginationEdge & {
  __typename?: 'MymkCombinedRecommendationEdge';
  node: MymkCombinedRecommendation;
  /** #virtual */
  cursor: Scalars['String'];
};

export type MymkCombinedRecommenderConnection = RecommenderResponse & HasCursorPagination & {
  __typename?: 'MymkCombinedRecommenderConnection';
  edges: Array<MymkCombinedRecommendationEdge>;
  requestTrackingToken: Scalars['String'];
  service: Scalars['String'];
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type MymkDeclineRecommendationError = {
  __typename?: 'MymkDeclineRecommendationError';
  /** #soft-logged-in */
  message?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  error?: Maybe<Scalars['String']>;
};

export type MymkDeclineRecommendationResult = {
  __typename?: 'MymkDeclineRecommendationResult';
  /** #soft-logged-in */
  success?: Maybe<MymkDeclineRecommendationSuccess>;
  /** #soft-logged-in */
  error?: Maybe<MymkDeclineRecommendationError>;
};

export type MymkDeclineRecommendationSuccess = {
  __typename?: 'MymkDeclineRecommendationSuccess';
  /** #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type MymkGenderEstimate = {
  __typename?: 'MymkGenderEstimate';
  estimate?: Maybe<Scalars['String']>;
  pMale: Scalars['Float'];
  pFemale: Scalars['Float'];
  support: Scalars['Int'];
};

export type MymkInviteRecommendation = Recommendation & {
  __typename?: 'MymkInviteRecommendation';
  /** #rest(batched) #virtual */
  vCard?: Maybe<VCard>;
  trackingToken: Scalars['String'];
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
};

export type MymkRecommendation = Recommendation & {
  __typename?: 'MymkRecommendation';
  /** #soft-logged-in #rest(batched) #virtual */
  member?: Maybe<XingId>;
  /** #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #soft-logged-in */
  position: Scalars['Int'];
  /** #soft-logged-in */
  itemId: Scalars['ID'];
  /** #soft-logged-in */
  urn: Scalars['URN'];
  /** #soft-logged-in */
  score: Scalars['Float'];
  /** #soft-logged-in */
  reason: Array<Scalars['String']>;
  /** #rest(batched) #virtual */
  sharedContactsWeb?: Maybe<SharedContacts>;
  /** #rest(batched) #virtual */
  sharedContactsMobile?: Maybe<SharedContacts>;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type MymkRecommendationEdge = PaginationEdge & {
  __typename?: 'MymkRecommendationEdge';
  /** #soft-logged-in */
  node: MymkRecommendation;
  /** #soft-logged-in */
  cursor: Scalars['String'];
};

export type MymkRecommenderConnection = RecommenderResponse & HasCursorPagination & {
  __typename?: 'MymkRecommenderConnection';
  /** #soft-logged-in */
  edges: Array<MymkRecommendationEdge>;
  /** #soft-logged-in */
  requestTrackingToken: Scalars['String'];
  /** #soft-logged-in */
  service: Scalars['String'];
  /** #soft-logged-in */
  pageInfo: PageInfo;
  /** #soft-logged-in */
  total: Scalars['Int'];
};

export type NameGenderSettings = {
  __typename?: 'NameGenderSettings';
  firstName?: Maybe<TextSetting>;
  lastName?: Maybe<TextSetting>;
  birthName?: Maybe<TextSetting>;
  gender?: Maybe<SelectSetting>;
  academicTitle?: Maybe<SelectSetting>;
  pendingChange?: Maybe<PendingNameGenderSettings>;
};

export type NbaCard = NbaProfileCard;

/** Available Card IDs */
export enum NbaCardId {
  WelcomeCard = 'WELCOME_CARD',
  CreateBusinessLocationCard = 'CREATE_BUSINESS_LOCATION_CARD',
  UpdateBusinessLocationCard = 'UPDATE_BUSINESS_LOCATION_CARD',
  CreateBusinessCityCard = 'CREATE_BUSINESS_CITY_CARD',
  UpdateBusinessCityCard = 'UPDATE_BUSINESS_CITY_CARD',
  CreateBusinessAddressCard = 'CREATE_BUSINESS_ADDRESS_CARD',
  CreateDisciplineCard = 'CREATE_DISCIPLINE_CARD',
  UpdateDisciplineCard = 'UPDATE_DISCIPLINE_CARD',
  ImproveHavesCard = 'IMPROVE_HAVES_CARD',
  UpdateHavesCard = 'UPDATE_HAVES_CARD',
  CreateHavesCard = 'CREATE_HAVES_CARD',
  UpdateJobTitleCard = 'UPDATE_JOB_TITLE_CARD',
  ImproveJobTitleCard = 'IMPROVE_JOB_TITLE_CARD',
  ImprovePhotoCard = 'IMPROVE_PHOTO_CARD',
  UpdatePhotoCard = 'UPDATE_PHOTO_CARD',
  CreatePhotoCard = 'CREATE_PHOTO_CARD',
  CreateMinCareerLevelCard = 'CREATE_MIN_CAREER_LEVEL_CARD',
  UpdateMinCareerLevelCard = 'UPDATE_MIN_CAREER_LEVEL_CARD',
  UpdateCompanyNameCard = 'UPDATE_COMPANY_NAME_CARD',
  CreateBirthdayCard = 'CREATE_BIRTHDAY_CARD',
  CreateCompleteEducationCard = 'CREATE_COMPLETE_EDUCATION_CARD',
  CreateEducationCard = 'CREATE_EDUCATION_CARD',
  PremiumPictureVoucher = 'PREMIUM_PICTURE_VOUCHER',
  PremiumUpsell = 'PREMIUM_UPSELL',
  SuccessCard = 'SUCCESS_CARD',
  All = 'ALL'
}

export type NbaProfileCard = {
  __typename?: 'NbaProfileCard';
  /** ID of the Card, e.g. CREATE_BUSINESS_CITY_CARD */
  id: NbaCardId;
  data?: Maybe<NbaProfileCardData>;
  /** Value of profile data that will be updated/improved by this card. Usually is used for Improve cards. */
  value?: Maybe<Scalars['String']>;
  /** ID of the entity related to the card (If any), for example this will be the order of educational experience in FieldOfStudy cards. */
  entityId?: Maybe<Scalars['ID']>;
};

export type NbaProfileCardData = {
  __typename?: 'NbaProfileCardData';
  /** List of suggestions, provided by DS */
  suggestions: Array<NbaProfileSuggestion>;
  /** Token, provided by DS to track suggestions interactions. Only provided if there are suggestions. */
  suggestionTrackingToken: Scalars['String'];
};

export type NbaProfileSuggestion = {
  __typename?: 'NbaProfileSuggestion';
  /** Suggestion value. Fox example: Ruby */
  entityLabel: Scalars['String'];
  /** Token, provided by DS to track suggestions interactions on specific item. */
  itemTrackingToken: Scalars['String'];
  /** Position of this suggestion in the list returned by DS. */
  positionShown: Scalars['Int'];
};

export type NeffiCard = {
  __typename?: 'NeffiCard';
  neffiData?: Maybe<NeffiCardData>;
};

export type NeffiCardData = {
  __typename?: 'NeffiCardData';
  title: Scalars['String'];
  description: Scalars['String'];
  score: Scalars['Float'];
  quality: Scalars['String'];
  abTestGroup: Scalars['String'];
  shouldCelebrate: Scalars['Boolean'];
  sections: Array<NeffiCardDataSection>;
};

export type NeffiCardDataSection = {
  __typename?: 'NeffiCardDataSection';
  name: Scalars['String'];
  title: Scalars['String'];
  urn?: Maybe<Scalars['GlobalID']>;
  fields: Array<NeffiCardDataSectionField>;
};

export type NeffiCardDataSectionField = {
  __typename?: 'NeffiCardDataSectionField';
  name: Scalars['String'];
  text: Scalars['String'];
  checked: Scalars['Boolean'];
  deeplink: Scalars['String'];
  outdated: Scalars['Boolean'];
};

export type NeffiModule = ModuleInterface & OutdatableModule & {
  __typename?: 'NeffiModule';
  /**
   * #rest #virtual
   * @deprecated This will be removed soon. neffiWdt is the replacement.
   */
  neffiCard?: Maybe<NeffiCard>;
  /** #rest #virtual */
  neffiWdt?: Maybe<NeffiWdt>;
  order: Scalars['Int'];
  title: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
  outdated: Scalars['Boolean'];
  outdatedFields?: Maybe<Scalars['String']>;
  lastModified?: Maybe<Scalars['Date']>;
};

export type NeffiOutdatedFields = {
  __typename?: 'NeffiOutdatedFields';
  /** #soft-logged-in */
  name: Scalars['String'];
  /** #soft-logged-in */
  lastModified?: Maybe<Scalars['String']>;
};

export type NeffiWdt = {
  __typename?: 'NeffiWdt';
  title: Scalars['String'];
  description: Scalars['String'];
  score: Scalars['Float'];
  quality: Scalars['String'];
  shouldCelebrate: Scalars['Boolean'];
  fields: Array<NeffiWdtField>;
};

export type NeffiWdtField = {
  __typename?: 'NeffiWdtField';
  name: Scalars['String'];
  text: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  checked: Scalars['Boolean'];
  outdated: Scalars['Boolean'];
  module?: Maybe<Scalars['String']>;
  deeplink: Scalars['String'];
};

export type NetworkBlockedUsersBlockError = {
  __typename?: 'NetworkBlockedUsersBlockError';
  message?: Maybe<Scalars['String']>;
};

export type NetworkBlockedUsersBlockInput = {
  id: Scalars['ID'];
};

export type NetworkBlockedUsersBlockResult = {
  __typename?: 'NetworkBlockedUsersBlockResult';
  error?: Maybe<NetworkBlockedUsersBlockError>;
  /**
   * #rest
   *
   *  XingIdModule of the stalker user (the user being a stalker to the viewer)
   */
  xingIdModule?: Maybe<XingIdModule>;
};


export type NetworkBlockedUsersBlockResultXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

export type NetworkBlockedUsersBlockedUser = {
  __typename?: 'NetworkBlockedUsersBlockedUser';
  id: Scalars['ID'];
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type NetworkBlockedUsersUnblockError = {
  __typename?: 'NetworkBlockedUsersUnblockError';
  message?: Maybe<Scalars['String']>;
};

export type NetworkBlockedUsersUnblockInput = {
  id: Scalars['ID'];
};

export type NetworkBlockedUsersUnblockResult = {
  __typename?: 'NetworkBlockedUsersUnblockResult';
  error?: Maybe<NetworkBlockedUsersUnblockError>;
  /**
   * #rest
   *
   *  XingIdModule of the stalker user (the user being a stalker to the viewer)
   */
  xingIdModule?: Maybe<XingIdModule>;
};


export type NetworkBlockedUsersUnblockResultXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

/** Persisted client settings for network apps */
export type NetworkClientSetting = {
  __typename?: 'NetworkClientSetting';
  /** #soft-logged-in */
  key: Scalars['String'];
  /** #soft-logged-in */
  value: Scalars['String'];
};

export type NetworkClientSettingError = {
  __typename?: 'NetworkClientSettingError';
  /** #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type NetworkClientSettingsInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type NetworkClientSettingsSetResult = {
  __typename?: 'NetworkClientSettingsSetResult';
  /** #soft-logged-in */
  success?: Maybe<Array<NetworkClientSetting>>;
  /** #soft-logged-in */
  error?: Maybe<NetworkClientSettingError>;
};

/** City of contact */
export type NetworkContactCity = {
  __typename?: 'NetworkContactCity';
  name: Scalars['String'];
};

/** Company of contact */
export type NetworkContactCompany = {
  __typename?: 'NetworkContactCompany';
  name: Scalars['String'];
};

/** List of aggregated companies */
export type NetworkContactsCities = {
  __typename?: 'NetworkContactsCities';
  collection?: Maybe<Array<NetworkContactCity>>;
};

/** List of aggregated companies */
export type NetworkContactsCompanies = {
  __typename?: 'NetworkContactsCompanies';
  collection?: Maybe<Array<NetworkContactCompany>>;
};

export type NetworkCreateTagInput = {
  name: Scalars['String'];
};

export type NetworkDeleteTagInput = {
  tagId: Scalars['ID'];
};

export type NetworkEfficiencyIndicator = {
  __typename?: 'NetworkEfficiencyIndicator';
  /** #soft-logged-in */
  id: Scalars['Long'];
  /** #soft-logged-in */
  score: Scalars['Float'];
  /** #soft-logged-in */
  missingFields: Array<Maybe<Scalars['String']>>;
  /** #soft-logged-in */
  outdatedFields: Array<Maybe<NeffiOutdatedFields>>;
  /** #soft-logged-in */
  userTypeSupported: Scalars['Boolean'];
  /** #soft-logged-in */
  category: Scalars['String'];
  /** #soft-logged-in */
  scoreVersion: Scalars['Int'];
};

export type NetworkHomeAdPlaceholder = {
  __typename?: 'NetworkHomeAdPlaceholder';
  /** @deprecated No longer used by clients */
  id: Scalars['ID'];
  /** @deprecated No longer used by clients */
  createdAt: Scalars['Date'];
};

export type NetworkHomeWebsocketAuthToken = {
  __typename?: 'NetworkHomeWebsocketAuthToken';
  /** #logged-out #soft-logged-in */
  token: Scalars['String'];
};

export type NetworkProximityUser = {
  __typename?: 'NetworkProximityUser';
  proximityId: Scalars['UUID'];
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type NetworkProximityUsers = {
  __typename?: 'NetworkProximityUsers';
  total?: Maybe<Scalars['Int']>;
  collection: Array<NetworkProximityUser>;
};

export type NetworkRecruiterInsights = Localizable & {
  __typename?: 'NetworkRecruiterInsights';
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
};

export type NetworkRelationship = {
  __typename?: 'NetworkRelationship';
  /**
   * #soft-logged-in
   *
   *  Id of the user. The relationship is verified between this id and userId
   */
  id: Scalars['ID'];
  /**
   * #soft-logged-in
   *
   *  The relationship itself between this id and userId
   */
  relationship?: Maybe<NetworkRelationshipType>;
  /**
   * #soft-logged-in
   *
   *  The current permissions for this relationship
   */
  permissions?: Maybe<Array<Maybe<NetworkRelationshipPermissionType>>>;
  /**
   * #soft-logged-in
   *
   *  The error value when the relationship status couldn't be retrieved
   */
  error?: Maybe<NetworkRelationshipErrorType>;
};

/** The error values possible for each relationship request */
export enum NetworkRelationshipErrorType {
  UserNotFound = 'USER_NOT_FOUND',
  UserBlacklisted = 'USER_BLACKLISTED',
  SameId = 'SAME_ID'
}

/** The permission values for each relationship */
export enum NetworkRelationshipPermissionType {
  SendRequest = 'SEND_REQUEST',
  DeleteContact = 'DELETE_CONTACT',
  DeleteRequest = 'DELETE_REQUEST',
  ConfirmRequest = 'CONFIRM_REQUEST',
  DeclineRequest = 'DECLINE_REQUEST'
}

/**
 * Possible values are:
 * 'none': No relationship between userId and id, userId can send a contact request to id
 * 'contact': userId and id are contacts, the contact can be deleted
 * 'sent': userId has sent contact request to id, the contact request can be deleted
 * 'received': userId received a contact request from id, the contact request can be confirmed or declined
 * 'received_declined': userId received and declined a request from id, the contact request can still be confirmed
 */
export enum NetworkRelationshipType {
  None = 'NONE',
  Contact = 'CONTACT',
  Sent = 'SENT',
  Received = 'RECEIVED',
  ReceivedDeclined = 'RECEIVED_DECLINED'
}

/** People team, network app related settings */
export type NetworkSettings = {
  __typename?: 'NetworkSettings';
  /** Who can see your contact list ('0' - nobody, '1' - friends, '2' - friends of friends, '99' - everyone) */
  distanceForContactList?: Maybe<SelectSetting>;
  /** Keep data from addressbook uploads */
  addressbookUploadAllowed?: Maybe<ToggleSetting>;
};

export type NetworkSettingsInput = {
  distanceForContactList?: Maybe<SelectSettingInput>;
  addressbookUploadAllowed?: Maybe<ToggleSettingInput>;
};

export type NetworkSettingsMutationResult = {
  __typename?: 'NetworkSettingsMutationResult';
  error?: Maybe<NetworkSettings>;
  response?: Maybe<NetworkSettings>;
};

/** Tags attached to a contact */
export type NetworkTag = {
  __typename?: 'NetworkTag';
  name: Scalars['String'];
  id: Scalars['ID'];
};

export type NetworkTagAssignResult = {
  __typename?: 'NetworkTagAssignResult';
  error?: Maybe<NetworkTaggingError>;
  success?: Maybe<ContactsListContact>;
};

export type NetworkTagCreateResult = {
  __typename?: 'NetworkTagCreateResult';
  error?: Maybe<NetworkTagError>;
  success?: Maybe<NetworkTag>;
};

export type NetworkTagDeleteResult = {
  __typename?: 'NetworkTagDeleteResult';
  error?: Maybe<NetworkTagError>;
  success?: Maybe<NetworkTag>;
};

export type NetworkTagError = {
  __typename?: 'NetworkTagError';
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
  tag?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NetworkTagUnassignResult = {
  __typename?: 'NetworkTagUnassignResult';
  error?: Maybe<NetworkTaggingError>;
  success?: Maybe<ContactsListContact>;
};

export type NetworkTaggingError = {
  __typename?: 'NetworkTaggingError';
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
  taggings?: Maybe<Array<Maybe<Scalars['String']>>>;
  friendship?: Maybe<Array<Maybe<Scalars['String']>>>;
  tag?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NetworkTaggingInput = {
  friendId: Scalars['ID'];
  tagId: Scalars['ID'];
};

/** List of tags */
export type NetworkTags = {
  __typename?: 'NetworkTags';
  total?: Maybe<Scalars['Int']>;
  collection?: Maybe<Array<NetworkTag>>;
};

export type NetworkUpdate = MessengerChat | AdConversationStarter | NetworkHomeAdPlaceholder | BirthdayStack | VompStack | ContactRequestStack | NewContactStack | WorkExperienceUpdateStack | ContactRecommendationStack;

export type NetworkUpdatesConnection = HasCursorPagination & {
  __typename?: 'NetworkUpdatesConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<NetworkUpdatesEdge>>;
};

export type NetworkUpdatesEdge = PaginationEdge & {
  __typename?: 'NetworkUpdatesEdge';
  cursor: Scalars['String'];
  node: NetworkUpdate;
};

export enum NetworkUpdatesFilter {
  All = 'ALL',
  Chats = 'CHATS',
  Updates = 'UPDATES'
}

export type NetworkUpdatesSectionFilterInput = {
  chatsFilter?: Maybe<MessengerChatsFilterTypes>;
};

export type NetworkUpdatesStackItem = {
  id: Scalars['ID'];
  stackId: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type NetworkUserProximityIdSetError = {
  __typename?: 'NetworkUserProximityIdSetError';
  message?: Maybe<Scalars['String']>;
};

export type NetworkUserProximityIdSetInput = {
  proximityId: Scalars['UUID'];
};

export type NetworkUserProximityIdSetResult = {
  __typename?: 'NetworkUserProximityIdSetResult';
  error?: Maybe<NetworkUserProximityIdSetError>;
  /** #expand */
  success?: Maybe<NetworkUserProximityIdSetSuccess>;
};

export type NetworkUserProximityIdSetSuccess = {
  __typename?: 'NetworkUserProximityIdSetSuccess';
  proximityId?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['ID']>;
};

export type NewContactConversationStarter = ConversationStarter & {
  __typename?: 'NewContactConversationStarter';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest #virtual */
  commonalities?: Maybe<Commonalities>;
  /** #rest(batched) #virtual */
  sharedContacts?: Maybe<SharedContacts>;
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type NewContactStack = SignalsStack & {
  __typename?: 'NewContactStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type NewContactStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type NewGroupMessageConversationStarter = ConversationStarter & {
  __typename?: 'NewGroupMessageConversationStarter';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  object?: Maybe<MessengerMessage>;
  /** #rest(batched) #virtual */
  target?: Maybe<MessengerChat>;
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type NewMessageConversationStarter = ConversationStarter & {
  __typename?: 'NewMessageConversationStarter';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  object?: Maybe<MessengerMessage>;
  /** #rest(batched) #virtual */
  target?: Maybe<MessengerChat>;
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type NewNotificationCenterMutationError = {
  __typename?: 'NewNotificationCenterMutationError';
  message?: Maybe<Scalars['String']>;
};

export type NewProfileVisitResult = ProfileVisitSuccessResponse | ProfileVisitErrorResponse;

export enum NewVisitType {
  NotVisible = 'NOT_VISIBLE',
  Visible = 'VISIBLE'
}

export type NewsAggregations = {
  __typename?: 'NewsAggregations';
  category?: Maybe<Array<Maybe<CategoryAggregation>>>;
  entityType?: Maybe<Array<Maybe<EntityTypeAggregation>>>;
};

export type NewsAggregationsInput = {
  /** category: Maximum number of distinct values to be returned by this aggregation */
  category?: Maybe<Scalars['String']>;
  /** entityType: Maximum number of distinct values to be returned by this aggregation. For now we only have 4 of those. */
  entityType?: Maybe<Scalars['String']>;
};

export type NewsArticleSearchItem = UniversalSearchNewsResult & {
  __typename?: 'NewsArticleSearchItem';
  /** #rest #virtual */
  contentArticle?: Maybe<ContentArticle>;
  trackingToken: Scalars['String'];
  position: Scalars['Int'];
  score: Scalars['Float'];
  urn?: Maybe<Scalars['URN']>;
};

/**  Available filters for news search */
export type NewsFiltersInput = {
  /** category: Filter results which match ANY of the given values(comma separated).  */
  category?: Maybe<Scalars['String']>;
  /** entity_type: Filter results which match ANY of the given values(comma separated). Values should be in this enum: page|insider|article */
  entityType?: Maybe<EntityTypeValue>;
};

export type NewsInsiderSearchItem = UniversalSearchNewsResult & {
  __typename?: 'NewsInsiderSearchItem';
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  trackingToken: Scalars['String'];
  position: Scalars['Int'];
  score: Scalars['Float'];
  urn?: Maybe<Scalars['URN']>;
};

export type NewsPageSearchItem = UniversalSearchNewsResult & {
  __typename?: 'NewsPageSearchItem';
  /** #rest(batched) #virtual */
  contentPage?: Maybe<ContentPage>;
  trackingToken: Scalars['String'];
  position: Scalars['Int'];
  score: Scalars['Float'];
  urn?: Maybe<Scalars['URN']>;
};

export type NewsSearchConnection = HasCursorPagination & {
  __typename?: 'NewsSearchConnection';
  edges: Array<NewsSearchEdge>;
  aggs?: Maybe<NewsAggregations>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type NewsSearchEdge = PaginationEdge & {
  __typename?: 'NewsSearchEdge';
  node?: Maybe<UniversalSearchNewsResult>;
  /** #virtual */
  cursor: Scalars['String'];
};

/** Next Best Action Module */
export type NextBestActionModule = ModuleInterface & {
  __typename?: 'NextBestActionModule';
  /** Generated by backend the tracking token for the whole request. Should be used by frontend to track cards interactions. */
  trackingToken: Scalars['String'];
  /** List of cards with suggestions */
  cards: Array<NbaCard>;
  order: Scalars['Int'];
  title: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

/** note for another userr */
export type Note = {
  __typename?: 'Note';
  otherUserId: Scalars['ID'];
  content: Scalars['String'];
};

export type NoteInputType = {
  otherUserId: Scalars['ID'];
  content: Scalars['String'];
};

/** Note Module */
export type NoteModule = ModuleInterface & {
  __typename?: 'NoteModule';
  /** #rest #virtual */
  note?: Maybe<Note>;
  order: Scalars['Int'];
  title: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type Notification = {
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type NotificationConnection = HasCursorPagination & {
  __typename?: 'NotificationConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<NotificationEdge>>;
};

export type NotificationEdge = PaginationEdge & {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String'];
  node: Notification;
};

export type NotificationMarkAsOpenedInput = {
  id: Scalars['ID'];
};

export type NotificationMarkAsOpenedResult = NotificationMarkAsOpenedResultSuccess | NotificationMarkAsOpenedResultError;

export type NotificationMarkAsOpenedResultError = {
  __typename?: 'NotificationMarkAsOpenedResultError';
  message?: Maybe<Scalars['String']>;
};

export type NotificationMarkAsOpenedResultSuccess = {
  __typename?: 'NotificationMarkAsOpenedResultSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  /** A users certain notification setting */
  type: Scalars['String'];
  value: Scalars['Boolean'];
  textResourceKeys?: Maybe<TextResourceKeys>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type NotificationSettingInput = {
  /** Type of notification */
  type: Scalars['String'];
  /** The corresponding boolean value for it */
  value: Scalars['Boolean'];
};

/** Settings related to Notifications */
export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  /** A users notification settings, unpaginated and grouped by section */
  push?: Maybe<Array<Maybe<NotificationSetting>>>;
  email?: Maybe<Array<Maybe<NotificationSetting>>>;
};

export type NotificationSettingsCollection = {
  __typename?: 'NotificationSettingsCollection';
  /** Complete collection of a users notification settings */
  collection?: Maybe<NotificationSettings>;
};

export type NotificationSettingsCollectionInput = {
  collection?: Maybe<NotificationSettingsInput>;
};

export type NotificationSettingsInput = {
  /** Input consists of a type and value for a particular push setting. */
  push?: Maybe<NotificationSettingInput>;
  /** Input consists of a type and value for a particular email setting. */
  email?: Maybe<NotificationSettingInput>;
};

export type NotificationSettingsMutationResult = {
  __typename?: 'NotificationSettingsMutationResult';
  error?: Maybe<NotificationSettingsCollection>;
  response?: Maybe<NotificationSettingsCollection>;
};

export type NotificationsBadgeNamesInput = {
  badgeNames: Array<Scalars['String']>;
};

/** Response is currently ignored by clients. */
export type NotificationsBadgesSeenData = {
  __typename?: 'NotificationsBadgesSeenData';
  response?: Maybe<Scalars['String']>;
};

export type NotificationsBadgesSeenError = {
  __typename?: 'NotificationsBadgesSeenError';
  description?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

/**
 * The response should contain information regarding a successful or
 * unsuccessful request. This decision is done internally, and the
 * response is just proxied back to the client.
 */
export type NotificationsBadgesSeenResponse = {
  __typename?: 'NotificationsBadgesSeenResponse';
  success?: Maybe<NotificationsBadgesSeenData>;
  error?: Maybe<NotificationsBadgesSeenError>;
};

export type NotificationsMarkAllAsOpenedResult = NotificationsMarkAllAsOpenedResultSuccess | NotificationsMarkAllAsOpenedResultError;

export type NotificationsMarkAllAsOpenedResultError = {
  __typename?: 'NotificationsMarkAllAsOpenedResultError';
  message?: Maybe<Scalars['String']>;
};

export type NotificationsMarkAllAsOpenedResultSuccess = {
  __typename?: 'NotificationsMarkAllAsOpenedResultSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type NumberOfNewProfileVisits = {
  __typename?: 'NumberOfNewProfileVisits';
  /**
   * #virtual
   *
   *  Total number of new visits
   */
  total: Scalars['Int'];
};

export type ObjectActions = {
  trackingToken?: Maybe<Scalars['String']>;
};

export type OccupiedJob = {
  __typename?: 'OccupiedJob';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companyId?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
  /** #logged-out #soft-logged-in */
  fallbackCompany?: Maybe<FallbackCompany>;
  /** #logged-out #soft-logged-in */
  jobTitle?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  workType?: Maybe<Scalars['String']>;
  skillsMatchedCount?: Maybe<Scalars['Int']>;
  skillsNotMatchedCount?: Maybe<Scalars['Int']>;
  skillsTotal?: Maybe<Scalars['Int']>;
  skillsMatched?: Maybe<Array<Maybe<DreamJobSkills>>>;
  skillsNotMatched?: Maybe<Array<Maybe<DreamJobSkills>>>;
  experienceMatchedScore?: Maybe<Scalars['Int']>;
  experienceTotal?: Maybe<Scalars['Int']>;
  preferredIndustry?: Maybe<DreamJobIndusty>;
  preferredDiscipline?: Maybe<DreamJobDiscipline>;
  similarMembersCount?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  similarMembers?: Maybe<Array<Maybe<DreamJobSimilarMembers>>>;
  /** #logged-out #soft-logged-in */
  salary?: Maybe<JobSalary>;
  trackingToken?: Maybe<Scalars['String']>;
  vompEnabled?: Maybe<Scalars['Boolean']>;
  vompMembers?: Maybe<Array<Maybe<DreamJobSimilarMembers>>>;
  urn?: Maybe<Scalars['URN']>;
};

export type OfferStatusAggregation = HasAggregationCount & {
  __typename?: 'OfferStatusAggregation';
  value?: Maybe<CompanyOffers>;
  count: Scalars['Int'];
};

export type OnboardingDeveloperJourneyInput = {
  screen: OnboardingScreenType;
  metadata: OnboardingJourneyMetadataInput;
};

export enum OnboardingJourneyFlowType {
  Jobseeker = 'JOBSEEKER',
  Resume = 'RESUME'
}

export type OnboardingJourneyMetadataInput = {
  welcomeScreen?: Maybe<Scalars['Boolean']>;
  timelineEntryScreen?: Maybe<Scalars['Boolean']>;
  studiesScreen?: Maybe<Scalars['Boolean']>;
  studiesLocationScreen?: Maybe<Scalars['Boolean']>;
  workExperienceScreen?: Maybe<Scalars['Boolean']>;
  skillsScreen?: Maybe<Scalars['Boolean']>;
  pictureScreen?: Maybe<Scalars['Boolean']>;
  transitionScreen?: Maybe<Scalars['Boolean']>;
  dataImportOptinScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesJobTitlesScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesLocationScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesSelectionScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesSalaryScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesIndustryScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesDisciplineScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesCareerLevelScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesWorkingHoursScreen?: Maybe<Scalars['Boolean']>;
  jobseekerStatusScreen?: Maybe<Scalars['Boolean']>;
  upsellScreen?: Maybe<Scalars['Boolean']>;
  outroScreen?: Maybe<Scalars['Boolean']>;
  resumeScreen?: Maybe<Scalars['Boolean']>;
  employee?: Maybe<Scalars['Boolean']>;
  student?: Maybe<Scalars['Boolean']>;
};

export type OnboardingJourneyMetadataType = {
  __typename?: 'OnboardingJourneyMetadataType';
  welcomeScreen?: Maybe<Scalars['Boolean']>;
  timelineEntryScreen?: Maybe<Scalars['Boolean']>;
  studiesScreen?: Maybe<Scalars['Boolean']>;
  studiesLocationScreen?: Maybe<Scalars['Boolean']>;
  /** @deprecated OccupationScreen will be replaced with workExperienceScreen soon */
  occupationScreen?: Maybe<Scalars['Boolean']>;
  /** @deprecated EmployerScreen will be replaced with workExperienceScreen soon */
  employerScreen?: Maybe<Scalars['Boolean']>;
  workExperienceScreen?: Maybe<Scalars['Boolean']>;
  skillsScreen?: Maybe<Scalars['Boolean']>;
  pictureScreen?: Maybe<Scalars['Boolean']>;
  transitionScreen?: Maybe<Scalars['Boolean']>;
  dataImportOptinScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesJobTitlesScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesLocationScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesSelectionScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesSalaryScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesIndustryScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesDisciplineScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesCareerLevelScreen?: Maybe<Scalars['Boolean']>;
  jobPreferencesWorkingHoursScreen?: Maybe<Scalars['Boolean']>;
  jobseekerStatusScreen?: Maybe<Scalars['Boolean']>;
  upsellScreen?: Maybe<Scalars['Boolean']>;
  outroScreen?: Maybe<Scalars['Boolean']>;
  resumeScreen?: Maybe<Scalars['Boolean']>;
  employee?: Maybe<Scalars['Boolean']>;
  student?: Maybe<Scalars['Boolean']>;
  wellDescribedTalent?: Maybe<Scalars['Boolean']>;
  hasJobPreferencesLocation?: Maybe<Scalars['Boolean']>;
  hasJobPreferencesJobTitles?: Maybe<Scalars['Boolean']>;
  fsLinkedinScaling?: Maybe<Scalars['Boolean']>;
};

export type OnboardingJourneyNextScreenResponseType = {
  __typename?: 'OnboardingJourneyNextScreenResponseType';
  nextScreen?: Maybe<OnboardingNextScreenType>;
  journey?: Maybe<OnboardingJourneyType>;
};

export type OnboardingJourneyType = {
  __typename?: 'OnboardingJourneyType';
  journeyId: Scalars['UUID'];
  userId: Scalars['ID'];
  resumable: Scalars['Boolean'];
  flow?: Maybe<OnboardingJourneyFlowType>;
  metadata?: Maybe<OnboardingJourneyMetadataType>;
  segment?: Maybe<Scalars['String']>;
  /** #rest #virtual */
  registerRedirectTo?: Maybe<OnboardingRegisterRedirectTo>;
};

export type OnboardingNextScreenType = {
  __typename?: 'OnboardingNextScreenType';
  name: Scalars['String'];
};

export type OnboardingProfile = {
  __typename?: 'OnboardingProfile';
  globalId: Scalars['URN'];
  signupChannel: Scalars['String'];
  segment: Scalars['String'];
  showSimpleProfile: Scalars['Boolean'];
  completedSimpleProfile: Scalars['Boolean'];
  resumeOnboardingInfo?: Maybe<ResumeOnboardingInfo>;
  motive?: Maybe<Scalars['String']>;
  isWellDescribedTalent: Scalars['Boolean'];
};

export type OnboardingRedirectProfile = {
  __typename?: 'OnboardingRedirectProfile';
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
};

export type OnboardingRegisterRedirectTo = {
  __typename?: 'OnboardingRegisterRedirectTo';
  url?: Maybe<Scalars['String']>;
};

export enum OnboardingScreenType {
  WelcomeScreen = 'WELCOME_SCREEN',
  ResumeScreen = 'RESUME_SCREEN',
  TimelineEntryScreen = 'TIMELINE_ENTRY_SCREEN',
  StudiesScreen = 'STUDIES_SCREEN',
  StudiesLocationScreen = 'STUDIES_LOCATION_SCREEN',
  OccupationScreen = 'OCCUPATION_SCREEN',
  EmployerScreen = 'EMPLOYER_SCREEN',
  WorkExperienceScreen = 'WORK_EXPERIENCE_SCREEN',
  SkillsScreen = 'SKILLS_SCREEN',
  PictureScreen = 'PICTURE_SCREEN',
  DataImportOptinScreen = 'DATA_IMPORT_OPTIN_SCREEN',
  TransitionScreen = 'TRANSITION_SCREEN',
  JobPreferencesJobTitlesScreen = 'JOB_PREFERENCES_JOB_TITLES_SCREEN',
  JobPreferencesLocationScreen = 'JOB_PREFERENCES_LOCATION_SCREEN',
  JobPreferencesSelectionScreen = 'JOB_PREFERENCES_SELECTION_SCREEN',
  JobPreferencesSalaryScreen = 'JOB_PREFERENCES_SALARY_SCREEN',
  JobPreferencesIndustryScreen = 'JOB_PREFERENCES_INDUSTRY_SCREEN',
  JobPreferencesDisciplineScreen = 'JOB_PREFERENCES_DISCIPLINE_SCREEN',
  JobPreferencesCareerLevelScreen = 'JOB_PREFERENCES_CAREER_LEVEL_SCREEN',
  JobPreferencesWorkingHoursScreen = 'JOB_PREFERENCES_WORKING_HOURS_SCREEN',
  JobStatusScreen = 'JOB_STATUS_SCREEN',
  UpsellScreen = 'UPSELL_SCREEN',
  OutroScreen = 'OUTRO_SCREEN',
  RedirectScreen = 'REDIRECT_SCREEN'
}

export type OneOnOneMessageConversationStarter = ConversationStarter & {
  __typename?: 'OneOnOneMessageConversationStarter';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  object?: Maybe<MessengerMessage>;
  /** #rest(batched) #virtual */
  target?: Maybe<MessengerChat>;
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type OntologyEntityLabel = {
  __typename?: 'OntologyEntityLabel';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  label: Scalars['String'];
};

export type OntologyEntityLabels = {
  __typename?: 'OntologyEntityLabels';
  en?: Maybe<Array<Maybe<Scalars['String']>>>;
  de?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OntologyEntityMatchingResponseItem = {
  __typename?: 'OntologyEntityMatchingResponseItem';
  entityId?: Maybe<Scalars['ID']>;
  entityType?: Maybe<OntologyEntityType>;
  score?: Maybe<Scalars['Int']>;
  referencedLabel?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Scalars['String']>>>;
  labels?: Maybe<OntologySeqEntityLabels>;
};

export enum OntologyEntityType {
  JobRole = 'JOB_ROLE',
  Skill = 'SKILL',
  FieldOfStudy = 'FIELD_OF_STUDY',
  Company = 'COMPANY',
  School = 'SCHOOL',
  Degree = 'DEGREE',
  Function = 'FUNCTION',
  Jobrole = 'JOBROLE',
  Department = 'DEPARTMENT',
  Discipline = 'DISCIPLINE',
  Industry = 'INDUSTRY',
  AdminArea = 'ADMIN_AREA',
  City = 'CITY',
  Country = 'COUNTRY',
  Municipality = 'MUNICIPALITY',
  Ignorable = 'IGNORABLE',
  CareerLevel = 'CAREER_LEVEL'
}

export enum OntologyLabels {
  None = 'NONE',
  Primary = 'PRIMARY',
  Alternative = 'ALTERNATIVE',
  All = 'ALL'
}

export enum OntologyLanguage {
  De = 'DE',
  En = 'EN',
  Fr = 'FR',
  Pt = 'PT',
  Es = 'ES',
  Ru = 'RU',
  It = 'IT',
  Tr = 'TR',
  Nl = 'NL',
  Zh = 'ZH',
  Pl = 'PL',
  Np = 'NP',
  Un = 'UN'
}

export type OntologyLocalizedJobPostingSkill = {
  __typename?: 'OntologyLocalizedJobPostingSkill';
  label: Scalars['String'];
  language: OntologyLanguage;
  isSoft: Scalars['Boolean'];
};

export type OntologyLocalizedJobRole = {
  __typename?: 'OntologyLocalizedJobRole';
  label: Scalars['String'];
  language: OntologyLanguage;
};

export type OntologyResolvedEntitiesInput = {
  text: Scalars['String'];
  xingType: OntologyXingType;
  xingField: OntologyXingField;
  labels: Scalars['String'];
  labelLanguages: Array<Maybe<Scalars['String']>>;
  entityLimit: Scalars['Int'];
  externalLinks: Array<Maybe<Scalars['String']>>;
};

export type OntologyResolvedEntitiesReferenceCollection = {
  __typename?: 'OntologyResolvedEntitiesReferenceCollection';
  references?: Maybe<Array<Maybe<OntologyResolvedEntitiesReferenceItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type OntologyResolvedEntitiesReferenceItem = {
  __typename?: 'OntologyResolvedEntitiesReferenceItem';
  entityMatches?: Maybe<Array<Maybe<OntologyEntityMatchingResponseItem>>>;
  reference?: Maybe<Scalars['String']>;
};

export type OntologySeqEntityLabels = {
  __typename?: 'OntologySeqEntityLabels';
  primary?: Maybe<OntologyEntityLabels>;
  alternative?: Maybe<OntologyEntityLabels>;
  matchingOnly?: Maybe<OntologyEntityLabels>;
};

export type OntologySkill = {
  __typename?: 'OntologySkill';
  id?: Maybe<Scalars['ID']>;
  entityType?: Maybe<OntologyEntityType>;
  labels?: Maybe<Array<Maybe<OntologySkillLabel>>>;
  links?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OntologySkillLabel = {
  __typename?: 'OntologySkillLabel';
  label?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isMatchingOnly?: Maybe<Scalars['Boolean']>;
  language?: Maybe<OntologyLanguage>;
};

export type OntologyUserJobPostingProfileMatchResponse = {
  __typename?: 'OntologyUserJobPostingProfileMatchResponse';
  jobPostingId?: Maybe<Scalars['ID']>;
  skills?: Maybe<JobPostingSkillMatches>;
  jobRoles?: Maybe<JobPostingJobRoleMatches>;
};

export type OntologyUserJobPostingSkillsMatchResponse = {
  __typename?: 'OntologyUserJobPostingSkillsMatchResponse';
  jobPostingId?: Maybe<Scalars['ID']>;
  skills?: Maybe<JobPostingSkillMatches>;
};

export enum OntologyXingField {
  OccupationOrg = 'OCCUPATION_ORG',
  OccupationTitle = 'OCCUPATION_TITLE',
  Whi = 'WHI',
  Haves = 'HAVES',
  Wants = 'WANTS',
  Interests = 'INTERESTS',
  JobTitle = 'JOB_TITLE',
  Degree = 'DEGREE',
  AcademicDegree = 'ACADEMIC_DEGREE',
  Subject = 'SUBJECT',
  SchoolName = 'SCHOOL_NAME',
  CompanyTags = 'COMPANY_TAGS',
  TargetPositions = 'TARGET_POSITIONS',
  TargetCompanies = 'TARGET_COMPANIES',
  ExcludedKeywords = 'EXCLUDED_KEYWORDS',
  TopicsAndProjects = 'TOPICS_AND_PROJECTS',
  TasksAndActions = 'TASKS_AND_ACTIONS',
  ResultsAndAchievements = 'RESULTS_AND_ACHIEVEMENTS',
  SchoolNotes = 'SCHOOL_NOTES',
  CompanyNotes = 'COMPANY_NOTES',
  Qualifications = 'QUALIFICATIONS',
  Function = 'FUNCTION',
  Tags = 'TAGS',
  EnrichedTags = 'ENRICHED_TAGS',
  Skills = 'SKILLS',
  EnrichedSkills = 'ENRICHED_SKILLS',
  Company = 'COMPANY',
  CompanyName = 'COMPANY_NAME'
}

export enum OntologyXingType {
  Profile = 'PROFILE',
  Posting = 'POSTING',
  Jobboerse = 'JOBBOERSE'
}

export type OpenChatAction = ObjectActions & {
  __typename?: 'OpenChatAction';
  params: OpenChatActionParams;
  trackingToken?: Maybe<Scalars['String']>;
};

export type OpenChatActionParams = {
  __typename?: 'OpenChatActionParams';
  userId: Scalars['ID'];
  contextId?: Maybe<Scalars['String']>;
};

export type OpenJobAction = ObjectActions & {
  __typename?: 'OpenJobAction';
  params: OpenJobActionParams;
  trackingToken?: Maybe<Scalars['String']>;
};

export type OpenJobActionParams = {
  __typename?: 'OpenJobActionParams';
  jobId: Scalars['ID'];
  jobSlug: Scalars['String'];
};

/**
 * Metadata for original image.
 * Returns back metadata from image-cache service by using original_images endpoint and uuid for an original image.
 */
export type OriginalImageMetadata = {
  __typename?: 'OriginalImageMetadata';
  /** Width of the image */
  width?: Maybe<Scalars['Int']>;
  /** Height of the image */
  height?: Maybe<Scalars['Int']>;
  /** Files size of the image */
  fileSize?: Maybe<Scalars['Int']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Content type of the image: ex: `image/jpeg`
   */
  contentType?: Maybe<Scalars['String']>;
};

export type OutdatableModule = {
  outdated: Scalars['Boolean'];
  outdatedFields?: Maybe<Scalars['String']>;
  lastModified?: Maybe<Scalars['Date']>;
};

/** Information about current cursor pagination page */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** #logged-out #soft-logged-in */
  hasNextPage: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  hasPreviousPage: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  startCursor?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  endCursor?: Maybe<Scalars['String']>;
};

/**
 * Provides common fields for cursor pagination edges. Complies with
 * [Relay Edge Type](https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types) specification.
 */
export type PaginationEdge = {
  /** #virtual */
  cursor: Scalars['String'];
};

/** Types for XTM Message Parser */
export type ParseMessageInput = {
  templateId: Scalars['ID'];
  recipientId?: Maybe<Scalars['ID']>;
};

export type ParseMessageTemplateError = {
  __typename?: 'ParseMessageTemplateError';
  message?: Maybe<Scalars['String']>;
};

export type ParseMessageTemplateMutationResult = ParseMessageTemplateSuccess | ParseMessageTemplateError;

export type ParseMessageTemplateSuccess = {
  __typename?: 'ParseMessageTemplateSuccess';
  subject?: Maybe<Array<Maybe<XtmMessageTemplateParserOutputElement>>>;
  body?: Maybe<Array<Maybe<XtmMessageTemplateParserOutputElement>>>;
};

export type ParticipantsCount = {
  __typename?: 'ParticipantsCount';
  total: Scalars['Int'];
  yes: Scalars['Int'];
  no: Scalars['Int'];
  unanswered: Scalars['Int'];
};

export type Partner = {
  __typename?: 'Partner';
  /** #soft-logged-in */
  partnerName?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  displayName?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  slug?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  new?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   * @deprecated No longer in use by the clients. To be out of use in 31/05/2023
   */
  detailUrl?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  uplt?: Maybe<Scalars['Int']>;
  /** #soft-logged-in */
  teaser?: Maybe<PartnerTeaser>;
  /** #soft-logged-in */
  logo?: Maybe<PartnerLogo>;
  /** #soft-logged-in */
  offerType?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  categoriesWithId?: Maybe<Array<Maybe<PartnersCategory>>>;
  /** #soft-logged-in */
  membership?: Maybe<PartnerMemberships>;
};

/** Partner Mutations */
export type PartnerCreateCodeMutationInput = {
  slug?: Maybe<Scalars['String']>;
};

/** "Result type for  partner code create mutations that returns the code on success" */
export type PartnerCreateCodeMutationResult = {
  __typename?: 'PartnerCreateCodeMutationResult';
  /** #soft-logged-in */
  error?: Maybe<PartnerMutationError>;
  /** #soft-logged-in */
  success?: Maybe<PartnerDetailsCode>;
};

/** Partner details for a user */
export type PartnerDetails = {
  __typename?: 'PartnerDetails';
  /** #soft-logged-in */
  partnerId: Scalars['ID'];
  /** #soft-logged-in */
  new?: Maybe<Scalars['Boolean']>;
  /** #soft-logged-in */
  displayName?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  slug?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  backgroundImage?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  logoImage?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  filter?: Maybe<PartnerDetailsFilter>;
  /** #soft-logged-in */
  benefits?: Maybe<PartnerDetailsBenefits>;
  /** #soft-logged-in */
  body?: Maybe<Array<Maybe<PartnerDetailsBody>>>;
  /** #soft-logged-in */
  sideSection?: Maybe<Array<Maybe<PartnerDetailsSideSection>>>;
  /** #soft-logged-in */
  footerNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  uplt?: Maybe<Scalars['Int']>;
};

export type PartnerDetailsBenefit = {
  __typename?: 'PartnerDetailsBenefit';
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PartnerDetailsBenefits = {
  __typename?: 'PartnerDetailsBenefits';
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<PartnerDetailsBenefit>>>;
};

export type PartnerDetailsBody = PartnerDetailsBodyHeader | PartnerDetailsBodyVideo | PartnerDetailsBodySubheader | PartnerDetailsBodyParagraph;

/** Types for PartnerDetailsBody */
export type PartnerDetailsBodyHeader = {
  __typename?: 'PartnerDetailsBodyHeader';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PartnerDetailsBodyParagraph = {
  __typename?: 'PartnerDetailsBodyParagraph';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PartnerDetailsBodySubheader = {
  __typename?: 'PartnerDetailsBodySubheader';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PartnerDetailsBodyVideo = {
  __typename?: 'PartnerDetailsBodyVideo';
  /** #soft-logged-in */
  videoId?: Maybe<Scalars['ID']>;
};

export type PartnerDetailsCode = {
  __typename?: 'PartnerDetailsCode';
  /** #soft-logged-in */
  value?: Maybe<Scalars['String']>;
};

export type PartnerDetailsFilter = {
  __typename?: 'PartnerDetailsFilter';
  /** #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PartnerDetailsSideSection = PartnerDetailsSideSectionHeader | PartnerDetailsSideSectionSubheader | PartnerDetailsSideSectionList | PartnerDetailsSideSectionCodebutton | PartnerDetailsSideSectionButton;

export type PartnerDetailsSideSectionButton = {
  __typename?: 'PartnerDetailsSideSectionButton';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
};

export type PartnerDetailsSideSectionCodebutton = {
  __typename?: 'PartnerDetailsSideSectionCodebutton';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #soft-logged-in #rest #virtual */
  code?: Maybe<PartnerDetailsCode>;
};

/** Types for PartnerDetailsSideSection */
export type PartnerDetailsSideSectionHeader = {
  __typename?: 'PartnerDetailsSideSectionHeader';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PartnerDetailsSideSectionList = {
  __typename?: 'PartnerDetailsSideSectionList';
  /** #soft-logged-in */
  listElements?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PartnerDetailsSideSectionSubheader = {
  __typename?: 'PartnerDetailsSideSectionSubheader';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PartnerHighlight = {
  __typename?: 'PartnerHighlight';
  /** #soft-logged-in */
  partnerName?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  displayName?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  slug?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  new?: Maybe<Scalars['Boolean']>;
  /** #soft-logged-in */
  offerType?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  highlightImageUrl?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  squareHighlightImageUrl?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  body?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  logoUrl?: Maybe<Scalars['String']>;
};

export type PartnerLogo = {
  __typename?: 'PartnerLogo';
  /** #soft-logged-in */
  imageUrl?: Maybe<Scalars['String']>;
};

/** Memberships available to partners */
export enum PartnerMemberships {
  /** Premium */
  Premium = 'PREMIUM',
  /** ProJobs */
  Projobs = 'PROJOBS'
}

export type PartnerMutationError = {
  __typename?: 'PartnerMutationError';
  /** #soft-logged-in */
  message?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  error?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  status?: Maybe<Scalars['Int']>;
  /** #soft-logged-in */
  errors?: Maybe<Scalars['String']>;
};

export type PartnerTeaser = {
  __typename?: 'PartnerTeaser';
  /** #soft-logged-in */
  localizedTitle?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  localizedDescription?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  localizedSmallDescription?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  imageUrl?: Maybe<Scalars['String']>;
};

export type Partners = {
  __typename?: 'Partners';
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<Partner>>>;
};

/** List of Partner's categories */
export type PartnersCategories = {
  __typename?: 'PartnersCategories';
  /** #soft-logged-in */
  headline?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<PartnersCategory>>>;
};

export type PartnersCategory = {
  __typename?: 'PartnersCategory';
  /** #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  slug?: Maybe<Scalars['String']>;
};

export type PasswordProtectedSettingError = {
  __typename?: 'PasswordProtectedSettingError';
  message?: Maybe<Scalars['String']>;
};

export type PasswordProtectedSettingTokenInput = {
  password: Scalars['String'];
};

export type PasswordProtectedSettingTokenMutationResult = {
  passwordToken?: Maybe<Scalars['String']>;
  error?: Maybe<PasswordProtectedSettingError>;
};

export type PasswordProtectedSettingTokenMutationResultError = PasswordProtectedSettingTokenMutationResult & {
  __typename?: 'PasswordProtectedSettingTokenMutationResultError';
  passwordToken?: Maybe<Scalars['String']>;
  error?: Maybe<PasswordProtectedSettingError>;
};

export type PasswordProtectedSettingTokenMutationResultSuccess = PasswordProtectedSettingTokenMutationResult & {
  __typename?: 'PasswordProtectedSettingTokenMutationResultSuccess';
  passwordToken?: Maybe<Scalars['String']>;
  error?: Maybe<PasswordProtectedSettingError>;
};

/** Response for password changing mutation */
export type PasswordSetting = {
  __typename?: 'PasswordSetting';
  activePasswordErrors?: Maybe<Array<Scalars['String']>>;
  newPasswordErrors?: Maybe<Array<Scalars['String']>>;
  /** active password remaining attempts, after exhausting this attempts all active sessions of a user are terminated */
  activePasswordRemainingAttempts: Scalars['Int'];
};

/**
 * In order to change the password, both current password and the new
 * password must be provided.
 */
export type PasswordSettingInput = {
  /** current active password, will be verified upon change */
  activePassword: Scalars['String'];
  /** new desired password, should be between 4 and 1024 chars long, must not match first, last names, email or username. */
  newPassword: Scalars['String'];
};

/** Client for Payment & Billing */
export type PayBilClient = {
  __typename?: 'PayBilClient';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<TextSetting>;
  addressAddition?: Maybe<TextSetting>;
  street?: Maybe<TextSetting>;
  postcode?: Maybe<TextSetting>;
  city?: Maybe<TextSetting>;
  country?: Maybe<TextSetting>;
  taxId?: Maybe<TextSetting>;
  email?: Maybe<TextSetting>;
  language?: Maybe<TextSetting>;
  ccEmail?: Maybe<TextSetting>;
};

/** Input for Payment & Billing client */
export type PayBilClientInput = {
  name?: Maybe<TextSettingInput>;
  street?: Maybe<TextSettingInput>;
  postcode?: Maybe<TextSettingInput>;
  city?: Maybe<TextSettingInput>;
  country?: Maybe<SelectSettingInput>;
  email?: Maybe<TextSettingInput>;
  ccEmail?: Maybe<TextSettingInput>;
  taxId?: Maybe<TextSettingInput>;
  addressInfo?: Maybe<TextSettingInput>;
  addressAddition?: Maybe<TextSettingInput>;
  language?: Maybe<SelectSettingInput>;
};

export type PayBilClientMutationInput = {
  client: PayBilClientInput;
  withoutAuthorizedUser?: Maybe<Scalars['Boolean']>;
  embeddedBy?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['ID']>;
  testActionAllowed?: Maybe<Scalars['Boolean']>;
};

export type PayBilClientMutationInvalidDataError = {
  __typename?: 'PayBilClientMutationInvalidDataError';
  client?: Maybe<PayBilClient>;
};

export type PayBilClientMutationResult = PayBilClientMutationSuccess | PayBilClientMutationInvalidDataError | ErrorResponse;

export type PayBilClientMutationSuccess = {
  __typename?: 'PayBilClientMutationSuccess';
  client?: Maybe<PayBilClient>;
};

export type PayBilClientResponse = PayBilClient | ErrorResponse;

export type PaymentAccount = {
  __typename?: 'PaymentAccount';
  /** #soft-logged-in */
  id: Scalars['ID'];
  /**
   * #soft-logged-in
   *
   *  ISO-639 language code for invoice language e.g. 'de'
   */
  invoiceLanguage: PaymentInvoiceLanguage;
  /**
   * #soft-logged-in
   *
   *  Email address where user receives invoices and billing-related messages
   */
  emailCc?: Maybe<Scalars['Email']>;
  /**
   * #soft-logged-in
   *
   *  Personal or company tax ID
   */
  taxId?: Maybe<Scalars['String']>;
  /**
   * #soft-logged-in
   *
   *  The payment method data. e.g. credit card type, IBAN
   */
  paymentData?: Maybe<PaymentData>;
  /** A flag whether user has any open payments */
  paymentsDue?: Maybe<Scalars['Boolean']>;
  /**
   * #soft-logged-in
   *
   *  Billing address associated with the payment account
   */
  address?: Maybe<PaymentBillingAddress>;
};

export type PaymentAccountInput = {
  id?: Maybe<Scalars['ID']>;
  /** ISO-639 language code for invoice language e.g. 'de' */
  invoiceLanguage?: Maybe<TextSettingInput>;
  taxId?: Maybe<TextSettingInput>;
  emailCc?: Maybe<TextSettingInput>;
  paymentData?: Maybe<PaymentDataInput>;
  address?: Maybe<PaymentBillingAddressInput>;
};

export type PaymentAccountMutationResult = {
  __typename?: 'PaymentAccountMutationResult';
  success?: Maybe<PaymentAccount>;
  error?: Maybe<PaymentsSettingsError>;
};

export enum PaymentAccountType {
  Invoice = 'INVOICE',
  Sepa = 'SEPA',
  CreditCard = 'CREDIT_CARD',
  Paypal = 'PAYPAL'
}

export type PaymentAccounts = {
  __typename?: 'PaymentAccounts';
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<PaymentAccount>>>;
};

export type PaymentBillingAddress = {
  __typename?: 'PaymentBillingAddress';
  /** #soft-logged-in */
  academicTitle?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  firstName: Scalars['String'];
  /** #soft-logged-in */
  lastName: Scalars['String'];
  /** #soft-logged-in */
  company?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  street: Scalars['String'];
  /** #soft-logged-in */
  postcode?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  city: Scalars['String'];
  /** #soft-logged-in */
  province?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  country?: Maybe<CountryCodesAlpha2>;
  /** #soft-logged-in */
  gender: Gender;
};

export type PaymentBillingAddressInput = {
  id?: Maybe<Scalars['ID']>;
  academicTitle?: Maybe<TextSettingInput>;
  firstName?: Maybe<TextSettingInput>;
  lastName?: Maybe<TextSettingInput>;
  company?: Maybe<TextSettingInput>;
  street?: Maybe<TextSettingInput>;
  postcode?: Maybe<TextSettingInput>;
  city?: Maybe<TextSettingInput>;
  province?: Maybe<TextSettingInput>;
  country?: Maybe<CountryCodesAlpha2>;
  gender?: Maybe<TextSettingInput>;
};

/**
 * Products are divided into product groups.
 * See the source of [business_product.rb](https://source.xing.com/paybil/payment-billing/blob/master/app/models/products/clients/product/business_product.rb#L5)
 */
export enum PaymentClientProductGroup {
  Ad = 'AD',
  Bp = 'BP',
  Ev = 'EV',
  Gr = 'GR',
  Ja = 'JA',
  Pj = 'PJ',
  Pr = 'PR',
  Pp = 'PP',
  Pc = 'PC',
  Rm = 'RM',
  Tm = 'TM',
  Tp = 'TP',
  Ex = 'EX',
  Cd = 'CD',
  Pb = 'PB',
  Xf = 'XF',
  Xs = 'XS'
}

export enum PaymentCurrency {
  Eur = 'EUR',
  Chf = 'CHF',
  Usd = 'USD',
  Unk = 'UNK'
}

export type PaymentData = {
  __typename?: 'PaymentData';
  /**
   * #soft-logged-in
   *
   *  Two-character code identifying the account type.
   */
  type?: Maybe<PaymentAccountType>;
  /**
   * #soft-logged-in
   *
   *  CC-only: Expiration month
   */
  expiryMonth?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  CC-only: Expiration year
   */
  expiryYear?: Maybe<Scalars['Int']>;
  /**
   * #soft-logged-in
   *
   *  CC-only: brand name
   */
  brand?: Maybe<Scalars['String']>;
  /**
   * #soft-logged-in
   *
   *  CC-only: Masked account number
   */
  number?: Maybe<Scalars['String']>;
  /**
   * #soft-logged-in
   *
   *  CC and DD only: Account holder's name on the account
   */
  holder?: Maybe<Scalars['String']>;
  /**
   * #soft-logged-in
   *
   *  DD-only: IBAN on the direct debit/Sepa account
   */
  iban?: Maybe<Scalars['String']>;
  /**
   * #soft-logged-in
   *
   *  DD-only: SWIFT/BIC number on the direct debit/Sepa account
   */
  bic?: Maybe<Scalars['String']>;
  /**
   * #soft-logged-in
   *
   *  PP-only: Unique ID with PayPal for the established payment agreement
   */
  agreementId?: Maybe<Scalars['String']>;
};

export type PaymentDataInput = {
  /** Two-character code identifying the account type. */
  type?: Maybe<PaymentAccountType>;
  /** DD only: Account holder's name on the account */
  holder?: Maybe<TextSettingInput>;
  /** DD-only: IBAN on the direct debit/Sepa account */
  iban?: Maybe<TextSettingInput>;
  /** DD-only: SWIFT/BIC number on the direct debit/Sepa account */
  bic?: Maybe<TextSettingInput>;
};

export enum PaymentDurationType {
  Days = 'DAYS',
  Weeks = 'WEEKS',
  Months = 'MONTHS'
}

export type PaymentInvoice = {
  __typename?: 'PaymentInvoice';
  id: Scalars['ID'];
  date: Scalars['Date'];
  productGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  number: Scalars['String'];
  amount: PaymentPrice;
  status: PaymentInvoiceStatus;
  isCancellation: Scalars['Boolean'];
  isRegeneratable: Scalars['Boolean'];
  isCanceled: Scalars['Boolean'];
  dunningLevel: Scalars['Int'];
  downloadUrl: Scalars['String'];
  error?: Maybe<Scalars['String']>;
};

export enum PaymentInvoiceLanguage {
  En = 'EN',
  De = 'DE'
}

export enum PaymentInvoiceStatus {
  Open = 'OPEN',
  Paid = 'PAID',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Collecting = 'COLLECTING',
  Dunning = 'DUNNING',
  Resolved = 'RESOLVED',
  FirstReminder = 'FIRST_REMINDER',
  SecondReminder = 'SECOND_REMINDER',
  ThirdReminder = 'THIRD_REMINDER',
  FourthReminder = 'FOURTH_REMINDER',
  Encashment = 'ENCASHMENT',
  EncashmentFailed = 'ENCASHMENT_FAILED'
}

export type PaymentInvoices = {
  __typename?: 'PaymentInvoices';
  collection?: Maybe<Array<Maybe<PaymentInvoice>>>;
};

export enum PaymentMobileMerchant {
  Gplay = 'Gplay',
  ITunes = 'iTunes'
}

export type PaymentNotifications = {
  __typename?: 'PaymentNotifications';
  /** If the user has an expired credit card */
  expiredCreditCard: Scalars['Boolean'];
  /** Active subscriptions (product groups) that are paid via 'invoice' (Invoice, SEPA, Credit Card, PayPal) */
  activeInvoicedSubscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Active subscriptions (product groups) that aren't paid by 'invoice'. This indicates mobile subscriptions */
  subscriptionsPaidElsewhere?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** User is blocked from using features */
  blocked: Scalars['Boolean'];
  /** User is in dunning but not yet blocked. Sometimes called 'low dunning' */
  inNonBlockingDunning: Scalars['Boolean'];
  /** Maximum dunning level across all product groups */
  maxDunningLevel: Scalars['Int'];
};

/** Price with the ISO currency code and the amount in cents; not decimal */
export type PaymentPrice = {
  __typename?: 'PaymentPrice';
  /** ISO-4217 currency codes. e.g. EUR, USD, CHF */
  currency?: Maybe<PaymentCurrency>;
  /** Amount in cents. e.g. 25.17 EUR would be 2517 */
  amountCents?: Maybe<Scalars['Int']>;
  /** Net amount in cents. e.g. 25.17 EUR would be 2517 */
  netAmountCents?: Maybe<Scalars['Int']>;
};

/**
 * Represents a subscription the user has or had. There will only be one subscription
 * per productGroup such as Premium, News, ProBusiness.
 */
export type PaymentSubscription = {
  __typename?: 'PaymentSubscription';
  productGroup: Scalars['String'];
  /** Name of the product in English or German. Will be in English if user's language is anything but German */
  description: Scalars['String'];
  /** Google or Apple if this is a mobile subscription */
  merchant?: Maybe<PaymentMobileMerchant>;
  price?: Maybe<PaymentPrice>;
  isRunning: Scalars['Boolean'];
  /** If the subscription is active and providing features */
  isActive: Scalars['Boolean'];
  /** If the subscription is ended */
  isEnded: Scalars['Boolean'];
  /** If the subscription is canceled */
  isCanceled: Scalars['Boolean'];
  /** Date when the subscription was ended or canceled */
  endedOn?: Maybe<Scalars['Date']>;
  /** Features from the subscription are blocked, usually due to non-payment */
  isBlocked: Scalars['Boolean'];
  /** Subscription is currently in a bonus period */
  inBonus: Scalars['Boolean'];
  /** If the subscription is paused. Features not granted, accounting paused */
  isPaused: Scalars['Boolean'];
  /** If the subscription is endable */
  isEndable: Scalars['Boolean'];
  /** If the contract is paused, the date on which it will automatically unpause */
  unpauseOn?: Maybe<Scalars['Date']>;
  runtime: PaymentSubscriptionRuntime;
  /** A subscription will have one or more statuses such as past, future, cancelled, paused, current. */
  statuses?: Maybe<Array<Maybe<PaymentSubscriptionStatus>>>;
  /** When the current period of the subscription ends. It might renew though! */
  endsOn: Scalars['Date'];
  /** If this is a recurring subscription and will renew after the `endsOn` date */
  willRenew: Scalars['Boolean'];
  renewal?: Maybe<PaymentSubscriptionRenewal>;
};

export type PaymentSubscriptionRenewal = {
  __typename?: 'PaymentSubscriptionRenewal';
  /** Date of the first day of the new contract period */
  startDate?: Maybe<Scalars['Date']>;
  /** Price after renewal. Can change if the user had an introductory price */
  price?: Maybe<PaymentPrice>;
  /** Runtime of the renewal (next) contract */
  runtime?: Maybe<PaymentSubscriptionRuntime>;
  /** If the renewal is a bonus */
  isBonus: Scalars['Boolean'];
};

/** Duration of a subscription. Typically 3, 6, or 12 months */
export type PaymentSubscriptionRuntime = {
  __typename?: 'PaymentSubscriptionRuntime';
  /** Duration interval. For example a 3 month subscription, this field is 3 */
  duration: Scalars['Int'];
  /** Duration type. Either 'days', 'weeks', or 'months' */
  durationType: PaymentDurationType;
};

/** See the source of [contract_decorator.rb](https://source.xing.com/paybil/payment-billing/blob/master/app/decorators/contract_decorator.rb) */
export enum PaymentSubscriptionStatus {
  Past = 'PAST',
  Future = 'FUTURE',
  Canceled = 'CANCELED',
  InvoiceCanceled = 'INVOICE_CANCELED',
  Ended = 'ENDED',
  Paused = 'PAUSED',
  Current = 'CURRENT',
  Subscription = 'SUBSCRIPTION',
  ResumeDisabled = 'RESUME_DISABLED'
}

export type PaymentSubscriptions = {
  __typename?: 'PaymentSubscriptions';
  collection?: Maybe<Array<Maybe<PaymentSubscription>>>;
};

export type PaymentsAttributeMessage = {
  __typename?: 'PaymentsAttributeMessage';
  /** #soft-logged-in */
  attribute?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PaymentsSettingsError = {
  __typename?: 'PaymentsSettingsError';
  errors?: Maybe<Array<Maybe<PaymentsAttributeMessage>>>;
};

export type PaypalUrl = {
  __typename?: 'PaypalUrl';
  /**
   * #soft-logged-in
   *
   *  url for paypal payment flow / pop-up
   */
  url?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  errors?: Maybe<Array<Maybe<PaymentsAttributeMessage>>>;
};

export type PdfDescription = {
  __typename?: 'PdfDescription';
  /** #logged-out #soft-logged-in */
  htmlContent: Scalars['String'];
  /** #logged-out #soft-logged-in */
  previewImage?: Maybe<PdfPreviewImage>;
  /** #logged-out #soft-logged-in */
  pdfUrl?: Maybe<Scalars['URL']>;
};

export type PdfPreviewImage = {
  __typename?: 'PdfPreviewImage';
  /** #logged-out #soft-logged-in */
  image870x: Scalars['URL'];
};

export type PendingNameGenderSetting = HasGlobalId & {
  __typename?: 'PendingNameGenderSetting';
  value?: Maybe<Scalars['String']>;
  /** Globally unique id for this instance */
  globalId: Scalars['GlobalID'];
};

export type PendingNameGenderSettingInput = {
  firstName?: Maybe<TextSettingInput>;
  lastName?: Maybe<TextSettingInput>;
  birthName?: Maybe<TextSettingInput>;
  gender?: Maybe<SelectSettingInput>;
  academicTitle?: Maybe<SelectSettingInput>;
  explanation?: Maybe<TextSettingInput>;
};

export type PendingNameGenderSettings = {
  __typename?: 'PendingNameGenderSettings';
  firstName?: Maybe<PendingNameGenderSetting>;
  lastName?: Maybe<PendingNameGenderSetting>;
  birthName?: Maybe<PendingNameGenderSetting>;
  gender?: Maybe<PendingNameGenderSetting>;
  academicTitle?: Maybe<PendingNameGenderSetting>;
  explanation?: Maybe<PendingNameGenderSetting>;
};

export type PeopleBreadcrumbsItem = {
  __typename?: 'PeopleBreadcrumbsItem';
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
};

export type PeopleByCityChunkPage = {
  __typename?: 'PeopleByCityChunkPage';
  /** #logged-out #soft-logged-in */
  country?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  city?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  letter?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  toName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  page?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  totalPages?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  breadcrumbs?: Maybe<Array<Maybe<PeopleBreadcrumbsItem>>>;
  /** #logged-out #soft-logged-in */
  names?: Maybe<Array<Maybe<PeopleDirectoryItem>>>;
};

export type PeopleByCityTopLevelPage = {
  __typename?: 'PeopleByCityTopLevelPage';
  /** #logged-out #soft-logged-in */
  country?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  city?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  letter?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  breadcrumbs?: Maybe<Array<Maybe<PeopleBreadcrumbsItem>>>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  toName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  names?: Maybe<Array<Maybe<PeopleDirectoryItem>>>;
  /** #logged-out #soft-logged-in */
  popularNames?: Maybe<Array<Maybe<PeopleUserBagItem>>>;
};

export type PeopleByCityUserBagPage = {
  __typename?: 'PeopleByCityUserBagPage';
  /** #logged-out #soft-logged-in */
  city?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  page?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  totalPages?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  count?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  breadcrumbs?: Maybe<Array<Maybe<PeopleBreadcrumbsItem>>>;
  /** #logged-out #soft-logged-in */
  names?: Maybe<Array<Maybe<PeopleProfileItem>>>;
};

export type PeopleChildItem = {
  __typename?: 'PeopleChildItem';
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  toName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
};

export type PeopleChunkPage = {
  __typename?: 'PeopleChunkPage';
  /** #logged-out #soft-logged-in */
  letter?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  toName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  page?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  totalPages?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  cities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #logged-out #soft-logged-in */
  breadcrumbs?: Maybe<Array<Maybe<PeopleBreadcrumbsItem>>>;
  /** #logged-out #soft-logged-in */
  names?: Maybe<Array<Maybe<PeopleDirectoryItem>>>;
};

export type PeopleCitiesTopLevelPage = {
  __typename?: 'PeopleCitiesTopLevelPage';
  /** #logged-out #soft-logged-in */
  cityTopLevelPages?: Maybe<Array<Maybe<PeopleCityTopLevelPage>>>;
};

export type PeopleCityPage = {
  __typename?: 'PeopleCityPage';
  /** #logged-out #soft-logged-in */
  city?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  country?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  breadcrumbs?: Maybe<Array<Maybe<PeopleBreadcrumbsItem>>>;
  /** #logged-out #soft-logged-in */
  letters?: Maybe<Array<Maybe<PeopleLetterForCity>>>;
};

export type PeopleCityTopLevelPage = {
  __typename?: 'PeopleCityTopLevelPage';
  /** #logged-out #soft-logged-in */
  cityName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  exampleNames?: Maybe<Array<Maybe<PeopleUserBagItem>>>;
};

export type PeopleDirectoryItem = PeopleProfileItem | PeopleUserBagItem | PeopleChildItem;

export type PeopleLetterForCity = {
  __typename?: 'PeopleLetterForCity';
  /** #logged-out #soft-logged-in */
  letter?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  topUserBags?: Maybe<Array<Maybe<PeopleUserBagItem>>>;
};

export type PeopleLetterTopLevelPage = {
  __typename?: 'PeopleLetterTopLevelPage';
  /** #logged-out #soft-logged-in */
  letter?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  exampleNames?: Maybe<Array<Maybe<PeopleUserBagItem>>>;
};

export type PeopleProfileItem = {
  __typename?: 'PeopleProfileItem';
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  photoUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  coach?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  occupationTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  city?: Maybe<Scalars['String']>;
};

export type PeopleStartPage = {
  __typename?: 'PeopleStartPage';
  /** #logged-out #soft-logged-in */
  letterTopLevelPages?: Maybe<Array<Maybe<PeopleLetterTopLevelPage>>>;
  /** #logged-out #soft-logged-in */
  cityTopLevelPages?: Maybe<Array<Maybe<PeopleCityTopLevelPage>>>;
  /** #logged-out #soft-logged-in */
  seeMore?: Maybe<Scalars['String']>;
};

export type PeopleStoryGeneratorMymkRecommendation = {
  __typename?: 'PeopleStoryGeneratorMymkRecommendation';
  id: Scalars['ID'];
  urn: Scalars['GlobalID'];
  trackingToken: Scalars['String'];
  reasons: Array<Scalars['String']>;
  position: Scalars['Int'];
};

export type PeopleStoryGeneratorProfileUpdate = {
  id: Scalars['ID'];
  profileId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
};

export type PeopleTopLevelPage = {
  __typename?: 'PeopleTopLevelPage';
  /** #logged-out #soft-logged-in */
  letter?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  breadcrumbs?: Maybe<Array<Maybe<PeopleBreadcrumbsItem>>>;
  /** #logged-out #soft-logged-in */
  names?: Maybe<Array<Maybe<PeopleDirectoryItem>>>;
  /** #logged-out #soft-logged-in */
  popularNames?: Maybe<Array<Maybe<PeopleUserBagItem>>>;
};

export type PeopleUserBagConnection = HasCursorPagination & {
  __typename?: 'PeopleUserBagConnection';
  /** #logged-out #soft-logged-in */
  edges?: Maybe<Array<Maybe<PeopleUserBagConnectionEdge>>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
  /** #logged-out #soft-logged-in */
  userBagUrl?: Maybe<Scalars['URL']>;
};

export type PeopleUserBagConnectionEdge = PaginationEdge & {
  __typename?: 'PeopleUserBagConnectionEdge';
  /** #logged-out #soft-logged-in */
  node: RelatedProfile;
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
};

export type PeopleUserBagItem = {
  __typename?: 'PeopleUserBagItem';
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  count?: Maybe<Scalars['Int']>;
};

export type PeopleUserBagPage = {
  __typename?: 'PeopleUserBagPage';
  /** #logged-out #soft-logged-in */
  letter?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  page?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  totalPages?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  count?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  cities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #logged-out #soft-logged-in */
  breadcrumbs?: Maybe<Array<Maybe<PeopleBreadcrumbsItem>>>;
  /** #logged-out #soft-logged-in */
  names?: Maybe<Array<Maybe<PeopleProfileItem>>>;
};

export type PersonMakeFriend = {
  __typename?: 'PersonMakeFriend';
  urn: Scalars['GlobalID'];
  /** #rest(batched) #virtual */
  contact?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  newContact?: Maybe<XingId>;
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PersonalDetails = HasDerivedGlobalId & {
  __typename?: 'PersonalDetails';
  /** Id of the user */
  id: Scalars['ID'];
  /** Birth date of the user */
  birthDate?: Maybe<BirthDate>;
  /** Birth name of the user */
  birthName?: Maybe<Scalars['String']>;
  /** Globally unique id for this instance based on typename and id */
  globalId: Scalars['GlobalID'];
};

export type PersonalDetailsError = {
  __typename?: 'PersonalDetailsError';
  birthName?: Maybe<Array<Scalars['String']>>;
  birthDate?: Maybe<Array<Scalars['String']>>;
};

/** Profile Module Personal Details */
export type PersonalDetailsModule = ModuleInterface & {
  __typename?: 'PersonalDetailsModule';
  title: Scalars['String'];
  order: Scalars['Int'];
  /** #rest(batched) #virtual */
  personalDetails?: Maybe<PersonalDetails>;
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type PersonalDetailsUpdateError = {
  __typename?: 'PersonalDetailsUpdateError';
  message?: Maybe<Scalars['String']>;
  errors?: Maybe<PersonalDetailsError>;
};

export type PersonalDetailsUpdateInput = {
  /** Birth date of the user */
  birthDate?: Maybe<BirthDateUpdateInput>;
  /** Birth name of the user */
  birthName?: Maybe<Scalars['String']>;
};

export type PersonalDetailsUpdateResult = {
  __typename?: 'PersonalDetailsUpdateResult';
  /** #rest(batched) #virtual */
  success?: Maybe<PersonalDetails>;
  error?: Maybe<PersonalDetailsUpdateError>;
};

/**
 * "
 * A standard container for telephone numbers based on the [E.164](https://en.wikipedia.org/wiki/E.164) standard.
 *
 * This container offers support for also exposing telephone numbers which are not valid according to the standard via the mandatory raw field. Use this to enable update by the user on next save.
 *
 * Expected behaviour:
 *
 * If the telephone number is present and valid, all fields should be filled.
 * If the telephone number is invalid, only raw is filled while the rest of the fields are set to null.
 * The whole object should be null in the parent in the absence of a telephone number.
 */
export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  /**
   * #logged-out #soft-logged-in
   *
   *  The ISO-3166-1 country code of the telephone number
   */
  countryCode?: Maybe<CountryCodesAlpha2>;
  /**
   * #logged-out #soft-logged-in
   *
   *  The phone number in the internationally formatted E.164 format for display purposes
   */
  internationalFormat?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  The telephone number in the E.164 format
   */
  phoneNumber?: Maybe<Scalars['PhoneNumberE164']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Raw underlying value. Caution this can be potentially not valid E1.164
   */
  raw?: Maybe<Scalars['String']>;
};


export enum PhonePreferenceDays {
  EveryDay = 'EVERY_DAY',
  WorkingDays = 'WORKING_DAYS',
  Weekend = 'WEEKEND'
}

export type PhonePreferenceTime = Localizable & {
  __typename?: 'PhonePreferenceTime';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
};

/** Phone Preferences */
export type PhonePreferences = SpecificTimePhonePreferences | AnyTimePhonePreferences;

export enum PhonePreferencesOptions {
  AnyTime = 'ANY_TIME',
  SpecificTime = 'SPECIFIC_TIME'
}

/** Active and pending phone numbers */
export type PhoneSetting = HasGlobalId & {
  __typename?: 'PhoneSetting';
  /** current phone number */
  active?: Maybe<Scalars['PhoneNumberE164']>;
  /** new phone number the user has submitted, not verified yet */
  pending?: Maybe<Scalars['PhoneNumberE164']>;
  errors?: Maybe<Array<Scalars['String']>>;
  /** Globally unique id for this instance */
  globalId: Scalars['GlobalID'];
};

/**
 * Used to set new phone number, and to verify the change.
 * Only one of the fields should be submitted
 */
export type PhoneSettingInput = {
  /** new phone number, will need to be confirmed using an SMS code */
  pending?: Maybe<Scalars['PhoneNumberE164']>;
  /** code to confirm new phone number, received by SMS */
  activationCode?: Maybe<Scalars['String']>;
  passwordToken?: Maybe<Scalars['String']>;
};

export type PollJobsEasyCreateAiJobGenerationResult = PollJobsEasyCreateAiJobGenerationSuccess | JobsEasyCreateAiJobGenerationError;

export type PollJobsEasyCreateAiJobGenerationSuccess = {
  __typename?: 'PollJobsEasyCreateAIJobGenerationSuccess';
  /** #logged-out #soft-logged-in */
  status: JobsEasyCreateAiJobGenerationPollStatus;
  /** #logged-out #soft-logged-in */
  jobId?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  result?: Maybe<JobsEasyCreateAiJobGenerationSuccess>;
};

export type PollJobsEasyCreateEcomPurchaseResolverResult = PollJobsEasyCreateEcomPurchaseResolverSuccess | JobsEasyCreateEcomPurchaseError;

export type PollJobsEasyCreateEcomPurchaseResolverSuccess = {
  __typename?: 'PollJobsEasyCreateEcomPurchaseResolverSuccess';
  /** #logged-out #soft-logged-in */
  status: JobsEasyCreateEcomPurchasePollStatus;
  /** #logged-out #soft-logged-in */
  jobId?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  result?: Maybe<JobsEasyCreateEcomPurchaseSuccess>;
};

export type PollOptionInput = {
  text: Scalars['String'];
};

/**
 * A posting that can be created in the commbox.
 * Every published posting is made visible by a corresponding startpage story.
 */
export type PostingActor = XingId | EntityPage;

export enum PostingAdSubType {
  LinkShare = 'LINK_SHARE',
  Image = 'IMAGE'
}

/** indicates whether the posting has been spread by startpage */
export enum PostingPublicationState {
  /** the posting has not yet been spread */
  Draft = 'DRAFT',
  /** the posting has already been spread */
  Published = 'PUBLISHED',
  /** the posting is going to be spread at the time specified in `published_at` */
  Scheduled = 'SCHEDULED',
  /** a spread posting is no longer visible */
  Hidden = 'HIDDEN'
}

/** When you would like your posting to be published */
export enum PostingPublicationStrategy {
  /** create, publish and spread the posting immediately */
  Now = 'NOW',
  /** create posting as a draft, without spreading */
  Later = 'LATER'
}

export type PostingsArticleAttachment = PostingsAttachment & {
  __typename?: 'PostingsArticleAttachment';
  /** #logged-out #soft-logged-in #rest #virtual */
  article?: Maybe<ArticlesArticle>;
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
};


export type PostingsArticleAttachmentArticleArgs = {
  supportedBlockTypes?: Array<ArticleSupportedBlockTypes>;
};

export type PostingsAttachment = {
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
};

export type PostingsAttachmentMutationResult = {
  __typename?: 'PostingsAttachmentMutationResult';
  success?: Maybe<PostingsAttachment>;
  error?: Maybe<PostingsError>;
};

export enum PostingsAvailablePostingTypes {
  PlainTextPosting = 'PLAIN_TEXT_POSTING',
  ArticlePosting = 'ARTICLE_POSTING',
  ImagePosting = 'IMAGE_POSTING',
  LinkSharePosting = 'LINK_SHARE_POSTING',
  VideoPosting = 'VIDEO_POSTING',
  PollPosting = 'POLL_POSTING'
}

export type PostingsBatchStoryInput = {
  /**
   * Defines the story's type.
   * Text and Image stories have an Image medium, whereas video stories have a video.
   * While text and image stories behave near identical, we still need the right type for tracking.
   */
  storyType: StoryType;
  /** see PostingsStory.text */
  text?: Maybe<Scalars['String']>;
  /**
   * must be an uploadId of an image
   * Story type image or text requires an uploadId. Story type video ignores this
   */
  uploadId?: Maybe<Scalars['UploadId']>;
  /**
   * GlobalID of an uploaded video that has not been processed yet.
   * The owner of the video should be the story's story group.
   * Story type video requires a videoUrn. Story types image and text ignore this
   */
  videoUrn?: Maybe<Scalars['GlobalID']>;
};

export type PostingsCreateImageAttachmentInput = {
  /** a hash representing the id of the uploaded image in the upload service */
  uploadId: Scalars['String'];
};

export type PostingsCreateLinkAttachmentInput = {
  url: Scalars['URL'];
  customTitle?: Maybe<Scalars['String']>;
  customDescription?: Maybe<Scalars['String']>;
  /** a hash representing the id of the uploaded image in the upload service */
  customImageUploadId?: Maybe<Scalars['String']>;
};

export type PostingsCreatePollAttachmentInput = {
  question: Scalars['String'];
  /** An integer representing the days from now that the poll is open */
  openDays: Scalars['Int'];
  options: Array<PollOptionInput>;
};

export type PostingsCreatePostingInput = {
  /** on whose behalf this posting shall be posted */
  actorGlobalId: Scalars['GlobalID'];
  /**
   * the context to which the posting belongs
   * possible values currently are, but will not necessarily
   * be limited to, discussion module global ids
   */
  targetGlobalId?: Maybe<Scalars['GlobalID']>;
  /** legacy plaintext format */
  comment?: Maybe<Scalars['String']>;
  /** new comment format that allows for @mentions; will eventually outmode the `comment` field */
  commentArticleV1?: Maybe<Array<ArticlesCreateArticleBlocksInput>>;
  publicationStrategy?: Maybe<PostingPublicationStrategy>;
  /** who should be able to see this posting */
  visibility?: Maybe<PostingsVisibility>;
  publishAt?: Maybe<Scalars['Date']>;
  /** upload ids of images to be attached */
  images?: Maybe<Array<PostingsCreateImageAttachmentInput>>;
  /** urls of links to be shared */
  links?: Maybe<Array<PostingsCreateLinkAttachmentInput>>;
  /** pre-uploaded and processed videos to be attached */
  videos?: Maybe<Array<PostingsCreateVideoAttachmentInput>>;
  /** poll data to be created */
  polls?: Maybe<Array<PostingsCreatePollAttachmentInput>>;
  /**
   * A list of AGIs that define the audience which should receive this posting
   * https://new-work.atlassian.net/wiki/spaces/RAC/pages/55182221/Actor+Group+Identifiers+-+AGIs
   * If omitted, a default is picked depending on the posting's actor:
   * - `users:user`: the user's network, `["urn:x-xing:contacts:network:<user-id>"]`
   * - `entitypage:page`: its followers `["urn:x-xing:entitypages:page:<user-id>:followers"]`
   */
  audience?: Maybe<Array<Scalars['GlobalID']>>;
};

export type PostingsCreateRssImporterInput = {
  /** on whose behalf this importer shall post */
  actorGlobalId: Scalars['GlobalID'];
  /** the feed's URL */
  url: Scalars['URL'];
};

export type PostingsCreateStoryGroupInput = {
  /**
   * The actor on whose behalf the story group is created.
   * Will check whether the current user is allowed to impersonate this actor
   */
  actorGlobalId: Scalars['GlobalID'];
};

export type PostingsCreateStoryInput = {
  /**
   * the actor on whose behalf this is created.
   * A permission check is performed whether the current user is allowed to
   * create stories on behalf of this actor
   */
  actorGlobalId: Scalars['GlobalID'];
  /**
   * lets the Backend know if this image was uploaded by the users or generated from text by the client app
   * Mostly for tracking and our statistics
   */
  storyType: StoryType;
  /** see PostingsStory.text */
  text?: Maybe<Scalars['String']>;
  /** must be an uploadId of an image */
  uploadId: Scalars['UploadId'];
  /**
   * A list of AGIs that define the audience which should receive this story
   * https://new-work.atlassian.net/wiki/spaces/RAC/pages/55182221/Actor+Group+Identifiers+-+AGIs
   * If omitted, a default is picked depending on the story's actor:
   * - `users:user`: the user's network, `["urn:x-xing:contacts:network:<user-id>"]`
   * - `entitypage:page`: nil
   */
  audience?: Maybe<Array<Scalars['GlobalID']>>;
};

export type PostingsCreateTwitterImporterInput = {
  /** on whose behalf this importer shall post */
  actorGlobalId: Scalars['GlobalID'];
  /** the twitter account's handle */
  handle: Scalars['String'];
};

export type PostingsCreateVideoAttachmentInput = {
  /**
   * ID of a previously uploaded and processed video
   * Typically this video should have been uploaded specifically for posting it
   * Caution: The postings service will assume ownership of this video and,
   * should the posting get deleted, also delete the video
   */
  videoId: Scalars['SlugOrID'];
};

export type PostingsDeleteImporterInput = {
  /** reference to the importer that is to be deleted */
  globalId: Scalars['GlobalID'];
};

export type PostingsDeleteMyMentionsInput = {
  /** GlobalID of the posting which includes mentions of you that you would like to delete. */
  globalId: Scalars['GlobalID'];
};

export type PostingsDeletePostingInput = {
  id: Scalars['ID'];
  /**
   * Actor on whose behalf the posting should be deleted.
   * Defaults to the posting's own actorGlobalId
   */
  actorGlobalId?: Maybe<Scalars['GlobalID']>;
};

export type PostingsDeleteStoryInput = {
  id: Scalars['ID'];
  /**
   * Actor on whose behalf the story should be deleted.
   * Defaults to the story's own actorGlobalId
   */
  actorGlobalId?: Maybe<Scalars['GlobalID']>;
};

export type PostingsError = {
  __typename?: 'PostingsError';
  /** what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  details?: Maybe<Array<Scalars['String']>>;
};

export type PostingsImageAttachment = PostingsAttachment & StoryMedium & {
  __typename?: 'PostingsImageAttachment';
  /** #logged-out #soft-logged-in */
  uuid: Scalars['UUID'];
  /** #logged-out #soft-logged-in #virtual */
  images?: Maybe<Array<ScaledImage>>;
  /** #rest(batched) #virtual */
  imageMetadata?: Maybe<OriginalImageMetadata>;
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
};


export type PostingsImageAttachmentImagesArgs = {
  dimensions: Array<ScaledImageDimension>;
};

export type PostingsImporters = {
  __typename?: 'PostingsImporters';
  /** #expand */
  rssImporters: Array<PostingsRssFeed>;
  /** #expand */
  twitterImporters: Array<PostingsTwitterTimeline>;
};

export type PostingsLinkAttachment = PostingsAttachment & {
  __typename?: 'PostingsLinkAttachment';
  /** #logged-out #soft-logged-in */
  url: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  customTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  customDescription?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #virtual */
  customImages?: Maybe<Array<ScaledImage>>;
  /** #logged-out #soft-logged-in #rest #virtual */
  link?: Maybe<SocialExternalLinkResult>;
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
};


export type PostingsLinkAttachmentCustomImagesArgs = {
  dimensions: Array<ScaledImageDimension>;
};

export type PostingsPaginatedCollectionMetadata = {
  __typename?: 'PostingsPaginatedCollectionMetadata';
  publishedTotal?: Maybe<Scalars['Int']>;
  hiddenTotal?: Maybe<Scalars['Int']>;
};

export type PostingsPaginatedPostingConnection = HasCursorPagination & {
  __typename?: 'PostingsPaginatedPostingConnection';
  /** #logged-out #soft-logged-in #rest #virtual */
  pinnedPostings?: Maybe<PostingsPostingCollection>;
  /** #logged-out #soft-logged-in */
  pageInfo: PageInfo;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
  metadata?: Maybe<PostingsPaginatedCollectionMetadata>;
  /** #logged-out #soft-logged-in */
  edges: Array<PostingsPaginatedPostingEdge>;
};


export type PostingsPaginatedPostingConnectionPinnedPostingsArgs = {
  supportedObjectTypes: Array<PostingsAvailablePostingTypes>;
};

export type PostingsPaginatedPostingEdge = PaginationEdge & {
  __typename?: 'PostingsPaginatedPostingEdge';
  /** #logged-out #soft-logged-in */
  cursor: Scalars['String'];
  /** #logged-out #soft-logged-in */
  node: PostingsPosting;
};

export type PostingsPinActivityByTargetInput = {
  activityId: Scalars['ID'];
  targetGlobalId: Scalars['GlobalID'];
};

export type PostingsPinActivityInput = {
  activityId: Scalars['ID'];
  entityPageId: Scalars['ID'];
};

export type PostingsPinActivityResult = {
  __typename?: 'PostingsPinActivityResult';
  success?: Maybe<PostingsPinnedActivity>;
  error?: Maybe<PostingsError>;
};

export type PostingsPinnedActivity = {
  __typename?: 'PostingsPinnedActivity';
  activityId: Scalars['ID'];
  entityPageId: Scalars['ID'];
  targetGlobalId?: Maybe<Scalars['GlobalID']>;
};

export type PostingsPollAttachment = PostingsAttachment & {
  __typename?: 'PostingsPollAttachment';
  /** #logged-out #soft-logged-in */
  question: Scalars['String'];
  /** #logged-out #soft-logged-in */
  secondsLeft: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  votes: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  votedOption?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  participantsIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #logged-out #soft-logged-in */
  isCreator: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  isClosed: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  options: Array<PostingsPollOption>;
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
};

export type PostingsPollOption = {
  __typename?: 'PostingsPollOption';
  /** #logged-out #soft-logged-in */
  id: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
  /** #logged-out #soft-logged-in */
  percentage?: Maybe<Scalars['Int']>;
};

export type PostingsPopulateStoryGroupInput = {
  /** ID of the story group that you'd like to populate */
  storyGroupGlobalId: Scalars['GlobalID'];
  /**
   * A list of AGIs that define the audience which should receive this story
   * https://new-work.atlassian.net/wiki/spaces/RAC/pages/55182221/Actor+Group+Identifiers+-+AGIs
   * If omitted, a default is picked depending on the story's actor:
   * - `users:user`: the user's network, `["urn:x-xing:contacts:network:<user-id>"]`
   * - `entitypage:page`: nil
   */
  audience?: Maybe<Array<Scalars['GlobalID']>>;
  stories: Array<PostingsBatchStoryInput>;
};

export type PostingsPosting = HasOperationalDataTrackingTokens & {
  __typename?: 'PostingsPosting';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  on whose behalf this posting has been posted. E.g. a page or the user themself. Becomes the actor of the corresponding startpage story
   */
  actorGlobalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  actor?: Maybe<PostingActor>;
  /**
   * #logged-out #soft-logged-in
   *
   *  A comment on the posted content. Sometimes the only content of a posting.
   */
  comment: Scalars['String'];
  /** #logged-out #soft-logged-in */
  commentArticleV1?: Maybe<Array<ArticleBlock>>;
  /**
   * #logged-out #soft-logged-in
   *
   *  whether the posting's comment/commentArticleV1 property has been changed
   */
  edited: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  publicationState: PostingPublicationState;
  /**
   * #logged-out #soft-logged-in
   *
   *  When the posting has been - or is going to be - published
   * For published postings this lies in the past
   * For scheduled postings it is in the future
   * For draft postings it is null
   */
  publishedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  createdAt: Scalars['Date'];
  /**
   * #logged-out #soft-logged-in
   *
   *  who should be able to see this posting
   */
  visibility: PostingsVisibility;
  /** #logged-out #soft-logged-in */
  attachments: Array<PostingsAttachment>;
  /** a posting's activity is created when the posting gets published */
  activityId?: Maybe<Scalars['ID']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  see activityId
   */
  activityGlobalId?: Maybe<Scalars['GlobalID']>;
  /**
   * #rest(batched) #virtual
   *
   *  the social interaction target of the posting (to query mention permissions)
   */
  interactionTarget?: Maybe<SocialInteractionTarget>;
  actions?: Maybe<PostingsPostingActions>;
  /** #logged-out #soft-logged-in */
  targetGlobalId?: Maybe<Scalars['GlobalID']>;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PostingsPostingActions = {
  __typename?: 'PostingsPostingActions';
  canEdit: Scalars['Boolean'];
  canDelete: Scalars['Boolean'];
  canPin: Scalars['Boolean'];
  canHide: Scalars['Boolean'];
};

export type PostingsPostingCollection = {
  __typename?: 'PostingsPostingCollection';
  /** #logged-out #soft-logged-in */
  collection: Array<PostingsPosting>;
};

export type PostingsPostingDeleteResult = {
  __typename?: 'PostingsPostingDeleteResult';
  error?: Maybe<PostingsError>;
};

export type PostingsPostingMutationResult = {
  __typename?: 'PostingsPostingMutationResult';
  success?: Maybe<PostingsPosting>;
  error?: Maybe<PostingsError>;
};

export type PostingsPublishPostingInput = {
  id: Scalars['ID'];
  /**
   * Actor on whose behalf the posting should be published.
   * Defaults to the posting's own actorGlobalId
   */
  actorGlobalId?: Maybe<Scalars['GlobalID']>;
};

export type PostingsRssFeed = {
  __typename?: 'PostingsRssFeed';
  globalId: Scalars['GlobalID'];
  url: Scalars['URL'];
};

export type PostingsRssImporterMutationResult = {
  __typename?: 'PostingsRssImporterMutationResult';
  success?: Maybe<PostingsRssFeed>;
  error?: Maybe<PostingsError>;
};

/**
 * Stories consist of an image, or a text that is rendered as an image.
 * They are shared to contacts privately. Interaction like commenting happens
 * privately as well, via private messages. Stories are subject to ephemerality,
 * i.e. they are deleted after a while.
 */
export type PostingsStory = HasOperationalDataTrackingTokens & {
  __typename?: 'PostingsStory';
  globalID: Scalars['GlobalID'];
  actorGlobalId: Scalars['GlobalID'];
  activityGlobalId?: Maybe<Scalars['GlobalID']>;
  /** #rest(batched) #virtual */
  actor?: Maybe<StoryActor>;
  storyType: StoryType;
  /** @deprecated use postedAt instead. It's the same date, except it can be null when required. WILL BE REMOVED ... */
  createdAt: Scalars['Date'];
  /** When the story was posted. `null` for demo stories. */
  postedAt?: Maybe<Scalars['Date']>;
  expiresAt?: Maybe<Scalars['Date']>;
  /** Indicates whether the user has already seen this story */
  hasSeen: Scalars['Boolean'];
  /** A text that describes or adds information to the story's medium */
  text?: Maybe<Scalars['String']>;
  /**
   * Token used to join Delivery and Tracking events used in Operational Tracking
   * https://operational-tracking.xing.io/tracking_token/
   */
  metadata?: Maybe<PostingsStoryMetadata>;
  interactions: StoryInteractions;
  /**
   * #virtual
   *
   *  the image makes up the content of a story
   * @deprecated Please use medium instead.
   */
  images?: Maybe<Array<ScaledImage>>;
  medium: StoryMedium;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/**
 * Stories consist of an image, or a text that is rendered as an image.
 * They are shared to contacts privately. Interaction like commenting happens
 * privately as well, via private messages. Stories are subject to ephemerality,
 * i.e. they are deleted after a while.
 */
export type PostingsStoryImagesArgs = {
  dimensions: Array<ScaledImageDimension>;
};

export type PostingsStoryMetadata = {
  __typename?: 'PostingsStoryMetadata';
  /** Unique viewers of this story. `null` indicates missing permission to access this field. */
  uniqueUserViews?: Maybe<Scalars['Int']>;
};

/**
 * not much of a promise yet, but can be extended to support polling until the
 * story has been processed
 */
export type PostingsStoryPromise = HasOperationalDataTrackingTokens & {
  __typename?: 'PostingsStoryPromise';
  globalId: Scalars['GlobalID'];
  actorGlobalId: Scalars['GlobalID'];
  text?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  expiresAt?: Maybe<Scalars['Date']>;
  storyType: StoryType;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PostingsToggleHiddenPostingInput = {
  id: Scalars['ID'];
  /**
   * Actor on whose behalf the posting should be hidden or unhidden.
   * Defaults to the posting's own actorGlobalId
   */
  actorGlobalId?: Maybe<Scalars['GlobalID']>;
};

export type PostingsTwitterImporterMutationResult = {
  __typename?: 'PostingsTwitterImporterMutationResult';
  success?: Maybe<PostingsTwitterTimeline>;
  error?: Maybe<PostingsError>;
};

export type PostingsTwitterTimeline = {
  __typename?: 'PostingsTwitterTimeline';
  globalId: Scalars['GlobalID'];
  handle: Scalars['String'];
};

export type PostingsUnpinActivityByTargetInput = {
  targetGlobalId: Scalars['GlobalID'];
};

export type PostingsUnpinActivityInput = {
  entityPageId: Scalars['ID'];
};

export type PostingsUnpinActivityResult = {
  __typename?: 'PostingsUnpinActivityResult';
  error?: Maybe<PostingsError>;
};

export type PostingsUpdateLinkShareInput = {
  id: Scalars['ID'];
  customTitle?: Maybe<Scalars['String']>;
  customDescription?: Maybe<Scalars['String']>;
  /** this upload ID is provided by the uploadRequest mutation */
  customImageUploadId?: Maybe<Scalars['String']>;
};

export type PostingsUpdatePostingInput = {
  id: Scalars['ID'];
  /** legacy plaintext format */
  comment?: Maybe<Scalars['String']>;
  /** new comment format that allows for @mentions; will eventually outmode the `comment` */
  commentArticleV1?: Maybe<Array<ArticlesCreateArticleBlocksInput>>;
  /**
   * Providing this reschedules a scheduled posting. It can also schedule a draft posting.
   * Does not affect postings that have already been published.
   */
  publishAt?: Maybe<Scalars['Date']>;
  /**
   * Actor on whose behalf the posting should be updated.
   * Defaults to the posting's own actorGlobalId
   */
  actorGlobalId?: Maybe<Scalars['GlobalID']>;
};

export type PostingsVideoAttachment = PostingsAttachment & StoryMedium & {
  __typename?: 'PostingsVideoAttachment';
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   * @deprecated Please use videoV2 instead.
   */
  video?: Maybe<Video>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  videoV2?: Maybe<VideoV2>;
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
};

export type PostingsVideoCreateInput = {
  actorGlobalId: Scalars['GlobalID'];
  ownerUrn: Scalars['String'];
  fileName: Scalars['String'];
};

export type PostingsVideoCreateMutationResult = {
  __typename?: 'PostingsVideoCreateMutationResult';
  success?: Maybe<PostingsVideoUploadResponse>;
  error?: Maybe<PostingsError>;
};

export type PostingsVideoUploadResponse = VideoUploadResponse & {
  __typename?: 'PostingsVideoUploadResponse';
  videoDetails: VideoUploadDetails;
};

export enum PostingsVisibility {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type PostingsVoteForPollOptionInput = {
  /** pollOptionId of the poll that you would like to vote. */
  pollOptionId: Scalars['Int'];
};

export type PostingsVoteForPollOptionResult = PostingsPollAttachment | PostingsError;

export type PotentialCandidate = {
  __typename?: 'PotentialCandidate';
  userId: Scalars['ID'];
  interactions: Array<Maybe<PotentialCandidatesInteraction>>;
  /** #rest(batched) #virtual */
  profileDetails?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  profileAdditionalDetails?: Maybe<XjmProfileAdditionalDetails>;
  lastInteraction?: Maybe<Scalars['Date']>;
};

export type PotentialCandidatesCollection = {
  __typename?: 'PotentialCandidatesCollection';
  collection: Array<Maybe<PotentialCandidate>>;
  total: Scalars['Int'];
};

export enum PotentialCandidatesInteraction {
  Apply = 'APPLY',
  Visit = 'VISIT',
  Interest = 'INTEREST',
  Recommend = 'RECOMMEND'
}

export enum PotentialCandidatesOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Potential Candidates requested by XJM */
export type PotentialCandidatesTotals = {
  __typename?: 'PotentialCandidatesTotals';
  apply?: Maybe<Scalars['Int']>;
  interest?: Maybe<Scalars['Int']>;
  visit?: Maybe<Scalars['Int']>;
  recommend?: Maybe<Scalars['Int']>;
};

export type PredictiveSearch = HasTrackingToken & {
  __typename?: 'PredictiveSearch';
  /** #soft-logged-in */
  service: Scalars['String'];
  /** #soft-logged-in */
  sections: Array<PredictiveSearchSection>;
  /**
   * #soft-logged-in
   *
   *  Tracking token generated by predictive search service to track responses. Used for DS tracking
   */
  trackingToken: Scalars['String'];
};

export type PredictiveSearchItem = {
  /** #soft-logged-in */
  data: Scalars['String'];
  /** #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #soft-logged-in */
  payload?: Maybe<ExtraData>;
};

export type PredictiveSearchSection = {
  __typename?: 'PredictiveSearchSection';
  /** #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  sectionType?: Maybe<PredictiveSearchSectionType>;
  /** #soft-logged-in */
  link?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  items?: Maybe<Array<PredictiveSearchItem>>;
};

export enum PredictiveSearchSectionType {
  IncrementalSearch = 'INCREMENTAL_SEARCH'
}

/** Jobs Seeking status of an User */
export enum PreferenceSeekingStatus {
  Seeking = 'SEEKING',
  Interested = 'INTERESTED',
  NotSeeking = 'NOT_SEEKING'
}

export type PreferencesJobWishesError = {
  __typename?: 'PreferencesJobWishesError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type PreferencesJobWishesInput = {
  cities?: Maybe<Array<Maybe<PreferencesLocationInput>>>;
  willingnessToTravel?: Maybe<WillingnessToTravelPreferenceEnum>;
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  openToOtherIndustries?: Maybe<Scalars['Boolean']>;
  partTime?: Maybe<Scalars['Boolean']>;
  fullTime?: Maybe<Scalars['Boolean']>;
  discipline?: Maybe<Scalars['ID']>;
  salaryExpectations?: Maybe<Scalars['Int']>;
  minCareerLevel?: Maybe<Scalars['Int']>;
  maxCareerLevel?: Maybe<Scalars['Int']>;
  maxDistance?: Maybe<Scalars['Int']>;
};

/** "Result type for user preference job wishes status update that returns 204 on success" */
export type PreferencesJobWishesResult = PreferencesJobWishesSuccess | PreferencesJobWishesError;

export type PreferencesJobWishesSuccess = {
  __typename?: 'PreferencesJobWishesSuccess';
  value?: Maybe<Scalars['String']>;
};

export type PreferencesLocationInput = {
  id?: Maybe<Scalars['String']>;
  cityId: Scalars['ID'];
};

/** Preferences Settings Type */
export type PreferencesSettings = {
  __typename?: 'PreferencesSettings';
  /**
   * #rest(batched) #virtual
   * @deprecated Use blockedCompanies instead for queries and mutations
   */
  blockedCompanies?: Maybe<Array<Maybe<Company>>>;
  seekingStatus: PreferenceSeekingStatus;
};

export type PreferencesSettingsError = {
  __typename?: 'PreferencesSettingsError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type PreferencesSettingsInput = {
  seekingStatus?: Maybe<PreferenceSeekingStatus>;
};

/** "Result type for user preference seeking status update that returns 204 on success" */
export type PreferencesSettingsResult = PreferencesSettingsSuccess | PreferencesSettingsError;

export type PreferencesSettingsSuccess = {
  __typename?: 'PreferencesSettingsSuccess';
  value?: Maybe<Scalars['String']>;
};

export type PremiumAction = {
  __typename?: 'PremiumAction';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  androidPath?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  iosPath?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  webPath?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  trackingId?: Maybe<Scalars['String']>;
};

export type PremiumContact = {
  __typename?: 'PremiumContact';
  /** #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type PremiumContactEdge = PaginationEdge & {
  __typename?: 'PremiumContactEdge';
  cursor: Scalars['String'];
  node: PremiumContact;
};

export type PremiumContactsCursorConnection = HasCursorPagination & {
  __typename?: 'PremiumContactsCursorConnection';
  /** #soft-logged-in */
  total: Scalars['Int'];
  /** #soft-logged-in */
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<PremiumContactEdge>>>;
};

export type PremiumEngagementMutationError = {
  __typename?: 'PremiumEngagementMutationError';
  /** #soft-logged-in */
  message?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  error?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  status?: Maybe<Scalars['Int']>;
  /** #soft-logged-in */
  errors?: Maybe<Scalars['String']>;
};

export type PremiumFeaturesOverview = {
  __typename?: 'PremiumFeaturesOverview';
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<PremiumFeaturesOverviewArea>>>;
};

export type PremiumFeaturesOverviewArea = {
  __typename?: 'PremiumFeaturesOverviewArea';
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  groups?: Maybe<Array<Maybe<PremiumFeaturesOverviewGroup>>>;
  /** #soft-logged-in */
  trackingId?: Maybe<Scalars['String']>;
};

export type PremiumFeaturesOverviewFeatureUrl = {
  __typename?: 'PremiumFeaturesOverviewFeatureUrl';
  /** #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PremiumFeaturesOverviewGroup = {
  __typename?: 'PremiumFeaturesOverviewGroup';
  /** #soft-logged-in */
  urn?: Maybe<Scalars['GlobalID']>;
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  subheader?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  imageUrl?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  darkImageUrl?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  featureUrl?: Maybe<PremiumFeaturesOverviewFeatureUrl>;
  /** #soft-logged-in */
  items?: Maybe<Array<Maybe<PremiumFeaturesOverviewItem>>>;
  /** #soft-logged-in */
  tipsAndTricks?: Maybe<Array<Maybe<PremiumFeaturesOverviewTipsAndTricks>>>;
  /** #soft-logged-in */
  trackingId?: Maybe<Scalars['String']>;
};

export type PremiumFeaturesOverviewItem = {
  __typename?: 'PremiumFeaturesOverviewItem';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  specialText?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  webOnly?: Maybe<Scalars['Boolean']>;
  /** #soft-logged-in */
  values?: Maybe<Array<Maybe<PremiumFeaturesOverviewItemValue>>>;
};

export type PremiumFeaturesOverviewItemValue = {
  __typename?: 'PremiumFeaturesOverviewItemValue';
  /** #soft-logged-in */
  enabled?: Maybe<Scalars['Boolean']>;
  /** #soft-logged-in */
  maxUsage?: Maybe<Scalars['Int']>;
};

/** Available products for Premium Features Overview */
export enum PremiumFeaturesOverviewProducts {
  Premium = 'PREMIUM',
  Probusiness = 'PROBUSINESS',
  Projobs = 'PROJOBS'
}

export type PremiumFeaturesOverviewTipsAndTricks = {
  __typename?: 'PremiumFeaturesOverviewTipsAndTricks';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  videoId?: Maybe<Scalars['Int']>;
  /** #soft-logged-in */
  top?: Maybe<PremiumFeaturesOverviewTipsAndTricksSection>;
  /** #soft-logged-in */
  bottom?: Maybe<PremiumFeaturesOverviewTipsAndTricksSection>;
};

export type PremiumFeaturesOverviewTipsAndTricksAction = {
  __typename?: 'PremiumFeaturesOverviewTipsAndTricksAction';
  /** #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  trackingId?: Maybe<Scalars['String']>;
};

export type PremiumFeaturesOverviewTipsAndTricksSection = {
  __typename?: 'PremiumFeaturesOverviewTipsAndTricksSection';
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  actions?: Maybe<Array<Maybe<PremiumFeaturesOverviewTipsAndTricksAction>>>;
};

export type PremiumFeaturesVompNotification = Notification & {
  __typename?: 'PremiumFeaturesVompNotification';
  /** #rest(batched) #virtual */
  actor?: Maybe<QualifiedVompVisitor>;
  /** #rest(batched) #virtual */
  object?: Maybe<QualifiedVomp>;
  /** #rest(batched) #virtual */
  target?: Maybe<QualifiedVompVisitee>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type PremiumNews = {
  __typename?: 'PremiumNews';
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  subheader?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<PremiumNewsItem>>>;
  /** #soft-logged-in */
  reassuranceFlag?: Maybe<PremiumReassuranceFlag>;
};

export type PremiumNewsItem = {
  __typename?: 'PremiumNewsItem';
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  imageUrl?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  action?: Maybe<PremiumAction>;
};

export type PremiumPartner = {
  __typename?: 'PremiumPartner';
  /** #soft-logged-in */
  partnerName?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  new?: Maybe<Scalars['Boolean']>;
  /** #soft-logged-in */
  detailUrl?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  uplt?: Maybe<Scalars['Int']>;
  /** #soft-logged-in */
  teaser?: Maybe<PremiumPartnerTeaser>;
  /** #soft-logged-in */
  logo?: Maybe<PremiumPartnerLogo>;
  /** #soft-logged-in */
  offerType?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  categoriesWithId?: Maybe<Array<Maybe<PremiumPartnersCategory>>>;
};

export type PremiumPartnerCreateCodeMutationInput = {
  slug?: Maybe<Scalars['String']>;
};

/** "Result type for Premium partner code create mutations that returns the code on success" */
export type PremiumPartnerCreateCodeMutationResult = {
  __typename?: 'PremiumPartnerCreateCodeMutationResult';
  /** #soft-logged-in */
  error?: Maybe<PremiumEngagementMutationError>;
  /** #soft-logged-in */
  success?: Maybe<PremiumPartnerDetailsCode>;
};

export type PremiumPartnerDetails = {
  __typename?: 'PremiumPartnerDetails';
  /** #soft-logged-in */
  partnerId: Scalars['ID'];
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  backgroundImage?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  logoImage?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  filter?: Maybe<PremiumPartnerDetailsFilter>;
  /** #soft-logged-in */
  benefits?: Maybe<PremiumPartnerDetailsBenefits>;
  /** #soft-logged-in */
  body?: Maybe<Array<Maybe<PremiumPartnerDetailsBody>>>;
  /** #soft-logged-in */
  sideSection?: Maybe<Array<Maybe<PremiumPartnerDetailsSideSection>>>;
  /** #soft-logged-in */
  footerNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  uplt?: Maybe<Scalars['Int']>;
};

export type PremiumPartnerDetailsBenefit = {
  __typename?: 'PremiumPartnerDetailsBenefit';
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PremiumPartnerDetailsBenefits = {
  __typename?: 'PremiumPartnerDetailsBenefits';
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<PremiumPartnerDetailsBenefit>>>;
};

export type PremiumPartnerDetailsBody = PremiumPartnerDetailsBodyHeader | PremiumPartnerDetailsBodyVideo | PremiumPartnerDetailsBodySubheader | PremiumPartnerDetailsBodyParagraph;

/** Types for PremiumPartnerDetailsBody */
export type PremiumPartnerDetailsBodyHeader = {
  __typename?: 'PremiumPartnerDetailsBodyHeader';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PremiumPartnerDetailsBodyParagraph = {
  __typename?: 'PremiumPartnerDetailsBodyParagraph';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PremiumPartnerDetailsBodySubheader = {
  __typename?: 'PremiumPartnerDetailsBodySubheader';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PremiumPartnerDetailsBodyVideo = {
  __typename?: 'PremiumPartnerDetailsBodyVideo';
  /** #soft-logged-in */
  videoId?: Maybe<Scalars['ID']>;
};

export type PremiumPartnerDetailsCode = {
  __typename?: 'PremiumPartnerDetailsCode';
  /** #soft-logged-in */
  value?: Maybe<Scalars['String']>;
};

export type PremiumPartnerDetailsFilter = {
  __typename?: 'PremiumPartnerDetailsFilter';
  /** #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PremiumPartnerDetailsSideSection = PremiumPartnerDetailsSideSectionHeader | PremiumPartnerDetailsSideSectionSubheader | PremiumPartnerDetailsSideSectionList | PremiumPartnerDetailsSideSectionCodebutton | PremiumPartnerDetailsSideSectionButton;

export type PremiumPartnerDetailsSideSectionButton = {
  __typename?: 'PremiumPartnerDetailsSideSectionButton';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
};

export type PremiumPartnerDetailsSideSectionCodebutton = {
  __typename?: 'PremiumPartnerDetailsSideSectionCodebutton';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #soft-logged-in #rest #virtual */
  code?: Maybe<PremiumPartnerDetailsCode>;
};

/** Types for PremiumPartnerDetailsSideSection */
export type PremiumPartnerDetailsSideSectionHeader = {
  __typename?: 'PremiumPartnerDetailsSideSectionHeader';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PremiumPartnerDetailsSideSectionList = {
  __typename?: 'PremiumPartnerDetailsSideSectionList';
  /** #soft-logged-in */
  listElements?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PremiumPartnerDetailsSideSectionSubheader = {
  __typename?: 'PremiumPartnerDetailsSideSectionSubheader';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
};

export type PremiumPartnerHighlight = {
  __typename?: 'PremiumPartnerHighlight';
  /** #soft-logged-in */
  partnerName?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  new?: Maybe<Scalars['Boolean']>;
  /** #soft-logged-in */
  offerType?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  highlightImageUrl?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  body?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  logoUrl?: Maybe<Scalars['String']>;
};

export type PremiumPartnerLogo = {
  __typename?: 'PremiumPartnerLogo';
  /** #soft-logged-in */
  imageUrl?: Maybe<Scalars['String']>;
};

export type PremiumPartnerTeaser = {
  __typename?: 'PremiumPartnerTeaser';
  /** #soft-logged-in */
  localizedTitle?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  localizedDescription?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  imageUrl?: Maybe<Scalars['String']>;
};

export type PremiumPartners = {
  __typename?: 'PremiumPartners';
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<PremiumPartner>>>;
};

export type PremiumPartnersCategories = {
  __typename?: 'PremiumPartnersCategories';
  /** #soft-logged-in */
  headline?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<PremiumPartnersCategory>>>;
};

export type PremiumPartnersCategory = {
  __typename?: 'PremiumPartnersCategory';
  /** #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  slug?: Maybe<Scalars['String']>;
};

export enum PremiumPlatform {
  Ios = 'IOS',
  Android = 'ANDROID',
  Web = 'WEB'
}

/** Premium reassurance flag */
export type PremiumReassuranceFlag = {
  __typename?: 'PremiumReassuranceFlag';
  /** #soft-logged-in */
  header: Scalars['String'];
  /** #soft-logged-in */
  body: Array<Scalars['String']>;
  /** #soft-logged-in */
  action?: Maybe<PremiumReassuranceFlagAction>;
};

export type PremiumReassuranceFlagAction = {
  __typename?: 'PremiumReassuranceFlagAction';
  /** #soft-logged-in */
  text: Scalars['String'];
  /** #soft-logged-in */
  url?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  urn?: Maybe<Scalars['GlobalID']>;
  /** #soft-logged-in */
  trackingId?: Maybe<Scalars['String']>;
};

export type PremiumSelfAssessmentStatus = {
  __typename?: 'PremiumSelfAssessmentStatus';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  state?: Maybe<PremiumSelfAssessmentStatusState>;
};

/** Possible states of PremiumSelfAssessmentStatus */
export enum PremiumSelfAssessmentStatusState {
  /** The user has not started the self assessment test */
  NotStarted = 'NOT_STARTED',
  /** The user has started and not finished the self assessment test */
  Started = 'STARTED',
  /** The user has finished the self assessment test */
  Finished = 'FINISHED'
}

export type PremiumSelfDevelopment = {
  __typename?: 'PremiumSelfDevelopment';
  /** #rest #virtual */
  testStatus?: Maybe<PremiumSelfAssessmentStatus>;
  /** #soft-logged-in #rest #virtual */
  courseCategories?: Maybe<PremiumSelfDevelopmentCourseCategories>;
  /** #soft-logged-in #rest #virtual */
  courses?: Maybe<PremiumSelfDevelopmentCourses>;
};


export type PremiumSelfDevelopmentCoursesArgs = {
  filter?: Maybe<PremiumSelfDevelopmentCourseFilter>;
  category?: Maybe<Scalars['String']>;
};

export type PremiumSelfDevelopmentCourse = {
  __typename?: 'PremiumSelfDevelopmentCourse';
  /** #soft-logged-in */
  id: Scalars['ID'];
  /** #soft-logged-in */
  partner?: Maybe<PremiumSelfDevelopmentCoursePartner>;
  /** #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  duration?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #soft-logged-in */
  level?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  new?: Maybe<Scalars['Boolean']>;
  /** #soft-logged-in */
  imageUrl?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  orderedCategories?: Maybe<Array<Maybe<PremiumSelfDevelopmentOrderCategory>>>;
};

export type PremiumSelfDevelopmentCourseCategories = {
  __typename?: 'PremiumSelfDevelopmentCourseCategories';
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<PremiumSelfDevelopmentCourseCategory>>>;
};

export type PremiumSelfDevelopmentCourseCategory = {
  __typename?: 'PremiumSelfDevelopmentCourseCategory';
  /** #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #soft-logged-in */
  slug?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  imageUrl?: Maybe<Scalars['URL']>;
};

export enum PremiumSelfDevelopmentCourseFilter {
  Popular = 'POPULAR'
}

export type PremiumSelfDevelopmentCoursePartner = {
  __typename?: 'PremiumSelfDevelopmentCoursePartner';
  /** #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  logoUrl?: Maybe<Scalars['URL']>;
  /** #soft-logged-in */
  specialText?: Maybe<Scalars['String']>;
};

export type PremiumSelfDevelopmentCourses = {
  __typename?: 'PremiumSelfDevelopmentCourses';
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<PremiumSelfDevelopmentCourse>>>;
};

export type PremiumSelfDevelopmentOrderCategory = {
  __typename?: 'PremiumSelfDevelopmentOrderCategory';
  /** #soft-logged-in */
  categoryId?: Maybe<Scalars['ID']>;
  /** #soft-logged-in */
  position?: Maybe<Scalars['Int']>;
};

/** Return all the data for the premium startpage */
export type PremiumStartpage = {
  __typename?: 'PremiumStartpage';
  /** #soft-logged-in #rest #virtual */
  premiumStartpageInfo?: Maybe<PremiumStartpageInfo>;
};

export type PremiumStartpageInfo = {
  __typename?: 'PremiumStartpageInfo';
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  subheader?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  imageUrl?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  status?: Maybe<PremiumStatus>;
  /** #soft-logged-in */
  revokeBonusMonths?: Maybe<Scalars['String']>;
};

/**  Premium Statistics Type  */
export type PremiumStatistics = {
  __typename?: 'PremiumStatistics';
  searchAppearances?: Maybe<Scalars['Int']>;
  startpageAppearances?: Maybe<Scalars['Int']>;
};

export type PremiumStatus = {
  __typename?: 'PremiumStatus';
  /** #soft-logged-in */
  memberSince?: Maybe<XingMemberSince>;
  /** #soft-logged-in */
  action?: Maybe<PremiumAction>;
  /** #soft-logged-in */
  premiumMemberSince?: Maybe<XingMemberSince>;
};

export type PremiumSwitch = HasGlobalId & {
  __typename?: 'PremiumSwitch';
  globalId: Scalars['GlobalID'];
  /** A list of the memberships set by the PremiumSwitch */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
  errors?: Maybe<PremiumSwitchSettingsError>;
};

/** Represents if the PremiumFeature is enable or not */
export type PremiumSwitchFeature = {
  __typename?: 'PremiumSwitchFeature';
  value: Scalars['String'];
};

/**
 * Settings for overriding a subscription for testing/QA purposes
 * only available to Xing employees and Ambassadors
 */
export type PremiumSwitchSettings = {
  __typename?: 'PremiumSwitchSettings';
  /**
   * #rest #virtual
   *
   *  Settings field holding PremiumSwitch selected value
   */
  premiumSwitch?: Maybe<PremiumSwitch>;
  /**
   * #rest #virtual
   *
   *  Feature flag to define if user can have the PremiumSwitch as a Xing employee
   */
  hasPremiumSwitch?: Maybe<PremiumSwitchFeature>;
  /**
   * #rest #virtual
   *
   *  Feature flag to define if user can have the PremiumSwitch as a Xing ambassador
   */
  hasPremiumSwitchExternal?: Maybe<PremiumSwitchFeature>;
};

export type PremiumSwitchSettingsError = {
  __typename?: 'PremiumSwitchSettingsError';
  message?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PremiumSwitchSettingsInput = {
  premiumSwitch?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PremiumSwitchSettingsMutationResult = {
  __typename?: 'PremiumSwitchSettingsMutationResult';
  response?: Maybe<PremiumSwitchSettings>;
  error?: Maybe<PremiumSwitchSettings>;
};

export type PremiumVisibility = {
  __typename?: 'PremiumVisibility';
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  subheader?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  collection?: Maybe<Array<Maybe<PremiumVisibilityItem>>>;
  /** #soft-logged-in */
  reassuranceFlag?: Maybe<PremiumReassuranceFlag>;
};

export type PremiumVisibilityItem = {
  __typename?: 'PremiumVisibilityItem';
  /** #soft-logged-in */
  value?: Maybe<Scalars['Int']>;
  /** #soft-logged-in */
  header?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  action?: Maybe<PremiumAction>;
};

export type PreviewMetadata = {
  sourceActor?: Maybe<LinkPreviewSourceActor>;
};

export type ProBusinessCreateLeadResult = XingIdActionPayloadInterface & {
  __typename?: 'ProBusinessCreateLeadResult';
  error?: Maybe<ProbusinessCreateLeadError>;
  /**
   * #rest
   *
   *  XingIdModule of the user added as a lead
   */
  xingIdModule?: Maybe<XingIdModule>;
};


export type ProBusinessCreateLeadResultXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

export type ProBusinessDeleteLeadResult = XingIdActionPayloadInterface & {
  __typename?: 'ProBusinessDeleteLeadResult';
  error?: Maybe<ProbusinessDeleteLeadError>;
  /**
   * #rest
   *
   *  XingIdModule of the user removed as a lead
   */
  xingIdModule?: Maybe<XingIdModule>;
};


export type ProBusinessDeleteLeadResultXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

export type ProJobsIdealEmployer = {
  __typename?: 'ProJobsIdealEmployer';
  createdAt: Scalars['Date'];
  /** #rest(batched) #virtual */
  company: Company;
};

export type ProJobsIdealEmployerMutationError = {
  __typename?: 'ProJobsIdealEmployerMutationError';
  message?: Maybe<Scalars['String']>;
};

export type ProJobsIdealEmployerMutationInput = {
  companyId: Scalars['ID'];
};

export type ProJobsIdealEmployerMutationResult = {
  __typename?: 'ProJobsIdealEmployerMutationResult';
  error?: Maybe<ProJobsIdealEmployerMutationError>;
};

export type ProJobsIdealEmployersConnection = HasCursorPagination & {
  __typename?: 'ProJobsIdealEmployersConnection';
  edges: Array<Maybe<ProJobsIdealEmployersEdge>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type ProJobsIdealEmployersEdge = PaginationEdge & {
  __typename?: 'ProJobsIdealEmployersEdge';
  node: ProJobsIdealEmployer;
  /** #virtual */
  cursor: Scalars['String'];
};

/** ProJobs JobSeeker WorkExperience. 2.0 */
export type ProJobsV2WorkExperience = {
  __typename?: 'ProJobsV2WorkExperience';
  responsibility?: Maybe<Scalars['String']>;
  formattedResponsibility?: Maybe<Scalars['String']>;
  hasBudgetResponsibility: Scalars['Boolean'];
  formattedHasBudgetResponsibility: Scalars['String'];
  budgetAmount?: Maybe<Scalars['Int']>;
  formattedBudgetAmount?: Maybe<Scalars['String']>;
  hasRevenueResponsibility: Scalars['Boolean'];
  formattedHasRevenueResponsibility: Scalars['String'];
  revenueAmount?: Maybe<Scalars['Int']>;
  formattedRevenueAmount?: Maybe<Scalars['String']>;
  responsibilityTeamSize?: Maybe<Scalars['String']>;
};

/** ProJobs JobSeeker WorkExperience. */
export type ProJobsWorkExperience = {
  __typename?: 'ProJobsWorkExperience';
  responsibility: Scalars['String'];
  formattedResponsibility?: Maybe<Scalars['String']>;
  responsibilityTeamSize?: Maybe<Scalars['String']>;
  formattedResponsibilityTeamSize?: Maybe<Scalars['String']>;
  budget: Scalars['Boolean'];
  budgetAmount?: Maybe<Scalars['Int']>;
  formattedBudgetAmount?: Maybe<Scalars['String']>;
  revenue: Scalars['Boolean'];
  revenueAmount?: Maybe<Scalars['Int']>;
  formattedRevenueAmount?: Maybe<Scalars['String']>;
  resultsAndAchievements?: Maybe<Scalars['String']>;
  tasksAndActions?: Maybe<Scalars['String']>;
  topicsAndProjects?: Maybe<Scalars['String']>;
};

export type ProbusinessCreateLeadError = {
  __typename?: 'ProbusinessCreateLeadError';
  message?: Maybe<Scalars['String']>;
};

export type ProbusinessCreateLeadInput = {
  /** id of a user who is being added as a lead */
  id: Scalars['ID'];
};

export type ProbusinessDeleteLeadError = {
  __typename?: 'ProbusinessDeleteLeadError';
  message?: Maybe<Scalars['String']>;
};

export type ProbusinessDeleteLeadInput = {
  /** id of a user who is being removed as a lead */
  id: Scalars['ID'];
};

export enum ProductType {
  Premium = 'premium',
  Projobs = 'projobs'
}

export type ProfileAboutMe = {
  __typename?: 'ProfileAboutMe';
  /** #logged-out #soft-logged-in */
  intro?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  globalId?: Maybe<Scalars['GlobalID']>;
  id?: Maybe<Scalars['ID']>;
};

/** Profile module that allow users to express themselves in creative ways */
export type ProfileAboutMeModule = ModuleInterface & {
  __typename?: 'ProfileAboutMeModule';
  title: Scalars['String'];
  order: Scalars['Int'];
  /** #rest #virtual */
  content?: Maybe<ProfileAboutMe>;
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type ProfileAboutMeUpdateError = {
  __typename?: 'ProfileAboutMeUpdateError';
  message?: Maybe<Scalars['String']>;
  errors?: Maybe<ProfileAboutMeUpdateFieldErrors>;
};

export type ProfileAboutMeUpdateFieldErrors = {
  __typename?: 'ProfileAboutMeUpdateFieldErrors';
  intro?: Maybe<Scalars['String']>;
};

export type ProfileAboutMeUpdateInput = {
  /** Intro/about me description of a user */
  intro: Scalars['String'];
};

export type ProfileAboutMeUpdateResult = {
  __typename?: 'ProfileAboutMeUpdateResult';
  success?: Maybe<ProfileAboutMe>;
  error?: Maybe<ProfileAboutMeUpdateError>;
};

export type ProfileAcademicTitleUpdate = PeopleStoryGeneratorProfileUpdate & {
  __typename?: 'ProfileAcademicTitleUpdate';
  academicTitle?: Maybe<Scalars['String']>;
  previousAcademicTitle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  profileId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
};

export type ProfileAdditionalDetails = {
  __typename?: 'ProfileAdditionalDetails';
  workExperience?: Maybe<Array<Maybe<ProfileWorkExperience>>>;
  education?: Maybe<Array<Maybe<ProfileEducation>>>;
  skills?: Maybe<Scalars['String']>;
};

export type ProfileBusinessContactUpdate = PeopleStoryGeneratorProfileUpdate & {
  __typename?: 'ProfileBusinessContactUpdate';
  businessStreet?: Maybe<Scalars['String']>;
  businessZip?: Maybe<Scalars['String']>;
  businessCity?: Maybe<Scalars['String']>;
  businessCountry?: Maybe<Scalars['String']>;
  businessEmail?: Maybe<Scalars['String']>;
  businessPhone?: Maybe<Scalars['String']>;
  businessMobile?: Maybe<Scalars['String']>;
  previousBusinessStreet?: Maybe<Scalars['String']>;
  previousBusinessZip?: Maybe<Scalars['String']>;
  previousBusinessCity?: Maybe<Scalars['String']>;
  previousBusinessCountry?: Maybe<Scalars['String']>;
  previousBusinessEmail?: Maybe<Scalars['String']>;
  previousBusinessPhone?: Maybe<Scalars['String']>;
  previousBusinessMobile?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  profileId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
};

/** A simple type for company objects stored locally by the profile-backend app */
export type ProfileCompany = {
  __typename?: 'ProfileCompany';
  /** The user provided Company name */
  name: Scalars['String'];
  /**
   * #rest(batched) #virtual
   *
   *  The user provided industry
   */
  industry?: Maybe<Industry>;
  /**
   * #rest(batched) #virtual
   *
   *  The company that is linked to the professional entry, in case it exists then the `companyName` and `industry` of this company are the up-to-date info; clients should use them instead of the `name` and `industry` in the parent type
   */
  company?: Maybe<Company>;
};

/** Contains all the information about the other user's contact */
export type ProfileContact = {
  __typename?: 'ProfileContact';
  /**
   * #soft-logged-in
   *
   *  Id of the contact
   */
  id?: Maybe<Scalars['ID']>;
  /**
   * #soft-logged-in
   *
   *  Initial of first name (used for grouping)
   */
  normalizedInitialOfFirstName?: Maybe<Scalars['String']>;
  /**
   * #soft-logged-in
   *
   *  Initial of last name (used for grouping)
   */
  normalizedInitialOfLastName?: Maybe<Scalars['String']>;
  /**
   * #soft-logged-in #rest(batched) #virtual
   *
   *  XingId representation of the information about the contact
   */
  xingId?: Maybe<XingId>;
};

/** List of contacts of a profile */
export type ProfileContacts = {
  __typename?: 'ProfileContacts';
  /** #virtual #soft-logged-in */
  total?: Maybe<Scalars['Int']>;
  /** #soft-logged-in */
  collection?: Maybe<Array<ProfileContact>>;
};

export type ProfileEducation = {
  __typename?: 'ProfileEducation';
  /** #logged-out #soft-logged-in */
  primarySchool?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  subject?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  degree?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  schoolName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  beginDate?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  endDate?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  schoolNotes?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  only filled with data loggedout
   */
  localizedTimeString?: Maybe<Scalars['String']>;
};

export type ProfileEducationCollection = {
  __typename?: 'ProfileEducationCollection';
  /** #logged-out #soft-logged-in */
  education?: Maybe<Array<Maybe<ProfileEducation>>>;
};

/** A simple type for educational institution, following the basic interface of the common Company type */
export type ProfileEducationalInstitution = {
  __typename?: 'ProfileEducationalInstitution';
  name: Scalars['String'];
};

export type ProfileEngagementContactHasNewJobContext = ProfileEngagementContextInterface & {
  __typename?: 'ProfileEngagementContactHasNewJobContext';
  /** Order of the context, to be used in the case there are multiple contexts available */
  order: Scalars['Int'];
  /** Localised title of the context */
  title: Scalars['String'];
  /** The new job title of the user */
  jobTitle: Scalars['String'];
  /** The localised timespan of the new job, can be something like `Since June 2018` or `March 2015 - October 2016`  */
  jobTimeSpan?: Maybe<Scalars['Markdown']>;
  /** The new organization of the user */
  organization: ProfileEngagementOrganization;
  /** What actions are available in this context */
  actions?: Maybe<ProfileEngagementContextsActions>;
};

export type ProfileEngagementContextInterface = {
  /** Order of the context */
  order: Scalars['Int'];
};

export type ProfileEngagementContexts = {
  __typename?: 'ProfileEngagementContexts';
  /** The profile has a new job, only for contacts */
  contactHasNewJob?: Maybe<ProfileEngagementContactHasNewJobContext>;
  /** The profile is your new coworker, only for non-contacts */
  newCoworker?: Maybe<ProfileEngagementNewCoworkerContext>;
};

export type ProfileEngagementContextsActions = {
  __typename?: 'ProfileEngagementContextsActions';
  /** Sending a message action */
  sendMessage?: Maybe<ProfileEngagementSendMessageAction>;
};

export type ProfileEngagementConversationStarter = {
  __typename?: 'ProfileEngagementConversationStarter';
  /** The localized representation of a conversation starter */
  title: Scalars['String'];
  messengerContextId: MessengerContextId;
};

/** Profile module to trigger engagement between users */
export type ProfileEngagementModule = ModuleInterface & {
  __typename?: 'ProfileEngagementModule';
  title: Scalars['String'];
  order: Scalars['Int'];
  /**
   * #expand
   *
   *  Different contexts that can be available on a profile, a context is a signal that something is currently associated with the profile (this profile just got a new job, this profile is on parental leave, etc.), it can also be related to the visitor of the profile (contacts, etc.)
   */
  contexts: ProfileEngagementContexts;
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type ProfileEngagementNewCoworkerContext = ProfileEngagementContextInterface & {
  __typename?: 'ProfileEngagementNewCoworkerContext';
  /** Order of the context, to be used in the case there are multiple contexts available */
  order: Scalars['Int'];
  /** The localised timespan of the new job (for example: `Since June 2018 with XING SE`) */
  jobTimeSpan: Scalars['String'];
  /** Localised title of the context (`Your new colleague`) */
  title: Scalars['String'];
  /** Localised title of the context (for example: `started as Relationship & Content Manager`) */
  description: Scalars['String'];
  /** The profile's gender for choosing which icon to show */
  gender: Gender;
  /** What actions are available in this context */
  actions?: Maybe<ProfileEngagementContextsActions>;
};

/** A representation of the organization in the context of Profile Engagement module */
export type ProfileEngagementOrganization = {
  __typename?: 'ProfileEngagementOrganization';
  name: Scalars['String'];
};

export type ProfileEngagementSendMessageAction = {
  __typename?: 'ProfileEngagementSendMessageAction';
  /** Array of quick messages that can act as a conversation starter */
  conversationStarters?: Maybe<Array<Maybe<ProfileEngagementConversationStarter>>>;
};

export type ProfileHavesUpdate = PeopleStoryGeneratorProfileUpdate & {
  __typename?: 'ProfileHavesUpdate';
  haves: Array<Scalars['String']>;
  previousHaves?: Maybe<Array<Maybe<Scalars['String']>>>;
  newHaves: Array<Scalars['String']>;
  urn: Scalars['GlobalID'];
  id: Scalars['ID'];
  profileId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
};

/** Profile Picture */
export type ProfileImage = UniformResourceLocatable & {
  __typename?: 'ProfileImage';
  /** #logged-out #soft-logged-in */
  url: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  size: ProfileImageSize;
};

export enum ProfileImageSize {
  /** 32x32 pixels */
  Square_32 = 'SQUARE_32',
  /** 48x48 pixels */
  Square_48 = 'SQUARE_48',
  /** 64x64 pixels */
  Square_64 = 'SQUARE_64',
  /** 96x96 pixels */
  Square_96 = 'SQUARE_96',
  /** 128x128 pixels */
  Square_128 = 'SQUARE_128',
  /** 192x192 pixels */
  Square_192 = 'SQUARE_192',
  /** 256x256 pixels */
  Square_256 = 'SQUARE_256',
  /** 1024x1024 pixels */
  Square_1024 = 'SQUARE_1024',
  /** Original dimensions */
  Original = 'ORIGINAL'
}

export type ProfileInputYearAndMonth = {
  year?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
};

export type ProfileInterests = {
  __typename?: 'ProfileInterests';
  /** #logged-out #soft-logged-in */
  interests?: Maybe<Scalars['String']>;
};

export type ProfileInterests2 = HasGlobalId & {
  __typename?: 'ProfileInterests2';
  /** #soft-logged-in #logged-out */
  globalId: Scalars['GlobalID'];
  /** #soft-logged-in #logged-out */
  interests?: Maybe<Array<Scalars['String']>>;
};

/** Interests Autocomplete Suggestions queries */
export type ProfileInterestsAutocompleteSuggestions = {
  __typename?: 'ProfileInterestsAutocompleteSuggestions';
  collection: Array<ProfileInterestsSuggestion>;
  /** Suggestions service name for use in autocompletionTrack mutation */
  service: Scalars['String'];
  total: Scalars['Int'];
};

/** Profile module that allow users to see/add interests */
export type ProfileInterestsModule = ModuleInterface & {
  __typename?: 'ProfileInterestsModule';
  /** #soft-logged-in */
  title: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #soft-logged-in #rest #virtual */
  content?: Maybe<ProfileInterests2>;
  /** #rest #virtual */
  recommendations?: Maybe<ProfileInterestsModuleRecommendations>;
  active?: Maybe<Scalars['Boolean']>;
};

export type ProfileInterestsModuleRecommendation = {
  __typename?: 'ProfileInterestsModuleRecommendation';
  label: Scalars['String'];
};

export type ProfileInterestsModuleRecommendations = {
  __typename?: 'ProfileInterestsModuleRecommendations';
  total: Scalars['Int'];
  collection?: Maybe<Array<ProfileInterestsModuleRecommendation>>;
};

export type ProfileInterestsSuggestion = {
  __typename?: 'ProfileInterestsSuggestion';
  /** Suggestion text */
  suggestion: Scalars['String'];
  /** Tracking token for use in autocompletionTrack mutation */
  trackingToken: Scalars['String'];
  /** 0-based position in suggestion list */
  position: Scalars['Int'];
  /** Interest performance */
  totalPerformance?: Maybe<Scalars['Int']>;
  /** Interest performance trend */
  trend?: Maybe<Scalars['Int']>;
};

export type ProfileInterestsUpdateError = {
  __typename?: 'ProfileInterestsUpdateError';
  message?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<ProfileInterestsUpdateFieldsError>;
};

export type ProfileInterestsUpdateFieldsError = {
  __typename?: 'ProfileInterestsUpdateFieldsError';
  interests?: Maybe<Array<Scalars['String']>>;
};

export type ProfileInterestsUpdateInput = {
  /** Interests of a user, like ['interest-1', 'interest-2']  */
  interests: Array<Scalars['String']>;
  userId: Scalars['ID'];
};

export type ProfileInterestsUpdateResult = ProfileInterests2 | ProfileInterestsUpdateError;

export type ProfileKnownLanguage = {
  __typename?: 'ProfileKnownLanguage';
  identifier: Scalars['String'];
  text: Scalars['String'];
};

export type ProfileKnownLanguages = {
  __typename?: 'ProfileKnownLanguages';
  collection?: Maybe<Array<Maybe<ProfileKnownLanguage>>>;
};

export type ProfileLanguage = {
  __typename?: 'ProfileLanguage';
  identifier?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  skillLevelId?: Maybe<Scalars['Int']>;
};

export type ProfileLanguageCollection = LoggedOutProfileLanguageCollection | LoggedInProfileLanguageCollection;

export type ProfileLanguageInput = {
  identifier?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  skillLevelId?: Maybe<Scalars['Int']>;
};

export type ProfileLanguages = HasGlobalId & {
  __typename?: 'ProfileLanguages';
  /** #soft-logged-in #logged-out */
  globalId: Scalars['GlobalID'];
  collection?: Maybe<Array<Maybe<ProfileLanguage>>>;
};

export type ProfileLanguagesModule = ModuleInterface & {
  __typename?: 'ProfileLanguagesModule';
  /** #soft-logged-in */
  title: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #rest #virtual */
  content?: Maybe<ProfileLanguages>;
  /** #rest #virtual */
  knownLanguages?: Maybe<ProfileKnownLanguages>;
  active?: Maybe<Scalars['Boolean']>;
};

export type ProfileLanguagesUpdateError = {
  __typename?: 'ProfileLanguagesUpdateError';
  message?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<ProfileLanguagesUpdateFieldsError>;
};

export type ProfileLanguagesUpdateFieldsError = {
  __typename?: 'ProfileLanguagesUpdateFieldsError';
  language?: Maybe<Array<Scalars['String']>>;
};

export type ProfileLanguagesUpdateInput = {
  /** Languages of a user */
  collection?: Maybe<Array<Maybe<ProfileLanguageInput>>>;
  userId: Scalars['ID'];
};

export type ProfileLegalInformation = {
  __typename?: 'ProfileLegalInformation';
  /** #logged-out #soft-logged-in */
  content?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  displayContent?: Maybe<Scalars['String']>;
};

export enum ProfileModuleIdentifier {
  /** Xing ID module */
  XingIdModule = 'XING_ID_MODULE',
  /** Next best action module */
  NextBestActionModule = 'NEXT_BEST_ACTION_MODULE',
  /** DisplayAd module */
  DisplayAdModule = 'DISPLAY_AD_MODULE',
  /** Vomp module */
  VompModule = 'VOMP_MODULE',
  /** Note module */
  NoteModule = 'NOTE_MODULE',
  /** Career settings module */
  CareerSettingsModule = 'CAREER_SETTINGS_MODULE',
  /** Content insider module */
  ContentInsiderModule = 'CONTENT_INSIDER_MODULE',
  /** Timeline module */
  TimelineModule = 'TIMELINE_MODULE',
  /** Contacts module */
  ContactsModule = 'CONTACTS_MODULE',
  /** Legal imprint module */
  LegalImprintModule = 'LEGAL_IMPRINT_MODULE',
  /** Patterns showcase module */
  PatternsShowcaseModule = 'PATTERNS_SHOWCASE_MODULE',
  /** Personal details module */
  PersonalDetailsModule = 'PERSONAL_DETAILS_MODULE',
  /** Engagement module */
  EngagementModule = 'ENGAGEMENT_MODULE',
  /** Skills module */
  SkillsModule = 'SKILLS_MODULE',
  /** Wants module */
  WantsModule = 'WANTS_MODULE',
  /** Interests module */
  InterestsModule = 'INTERESTS_MODULE',
  /** Languages module */
  LanguagesModule = 'LANGUAGES_MODULE',
  /** About me module */
  AboutMeModule = 'ABOUT_ME_MODULE',
  /** Accomplishments */
  AccomplishmentsModule = 'ACCOMPLISHMENTS_MODULE',
  /** Hiring Highlights */
  HiringHighlightsModule = 'HIRING_HIGHLIGHTS_MODULE'
}

export type ProfileModuleStoreItem = {
  __typename?: 'ProfileModuleStoreItem';
  /** #soft-logged-in #logged-out */
  isActive: Scalars['Boolean'];
  /** #soft-logged-in #logged-out */
  moduleTitle: Scalars['String'];
  /** #soft-logged-in #logged-out */
  moduleIdentifier: ProfileModuleIdentifier;
  /** #soft-logged-in #logged-out */
  isVisibleOnAllClients: Scalars['Boolean'];
};

export type ProfileModules = HasGlobalId & {
  __typename?: 'ProfileModules';
  /** #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /**
   * #rest
   * @deprecated Will be removed. Jira ticket: PROFILE-10408
   */
  nextBestActionModule?: Maybe<NextBestActionModule>;
  /** #soft-logged-in #rest */
  xingIdModule?: Maybe<XingIdModule>;
  /** #rest */
  timelineModule?: Maybe<ProfileTimelineModule>;
  /** @deprecated Module is removed */
  engagementModule?: Maybe<ProfileEngagementModule>;
  /** #rest */
  contentInsiderModule?: Maybe<ContentInsiderModule>;
  noteModule?: Maybe<NoteModule>;
  commonalitiesModule?: Maybe<CommonalitiesModule>;
  neffiModule?: Maybe<NeffiModule>;
  displayAdModule?: Maybe<DisplayAdModule>;
  contactsModule?: Maybe<ContactsModule>;
  vompModule?: Maybe<VompModule>;
  /** @deprecated Module is renamed to legalInformationModule */
  legalImprintModule?: Maybe<LegalImprintModule>;
  legalInformationModule?: Maybe<LegalInformationModule>;
  personalDetailsModule?: Maybe<PersonalDetailsModule>;
  /** #soft-logged-in */
  skillsModule?: Maybe<ProfileSkillsModule>;
  /**
   * #soft-logged-in
   * @deprecated The wants will be removed in favor of job-preferences: PROFILE-10484.
   */
  wantsModule?: Maybe<ProfileWantsModule>;
  /** #soft-logged-in */
  interestsModule?: Maybe<ProfileInterestsModule>;
  /** #soft-logged-in */
  languagesModule?: Maybe<ProfileLanguagesModule>;
  aboutMeModule?: Maybe<ProfileAboutMeModule>;
  careerSettingsModule?: Maybe<CareerSettingsModule>;
  jobWishesPreferenceModule?: Maybe<JobWishesPreferenceModule>;
  statsModule?: Maybe<ProfileStatsModule>;
  accomplishmentsModule?: Maybe<AccomplishmentsModule>;
  projobsUpsellBannerModule?: Maybe<ProjobsUpsellBannerModule>;
  hiringHighlightsModule?: Maybe<HiringHighlightsModule>;
};


export type ProfileModulesNextBestActionModuleArgs = {
  cards: Array<NbaCardId>;
};


export type ProfileModulesXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

export type ProfileOccupation = {
  __typename?: 'ProfileOccupation';
  /**
   * #logged-out #soft-logged-in
   * @deprecated Use occupations[0].subline instead. Checked on 14.11.2023 - still used a lot by Web and Mobile
   */
  occupationTitle?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Use occupations[0].headline instead. Checked on 14.11.2023 - still used a lot by Web and Mobile
   */
  occupationOrg?: Maybe<Scalars['String']>;
};

/** The type of an occupation, like student or employee */
export type ProfileOccupationType = Localizable & {
  __typename?: 'ProfileOccupationType';
  identifier: ProfileOccupationTypeIdentifier;
  /** The raw text resource key from Phraseapp */
  localizationKey: Scalars['String'];
  /** The value localized based on the `Accept-Language` header */
  localizationValue: Scalars['String'];
};

/** Categories of occupation types */
export type ProfileOccupationTypeCategory = Localizable & {
  __typename?: 'ProfileOccupationTypeCategory';
  identifier?: Maybe<ProfileOccupationTypeCategoryIdentifier>;
  occupationTypes?: Maybe<Array<ProfileOccupationType>>;
  /** The raw text resource key from Phraseapp */
  localizationKey: Scalars['String'];
  /** The value localized based on the `Accept-Language` header */
  localizationValue: Scalars['String'];
};

export enum ProfileOccupationTypeCategoryIdentifier {
  Professional = 'PROFESSIONAL',
  EntryLevel = 'ENTRY_LEVEL',
  Educational = 'EDUCATIONAL',
  Other = 'OTHER'
}

export enum ProfileOccupationTypeIdentifier {
  Employee = 'EMPLOYEE',
  Intern = 'INTERN',
  FreelancerSelfEmployed = 'FREELANCER_SELF_EMPLOYED',
  Owner = 'OWNER',
  PartnerShareholder = 'PARTNER_SHAREHOLDER',
  BoardMember = 'BOARD_MEMBER',
  Volunteer = 'VOLUNTEER',
  SelfEmployed = 'SELF_EMPLOYED',
  Shareholder = 'SHAREHOLDER',
  CivilServant = 'CIVIL_SERVANT',
  Freelancer = 'FREELANCER',
  Partner = 'PARTNER',
  UniversityStudent = 'UNIVERSITY_STUDENT',
  Apprenticeship = 'APPRENTICESHIP',
  ParentalLeave = 'PARENTAL_LEAVE'
}

export type ProfilePageMeta = {
  __typename?: 'ProfilePageMeta';
  /** #logged-out #soft-logged-in */
  pageTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  pageDescription?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  indexable?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  pageCanonical?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  socialMediaImage?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  socialMediaDescription?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  socialMediaTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  scrambledProfileUrl?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  qualityIndex?: Maybe<Scalars['Float']>;
  /** #logged-out #soft-logged-in */
  qualityVariant?: Maybe<Scalars['String']>;
};

export type ProfilePageMetaOrError = ProfilePageMeta | ResponseError;

/** Something like (`on parental leave` etc.), including a global id */
export type ProfilePersonalStatus = {
  __typename?: 'ProfilePersonalStatus';
  localizationKey?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  localizationValue?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  identifier?: Maybe<ProfilePersonalStatuses>;
  bucketIdentifier?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  variants: Array<Maybe<ProfilePersonalStatusVariant>>;
};

/** Something like the category of a status */
export type ProfilePersonalStatusBucket = Localizable & {
  __typename?: 'ProfilePersonalStatusBucket';
  identifier?: Maybe<Scalars['String']>;
  /** The raw text resource key from Phraseapp */
  localizationKey: Scalars['String'];
  /** The value localized based on the `Accept-Language` header */
  localizationValue: Scalars['String'];
};

/** Collection of ProfilePersonalStatusBucket */
export type ProfilePersonalStatusBuckets = {
  __typename?: 'ProfilePersonalStatusBuckets';
  collection: Array<Maybe<ProfilePersonalStatusBucket>>;
};

/** Collection of statuses that are available to the viewer */
export type ProfilePersonalStatusOptions = {
  __typename?: 'ProfilePersonalStatusOptions';
  /** #rest #virtual */
  buckets?: Maybe<ProfilePersonalStatusBuckets>;
  collection: Array<Maybe<ProfilePersonalStatus>>;
};

/** A different localization variant of a status. E.g. Vacationing (smiley) */
export type ProfilePersonalStatusVariant = Localizable & {
  __typename?: 'ProfilePersonalStatusVariant';
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
};

/** All possible status identifiers */
export enum ProfilePersonalStatuses {
  /** The user has a custom status. */
  Custom = 'CUSTOM',
  /** The employee is on parental leave. */
  ParentalLeave = 'PARENTAL_LEAVE',
  /** The employee does a sabbatical. */
  Sabbatical = 'SABBATICAL',
  /** The employee travels around. */
  Travelling = 'TRAVELLING',
  /** The employee is on a training course. */
  TrainingCourse = 'TRAINING_COURSE',
  /** The employee is doing further education */
  FurtherEducation = 'FURTHER_EDUCATION',
  /** The employee is on holiday. */
  Holiday = 'HOLIDAY',
  /** The employee is looking for a new team member. */
  LookingForNewTeamMember = 'LOOKING_FOR_NEW_TEAM_MEMBER',
  /** The student is doing a practical semester. */
  PracticalSemester = 'PRACTICAL_SEMESTER',
  /** The student is studying abroad. */
  SemesterAbroad = 'SEMESTER_ABROAD',
  /** The student paused his studies for one semester. */
  SemesterOff = 'SEMESTER_OFF',
  /** The student writes his final thesis. */
  FinalThesis = 'FINAL_THESIS',
  /** The student is having exams */
  ExamPeriod = 'EXAM_PERIOD',
  /** The freelancer is available for bookings. */
  Available = 'AVAILABLE',
  /** The freelancer will be available for bookings soon. */
  AvailableSoon = 'AVAILABLE_SOON',
  /** The freelancer is partially available. */
  AvailablePartially = 'AVAILABLE_PARTIALLY',
  /** The freelancer is currently booked. */
  Booked = 'BOOKED',
  /** The freelancer is not interested in bookings. */
  NotInterested = 'NOT_INTERESTED',
  /** Staying at home */
  StayingAtHome = 'STAYING_AT_HOME',
  /** Working from home */
  WorkingFromHome = 'WORKING_FROM_HOME',
  /** Would like to help */
  WouldLikeToHelp = 'WOULD_LIKE_TO_HELP',
  /** Looking for volunteers */
  LookingForVolunteers = 'LOOKING_FOR_VOLUNTEERS',
  /** Open for projects */
  OpenForProjects = 'OPEN_FOR_PROJECTS',
  /** Fine and healthy */
  FineAndHealthy = 'FINE_AND_HEALTHY',
  /** Would appreciate social contacts */
  WouldAppreciateSocialContacts = 'WOULD_APPRECIATE_SOCIAL_CONTACTS'
}

export type ProfilePreviewMetadata = PreviewMetadata & {
  __typename?: 'ProfilePreviewMetadata';
  userId: Scalars['ID'];
  sourceActor?: Maybe<LinkPreviewSourceActor>;
};

export type ProfileQualification = {
  __typename?: 'ProfileQualification';
  /** Qualification description */
  description: Scalars['String'];
  /** Qualification id */
  id: Scalars['ID'];
};

export type ProfileQualificationCollection = {
  __typename?: 'ProfileQualificationCollection';
  qualificationList?: Maybe<Array<ProfileQualification>>;
};

/** Settings related to profiles pages */
export type ProfileSettings = {
  __typename?: 'ProfileSettings';
  /** Settings regarding the default tab of profile */
  defaultTab?: Maybe<SelectSetting>;
  portfolioTabVisibility?: Maybe<SelectSetting>;
  activityTabVisibility?: Maybe<SelectSetting>;
  nameGender?: Maybe<NameGenderSettings>;
  enrichProfileWithLinkedinConsent?: Maybe<ToggleSetting>;
};

export type ProfileSettingsInput = {
  defaultTab?: Maybe<SelectSettingInput>;
  portfolioTabVisibility?: Maybe<SelectSettingInput>;
  activityTabVisibility?: Maybe<SelectSettingInput>;
  nameGender?: Maybe<PendingNameGenderSettingInput>;
  enrichProfileWithLinkedinConsent?: Maybe<ToggleSettingInput>;
};

export type ProfileSettingsMutationResult = {
  __typename?: 'ProfileSettingsMutationResult';
  error?: Maybe<ProfileSettings>;
  response?: Maybe<ProfileSettings>;
};

export type ProfileSkill = {
  __typename?: 'ProfileSkill';
  value: Scalars['String'];
  isTop: Scalars['Boolean'];
  category: Scalars['String'];
};

export type ProfileSkillInput = {
  value: Scalars['String'];
  isTop: Scalars['Boolean'];
  category?: Maybe<Scalars['String']>;
};

export type ProfileSkills = HasGlobalId & {
  __typename?: 'ProfileSkills';
  /** #soft-logged-in #logged-out */
  globalId: Scalars['GlobalID'];
  /**
   * #soft-logged-in #logged-out
   * @deprecated use collection field instead
   */
  skills?: Maybe<Array<Scalars['String']>>;
  /**
   * #soft-logged-in #logged-out
   * @deprecated use collection field instead
   */
  topSkills?: Maybe<Array<Scalars['String']>>;
  collection?: Maybe<Array<Maybe<ProfileSkill>>>;
};

export type ProfileSkillsAddInput = {
  skill: ProfileSkillInput;
  shareWithContacts?: Maybe<Scalars['Boolean']>;
};

/** Skills Autocomplete Suggestions queries */
export type ProfileSkillsAutocompleteSuggestions = {
  __typename?: 'ProfileSkillsAutocompleteSuggestions';
  collection: Array<ProfileSkillsSuggestion>;
  /** Suggestions service name for use in autocompletionTrack mutation */
  service: Scalars['String'];
  total: Scalars['Int'];
};

/** Profile module that allow users to see/add skills */
export type ProfileSkillsModule = ModuleInterface & OutdatableModule & {
  __typename?: 'ProfileSkillsModule';
  /** #soft-logged-in */
  title: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #soft-logged-in */
  outdated: Scalars['Boolean'];
  /** #soft-logged-in */
  outdatedFields?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  lastModified?: Maybe<Scalars['Date']>;
  /** #soft-logged-in #rest #virtual */
  content?: Maybe<ProfileSkills>;
  active?: Maybe<Scalars['Boolean']>;
};

export type ProfileSkillsModuleRecommendation = {
  __typename?: 'ProfileSkillsModuleRecommendation';
  /** #rest #virtual */
  userRecommendedSkills?: Maybe<ProfileSkillsModuleRecommendedSkills>;
};


export type ProfileSkillsModuleRecommendationUserRecommendedSkillsArgs = {
  consumer?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

/** Skills recommendations queries */
export type ProfileSkillsModuleRecommendedSkill = {
  __typename?: 'ProfileSkillsModuleRecommendedSkill';
  label: Scalars['String'];
  trackingToken?: Maybe<Scalars['String']>;
  score: Scalars['Float'];
  totalPerformance?: Maybe<Scalars['Int']>;
  trend?: Maybe<Scalars['Int']>;
};

export type ProfileSkillsModuleRecommendedSkills = {
  __typename?: 'ProfileSkillsModuleRecommendedSkills';
  collection?: Maybe<Array<ProfileSkillsModuleRecommendedSkill>>;
};

/** Skills recommendations queries */
export type ProfileSkillsModuleSkillPerformance = {
  __typename?: 'ProfileSkillsModuleSkillPerformance';
  isTopSkill: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  label: Scalars['String'];
  /** @deprecated renamed to label. WILL BE REMOVED ... */
  skill: Scalars['String'];
  totalPerformance?: Maybe<Scalars['Int']>;
  trend?: Maybe<Scalars['Int']>;
  isNewSkill?: Maybe<Scalars['Boolean']>;
};

export type ProfileSkillsModuleSkillsPerformace = HasGlobalId & {
  __typename?: 'ProfileSkillsModuleSkillsPerformace';
  globalId: Scalars['GlobalID'];
  skills?: Maybe<Array<ProfileSkillsModuleSkillPerformance>>;
  totalPerformance?: Maybe<Scalars['Int']>;
};

export type ProfileSkillsModuleSkillsPerformaceWithCurrentSkills = {
  __typename?: 'ProfileSkillsModuleSkillsPerformaceWithCurrentSkills';
  changePercentage?: Maybe<Scalars['Int']>;
  currentTotalPerformance?: Maybe<Scalars['Int']>;
  globalId: Scalars['GlobalID'];
  savedTotalPerformance: Scalars['Int'];
  skills?: Maybe<Array<ProfileSkillsModuleSkillPerformance>>;
};

/** Skills module visibility */
export type ProfileSkillsModuleVisibility = {
  __typename?: 'ProfileSkillsModuleVisibility';
  enabled: Scalars['Boolean'];
};

export type ProfileSkillsSuggestion = {
  __typename?: 'ProfileSkillsSuggestion';
  /** Suggestion text */
  suggestion: Scalars['String'];
  /** Tracking token for use in autocompletionTrack mutation */
  trackingToken: Scalars['String'];
  /** 0-based position in suggestion list */
  position: Scalars['Int'];
  /** Skill performance */
  totalPerformance?: Maybe<Scalars['Int']>;
  /** Skill performance trend */
  trend?: Maybe<Scalars['Int']>;
  /** Skill category, either 'soft' or 'hard' */
  category?: Maybe<Scalars['String']>;
};

export type ProfileSkillsUpdateError = {
  __typename?: 'ProfileSkillsUpdateError';
  message?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<ProfileSkillsUpdateFieldsError>;
};

export type ProfileSkillsUpdateFieldsError = {
  __typename?: 'ProfileSkillsUpdateFieldsError';
  haves?: Maybe<Array<Scalars['String']>>;
};

export type ProfileSkillsUpdateInput = {
  /** Collection of skills, like [{value: 'top-skill-1', isTop: true, category: 'hard'}, {value: 'skill-1', isTop: false, category: 'soft'}]  */
  shareWithContacts?: Maybe<Scalars['Boolean']>;
  collection?: Maybe<Array<Maybe<ProfileSkillInput>>>;
  userId?: Maybe<Scalars['ID']>;
};

export type ProfileSkillsUpdateResult = {
  __typename?: 'ProfileSkillsUpdateResult';
  /** #rest #virtual */
  profileSkills?: Maybe<ProfileSkills>;
  error?: Maybe<ProfileSkillsUpdateError>;
};

export type ProfileStats = HasDerivedGlobalId & {
  __typename?: 'ProfileStats';
  createdAt: Scalars['String'];
  totalHits: Scalars['Int'];
  /** Globally unique id for this instance based on typename and id */
  globalId: Scalars['GlobalID'];
};

export type ProfileStatsModule = ModuleInterface & {
  __typename?: 'ProfileStatsModule';
  title: Scalars['String'];
  order: Scalars['Int'];
  /** #rest #virtual */
  content?: Maybe<ProfileStats>;
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type ProfileStructuredData = {
  __typename?: 'ProfileStructuredData';
  /** #logged-out #soft-logged-in */
  context?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  type?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  sameAs?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  givenName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  familyName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  jobTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  honorificPrefix?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  honorificSuffix?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  image?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  workLocation?: Maybe<ProfileStructuredDataWorkLocation>;
  /** #logged-out #soft-logged-in */
  worksFor?: Maybe<Array<Maybe<ProfileStructuredDataWorkExperience>>>;
  /** #logged-out #soft-logged-in */
  makesOffer?: Maybe<Array<Maybe<ProfileStructuredDataOfferAndSeeks>>>;
  /** #logged-out #soft-logged-in */
  alumniOf?: Maybe<Array<Maybe<ProfileStructuredDataAlumni>>>;
  /** #logged-out #soft-logged-in */
  seeks?: Maybe<Array<Maybe<ProfileStructuredDataOfferAndSeeks>>>;
};

export type ProfileStructuredDataAlumni = {
  __typename?: 'ProfileStructuredDataAlumni';
  /** #logged-out #soft-logged-in */
  type?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  startDate?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  endDate?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  alumniOf?: Maybe<ProfileStructuredDataAlumniOrganization>;
};

export type ProfileStructuredDataAlumniOrganization = {
  __typename?: 'ProfileStructuredDataAlumniOrganization';
  /** #logged-out #soft-logged-in */
  type?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
};

export type ProfileStructuredDataOfferAndSeeks = {
  __typename?: 'ProfileStructuredDataOfferAndSeeks';
  /** #logged-out #soft-logged-in */
  type?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
};

export type ProfileStructuredDataWorkAddress = {
  __typename?: 'ProfileStructuredDataWorkAddress';
  /** #logged-out #soft-logged-in */
  type?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  addressCountry?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  addressLocality?: Maybe<Scalars['String']>;
};

export type ProfileStructuredDataWorkExperience = {
  __typename?: 'ProfileStructuredDataWorkExperience';
  /** #logged-out #soft-logged-in */
  type?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  roleName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  startDate?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  endDate?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  worksFor?: Maybe<ProfileStructuredDataWorkOrganization>;
};

export type ProfileStructuredDataWorkLocation = {
  __typename?: 'ProfileStructuredDataWorkLocation';
  /** #logged-out #soft-logged-in */
  type?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  address?: Maybe<ProfileStructuredDataWorkAddress>;
};

export type ProfileStructuredDataWorkOrganization = {
  __typename?: 'ProfileStructuredDataWorkOrganization';
  /** #logged-out #soft-logged-in */
  type?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  location?: Maybe<ProfileStructuredDataWorkAddress>;
};

/** All avaliable actions: ProfileTimelineGlobalAction + ProfileTimelineEntryAction */
export enum ProfileTimelineAction {
  AddEntry = 'ADD_ENTRY',
  EditEntry = 'EDIT_ENTRY'
}

export type ProfileTimelineAddEntryInput = {
  formInput: ProfileTimelineEntryFormInput;
  occupationType: ProfileOccupationTypeIdentifier;
  occupationTypeCategory: ProfileOccupationTypeCategoryIdentifier;
};

/** The outermost organizational unit. Until now 'Work experience' or 'Education' */
export type ProfileTimelineBucket = Localizable & {
  __typename?: 'ProfileTimelineBucket';
  /** The actual entries */
  entries?: Maybe<Array<Maybe<ProfileTimelineEntry>>>;
  /** The raw text resource key from Phraseapp */
  localizationKey: Scalars['String'];
  /** The value localized based on the `Accept-Language` header */
  localizationValue: Scalars['String'];
};

export type ProfileTimelineCareerLevelField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineDropdownField & ProfileTimelineLabelableField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineCareerLevelField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  options?: Maybe<Array<ProfileTimelineDropdownValue>>;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

/** Just simple 'sub-entries' */
export type ProfileTimelineCareerStep = {
  __typename?: 'ProfileTimelineCareerStep';
  /** A job title, like Senior Buzzword Generator */
  title: Scalars['String'];
  /** Localized time data as markdown */
  localizedTimeString: Scalars['Markdown'];
};

export type ProfileTimelineCompanyFieldInput = {
  companyId?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
};

export type ProfileTimelineCompanyIndustryField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & {
  __typename?: 'ProfileTimelineCompanyIndustryField';
  companyIndustryValue?: Maybe<ProfileTimelineCompanyIndustryFieldValue>;
  /** #rest #virtual */
  options?: Maybe<Array<Industry>>;
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
};

export type ProfileTimelineCompanyIndustryFieldInput = {
  /** Id as taken from Query.industries.id */
  industry?: Maybe<Scalars['ID']>;
  /** Id as taken from Query.industries.segments.id */
  segment?: Maybe<Scalars['ID']>;
};

export type ProfileTimelineCompanyIndustryFieldValue = {
  __typename?: 'ProfileTimelineCompanyIndustryFieldValue';
  /** Id as taken from Query.industries.id */
  industry?: Maybe<Scalars['ID']>;
  /** Id as taken from Query.industries.segments.id */
  segment?: Maybe<Scalars['ID']>;
};

export type ProfileTimelineCompanyNameField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineFieldStringValue & ProfileTimelineMaxLengthField & {
  __typename?: 'ProfileTimelineCompanyNameField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
  maxLength?: Maybe<Scalars['Int']>;
};

export type ProfileTimelineCourseOfStudyField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineCourseOfStudyField';
  title: Scalars['String'];
  isMandatory: Scalars['Boolean'];
  isAddable: Scalars['Boolean'];
  name: ProfileTimelineFieldName;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

export type ProfileTimelineCourseOfStudyFieldInput = {
  value?: Maybe<Scalars['String']>;
};

export type ProfileTimelineDegreeField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineDegreeField';
  title: Scalars['String'];
  isMandatory: Scalars['Boolean'];
  isAddable: Scalars['Boolean'];
  name: ProfileTimelineFieldName;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

export type ProfileTimelineDegreeFieldInput = {
  value?: Maybe<Scalars['String']>;
};

export type ProfileTimelineDeleteEntryError = {
  __typename?: 'ProfileTimelineDeleteEntryError';
  message: Scalars['String'];
};

export type ProfileTimelineDeleteEntryInput = {
  urn: Scalars['GlobalID'];
};

export type ProfileTimelineDeleteEntryPayload = {
  __typename?: 'ProfileTimelineDeleteEntryPayload';
  success?: Maybe<ProfileTimelineModule>;
  error?: Maybe<ProfileTimelineDeleteEntryError>;
};

export type ProfileTimelineDescriptionField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineFieldStringValue & ProfileTimelineMaxLengthField & {
  __typename?: 'ProfileTimelineDescriptionField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
  maxLength?: Maybe<Scalars['Int']>;
};

export type ProfileTimelineDescriptionFieldInput = {
  value?: Maybe<Scalars['String']>;
};

export type ProfileTimelineDisciplineField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineDropdownField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineDisciplineField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  options?: Maybe<Array<ProfileTimelineDropdownValue>>;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

/** Describes dropdown form field for the Timeline module */
export type ProfileTimelineDropdownField = {
  options?: Maybe<Array<ProfileTimelineDropdownValue>>;
};

/** Dropdown value for the form field on the Timeline module */
export type ProfileTimelineDropdownValue = {
  __typename?: 'ProfileTimelineDropdownValue';
  value: Scalars['String'];
  label: Scalars['String'];
};

/** Describes dropdown form field for the Timeline module but using ID for value */
export type ProfileTimelineDropdownWithIdField = {
  optionsWithId: Array<ProfileTimelineDropdownWithIdValue>;
};

/** Dropdown value with scrambled ID for the form field on the Timeline module */
export type ProfileTimelineDropdownWithIdValue = {
  __typename?: 'ProfileTimelineDropdownWithIdValue';
  value: Scalars['ID'];
  label: Scalars['String'];
};

export type ProfileTimelineEditEntryInput = {
  urn: Scalars['GlobalID'];
  formInput: ProfileTimelineEntryFormInput;
};

export type ProfileTimelineEmployeesField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineDropdownField & ProfileTimelineDropdownWithIdField & ProfileTimelineFieldIdValue & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineEmployeesField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  options?: Maybe<Array<ProfileTimelineDropdownValue>>;
  optionsWithId: Array<ProfileTimelineDropdownWithIdValue>;
  /** Value stored for the field in the scrambled Id format */
  idValue?: Maybe<Scalars['ID']>;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

export type ProfileTimelineEmploymentField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineDropdownField & ProfileTimelineLabelableField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineEmploymentField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  options?: Maybe<Array<ProfileTimelineDropdownValue>>;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

/** A ProfileTimelineEntry is the affiliation with a specific organization, like working for a company. It can hold several career steps and has possible actions. */
export type ProfileTimelineEntry = {
  __typename?: 'ProfileTimelineEntry';
  /** The raw id. Not the URN */
  id?: Maybe<Scalars['ID']>;
  /** Multiple entries can be current, think parallel club membership and employment at a company */
  isCurrent: Scalars['Boolean'];
  /**
   * #rest(batched) #virtual
   *
   *  An organization, like the company somebody is working at or a club she is a member of
   */
  organization?: Maybe<ProfileTimelineOrganization>;
  /** Something like employee, freelancer, owner */
  occupationType: ProfileOccupationType;
  /** Localized time data as markdown, the date copy part indicating current ("present"/"bis heute") is formatted in **bold** */
  localizedTimeString: Scalars['Markdown'];
  /** A simplified localized time string that does not include 'current' aka 'ongoing' or 'until now' and no markdown */
  justLocalizedTimeString: Scalars['String'];
  /** An entry title, this can be a job title like Software Engineer, an educational title like Mathematics or it can be null */
  title?: Maybe<Scalars['String']>;
  /** The geographical location of this entry. Where is the office? */
  location?: Maybe<ProfileTimelineEntryLocation>;
  /** Data based on user memberships or roles like projobs or executives */
  additionalData?: Maybe<ProfileTimelineEntryAdditionalData>;
  /**
   * #preview
   *
   *  Simple sub-entries the user can have as part of an entry
   */
  careerSteps: Array<ProfileTimelineCareerStep>;
  /** User entered information that describes the entry in more detail. Company notes for work experiences, and school notes for schools */
  description?: Maybe<Scalars['String']>;
  /** User entered website with more information on the entry */
  website?: Maybe<ProfileTimelineEntryWebsite>;
  /** User entered (future) degree */
  degree?: Maybe<Scalars['String']>;
  /** The URN of the entry */
  urn?: Maybe<Scalars['GlobalID']>;
};

/**
 * Additional Data vowen in from other back ends depending on the entry having different types of additional data.
 * As of now we have the old projobs data integration as `projobsData` and the new integration of the projobs V2
 * work experiences endpoint as `projobsV2WorkExperienceData`
 */
export type ProfileTimelineEntryAdditionalData = {
  __typename?: 'ProfileTimelineEntryAdditionalData';
  /** Old projobs job seeker data */
  projobsData?: Maybe<ProJobsWorkExperience>;
  /**
   * #rest #virtual
   *
   *  New projobs V2 backend data
   */
  projobsV2Data?: Maybe<ProfileTimelineEntryProjobsV2Data>;
};

export type ProfileTimelineEntryDeletability = {
  __typename?: 'ProfileTimelineEntryDeletability';
  isDeletable: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  isPotentiallyDeletable: Scalars['Boolean'];
};

export type ProfileTimelineEntryError = {
  __typename?: 'ProfileTimelineEntryError';
  message: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<ProfileTimelineEntryFieldErrors>;
};

export type ProfileTimelineEntryFieldErrors = {
  __typename?: 'ProfileTimelineEntryFieldErrors';
  description?: Maybe<Array<Scalars['String']>>;
  location?: Maybe<Array<Scalars['String']>>;
  timePeriod?: Maybe<Array<Scalars['String']>>;
  website?: Maybe<Array<Scalars['String']>>;
  courseOfStudy?: Maybe<Array<Scalars['String']>>;
  university?: Maybe<Array<Scalars['String']>>;
  degree?: Maybe<Array<Scalars['String']>>;
  careerLevel?: Maybe<Array<Scalars['String']>>;
  companyName?: Maybe<Array<Scalars['String']>>;
  discipline?: Maybe<Array<Scalars['String']>>;
  employees?: Maybe<Array<Scalars['String']>>;
  employment?: Maybe<Array<Scalars['String']>>;
  companyIndustry?: Maybe<Array<Scalars['String']>>;
  industry?: Maybe<Array<Scalars['String']>>;
  jobTitle?: Maybe<Array<Scalars['String']>>;
  legalForm?: Maybe<Array<Scalars['String']>>;
  primaryOccupation?: Maybe<Array<Scalars['String']>>;
  projobsBudget?: Maybe<Array<Scalars['String']>>;
  projobsRevenue?: Maybe<Array<Scalars['String']>>;
  projobsStaffResponsibility?: Maybe<Array<Scalars['String']>>;
};

export type ProfileTimelineEntryFormInput = {
  description?: Maybe<ProfileTimelineDescriptionFieldInput>;
  location?: Maybe<ProfileTimelineLocationFieldInput>;
  timePeriod?: Maybe<ProfileTimelineTimePeriodFieldInput>;
  website?: Maybe<ProfileTimelineWebsiteFieldInput>;
  courseOfStudy?: Maybe<ProfileTimelineCourseOfStudyFieldInput>;
  degree?: Maybe<ProfileTimelineDegreeFieldInput>;
  university?: Maybe<ProfileTimelineUniversityFieldInput>;
  careerLevel?: Maybe<ProfileTimelineStringFieldInput>;
  companyName?: Maybe<ProfileTimelineCompanyFieldInput>;
  discipline?: Maybe<ProfileTimelineStringFieldInput>;
  employees?: Maybe<ProfileTimelineStringFieldInput>;
  employment?: Maybe<ProfileTimelineStringFieldInput>;
  /** The industry fields comes as `industry` and `companyIndustry` to work around an old issue */
  companyIndustry?: Maybe<ProfileTimelineCompanyIndustryFieldInput>;
  /** The industry fields comes as `industry` and `companyIndustry` to work around an old issue */
  industry?: Maybe<ProfileTimelineCompanyIndustryFieldInput>;
  jobTitle?: Maybe<ProfileTimelineStringFieldInput>;
  legalForm?: Maybe<ProfileTimelineStringFieldInput>;
  primaryOccupation?: Maybe<ProfileTimelinePrimaryOccupationFieldInput>;
  subject?: Maybe<ProfileTimelineSubjectFieldInput>;
  vocationalSchool?: Maybe<ProfileTimelineVocationalSchoolFieldInput>;
  qualification?: Maybe<ProfileTimelineQualificationFieldInput>;
  projobsBudget?: Maybe<ProfileTimelineProjobsFieldInput>;
  projobsRevenue?: Maybe<ProfileTimelineProjobsFieldInput>;
  projobsStaffResponsibility?: Maybe<ProfileTimelineStringFieldInput>;
};

/** The geographical location of a career step */
export type ProfileTimelineEntryLocation = {
  __typename?: 'ProfileTimelineEntryLocation';
  city?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  country?: Maybe<Country>;
};

export type ProfileTimelineEntryMonthYear = {
  year?: Maybe<Scalars['Int']>;
  /** Month with January = 1 */
  month?: Maybe<Scalars['Int']>;
};

export type ProfileTimelineEntryPayload = {
  __typename?: 'ProfileTimelineEntryPayload';
  success?: Maybe<ProfileTimelineModule>;
  error?: Maybe<ProfileTimelineEntryError>;
};

/** Types for the new projobs v2 */
export type ProfileTimelineEntryProjobsV2Data = ProJobsV2WorkExperience;

/** A web site */
export type ProfileTimelineEntryWebsite = {
  __typename?: 'ProfileTimelineEntryWebsite';
  url: Scalars['URL'];
};

/** Describes basic form field for the Timeline module */
export type ProfileTimelineField = {
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
};

export type ProfileTimelineFieldIdValue = {
  /** Value stored for the field in the scrambled Id format */
  idValue?: Maybe<Scalars['ID']>;
};

/** Supported fields for the forms in the Timeline module */
export enum ProfileTimelineFieldName {
  JobTitle = 'JOB_TITLE',
  Employment = 'EMPLOYMENT',
  CareerLevel = 'CAREER_LEVEL',
  PartTime = 'PART_TIME',
  ProjobsStaffResponsibility = 'PROJOBS_STAFF_RESPONSIBILITY',
  ProjobsStaff = 'PROJOBS_STAFF',
  ProjobsBudget = 'PROJOBS_BUDGET',
  ProjobsRevenue = 'PROJOBS_REVENUE',
  CompanyName = 'COMPANY_NAME',
  LegalForm = 'LEGAL_FORM',
  Employees = 'EMPLOYEES',
  Industry = 'INDUSTRY',
  Location = 'LOCATION',
  Discipline = 'DISCIPLINE',
  Website = 'WEBSITE',
  Description = 'DESCRIPTION',
  CourseOfStudy = 'COURSE_OF_STUDY',
  Subject = 'SUBJECT',
  University = 'UNIVERSITY',
  VocationalSchool = 'VOCATIONAL_SCHOOL',
  TimePeriod = 'TIME_PERIOD',
  Degree = 'DEGREE',
  Qualification = 'QUALIFICATION',
  PrimaryOccupation = 'PRIMARY_OCCUPATION'
}

export type ProfileTimelineFieldStringValue = {
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

/** Describes a form for the Timeline module */
export type ProfileTimelineForm = {
  __typename?: 'ProfileTimelineForm';
  components: Array<Maybe<ProfileTimelineFormComponent>>;
  deletability: ProfileTimelineEntryDeletability;
  occupationType: ProfileOccupationType;
  occupationTypeCategory: ProfileOccupationTypeCategory;
};

export type ProfileTimelineFormComponent = {
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
};

export type ProfileTimelineHeader = ProfileTimelineFormComponent & {
  __typename?: 'ProfileTimelineHeader';
  /** Text to be displayed as the header */
  title: Scalars['String'];
};

export type ProfileTimelineJobTitleField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineJobTitleField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

/** Fields that have a label, deprecated: please use ProfileTimelineFormComponent instead */
export type ProfileTimelineLabelableField = {
  /** Text to be displayed next to the field */
  title: Scalars['String'];
};

export type ProfileTimelineLegalFormField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineDropdownField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineLegalFormField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  options?: Maybe<Array<ProfileTimelineDropdownValue>>;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

export type ProfileTimelineLocationField = ProfileTimelineFormComponent & ProfileTimelineField & {
  __typename?: 'ProfileTimelineLocationField';
  /** Location stored for the field */
  locationValue?: Maybe<ProfileTimelineLocationFieldValue>;
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
};

export type ProfileTimelineLocationFieldInput = {
  city?: Maybe<Scalars['String']>;
  /** Autocomplete item ID */
  locationId?: Maybe<Scalars['Int']>;
};

export type ProfileTimelineLocationFieldValue = {
  __typename?: 'ProfileTimelineLocationFieldValue';
  city?: Maybe<Scalars['String']>;
  /** Autocomplete item ID */
  locationId?: Maybe<Scalars['Int']>;
};

export type ProfileTimelineMaxLengthField = {
  maxLength?: Maybe<Scalars['Int']>;
};

/** The Timeline module, with buckets of professional and educational timeline data, as well as global actions */
export type ProfileTimelineModule = ModuleInterface & OutdatableModule & HasGlobalId & {
  __typename?: 'ProfileTimelineModule';
  buckets?: Maybe<Array<ProfileTimelineBucket>>;
  order: Scalars['Int'];
  title: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
  outdated: Scalars['Boolean'];
  outdatedFields?: Maybe<Scalars['String']>;
  lastModified?: Maybe<Scalars['Date']>;
};

/** A union of organization types, like Company and EducationalInstitution */
export type ProfileTimelineOrganization = ProfileEducationalInstitution | ProfileCompany;

export type ProfileTimelinePrimaryOccupationField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & {
  __typename?: 'ProfileTimelinePrimaryOccupationField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
};

export type ProfileTimelinePrimaryOccupationFieldInput = {
  value?: Maybe<Scalars['Boolean']>;
};

export type ProfileTimelineProjobsBudgetField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineProjobsResponsibilityField & {
  __typename?: 'ProfileTimelineProjobsBudgetField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  projobsValue?: Maybe<ProfileTimelineProjobsValue>;
};

export type ProfileTimelineProjobsFieldInput = {
  hasResponsibility?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Int']>;
};

/**
 * Input for the fact if a user has budget or revenue responsibility and the monetary value as an integer.
 *
 * The value is an object of the following form:
 *
 * ```
 * {
 *   "projobsValue": {
 *     "hasResponsibility": true,
 *     "value": 1000000
 *   }
 * }
 * ```
 */
export type ProfileTimelineProjobsResponsibilityField = {
  projobsValue?: Maybe<ProfileTimelineProjobsValue>;
};

export type ProfileTimelineProjobsRevenueField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineProjobsResponsibilityField & {
  __typename?: 'ProfileTimelineProjobsRevenueField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  projobsValue?: Maybe<ProfileTimelineProjobsValue>;
};

export type ProfileTimelineProjobsStaffResponsibilityField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineDropdownField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineProjobsStaffResponsibilityField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  options?: Maybe<Array<ProfileTimelineDropdownValue>>;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

export type ProfileTimelineProjobsValue = {
  __typename?: 'ProfileTimelineProjobsValue';
  hasResponsibility: Scalars['Boolean'];
  value?: Maybe<Scalars['Int']>;
};

export type ProfileTimelineQualificationField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineQualificationField';
  title: Scalars['String'];
  isMandatory: Scalars['Boolean'];
  isAddable: Scalars['Boolean'];
  name: ProfileTimelineFieldName;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

export type ProfileTimelineQualificationFieldInput = {
  value?: Maybe<Scalars['String']>;
};

export type ProfileTimelineStringFieldInput = {
  value?: Maybe<Scalars['String']>;
};

export type ProfileTimelineSubjectField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineSubjectField';
  title: Scalars['String'];
  isMandatory: Scalars['Boolean'];
  isAddable: Scalars['Boolean'];
  name: ProfileTimelineFieldName;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

export type ProfileTimelineSubjectFieldInput = {
  value?: Maybe<Scalars['String']>;
};

export type ProfileTimelineTimePeriodField = ProfileTimelineFormComponent & ProfileTimelineField & {
  __typename?: 'ProfileTimelineTimePeriodField';
  /** The title is unused in this type since the sub-fields are labeled individually */
  title: Scalars['String'];
  isMandatory: Scalars['Boolean'];
  isAddable: Scalars['Boolean'];
  name: ProfileTimelineFieldName;
  /** Time period stored for the field */
  timePeriodValue?: Maybe<ProfileTimelineTimePeriodFieldValue>;
};

export type ProfileTimelineTimePeriodFieldInput = {
  startDate?: Maybe<ProfileTimelineEntryMonthYear>;
  endDate?: Maybe<ProfileTimelineEntryMonthYear>;
  /** Normally, either one field must be provided e.g `endDate` or `isOngoing` */
  isOngoing?: Maybe<Scalars['Boolean']>;
};

export type ProfileTimelineTimePeriodFieldMonthYearValue = {
  __typename?: 'ProfileTimelineTimePeriodFieldMonthYearValue';
  year: Scalars['Int'];
  /** Month with January = 1 */
  month?: Maybe<Scalars['Int']>;
};

export type ProfileTimelineTimePeriodFieldValue = {
  __typename?: 'ProfileTimelineTimePeriodFieldValue';
  startDate?: Maybe<ProfileTimelineTimePeriodFieldMonthYearValue>;
  endDate?: Maybe<ProfileTimelineTimePeriodFieldMonthYearValue>;
};

export type ProfileTimelineUniversityField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineUniversityField';
  title: Scalars['String'];
  isMandatory: Scalars['Boolean'];
  isAddable: Scalars['Boolean'];
  name: ProfileTimelineFieldName;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

export type ProfileTimelineUniversityFieldInput = {
  value?: Maybe<Scalars['String']>;
};

export type ProfileTimelineVocationalSchoolField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineFieldStringValue & {
  __typename?: 'ProfileTimelineVocationalSchoolField';
  title: Scalars['String'];
  isMandatory: Scalars['Boolean'];
  isAddable: Scalars['Boolean'];
  name: ProfileTimelineFieldName;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
};

export type ProfileTimelineVocationalSchoolFieldInput = {
  value?: Maybe<Scalars['String']>;
};

export type ProfileTimelineWebsiteField = ProfileTimelineFormComponent & ProfileTimelineField & ProfileTimelineLabelableField & ProfileTimelineFieldStringValue & ProfileTimelineMaxLengthField & {
  __typename?: 'ProfileTimelineWebsiteField';
  /** Text to be displayed next to the field or as separator */
  title: Scalars['String'];
  /** If the field is mandatory */
  isMandatory: Scalars['Boolean'];
  /** If the field should be displayed in 'Additional fields' section */
  isAddable: Scalars['Boolean'];
  /** Identifier (name) of the form field to be sent to the backend */
  name: ProfileTimelineFieldName;
  /** Value stored for the field in the simple String format */
  stringValue?: Maybe<Scalars['String']>;
  maxLength?: Maybe<Scalars['Int']>;
};

export type ProfileTimelineWebsiteFieldInput = {
  value?: Maybe<Scalars['String']>;
};

export type ProfileUpdateDeleteError = {
  __typename?: 'ProfileUpdateDeleteError';
  message?: Maybe<Scalars['String']>;
};

export type ProfileUpdateDeleteInput = {
  id: Scalars['ID'];
};

export type ProfileUpdateDeleteResult = {
  __typename?: 'ProfileUpdateDeleteResult';
  success?: Maybe<ProfileUpdateDeleteSuccess>;
  error?: Maybe<ProfileUpdateDeleteError>;
};

export type ProfileUpdateDeleteSuccess = {
  __typename?: 'ProfileUpdateDeleteSuccess';
  message?: Maybe<Scalars['String']>;
};

export type ProfileUpdatePhoto = {
  __typename?: 'ProfileUpdatePhoto';
  id: Scalars['ID'];
  createdAt?: Maybe<Scalars['Date']>;
  urn: Scalars['GlobalID'];
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
};

export type ProfileUpdateStatus = {
  __typename?: 'ProfileUpdateStatus';
  id: Scalars['ID'];
  status: Scalars['String'];
  statusText: Scalars['String'];
  text: Scalars['String'];
  createdAt: Scalars['Date'];
  urn: Scalars['GlobalID'];
};

/** Settings related to the visbility of the logged-out profile of a user. */
export type ProfileVisibilitySetting = HasGlobalId & {
  __typename?: 'ProfileVisibilitySetting';
  /** Whether the user wishes that his/her profile is available logged-out */
  isLoggedOutVisible: Scalars['Boolean'];
  /** Whether the user wishes for search-engines to index his/her profile */
  isSearchEngineIndexable: Scalars['Boolean'];
  /** Globally unique id for this instance */
  globalId: Scalars['GlobalID'];
};

export type ProfileVisibilitySettingInput = {
  /** Whether the user wishes that his/her profile is available logged-out */
  isLoggedOutVisible: Scalars['Boolean'];
  /** Whether the user wishes for search-engines to index his/her profile */
  isSearchEngineIndexable: Scalars['Boolean'];
};

/**
 * Represents a visit of a profile.
 * Contains information about the user, reason and time of the visit
 */
export type ProfileVisit = {
  __typename?: 'ProfileVisit';
  /** ID of the profile visit. */
  id: Scalars['ID'];
  /** ID of the user who visited the profile. 0 for logged-out visits. */
  visitorId?: Maybe<Scalars['ID']>;
  /**
   * #rest(batched) #virtual
   *
   *  XingId representation of the profile visitor
   * @deprecated deprecated in favor of profileVisitor.
   */
  visitor?: Maybe<XingId>;
  /**
   * #rest(batched) #virtual
   *
   *  Fenced XingId representation of the profile visitor
   */
  profileVisitor?: Maybe<ProfileVisitor>;
  /** ISO 8601 Timestamp when the profile was visited. */
  viewedAt?: Maybe<Scalars['Date']>;
  /** Number of times the visitor visited the profile. */
  numberOfVisits?: Maybe<Scalars['Int']>;
  /**
   * Click reason (translation language complies with the first two letters of an Accept-Language request header,
   *     which in Rails/Rack is internally represented as HTTP_ACCEPT_LANGUAGE and must be one of the valid languages
   *     of a XING platform, falling back to German otherwise)
   */
  reasonHtml?: Maybe<Scalars['String']>;
  /** New VOMP message which contains click reason text resources and/or prioritized commonality text resource */
  label?: Maybe<Scalars['String']>;
  /** Additional payload of a profile visit containing information about recruiter status, company name and job title */
  payload: ProfileVisitPayload;
  /**
   * #rest(batched) #virtual
   *
   *  SharedContacts the contacts that the user shares with this profile visitor
   */
  sharedContacts?: Maybe<SharedContacts>;
  /**
   * #rest(batched) #virtual
   *
   *  Distance between the user and the profile visitor
   */
  contactDistance?: Maybe<ContactDistance>;
  /**
   * #rest(batched) #virtual
   *
   *  Relationship between the user and the profile visitor
   */
  networkRelationship?: Maybe<NetworkRelationship>;
  /** Indicates if visit is new or not */
  newVisit?: Maybe<Scalars['Boolean']>;
};

/** New VOMP error response */
export type ProfileVisitErrorResponse = {
  __typename?: 'ProfileVisitErrorResponse';
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  created?: Maybe<Scalars['Boolean']>;
};

/** Input parameters for new VOMP */
export type ProfileVisitInput = {
  visiteePageName: Scalars['String'];
  clickReasonCode?: Maybe<Scalars['String']>;
  remoteIp?: Maybe<Scalars['String']>;
  referer?: Maybe<Scalars['String']>;
  platform: VompPlatformEnum;
};

/** Wrapper object for additional payload to a visitor */
export type ProfileVisitPayload = {
  __typename?: 'ProfileVisitPayload';
  visitor?: Maybe<ProfileVisitorPayload>;
};

/** New VOMP success response */
export type ProfileVisitSuccessResponse = {
  __typename?: 'ProfileVisitSuccessResponse';
  /** #logged-out #soft-logged-in */
  created?: Maybe<Scalars['Boolean']>;
};

export type ProfileVisitor = FencedProfileVisitor | XingId;

/**
 * Additional Payload to a Profile Visit.
 * It contains information about the company name, job title and if a user is a recruiter.
 */
export type ProfileVisitorPayload = {
  __typename?: 'ProfileVisitorPayload';
  /** Name of the company the profile visitor is currently working at */
  companyName?: Maybe<Scalars['String']>;
  /** Job title of the profile visitor */
  jobTitle?: Maybe<Scalars['String']>;
  /** Whether the user is a recruiter */
  isRecruiter?: Maybe<Scalars['Boolean']>;
};

export type ProfileVisitorsConnection = HasCursorPagination & {
  __typename?: 'ProfileVisitorsConnection';
  edges: Array<ProfileVisitorsEdge>;
  /**
   * #virtual
   *
   *  Total number of visits
   */
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type ProfileVisitorsEdge = PaginationEdge & {
  __typename?: 'ProfileVisitorsEdge';
  node: ProfileVisit;
  /** #virtual */
  cursor: Scalars['String'];
};

export type ProfileWants = {
  __typename?: 'ProfileWants';
  /** #logged-out #soft-logged-in */
  wants?: Maybe<Scalars['String']>;
};

export type ProfileWants2 = HasGlobalId & {
  __typename?: 'ProfileWants2';
  /** #soft-logged-in #logged-out */
  globalId: Scalars['GlobalID'];
  /** #soft-logged-in #logged-out */
  wants?: Maybe<Array<Scalars['String']>>;
};

/** Profile module that allow users to see/add wants */
export type ProfileWantsModule = ModuleInterface & {
  __typename?: 'ProfileWantsModule';
  /** #soft-logged-in */
  title: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  globalId: Scalars['GlobalID'];
  content?: Maybe<ProfileWants2>;
  recommendations?: Maybe<ProfileWantsModuleRecommendations>;
  active?: Maybe<Scalars['Boolean']>;
};

export type ProfileWantsModuleRecommendation = {
  __typename?: 'ProfileWantsModuleRecommendation';
  label: Scalars['String'];
};

export type ProfileWantsModuleRecommendations = {
  __typename?: 'ProfileWantsModuleRecommendations';
  total: Scalars['Int'];
  collection?: Maybe<Array<ProfileWantsModuleRecommendation>>;
};

export type ProfileWantsUpdate = PeopleStoryGeneratorProfileUpdate & {
  __typename?: 'ProfileWantsUpdate';
  wants: Array<Scalars['String']>;
  previousWants?: Maybe<Array<Maybe<Scalars['String']>>>;
  newWants: Array<Scalars['String']>;
  urn: Scalars['GlobalID'];
  id: Scalars['ID'];
  profileId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
};

export type ProfileWantsUpdateError = {
  __typename?: 'ProfileWantsUpdateError';
  message?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<ProfileWantsUpdateFieldsError>;
};

export type ProfileWantsUpdateFieldsError = {
  __typename?: 'ProfileWantsUpdateFieldsError';
  wants?: Maybe<Array<Scalars['String']>>;
};

export type ProfileWantsUpdateInput = {
  /** Wants of a user, like ['want-1', 'want-2']  */
  wants: Array<Scalars['String']>;
  userId: Scalars['ID'];
};

export type ProfileWantsUpdateResult = ProfileWants2 | ProfileWantsUpdateError;

export type ProfileWorkExperience = {
  __typename?: 'ProfileWorkExperience';
  /** #logged-out #soft-logged-in */
  currentCompany?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  primaryJob?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  beginDate?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  duration?: Maybe<ProfileWorkExperienceDuration>;
  /** #logged-out #soft-logged-in */
  endDate?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companyName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companyUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
  /** #logged-out #soft-logged-in */
  normalizedName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  jobTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  careerLevel?: Maybe<CareerLevel>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
  /** #rest(batched) #virtual */
  workExperienceStatus?: Maybe<WorkExperienceStatus>;
  /** #logged-out #soft-logged-in */
  orgTypeId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  localizedTimeString?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companyNotes?: Maybe<Scalars['String']>;
};

export type ProfileWorkExperienceCollection = {
  __typename?: 'ProfileWorkExperienceCollection';
  /** #logged-out #soft-logged-in */
  collection?: Maybe<Array<Maybe<ProfileWorkExperience>>>;
};

export type ProfileWorkExperienceDuration = {
  __typename?: 'ProfileWorkExperienceDuration';
  /** #logged-out #soft-logged-in */
  years?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  months?: Maybe<Scalars['Int']>;
};

export type ProfileWorkExperienceUpdate = PeopleStoryGeneratorProfileUpdate & {
  __typename?: 'ProfileWorkExperienceUpdate';
  workExperienceId?: Maybe<Scalars['ID']>;
  jobTitle?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  beginMonth?: Maybe<Scalars['Int']>;
  beginYear?: Maybe<Scalars['Int']>;
  endMonth?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  previousWorkExperienceId?: Maybe<Scalars['ID']>;
  previousJobTitle?: Maybe<Scalars['String']>;
  previousCompanyName?: Maybe<Scalars['String']>;
  previousBeginMonth?: Maybe<Scalars['Int']>;
  previousBeginYear?: Maybe<Scalars['Int']>;
  previousEndMonth?: Maybe<Scalars['Int']>;
  previousEndYear?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  urn: Scalars['GlobalID'];
  id: Scalars['ID'];
  profileId?: Maybe<Scalars['ID']>;
};

export type ProfileYearAndMonth = {
  __typename?: 'ProfileYearAndMonth';
  year?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
};

export type ProfilesB2bClientIdPayload = {
  __typename?: 'ProfilesB2bClientIdPayload';
  value?: Maybe<Scalars['ID']>;
};

/** Settings related to logged-out profiles and logged-out content */
export type ProfilesLoggedoutSettings = {
  __typename?: 'ProfilesLoggedoutSettings';
  /** Settings regarding the visibility of the profile itself */
  profileVisibility?: Maybe<ProfileVisibilitySetting>;
  /** Setting regarding the visibility of postings/comments the user creates */
  arePostsLoggedOutVisible?: Maybe<ToggleSetting>;
};

export type ProfilesLoggedoutSettingsInput = {
  /** Settings regarding the visibility of the profile itself */
  profileVisibility?: Maybe<ProfileVisibilitySettingInput>;
  /** Setting regarding the visibility of postings/comments the user creates */
  arePostsLoggedOutVisible?: Maybe<ToggleSettingInput>;
};

export type ProfilesLoggedoutSettingsMutationResult = {
  __typename?: 'ProfilesLoggedoutSettingsMutationResult';
  error?: Maybe<ProfilesLoggedoutSettings>;
  response?: Maybe<ProfilesLoggedoutSettings>;
};

export type ProjobsAddAllowlistUserError = ProjobsAllowlistError & {
  __typename?: 'ProjobsAddAllowlistUserError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsAddAllowlistUserInput = {
  userIds: Array<Scalars['ID']>;
};

/** Result type for adding a user to the allowlist that returns 204 on success */
export type ProjobsAddAllowlistUserResult = ProjobsAddAllowlistUserSuccess | ProjobsAddAllowlistUserError | ProjobsUserAlreadyBlockedError;

export type ProjobsAddAllowlistUserSuccess = {
  __typename?: 'ProjobsAddAllowlistUserSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsAddBlockedCompaniesError = ProjobsBlockedCompaniesError & {
  __typename?: 'ProjobsAddBlockedCompaniesError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsAddBlockedCompaniesInput = {
  companyIds: Array<Scalars['ID']>;
};

/** Result type for adding companies to the blocked_companies that returns 204 on success */
export type ProjobsAddBlockedCompaniesResult = ProjobsAddBlockedCompaniesSuccess | ProjobsAddBlockedCompaniesError;

export type ProjobsAddBlockedCompaniesSuccess = {
  __typename?: 'ProjobsAddBlockedCompaniesSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsAddBlocklistUserError = ProjobsBlocklistError & {
  __typename?: 'ProjobsAddBlocklistUserError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsAddBlocklistUserInput = {
  userIds: Array<Scalars['ID']>;
};

/** Result type for adding a user to the blocklist that returns 204 on success */
export type ProjobsAddBlocklistUserResult = ProjobsAddBlocklistUserSuccess | ProjobsAddBlocklistUserError | ProjobsUserAlreadyAllowedError;

export type ProjobsAddBlocklistUserSuccess = {
  __typename?: 'ProjobsAddBlocklistUserSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsAddIdealEmployersError = {
  __typename?: 'ProjobsAddIdealEmployersError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsAddIdealEmployersInput = {
  idealEmployerIds: Array<Maybe<Scalars['ID']>>;
};

/** Result type for adding a company to target companies that returns 204 on success */
export type ProjobsAddIdealEmployersResult = ProjobsAddIdealEmployersSuccess | ProjobsAddIdealEmployersError;

export type ProjobsAddIdealEmployersSuccess = {
  __typename?: 'ProjobsAddIdealEmployersSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsAllowlistError = {
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsAvoidError = {
  __typename?: 'ProjobsAvoidError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsAvoidInput = {
  avoid?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Result type for updating the avoid */
export type ProjobsAvoidResult = ProjobsAvoidSuccess | ProjobsAvoidError;

export type ProjobsAvoidSuccess = {
  __typename?: 'ProjobsAvoidSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsBlockedCompaniesError = {
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsBlockedCompanyError = {
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsBlocklistError = {
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsCitiesError = {
  __typename?: 'ProjobsCitiesError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsCitiesInput = {
  cityIds: Array<Maybe<Scalars['ID']>>;
  willingnessToMove: Scalars['Boolean'];
};

/** Result type for updating the descipline */
export type ProjobsCitiesResult = ProjobsCitiesSuccess | ProjobsCitiesError;

export type ProjobsCitiesSuccess = {
  __typename?: 'ProjobsCitiesSuccess';
  value?: Maybe<Scalars['String']>;
};

export enum ProjobsConsumer {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

/** Projobs Contact Options Type */
export type ProjobsContactOptions = {
  __typename?: 'ProjobsContactOptions';
  viaXingMessage: Scalars['Boolean'];
  viaEmail: Scalars['Boolean'];
  viaPhone: Scalars['Boolean'];
  emailAddress?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phonePreferences: PhonePreferences;
};

export type ProjobsContactOptionsError = {
  __typename?: 'ProjobsContactOptionsError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsContactOptionsInput = {
  viaXingMessage: Scalars['Boolean'];
  viaEmail: Scalars['Boolean'];
  viaPhone: Scalars['Boolean'];
  emailAddress?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phonePreference?: Maybe<PhonePreferencesOptions>;
  phonePreferenceSpecificTime?: Maybe<ProjobsPhonePreferenceSpecificTime>;
};

/** Result type for projobs contact options update that returns 204 on success" */
export type ProjobsContactOptionsResult = ProjobsContactOptionsSuccess | ProjobsContactOptionsError;

export type ProjobsContactOptionsSuccess = {
  __typename?: 'ProjobsContactOptionsSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsDeleteDocumentError = {
  __typename?: 'ProjobsDeleteDocumentError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsDeleteDocumentInput = {
  documentId: Scalars['ID'];
};

/** Result type for deleting a document from user that returns 204 on success */
export type ProjobsDeleteDocumentResult = ProjobsDeleteDocumentSuccess | ProjobsDeleteDocumentError;

export type ProjobsDeleteDocumentSuccess = {
  __typename?: 'ProjobsDeleteDocumentSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsDisciplineError = {
  __typename?: 'ProjobsDisciplineError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsDisciplineInput = {
  discipline?: Maybe<Scalars['ID']>;
};

/** Result type for updating the discipline */
export type ProjobsDisciplineResult = ProjobsDisciplineSuccess | ProjobsDisciplineError;

export type ProjobsDisciplineSuccess = {
  __typename?: 'ProjobsDisciplineSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsDocument = {
  __typename?: 'ProjobsDocument';
  id: Scalars['ID'];
  name: Scalars['String'];
  title: Scalars['String'];
  format: Scalars['String'];
  size: Scalars['String'];
  uploadDate: Scalars['String'];
  url: Scalars['String'];
};

/** Projobs Documents Type */
export type ProjobsDocuments = {
  __typename?: 'ProjobsDocuments';
  collection?: Maybe<Array<Maybe<ProjobsDocument>>>;
};

export type ProjobsIndustriesError = {
  __typename?: 'ProjobsIndustriesError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsIndustriesInput = {
  openToOtherIndustries: Scalars['Boolean'];
  industries: Array<Maybe<Scalars['ID']>>;
};

/** Result type for updating the industry */
export type ProjobsIndustriesResult = ProjobsIndustriesSuccess | ProjobsIndustriesError;

export type ProjobsIndustriesSuccess = {
  __typename?: 'ProjobsIndustriesSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsPhonePreferenceSpecificTime = {
  days: PhonePreferenceDays;
  timeFrom: Scalars['ID'];
  timeUntil: Scalars['ID'];
};

export type ProjobsPositionsError = {
  __typename?: 'ProjobsPositionsError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsPositionsInput = {
  positions: Array<Maybe<Scalars['String']>>;
};

/** Result type for updating the positions */
export type ProjobsPositionsResult = ProjobsPositionsSuccess | ProjobsPositionsError;

export type ProjobsPositionsSuccess = {
  __typename?: 'ProjobsPositionsSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsProfileSearchQueryInput = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  keywords: Scalars['String'];
  consumer: ProjobsConsumer;
};

export type ProjobsProfileSearchResult = {
  __typename?: 'ProjobsProfileSearchResult';
  trackingToken?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
};

export type ProjobsProfileSearchResults = {
  __typename?: 'ProjobsProfileSearchResults';
  total?: Maybe<Scalars['Int']>;
  collection: Array<ProjobsProfileSearchResult>;
};

export type ProjobsRecruiterInsights = {
  __typename?: 'ProjobsRecruiterInsights';
  /** The number of times the user was marked as candidate by recruiters */
  markedAsCandidate?: Maybe<Scalars['Int']>;
};

export type ProjobsRemoveAllowlistUserError = {
  __typename?: 'ProjobsRemoveAllowlistUserError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsRemoveAllowlistUserInput = {
  allowlistUserId: Scalars['ID'];
};

/** Result type for removing a user to the allowlist that returns 204 on success */
export type ProjobsRemoveAllowlistUserResult = ProjobsRemoveAllowlistUserSuccess | ProjobsRemoveAllowlistUserError;

export type ProjobsRemoveAllowlistUserSuccess = {
  __typename?: 'ProjobsRemoveAllowlistUserSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsRemoveBlockedCompanyError = ProjobsBlockedCompanyError & {
  __typename?: 'ProjobsRemoveBlockedCompanyError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsRemoveBlockedCompanyInput = {
  blockedCompanyId: Scalars['ID'];
};

/** Result type for removing company from the blocked_companies that returns 204 on success */
export type ProjobsRemoveBlockedCompanyResult = ProjobsRemoveBlockedCompanySuccess | ProjobsRemoveBlockedCompanyError;

export type ProjobsRemoveBlockedCompanySuccess = {
  __typename?: 'ProjobsRemoveBlockedCompanySuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsRemoveBlocklistUserError = {
  __typename?: 'ProjobsRemoveBlocklistUserError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsRemoveBlocklistUserInput = {
  blocklistUserId: Scalars['ID'];
};

/** Result type for removing a user to the blocklist that returns 204 on success */
export type ProjobsRemoveBlocklistUserResult = ProjobsRemoveBlocklistUserSuccess | ProjobsRemoveBlocklistUserError;

export type ProjobsRemoveBlocklistUserSuccess = {
  __typename?: 'ProjobsRemoveBlocklistUserSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsSalaryExpectationError = {
  __typename?: 'ProjobsSalaryExpectationError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsSalaryExpectationInput = {
  salaryExpectations?: Maybe<Scalars['Int']>;
};

/** Result type for updating the salary expectation */
export type ProjobsSalaryExpectationResult = ProjobsSalaryExpectationSuccess | ProjobsSalaryExpectationError;

export type ProjobsSalaryExpectationSuccess = {
  __typename?: 'ProjobsSalaryExpectationSuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsSeekingStatusError = {
  __typename?: 'ProjobsSeekingStatusError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsSeekingStatusInput = {
  seekingStatus: SeekingStatus;
};

/** "Result type for projobs seeking status update that returns 204 on success" */
export type ProjobsSeekingStatusResult = ProjobsSeekingStatusSuccess | ProjobsSeekingStatusError;

export type ProjobsSeekingStatusSuccess = {
  __typename?: 'ProjobsSeekingStatusSuccess';
  value?: Maybe<Scalars['String']>;
};

/** Projobs Settings Type */
export type ProjobsSettings = {
  __typename?: 'ProjobsSettings';
  /** #rest(batched) #virtual */
  allowlist?: Maybe<Array<Maybe<XingId>>>;
  /** #rest(batched) #virtual */
  blockedCompanies?: Maybe<Array<Maybe<Company>>>;
  /** #rest(batched) #virtual */
  blocklist?: Maybe<Array<Maybe<XingId>>>;
  seekingStatus: SeekingStatus;
  visibility: VisibilitySetting;
};

export type ProjobsSettingsOther = {
  __typename?: 'ProjobsSettingsOther';
  seekingStatus: SeekingStatus;
  visibility: VisibilitySetting;
};

export type ProjobsUpdateDocumentError = {
  __typename?: 'ProjobsUpdateDocumentError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsUpdateDocumentInput = {
  documentId: Scalars['ID'];
  title: Scalars['String'];
};

/** Result type for updating document title */
export type ProjobsUpdateDocumentResult = ProjobsUpdateDocumentSuccess | ProjobsUpdateDocumentError;

export type ProjobsUpdateDocumentSuccess = {
  __typename?: 'ProjobsUpdateDocumentSuccess';
  id: Scalars['ID'];
  name: Scalars['String'];
  title: Scalars['String'];
  format: Scalars['String'];
  size: Scalars['String'];
  uploadDate: Scalars['String'];
  url: Scalars['String'];
};

export type ProjobsUploadDocumentError = {
  __typename?: 'ProjobsUploadDocumentError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsUploadDocumentInput = {
  /** this upload ID is provided by the uploadRequest mutation */
  uploadId: Scalars['String'];
  title: Scalars['String'];
  filename: Scalars['String'];
};

/** Result type for uploading documents that can return a ProjobsDocument or an error */
export type ProjobsUploadDocumentResult = ProjobsDocument | ProjobsUploadDocumentError;

/** Projobs Upsell Banner */
export type ProjobsUpsellBannerModule = ModuleInterface & {
  __typename?: 'ProjobsUpsellBannerModule';
  order: Scalars['Int'];
  title: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};

export type ProjobsUserAlreadyAllowedError = ProjobsBlocklistError & {
  __typename?: 'ProjobsUserAlreadyAllowedError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsUserAlreadyBlockedError = ProjobsAllowlistError & {
  __typename?: 'ProjobsUserAlreadyBlockedError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsVisibilityError = {
  __typename?: 'ProjobsVisibilityError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsVisibilityInput = {
  visibleToContacts?: Maybe<Scalars['Boolean']>;
  visibleToOthers?: Maybe<Scalars['Boolean']>;
  visibleToHeadhunters?: Maybe<Scalars['Boolean']>;
  visibleToRecruiters?: Maybe<Scalars['Boolean']>;
  visibleToColleagues?: Maybe<Scalars['Boolean']>;
};

/** "Result for projobs visibility settings update that returns 204 on success" */
export type ProjobsVisibilityResult = {
  __typename?: 'ProjobsVisibilityResult';
  error?: Maybe<ProjobsVisibilityError>;
  success?: Maybe<ProjobsVisibilitySuccess>;
};

export type ProjobsVisibilitySuccess = {
  __typename?: 'ProjobsVisibilitySuccess';
  value?: Maybe<Scalars['String']>;
};

export type ProjobsWillingnessToTravelError = {
  __typename?: 'ProjobsWillingnessToTravelError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsWillingnessToTravelInput = {
  willingnessToTravel: JobSeekerWillingnessToTravel;
};

/** Result type for updating willingness to travel that returns 204 on success */
export type ProjobsWillingnessToTravelResult = ProjobsWillingnessToTravelSuccess | ProjobsWillingnessToTravelError;

export type ProjobsWillingnessToTravelSuccess = {
  __typename?: 'ProjobsWillingnessToTravelSuccess';
  value?: Maybe<Scalars['String']>;
};

/** Projobs Wishes Type */
export type ProjobsWishes = {
  __typename?: 'ProjobsWishes';
  /** #rest(batched) #virtual */
  idealEmployers: Array<Maybe<Company>>;
  salaryExpectations?: Maybe<Scalars['Int']>;
  /** #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
  openToOtherIndustries: Scalars['Boolean'];
  /** #rest(batched) #virtual */
  industries: Array<Maybe<Industry>>;
  willingnessToMove: Scalars['Boolean'];
  /** #rest(batched) #virtual */
  cities: Array<Maybe<City>>;
  positions: Array<Maybe<Scalars['String']>>;
  willingnessToTravel?: Maybe<JobSeekerWillingnessToTravel>;
  workingHours?: Maybe<JobSeekerWorkingHours>;
  avoid?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProjobsWorkingHoursError = {
  __typename?: 'ProjobsWorkingHoursError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
  /** contains all errors that occured */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ProjobsWorkingHoursInput = {
  partTime: Scalars['Boolean'];
  fullTime: Scalars['Boolean'];
};

/** Result type for updating the working hours */
export type ProjobsWorkingHoursResult = ProjobsWorkingHoursSuccess | ProjobsWorkingHoursError;

export type ProjobsWorkingHoursSuccess = {
  __typename?: 'ProjobsWorkingHoursSuccess';
  value?: Maybe<Scalars['String']>;
};

export type Province = Localizable & {
  __typename?: 'Province';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  canonicalName: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
  /** #logged-out #soft-logged-in */
  countryCode: CountryCodesAlpha2;
};

export type PublisherAboutUsFacts = {
  __typename?: 'PublisherAboutUsFacts';
  /** #logged-out #soft-logged-in */
  imprint?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  properties?: Maybe<AboutUsFactsProperties>;
  /** #logged-out #soft-logged-in */
  websiteUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  foundingYear?: Maybe<Scalars['Int']>;
};

export enum PurchasableProduct {
  Premium = 'PREMIUM',
  Projobs = 'PROJOBS'
}

export type PurchaseAbTest = {
  __typename?: 'PurchaseAbTest';
  /** #soft-logged-in */
  abTestGroup: Scalars['String'];
  /** #soft-logged-in */
  isBasic: Scalars['Boolean'];
  /** #soft-logged-in */
  shouldRedirectToUpsell: Scalars['Boolean'];
};

export type PurchaseAdminWebContract = PurchaseContract & {
  __typename?: 'PurchaseAdminWebContract';
  id: Scalars['ID'];
  platform: PurchasePlatform;
  featureSet: PurchaseFeatureSet;
  name: Scalars['String'];
  initialRuntime: PurchaseRuntime;
  renewalRuntimes: Array<Maybe<PurchaseRuntime>>;
};

export type PurchaseBundle = {
  __typename?: 'PurchaseBundle';
  id: Scalars['ID'];
  bonusMonths?: Maybe<Scalars['Int']>;
  contracts?: Maybe<Array<Maybe<PurchaseContract>>>;
};

export type PurchaseBundleInput = {
  bonusMonths?: Maybe<Scalars['Int']>;
  contractIds: Array<Scalars['ID']>;
};

export type PurchaseCampaign = {
  __typename?: 'PurchaseCampaign';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  platform?: Maybe<PurchasePlatform>;
  targetGroup?: Maybe<PurchaseTargetGroup>;
  template?: Maybe<PurchaseTemplate>;
  bundles?: Maybe<Array<Maybe<PurchaseBundle>>>;
};

export type PurchaseCampaignGroup = {
  __typename?: 'PurchaseCampaignGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  startsAt: Scalars['Date'];
  endsAt?: Maybe<Scalars['Date']>;
  permanent: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  priority: Scalars['Int'];
  campaigns?: Maybe<PurchaseCampaignPlatforms>;
};

export type PurchaseCampaignPlatform = {
  __typename?: 'PurchaseCampaignPlatform';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
};

export type PurchaseCampaignPlatforms = {
  __typename?: 'PurchaseCampaignPlatforms';
  ios?: Maybe<PurchaseCampaignPlatform>;
  android?: Maybe<PurchaseCampaignPlatform>;
  web?: Maybe<PurchaseCampaignPlatform>;
};

export type PurchaseCommonTarget = {
  __typename?: 'PurchaseCommonTarget';
  id: Scalars['ID'];
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Fields needed to show the purchase contracsts */
export type PurchaseContract = {
  id: Scalars['ID'];
  platform: PurchasePlatform;
  featureSet: PurchaseFeatureSet;
  name: Scalars['String'];
};

export type PurchaseCreateCampaignGroupInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  startsAt: Scalars['Date'];
  endsAt?: Maybe<Scalars['Date']>;
  permanent?: Maybe<Scalars['Boolean']>;
  priority?: Maybe<Scalars['Int']>;
};

export type PurchaseCreateCampaignGroupResult = {
  __typename?: 'PurchaseCreateCampaignGroupResult';
  error?: Maybe<PurchaseErrorResponse>;
  success?: Maybe<PurchaseCreateSuccessResponse>;
};

export type PurchaseCreateCampaignInput = {
  campaignGroupId: Scalars['ID'];
  platform: PurchasePlatform;
  bundles: Array<PurchaseBundleInput>;
  recommended: Scalars['Int'];
  targetGroup: PurchaseTargetGroupInput;
};

export type PurchaseCreateCampaignResult = {
  __typename?: 'PurchaseCreateCampaignResult';
  error?: Maybe<PurchaseErrorResponse>;
  success?: Maybe<PurchaseCreateSuccessResponse>;
};

export type PurchaseCreateSuccessResponse = {
  __typename?: 'PurchaseCreateSuccessResponse';
  id: Scalars['ID'];
};

export type PurchaseDeleteCampaignGroupInput = {
  id: Scalars['ID'];
};

export type PurchaseDeleteCampaignGroupResult = {
  __typename?: 'PurchaseDeleteCampaignGroupResult';
  error?: Maybe<PurchaseErrorResponse>;
};

export type PurchaseEnablePlatformInput = {
  id: Scalars['ID'];
  enable: Scalars['Boolean'];
};

export type PurchaseEnablePlatformResult = {
  __typename?: 'PurchaseEnablePlatformResult';
  success?: Maybe<PurchaseCampaignPlatform>;
  error?: Maybe<PurchaseErrorResponse>;
};

export type PurchaseErrorResponse = {
  __typename?: 'PurchaseErrorResponse';
  errors?: Maybe<Scalars['String']>;
};

/** Fields needed to show the feature set in the Apps */
export type PurchaseFeatureSet = {
  __typename?: 'PurchaseFeatureSet';
  id: Scalars['ID'];
  name: Scalars['String'];
  billingCode: Scalars['String'];
};

export type PurchaseFeaturesTarget = {
  __typename?: 'PurchaseFeaturesTarget';
  id: Scalars['ID'];
  key: Scalars['String'];
  value: Scalars['Boolean'];
};

export type PurchaseFeaturesTargetInput = {
  key: Scalars['String'];
  value: Scalars['Boolean'];
};

export type PurchaseLegacyMobileOffer = {
  __typename?: 'PurchaseLegacyMobileOffer';
  collection?: Maybe<Array<Maybe<MobileOfferProduct>>>;
};

export type PurchaseMobileContract = PurchaseContract & {
  __typename?: 'PurchaseMobileContract';
  id: Scalars['ID'];
  appStoreCode: Scalars['String'];
  platform: PurchasePlatform;
  featureSet: PurchaseFeatureSet;
  name: Scalars['String'];
};

/** The mobile Platforms available for purchase */
export enum PurchaseMobilePlatform {
  Ios = 'IOS',
  Android = 'ANDROID'
}

export type PurchaseMobileProperties = {
  __typename?: 'PurchaseMobileProperties';
  recommended?: Maybe<Scalars['Int']>;
};

export enum PurchaseOrderType {
  Upsell = 'UPSELL',
  Revoke = 'REVOKE'
}

/** The Platform the user wants to make a purchase from */
export enum PurchasePlatform {
  Ios = 'IOS',
  Android = 'ANDROID',
  Web = 'WEB'
}

/** Fields needed to show the mobile offers in the Apps */
export enum PurchaseProduct {
  Premium = 'PREMIUM',
  Projobs = 'PROJOBS'
}

export type PurchasePublishCampaignInput = {
  id: Scalars['ID'];
  enable: Scalars['Boolean'];
};

export type PurchasePublishCampaignResult = {
  __typename?: 'PurchasePublishCampaignResult';
  success?: Maybe<PurchaseCampaignGroup>;
  error?: Maybe<PurchaseErrorResponse>;
};

export type PurchaseRestoreCampaignGroup = {
  id: Scalars['ID'];
};

export type PurchaseRestoreCampaignGroupResult = {
  __typename?: 'PurchaseRestoreCampaignGroupResult';
  error?: Maybe<PurchaseErrorResponse>;
};

export type PurchaseRuntime = {
  __typename?: 'PurchaseRuntime';
  id: Scalars['ID'];
  duration: Scalars['Int'];
  priceCh: Scalars['String'];
  priceEu: Scalars['String'];
  priceUs: Scalars['String'];
};

export type PurchaseTargetGroup = {
  __typename?: 'PurchaseTargetGroup';
  id: Scalars['ID'];
  features?: Maybe<Array<Maybe<PurchaseFeaturesTarget>>>;
  ciProperties?: Maybe<Array<Maybe<PurchaseCommonTarget>>>;
  urlParameters?: Maybe<Array<Maybe<PurchaseCommonTarget>>>;
};

export type PurchaseTargetGroupInput = {
  features?: Maybe<Array<Maybe<PurchaseFeaturesTargetInput>>>;
  ciProperties?: Maybe<Array<Maybe<PurchaseTargetInput>>>;
  urlParameters?: Maybe<Array<Maybe<PurchaseTargetInput>>>;
};

export type PurchaseTargetInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type PurchaseTemplate = {
  __typename?: 'PurchaseTemplate';
  id: Scalars['ID'];
  properties?: Maybe<PurchaseMobileProperties>;
  configIdentifier: Scalars['String'];
};

export type PurchaseUpdateCampaignGroupInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['Date']>;
  endsAt?: Maybe<Scalars['Date']>;
  permanent?: Maybe<Scalars['Boolean']>;
  priority?: Maybe<Scalars['Int']>;
};

export type PurchaseUpdateCampaignGroupResult = {
  __typename?: 'PurchaseUpdateCampaignGroupResult';
  error?: Maybe<PurchaseErrorResponse>;
  success?: Maybe<PurchaseUpdateSuccessResponse>;
};

export type PurchaseUpdateCampaignInput = {
  id: Scalars['ID'];
  bundles: Array<PurchaseBundleInput>;
  recommended: Scalars['Int'];
  targetGroup: PurchaseTargetGroupInput;
};

export type PurchaseUpdateCampaignResult = {
  __typename?: 'PurchaseUpdateCampaignResult';
  error?: Maybe<PurchaseErrorResponse>;
  success?: Maybe<PurchaseUpdateSuccessResponse>;
};

export type PurchaseUpdateSuccessResponse = {
  __typename?: 'PurchaseUpdateSuccessResponse';
  id: Scalars['ID'];
};

export type PurchaseUpltBoneyard = {
  __typename?: 'PurchaseUpltBoneyard';
  /** #soft-logged-in */
  enabled: Scalars['Boolean'];
  /** #soft-logged-in */
  type: Scalars['String'];
};

export type PurchaseWebCampaignOffer = {
  __typename?: 'PurchaseWebCampaignOffer';
  /** #soft-logged-in #logged-out */
  id: Scalars['ID'];
  /** #soft-logged-in #logged-out */
  campaignType: PurchaseWebCampaignType;
  /** #soft-logged-in #logged-out */
  campaignIdentifier: Scalars['String'];
  /** #soft-logged-in #logged-out */
  textValues: PurchaseWebTextValues;
  /** #soft-logged-in #logged-out */
  startsAt: Scalars['Date'];
  /** #soft-logged-in #logged-out */
  endsAt?: Maybe<Scalars['Date']>;
  /** #soft-logged-in #logged-out */
  contracts: Array<PurchaseWebContract>;
};

export enum PurchaseWebCampaignType {
  Default = 'DEFAULT',
  Special = 'SPECIAL',
  Winback = 'WINBACK',
  Trigger = 'TRIGGER',
  Revoke = 'REVOKE',
  Student = 'STUDENT',
  Onlinemarketing = 'ONLINEMARKETING'
}

export type PurchaseWebContract = {
  __typename?: 'PurchaseWebContract';
  /** #soft-logged-in #logged-out */
  id: Scalars['ID'];
  /** #soft-logged-in #logged-out */
  orderType: PurchaseOrderType;
  /** #soft-logged-in #logged-out */
  duration: Scalars['Int'];
  /** #soft-logged-in #logged-out */
  initialDuration: Scalars['Int'];
  /** #soft-logged-in #logged-out */
  renewalDuration: Scalars['Int'];
  /** #soft-logged-in #logged-out */
  featureSet: Scalars['String'];
  /** #soft-logged-in #logged-out */
  price: PurchaseWebPrice;
  /** #soft-logged-in #logged-out */
  campaignIdentifier: Scalars['String'];
};

export enum PurchaseWebCurrency {
  Eur = 'EUR',
  Chf = 'CHF',
  Usd = 'USD'
}

export type PurchaseWebOrder = {
  __typename?: 'PurchaseWebOrder';
  /** #soft-logged-in */
  success?: Maybe<PurchaseWebOrderSuccess>;
  /** #soft-logged-in */
  error?: Maybe<PurchaseWebOrderError>;
};

export type PurchaseWebOrderError = {
  __typename?: 'PurchaseWebOrderError';
  /** #soft-logged-in */
  message: Scalars['String'];
};

export type PurchaseWebOrderSuccess = {
  __typename?: 'PurchaseWebOrderSuccess';
  /** #soft-logged-in */
  purchaseId: Scalars['String'];
  /** #soft-logged-in */
  contract: PurchaseWebContract;
};

export type PurchaseWebPrice = {
  __typename?: 'PurchaseWebPrice';
  /** #soft-logged-in #logged-out */
  initial: Scalars['Int'];
  /** #soft-logged-in #logged-out */
  renewal: Scalars['Int'];
  /** #soft-logged-in #logged-out */
  currency: PurchaseWebCurrency;
  /** #soft-logged-in #logged-out */
  current?: Maybe<Scalars['Int']>;
};

export type PurchaseWebTextValues = {
  __typename?: 'PurchaseWebTextValues';
  /** #soft-logged-in #logged-out */
  benefits: Array<Scalars['String']>;
  /** #soft-logged-in #logged-out */
  heading: Scalars['String'];
  /** #soft-logged-in #logged-out */
  legalNotice: Scalars['String'];
  /** #soft-logged-in #logged-out */
  subheading: Scalars['String'];
};

/** Qualified VOMP */
export type QualifiedVomp = {
  __typename?: 'QualifiedVomp';
  id: Scalars['ID'];
  label: Scalars['String'];
  vompType: VompTypeEnum;
  shortCopy?: Maybe<Scalars['Boolean']>;
};

/** Qualified VOMP's visitee */
export type QualifiedVompVisitee = {
  __typename?: 'QualifiedVompVisitee';
  id: Scalars['ID'];
  isBasic: Scalars['Boolean'];
  isPremium: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
};

/** Qualified VOMP's visitor */
export type QualifiedVompVisitor = {
  __typename?: 'QualifiedVompVisitor';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isRecruiter: Scalars['Boolean'];
  /** #rest(batched) #virtual */
  contactDistance?: Maybe<ContactDistance>;
  /** #rest(batched) #virtual */
  profileVisitor?: Maybe<QualifiedVompVisitorType>;
};

export type QualifiedVompVisitorType = FencedQualifiedVompVisitor | XingId;

/** The root query type */
export type Query = {
  __typename?: 'Query';
  /** #soft-logged-in #logged-out */
  viewer?: Maybe<Viewer>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Career Hub Topics
   */
  careerHubTopics?: Maybe<CareerHubTopicsResponse>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Career Hub Topic page / Evergreen article page
   */
  careerHubTopicPage?: Maybe<CareerHubTopicPageResponse>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Career Hub Glossary
   */
  careerHubGlossary?: Maybe<CareerHubGlossaryResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch dreamJobs recommendations as a collection
   */
  dreamJobsFetchRecommendation?: Maybe<DreamJobsCollection>;
  /**
   * #rest #virtual
   *
   *  Fetch dreamJobs entrypoint recommendations as a collection
   */
  dreamJobsFetchStartRecommendation?: Maybe<DreamJobsCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Fetch dreamJobs for Search and Swipe experiment
   */
  dreamJobsFetchSearchSwipeRecommendation?: Maybe<DreamJobsCollection>;
  /**
   * #rest #virtual
   *
   *  Fetch dreamJobs activity basket - stored like/dislike/superlike jobs
   */
  dreamJobsFetchActivityBasket?: Maybe<DreamJobsCollection>;
  /**
   * #rest(batched) #virtual
   *
   *  Fetch taken job details
   */
  dreamJobsFetchTakenJobDetails?: Maybe<Array<Maybe<OccupiedJob>>>;
  /**
   * #rest #virtual
   *
   *  Fetch consent details for the VOMPs
   */
  dreamJobsFetchConsentDetails?: Maybe<DreamJobsOperationResult>;
  /**
   * #rest #virtual
   *
   *  Search profiles
   *
   * ```
   * query XtmSearch {
   *   xtmSearch(consumer: "test", keywords: "Gregor Gysi", currentTitle: "Software", filterDistance: "10,10,10000") {
   *     total
   *     collection {
   *       id
   *       trackingToken
   *       position
   *     }
   *   }
   * }
   * ```
   */
  xtmSearch?: Maybe<XtmSearchResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Article by id
   */
  articlesArticle?: Maybe<ArticlesArticle>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Article by globalId
   */
  articleByGlobalId?: Maybe<ArticlesArticle>;
  /**
   * #rest #virtual
   *
   *  Gets voucher by code
   */
  getJobsMtncVoucher?: Maybe<JobsMtncVoucherResponse>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get details of a Job by slug
   */
  job?: Maybe<JobResult>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Get details of a Job by id
   */
  jobById?: Maybe<JobResult>;
  /**
   * #rest #virtual
   *
   *  Query is going to be deprecated in favour of Viewer.userRecentCvs
   * @deprecated We are going to use the viewer since the info shown is user related
   */
  userRecentCvs?: Maybe<Array<Maybe<UserJobApplicationCv>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  [DEPRECATED!] Job Application External Documents by Job Id (works only for xing_apply jobs)
   * @deprecated This field is deprecated. You can obtain the same information from the VisibleJob.application.formExternalDocument field.
   */
  formExternalDocument?: Maybe<FormExternalDocuments>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Status of the job application service.
   */
  applyServiceSetting?: Maybe<ApplyServiceSettings>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Job Application Form Settings by Job Id
   */
  formSetting?: Maybe<FormSettings>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Getting Job search query from job_searches endpoint
   */
  jobSearchQuery?: Maybe<JobSearchQuery>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Returns the total num of results and the associated search query given a GUID
   * NOTE: Please, bear in mind that the resolver used by this query doesn't
   * use the httpGetBatched directive due to technical needs.
   */
  jobSearch?: Maybe<JobSearchResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Returns the job results based on a query body
   */
  jobSearchByQuery?: Maybe<JobSearchResult>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Get web boneyard upsell hint for a user
   */
  purchaseUpltBoneyard?: Maybe<PurchaseUpltBoneyard>;
  /**
   * #rest #virtual
   *
   *  Get iOS campaign offers for a user.
   * To make this query accessibile for older iOS versions of the Xing app,
   * we have a default value for the purchasable product
   */
  upsellIosCampaignOffer?: Maybe<UpsellIosCampaignOffer>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Get user AB test group
   */
  purchaseAbTest?: Maybe<PurchaseAbTest>;
  /**
   * #rest #virtual
   *
   *  Check user cancellation status
   */
  upsellCancellationStatus?: Maybe<UpsellCancellationStatus>;
  /**
   * #rest #virtual
   *
   *  Get Android campaign offers for a user.
   */
  upsellAndroidCampaignOffer?: Maybe<UpsellAndroidCampaignOffer>;
  /**
   * #soft-logged-in #logged-out #rest #virtual
   *
   *  Get web campaign offer for a user
   */
  purchaseWebCampaignOffer?: Maybe<PurchaseWebCampaignOffer>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Get web campaign offer preview
   */
  purchaseWebCampaignOfferPreview?: Maybe<PurchaseWebCampaignOffer>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Get web contract for a user
   */
  purchaseWebContract?: Maybe<PurchaseWebContract>;
  /**
   * #rest #virtual
   *
   *  Paginated list of all campaigns
   */
  purchaseCampaigns?: Maybe<Array<Maybe<PurchaseCampaign>>>;
  /**
   * #rest #virtual
   *
   *  Fetches one campaign by id
   */
  purchaseCampaign?: Maybe<PurchaseCampaign>;
  /**
   * #rest #virtual
   *
   *  Gets one campaign for a user by platform
   */
  purchaseCampaignOffer?: Maybe<PurchaseCampaign>;
  /**
   * #rest #virtual
   *
   *  Purchase feature sets
   */
  purchaseFeatureSets?: Maybe<Array<Maybe<PurchaseFeatureSet>>>;
  /**
   * #rest #virtual
   *
   *  Retrieves list of available contracts for a platform
   */
  purchaseContracts?: Maybe<Array<Maybe<PurchaseContract>>>;
  /**
   * #rest #virtual
   *
   *  Fetches multiple campaign groups
   */
  purchaseCampaignGroups?: Maybe<Array<Maybe<PurchaseCampaignGroup>>>;
  /**
   * #rest #virtual
   *
   *  Fetches one campaign group by id
   */
  purchaseCampaignGroup?: Maybe<PurchaseCampaignGroup>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Direct connections in network for logged out users.
   */
  networkDirectConnections?: Maybe<DirectConnectionsCollection>;
  /**
   * #logged-out #soft-logged-in
   *
   *  List of top recruiters in the network.
   */
  networkTopRecruiters?: Maybe<TopRecruitersCollection>;
  /**
   * #paginated #rest #virtual
   *
   *  Briefings List of the logged-in user
   */
  briefings?: Maybe<BriefingConnection>;
  /**
   * #rest #virtual
   *
   *  Initial Talents Search
   */
  initialTalentsSearch?: Maybe<InitialTalentsSearchSummary>;
  /**
   * #rest #virtual
   *
   *  CandidatesSearch details
   */
  candidateSearchDetails?: Maybe<CandidateSearchDetailsSummary>;
  /**
   * #rest #virtual
   *
   *  Briefing details
   */
  briefingDetails?: Maybe<BriefingDetailsSummary>;
  /**
   * #paginated #rest #virtual
   *
   *  Briefing Candidates List of the logged-in user
   */
  briefingCandidates?: Maybe<CandidateConnection>;
  /**
   * #rest #virtual
   *
   *  Fetch security issues of a particular user
   */
  loginUserSecurityIssues?: Maybe<LoginUserSecurityIssues>;
  /**
   * #rest #virtual
   *
   *  Autocomplete profiles
   *
   * ```
   * query AutocompletionProfileProfile {
   *   autocompletionProfileProfile(consumer: "test", text: "Gregor Gysi") {
   *     total
   *     service
   *     collection {
   *       suggestion
   *       trackingToken
   *       position
   *     }
   *   }
   * }
   * ```
   */
  autocompletionProfileProfile?: Maybe<AutocompletionProfileProfileSuggestions>;
  /**
   * #rest #virtual
   *
   *  Autocomplete contacts
   *
   * ```
   * query AutocompletionProfileContact {
   *   autocompletionProfileProfile(consumer: "test", text: "Gregor Gysi") {
   *     total
   *     service
   *     collection {
   *       suggestion
   *       trackingToken
   *       position
   *     }
   *   }
   * }
   * ```
   */
  autocompletionProfileContact?: Maybe<AutocompletionProfileProfileSuggestions>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Autocomplete jobrole names
   *
   * ```
   * query AutocompletionProfileJobRole {
   *   autocompletionProfileJobRole(consumer: "test", text: "XPS-Entwicklerin") {
   *     total
   *     service
   *     collection {
   *       suggestion
   *       trackingToken
   *       position
   *     }
   *   }
   * }
   * ```
   */
  autocompletionProfileJobRole?: Maybe<AutocompletionProfileJobRoleSuggestions>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Autocomplete jobrole names via AWS
   */
  autocompletionAwsX1ProfileJobRole?: Maybe<AutocompletionProfileJobRoleSuggestions>;
  /**
   * #rest #virtual
   *
   *  Autocomplete field of study names
   *
   * ```
   * query AutocompletionProfileFieldOfStudy {
   *   autocompletionProfileFieldOfStudy(consumer: "test", text: "Xilografia") {
   *     total
   *     service
   *     collection {
   *       suggestion
   *       trackingToken
   *       position
   *     }
   *   }
   * }
   * ```
   */
  autocompletionProfileFieldOfStudy?: Maybe<AutocompletionProfileFieldOfStudySuggestions>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Autocomplete have names
   *
   * ```
   * query AutocompletionProfileHave {
   *   autocompletionProfileHave(consumer: "test", text: "Xilografia") {
   *     total
   *     service
   *     collection {
   *       suggestion
   *       trackingToken
   *       position
   *     }
   *   }
   * }
   * ```
   */
  autocompletionProfileHave?: Maybe<AutocompletionProfileHaveSuggestions>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Autocomplete company names
   *
   * ```
   * query AutocompletionCompanyName {
   *   autocompletionCompanyName(consumer: "test", text: "XING AG") {
   *     total
   *     service
   *     collection {
   *       suggestion
   *       thumbnail
   *       logo
   *       trackingToken
   *       position
   *     }
   *   }
   * }
   * ```
   */
  autocompletionCompanyName?: Maybe<AutocompletionCompanyNameSuggestions>;
  /**
   * #rest #virtual
   *
   *  Autocomplete university names
   *
   * ```
   * query AutocompletionProfileUniversity {
   *   autocompletionProfileUniversity(consumer: "test", text: "Lu Xun Academy of Fine") {
   *     total
   *     service
   *     collection {
   *       suggestion
   *       trackingToken
   *       position
   *     }
   *   }
   * }
   * ```
   */
  autocompletionProfileUniversity?: Maybe<AutocompletionProfileUniversitySuggestions>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Autocomplete locations city names
   *
   * ```
   * query AutocompletionLocationsCity {
   *   autocompletionLocationsCity(consumer: "test", text: "Hamburg", language: "de", countries: ["DE"]) {
   *     total
   *     service
   *     collection {
   *       name
   *       trackingToken
   *       position
   *       cityId
   *       countryCode
   *     }
   *   }
   * }
   * ```
   */
  autocompletionLocationsCity?: Maybe<AutocompletionLocationsCitySuggestions>;
  /**
   * #rest #virtual
   *
   *  Autocomplete jobs skill names
   *
   * ```
   * query AutocompletionJobsSkill {
   *   autocompletionJobsSkill(consumer: "test", text: "Java") {
   *     total
   *     service
   *     collection {
   *       suggestion
   *       trackingToken
   *       position
   *     }
   *   }
   * }
   * ```
   */
  autocompletionJobsSkill?: Maybe<AutocompletionJobsSkillSuggestions>;
  /**
   * #rest #virtual
   *
   *  Resolve matching ontological entities
   *
   * ```
   * query ResolveProfileHaves {
   *   ontologyResolveEntities(
   *     input: $input
   *   ) {
   *     total
   *     collection {
   *       references {
   *         entityMatches {
   *           entityId
   *           entityType
   *           referencedLabel
   *           score
   *           labels {
   *             primary
   *             alternative
   *             matchingOnly
   *           }
   *           links
   *           }
   *         }
   *       }
   *     }
   *   }
   * }
   * ```
   *
   * ```
   * {
   *   "input": [
   *     {
   *     "text": "java",
   *     "xingType": "PROFILE",
   *     "xingField": "HAVES",
   *     "labels": "none",
   *     "labelLanguages": [],
   *     "entityLimit": 1,
   *     "externalLinks": []
   *     },
   *   ]
   * }
   * ```
   */
  ontologyResolveEntities?: Maybe<Array<Maybe<OntologyResolvedEntitiesReferenceCollection>>>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Get details of a City
   */
  city?: Maybe<City>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Get details of a list of Cities
   */
  cities?: Maybe<Array<Maybe<City>>>;
  /**
   * #rest #virtual
   *
   *  Identifies a city by city name, region, country, etc. Used for two different situations - if only city name/query and
   * country are provided then a query to an internal database is attempted - if more details are provided (street...)
   * then the query goes to google maps api once a call is made to google, the city/country from the response are matched
   * back to our internal database
   *
   * ```
   * query identifyCity {
   *     identifiedCity(
   *         input: {
   *             language: "en",
   *             cityName: "Madrid (Madrid - Madrid), Spain",
   *             country: "ES"
   *         },
   *         consumer: "test"
   *     ) {
   *         id, name
   *     }
   * }
   * ```
   */
  identifiedCity?: Maybe<Array<Maybe<City>>>;
  /**
   * #rest #virtual
   *
   *  Profile Interests Autocomplete Suggestions
   */
  profileInterestsAutocompleteSuggestions?: Maybe<ProfileInterestsAutocompleteSuggestions>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Tracking variables for profile
   */
  profileTrackingVariables?: Maybe<Array<Maybe<TrackingVariable>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for directly requesting the Education of a profile.
   * Arguments:
   * 1) profileId: Profile Id of a user.
   * 2) fenced: Optional argument for loggedOut resolver, by default Loggedout(LO) api responds with unfenced data.
   *            Fencing is a SEO/LO concept where we perform randomisation and re-strict visibility of data with the help of login ctas.
   *            Should be provided as true if you're interested in fenced data.
   */
  profileEducation?: Maybe<ProfileEducationCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get a parsed cv for a given id
   */
  cvUploadParsedCv?: Maybe<CvUploadParsedCv>;
  /**
   * #rest #virtual
   *
   *  Get a parsed cv for a given user ID
   */
  cvUploadParsedCvByUserId?: Maybe<CvUploadParsedCv>;
  /**
   * #rest #virtual
   *
   *  Query for requesting qualifications of a profile
   * Arguments:
   * 1) profileId: Profile Id of a user.
   */
  profileQualifications?: Maybe<ProfileQualificationCollection>;
  /**
   * #soft-logged-in #logged-out #rest(batched) #virtual
   *
   *  XingID of selected user
   */
  xingId?: Maybe<XingId>;
  /**
   * #rest(batched) #virtual
   *
   *  Query for getting xingIds in batch
   */
  xingIds?: Maybe<Array<Maybe<XingId>>>;
  /**
   * #rest #virtual
   *
   *  Profile Skills Autocomplete Suggestions
   */
  profileSkillsAutocompleteSuggestions?: Maybe<ProfileSkillsAutocompleteSuggestions>;
  /**
   * #rest #virtual
   *
   *  Occupation type categories
   */
  profileOccupationTypeCategories?: Maybe<Array<ProfileOccupationTypeCategory>>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Profile modules
   */
  profileModules?: Maybe<ProfileModules>;
  /**
   * #rest #virtual
   *
   *  List accomplishments of the given user
   */
  accomplishmentsGet?: Maybe<AccomplishmentsCollection>;
  /**
   * #rest #virtual
   *
   *  Returns LinkedIn import status for the current user
   */
  getLinkedInImportStatus?: Maybe<LinkedInImportStatus>;
  /**
   * #rest #virtual
   *
   *  List available updates for the current user
   */
  externalUpdatesGet?: Maybe<ExternalUpdatesCollection>;
  /**
   * #rest #virtual
   *
   *  Get Shadow Profile of current user
   */
  shadowProfile?: Maybe<ShadowProfile>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Returns a list of hero articles for the Logged Out Insights page
   */
  getInsightsHeroArticles?: Maybe<InsightsArticlesCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Returns a list of salary articles for the Logged Out Insights page
   */
  getInsightsSalaryArticles?: Maybe<InsightsArticlesCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Returns a list of job search articles for the Logged Out Insights page
   */
  getInsightsJobSearchArticles?: Maybe<InsightsArticlesCollection>;
  /**
   * #rest #virtual
   *
   *  Get preferences wishes for a specific user id
   */
  jobWishesPreference?: Maybe<JobWishesPreference>;
  /**
   * #rest #virtual
   *
   *  Retrieve the current user preferences
   */
  preferenceSettings?: Maybe<PreferencesSettings>;
  /**
   * #rest #virtual
   *
   *  Get article content and social interaction information
   */
  moveonArticles?: Maybe<MoveonArticlesResult>;
  /** The team permissions that can be requested between users and resources */
  teamPermissions?: Maybe<TeamPermissionsQuery>;
  /**
   * #rest #virtual
   *
   *  Get Ecomm Order
   */
  ecommOrder?: Maybe<EcommOrder>;
  /**
   * #rest #virtual
   *
   *  Get Order Company Details
   */
  ecommCompanyDetails?: Maybe<EcommCompanyDetails>;
  /**
   * #rest #virtual
   *
   *  Get Order Payment Status
   */
  ecommPaymentStatus?: Maybe<EcommPaymentStatus>;
  /**
   * #rest #virtual
   *
   *  Get User Connections
   */
  ecommUserConnectionsData?: Maybe<UserConnectionData>;
  /**
   * #rest #virtual
   *
   *  Get Ecomm Product By Id
   */
  ecommProduct?: Maybe<EcommProduct>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get All Ecomm Products
   */
  ecommProducts?: Maybe<Array<EcommProduct>>;
  /**
   * #rest #virtual
   *
   *  Get Order Contact Details
   */
  ecommContactDetails?: Maybe<EcommContactDetails>;
  /**
   * #rest #virtual
   *
   *  Get Previous Client
   */
  ecommPreviousClient?: Maybe<EcommPreviousClient>;
  /**
   * #paginated #logged-out #soft-logged-in #rest #virtual
   *
   *  Provides paginated PostingsPosting along with metadata for a given targetGlobalId
   */
  postingsPostingsForTarget?: Maybe<PostingsPaginatedPostingConnection>;
  /** Get a story by id */
  storyById?: Maybe<PostingsStory>;
  /** Stories by global IDs */
  storyCollection?: Maybe<StoryCollection>;
  /**
   * #paginated #rest #virtual
   *
   *  Get a list of a story's users
   */
  storyViewerList?: Maybe<StoryViewerConnection>;
  /**
   * #rest #virtual
   *
   *  Get an actor's importers
   */
  postingsImporters?: Maybe<PostingsImporters>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting data for people directory cities top level
   * page(/people/cities).
   */
  peopleCityTopLevelPage?: Maybe<PeopleCitiesTopLevelPage>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting data for people directory's people by city user bag page for a given slug, city and country
   */
  peopleByCityUserBagPage?: Maybe<PeopleByCityUserBagPage>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting data for people directory top level page for a given letter
   */
  peopleTopLevelPage?: Maybe<PeopleTopLevelPage>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting data for people directory user bag page for a given slug and page
   */
  peopleUserBagPage?: Maybe<PeopleUserBagPage>;
  /**
   * #paginated #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting user bags(same name(first & last) profiles) for a user
   */
  peopleUserBag?: Maybe<PeopleUserBagConnection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting data for people directory city page for a given city and country
   */
  peopleCityPage?: Maybe<PeopleCityPage>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting data for people directory child page for a given letter, level and page
   */
  peopleChunkPage?: Maybe<PeopleChunkPage>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting data for people directory child page for a given country, city, letter, level and page
   */
  peopleByCityChunkPage?: Maybe<PeopleByCityChunkPage>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting data for people directory top level page for a given letter, city and country
   */
  peopleByCityTopLevelPage?: Maybe<PeopleByCityTopLevelPage>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting data for people directory startpage.
   */
  peopleStartPage?: Maybe<PeopleStartPage>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get all EntityPage's modules. When querying for disabled modules, only users with correct permissions might see those.
   */
  allEntityPageModules?: Maybe<EntityPageModules>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get a single entity page module
   */
  entityPageShowModule?: Maybe<EntityPageModule>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get a single entity page module and return the EntityPageGenericModule
   * @deprecated Deprecated in favour of entityPageShowModule, which uses the EntityPageModules type as the response Checked on 22.02.2023: still used on Web.
   */
  entityPageModule?: Maybe<EntityPageGenericModule>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Fetch an entity page by ID or Slug, with support for error handling and redirection
   */
  entityPageEX?: Maybe<EntityPageResult>;
  /**
   * #logged-out #soft-logged-in
   *
   *  DEPRECATED: Get the contacts associated with an entity page
   * @deprecated Since the split with locations, this query became more complex than necessary. Please use the entityPageContactUsers instead. Checked on 23.02.2023 - still used a bit by Web and old Mobile vertions
   */
  entityPageContacts?: Maybe<EntityPageContacts>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get the contact users associated with an entity page
   */
  entityPageContactUsers?: Maybe<EntityPageContactUsers>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  AboutUs information for Entity Pages
   */
  pagesAboutUs?: Maybe<AboutEntityResult>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  AboutUsBatched information for Entity Pages by ID
   */
  pagesAboutUsBatchedById?: Maybe<AboutEntityResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Documents for Entity Pages
   */
  pagesDocuments?: Maybe<EntityDocumentResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  AboutUs media for Entity Pages
   */
  pagesAboutUsMedia?: Maybe<EntityMediaResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  AboutUs media for Entity Pages
   */
  pagesAboutUsMediaItem?: Maybe<EntityMediaItemResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  AboutUs Facts
   */
  pagesAboutUsFacts?: Maybe<AboutUsFactsResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get the locations associated with an entity page
   */
  entityPageLocations?: Maybe<EntityPageLocations>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  News Feeds for Entity Pages
   */
  entityPageContentFeeds?: Maybe<EntityPageContentFeedCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Companies most recently claimed
   */
  companiesRecentlyClaimed?: Maybe<CompanyClaimedCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Number of Companies grouped by Industries
   */
  companiesIndustries?: Maybe<CompaniesIndustriesCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Number of Companies grouped by segments
   */
  companiesSegments?: Maybe<CompaniesSegmentsCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Companies grouped by industry
   */
  companiesByIndustry?: Maybe<CompaniesByIndustryCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Number of Companies grouped by segments using slug
   */
  companiesSegmentsWithSlug?: Maybe<CompaniesSegmentsCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Companies grouped by industry using slug
   */
  companiesByIndustryWithSlug?: Maybe<CompaniesByIndustryCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  List of Top Companies By City
   */
  topCompaniesByCity?: Maybe<TopCompaniesByCityCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  List of most visited Companies
   */
  mostVisitedCompanies?: Maybe<MostVisitedCompaniesCollection>;
  /**
   * #rest #virtual
   *
   *  Get company affiliaton categories
   */
  companyAffiliationCategories?: Maybe<CompanyAffiliationCategories>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  List of Company Articles
   */
  companyArticles?: Maybe<CompaniesArticlesCollection>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Company by id
   */
  company?: Maybe<Company>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Companies by ids
   */
  companies?: Maybe<Array<Maybe<Company>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get company default logos
   */
  companyDefaultLogos?: Maybe<CompanyDefaultLogos>;
  /**
   * #rest #virtual
   *
   *  Get company by tags
   */
  companiesByTag?: Maybe<CompanyCollection>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Get all company employees numbers
   */
  companyEmployeesNumbers?: Maybe<Array<Maybe<CompanyEmployeesNumber>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  List of Top Companies
   */
  topCompanies?: Maybe<TopCompaniesCollection>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Fetch video details given the ref
   */
  videoV2?: Maybe<VideoV2>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Fetch the list of reasons for a complaints report
   */
  complaintsReasons?: Maybe<Array<ComplaintReason>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Fetch a complaint report
   */
  complaintsReport?: Maybe<FetchComplaintsReportResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Fetch a complaint report
   */
  complaintsReportLoggedOut?: Maybe<FetchComplaintsReportResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Fetch a review of a report
   */
  complaintsReviewOfReport?: Maybe<ReviewResponse>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  User flags of the user
   */
  userFlags?: Maybe<UserFlags>;
  /**
   * #soft-logged-in #rest(batched) #virtual
   *
   *  User flags of multiple users
   */
  usersFlags?: Maybe<Array<Maybe<UserFlags>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get content by URN
   */
  contentServiceContentByGlobalId?: Maybe<ContentServiceContent>;
  /**
   * Community topics
   * @deprecated Groups are going to be shutdown at the end of 2022. This field will stop working on 01/01/2023.
   */
  communityTopics?: Maybe<CommunityTopics>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Retrieving a vita document with a prepared secure token
   */
  vitaDocumentViaToken?: Maybe<VitaDocument>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Retrieving information about the document rendering status via token
   */
  vitaDocumentRenderingTokenStatus?: Maybe<VitaDocumentRenderingStatusResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Retrieving a vita document with a prepared secure token
   */
  vitaCoverLetterViaToken?: Maybe<VitaCoverLetter>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Retrieving information about the cover_letter rendering status via token
   */
  vitaCoverLetterRenderingStatus?: Maybe<VitaDocumentRenderingStatusResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Retrieving cover_letter suggestion status and data
   */
  vitaCoverLetterSuggestionStatus?: Maybe<LlmGatewayGenerateCoverLetterResult>;
  /**
   * #rest #virtual
   *
   *  Fetch a list of Message Reminder for a consultant ID
   */
  erecruitingSourcingServiceMessageRemindersList?: Maybe<ErecruitingSourcingServiceMessageRemindersListResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch a single CandidateNote resource by candidateId
   */
  erecruitingSourcingServiceCandidateNote?: Maybe<ErecruitingSourcingServiceCandidateNoteResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch a single CandidateNote resource by userId
   */
  erecruitingSourcingServiceCandidateNoteByUserId?: Maybe<ErecruitingSourcingServiceCandidateNoteResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch a list of CandidateNotes for a user id
   */
  erecruitingSourcingServiceCandidateNoteList?: Maybe<ErecruitingSourcingServiceCandidateNoteListResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch the collection of SalaryExpectations
   */
  erecruitingSourcingServiceSalaryExpectations?: Maybe<ErecruitingSourcingServiceSalaryExpectationsListResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch the collection of WillingnessToTravel
   */
  erecruitingSourcingServiceWillingnessToTravel?: Maybe<ErecruitingSourcingServiceWillingnessToTravelListResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch the collection of NoticePeriod
   */
  erecruitingSourcingServiceNoticePeriods?: Maybe<ErecruitingSourcingServiceNoticePeriodsListResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch the Message Reminder metadata for a briefing
   */
  erecruitingSourcingServiceMessageReminderMetadata?: Maybe<ErecruitingSourcingServiceMessageReminderMetadataResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch a list of candidate recommendations
   */
  erecruitingSourcingServiceCandidateRecommendations?: Maybe<ErecruitingSourcingServiceCandidateRecommendationsResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch an array of ordered candidate ids
   */
  erecruitingSourcingServiceCandidateRecommendationsOrder?: Maybe<ErecruitingSourcingServiceCandidateRecommendationsOrderResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch a single Xing Talent Service (XTS) briefing metadata by briefing id
   */
  erecruitingSourcingServiceBriefingMetadata?: Maybe<ErecruitingSourcingServiceBriefingMetadataResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch a single XTS briefing report by id
   */
  erecruitingSourcingServiceBriefingReport?: Maybe<ErecruitingSourcingServiceBriefingReportResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch a XTS report collection given a briefing
   */
  erecruitingSourcingServiceBriefingReportsCollection?: Maybe<ErecruitingSourcingServiceBriefingReportsCollectionResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch a single Xing Sourcing Service (XSS) briefing by id
   */
  erecruitingSourcingServiceBriefing?: Maybe<ErecruitingSourcingServiceBriefingResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch a list of Xing Sourcing Service (XSS) briefings by rid
   */
  erecruitingSourcingServiceBriefingList?: Maybe<ErecruitingSourcingServiceBriefingListResponse>;
  /** XTM project related data for a briefing, proxied by XTS back-end (see XTS-1426 to know more). */
  erecruitingSourcingServiceXTMReportDetails?: Maybe<ErecruitingSourcingServiceXtmReportDetails>;
  /**
   * #rest #virtual
   *
   *  Fetch a single Xing Talent Manager (XTM) project by id
   */
  erecruitingSourcingServiceXTMProject?: Maybe<ErecruitingSourcingServiceXtmProjectResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch a list of candidates for a briefing id
   */
  erecruitingSourcingServiceBriefingCandidateList?: Maybe<ErecruitingSourcingServiceBriefingCandidateListResponse>;
  /**
   * #rest #virtual
   *
   *  Fetch a list of candidates for a user id
   */
  erecruitingSourcingServiceBriefingCandidateListByUser?: Maybe<ErecruitingSourcingServiceBriefingCandidateListResponse>;
  /** Recruiter Insights and statistics data */
  recruiterInsights?: Maybe<RecruiterInsights>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Poll state of Job draft generation using AI
   */
  pollJobsEasyCreateGenerateJobWithAI?: Maybe<PollJobsEasyCreateAiJobGenerationResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Poll state of purchasing of a job ad and activating a Jobs B2B Jobs Edition customer
   */
  pollJobsEasyCreateInstantActivation?: Maybe<PollJobsEasyCreateEcomPurchaseResolverResult>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Poll state of a DirectPublish flow
   */
  jobsEasyCreateDirectPublishPollById?: Maybe<JobsEasyCreateDirectPublishPollingResponse>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Poll state of a DirectPublish flow
   */
  jobsEasyCreateDirectPublishPollByIds?: Maybe<Array<Maybe<JobsEasyCreateDirectPublishPollingResponse>>>;
  /**
   * #rest #virtual
   *
   *  Query for requesting deletion reasons
   */
  deletionReasons?: Maybe<Array<Maybe<DeletionReasons>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get master directory entries starting with the specified letter
   */
  masterDirectoryEntryByLetter?: Maybe<MasterDirectoryEntryList>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get SEO link boxes
   */
  seoLinkBoxes?: Maybe<SeoLinkBoxCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Fetch all public legal pages
   */
  legalPages?: Maybe<LegalPages>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Fetch the legal page content by slug.
   */
  legalPageContent?: Maybe<LegalPageContent>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Field used for monitoring purposes. (SRE probe)
   */
  ping?: Maybe<Scalars['String']>;
  /** Logged-in only field used for monitoring purposes. (SRE probe) */
  pingLoggedInOnly?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get all career levels
   */
  careerLevels?: Maybe<Array<CareerLevel>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get all phone preference times
   */
  phonePreferenceTimes?: Maybe<Array<PhonePreferenceTime>>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Get industry by id
   */
  industryById?: Maybe<Industry>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   *
   *  Get industries by ids
   */
  industriesByIds?: Maybe<Array<Maybe<Industry>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get all industries
   */
  industries?: Maybe<Array<Industry>>;
  /**
   * #soft-logged-in #rest(batched) #virtual
   *
   *  Get all company employees number by id
   */
  companyEmployeesNumber?: Maybe<CompanyEmployeesNumber>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get all disciplines
   */
  disciplines?: Maybe<Array<Discipline>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get all work experience statuses
   */
  workExperienceStatuses?: Maybe<Array<WorkExperienceStatus>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get all countries
   */
  countries?: Maybe<Array<Country>>;
  /**
   * #rest #virtual
   *
   *  Get Job
   */
  jobsB2bJob?: Maybe<JobsB2bJobResult>;
  /**
   * #rest #virtual
   *
   *  Get Job Metrics Details
   */
  jobsB2bJobMetricsDetails?: Maybe<JobsB2bJobMetricsResult>;
  /**
   * #rest #virtual
   *
   *  Get Candidates for job
   */
  jobsB2bJobCandidates?: Maybe<JobsB2bCandidatesResult>;
  /**
   * #rest #virtual
   *
   *  Get Candidates for job
   */
  jobsB2bJobCandidateActions?: Maybe<JobsB2bCandidateActionsResult>;
  /**
   * #rest #virtual
   *
   *  Get an array of company ids representing employer preferences for a specific user id
   */
  employersPreference?: Maybe<EmployersPreference>;
  /**
   * #rest #virtual
   *
   *  Get the industries preference for a specific user id
   */
  industriesPreference?: Maybe<IndustriesPreference>;
  /**
   * #rest #virtual
   *
   *  Get an array of disciplines ids for a specific user id
   */
  disciplinesPreference?: Maybe<DisciplinesPreference>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get the salary expectations preference for a specific user or visitor id
   */
  salaryExpectationsPreference?: Maybe<SalaryExpectationsPreference>;
  /**
   * #rest #virtual
   *
   *  Get an array of disciplines ids for a specific user id
   */
  blockedCompanies?: Maybe<BlockedCompanies>;
  /**
   * #rest #virtual
   *
   *  Get the job preference user flags for a specific user id
   */
  jobPreferenceUserFlags?: Maybe<JobPreferenceUserFlags>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get the career level preference for a specific user/visitor id
   */
  careerLevelPreference?: Maybe<CareerLevelPreference>;
  /**
   * #rest #virtual
   *
   *  Get the workplace preference for a specific user id
   */
  workplacePreference?: Maybe<WorkplacePreference>;
  /**
   * #rest #virtual
   *
   *  Get an list of the job preferences data states for a specific user id
   * @deprecated Use jobPreferencesDataStateInfo instead
   */
  jobPreferencesDataState?: Maybe<JobPreferencesDataState>;
  /**
   * #rest #virtual
   *
   *  Get the job preferences data states info for a specific user id
   */
  jobPreferencesDataStateInfo?: Maybe<JobPreferencesDataStateInfo>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get the locations preference for a specific user/visitor id
   */
  locationsPreference?: Maybe<LocationsPreference>;
  /**
   * #rest #virtual
   *
   *  Get the working hours preference for a specific user id
   */
  workingHoursPreference?: Maybe<WorkingHoursPreference>;
  /**
   * #rest #virtual
   *
   *  Get an array of job titles(target positions) and unpreferred positions for a specific user id
   */
  jobTitlesPreference?: Maybe<JobTitlesPreference>;
  /**
   * #rest #virtual
   *
   *  Get an array of only the target positions for a specific user id
   */
  targetPositionsPreference?: Maybe<TargetPositionsPreference>;
  /**
   * #rest #virtual
   *
   *  Get an array of only unpreferred positions for a specific user id
   */
  unpreferredPositionsPreference?: Maybe<UnpreferredPositionsPreference>;
  /**
   * #rest #virtual
   *
   *  Get an array of suggested related job titles from an array of current job titles
   */
  jobTitleSuggestionsPreference?: Maybe<JobTitleSuggestionsPreference>;
  /**
   * #rest #virtual
   *
   *  Get the job seeker status for a specific user id
   */
  jobPreferencesJobSeekerStatus?: Maybe<JobPreferencesJobSeekerStatus>;
  /**
   * #rest #virtual
   *
   *  Submit for the polling of hotleads matching reasons
   */
  hotleadsMatchingReasonsSubmit?: Maybe<HotleadsMatchingReasonsSubmitResponse>;
  /**
   * #rest #virtual
   *
   *  Poll for the results of a hotleads matching reasons
   */
  hotleadsMatchingReasonsPoll?: Maybe<HotleadsMatchingReasonsPollResponse>;
  /** TalentManager pool related data */
  xtmPool?: Maybe<XtmPool>;
  /**
   * #rest #virtual
   *
   *  TalentManager automatic pool
   */
  automaticPools?: Maybe<Array<Maybe<AutomaticPool>>>;
  /**
   * #rest #virtual
   *
   *  Check logged in user has an active XTM seat
   * ```
   * query CandidateSearch {
   *   xtmAuthorizedUser {
   *     candidateSearch(
   *       consumer: "test"
   *       queries: {keywords:"Software"}
   *       filters:{workExperience:"1-2,2-5"}
   *       aggregations: {workExperience: 10, city: 10}
   *       limit: 10
   *     ) {
   *       total
   *       aggs {
   *         city {
   *           count city { name latitude longitude }
   *         }
   *         workExperience { count value }
   *       }
   *       collection {
   *         profile { displayName }
   *         profileAdditionalDetails {
   *           workExperience { jobTitle, duration { years months } }
   *         }
   *       }
   *     }
   *     hotleads (
   *       jobPostingId: 1
   *       consumer: "test"
   *       days: 90
   *       limit: 1
   *       offset: 10
   *       excludedCandidateIds: [1,2,3,4]
   *     ) {
   *       requestTrackingToken
   *       total
   *       service
   *       collection {
   *         itemId
   *         urn
   *         score
   *         reason
   *         interactions {
   *           clicked
   *           bookmarked
   *           unbookmarked
   *           intended
   *           jobDetailViewed
   *           applied
   *           enteredViewport
   *           liked
   *           discarded
   *         }
   *         trackingToken
   *         position
   *         profile {
   *           displayName
   *         }
   *         xtmHotleadMetadata {
   *           firstSeenAt
   *         }
   *         postingType
   *         overlappingSkills
   *       }
   *     }
   *   }
   * }
   * ```
   */
  xtmAuthorizedUser?: Maybe<XtmAuthorizedUser>;
  /**
   * #rest #virtual
   *
   *  Expose XTM seats stats"
   */
  xtmSeatsStats?: Maybe<XtmSeatsStatsResponse>;
  /**
   * #rest #virtual
   *
   *  TalentManager project related data
   */
  xtmProject?: Maybe<XtmProject>;
  /**
   * #rest #virtual
   *
   *  Fetch a single message templates accessible by the current user by id
   */
  xtmMessageTemplates?: Maybe<XtmMessageTemplateResponse>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  List of contacts of a profile (checked for visibility for current user)
   */
  profileContacts?: Maybe<ProfileContacts>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Count of contacts of a profile
   */
  profileContactsCount?: Maybe<ContactsCount>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This query returns a list of top locations.
   */
  jobsLinkBoxTopLocations?: Maybe<Array<Maybe<JobsLinkBoxLocation>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This query returns a list of nearby top locations based on an seo city name input.
   */
  jobsLinkBoxTopLocationsNearby?: Maybe<Array<Maybe<JobsLinkBoxLocation>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This query returns a list of top locations for a given skill.
   */
  jobsLinkBoxSkillTopLocations?: Maybe<Array<Maybe<JobsLinkBoxLocation>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This query returns a list of job roles related to a job role based on an seo job role name input.
   */
  jobsLinkBoxJobRolesRelatedJobRoles?: Maybe<Array<Maybe<JobsLinkBoxJobRole>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This query returns a list of skills related to a job role based on an seo job role name input.
   */
  jobsLinkBoxJobRolesRelatedSkills?: Maybe<Array<Maybe<JobsLinkBoxSkill>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This query returns a list of job roles related to a skill based on an seo skill name input.
   */
  jobsLinkBoxSkillsRelatedJobRoles?: Maybe<Array<Maybe<JobsLinkBoxJobRole>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This query returns a salary estimate related to a job role based on a job role input.
   */
  jobsLinkBoxJobRoleSalaryEstimate?: Maybe<SalaryEstimate>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Support Contact
   */
  supportContact?: Maybe<SupportContactFormTopics>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Fetch a list of followers
   */
  followersFollowingLimitOffset?: Maybe<FollowersFollowingCollection>;
  /**
   * #rest #virtual
   *
   *  Get projobs wishes for a specific user id
   * @deprecated Will be removed at the end of Q4
   */
  projobsWishesOther?: Maybe<ProjobsWishes>;
  /**
   * #rest #virtual
   *
   *  Fetch Skills Module Visibility to hide Haves Module in native apps
   * ```
   * query SkillsModuleVisibility {
   *   skillsModuleVisibility(userId: "1") {
   *     enabled
   *   }
   * }
   * ```
   */
  skillsModuleVisibility?: Maybe<ProfileSkillsModuleVisibility>;
  /**
   * #rest #virtual
   *
   *  Customer
   */
  customer?: Maybe<Customer>;
  /**
   * #rest #virtual
   *
   *  This query returns a winning ad for an adId without running an auction for preview purposes only.
   */
  adAuctionWinnerAdPreview?: Maybe<WinningAd>;
  /**
   * #rest #virtual
   *
   *  LeadAdForm by id
   */
  leadAdForm?: Maybe<LeadAdForm>;
  /**
   * #rest #virtual
   *
   *  EntityCustomer by urns
   */
  entityCustomerByUrns?: Maybe<EntityCustomers>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This query triggers Auction of an Ads for a user and returns collections of most profitable Ads to be displayed.
   */
  adAuctionWinners?: Maybe<AdAuctionWinners>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting
   * structured data
   * of a profile
   */
  profileStructuredData?: Maybe<ProfileStructuredData>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Query for requesting wants of a profile
   * Arguments:
   * 1) profileId: Profile Id of a user.
   * 2) fenced: Optional argument for loggedOut resolver, by default Loggedout(LO) api responds with unfenced data.
   *            Fencing is a SEO/LO concept where we perform randomisation and re-strict visibility of data with the help of login ctas.
   *            Should be provided as true if you're interested in fenced data.
   * @deprecated The wants will be removed in favor of job-preferences: PROFILE-10484.
   */
  profileWants?: Maybe<ProfileWants>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Query for requesting wants as a collection of a profile !!Intermediate solution for transition the structure change!!
   * Arguments:
   * 1) profileId: Profile Id of a user.
   * 2) fenced: Optional argument for loggedOut resolver, by default Loggedout(LO) api responds with unfenced data.
   * Fencing is a SEO/LO concept where we perform randomisation and re-strict visibility of data with the help of login ctas.
   * Should be provided as true if you're interested in fenced data.
   * @deprecated The wants will be removed in favor of job-preferences: PROFILE-10484.
   */
  profileWantsCollection?: Maybe<ProfileWants2>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting hiring profile of a profile
   */
  profileHiringProfile?: Maybe<HiringProfile>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Ordered list of available modules on Profiles platform for loggedout
   */
  profileModuleStoreItems?: Maybe<Array<Maybe<ProfileModuleStoreItem>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting LanguageSkills of a profile
   */
  profileLanguageSkills?: Maybe<ProfileLanguageCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for directly requesting the legal information of a profile
   */
  profileLegalInformation?: Maybe<ProfileLegalInformation>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting interests of a profile
   * Arguments:
   * 1) profileId: Profile Id of a user.
   * 2) fenced: Optional argument for loggedOut resolver, by default Loggedout(LO) api responds with unfenced data.
   *            Fencing is a SEO/LO concept where we perform randomisation and re-strict visibility of data with the help of login ctas.
   *            Should be provided as true if you're interested in fenced data.
   */
  profileInterests?: Maybe<ProfileInterests>;
  /**
   * #soft-logged-in #logged-out #rest #virtual
   *
   *  Query for getting a single Xing-ID with detailed feedback for common http status codes
   */
  xingIdWithError?: Maybe<XingIdOrError>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for directly requesting the WorkExperiences of a profile
   * Arguments:
   *   1) profileId: Profile Id of a user.
   *   2) fenced: Optional argument for loggedOut resolver, by default Loggedout(LO) api responds with unfenced data.
   *              Fencing is a SEO/LO concept where we perform randomisation and re-strict visibility of data with the help of login ctas.
   *              Should be provided as true if you're interested in fenced data.
   */
  profileWorkExperience?: Maybe<ProfileWorkExperienceCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This is a loggedout query to get skills directly via loggedout skills api with params slug_or_id
   * Arguments:
   * 1) userId: Id of a user.
   * 2) fenced: Optional argument for loggedOut resolver, by default Loggedout(LO) api responds with unfenced data.
   *            Fencing is a SEO/LO concept where we perform randomisation and re-strict visibility of data with the help of login ctas.
   *            Should be provided as true if you're interested in fenced data.
   */
  profileSkills?: Maybe<ProfileSkills>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  This is a loggedout query to get similar profiles directly via loggedout similar profiles api
   */
  similarProfiles?: Maybe<RelatedProfileCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting about_me of a profile
   * Arguments:
   * 1) userId: Id of a user.
   */
  profileAboutMe?: Maybe<ProfileAboutMe>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting page meta(contents for seo header tags) of a profile
   */
  profilePageMeta?: Maybe<ProfilePageMeta>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for requesting page meta(contents for seo header tags) of a profile with more detailed http status behaviour
   */
  profilePageMetaWithError?: Maybe<ProfilePageMetaOrError>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  List of feature switches experiments for logged out uuid.
   */
  featureSwitchesLoggedOutExperiments?: Maybe<FeatureSwitchesExperimentsCollection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Returns a lists of skills and competencies extracted from a job ad
   */
  llmGatewayCvLessApplyQuestions?: Maybe<LlmGatewayGenerateCvLessApplyQuestionsResult>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get XING Fabi Assistant suggestions for a job search query
   */
  fabiJobSearch?: Maybe<FabiJobSearchResponse>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Generate job search queries based on user profile
   */
  fabiJobSearchQueryGeneration?: Maybe<FabiJobSearchQueryGenerationResponse>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Poll for the results of a job search matching reasons generation
   */
  fabiJobSearchMatchingReasonsPoll?: Maybe<FabiJobSearchMatchingReasonsPollResponse>;
  /**
   * #rest #virtual
   *
   *  Get client data for a seat manager user
   */
  seatManagerClient?: Maybe<SeatManagerClientResponse>;
  /**
   * #rest #virtual
   *
   *  Get search results for a search query
   */
  seatManagerSearch?: Maybe<SeatManagerSearchResponse>;
  /**
   * #paginated #rest #virtual
   *
   *  Get comments for commentable
   */
  contentComments?: Maybe<ContentCommentsConnection>;
  /**
   * #paginated #rest #virtual
   *
   *  Insider articles
   */
  contentInsiderArticles?: Maybe<ContentArticlesConnection>;
  /**
   * #rest #virtual
   *
   *  Insider featured article
   */
  contentInsiderFeaturedArticles?: Maybe<ContentArticlesResponse>;
  /**
   * #paginated #logged-out #soft-logged-in #rest #virtual
   *
   *  Content page articles
   */
  contentPageArticles?: Maybe<ContentPageArticlesConnection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Content page featured article
   */
  contentPageFeaturedArticle?: Maybe<ContentPageArticle>;
  /**
   * #preview
   *
   *  List of available content channels
   */
  contentChannels?: Maybe<ContentChannelCollection>;
  /**
   * #rest #virtual
   *
   *  Get link data for a link
   */
  contentLinkData?: Maybe<ContentLinkData>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get a link share
   */
  contentLinkShare?: Maybe<ContentLinkShareResult>;
  /**
   * #paginated #rest #virtual
   *
   *  Get common insider followers
   */
  contentInsiderPageFollowersWithinContacts?: Maybe<ContentInsiderPageFollowersWithinContactsConnection>;
  /**
   * #paginated #rest #virtual
   *
   *  Get followers for your own page
   */
  contentInsiderPageFollowers?: Maybe<ContentInsiderPageFollowersConnection>;
  /**
   * #paginated #rest #virtual
   *
   *  Get common page followers
   */
  contentPageFollowersWithinContacts?: Maybe<ContentPageFollowersWithinContactsConnection>;
  /**
   * #rest #virtual
   *
   *  Get insider page info
   */
  contentInsiderPage?: Maybe<ContentInsiderPage>;
  /**
   * #paginated #logged-out #soft-logged-in #rest #virtual
   *
   *  Get a list of pages by type, ordered by title
   */
  contentPagesByType?: Maybe<ContentPagesConnection>;
  /**
   * #paginated #rest #virtual
   *
   *  Get a list of followed pages
   */
  contentFollowedPages?: Maybe<ContentPagesConnection>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get recommendeded pages grouped by sources
   */
  contentPagesRecommended?: Maybe<ContentPagesRecommendedCollection>;
  /**
   * #paginated #logged-out #soft-logged-in #rest #virtual
   *
   *  Get news sources pages by type
   */
  contentPagesNewsSourcesByType?: Maybe<ContentPagesConnection>;
  /**
   * #paginated #rest #virtual
   *
   *  Get insider page infos
   */
  contentStarableStarrers?: Maybe<ContentStarableStarrersConnection>;
  /**
   * #rest #virtual
   *
   *  Content categories
   */
  contentCategories?: Maybe<ContentCategoryCollection>;
};


/** The root query type */
export type QueryCareerHubTopicPageArgs = {
  topicKey: Scalars['String'];
};


/** The root query type */
export type QueryDreamJobsFetchRecommendationArgs = {
  count?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryDreamJobsFetchStartRecommendationArgs = {
  count?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryDreamJobsFetchSearchSwipeRecommendationArgs = {
  recoType?: Maybe<RecommendationType>;
};


/** The root query type */
export type QueryDreamJobsFetchActivityBasketArgs = {
  jobTypes?: Maybe<Array<Maybe<DreamJobType>>>;
  interactionTypes?: Maybe<Array<Maybe<DreamJobInteractionType>>>;
};


/** The root query type */
export type QueryDreamJobsFetchTakenJobDetailsArgs = {
  ids: Array<Scalars['ID']>;
};


/** The root query type */
export type QueryXtmSearchArgs = {
  consumer: Scalars['String'];
  keywords: Scalars['String'];
  currentTitle?: Maybe<Scalars['String']>;
  filterDistance?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryArticlesArticleArgs = {
  id: Scalars['SlugOrID'];
  supportedBlockTypes?: Maybe<Array<ArticleSupportedBlockTypes>>;
};


/** The root query type */
export type QueryArticleByGlobalIdArgs = {
  globalId: Scalars['GlobalID'];
  supportedBlockTypes?: Maybe<Array<ArticleSupportedBlockTypes>>;
};


/** The root query type */
export type QueryGetJobsMtncVoucherArgs = {
  id: Scalars['String'];
};


/** The root query type */
export type QueryJobArgs = {
  slug: Scalars['String'];
  enableTemplateData?: Maybe<Scalars['Boolean']>;
  templateDataFormat?: Maybe<TemplateDataFormat>;
  enableXingCustomApplication?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryJobByIdArgs = {
  id: Scalars['ID'];
  enableTemplateData?: Maybe<Scalars['Boolean']>;
  templateDataFormat?: Maybe<TemplateDataFormat>;
  enableXingCustomApplication?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryFormExternalDocumentArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryApplyServiceSettingArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryFormSettingArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryJobSearchQueryArgs = {
  guid: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryJobSearchArgs = {
  guid: Scalars['SlugOrID'];
  consumer: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  trackRecent?: Maybe<Scalars['Boolean']>;
  since?: Maybe<Scalars['Date']>;
  sincePeriod?: Maybe<SincePeriod>;
  splitBenefit?: Maybe<Scalars['Boolean']>;
  returnAggregations?: Maybe<Scalars['Boolean']>;
  flags?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryJobSearchByQueryArgs = {
  query: JobSearchQueryInput;
  consumer: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  since?: Maybe<Scalars['Date']>;
  sincePeriod?: Maybe<SincePeriod>;
  trackRecent?: Maybe<Scalars['Boolean']>;
  splitBenefit?: Maybe<Scalars['Boolean']>;
  returnAggregations?: Maybe<Scalars['Boolean']>;
  aggregationsFilter?: Maybe<JobSearchAggregationsFilter>;
  visitorId?: Maybe<Scalars['String']>;
  tppBoostingVariant?: Maybe<Scalars['String']>;
  searchMode?: Maybe<SearchMode>;
  flags?: Maybe<Array<JobSearchFlagInput>>;
};


/** The root query type */
export type QueryUpsellIosCampaignOfferArgs = {
  purchasableProduct?: Maybe<PurchasableProduct>;
};


/** The root query type */
export type QueryUpsellCancellationStatusArgs = {
  product: UpsellProduct;
};


/** The root query type */
export type QueryUpsellAndroidCampaignOfferArgs = {
  purchasableProduct?: Maybe<PurchasableProduct>;
};


/** The root query type */
export type QueryPurchaseWebCampaignOfferArgs = {
  mid?: Maybe<Scalars['String']>;
  product?: Maybe<ProductType>;
  language?: Maybe<Scalars['String']>;
  currency?: Maybe<PurchaseWebCurrency>;
};


/** The root query type */
export type QueryPurchaseWebCampaignOfferPreviewArgs = {
  identifier?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryPurchaseWebContractArgs = {
  contractId: Scalars['ID'];
};


/** The root query type */
export type QueryPurchaseCampaignsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryPurchaseCampaignArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryPurchaseCampaignOfferArgs = {
  platform: Scalars['String'];
};


/** The root query type */
export type QueryPurchaseContractsArgs = {
  platform: PurchasePlatform;
};


/** The root query type */
export type QueryPurchaseCampaignGroupsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryPurchaseCampaignGroupArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryBriefingsArgs = {
  status?: Maybe<Array<Maybe<BriefingStatus>>>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryInitialTalentsSearchArgs = {
  input: InitialTalentsSearchInput;
};


/** The root query type */
export type QueryCandidateSearchDetailsArgs = {
  input: CandidateSearchDetailsInput;
};


/** The root query type */
export type QueryBriefingDetailsArgs = {
  input: BriefingDetailsInput;
};


/** The root query type */
export type QueryBriefingCandidatesArgs = {
  briefingId: Scalars['ID'];
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryAutocompletionProfileProfileArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryAutocompletionProfileContactArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryAutocompletionProfileJobRoleArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  highlight?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryAutocompletionAwsX1ProfileJobRoleArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  highlight?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryAutocompletionProfileFieldOfStudyArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
};


/** The root query type */
export type QueryAutocompletionProfileHaveArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
  language?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryAutocompletionCompanyNameArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  highlight?: Maybe<Scalars['Boolean']>;
  excluded?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryAutocompletionProfileUniversityArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
};


/** The root query type */
export type QueryAutocompletionLocationsCityArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
  language: Scalars['String'];
  countries?: Maybe<Array<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  highlight?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryAutocompletionJobsSkillArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
};


/** The root query type */
export type QueryOntologyResolveEntitiesArgs = {
  input: Array<OntologyResolvedEntitiesInput>;
};


/** The root query type */
export type QueryCityArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryCitiesArgs = {
  ids: Array<Scalars['ID']>;
};


/** The root query type */
export type QueryIdentifiedCityArgs = {
  input: IdentifyCityQueryInput;
  consumer: Scalars['String'];
};


/** The root query type */
export type QueryProfileInterestsAutocompleteSuggestionsArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
  language?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryProfileTrackingVariablesArgs = {
  id: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryProfileEducationArgs = {
  profileId: Scalars['SlugOrID'];
  fenced?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryCvUploadParsedCvArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryCvUploadParsedCvByUserIdArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryProfileQualificationsArgs = {
  profileId: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryXingIdArgs = {
  id: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryXingIdsArgs = {
  ids: Array<Scalars['SlugOrID']>;
};


/** The root query type */
export type QueryProfileSkillsAutocompleteSuggestionsArgs = {
  consumer: Scalars['String'];
  text: Scalars['String'];
  language?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryProfileModulesArgs = {
  id: Scalars['SlugOrID'];
  includeDeactivatedModules?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryAccomplishmentsGetArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryJobWishesPreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryPreferenceSettingsArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryEcommProductArgs = {
  productId: Scalars['ID'];
};


/** The root query type */
export type QueryPostingsPostingsForTargetArgs = {
  targetGlobalId: Scalars['GlobalID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  filter?: Maybe<Array<PostingPublicationState>>;
  separatePinned?: Maybe<Scalars['Boolean']>;
  includeCounts?: Maybe<Scalars['Boolean']>;
  supportedObjectTypes: Array<PostingsAvailablePostingTypes>;
};


/** The root query type */
export type QueryStoryByIdArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryStoryCollectionArgs = {
  storyGlobalIds: Array<Scalars['GlobalID']>;
};


/** The root query type */
export type QueryStoryViewerListArgs = {
  storyGlobalId: Scalars['GlobalID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryPostingsImportersArgs = {
  actorGlobalId: Scalars['GlobalID'];
};


/** The root query type */
export type QueryPeopleByCityUserBagPageArgs = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  jobtitleQuery?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryPeopleTopLevelPageArgs = {
  letter?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryPeopleUserBagPageArgs = {
  slug?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  cityQuery?: Maybe<Scalars['String']>;
  jobtitleQuery?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryPeopleUserBagArgs = {
  userId?: Maybe<Scalars['SlugOrID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryPeopleCityPageArgs = {
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryPeopleChunkPageArgs = {
  letter?: Maybe<Scalars['String']>;
  pageLevel?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryPeopleByCityChunkPageArgs = {
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  letter?: Maybe<Scalars['String']>;
  pageLevel?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryPeopleByCityTopLevelPageArgs = {
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  letter?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryAllEntityPageModulesArgs = {
  id: Scalars['SlugOrID'];
  includeDisabled?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryEntityPageShowModuleArgs = {
  id: Scalars['SlugOrID'];
  moduleType: Scalars['String'];
  includeDisabled?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryEntityPageModuleArgs = {
  id: Scalars['SlugOrID'];
  moduleType: Scalars['String'];
  includeDisabled?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryEntityPageExArgs = {
  id: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryEntityPageContactsArgs = {
  id: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryEntityPageContactUsersArgs = {
  id: Scalars['SlugOrID'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  includeDisabled?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryPagesAboutUsArgs = {
  id: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryPagesAboutUsBatchedByIdArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryPagesDocumentsArgs = {
  id: Scalars['SlugOrID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryPagesAboutUsMediaArgs = {
  id: Scalars['SlugOrID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  includeDisabled?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryPagesAboutUsMediaItemArgs = {
  pageId: Scalars['SlugOrID'];
  id: Scalars['ID'];
  includeDisabled?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryPagesAboutUsFactsArgs = {
  id: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryEntityPageLocationsArgs = {
  id: Scalars['SlugOrID'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryEntityPageContentFeedsArgs = {
  id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  until?: Maybe<Scalars['String']>;
  since?: Maybe<Scalars['String']>;
  filter?: Maybe<PostingPublicationState>;
  includePinned?: Maybe<Scalars['Boolean']>;
  supportedObjectTypes?: Array<EntityPageSupportedContentObjectTypes>;
};


/** The root query type */
export type QueryCompaniesRecentlyClaimedArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<CompaniesRecentlyClaimedOrder>;
};


/** The root query type */
export type QueryCompaniesIndustriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<CompaniesIndustriesSortOptions>;
  letter?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryCompaniesSegmentsArgs = {
  id: Scalars['ID'];
  category?: Maybe<Scalars['SlugOrID']>;
};


/** The root query type */
export type QueryCompaniesByIndustryArgs = {
  id: Scalars['ID'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['SlugOrID']>;
};


/** The root query type */
export type QueryCompaniesSegmentsWithSlugArgs = {
  id: Scalars['SlugOrID'];
  category?: Maybe<Scalars['SlugOrID']>;
};


/** The root query type */
export type QueryCompaniesByIndustryWithSlugArgs = {
  id: Scalars['SlugOrID'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['SlugOrID']>;
};


/** The root query type */
export type QueryTopCompaniesByCityArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  cityId: Scalars['ID'];
};


/** The root query type */
export type QueryMostVisitedCompaniesArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<MostVisitedCompaniesOrder>;
};


/** The root query type */
export type QueryCompanyArticlesArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryCompanyArgs = {
  id: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryCompaniesArgs = {
  ids: Array<Scalars['SlugOrID']>;
};


/** The root query type */
export type QueryCompaniesByTagArgs = {
  tags?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryTopCompaniesArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryVideoV2Args = {
  ref?: Maybe<Scalars['SlugOrID']>;
};


/** The root query type */
export type QueryComplaintsReportArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryComplaintsReportLoggedOutArgs = {
  id: Scalars['String'];
};


/** The root query type */
export type QueryComplaintsReviewOfReportArgs = {
  id: Scalars['ID'];
  token: Scalars['String'];
};


/** The root query type */
export type QueryUserFlagsArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryUsersFlagsArgs = {
  ids: Array<Scalars['ID']>;
};


/** The root query type */
export type QueryContentServiceContentByGlobalIdArgs = {
  globalId: Scalars['GlobalID'];
  supportedBlockTypes?: Maybe<Array<ArticleSupportedBlockTypes>>;
};


/** The root query type */
export type QueryCommunityTopicsArgs = {
  limit: Scalars['Int'];
};


/** The root query type */
export type QueryVitaDocumentViaTokenArgs = {
  token: Scalars['String'];
};


/** The root query type */
export type QueryVitaDocumentRenderingTokenStatusArgs = {
  token?: Maybe<Scalars['String']>;
  kind?: Maybe<VitaDocumentKind>;
};


/** The root query type */
export type QueryVitaCoverLetterViaTokenArgs = {
  token: Scalars['String'];
};


/** The root query type */
export type QueryVitaCoverLetterRenderingStatusArgs = {
  token?: Maybe<Scalars['String']>;
  kind?: Maybe<VitaDocumentKind>;
};


/** The root query type */
export type QueryVitaCoverLetterSuggestionStatusArgs = {
  jobId?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryErecruitingSourcingServiceMessageRemindersListArgs = {
  briefingId: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceCandidateNoteArgs = {
  candidateId: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceCandidateNoteByUserIdArgs = {
  userId: Scalars['ID'];
  briefingId: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceCandidateNoteListArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceMessageReminderMetadataArgs = {
  briefingId: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceCandidateRecommendationsArgs = {
  xtmProjectId: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceCandidateRecommendationsOrderArgs = {
  input?: Maybe<ErecruitingSourcingServiceCandidateRecommendationsOrderInput>;
};


/** The root query type */
export type QueryErecruitingSourcingServiceBriefingMetadataArgs = {
  briefingId: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceBriefingReportArgs = {
  id: Scalars['ID'];
  briefingId: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceBriefingReportsCollectionArgs = {
  briefingId: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceBriefingArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceXtmReportDetailsArgs = {
  briefingId: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceXtmProjectArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryErecruitingSourcingServiceBriefingCandidateListArgs = {
  briefingId: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
  createdAtBefore?: Maybe<Scalars['Date']>;
};


/** The root query type */
export type QueryErecruitingSourcingServiceBriefingCandidateListByUserArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryPollJobsEasyCreateGenerateJobWithAiArgs = {
  id: Scalars['String'];
};


/** The root query type */
export type QueryPollJobsEasyCreateInstantActivationArgs = {
  id: Scalars['String'];
};


/** The root query type */
export type QueryJobsEasyCreateDirectPublishPollByIdArgs = {
  id: Scalars['String'];
};


/** The root query type */
export type QueryJobsEasyCreateDirectPublishPollByIdsArgs = {
  ids: Array<Scalars['String']>;
};


/** The root query type */
export type QueryMasterDirectoryEntryByLetterArgs = {
  letter: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  type: MasterDirectoryEntryType;
};


/** The root query type */
export type QuerySeoLinkBoxesArgs = {
  input: SeoLinkBoxInput;
};


/** The root query type */
export type QueryLegalPageContentArgs = {
  slug: Scalars['String'];
  groupIdentifier: Scalars['String'];
};


/** The root query type */
export type QueryIndustryByIdArgs = {
  id?: Maybe<Scalars['ID']>;
};


/** The root query type */
export type QueryIndustriesByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** The root query type */
export type QueryCompanyEmployeesNumberArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryCountriesArgs = {
  filter?: Maybe<CountryFilter>;
};


/** The root query type */
export type QueryJobsB2bJobArgs = {
  jobUrn: Scalars['URN'];
};


/** The root query type */
export type QueryJobsB2bJobMetricsDetailsArgs = {
  jobUrn: Scalars['URN'];
};


/** The root query type */
export type QueryJobsB2bJobCandidatesArgs = {
  input: JobsB2bCandidatesQueryInput;
};


/** The root query type */
export type QueryJobsB2bJobCandidateActionsArgs = {
  input: JobsB2bCandidateActionsQueryInput;
};


/** The root query type */
export type QueryEmployersPreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryIndustriesPreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryDisciplinesPreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QuerySalaryExpectationsPreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryBlockedCompaniesArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryJobPreferenceUserFlagsArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryCareerLevelPreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryWorkplacePreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryJobPreferencesDataStateArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryJobPreferencesDataStateInfoArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryLocationsPreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryWorkingHoursPreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryJobTitlesPreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryTargetPositionsPreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryUnpreferredPositionsPreferenceArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryJobTitleSuggestionsPreferenceArgs = {
  userId: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryJobPreferencesJobSeekerStatusArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryHotleadsMatchingReasonsSubmitArgs = {
  input: HotleadsMatchingReasonsSubmitInput;
};


/** The root query type */
export type QueryHotleadsMatchingReasonsPollArgs = {
  backgroundJobId: Scalars['String'];
};


/** The root query type */
export type QueryXtmPoolArgs = {
  id?: Maybe<Scalars['ID']>;
};


/** The root query type */
export type QueryXtmSeatsStatsArgs = {
  clientId?: Maybe<Scalars['ID']>;
};


/** The root query type */
export type QueryXtmProjectArgs = {
  id?: Maybe<Scalars['ID']>;
};


/** The root query type */
export type QueryXtmMessageTemplatesArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryProfileContactsArgs = {
  otherUserId: Scalars['ID'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<ContactsListOrderBy>;
};


/** The root query type */
export type QueryProfileContactsCountArgs = {
  userId: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryJobsLinkBoxTopLocationsNearbyArgs = {
  input: JobsLinkBoxTopLocationsNearbyInput;
};


/** The root query type */
export type QueryJobsLinkBoxSkillTopLocationsArgs = {
  input?: Maybe<JobsLinkBoxSkillInput>;
};


/** The root query type */
export type QueryJobsLinkBoxJobRolesRelatedJobRolesArgs = {
  input: JobsLinkBoxJobRoleInput;
};


/** The root query type */
export type QueryJobsLinkBoxJobRolesRelatedSkillsArgs = {
  input: JobsLinkBoxJobRoleInput;
};


/** The root query type */
export type QueryJobsLinkBoxSkillsRelatedJobRolesArgs = {
  input: JobsLinkBoxSkillInput;
};


/** The root query type */
export type QueryJobsLinkBoxJobRoleSalaryEstimateArgs = {
  input: JobsLinkBoxJobRoleInput;
};


/** The root query type */
export type QueryFollowersFollowingLimitOffsetArgs = {
  namespace: FollowersFollowingNamespace;
  type: FollowersFollowingType;
  id: Scalars['ID'];
  sort?: Maybe<FollowersFollowingSort>;
  order?: Maybe<FollowersFollowingOrder>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** The root query type */
export type QueryProjobsWishesOtherArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QuerySkillsModuleVisibilityArgs = {
  userId: Scalars['ID'];
};


/** The root query type */
export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


/** The root query type */
export type QueryAdAuctionWinnerAdPreviewArgs = {
  adId: Scalars['Int'];
};


/** The root query type */
export type QueryLeadAdFormArgs = {
  id: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryEntityCustomerByUrnsArgs = {
  urns: Scalars['GlobalID'];
};


/** The root query type */
export type QueryAdAuctionWinnersArgs = {
  auctionAttributes: AuctionAttributes;
};


/** The root query type */
export type QueryProfileStructuredDataArgs = {
  slug: Scalars['String'];
};


/** The root query type */
export type QueryProfileWantsArgs = {
  profileId?: Maybe<Scalars['SlugOrID']>;
  fenced?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryProfileWantsCollectionArgs = {
  profileId?: Maybe<Scalars['SlugOrID']>;
  fenced?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryProfileHiringProfileArgs = {
  id: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryProfileModuleStoreItemsArgs = {
  userId: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryProfileLanguageSkillsArgs = {
  profileId?: Maybe<Scalars['SlugOrID']>;
};


/** The root query type */
export type QueryProfileLegalInformationArgs = {
  profileId: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryProfileInterestsArgs = {
  profileId?: Maybe<Scalars['SlugOrID']>;
  fenced?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryXingIdWithErrorArgs = {
  id: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryProfileWorkExperienceArgs = {
  profileId?: Maybe<Scalars['SlugOrID']>;
  fenced?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QueryProfileSkillsArgs = {
  userId: Scalars['SlugOrID'];
  fenced?: Maybe<Scalars['Boolean']>;
};


/** The root query type */
export type QuerySimilarProfilesArgs = {
  profileIdentifier: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryProfileAboutMeArgs = {
  userId: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryProfilePageMetaArgs = {
  profileId: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryProfilePageMetaWithErrorArgs = {
  profileId: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryFeatureSwitchesLoggedOutExperimentsArgs = {
  identifier: Scalars['UUID'];
  names?: Maybe<Array<Maybe<Scalars['String']>>>;
  platform?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryLlmGatewayCvLessApplyQuestionsArgs = {
  input: LlmGatewayCvLessApplyQuestionsInput;
};


/** The root query type */
export type QueryFabiJobSearchArgs = {
  input: FabiJobSearchInput;
};


/** The root query type */
export type QueryFabiJobSearchQueryGenerationArgs = {
  input: FabiJobSearchQueryGenerationInput;
};


/** The root query type */
export type QueryFabiJobSearchMatchingReasonsPollArgs = {
  backgroundJobId: Scalars['String'];
};


/** The root query type */
export type QuerySeatManagerSearchArgs = {
  searchQuery?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryContentCommentsArgs = {
  commentableGlobalId: Scalars['GlobalID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryContentInsiderArticlesArgs = {
  userId: Scalars['SlugOrID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  status?: Maybe<ContentArticleStatus>;
};


/** The root query type */
export type QueryContentInsiderFeaturedArticlesArgs = {
  userId: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryContentPageArticlesArgs = {
  pageUrn: Scalars['GlobalID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  status?: Maybe<ContentArticleStatus>;
};


/** The root query type */
export type QueryContentPageFeaturedArticleArgs = {
  pageUrn: Scalars['GlobalID'];
};


/** The root query type */
export type QueryContentLinkDataArgs = {
  link: Scalars['URL'];
};


/** The root query type */
export type QueryContentLinkShareArgs = {
  linkShareGlobalId: Scalars['GlobalID'];
};


/** The root query type */
export type QueryContentInsiderPageFollowersWithinContactsArgs = {
  userId: Scalars['SlugOrID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryContentInsiderPageFollowersArgs = {
  userId: Scalars['SlugOrID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryContentPageFollowersWithinContactsArgs = {
  pageUrn: Scalars['GlobalID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** The root query type */
export type QueryContentInsiderPageArgs = {
  userId: Scalars['SlugOrID'];
};


/** The root query type */
export type QueryContentPagesByTypeArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  pageType: ReducedContentPageType;
};


/** The root query type */
export type QueryContentFollowedPagesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  pageType?: Maybe<ReducedContentPageType>;
  sortField?: Maybe<ContentPageSortField>;
  sortOrder?: Maybe<ContentSortOrder>;
};


/** The root query type */
export type QueryContentPagesNewsSourcesByTypeArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  pageType: ReducedContentPageType;
  sortField?: Maybe<ContentPageSortField>;
  sortOrder?: Maybe<ContentSortOrder>;
};


/** The root query type */
export type QueryContentStarableStarrersArgs = {
  starableGlobalId: Scalars['GlobalID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export enum Range {
  NextTwoWeeks = 'NEXT_TWO_WEEKS',
  Today = 'TODAY'
}

export type ReasonKey = {
  key: Scalars['String'];
};

export type Recommendation = {
  trackingToken: Scalars['String'];
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
};

export type RecommendationContacts = {
  __typename?: 'RecommendationContacts';
  /** #rest(batched) #virtual */
  profileDetails?: Maybe<XingId>;
};

export type RecommendationContactsCollection = {
  __typename?: 'RecommendationContactsCollection';
  collection?: Maybe<Array<Maybe<RecommendationContacts>>>;
};

export enum RecommendationType {
  Taken = 'TAKEN',
  Available = 'AVAILABLE',
  All = 'ALL'
}

export type RecommenderResponse = {
  requestTrackingToken: Scalars['String'];
  service: Scalars['String'];
  total: Scalars['Int'];
};

export type RecruiterBookmarks = {
  __typename?: 'RecruiterBookmarks';
  bookmarks?: Maybe<Array<RecruiterInteractionItem>>;
  total?: Maybe<Scalars['Int']>;
};

export enum RecruiterFilter {
  False = 'FALSE',
  True = 'TRUE'
}

export type RecruiterInsights = {
  __typename?: 'RecruiterInsights';
  /**
   * Candidate insights and talent radar statistics
   *
   * ```
   * query RecruiterInsights {
   *   recruiterInsights {
   *     insights(projectId: "5669", locationId: "2643123", jobLabel: "Manager") {
   *       ...
   *     }
   *   }
   * }
   * ```
   */
  insights: Insights;
};


export type RecruiterInsightsInsightsArgs = {
  projectId?: Maybe<Scalars['ID']>;
  jobLabel?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['ID']>;
};

export type RecruiterInteractionConnection = HasCursorPagination & {
  __typename?: 'RecruiterInteractionConnection';
  /** #soft-logged-in */
  total: Scalars['Int'];
  /** #soft-logged-in */
  pageInfo: PageInfo;
  edges?: Maybe<Array<RecruiterInteractionEdge>>;
};

export type RecruiterInteractionEdge = PaginationEdge & {
  __typename?: 'RecruiterInteractionEdge';
  cursor: Scalars['String'];
  node: RecruiterInteractionItem;
};

export type RecruiterInteractionItem = {
  __typename?: 'RecruiterInteractionItem';
  /** #rest(batched) #virtual */
  recruiterId?: Maybe<XingId>;
  createdAt: Scalars['String'];
  reason: Scalars['String'];
};

export type RecruiterInteractions = {
  __typename?: 'RecruiterInteractions';
  /** @deprecated Use recruiterInteractionsConnection instead */
  recruiterInteractions?: Maybe<Array<RecruiterInteractionItem>>;
  /** @deprecated Use recruiterInteractionsConnection instead */
  total?: Maybe<Scalars['Int']>;
};

export type RecruiterMessageNotification = Notification & {
  __typename?: 'RecruiterMessageNotification';
  /** #rest(batched) #virtual */
  actor?: Maybe<MessengerParticipant>;
  /** #rest(batched) #virtual */
  object?: Maybe<MessengerMessage>;
  /** #rest(batched) #virtual */
  target?: Maybe<MessengerChat>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type RecruiterMessageSignal = ConversationStarter & {
  __typename?: 'RecruiterMessageSignal';
  /** #rest(batched) #virtual */
  actor?: Maybe<MessengerParticipant>;
  /** #rest(batched) #virtual */
  object?: Maybe<MessengerMessage>;
  /** #rest(batched) #virtual */
  target?: Maybe<MessengerChat>;
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type RecruiterMessageStack = SignalsStack & {
  __typename?: 'RecruiterMessageStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type RecruiterMessageStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type RecruiterRecommendation = Recommendation & {
  __typename?: 'RecruiterRecommendation';
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  trackingToken: Scalars['String'];
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
};

export type RecruiterRecommendationEdge = PaginationEdge & {
  __typename?: 'RecruiterRecommendationEdge';
  node: RecruiterRecommendation;
  /** #virtual */
  cursor: Scalars['String'];
};

export type RecruiterRecommendationsConnection = HasCursorPagination & {
  __typename?: 'RecruiterRecommendationsConnection';
  edges: Array<Maybe<RecruiterRecommendationEdge>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type RecruiterSearchAppearances = {
  __typename?: 'RecruiterSearchAppearances';
  appearances?: Maybe<Array<RecruiterInteractionItem>>;
  total?: Maybe<Scalars['Int']>;
};

/** The most important page types that we want to show in the insights section of Xing */
export enum ReducedContentPageType {
  Insider = 'insider',
  Industry = 'industry',
  Topic = 'topic',
  PressReview = 'press_review',
  Premium = 'premium',
  Publisher = 'publisher'
}

/**
 * Interface for types with client side references.
 *
 * This originated in the `Lego` project and is used in places where
 * the result returned by the API is mixed with a client-supplied reference.
 *
 * Sometimes APIs don't offer stable identifiers, but client would benefit
 * from having them. For example the image cache API supports multiple
 * image dimensions, but what "large" means can vary from device to device.
 *
 * The idea with `Referenceable` is that the client can specify a tag or identifier
 * which is returned back to him, to give the element semantic meaning. An image
 * dimension object could return reference "large" for example.
 */
export type Referenceable = {
  reference: Scalars['String'];
};

export type RegenerateInvoicesError = {
  __typename?: 'RegenerateInvoicesError';
  errors?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type RegenerateInvoicesInput = {
  invoiceIds: Array<Scalars['ID']>;
};

export type RegenerateInvoicesMutationResult = {
  __typename?: 'RegenerateInvoicesMutationResult';
  success?: Maybe<PaymentInvoices>;
  error?: Maybe<RegenerateInvoicesError>;
};

export type RelatedCompany = {
  __typename?: 'RelatedCompany';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
};

/** Related Profile type for User Bags and Similar Profiles */
export type RelatedProfile = {
  __typename?: 'RelatedProfile';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  academicTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  businessCity?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  businessCountry?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  firstName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  lastName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  hasPhoto?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  occupationTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  pageName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  photoUrl?: Maybe<Scalars['URL']>;
};

export type RelatedProfileCollection = {
  __typename?: 'RelatedProfileCollection';
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<RelatedProfile>>;
};

export type RemoveJobFromBookmarksAction = ObjectActions & {
  __typename?: 'RemoveJobFromBookmarksAction';
  params: RemoveJobFromBookmarksActionParams;
  trackingToken?: Maybe<Scalars['String']>;
};

export type RemoveJobFromBookmarksActionParams = {
  __typename?: 'RemoveJobFromBookmarksActionParams';
  jobId: Scalars['ID'];
};

export type RepliesPage = {
  __typename?: 'RepliesPage';
  total: Scalars['Int'];
  previousCount: Scalars['Int'];
  nextCount: Scalars['Int'];
  pageInfo: PageInfo;
};

export type RequestVitaCoverLetterRenderingInput = {
  token?: Maybe<Scalars['String']>;
  kind?: Maybe<VitaDocumentKind>;
};

export type RequestVitaDocumentRenderingError = {
  __typename?: 'RequestVitaDocumentRenderingError';
  /** #logged-out #soft-logged-in */
  message: Scalars['String'];
};

export type RequestVitaDocumentRenderingInput = {
  id?: Maybe<Scalars['UUID']>;
  token?: Maybe<Scalars['String']>;
  kind?: Maybe<VitaDocumentKind>;
};

export type RequestVitaDocumentRenderingResult = RequestVitaDocumentRenderingSuccess | RequestVitaDocumentRenderingError;

export type RequestVitaDocumentRenderingSuccess = {
  __typename?: 'RequestVitaDocumentRenderingSuccess';
  /** #logged-out #soft-logged-in */
  success: Scalars['String'];
};

export type ResolvedParticipantUserUrn = {
  __typename?: 'ResolvedParticipantUserUrn';
  /** #rest(batched) #virtual */
  participant?: Maybe<MessengerParticipant>;
};

export type ResponseError = {
  __typename?: 'ResponseError';
  /** #logged-out #soft-logged-in */
  errorCode?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  errorMessage?: Maybe<Scalars['String']>;
};

export type ResumeOnboardingInfo = {
  __typename?: 'ResumeOnboardingInfo';
  shouldResumeOnboarding: Scalars['Boolean'];
  resumeOnboardingPath: Scalars['String'];
};

export type RevertReport403Error = {
  __typename?: 'RevertReport403Error';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
};

export type RevertReportResponse = {
  __typename?: 'RevertReportResponse';
  /** #logged-out #soft-logged-in */
  report?: Maybe<ComplaintsReport>;
};

export type RevertReportResult = RevertReportResponse | RevertReport403Error;

export type ReviewResponse = {
  __typename?: 'ReviewResponse';
  /** #logged-out #soft-logged-in */
  sentReviewRequest?: Maybe<Scalars['Boolean']>;
};

/** Salary in a given Currency */
export type Salary = {
  __typename?: 'Salary';
  /** #logged-out #soft-logged-in */
  currency?: Maybe<Currency>;
  /** #logged-out #soft-logged-in */
  amount?: Maybe<Scalars['Int']>;
};

export enum SalaryAvgComparison {
  Above = 'ABOVE',
  Equal = 'EQUAL',
  Below = 'BELOW',
  Unknown = 'UNKNOWN'
}

export type SalaryEstimate = {
  __typename?: 'SalaryEstimate';
  /** #logged-out #soft-logged-in */
  currency?: Maybe<Currency>;
  /** #logged-out #soft-logged-in */
  minimum?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  maximum?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  median?: Maybe<Scalars['Int']>;
};

export type SalaryExpectation = {
  __typename?: 'SalaryExpectation';
  label: Scalars['String'];
  amount: Scalars['Int'];
  xtmUrl: Scalars['URL'];
  avatars: Array<Maybe<Scalars['URL']>>;
};

export type SalaryExpectationInsight = {
  __typename?: 'SalaryExpectationInsight';
  medianSalaryExpectation: Scalars['Int'];
  medianSalaryExpectationCandidates: Scalars['Int'];
  xtmUrl: Scalars['URL'];
  stats: Array<Maybe<SalaryExpectation>>;
};

/** SalaryExpectationsPreference Type */
export type SalaryExpectationsPreference = {
  __typename?: 'SalaryExpectationsPreference';
  /** #logged-out #soft-logged-in */
  salaryExpectations?: Maybe<Scalars['Int']>;
};

export type SalaryInsights = HasNwtTrackingToken & HasNewWorkTrackingToken & {
  __typename?: 'SalaryInsights';
  currentJobTitle?: Maybe<Scalars['String']>;
  currentSalary?: Maybe<Salary>;
  salaryAvg?: Maybe<Salary>;
  salaryAvgJobTitle?: Maybe<Scalars['String']>;
  salaryAvgJobRoleId?: Maybe<Scalars['Int']>;
  salaryAvgComparison?: Maybe<SalaryAvgComparison>;
  /** @deprecated Replaced by HasNewWorkTrackingToken to not confuse with another field with same name */
  trackingToken?: Maybe<Scalars['String']>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type SalaryInsightsError = {
  __typename?: 'SalaryInsightsError';
  message?: Maybe<Scalars['String']>;
};

export type SalaryInsightsInput = {
  currentJobTitle?: Maybe<Scalars['String']>;
  currentSalary?: Maybe<Scalars['Int']>;
};

export type SalaryInsightsResult = SalaryInsights | SalaryInsightsError;

export type SalaryRange = {
  __typename?: 'SalaryRange';
  /** #logged-out #soft-logged-in */
  currency?: Maybe<Currency>;
  /** #logged-out #soft-logged-in */
  minimum?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  maximum?: Maybe<Scalars['Int']>;
};

export type SalaryUnauthorized = {
  __typename?: 'SalaryUnauthorized';
  stub?: Maybe<Scalars['String']>;
};

export type SaveJobToBookmarksAction = ObjectActions & {
  __typename?: 'SaveJobToBookmarksAction';
  params: SaveJobToBookmarksActionParams;
  trackingToken?: Maybe<Scalars['String']>;
};

export type SaveJobToBookmarksActionParams = {
  __typename?: 'SaveJobToBookmarksActionParams';
  jobId: Scalars['ID'];
};

/**
 * A type for ImageCache scaled images.
 * Creates references to signed image URLs using a shared secret, without having to do a REST call to image-cache.
 */
export type ScaledImage = {
  __typename?: 'ScaledImage';
  /**
   * #logged-out #soft-logged-in
   *
   *  The correlation reference for this image as passed in with `ScaledImageDimension`
   */
  reference?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  The signed URL of the scaled image
   */
  url?: Maybe<Scalars['URL']>;
};

export type ScaledImageDimension = {
  /** Width of the image */
  width: Scalars['Int'];
  /** Height of the image */
  height: Scalars['Int'];
  /**
   * The reference for this dimension.
   * Allows you to correlate a ScaledImage.
   *
   * See also: `ScaledImage.reference`
   */
  reference: Scalars['String'];
};

export type ScheduledMessage = {
  __typename?: 'ScheduledMessage';
  id?: Maybe<Scalars['ID']>;
  senderId?: Maybe<Scalars['ID']>;
  recipientId?: Maybe<Scalars['ID']>;
  messageType?: Maybe<MessageType>;
  payload?: Maybe<ScheduledMessagePayload>;
  scheduledAt?: Maybe<Scalars['Date']>;
  completedAt?: Maybe<Scalars['Date']>;
  status?: Maybe<ScheduledMessageStatus>;
  createdAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  contextId?: Maybe<Scalars['String']>;
};

export type ScheduledMessageMutationError = {
  __typename?: 'ScheduledMessageMutationError';
  message?: Maybe<Scalars['String']>;
};

export type ScheduledMessageMutationResult = {
  __typename?: 'ScheduledMessageMutationResult';
  error?: Maybe<ScheduledMessageMutationError>;
};

export type ScheduledMessagePayload = {
  __typename?: 'ScheduledMessagePayload';
  body?: Maybe<Scalars['String']>;
  imageUuid?: Maybe<Scalars['UUID']>;
};

export enum ScheduledMessageStatus {
  Scheduled = 'SCHEDULED',
  Sent = 'SENT',
  Failed = 'FAILED'
}

export type ScheduledMessages = {
  __typename?: 'ScheduledMessages';
  collection?: Maybe<Array<Maybe<ScheduledMessage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type SearchAlert = {
  __typename?: 'SearchAlert';
  id: Scalars['ID'];
  globalId: Scalars['GlobalID'];
  queryId: Scalars['SlugOrID'];
  /** #rest(batched) #virtual */
  query?: Maybe<JobSearchQuery>;
  name: Scalars['String'];
  newJobCount?: Maybe<Scalars['Long']>;
  hasNewJobs?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  visitedAt?: Maybe<Scalars['Date']>;
};

export type SearchAlertCreationInput = {
  queryId: Scalars['SlugOrID'];
  origin?: Maybe<SearchAlertOrigin>;
};

export type SearchAlertCreationResult = SearchAlertCreationSuccess | SearchAlertErrorResponse;

export type SearchAlertCreationSuccess = {
  __typename?: 'SearchAlertCreationSuccess';
  /** #rest(batched) #virtual */
  alert: SearchAlert;
};

export type SearchAlertErrorResponse = {
  __typename?: 'SearchAlertErrorResponse';
  requestId: Scalars['String'];
  timestamp?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  code?: Maybe<JobSearchAlertsDomainError>;
  description?: Maybe<Scalars['String']>;
};

export type SearchAlertForLo = {
  __typename?: 'SearchAlertForLO';
  /** #logged-out #soft-logged-in */
  email: Scalars['String'];
  /** #logged-out #soft-logged-in */
  query: SearchAlertQueryForLo;
  /** #logged-out #soft-logged-in */
  searchMode: SearchModeAlertLo;
};

export type SearchAlertForLoCreationAlertInput = {
  email: Scalars['String'];
  query: SearchAlertForLoCreationAlertQueryInput;
  searchMode?: Maybe<SearchModeAlertLo>;
};

export type SearchAlertForLoCreationAlertQueryExtractedFiltersDisabledInput = {
  benefits?: Maybe<Array<Scalars['String']>>;
  city?: Maybe<Array<Scalars['String']>>;
  country?: Maybe<Array<Scalars['String']>>;
  discipline?: Maybe<Array<Scalars['String']>>;
  industry?: Maybe<Array<Scalars['String']>>;
  level?: Maybe<Array<Scalars['String']>>;
  remoteOption?: Maybe<Array<Scalars['String']>>;
  salary?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Array<Scalars['String']>>;
  location?: Maybe<Array<Scalars['String']>>;
};

export type SearchAlertForLoCreationAlertQueryExtractedFiltersInput = {
  disabled?: Maybe<SearchAlertForLoCreationAlertQueryExtractedFiltersDisabledInput>;
};

export type SearchAlertForLoCreationAlertQueryFiltersInput = {
  benefits?: Maybe<Array<Scalars['String']>>;
  city?: Maybe<Array<Scalars['String']>>;
  country?: Maybe<Array<Scalars['String']>>;
  discipline?: Maybe<Array<Scalars['String']>>;
  industry?: Maybe<Array<Scalars['String']>>;
  level?: Maybe<Array<Scalars['String']>>;
  remoteOption?: Maybe<Array<Scalars['String']>>;
  salary?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Array<Scalars['String']>>;
};

export type SearchAlertForLoCreationAlertQueryInput = {
  keywords?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  radius?: Maybe<Scalars['String']>;
  filters?: Maybe<SearchAlertForLoCreationAlertQueryFiltersInput>;
  extractedFilters?: Maybe<SearchAlertForLoCreationAlertQueryExtractedFiltersInput>;
};

export type SearchAlertForLoCreationErrorResponse = {
  __typename?: 'SearchAlertForLOCreationErrorResponse';
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  errors?: Maybe<Scalars['String']>;
};

export type SearchAlertForLoCreationInput = {
  alert: SearchAlertForLoCreationAlertInput;
};

export type SearchAlertForLoCreationResult = SearchAlertForLoCreationSuccess | SearchAlertForLoCreationErrorResponse;

export type SearchAlertForLoCreationSuccess = {
  __typename?: 'SearchAlertForLOCreationSuccess';
  /** #logged-out #soft-logged-in */
  alert: SearchAlertForLo;
};

export type SearchAlertId = {
  id: Scalars['ID'];
};

export enum SearchAlertOrigin {
  Search = 'search',
  Onboarding = 'onboarding',
  DreamMachine = 'dream_machine',
  JobDetail = 'job_detail'
}

export type SearchAlertQueryExtractedFiltersDisabledForLo = {
  __typename?: 'SearchAlertQueryExtractedFiltersDisabledForLO';
  /** #logged-out #soft-logged-in */
  benefits?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  city?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  country?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  discipline?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  industry?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  level?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  remoteOption?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  salary?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  type?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  location?: Maybe<Array<Scalars['String']>>;
};

export type SearchAlertQueryExtractedFiltersForLo = {
  __typename?: 'SearchAlertQueryExtractedFiltersForLO';
  /** #logged-out #soft-logged-in */
  disabled?: Maybe<SearchAlertQueryExtractedFiltersDisabledForLo>;
};

export type SearchAlertQueryFiltersForLo = {
  __typename?: 'SearchAlertQueryFiltersForLO';
  /** #logged-out #soft-logged-in */
  benefits?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  city?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  country?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  discipline?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  industry?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  level?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  remoteOption?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  salary?: Maybe<Array<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  type?: Maybe<Array<Scalars['String']>>;
};

export type SearchAlertQueryForLo = {
  __typename?: 'SearchAlertQueryForLO';
  /** #logged-out #soft-logged-in */
  keywords?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  location?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  radius?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  filters?: Maybe<SearchAlertQueryFiltersForLo>;
  /** #logged-out #soft-logged-in */
  extractedFilters?: Maybe<SearchAlertQueryExtractedFiltersForLo>;
};

export type SearchAlertResponse = SearchAlertResultResponse | SearchAlertErrorResponse;

export type SearchAlertResultResponse = {
  __typename?: 'SearchAlertResultResponse';
  collection?: Maybe<Array<Maybe<SearchAlert>>>;
};

export type SearchAlertsInput = {
  origin?: Maybe<SearchAlertOrigin>;
};

export enum SearchMode {
  Normal = 'NORMAL',
  Semantic = 'SEMANTIC'
}

export enum SearchModeAlertLo {
  Normal = 'normal',
  Semantic = 'semantic'
}

export type SearchResultMessage = {
  __typename?: 'SearchResultMessage';
  /** #rest(batched) #virtual */
  message?: Maybe<MessengerMessage>;
  highlightedMessageBody?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  chat?: Maybe<MessengerChat>;
  searchId?: Maybe<Scalars['ID']>;
};

export type SeatAssignmentInput = {
  userId: Scalars['ID'];
};

export type SeatManagerClient = {
  __typename?: 'SeatManagerClient';
  name: Scalars['String'];
  hasPremiumSeatsContract: Scalars['Boolean'];
  premiumSeatsLimitUsed?: Maybe<Scalars['Int']>;
  premiumSeatsLimit?: Maybe<Scalars['Int']>;
  premiumUsers?: Maybe<Array<Maybe<SeatManagerUser>>>;
};

export type SeatManagerClientResponse = SeatManagerClient | SeatManagerError;

export type SeatManagerCreateAssignmentResponse = SeatManagerMutationResult | SeatManagerError;

export type SeatManagerDeleteAssignmentResponse = SeatManagerMutationResult | SeatManagerError;

export type SeatManagerError = {
  __typename?: 'SeatManagerError';
  message: Scalars['String'];
};

export type SeatManagerMutationResult = {
  __typename?: 'SeatManagerMutationResult';
  name: Scalars['String'];
  hasPremiumSeatsContract: Scalars['Boolean'];
  premiumSeatsLimitUsed?: Maybe<Scalars['Int']>;
  premiumSeatsLimit?: Maybe<Scalars['Int']>;
  premiumUsers?: Maybe<Array<Maybe<SeatManagerUser>>>;
  successMessage?: Maybe<Scalars['String']>;
};

export type SeatManagerSearchResponse = SeatManagerSearchResult | SeatManagerError;

export type SeatManagerSearchResult = {
  __typename?: 'SeatManagerSearchResult';
  results: Array<Maybe<SeatManagerUser>>;
};

export type SeatManagerUser = {
  __typename?: 'SeatManagerUser';
  id: Scalars['ID'];
  displayName?: Maybe<Scalars['String']>;
  displayFlag?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  occupationOrg?: Maybe<Scalars['String']>;
  occupationTitle?: Maybe<Scalars['String']>;
};

/** Jobs Seeking status of an User */
export enum SeekingStatus {
  Seeking = 'SEEKING',
  Interested = 'INTERESTED',
  NotSeeking = 'NOT_SEEKING'
}

export type SelectCustomQuestion = BaseApplyQuestion & {
  __typename?: 'SelectCustomQuestion';
  /** #logged-out #soft-logged-in */
  options?: Maybe<Array<Maybe<SelectCustomQuestionOption>>>;
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

export type SelectCustomQuestionOption = {
  __typename?: 'SelectCustomQuestionOption';
  /** #logged-out #soft-logged-in */
  label?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['String']>;
};

/** Simple selection setting, usually represented as a dropdown */
export type SelectSetting = HasGlobalId & {
  __typename?: 'SelectSetting';
  /** #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #soft-logged-in */
  value: Scalars['String'];
  options?: Maybe<Array<Maybe<SelectSettingOption>>>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type SelectSettingInput = {
  value: Scalars['String'];
};

/** An item in the SelectSetting */
export type SelectSettingOption = {
  __typename?: 'SelectSettingOption';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SendConsentRequestError = {
  __typename?: 'SendConsentRequestError';
  message?: Maybe<Scalars['String']>;
};

export type SendContactRequestAction = ObjectActions & {
  __typename?: 'SendContactRequestAction';
  params: SendContactRequestActionParams;
  trackingToken?: Maybe<Scalars['String']>;
};

export type SendContactRequestActionParams = {
  __typename?: 'SendContactRequestActionParams';
  recipientId: Scalars['ID'];
};

export type SendMobileConsentInput = {
  channel: Scalars['String'];
  domain: Scalars['String'];
  deviceId?: Maybe<Scalars['String']>;
  controllerId: Scalars['String'];
  nonTcfVendors: Scalars['JSON'];
  tcfVendors: Scalars['JSON'];
};

export type SendWebConsentInput = {
  channel: Scalars['String'];
  domain: Scalars['String'];
  controllerId: Scalars['String'];
  nonTcfVendors: Scalars['JSON'];
  tcfVendors: Scalars['JSON'];
};

export type SeoLinkBox = {
  __typename?: 'SeoLinkBox';
  /** #logged-out #soft-logged-in */
  kind: Scalars['String'];
  /** #logged-out #soft-logged-in */
  entries: Array<Maybe<SeoLinkBoxEntry>>;
};

export type SeoLinkBoxCollection = {
  __typename?: 'SeoLinkBoxCollection';
  /** #logged-out #soft-logged-in */
  collection: Array<Maybe<SeoLinkBox>>;
};

export type SeoLinkBoxEntry = {
  __typename?: 'SeoLinkBoxEntry';
  /** #logged-out #soft-logged-in */
  name: Scalars['String'];
  /** #logged-out #soft-logged-in */
  url: Scalars['String'];
  /** #logged-out #soft-logged-in */
  jobCount?: Maybe<Scalars['Int']>;
};

export type SeoLinkBoxInput = {
  serpType: Scalars['String'];
  jobRole?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  skill?: Maybe<Scalars['String']>;
};

/** contains the reason why setting a note failed */
export type SetNoteError = {
  __typename?: 'SetNoteError';
  message: Scalars['String'];
};

/** setNotePayload response object interface */
export type SetNotePayload = {
  note?: Maybe<Note>;
  error?: Maybe<SetNoteError>;
};

/** setNotePayload error response object */
export type SetNotePayloadError = SetNotePayload & {
  __typename?: 'SetNotePayloadError';
  note?: Maybe<Note>;
  error?: Maybe<SetNoteError>;
};

/** setNotePayload succesful response object */
export type SetNotePayloadSucces = SetNotePayload & {
  __typename?: 'SetNotePayloadSucces';
  note?: Maybe<Note>;
  error?: Maybe<SetNoteError>;
};

export type ShadowContactDetails = {
  __typename?: 'ShadowContactDetails';
  globalId: Scalars['GlobalID'];
  address?: Maybe<ShadowContactDetailsAddress>;
};

export type ShadowContactDetailsAddress = {
  __typename?: 'ShadowContactDetailsAddress';
  city?: Maybe<Scalars['String']>;
};

export type ShadowProfile = {
  __typename?: 'ShadowProfile';
  id: Scalars['ID'];
  urn: Scalars['URN'];
  profileId?: Maybe<Scalars['ID']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  academicTitle?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  organizations?: Maybe<Scalars['String']>;
  /** #rest #virtual */
  workExperiences?: Maybe<Array<Maybe<ShadowWorkExperience>>>;
  /** #rest #virtual */
  skills?: Maybe<Array<Maybe<ShadowSkill>>>;
  /** #rest #virtual */
  contactDetails?: Maybe<ShadowContactDetails>;
};

export type ShadowSkill = {
  __typename?: 'ShadowSkill';
  value: Scalars['String'];
  category: Scalars['String'];
};

export type ShadowWorkExperience = {
  __typename?: 'ShadowWorkExperience';
  globalId: Scalars['GlobalID'];
  jobTitle: Scalars['String'];
  levelId?: Maybe<Scalars['ID']>;
  disciplineId?: Maybe<Scalars['ID']>;
  companyName?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  industryId?: Maybe<Scalars['ID']>;
  statusId?: Maybe<Scalars['ID']>;
  beginDate?: Maybe<ProfileYearAndMonth>;
  endDate?: Maybe<ProfileYearAndMonth>;
};

/** Contains all the information about the shared contact */
export type SharedContact = {
  __typename?: 'SharedContact';
  /** Id of the shared contact */
  id: Scalars['ID'];
  /**
   * #rest(batched) #virtual
   *
   *  XingId representation of the information about the shared contact
   */
  xingId?: Maybe<XingId>;
};

export type SharedContacts = {
  __typename?: 'SharedContacts';
  sharedContacts?: Maybe<Array<Maybe<SharedContact>>>;
  /** The user id who has shared contacts with the rid */
  otherUserId: Scalars['ID'];
  /** The total number of shared contacts between rid and otherUserId */
  total?: Maybe<Scalars['Int']>;
};

export type SharedContactsConnection = HasCursorPagination & {
  __typename?: 'SharedContactsConnection';
  edges: Array<SharedContactsEdge>;
  /** Is false if the other user does not allow viewing its contacts for the current user. */
  isVisible: Scalars['Boolean'];
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type SharedContactsEdge = PaginationEdge & {
  __typename?: 'SharedContactsEdge';
  node: SharedContact;
  /** #virtual */
  cursor: Scalars['String'];
};

export type SignalDeleteInput = {
  id: Scalars['ID'];
  stackType: SignalsFilter;
};

export type SignalDeleteResult = {
  __typename?: 'SignalDeleteResult';
  error?: Maybe<SignalDeleteResultError>;
};

export type SignalDeleteResultError = {
  __typename?: 'SignalDeleteResultError';
  errors?: Maybe<Array<Scalars['String']>>;
};

export type SignalMarkInteractedInput = {
  id: Scalars['ID'];
  stackType: SignalsFilter;
};

export type SignalMarkInteractedResult = {
  __typename?: 'SignalMarkInteractedResult';
  error?: Maybe<SignalMarkInteractedResultError>;
  success?: Maybe<StackSignal>;
};

export type SignalMarkInteractedResultError = {
  __typename?: 'SignalMarkInteractedResultError';
  errors?: Maybe<Array<Scalars['String']>>;
};

export type SignalStackEdge = PaginationEdge & {
  __typename?: 'SignalStackEdge';
  cursor: Scalars['String'];
  node: Stack;
};

export type SignalsCollectionConnection = HasCursorPagination & {
  __typename?: 'SignalsCollectionConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<StackSignalEdge>>;
};

export enum SignalsFilter {
  Birthday = 'BIRTHDAY',
  ContactsRequest = 'CONTACTS_REQUEST',
  WorkExperienceUpdate = 'WORK_EXPERIENCE_UPDATE',
  Vomp = 'VOMP',
  NewContact = 'NEW_CONTACT',
  ContactRecommendation = 'CONTACT_RECOMMENDATION',
  SocialLike = 'SOCIAL_LIKE',
  SocialComment = 'SOCIAL_COMMENT',
  SocialShare = 'SOCIAL_SHARE',
  SocialMention = 'SOCIAL_MENTION',
  EventInvitation = 'EVENT_INVITATION',
  CulturalAssessmentProposal = 'CULTURAL_ASSESSMENT_PROPOSAL',
  JobRecommendation = 'JOB_RECOMMENDATION',
  RecruiterMessage = 'RECRUITER_MESSAGE',
  JobSearchAlert = 'JOB_SEARCH_ALERT'
}

export type SignalsStack = {
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type SignalsStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type SignalsStackMarkSeenInput = {
  stackType: SignalsFilter;
};

export type SignalsStackMarkSeenResult = {
  __typename?: 'SignalsStackMarkSeenResult';
  error?: Maybe<SignalsStackMarkSeenResultError>;
  success?: Maybe<SignalsStack>;
};

export type SignalsStackMarkSeenResultError = {
  __typename?: 'SignalsStackMarkSeenResultError';
  errors?: Maybe<Array<Scalars['String']>>;
};

export type SignalsStacksConnection = HasCursorPagination & {
  __typename?: 'SignalsStacksConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<SignalStackEdge>>;
};

export type SimilarCandidates = {
  __typename?: 'SimilarCandidates';
  requestTrackingToken?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  took?: Maybe<Scalars['Int']>;
  collection?: Maybe<Array<Maybe<Candidates>>>;
  total?: Maybe<Scalars['Int']>;
};

export type SimplifiedInsightsPushTopic = {
  __typename?: 'SimplifiedInsightsPushTopic';
  id: Scalars['ID'];
  headline: Scalars['String'];
};

export enum SincePeriod {
  Last_24Hours = 'LAST_24_HOURS',
  LastWeek = 'LAST_WEEK',
  LastMonth = 'LAST_MONTH'
}

export type Skill = {
  __typename?: 'Skill';
  id?: Maybe<Scalars['ID']>;
  label: Scalars['String'];
  category?: Maybe<Scalars['String']>;
};

export type SkillLabels = {
  __typename?: 'SkillLabels';
  de: Scalars['String'];
  en: Scalars['String'];
};

export type SkillRecommendation = Recommendation & {
  __typename?: 'SkillRecommendation';
  labels: SkillLabels;
  label: Scalars['String'];
  totalPerformance?: Maybe<Scalars['Long']>;
  category: Scalars['String'];
  trackingToken: Scalars['String'];
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  itemId: Scalars['ID'];
  urn: Scalars['URN'];
  score: Scalars['Float'];
  reason: Array<Scalars['String']>;
};

export type SkillRecommendationResponse = RecommenderResponse & {
  __typename?: 'SkillRecommendationResponse';
  collection: Array<SkillRecommendation>;
  requestTrackingToken: Scalars['String'];
  service: Scalars['String'];
  total: Scalars['Int'];
};

export type SkillsInsights = HasNwtTrackingToken & HasNewWorkTrackingToken & {
  __typename?: 'SkillsInsights';
  userId: Scalars['ID'];
  currentJobTitle?: Maybe<Scalars['String']>;
  minSkills: Scalars['Int'];
  topSkills?: Maybe<Array<Maybe<Skill>>>;
  /** @deprecated Replaced by HasNewWorkTrackingToken to not confuse with another field with same name */
  trackingToken?: Maybe<Scalars['String']>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};


export type SocialActivity = SocialEntity & {
  __typename?: 'SocialActivity';
  urn?: Maybe<Scalars['URN']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

export type SocialComment = SocialEntity & {
  __typename?: 'SocialComment';
  urn?: Maybe<Scalars['URN']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

export type SocialCommentEdge = PaginationEdge & {
  __typename?: 'SocialCommentEdge';
  node: SocialCommentResult;
  /** #virtual */
  cursor: Scalars['String'];
};

export type SocialCommentError = {
  __typename?: 'SocialCommentError';
  message?: Maybe<Scalars['String']>;
};

export type SocialCommentMutationResult = {
  __typename?: 'SocialCommentMutationResult';
  success?: Maybe<SocialCommentResult>;
  error?: Maybe<SocialCommentError>;
};

export type SocialCommentPermissions = {
  __typename?: 'SocialCommentPermissions';
  /** #logged-out #soft-logged-in */
  canCreate: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canUpdate: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canView: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canDelete: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canDeleteMentions: Scalars['Boolean'];
};

export type SocialCommentResult = {
  __typename?: 'SocialCommentResult';
  /** id of the comment */
  id: Scalars['ID'];
  /** urn of the comment */
  urn: Scalars['GlobalID'];
  /** the urn of the entity where the comment happened */
  interactionTargetUrn: Scalars['GlobalID'];
  /** comment text with json-encoded formatting (plaintext or slateV1) */
  message: Scalars['String'];
  /** comment in slate format */
  messageSlateV1: Scalars['String'];
  /** comment in article editor format */
  messageArticleV1: Array<ArticleBlock>;
  /** comment in plaintext format */
  messagePlaintext: Scalars['String'];
  /**
   * comment in plaintext format (legacy)
   * @deprecated use messagePlaintext instead
   */
  fallbackMessage: Scalars['String'];
  /** comment format (plaintext, slateV1, articleV1) */
  format: Scalars['String'];
  /** the user id who created the comment */
  userId: Scalars['ID'];
  /** the actor picked by the user */
  actorUrn?: Maybe<Scalars['GlobalID']>;
  /** depth of the comment */
  depth: Scalars['Int'];
  /** the date the comment has been created */
  createdAt?: Maybe<Scalars['Date']>;
  /** the date the comment was last updated */
  updatedAt?: Maybe<Scalars['Date']>;
  /** the date the comment was deleted */
  deletedAt?: Maybe<Scalars['Date']>;
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  interactionTarget?: Maybe<SocialInteractionTarget>;
  /** #rest(batched) #virtual */
  commentInteractionTarget?: Maybe<SocialInteractionTarget>;
  /** was the comment edited */
  isEdited?: Maybe<Scalars['Boolean']>;
  /** list of replies to the comment to show */
  initiallyShownReplies?: Maybe<Array<Maybe<SocialCommentResult>>>;
  /** pagination information for replies (only when providing comment ID) */
  repliesPage?: Maybe<RepliesPage>;
};

export type SocialCommentSignal = NetworkUpdatesStackItem & {
  __typename?: 'SocialCommentSignal';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  object?: Maybe<SocialComment>;
  subtype?: Maybe<SocialCommentSubtype>;
  id: Scalars['ID'];
  stackId: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type SocialCommentStack = SignalsStack & {
  __typename?: 'SocialCommentStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type SocialCommentStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export enum SocialCommentSubtype {
  ReplyToOwnComment = 'REPLY_TO_OWN_COMMENT',
  ReplyToOwnPost = 'REPLY_TO_OWN_POST',
  ReplyToThread = 'REPLY_TO_THREAD',
  CommentToOwnPost = 'COMMENT_TO_OWN_POST',
  CommentToThread = 'COMMENT_TO_THREAD'
}

export type SocialCommentsConnection = HasCursorPagination & {
  __typename?: 'SocialCommentsConnection';
  previousCount: Scalars['Int'];
  nextCount: Scalars['Int'];
  edges?: Maybe<Array<Maybe<SocialCommentEdge>>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type SocialCreateCommentInput = {
  interactionTargetUrn: Scalars['GlobalID'];
  message?: Maybe<Scalars['String']>;
  messageArticleV1?: Maybe<Array<ArticlesCreateArticleBlocksInput>>;
  format?: Maybe<Scalars['String']>;
  actorUrn?: Maybe<Scalars['GlobalID']>;
  trackingMetadata?: Maybe<SocialTrackingMetadataInput>;
};

export type SocialCreateExternalLinkInput = {
  url: Scalars['URL'];
};

export type SocialCreateReactionInput = {
  reactionType: SocialReactionType;
  interactionTargetUrn: Scalars['GlobalID'];
  trackingMetadata?: Maybe<SocialTrackingMetadataInput>;
};

export type SocialDeleteCommentInput = {
  id: Scalars['ID'];
};

export type SocialDeleteCommentMentionsInput = {
  id: Scalars['ID'];
};

export type SocialDeleteReactionInput = {
  interactionTargetUrn: Scalars['GlobalID'];
};

export type SocialEntity = {
  urn?: Maybe<Scalars['URN']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

export type SocialEvent = SocialEntity & {
  __typename?: 'SocialEvent';
  urn?: Maybe<Scalars['URN']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

export type SocialExternalLinkError = {
  __typename?: 'SocialExternalLinkError';
  message?: Maybe<Scalars['String']>;
};

export type SocialExternalLinkMutationResult = {
  __typename?: 'SocialExternalLinkMutationResult';
  success?: Maybe<SocialExternalLinkResult>;
  error?: Maybe<SocialExternalLinkError>;
};

export type SocialExternalLinkResult = {
  __typename?: 'SocialExternalLinkResult';
  /**
   * #logged-out #soft-logged-in
   *
   *  id of the external link
   */
  id: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  urn of the external link
   */
  urn: Scalars['GlobalID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  unique id of the external link (sha256 of the URL)
   */
  uniqueId: Scalars['String'];
  /**
   * #logged-out #soft-logged-in
   *
   *  URL of the link
   */
  url: Scalars['URL'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Canonical URL of the link (source of truth in case many URLs have the same content)
   */
  canonicalUrl: Scalars['URL'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Link title as specified by the meta tags or our best-guess
   */
  title?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Link description as specified by the meta tags or our best-guess
   */
  description?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Domain of the link (e.g. xing.com)
   */
  sourceDomain?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Preview image as specified by meta tags or the most prominent image on the page
   */
  imageUrl?: Maybe<Scalars['URL']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Same as the imageUrl, but stored in our ImageCache (should be prefered)
   */
  cachedImageUrl?: Maybe<Scalars['URL']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  True if the URL points to an external host, false if it is XING internal
   */
  isExternal?: Maybe<Scalars['Boolean']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  the Date when the link was first created on the platform
   */
  createdAt?: Maybe<Scalars['Date']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  the Date when the link was last updated
   */
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SocialImagePost = SocialEntity & {
  __typename?: 'SocialImagePost';
  urn?: Maybe<Scalars['URN']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

export type SocialInteractionTarget = {
  __typename?: 'SocialInteractionTarget';
  /** #logged-out #soft-logged-in */
  urn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  commentsCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  repliesCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  reactionsCount: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  sharesCount: Scalars['Int'];
  viewsCount?: Maybe<Scalars['Int']>;
  userReactionType?: Maybe<SocialReactionType>;
  /** #logged-out #soft-logged-in */
  permissions: SocialPermissions;
};

export type SocialLikeSignal = NetworkUpdatesStackItem & {
  __typename?: 'SocialLikeSignal';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  target?: Maybe<SocialLikeTarget>;
  id: Scalars['ID'];
  stackId: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type SocialLikeStack = SignalsStack & {
  __typename?: 'SocialLikeStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type SocialLikeStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type SocialLikeTarget = SocialActivity | SocialComment | SocialEvent | SocialImagePost | SocialLinkSharePost | SocialPlainTextPost | SocialVideoPost | SocialPollPost;

export type SocialLinkSharePost = SocialEntity & {
  __typename?: 'SocialLinkSharePost';
  urn?: Maybe<Scalars['URN']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

export type SocialMentionPermissions = {
  __typename?: 'SocialMentionPermissions';
  /** #logged-out #soft-logged-in */
  canDelete: Scalars['Boolean'];
};

export type SocialMentionSignal = NetworkUpdatesStackItem & {
  __typename?: 'SocialMentionSignal';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  target?: Maybe<SocialMentionTarget>;
  id: Scalars['ID'];
  stackId: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type SocialMentionStack = SignalsStack & {
  __typename?: 'SocialMentionStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type SocialMentionStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type SocialMentionTarget = SocialActivity | SocialComment | SocialEvent | SocialImagePost | SocialLinkSharePost | SocialPlainTextPost | SocialVideoPost | SocialPollPost;

export type SocialMessengerRecentChats = {
  __typename?: 'SocialMessengerRecentChats';
  collection?: Maybe<Array<Maybe<MessengerChat>>>;
};

export type SocialPermissions = {
  __typename?: 'SocialPermissions';
  /** #logged-out #soft-logged-in */
  reactions: SocialReactionPermissions;
  /** #logged-out #soft-logged-in */
  comments: SocialCommentPermissions;
  /** #logged-out #soft-logged-in */
  shares: SocialSharePermissions;
  /** #logged-out #soft-logged-in */
  mentions: SocialMentionPermissions;
};

export type SocialPlainTextPost = SocialEntity & {
  __typename?: 'SocialPlainTextPost';
  urn?: Maybe<Scalars['URN']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

export type SocialPollPost = SocialEntity & {
  __typename?: 'SocialPollPost';
  urn?: Maybe<Scalars['URN']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

export type SocialProofCollection = {
  __typename?: 'SocialProofCollection';
  urn: Scalars['GlobalID'];
  reactions?: Maybe<Array<Maybe<SocialProofRecord>>>;
};

export type SocialProofRecord = {
  __typename?: 'SocialProofRecord';
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  interactionTargetUrn: Scalars['GlobalID'];
  /** #rest(batched) #virtual */
  interactionTarget?: Maybe<SocialInteractionTarget>;
};

export type SocialProofResult = {
  __typename?: 'SocialProofResult';
  collection?: Maybe<Array<Maybe<SocialProofRecord>>>;
};

export type SocialReactionEdge = PaginationEdge & {
  __typename?: 'SocialReactionEdge';
  node: SocialReactionResult;
  /** #virtual */
  cursor: Scalars['String'];
};

export type SocialReactionError = {
  __typename?: 'SocialReactionError';
  message?: Maybe<Scalars['String']>;
};

export type SocialReactionMutationResult = {
  __typename?: 'SocialReactionMutationResult';
  success?: Maybe<SocialReactionResult>;
  error?: Maybe<SocialReactionError>;
};

export type SocialReactionPermissions = {
  __typename?: 'SocialReactionPermissions';
  /** #logged-out #soft-logged-in */
  canCreate: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canView: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canDelete: Scalars['Boolean'];
};

export type SocialReactionResult = {
  __typename?: 'SocialReactionResult';
  id: Scalars['ID'];
  reactionType: SocialReactionType;
  interactionTargetUrn: Scalars['GlobalID'];
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  actorUrn?: Maybe<Scalars['GlobalID']>;
  /** #rest(batched) #virtual */
  interactionTarget?: Maybe<SocialInteractionTarget>;
  /** the contact state between the current user and the creator of the reaction */
  isContactWithCurrentUser?: Maybe<Scalars['Boolean']>;
};

export enum SocialReactionType {
  Like = 'LIKE'
}

export type SocialReactionsConnection = HasCursorPagination & {
  __typename?: 'SocialReactionsConnection';
  previousCount: Scalars['Int'];
  nextCount: Scalars['Int'];
  edges?: Maybe<Array<Maybe<SocialReactionEdge>>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

/** Settings related to Social */
export type SocialSettings = {
  __typename?: 'SocialSettings';
  /** User is mentionable (via @name in comments) */
  mentionable?: Maybe<ToggleSetting>;
};

export type SocialSettingsInput = {
  /** User is mentionable (via @name in comments) */
  mentionable?: Maybe<ToggleSettingInput>;
};

export type SocialSettingsMutationResult = {
  __typename?: 'SocialSettingsMutationResult';
  error?: Maybe<SocialSettings>;
  response?: Maybe<SocialSettings>;
};

export type SocialShareEdge = PaginationEdge & {
  __typename?: 'SocialShareEdge';
  node: SocialShareResult;
  /** #virtual */
  cursor: Scalars['String'];
};

export type SocialShareError = {
  __typename?: 'SocialShareError';
  message?: Maybe<Scalars['String']>;
};

export type SocialShareMutationResult = {
  __typename?: 'SocialShareMutationResult';
  success?: Maybe<SocialShareResult>;
  error?: Maybe<SocialShareError>;
};

export type SocialSharePermissions = {
  __typename?: 'SocialSharePermissions';
  /** #logged-out #soft-logged-in */
  canCreate: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canView: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  canDelete: Scalars['Boolean'];
};

export type SocialShareResult = {
  __typename?: 'SocialShareResult';
  /** the destination type of the share: one of startpage|groups|messenger */
  targetType?: Maybe<Scalars['String']>;
  /** the urn of the entity where the interaction happened */
  interactionTargetUrn?: Maybe<Scalars['GlobalID']>;
  /** the urn of the entity identifying the content that was shared */
  shareableUrn?: Maybe<Scalars['GlobalID']>;
  /** the user-provided message */
  message?: Maybe<Scalars['String']>;
  /** the url of the newly created object as a result of the share */
  redirectUrl?: Maybe<Scalars['URL']>;
  /** the user id who created the share */
  userId: Scalars['ID'];
  /** the actor picked by the user */
  actorUrn?: Maybe<Scalars['GlobalID']>;
  /** the urn of the new object created by the share (unique) */
  newObjectUrn?: Maybe<Scalars['GlobalID']>;
  /** the contact state between the current user and the creator of the share */
  isContactWithCurrentUser?: Maybe<Scalars['Boolean']>;
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  interactionTarget?: Maybe<SocialInteractionTarget>;
  /** #rest(batched) #virtual */
  newInteractionTarget?: Maybe<SocialInteractionTarget>;
  /** the date the share has been created */
  createdAt?: Maybe<Scalars['Date']>;
};

export type SocialShareSignal = NetworkUpdatesStackItem & {
  __typename?: 'SocialShareSignal';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest(batched) #virtual */
  target?: Maybe<SocialShareTarget>;
  id: Scalars['ID'];
  stackId: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type SocialShareStack = SignalsStack & {
  __typename?: 'SocialShareStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type SocialShareStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type SocialShareTarget = SocialActivity | SocialComment | SocialEvent | SocialImagePost | SocialLinkSharePost | SocialPlainTextPost | SocialVideoPost | SocialPollPost;

export type SocialShareToGroupInput = {
  interactionTargetUrn: Scalars['GlobalID'];
  shareableUrn?: Maybe<Scalars['GlobalID']>;
  forumId: Scalars['ID'];
  url: Scalars['URL'];
  title: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  trackingMetadata?: Maybe<SocialTrackingMetadataInput>;
};

export type SocialShareToMessengerInput = {
  interactionTargetUrn: Scalars['GlobalID'];
  shareableUrn?: Maybe<Scalars['GlobalID']>;
  recipient: SocialShareToMessengerRecipient;
  url: Scalars['URL'];
  message?: Maybe<Scalars['String']>;
  trackingMetadata?: Maybe<SocialTrackingMetadataInput>;
};

export type SocialShareToMessengerRecipient = {
  type: SocialShareToMessengerRecipientType;
  id: Scalars['ID'];
};

export enum SocialShareToMessengerRecipientType {
  /** A recent chat */
  Chat = 'CHAT',
  /** A new chat participant */
  Participant = 'PARTICIPANT'
}

export enum SocialShareToStartPageAudienceType {
  /** Quick share in the feed(empty comment) */
  Startpage = 'STARTPAGE',
  /** Share with a comment in the feed */
  StartpageWithComment = 'STARTPAGE_WITH_COMMENT'
}

export type SocialShareToStartpageInput = {
  interactionTargetUrn: Scalars['GlobalID'];
  shareableUrn?: Maybe<Scalars['GlobalID']>;
  message?: Maybe<Scalars['String']>;
  verb?: Maybe<SocialShareToStartpageVerb>;
  visibility?: Maybe<SocialShareToStartpageVisibility>;
  trackingMetadata?: Maybe<SocialTrackingMetadataInput>;
};

export enum SocialShareToStartpageVerb {
  /** The default re-share action */
  Share = 'SHARE',
  /** An initial share action */
  Post = 'POST'
}

export enum SocialShareToStartpageVisibility {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type SocialSharesConnection = HasCursorPagination & {
  __typename?: 'SocialSharesConnection';
  previousCount: Scalars['Int'];
  nextCount: Scalars['Int'];
  edges?: Maybe<Array<Maybe<SocialShareEdge>>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type SocialTrackingMetadataInput = {
  trackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  userAgent?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  entryPoint?: Maybe<Scalars['String']>;
  audienceType?: Maybe<SocialShareToStartPageAudienceType>;
};

export type SocialUpdateCommentInput = {
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  messageArticleV1?: Maybe<Array<ArticlesCreateArticleBlocksInput>>;
  format?: Maybe<Scalars['String']>;
  actorUrn?: Maybe<Scalars['GlobalID']>;
  trackingMetadata?: Maybe<SocialTrackingMetadataInput>;
};

export type SocialUpdateReactionInput = {
  reactionType: SocialReactionType;
  interactionTargetUrn: Scalars['GlobalID'];
  trackingMetadata?: Maybe<SocialTrackingMetadataInput>;
};

export type SocialUserRecord = {
  __typename?: 'SocialUserRecord';
  userId: Scalars['ID'];
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  isMentionable?: Maybe<Scalars['Boolean']>;
};

export type SocialUserSearchResult = {
  __typename?: 'SocialUserSearchResult';
  collection?: Maybe<Array<Maybe<SocialUserRecord>>>;
};

export type SocialVideoPost = SocialEntity & {
  __typename?: 'SocialVideoPost';
  urn?: Maybe<Scalars['URN']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

export type Source = Community | GroupsGroup | XingId;

/** At Specific Time Phone Preferences Type */
export type SpecificTimePhonePreferences = {
  __typename?: 'SpecificTimePhonePreferences';
  at: PhonePreferencesOptions;
  days: PhonePreferenceDays;
  /** #rest(batched) #virtual */
  timeFrom?: Maybe<PhonePreferenceTime>;
  /** #rest(batched) #virtual */
  timeUntil?: Maybe<PhonePreferenceTime>;
};

export type Stack = BirthdayStack | VompStack | ContactRequestStack | NewContactStack | SocialLikeStack | SocialCommentStack | SocialShareStack | SocialMentionStack | EventInvitationStack | WorkExperienceUpdateStack | ContactRecommendationStack | CulturalAssessmentProposalStack | JobRecommendationStack | RecruiterMessageStack | JobSearchAlertStack;

export type StackSignal = BirthdayConversationStarter | ContactRequestConversationStarter | NewContactConversationStarter | VompConversationStarter | WorkExperienceUpdateConversationStarter | ContactRecommendationSignal | SocialLikeSignal | SocialCommentSignal | SocialShareSignal | SocialMentionSignal | EventInvitationSignal | CulturalAssessmentProposalSignal | JobRecommendationSignal | RecruiterMessageSignal | JobSearchAlertSignal;

export type StackSignalEdge = PaginationEdge & {
  __typename?: 'StackSignalEdge';
  cursor: Scalars['String'];
  node: StackSignal;
};

export type StartUserDataInquiryResult = {
  inquiry?: Maybe<UserDataInquiry>;
  error?: Maybe<UserDataInquiryError>;
};

export type StartUserDataInquiryResultError = StartUserDataInquiryResult & {
  __typename?: 'StartUserDataInquiryResultError';
  inquiry?: Maybe<UserDataInquiry>;
  error?: Maybe<UserDataInquiryError>;
};

export type StartUserDataInquiryResultSuccess = StartUserDataInquiryResult & {
  __typename?: 'StartUserDataInquiryResultSuccess';
  inquiry?: Maybe<UserDataInquiry>;
  error?: Maybe<UserDataInquiryError>;
};

/** Deprecated: It should be replaced to graphVisitor */
export type StatisticsGraph = {
  __typename?: 'StatisticsGraph';
  /** @deprecated the entire StatisticsGraph is deprecated. */
  sectionHeadline: Scalars['String'];
  /** @deprecated the entire StatisticsGraph is deprecated. */
  startDate: Scalars['Date'];
  /** @deprecated the entire StatisticsGraph is deprecated. */
  endDate: Scalars['Date'];
  /**
   * The trend percentage representing the visitors increase or decrease on the specified time frame
   * @deprecated the entire StatisticsGraph is deprecated.
   */
  visitsTrend: Scalars['Float'];
  /**
   * The headline for the trend percentage - it also includes the percentage as text
   * @deprecated the entire StatisticsGraph is deprecated.
   */
  visitsTrendHeadline: Scalars['String'];
  /**
   * The array of visits for the specified time frame
   * @deprecated the entire StatisticsGraph is deprecated.
   */
  visitsPerDay: Array<Scalars['Int']>;
  /**
   * When the user is basic, a description is given
   * @deprecated the entire StatisticsGraph is deprecated.
   */
  upsellDescription?: Maybe<Scalars['String']>;
};

export type StatisticsItem = {
  __typename?: 'StatisticsItem';
  sectionHeadline: Scalars['String'];
  /** If this component is suited for a count or a pie chart representation */
  type: StatisticsType;
  /** When the user is basic, a description is given */
  upsellDescription?: Maybe<Scalars['String']>;
  /** Upsell Point used for tracking purposes */
  uplt?: Maybe<Scalars['String']>;
  /** The actual number value object for this item */
  items: Array<StatisticsShare>;
};

export type StatisticsShare = {
  __typename?: 'StatisticsShare';
  title: Scalars['String'];
  /** The value for this item. It can be a percentage or an absolute number depending on the statistics type */
  share: Scalars['Int'];
  /** Tells the client if the feature should be shown fenced */
  fenced: Scalars['Boolean'];
};

/** The statistics component can be suited for percentage representation (PIE) or absolute representation (BAR) */
export enum StatisticsType {
  Bar = 'BAR',
  Pie = 'PIE'
}

/** Authorization to JobSeeker data of Basic and Premium users */
export enum StatusVisibility {
  Recruiter = 'RECRUITER',
  RecruiterAndContacts = 'RECRUITER_AND_CONTACTS',
  XingMembers = 'XING_MEMBERS'
}

export type StoryActivity = {
  __typename?: 'StoryActivity';
  /** The URN of the Story, not the Activity */
  globalId: Scalars['GlobalID'];
  /** Sort key of this story within a `StoryActivityCollection` */
  sortKey: Scalars['Int'];
  activityId?: Maybe<Scalars['ID']>;
  /** Indicates whether the user has already seen the corresponding story */
  hasSeen: Scalars['Boolean'];
};

/** A grouping of stories by actor (creator/owner). */
export type StoryActivityCollection = {
  __typename?: 'StoryActivityCollection';
  /**
   * All stories in this collection belong to this actor, or should at least be
   * displayed as stories by this actor.
   */
  actorGlobalId: Scalars['GlobalID'];
  /** #rest(batched) #virtual */
  actor?: Maybe<StoryActor>;
  /** Total number of currently active stories. */
  activeStoryCount: Scalars['Int'];
  storiesActivities?: Maybe<Array<Maybe<StoryActivity>>>;
  /**
   * Allows the server to decide the order that a collection should show up
   * among many collections. For example, a collection with the most recent post
   * would get `sortKey: 1`
   */
  sortKey?: Maybe<Scalars['Int']>;
  /**
   * Timestamp of the most recently created story in the collection
   * @deprecated no one is using it; if you are or want to, please contact the publishing team
   */
  lastCreatedAt: Scalars['Date'];
  /** Whether the requesting user is allowed to create stories on the actor of this collection's behalf */
  isManagedByUser: Scalars['Boolean'];
};

export type StoryActor = XingId | EntityPage | StoryDemoActor;

/** A collection of stories */
export type StoryCollection = {
  __typename?: 'StoryCollection';
  stories?: Maybe<Array<Maybe<PostingsStory>>>;
};

/** A collection of story collections is needed to create the "story row" for a user */
export type StoryCollectionList = {
  __typename?: 'StoryCollectionList';
  collection?: Maybe<Array<Maybe<StoryActivityCollection>>>;
};

export type StoryCreateMutationResult = {
  __typename?: 'StoryCreateMutationResult';
  success?: Maybe<PostingsStoryPromise>;
  error?: Maybe<PostingsError>;
};

export type StoryDeleteMutationResult = {
  __typename?: 'StoryDeleteMutationResult';
  error?: Maybe<PostingsError>;
};

export type StoryDemoActor = {
  __typename?: 'StoryDemoActor';
  title: Scalars['String'];
  /** #virtual */
  logoImage?: Maybe<Array<ScaledImage>>;
};


export type StoryDemoActorLogoImageArgs = {
  dimensions: Array<ScaledImageDimension>;
};

/**
 * Groups Stories for synchronized publication.
 * Only relevant for creation. Once the stories have been created, they can
 * and should be accessed directly, like all other stories.
 */
export type StoryGroup = {
  __typename?: 'StoryGroup';
  globalId: Scalars['GlobalID'];
  actorGlobalId: Scalars['GlobalID'];
  /** Use this as apiKey to create videos for stories in the videoCreate mutation */
  videoApiKey: Scalars['String'];
  stories?: Maybe<Array<PostingsStoryPromise>>;
};

export type StoryGroupMutationResult = {
  __typename?: 'StoryGroupMutationResult';
  success?: Maybe<StoryGroup>;
  error?: Maybe<PostingsError>;
};

export type StoryInteractions = {
  __typename?: 'StoryInteractions';
  messaging: Scalars['Boolean'];
};

export type StoryMedium = {
  id: Scalars['ID'];
  globalId: Scalars['GlobalID'];
};

export enum StorySupportedActors {
  XingId = 'XING_ID',
  EntityPage = 'ENTITY_PAGE',
  DemoActor = 'DEMO_ACTOR'
}

export enum StoryType {
  Image = 'IMAGE',
  Text = 'TEXT',
  Video = 'VIDEO'
}

/** Viewer of a story. Acts a wrapper for `XingId` */
export type StoryViewer = {
  __typename?: 'StoryViewer';
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
};

export type StoryViewerConnection = HasCursorPagination & {
  __typename?: 'StoryViewerConnection';
  edges: Array<StoryViewerEdge>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type StoryViewerEdge = PaginationEdge & {
  __typename?: 'StoryViewerEdge';
  node: StoryViewer;
  /** #virtual */
  cursor: Scalars['String'];
};

export type Subjects = {
  __typename?: 'Subjects';
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  label?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  form?: Maybe<Form>;
};

export type SubmitReview401Error = {
  __typename?: 'SubmitReview401Error';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
};

export type SubmitReviewInput = {
  token: Scalars['String'];
  message: Scalars['String'];
  id: Scalars['ID'];
};

export type SubmitReviewPostResult = SubmitReviewResponse | SubmitReview401Error;

export type SubmitReviewResponse = {
  __typename?: 'SubmitReviewResponse';
  /** #logged-out #soft-logged-in */
  report?: Maybe<ComplaintsReport>;
};

/** The root subscription type */
export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Dummy subscription field
   * @deprecated Makes GraphiQL happy
   */
  dummy?: Maybe<Scalars['String']>;
};

export type SupportContactFormTopics = {
  __typename?: 'SupportContactFormTopics';
  /** #logged-out #soft-logged-in #rest #virtual */
  topics?: Maybe<ContactTopicsResponse>;
};


export type SupportContactFormTopicsTopicsArgs = {
  subjectName?: Maybe<Scalars['String']>;
};

export type TableOfContent = {
  __typename?: 'TableOfContent';
  /**
   * #logged-out #soft-logged-in
   *
   *  ID of the table of content
   */
  id?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Title of the table of content
   */
  title?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Children of the table of content
   */
  children?: Maybe<Array<Maybe<TableOfContentChildren>>>;
};

export type TableOfContentChildren = {
  __typename?: 'TableOfContentChildren';
  /**
   * #logged-out #soft-logged-in
   *
   *  HTML id of the content from children
   */
  id?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Title of the content from children
   */
  title?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Children of the content from children
   */
  children?: Maybe<Array<Maybe<TableOfContentChildren>>>;
};

export type TakenJob = Recommendation & {
  __typename?: 'TakenJob';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  withSingleMember?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  job?: Maybe<OccupiedJob>;
  /** #logged-out #soft-logged-in */
  itemId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  position: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  urn: Scalars['URN'];
  /** #logged-out #soft-logged-in */
  score: Scalars['Float'];
  /** #logged-out #soft-logged-in */
  reason: Array<Scalars['String']>;
  /** @deprecated Operational Tracking (ODT) is being replaced by New Work Tracking */
  opTrackingTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  nwTrackingToken?: Maybe<Scalars['String']>;
};

export type TalentPoolsAggregation = {
  __typename?: 'TalentPoolsAggregation';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['ID']>;
};

/** TargetPositionsPreference Type */
export type TargetPositionsPreference = {
  __typename?: 'TargetPositionsPreference';
  targetPositions: Array<Maybe<Scalars['String']>>;
};

export type TeamPermissionsDeleteMutationResult = {
  __typename?: 'TeamPermissionsDeleteMutationResult';
  success?: Maybe<TeamPermissionsResourceRight>;
  error?: Maybe<TeamPermissionsMutationError>;
};

export type TeamPermissionsDeleteResourceUserInput = {
  resourceId: Scalars['ID'];
  resourceType: TeamPermissionsResourceType;
  userId: Scalars['ID'];
  /** When present, it assigns the role of the user being deleted to another user. Only implemented for XTM and XTP. */
  transferRoleTo?: Maybe<Scalars['ID']>;
};

export type TeamPermissionsMutationError = Localizable & {
  __typename?: 'TeamPermissionsMutationError';
  localizationKey: Scalars['String'];
  localizationValue: Scalars['String'];
};

export type TeamPermissionsMutationResult = {
  __typename?: 'TeamPermissionsMutationResult';
  success?: Maybe<TeamPermissionsResourceRight>;
  error?: Maybe<TeamPermissionsMutationError>;
};

export type TeamPermissionsQuery = {
  __typename?: 'TeamPermissionsQuery';
  /** #rest #virtual */
  userResource?: Maybe<TeamPermissionsResourceRight>;
  /** #paginated #rest #virtual */
  userResources?: Maybe<TeamPermissionsResourceRightsConnection>;
  /** #rest #virtual */
  resourceRoles?: Maybe<TeamPermissionsRoles>;
  /** #rest #virtual */
  resourceUsers?: Maybe<TeamPermissionsResourceRights>;
  /** #paginated #rest #virtual */
  users?: Maybe<TeamPermissionsResourceRightsConnection>;
};


export type TeamPermissionsQueryUserResourceArgs = {
  resourceType: TeamPermissionsResourceType;
  resourceId: Scalars['ID'];
  permissions?: Maybe<Scalars['String']>;
  types?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type TeamPermissionsQueryUserResourcesArgs = {
  resourceType: TeamPermissionsResourceType;
  permissions?: Maybe<Scalars['String']>;
  types?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type TeamPermissionsQueryResourceRolesArgs = {
  resourceType: TeamPermissionsResourceType;
};


export type TeamPermissionsQueryResourceUsersArgs = {
  resourceType: TeamPermissionsResourceType;
  resourceId: Scalars['ID'];
};


export type TeamPermissionsQueryUsersArgs = {
  resourceType: TeamPermissionsResourceType;
  resourceId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
  roles?: Maybe<Scalars['String']>;
};

export type TeamPermissionsResource = Company | EntityPage;

export type TeamPermissionsResourceRight = {
  __typename?: 'TeamPermissionsResourceRight';
  permissions: Array<Scalars['String']>;
  /** #rest(batched) #virtual */
  resource?: Maybe<TeamPermissionsResource>;
  resourceId: Scalars['ID'];
  resourceType: TeamPermissionsResourceType;
  role?: Maybe<TeamPermissionsRole>;
  /** #rest(batched) #virtual */
  user?: Maybe<XingId>;
  userId: Scalars['ID'];
  since: Scalars['Date'];
  /** Context is an object containg resource specific data. For XTM, XTP it contains information about blocked seats. */
  context?: Maybe<TeamPermissionsResourceRightContext>;
};

export type TeamPermissionsResourceRightContext = TeamPermissionsResourceRightPaymentsApiContext;

export type TeamPermissionsResourceRightPaymentsApiContext = {
  __typename?: 'TeamPermissionsResourceRightPaymentsApiContext';
  /** For XTM, XTP it contains the date when the seat will be unblocked */
  unblockedAt?: Maybe<Scalars['Date']>;
  /** For XTM, XTP whether seat is blocked */
  blocked?: Maybe<Scalars['Boolean']>;
};

export type TeamPermissionsResourceRights = {
  __typename?: 'TeamPermissionsResourceRights';
  collection?: Maybe<Array<Maybe<TeamPermissionsResourceRight>>>;
};

export type TeamPermissionsResourceRightsConnection = HasCursorPagination & {
  __typename?: 'TeamPermissionsResourceRightsConnection';
  total: Scalars['Int'];
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<TeamPermissionsResourceRightsEdge>>>;
};

export type TeamPermissionsResourceRightsEdge = PaginationEdge & {
  __typename?: 'TeamPermissionsResourceRightsEdge';
  cursor: Scalars['String'];
  node?: Maybe<TeamPermissionsResourceRight>;
};

/** Handling team permissions using the following API https://apidoc.xing.io/apidoc/?api=teampermissions/rest#/ */
export enum TeamPermissionsResourceType {
  Companies = 'COMPANIES',
  Pages = 'PAGES',
  Talentmanager = 'TALENTMANAGER',
  Talentpoolmanager = 'TALENTPOOLMANAGER',
  Jobmanager = 'JOBMANAGER',
  Referralmanager = 'REFERRALMANAGER',
  Briefings = 'BRIEFINGS'
}

export type TeamPermissionsRole = {
  __typename?: 'TeamPermissionsRole';
  id: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TeamPermissionsRoles = {
  __typename?: 'TeamPermissionsRoles';
  collection?: Maybe<Array<Maybe<TeamPermissionsRole>>>;
};

export type TeamPermissionsUpdateResourceUserInput = {
  resourceId: Scalars['ID'];
  resourceType: TeamPermissionsResourceType;
  userId: Scalars['ID'];
  roleId: Scalars['String'];
};

export type TeamPermissionsViewer = {
  __typename?: 'TeamPermissionsViewer';
  /** #rest #virtual */
  userResources?: Maybe<TeamPermissionsResourceRights>;
  /** #paginated #rest #virtual */
  resources?: Maybe<TeamPermissionsResourceRightsConnection>;
  /** #rest #virtual */
  userResource?: Maybe<TeamPermissionsResourceRight>;
};


export type TeamPermissionsViewerUserResourcesArgs = {
  resourceType: TeamPermissionsResourceType;
  permissions?: Maybe<Scalars['String']>;
  types?: Maybe<Scalars['String']>;
};


export type TeamPermissionsViewerResourcesArgs = {
  resourceType: TeamPermissionsResourceType;
  permissions?: Maybe<Scalars['String']>;
  types?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


export type TeamPermissionsViewerUserResourceArgs = {
  resourceType: TeamPermissionsResourceType;
  resourceId: Scalars['ID'];
  permissions?: Maybe<Scalars['String']>;
};

export type TemplateData = {
  __typename?: 'TemplateData';
  /** #logged-out #soft-logged-in */
  sectionTitleColor?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  genericDescription?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companyDescriptionTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  companyDescriptionContent?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  responsibilityTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  responsibilityContent?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  skillsTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  skillsContent?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  weOfferTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  weOfferContent?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  contactInfoTitle?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  contactInfoContent?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  headerImage?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  footerImage?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  videoUrls?: Maybe<TemplateDataVideoUrls>;
  /** #logged-out #soft-logged-in */
  socialUrls?: Maybe<TemplateDataSocialUrls>;
};

export enum TemplateDataFormat {
  Html = 'HTML',
  Markdown = 'MARKDOWN'
}

export type TemplateDataSocialUrls = {
  __typename?: 'TemplateDataSocialUrls';
  /** #logged-out #soft-logged-in */
  website?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  facebook?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  twitter?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  youtube?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  xing?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  instagram?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  pinterest?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  tiktok?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  kununu?: Maybe<Scalars['String']>;
};

export type TemplateDataVideoUrls = {
  __typename?: 'TemplateDataVideoUrls';
  /** #logged-out #soft-logged-in */
  youtube?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  vimeo?: Maybe<Scalars['String']>;
};

export type TextCustomQuestion = BaseApplyQuestion & {
  __typename?: 'TextCustomQuestion';
  /** #logged-out #soft-logged-in */
  multiline?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  maxLength?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

export type TextResourceKeys = {
  __typename?: 'TextResourceKeys';
  /** A text resource available in notification setting */
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** Simple text setting, usually represented as a input text box */
export type TextSetting = HasGlobalId & {
  __typename?: 'TextSetting';
  /** #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #soft-logged-in */
  value?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type TextSettingInput = {
  value: Scalars['String'];
};

export enum TimeFrameFilterOptions {
  SevenDays = 'SEVEN_DAYS',
  ThirtyDays = 'THIRTY_DAYS',
  NinetyDays = 'NINETY_DAYS'
}

export type TimeInCurrentPosition = {
  __typename?: 'TimeInCurrentPosition';
  id: Scalars['ID'];
  amount: Scalars['Int'];
  xtmUrl: Scalars['URL'];
  avatars: Array<Maybe<Scalars['URL']>>;
};

export type TimeInCurrentPositionInsight = {
  __typename?: 'TimeInCurrentPositionInsight';
  medianTimeInCurrentPosition: Scalars['String'];
  medianTimeInCurrentPositionCandidates: Scalars['Int'];
  xtmUrl: Scalars['URL'];
  stats: Array<Maybe<TimeInCurrentPosition>>;
};

/** Simple toggle setting, usually represented as a checkbox */
export type ToggleSetting = HasGlobalId & {
  __typename?: 'ToggleSetting';
  value: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
  /** Globally unique id for this instance */
  globalId: Scalars['GlobalID'];
};

export type ToggleSettingInput = {
  value: Scalars['Boolean'];
};

export type TopCompaniesByCityCollection = {
  __typename?: 'TopCompaniesByCityCollection';
  /** #expand #logged-out #soft-logged-in */
  collection: Array<Maybe<TopCompanyByCity>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export type TopCompaniesCollection = {
  __typename?: 'TopCompaniesCollection';
  /** #expand #logged-out #soft-logged-in */
  collection: Array<Maybe<TopCompany>>;
  /** #logged-out #soft-logged-in */
  total: Scalars['Int'];
};

export type TopCompaniesElement = {
  __typename?: 'TopCompaniesElement';
  company?: Maybe<Company>;
  total: Scalars['Int'];
};

export type TopCompany = {
  __typename?: 'TopCompany';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
};

export type TopCompanyByCity = {
  __typename?: 'TopCompanyByCity';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  company?: Maybe<Company>;
};

export type TopIndustriesElement = {
  __typename?: 'TopIndustriesElement';
  industryId: Scalars['ID'];
  /** #rest(batched) #virtual */
  industry?: Maybe<Industry>;
  total: Scalars['Int'];
};

export type TopRecruiter = {
  __typename?: 'TopRecruiter';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /** #logged-out #soft-logged-in #rest #virtual */
  profileWorkExperience?: Maybe<ProfileWorkExperienceCollection>;
  /** #logged-out #soft-logged-in #rest #virtual */
  hiringProfile?: Maybe<HiringProfile>;
};

export type TopRecruitersCollection = {
  __typename?: 'TopRecruitersCollection';
  /** #logged-out #soft-logged-in */
  collection?: Maybe<Array<Maybe<TopRecruiter>>>;
};

export type Topics = {
  __typename?: 'Topics';
  /** #logged-out #soft-logged-in */
  name?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  label?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  subjects?: Maybe<Array<Maybe<Subjects>>>;
};

export type TppCandidateNotification = Notification & {
  __typename?: 'TppCandidateNotification';
  /** #rest(batched) #virtual */
  object?: Maybe<JobResult>;
  id: Scalars['ID'];
  urn: Scalars['URN'];
  publishedAt: Scalars['Date'];
  seen: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  interacted: Scalars['Boolean'];
  aggregated: Scalars['Boolean'];
  trackingToken?: Maybe<Scalars['String']>;
};

export type TrackingError = {
  __typename?: 'TrackingError';
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type TrackingResult = {
  __typename?: 'TrackingResult';
  success?: Maybe<TrackingSuccess>;
  error?: Maybe<TrackingError>;
};

export enum TrackingSource {
  Stan = 'STAN',
  UserLocation = 'USER_LOCATION',
  StreamTrack = 'STREAM_TRACK',
  Itjfm = 'ITJFM',
  Messages = 'MESSAGES',
  SearchKeywords = 'SEARCH_KEYWORDS',
  Calendar = 'CALENDAR'
}

export type TrackingSuccess = {
  __typename?: 'TrackingSuccess';
  message?: Maybe<Scalars['String']>;
};

/** Represents a tracking variable, name/value pair */
export type TrackingVariable = {
  __typename?: 'TrackingVariable';
  /** #soft-logged-in */
  name: Scalars['String'];
  /** #soft-logged-in */
  value: Scalars['String'];
};

export type Tracy = {
  __typename?: 'Tracy';
  profileQualityIndex?: Maybe<TracyProfileQualityIndex>;
  willingnessToChangeJobs?: Maybe<TracyWillingnessToChangeJobs>;
};

export type TracyProfileQualityIndex = {
  __typename?: 'TracyProfileQualityIndex';
  overall?: Maybe<TracyProfileQualityIndexScore>;
};

export type TracyProfileQualityIndexScore = {
  __typename?: 'TracyProfileQualityIndexScore';
  score?: Maybe<Scalars['Float']>;
  qualityClass?: Maybe<Scalars['String']>;
};

export type TracyWillingnessToChangeJobs = {
  __typename?: 'TracyWillingnessToChangeJobs';
  probability?: Maybe<Scalars['Float']>;
  reasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  class?: Maybe<TracyWillingnessToChangeJobsClass>;
};

/** Willingness to change jobs available classes */
export enum TracyWillingnessToChangeJobsClass {
  /** low */
  Low = 'LOW',
  /** medium */
  Medium = 'MEDIUM',
  /** high */
  High = 'HIGH'
}

export type TriggerJobsEasyCreateAiJobGenerationInput = {
  jobTitle: Scalars['String'];
  companyName: Scalars['String'];
  language: Scalars['String'];
  writingTone?: Maybe<Scalars['String']>;
  writingForm?: Maybe<Scalars['String']>;
  writingStyle?: Maybe<Scalars['String']>;
};

export type TriggerJobsEasyCreateAiJobGenerationResult = TriggerJobsEasyCreateAiJobGenerationSuccess | JobsEasyCreateAiJobGenerationError;

export type TriggerJobsEasyCreateAiJobGenerationSuccess = {
  __typename?: 'TriggerJobsEasyCreateAIJobGenerationSuccess';
  /** #logged-out #soft-logged-in */
  status: JobsEasyCreateAiJobGenerationPollStatus;
  /** #logged-out #soft-logged-in */
  jobId: Scalars['String'];
  /** #logged-out #soft-logged-in */
  result?: Maybe<JobsEasyCreateAiJobGenerationSuccess>;
};

export type TriggerJobsEasyCreateEcomPurchaseInput = {
  orderNumber: Scalars['String'];
  productType: JobsEasyCreateProductType;
  clientId?: Maybe<Scalars['ID']>;
  variant?: Maybe<Scalars['String']>;
};

export type TriggerJobsEasyCreateEcomPurchaseResult = TriggerJobsEasyCreateEcomPurchaseSuccess | JobsEasyCreateEcomPurchaseError;

export type TriggerJobsEasyCreateEcomPurchaseSuccess = {
  __typename?: 'TriggerJobsEasyCreateEcomPurchaseSuccess';
  /** #logged-out #soft-logged-in */
  status: JobsEasyCreateEcomPurchasePollStatus;
  /** #logged-out #soft-logged-in */
  jobId: Scalars['String'];
  /** #logged-out #soft-logged-in */
  result?: Maybe<JobsEasyCreateEcomPurchaseSuccess>;
};

export type TwoFaSettings = HasGlobalId & {
  __typename?: 'TwoFaSettings';
  method: TwoFaSettingsMethod;
  /** Globally unique id for this instance */
  globalId: Scalars['GlobalID'];
};

export type TwoFaSettingsActivationInput = {
  /** one-time code either generated by authenticator app, or received using SMS */
  code: Scalars['String'];
};

export type TwoFaSettingsActivationResult = {
  __typename?: 'TwoFaSettingsActivationResult';
  success?: Maybe<TwoFaSettingsBackupCode>;
  error?: Maybe<LoginSettingsError>;
};

export type TwoFaSettingsBackupCode = {
  __typename?: 'TwoFaSettingsBackupCode';
  backupCode: Scalars['String'];
};

export type TwoFaSettingsBackupCodeRegenerationInput = {
  passwordToken: Scalars['String'];
};

export type TwoFaSettingsBackupCodeRegenerationResult = {
  __typename?: 'TwoFaSettingsBackupCodeRegenerationResult';
  success?: Maybe<TwoFaSettingsBackupCode>;
  error?: Maybe<LoginSettingsError>;
};

export enum TwoFaSettingsMethod {
  None = 'NONE',
  Sms = 'SMS',
  Authenticator = 'AUTHENTICATOR'
}

export type TwoFaSettingsUpdate = {
  __typename?: 'TwoFaSettingsUpdate';
  method: TwoFaSettingsMethod;
  /** Returned to the user in authenticator case so that QR code can be displayed */
  totpUrl?: Maybe<Scalars['String']>;
};

export type TwoFaSettingsUpdateInput = {
  method: TwoFaSettingsMethod;
  passwordToken: Scalars['String'];
};

export type TwoFaSettingsUpdateResult = {
  __typename?: 'TwoFaSettingsUpdateResult';
  success?: Maybe<TwoFaSettingsUpdate>;
  error?: Maybe<LoginSettingsError>;
};




export type UnauthorizedJob = {
  __typename?: 'UnauthorizedJob';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  reason: UnauthorizedJobReason;
};

export enum UnauthorizedJobReason {
  Private = 'PRIVATE',
  Projobs = 'PROJOBS'
}

export type UnconfirmedContactsFeature = {
  __typename?: 'UnconfirmedContactsFeature';
  /** #soft-logged-in */
  limit?: Maybe<Scalars['Int']>;
};

/**
 * Represents a type that can be retrieved by a URL.
 *
 * Copied from [GitHub's GraphQL API](https://docs.github.com/en/graphql/reference/interfaces#uniformresourcelocatable)
 */
export type UniformResourceLocatable = {
  /** The full `URL` to this resource */
  url: Scalars['URL'];
};

/** Represents a type that can be represented by a URN. For example urn:x-xing:communities:group:1234 */
export type UniformResourceNameable = {
  /** The `URN` for a resource, e.g. urn:x-xing:communities:group:1234 */
  urn: Scalars['URN'];
};

/** Available params for company search */
export type UniversalSearchCompanyQueryInput = {
  /** Request consumer, used for tracking and analysis purposes */
  consumer: Scalars['String'];
  /** Free text search for keywords */
  keywords?: Maybe<Scalars['String']>;
  queries?: Maybe<CompanyQueriesInput>;
  /** Params expected for highlight input are documented in HighlightInput field */
  highlight?: Maybe<HighlightInput>;
  filters?: Maybe<CompanyFiltersInput>;
  aggregations?: Maybe<CompanyAggregationsInput>;
  /** timeout for Elasticsearch call */
  timeout?: Maybe<Scalars['Int']>;
};

export type UniversalSearchCompanyResult = {
  __typename?: 'UniversalSearchCompanyResult';
  trackingToken: Scalars['String'];
  position: Scalars['Int'];
  score: Scalars['Float'];
  /** #rest(batched) #virtual */
  company?: Maybe<Company>;
  highlight?: Maybe<HighlightResultCompany>;
};

export type UniversalSearchGroupQueryInput = {
  /**
   * Available params for group search
   * keywords: Free text search for keywords
   * timeout: timeout for Elasticsearch call
   */
  consumer: Scalars['String'];
  keywords?: Maybe<Scalars['String']>;
  filters?: Maybe<GroupFiltersInput>;
  aggregations?: Maybe<GroupAggregationsInput>;
  timeout?: Maybe<Scalars['Int']>;
};

export type UniversalSearchGroupResult = HasTrackingToken & {
  __typename?: 'UniversalSearchGroupResult';
  position?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Float']>;
  /** @deprecated Groups are going to be shutdown at the end of 2022. This field will stop working on 01/01/2023. */
  group?: Maybe<Community>;
  /**
   * #soft-logged-in
   *
   *  Tracking token generated by predictive search service to track responses. Used for DS tracking
   */
  trackingToken: Scalars['String'];
};

export type UniversalSearchNewsQueryInput = {
  /**
   * Available params for News search
   * keywords: Free text search for keywords
   * timeout: timeout for Elasticsearch call
   */
  consumer: Scalars['String'];
  keywords?: Maybe<Scalars['String']>;
  filters?: Maybe<NewsFiltersInput>;
  aggregations?: Maybe<NewsAggregationsInput>;
  timeout?: Maybe<Scalars['Int']>;
};

export type UniversalSearchNewsResult = {
  trackingToken: Scalars['String'];
  position: Scalars['Int'];
  score: Scalars['Float'];
  urn?: Maybe<Scalars['URN']>;
};

/** UnpreferredPositionsPreference Type */
export type UnpreferredPositionsPreference = {
  __typename?: 'UnpreferredPositionsPreference';
  unpreferredPositions: Array<Maybe<JobTitleItem>>;
};

export type UpdateB2BProfileSettingsMutationResult = {
  __typename?: 'UpdateB2BProfileSettingsMutationResult';
  success?: Maybe<B2BProfileSettingsSuccess>;
  error?: Maybe<B2BProfileSettingsError>;
};

export type UpdateBlockedCompaniesError = {
  __typename?: 'UpdateBlockedCompaniesError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdateBlockedCompaniesInput = {
  companyIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/** Result type for updating blocked companies that returns 204 on success */
export type UpdateBlockedCompaniesResult = UpdateBlockedCompaniesSuccess | UpdateBlockedCompaniesError;

export type UpdateBlockedCompaniesSuccess = {
  __typename?: 'UpdateBlockedCompaniesSuccess';
  /** #rest(batched) #virtual */
  companies: Array<Maybe<Company>>;
};

export type UpdateBpayPaymentMethodResult = DirectDebitData | InvoiceData | DirectDebitDataError | ErrorResponse;

export type UpdateBriefingError = {
  __typename?: 'UpdateBriefingError';
  message: Scalars['String'];
  errors: Array<Maybe<Scalars['String']>>;
};

export type UpdateBriefingResult = UpdateBriefingSuccess | UpdateBriefingError;

export type UpdateBriefingSuccess = {
  __typename?: 'UpdateBriefingSuccess';
  briefing: Briefing;
};

export type UpdateCareerLevelPreferenceError = {
  __typename?: 'UpdateCareerLevelPreferenceError';
  /**
   * #logged-out #soft-logged-in
   *
   *  tells what went wrong
   */
  message?: Maybe<Scalars['String']>;
};

export type UpdateCareerLevelPreferenceInput = {
  /** Max prefered career level */
  maximum?: Maybe<Scalars['Int']>;
  /** Min prefered career level */
  minimum?: Maybe<Scalars['Int']>;
  /** A string identifying the conceptual user flow from which originates, for example, CoolNewCampaignFlow */
  flowIdentifier?: Maybe<Scalars['String']>;
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this originates from */
  source?: Maybe<Scalars['String']>;
};

/** Result type for updating career level preference that returns 200 on success */
export type UpdateCareerLevelPreferenceResult = UpdateCareerLevelPreferenceSuccess | UpdateCareerLevelPreferenceError;

export type UpdateCareerLevelPreferenceSuccess = {
  __typename?: 'UpdateCareerLevelPreferenceSuccess';
  /** #logged-out #soft-logged-in */
  minimum?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  maximum?: Maybe<Scalars['Int']>;
};

export type UpdateClientBillingAddressResult = {
  __typename?: 'UpdateClientBillingAddressResult';
  error?: Maybe<ErrorResponse>;
  response?: Maybe<ClientBillingAddress>;
};

export type UpdateDisciplinesPreferenceError = {
  __typename?: 'UpdateDisciplinesPreferenceError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdateDisciplinesPreferenceInput = {
  disciplineIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/** Result type for updating disciplines that returns 204 on success */
export type UpdateDisciplinesPreferenceResult = UpdateDisciplinesPreferenceSuccess | UpdateDisciplinesPreferenceError;

export type UpdateDisciplinesPreferenceSuccess = {
  __typename?: 'UpdateDisciplinesPreferenceSuccess';
  value?: Maybe<Scalars['String']>;
};

export type UpdateEmployersPreferenceError = {
  __typename?: 'UpdateEmployersPreferenceError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdateEmployersPreferenceInput = {
  /** List of company ids that user prefers as a potential employer */
  companyIds: Array<Maybe<Scalars['ID']>>;
  /** A string identifying the conceptual user flow from which originates, for example, CoolNewCampaignFlow */
  flowIdentifier?: Maybe<Scalars['String']>;
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this originates from */
  source?: Maybe<Scalars['String']>;
};

/** Result type for updating preferred employers for 204 success */
export type UpdateEmployersPreferenceResult = UpdateEmployersPreferenceSuccess | UpdateEmployersPreferenceError;

/** Result type for updating preferred employers successfully */
export type UpdateEmployersPreferenceSuccess = {
  __typename?: 'UpdateEmployersPreferenceSuccess';
  /** #rest(batched) #virtual */
  companies: Array<Maybe<Company>>;
};

export type UpdateHiringProfileError = {
  __typename?: 'UpdateHiringProfileError';
  message?: Maybe<Scalars['String']>;
  errors?: Maybe<UpdateHiringProfileErrors>;
};

export type UpdateHiringProfileErrors = {
  __typename?: 'UpdateHiringProfileErrors';
  hiringQuestionTimestamp?: Maybe<Array<Scalars['String']>>;
  hiringCities?: Maybe<Array<Scalars['String']>>;
  hiringCompanies?: Maybe<Array<Scalars['String']>>;
  hiringDisciplines?: Maybe<Array<Scalars['String']>>;
  hiringJobPostings?: Maybe<Array<Scalars['String']>>;
  hiringJobRoles?: Maybe<Array<Scalars['String']>>;
  hiringSkills?: Maybe<Array<Scalars['String']>>;
  hiringSpotlightSummary?: Maybe<Array<Scalars['String']>>;
  hiringWorkplace?: Maybe<Array<Scalars['String']>>;
};

export type UpdateHiringProfileInput = {
  hiringQuestionTimestamp?: Maybe<Scalars['Date']>;
  hiringCities?: Maybe<Array<Maybe<HiringEntityInput>>>;
  hiringCompanies?: Maybe<Array<Maybe<HiringEntityInput>>>;
  hiringDisciplines?: Maybe<Array<Maybe<HiringEntityInput>>>;
  hiringJobPostings?: Maybe<Array<Maybe<HiringEntityInput>>>;
  hiringJobRoles?: Maybe<Array<Maybe<HiringJobRolesInput>>>;
  hiringSkills?: Maybe<Array<Maybe<HiringSkillsInput>>>;
  hiringSpotlightSummary?: Maybe<HiringSpotLightSummaryInput>;
  hiringWorkplace?: Maybe<HiringWorkplaceInput>;
};

export type UpdateHiringProfileResult = HiringProfile | UpdateHiringProfileError;

export type UpdateIndustriesPreferenceError = {
  __typename?: 'UpdateIndustriesPreferenceError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdateIndustriesPreferenceInput = {
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  openToOtherIndustries?: Maybe<Scalars['Boolean']>;
  /** A string identifying the conceptual user flow from which originates, for example, CoolNewCampaignFlow */
  flowIdentifier?: Maybe<Scalars['String']>;
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this originates from */
  source?: Maybe<Scalars['String']>;
};

/** Result type for updating industries preference that returns 200 on success */
export type UpdateIndustriesPreferenceResult = UpdateIndustriesPreferenceSuccess | UpdateIndustriesPreferenceError;

export type UpdateIndustriesPreferenceSuccess = {
  __typename?: 'UpdateIndustriesPreferenceSuccess';
  /** #rest(batched) #virtual */
  industries: Array<Maybe<Industry>>;
  openToOtherIndustries?: Maybe<Scalars['Boolean']>;
};

export type UpdateJobPreferenceUserFlagsError = {
  __typename?: 'UpdateJobPreferenceUserFlagsError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdateJobPreferenceUserFlagsInput = {
  serpBannerHidden?: Maybe<Scalars['Boolean']>;
};

/** Result type for updating job preference user flags that returns 200 on success */
export type UpdateJobPreferenceUserFlagsResult = UpdateJobPreferenceUserFlagsSuccess | UpdateJobPreferenceUserFlagsError;

export type UpdateJobPreferenceUserFlagsSuccess = {
  __typename?: 'UpdateJobPreferenceUserFlagsSuccess';
  serpBannerHidden: Scalars['Boolean'];
};

export type UpdateJobPreferencesJobSeekerStatusError = {
  __typename?: 'UpdateJobPreferencesJobSeekerStatusError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdateJobPreferencesJobSeekerStatusInput = {
  status: PreferenceSeekingStatus;
};

/** Result type for updating job seeker status that returns 204 on success */
export type UpdateJobPreferencesJobSeekerStatusResult = UpdateJobPreferencesJobSeekerStatusSuccess | UpdateJobPreferencesJobSeekerStatusError;

export type UpdateJobPreferencesJobSeekerStatusSuccess = {
  __typename?: 'UpdateJobPreferencesJobSeekerStatusSuccess';
  status: PreferenceSeekingStatus;
};

export type UpdateJobTitlesTargetPositionsPreferenceError = {
  __typename?: 'UpdateJobTitlesTargetPositionsPreferenceError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdateJobTitlesTargetPositionsPreferenceInput = {
  targetPositions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A string identifying the conceptual user flow from which originates, for example, CoolNewCampaignFlow */
  flowIdentifier?: Maybe<Scalars['String']>;
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this originates from */
  source?: Maybe<Scalars['String']>;
};

/** Result type for updating job titles target positions that returns 204 on success */
export type UpdateJobTitlesTargetPositionsPreferenceResult = UpdateJobTitlesTargetPositionsPreferenceSuccess | UpdateJobTitlesTargetPositionsPreferenceError;

export type UpdateJobTitlesTargetPositionsPreferenceSuccess = {
  __typename?: 'UpdateJobTitlesTargetPositionsPreferenceSuccess';
  value?: Maybe<Scalars['String']>;
  targetPositions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateJobTitlesUnpreferredPositionsPreferenceError = {
  __typename?: 'UpdateJobTitlesUnpreferredPositionsPreferenceError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdateJobTitlesUnpreferredPositionsPreferenceInput = {
  unpreferredPositions?: Maybe<Array<Maybe<JobTitlesUnpreferredPositionsInput>>>;
  /** A string identifying the conceptual user flow from which originates, for example, CoolNewCampaignFlow */
  flowIdentifier?: Maybe<Scalars['String']>;
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this originates from */
  source?: Maybe<Scalars['String']>;
};

/** Result type for updating job titles unpreferred positions that returns 204 on success */
export type UpdateJobTitlesUnpreferredPositionsPreferenceResult = UpdateJobTitlesUnpreferredPositionsPreferenceSuccess | UpdateJobTitlesUnpreferredPositionsPreferenceError;

export type UpdateJobTitlesUnpreferredPositionsPreferenceSuccess = {
  __typename?: 'UpdateJobTitlesUnpreferredPositionsPreferenceSuccess';
  value?: Maybe<Scalars['String']>;
  unpreferredPositions?: Maybe<Array<Maybe<JobTitleItem>>>;
};

export type UpdateJobWishesIdealEmployersError = {
  __typename?: 'UpdateJobWishesIdealEmployersError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdateJobWishesIdealEmployersInput = {
  idealEmployerIds: Array<Maybe<Scalars['ID']>>;
};

/** Result type for updating ideal employers that returns 204 on success */
export type UpdateJobWishesIdealEmployersResult = UpdateJobWishesIdealEmployersSuccess | UpdateJobWishesIdealEmployersError;

export type UpdateJobWishesIdealEmployersSuccess = {
  __typename?: 'UpdateJobWishesIdealEmployersSuccess';
  value?: Maybe<Scalars['String']>;
};

export type UpdateLocationsPreferenceError = {
  __typename?: 'UpdateLocationsPreferenceError';
  /**
   * #logged-out #soft-logged-in
   *
   *  tells what went wrong
   */
  message?: Maybe<Scalars['String']>;
};

export type UpdateLocationsPreferenceInput = {
  cities: Array<Maybe<Scalars['ID']>>;
  maxDistance?: Maybe<Scalars['Int']>;
  willingnessToTravelPercentage?: Maybe<UpdateWillingnessToTravelEnum>;
  /** A string identifying the conceptual user flow from which originates, for example, CoolNewCampaignFlow */
  flowIdentifier?: Maybe<Scalars['String']>;
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this originates from */
  source?: Maybe<Scalars['String']>;
};

/** Result type for updating locations preference that returns 200 on success */
export type UpdateLocationsPreferenceResult = UpdateLocationsPreferenceSuccess | UpdateLocationsPreferenceError;

export type UpdateLocationsPreferenceSuccess = {
  __typename?: 'UpdateLocationsPreferenceSuccess';
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  cities: Array<Maybe<City>>;
  /** #logged-out #soft-logged-in */
  maxDistance?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  willingnessToTravel?: Maybe<GetWillingnessToTravelEnum>;
};

export type UpdateMessengerBannerError = {
  __typename?: 'UpdateMessengerBannerError';
  message: Scalars['String'];
};

export type UpdateMessengerBannerInput = {
  chatId?: Maybe<Scalars['ID']>;
  name: MessengerBannerType;
  userAction: MessengerBannerAction;
};

export type UpdateMessengerBannerResult = UpdateMessengerBannerSuccess | UpdateMessengerBannerError;

export type UpdateMessengerBannerSuccess = {
  __typename?: 'UpdateMessengerBannerSuccess';
  success: Scalars['Boolean'];
};

export type UpdateMessengerMessageTemplateError = {
  __typename?: 'UpdateMessengerMessageTemplateError';
  message: Scalars['String'];
};

export type UpdateMessengerMessageTemplateInput = {
  id: Scalars['ID'];
  title: Scalars['String'];
  body: Scalars['String'];
};

export type UpdateMessengerMessageTemplateResult = UpdateMessengerMessageTemplateSuccess | UpdateMessengerMessageTemplateError;

export type UpdateMessengerMessageTemplateSuccess = {
  __typename?: 'UpdateMessengerMessageTemplateSuccess';
  success: MessengerMessageTemplatesInterface;
};

export type UpdatePaymentsB2bClientIdError = {
  __typename?: 'UpdatePaymentsB2bClientIdError';
  /** #logged-out #soft-logged-in */
  error: Scalars['String'];
  /** #logged-out #soft-logged-in */
  message: Scalars['String'];
};

export type UpdatePaymentsB2bClientIdInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  street: Scalars['String'];
  postcode: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  vatId: Scalars['String'];
  email: Scalars['String'];
  salesforceId?: Maybe<Scalars['String']>;
};

export type UpdatePaymentsB2bClientIdResult = UpdatePaymentsB2bClientIdError;

export type UpdatePaymentsB2bClientIdSuccess = {
  __typename?: 'UpdatePaymentsB2bClientIdSuccess';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
};

export type UpdatePreferencesSettingsBlockedCompaniesError = {
  __typename?: 'UpdatePreferencesSettingsBlockedCompaniesError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdatePreferencesSettingsBlockedCompaniesInput = {
  companyIds: Array<Maybe<Scalars['ID']>>;
};

/** Result type for updating blocked companies that returns 204 on success */
export type UpdatePreferencesSettingsBlockedCompaniesResult = UpdatePreferencesSettingsBlockedCompaniesSuccess | UpdatePreferencesSettingsBlockedCompaniesError;

export type UpdatePreferencesSettingsBlockedCompaniesSuccess = {
  __typename?: 'UpdatePreferencesSettingsBlockedCompaniesSuccess';
  value?: Maybe<Scalars['String']>;
};

export type UpdateProfileModuleStoreItemsError = {
  __typename?: 'UpdateProfileModuleStoreItemsError';
  moduleIdentifier: ProfileModuleIdentifier;
  messages?: Maybe<Array<Scalars['String']>>;
};

export type UpdateProfileModuleStoreItemsInput = {
  isActive: Scalars['Boolean'];
  moduleIdentifier: ProfileModuleIdentifier;
};

export type UpdateProfileModuleStoreItemsResult = {
  __typename?: 'UpdateProfileModuleStoreItemsResult';
  success?: Maybe<Array<ProfileModuleStoreItem>>;
  error?: Maybe<Array<UpdateProfileModuleStoreItemsError>>;
};

export type UpdateReport400Error = {
  __typename?: 'UpdateReport400Error';
  /** #logged-out #soft-logged-in */
  errors?: Maybe<UpdateReportErrorMessages>;
};

export type UpdateReport403Error = {
  __typename?: 'UpdateReport403Error';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
};

export type UpdateReportErrorMessages = {
  __typename?: 'UpdateReportErrorMessages';
  /** #logged-out #soft-logged-in */
  reasonKey?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateReportInput = {
  id: Scalars['ID'];
  reasonKey?: Maybe<Scalars['String']>;
  userComment?: Maybe<Scalars['String']>;
  reporterEmail?: Maybe<Scalars['String']>;
};

export type UpdateReportPutResult = UpdateReportResponse | UpdateReport400Error | UpdateReport403Error;

export type UpdateReportResponse = {
  __typename?: 'UpdateReportResponse';
  /** #logged-out #soft-logged-in */
  report?: Maybe<ComplaintsReport>;
};

export type UpdateSalaryExpectationsPreferenceError = {
  __typename?: 'UpdateSalaryExpectationsPreferenceError';
  /**
   * #logged-out #soft-logged-in
   *
   *  tells what went wrong
   */
  message?: Maybe<Scalars['String']>;
};

export type UpdateSalaryExpectationsPreferenceInput = {
  salaryExpectations?: Maybe<Scalars['Int']>;
  /** A string identifying the conceptual user flow from which originates, for example, CoolNewCampaignFlow */
  flowIdentifier?: Maybe<Scalars['String']>;
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this originates from */
  source?: Maybe<Scalars['String']>;
};

/** Result type for updating salary expectations preference that returns 200 on success */
export type UpdateSalaryExpectationsPreferenceResult = UpdateSalaryExpectationsPreferenceSuccess | UpdateSalaryExpectationsPreferenceError;

export type UpdateSalaryExpectationsPreferenceSuccess = {
  __typename?: 'UpdateSalaryExpectationsPreferenceSuccess';
  /** #logged-out #soft-logged-in */
  salaryExpectations?: Maybe<Scalars['Int']>;
};

export type UpdateWebPushSubscriptionError = {
  __typename?: 'UpdateWebPushSubscriptionError';
  /** #logged-out #soft-logged-in */
  message: Scalars['String'];
};

export type UpdateWebPushSubscriptionInput = {
  notificationEnv: Scalars['String'];
  visitorId: Scalars['String'];
  subscriptionStatus: Scalars['String'];
  url: Scalars['String'];
  authDetails: Scalars['String'];
  ellipticCurve: Scalars['String'];
  locale: Scalars['String'];
};

export type UpdateWebPushSubscriptionResult = WebPushSubscription | UpdateWebPushSubscriptionError;

export enum UpdateWillingnessToTravelEnum {
  None = 'NONE',
  Occasional = 'OCCASIONAL',
  Frequent = 'FREQUENT'
}

export type UpdateWorkingHoursPreferenceError = {
  __typename?: 'UpdateWorkingHoursPreferenceError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdateWorkingHoursPreferenceInput = {
  partTime: Scalars['Boolean'];
  fullTime: Scalars['Boolean'];
  /** A string identifying the conceptual user flow from which originates, for example, CoolNewCampaignFlow */
  flowIdentifier?: Maybe<Scalars['String']>;
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this originates from */
  source?: Maybe<Scalars['String']>;
};

/** Result type for updating working hours preference that returns 200 on success */
export type UpdateWorkingHoursPreferenceResult = UpdateWorkingHoursPreferenceSuccess | UpdateWorkingHoursPreferenceError;

export type UpdateWorkingHoursPreferenceSuccess = {
  __typename?: 'UpdateWorkingHoursPreferenceSuccess';
  fullTime: Scalars['Boolean'];
  partTime: Scalars['Boolean'];
};

export type UpdateWorkplacePreferenceError = {
  __typename?: 'UpdateWorkplacePreferenceError';
  /** tells what went wrong */
  message?: Maybe<Scalars['String']>;
};

export type UpdateWorkplacePreferenceInput = {
  office: Scalars['Boolean'];
  partlyHome: Scalars['Boolean'];
  mostlyHome: Scalars['Boolean'];
  homeOffice: Scalars['Boolean'];
  /** A string identifying the conceptual user flow from which originates, for example, CoolNewCampaignFlow */
  flowIdentifier?: Maybe<Scalars['String']>;
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this originates from */
  source?: Maybe<Scalars['String']>;
};

/** Result type for updating workplace that returns 200 on success */
export type UpdateWorkplacePreferenceResult = UpdateWorkplacePreferenceSuccess | UpdateWorkplacePreferenceError;

export type UpdateWorkplacePreferenceSuccess = {
  __typename?: 'UpdateWorkplacePreferenceSuccess';
  office: Scalars['Boolean'];
  partlyHome: Scalars['Boolean'];
  mostlyHome: Scalars['Boolean'];
  homeOffice: Scalars['Boolean'];
};

/**
 * Represents an upload that has been created at the upload service.
 * It contains the information that a client would need to push data
 * to that upload.
 */
export type Upload = {
  __typename?: 'Upload';
  /**
   * #logged-out #soft-logged-in
   *
   *  The id of the upload. This can be used to retrieve the file from the internal API.
   * The client should pass this to whoever is going to process the upload.
   */
  id?: Maybe<Scalars['UploadId']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  An Authorization token for this specific upload.
   * This has to be sent in the `Authorization` HTTP header by the client
   * with every request to the upload service that belongs to this upload.
   */
  authToken?: Maybe<Scalars['UploadAuthToken']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  The URL that the client can use to upload the file.
   */
  url?: Maybe<Scalars['URL']>;
};

/**
 * The application that an upload is intended for.
 * Usually this is the application as described in the XING project metdata.
 */
export enum UploadApplication {
  StartPage = 'START_PAGE',
  Profile = 'PROFILE',
  Postings = 'POSTINGS',
  EntityPages = 'ENTITY_PAGES',
  Jobs = 'JOBS',
  Events = 'EVENTS',
  Articles = 'ARTICLES',
  Messenger = 'MESSENGER',
  Projobs = 'PROJOBS',
  CvUpload = 'CV_UPLOAD',
  SupportPages = 'SUPPORT_PAGES',
  VitaLebenslauf = 'VITA_LEBENSLAUF'
}



export type UploadRequestError = {
  __typename?: 'UploadRequestError';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type UploadRequestInput = {
  /** The application that this upload is intended for */
  application: UploadApplication;
  /** The size of the uploaded file in bytes */
  fileSize: Scalars['Long'];
  /** The MIME type of the file */
  fileType?: Maybe<Scalars['String']>;
  /** The file name */
  fileName?: Maybe<Scalars['String']>;
};

export type UploadRequestPayload = {
  __typename?: 'UploadRequestPayload';
  /** #logged-out #soft-logged-in */
  error?: Maybe<UploadRequestError>;
  /** #logged-out #soft-logged-in */
  success?: Maybe<Upload>;
};

export type UpsellAndroidCampaignOffer = {
  __typename?: 'UpsellAndroidCampaignOffer';
  campaignId: Scalars['ID'];
  campaignType: Scalars['String'];
  marketingId: Scalars['String'];
  offers: Array<UpsellAndroidOffer>;
};

export type UpsellAndroidOffer = {
  __typename?: 'UpsellAndroidOffer';
  productId: Scalars['String'];
  highlighted: Scalars['Boolean'];
};

export type UpsellCancellationAcceptCounterOfferApplyBonus = {
  applyBonus?: Maybe<Scalars['String']>;
};

export type UpsellCancellationAcceptCounterOfferResult = UpsellCancellationAcceptCounterOfferResultSuccess | UpsellMutationError;

export type UpsellCancellationAcceptCounterOfferResultSuccess = {
  __typename?: 'UpsellCancellationAcceptCounterOfferResultSuccess';
  message?: Maybe<Scalars['String']>;
};

export type UpsellCancellationRequestInput = {
  product: UpsellProduct;
  reasonIdentifier: Scalars['String'];
  reasonNote: Scalars['String'];
  isExtraordinary: Scalars['Boolean'];
};

export type UpsellCancellationRequestResult = UpsellCancellationRequestSuccess | UpsellMutationError;

export type UpsellCancellationRequestSuccess = {
  __typename?: 'UpsellCancellationRequestSuccess';
  product: UpsellProduct;
  remainingProduct?: Maybe<UpsellProduct>;
  endDate?: Maybe<Scalars['Date']>;
  reasonIdentifier: Scalars['String'];
  reasonNote: Scalars['String'];
  isExtraordinary: Scalars['Boolean'];
};

export type UpsellCancellationStatus = {
  __typename?: 'UpsellCancellationStatus';
  product: UpsellProduct;
  remainingProduct?: Maybe<UpsellProduct>;
  endDate?: Maybe<Scalars['Date']>;
  isEligibleForCounterOffer: Scalars['Boolean'];
};

export type UpsellIosCampaignOffer = {
  __typename?: 'UpsellIosCampaignOffer';
  campaignId: Scalars['ID'];
  campaignType: Scalars['String'];
  marketingId: Scalars['String'];
  offers: Array<UpsellIosOffer>;
};

export type UpsellIosOffer = {
  __typename?: 'UpsellIosOffer';
  productId: Scalars['String'];
  highlighted: Scalars['Boolean'];
  offerType: UpsellIosOfferType;
  offerId?: Maybe<Scalars['String']>;
  signatureData?: Maybe<UpsellIosSignatureData>;
};

/** The different types of iOS offers */
export enum UpsellIosOfferType {
  Intro = 'INTRO',
  Promo = 'PROMO',
  Regular = 'REGULAR'
}

export type UpsellIosSignatureData = {
  __typename?: 'UpsellIosSignatureData';
  offerId: Scalars['String'];
  base64Signature: Scalars['String'];
  nonce: Scalars['String'];
  timestamp: Scalars['Long'];
  keyId: Scalars['String'];
  userName: Scalars['String'];
};

export type UpsellMutationError = {
  __typename?: 'UpsellMutationError';
  errors: Scalars['String'];
};

export enum UpsellProduct {
  Premium = 'premium',
  Projobs = 'projobs'
}

export type UrlApplication = {
  __typename?: 'UrlApplication';
  /** #logged-out #soft-logged-in */
  applyUrl?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  scrambledApplyUrl?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type UserCommenter = {
  __typename?: 'UserCommenter';
  userId?: Maybe<Scalars['ID']>;
  urn?: Maybe<Scalars['GlobalID']>;
  socialType?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
};

export type UserConnectionData = {
  __typename?: 'UserConnectionData';
  clientId: Scalars['Int'];
  clientName: Scalars['String'];
};

export type UserDataInquiry = {
  __typename?: 'UserDataInquiry';
  createdAt?: Maybe<Scalars['Date']>;
  status?: Maybe<UserDataInquiryStatus>;
  /** Download size in bytes */
  downloadSize?: Maybe<Scalars['Long']>;
  /** Extra bundles that are not included in the users data disclosure */
  extraBundles?: Maybe<Array<UserDataInquiryBundle>>;
  /** Warning or info message */
  notificationMessage?: Maybe<Scalars['String']>;
  notificationType?: Maybe<UserDataInquiryNotificationType>;
};

export type UserDataInquiryBundle = {
  __typename?: 'UserDataInquiryBundle';
  /** Application identifier */
  name?: Maybe<Scalars['String']>;
  /** Translated description including application name and purpose */
  label?: Maybe<Scalars['String']>;
  status: UserDataInquiryStatus;
};

export type UserDataInquiryBundleDownloadUrl = {
  __typename?: 'UserDataInquiryBundleDownloadUrl';
  /** Application identifier */
  name?: Maybe<Scalars['String']>;
  /** Temporary public download url */
  url?: Maybe<Scalars['String']>;
};

export type UserDataInquiryError = {
  __typename?: 'UserDataInquiryError';
  message: Scalars['String'];
  userFacingMessage?: Maybe<Scalars['String']>;
  errors?: Maybe<UserDataInquiryErrorFields>;
};

export type UserDataInquiryErrorFields = {
  __typename?: 'UserDataInquiryErrorFields';
  userId?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Array<Maybe<Scalars['String']>>>;
  passwordToken?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UserDataInquiryInput = {
  passwordToken: Scalars['String'];
};

export enum UserDataInquiryNotificationType {
  Information = 'INFORMATION',
  Error = 'ERROR'
}

export enum UserDataInquiryStatus {
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export type UserDataInquiryTemporaryDownloadUrlResult = {
  temporaryDownloadUrl?: Maybe<Scalars['String']>;
  extraBundles?: Maybe<Array<UserDataInquiryBundleDownloadUrl>>;
  error?: Maybe<UserDataInquiryError>;
};

export type UserDataInquiryTemporaryDownloadUrlResultError = UserDataInquiryTemporaryDownloadUrlResult & {
  __typename?: 'UserDataInquiryTemporaryDownloadUrlResultError';
  temporaryDownloadUrl?: Maybe<Scalars['String']>;
  extraBundles?: Maybe<Array<UserDataInquiryBundleDownloadUrl>>;
  error?: Maybe<UserDataInquiryError>;
};

export type UserDataInquiryTemporaryDownloadUrlResultSuccess = UserDataInquiryTemporaryDownloadUrlResult & {
  __typename?: 'UserDataInquiryTemporaryDownloadUrlResultSuccess';
  temporaryDownloadUrl?: Maybe<Scalars['String']>;
  extraBundles?: Maybe<Array<UserDataInquiryBundleDownloadUrl>>;
  error?: Maybe<UserDataInquiryError>;
};

export type UserEntityPages = {
  __typename?: 'UserEntityPages';
  collection: Array<Maybe<EntityPage>>;
};

export type UserFeatures = {
  __typename?: 'UserFeatures';
  unconfirmedContacts?: Maybe<UnconfirmedContactsFeature>;
};

export type UserFeebackOnOutdatedFieldsResponse = {
  __typename?: 'UserFeebackOnOutdatedFieldsResponse';
  saved: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type UserFeedbackRequest = {
  fields: Scalars['String'];
};

export type UserFlagDetails = {
  __typename?: 'UserFlagDetails';
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  body?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #logged-out #soft-logged-in */
  action?: Maybe<UserFlagDetailsAction>;
};

export type UserFlagDetailsAction = {
  __typename?: 'UserFlagDetailsAction';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  urn?: Maybe<Scalars['GlobalID']>;
  /** #logged-out #soft-logged-in */
  trackingId?: Maybe<Scalars['String']>;
};

export type UserFlags = {
  __typename?: 'UserFlags';
  /** #logged-out #soft-logged-in */
  displayFlag?: Maybe<UserFlagsDisplayFlag>;
  /** #logged-out #soft-logged-in */
  userFlags?: Maybe<Array<Maybe<UserFlagsDisplayFlag>>>;
  /** #logged-out #soft-logged-in */
  userId?: Maybe<Scalars['ID']>;
};

/** Available User Flags Display Flags */
export enum UserFlagsDisplayFlag {
  /** A user with executive membership */
  Executive = 'EXECUTIVE',
  /** A user with ambassador role */
  Ambassador = 'AMBASSADOR',
  /** A user with insider role */
  Insider = 'INSIDER',
  /** A user with ProTrainer membership */
  ProTrainer = 'PRO_TRAINER',
  /** A user with ProCoach membership */
  ProCoach = 'PRO_COACH',
  /** A user with moderator role */
  Moderator = 'MODERATOR',
  /** A user with premium membership */
  Premium = 'PREMIUM',
  /** Default user role and membership */
  Basic = 'BASIC'
}

export type UserInfoJs = {
  __typename?: 'UserInfoJS';
  /** #logged-out #soft-logged-in */
  userId: Scalars['String'];
  /** #logged-out #soft-logged-in */
  userIdType: Scalars['String'];
};

export type UserJobApplicationCv = {
  __typename?: 'UserJobApplicationCv';
  key: Scalars['String'];
  name: Scalars['String'];
  lastUsedAt: Scalars['Date'];
  url: Scalars['URL'];
};

export type UserLiker = {
  __typename?: 'UserLiker';
  userId?: Maybe<Scalars['ID']>;
  urn?: Maybe<Scalars['GlobalID']>;
  socialType?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  profile?: Maybe<XingId>;
};

export type UserRemindApplicationError = {
  __typename?: 'UserRemindApplicationError';
  /** #logged-out #soft-logged-in */
  error?: Maybe<Scalars['String']>;
};

export type UserRemindMutationInput = {
  postingId: Scalars['ID'];
  postingUrl: Scalars['URL'];
  email: Scalars['Email'];
  locale: Scalars['String'];
};

export type UserSearchOccurrences = {
  __typename?: 'UserSearchOccurrences';
  total?: Maybe<Scalars['Int']>;
};

export type UserSettingsResponse = UserSettingsSuccessResponse | SearchAlertErrorResponse;

export type UserSettingsSuccessResponse = {
  __typename?: 'UserSettingsSuccessResponse';
  alertEnabled: Scalars['Boolean'];
  alertFrequency: EmailFrequency;
};

export type UserSettingsUpdateInput = {
  emailEnabled?: Maybe<Scalars['Boolean']>;
  emailFrequency?: Maybe<EmailFrequency>;
};

export type UserType = {
  __typename?: 'UserType';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type VCard = {
  __typename?: 'VCard';
  country?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  itemId: Scalars['ID'];
  jobtitle?: Maybe<Scalars['String']>;
  gender?: Maybe<MymkGenderEstimate>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  isOwn?: Maybe<Scalars['Boolean']>;
};

/** Visitor of my Profile */
export type Vomp = {
  __typename?: 'VOMP';
  /** ID of the profile visit. */
  id: Scalars['ID'];
  /** ID of the user who visited the profile. 0 for logged-out visits. */
  visitorId?: Maybe<Scalars['ID']>;
  /**
   * #rest(batched) #virtual
   *
   *  XingId representation of the profile visitor
   */
  visitor?: Maybe<XingId>;
  /**
   * #rest(batched) #virtual
   *
   *  Distance between the user and the profile visitor
   */
  contactDistance?: Maybe<ContactDistance>;
};

export type VompConnection = HasCursorPagination & {
  __typename?: 'VOMPConnection';
  edges: Array<VompEdge>;
  /**
   * #virtual
   *
   *  Total number of visits
   */
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type VompEdge = PaginationEdge & {
  __typename?: 'VOMPEdge';
  node: Vomp;
  /** #virtual */
  cursor: Scalars['String'];
};

/** VOMP Module aka VisibilityInsights */
export type VompModule = ModuleInterface & {
  __typename?: 'VOMPModule';
  /** #paginated #rest #virtual */
  visitorsOfMyProfile?: Maybe<VompConnection>;
  /** #rest #virtual */
  numberOfNewVisits?: Maybe<NumberOfNewProfileVisits>;
  /** #rest #virtual */
  statistics?: Maybe<VompStatistics>;
  order: Scalars['Int'];
  title: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  globalId: Scalars['GlobalID'];
};


/** VOMP Module aka VisibilityInsights */
export type VompModuleVisitorsOfMyProfileArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type VerticalNavigationMutationError = {
  __typename?: 'VerticalNavigationMutationError';
  message?: Maybe<Scalars['String']>;
};

export type Video = {
  __typename?: 'Video';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  ownerGlobalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  status: VideoStatus;
  /** #logged-out #soft-logged-in */
  sources?: Maybe<VideoSources>;
  /** #logged-out #soft-logged-in */
  subtitles?: Maybe<Array<VideoSubtitle>>;
  /** #logged-out #soft-logged-in */
  sprites?: Maybe<Array<VideoImage>>;
  /** #logged-out #soft-logged-in */
  thumbnails?: Maybe<Array<VideoImage>>;
};

export type VideoAdImage = {
  __typename?: 'VideoAdImage';
  /** #logged-out #soft-logged-in */
  width: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  height: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  src: Scalars['String'];
};

export type VideoAttachment = {
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  type?: Maybe<Scalars['String']>;
};

export type VideoCreationInput = {
  apiKey: Scalars['String'];
  encodingTriggerMode?: Maybe<VideoEncodingTriggerMode>;
  ownerGlobalId: Scalars['GlobalID'];
  mute?: Maybe<Scalars['Boolean']>;
};

export type VideoCustomThumbnailCreationInput = {
  apiKey: Scalars['String'];
  videoRef: Scalars['String'];
  uploadId: Scalars['UploadId'];
};

export type VideoCustomThumbnailDeletionInput = {
  apiKey: Scalars['String'];
  videoRef: Scalars['String'];
  customThumbnailId: Scalars['ID'];
};

export type VideoCustomThumbnailUpdateInput = {
  apiKey: Scalars['String'];
  videoRef: Scalars['String'];
  customThumbnailId: Scalars['ID'];
  uploadId: Scalars['UploadId'];
};

export type VideoDataInput = {
  filename: Scalars['String'];
  ownerUrn: Scalars['GlobalID'];
};

export type VideoDeletionInput = {
  apiKey: Scalars['String'];
  videoRef: Scalars['String'];
};

export type VideoEmptyResult = {
  __typename?: 'VideoEmptyResult';
  error?: Maybe<VideoMutationError>;
};

export enum VideoEncodingTriggerMode {
  /** Encoding will start as soon as the video upload is done */
  Immediate = 'IMMEDIATE',
  /** Encoding will start when the client explicitly starts it */
  Explicit = 'EXPLICIT'
}

export type VideoError = {
  __typename?: 'VideoError';
  /** #logged-out #soft-logged-in */
  errorType: Scalars['String'];
  /** #logged-out #soft-logged-in */
  errorCode: Scalars['Int'];
};

export type VideoImage = {
  __typename?: 'VideoImage';
  /** #logged-out #soft-logged-in */
  source: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  width: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  height: Scalars['Int'];
};

export type VideoImageAttachment = VideoAttachment & {
  __typename?: 'VideoImageAttachment';
  /** #logged-out #soft-logged-in */
  x: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  y: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  unit: VideoImageAttachmentUnit;
  /** #logged-out #soft-logged-in */
  zIndex: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  links?: Maybe<VideoImageAttachmentLinks>;
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  type?: Maybe<Scalars['String']>;
};

export type VideoImageAttachmentCreationInput = {
  apiKey: Scalars['String'];
  videoRef: Scalars['String'];
  x: Scalars['Int'];
  y: Scalars['Int'];
  unit?: Maybe<VideoImageAttachmentUnit>;
  zIndex?: Maybe<Scalars['Int']>;
  resourceId: Scalars['ID'];
};

export type VideoImageAttachmentCreationResult = {
  __typename?: 'VideoImageAttachmentCreationResult';
  success?: Maybe<VideoImageAttachment>;
  error?: Maybe<VideoMutationError>;
};

export type VideoImageAttachmentLinks = {
  __typename?: 'VideoImageAttachmentLinks';
  /** #logged-out #soft-logged-in */
  self: Scalars['URL'];
};

export enum VideoImageAttachmentUnit {
  Pixels = 'PIXELS',
  Percentage = 'PERCENTAGE'
}

export type VideoImageSource = {
  __typename?: 'VideoImageSource';
  /** #logged-out #soft-logged-in */
  source: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  width: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  height: Scalars['Int'];
};

export type VideoLinks = {
  __typename?: 'VideoLinks';
  /** #logged-out #soft-logged-in */
  self: Scalars['URL'];
  /** Only available when the video is created or updated (and a reupload is requested) */
  uploadUrl?: Maybe<Scalars['URL']>;
};

/** Generic video mutation error */
export type VideoMutationError = {
  __typename?: 'VideoMutationError';
  code: Scalars['Int'];
  message: Scalars['String'];
};

export type VideoMutationResult = {
  __typename?: 'VideoMutationResult';
  success?: Maybe<VideoV2>;
  error?: Maybe<VideoMutationError>;
};

export type VideoPreviewMetadata = PreviewMetadata & {
  __typename?: 'VideoPreviewMetadata';
  width?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  embedUrl?: Maybe<Scalars['URL']>;
  sourceActor?: Maybe<LinkPreviewSourceActor>;
};

export type VideoResource = {
  __typename?: 'VideoResource';
  id: Scalars['ID'];
  ownerGlobalId: Scalars['GlobalID'];
  global: Scalars['Boolean'];
  format: VideoResourceFormat;
  links?: Maybe<VideoResourceLinks>;
};

export type VideoResourceCreationInput = {
  apiKey: Scalars['String'];
  ownerGlobalId: Scalars['GlobalID'];
  global?: Maybe<Scalars['Boolean']>;
  format: VideoResourceFormat;
};

export type VideoResourceCreationResult = {
  __typename?: 'VideoResourceCreationResult';
  success?: Maybe<VideoResource>;
  error?: Maybe<VideoMutationError>;
};

export enum VideoResourceFormat {
  Png = 'PNG'
}

export type VideoResourceLinks = {
  __typename?: 'VideoResourceLinks';
  self: Scalars['URL'];
  /** Only available when the resource is created or updated (and a reupload is requested) */
  uploadUrl?: Maybe<Scalars['URL']>;
};

export type VideoSource = {
  __typename?: 'VideoSource';
  /** #logged-out #soft-logged-in */
  format: Scalars['String'];
  /** #logged-out #soft-logged-in */
  source: Scalars['URL'];
};

export type VideoSources = {
  __typename?: 'VideoSources';
  /** #logged-out #soft-logged-in */
  dash?: Maybe<Scalars['URL']>;
  /** #logged-out #soft-logged-in */
  hls: Scalars['URL'];
};

export type VideoSprite = VideoV2Image & {
  __typename?: 'VideoSprite';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  sources?: Maybe<Array<VideoImageSource>>;
};

export type VideoStartEncodingInput = {
  apiKey: Scalars['String'];
  videoRef: Scalars['String'];
};

export enum VideoStatus {
  Enqueued = 'ENQUEUED',
  Encoding = 'ENCODING',
  Available = 'AVAILABLE',
  Failed = 'FAILED'
}

export type VideoSubtitle = {
  __typename?: 'VideoSubtitle';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  type: VideoSubtitleType;
  /** #logged-out #soft-logged-in */
  language: Scalars['String'];
  /** #logged-out #soft-logged-in */
  label: Scalars['String'];
  /** #logged-out #soft-logged-in */
  source: Scalars['URL'];
};

export type VideoSubtitleCreationInput = {
  apiKey: Scalars['String'];
  videoRef: Scalars['String'];
  label: Scalars['String'];
  language: Scalars['String'];
  uploadId: Scalars['UploadId'];
};

export type VideoSubtitleDeletionInput = {
  apiKey: Scalars['String'];
  videoRef: Scalars['String'];
  subtitleId: Scalars['ID'];
};

export type VideoSubtitleInput = {
  subtitleId?: Maybe<Scalars['ID']>;
  uploadId?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
};

export enum VideoSubtitleType {
  Webvtt = 'WEBVTT',
  Srt = 'SRT'
}

export type VideoSubtitleUpdateInput = {
  apiKey: Scalars['String'];
  videoRef: Scalars['String'];
  subtitleId: Scalars['ID'];
  label: Scalars['String'];
  language: Scalars['String'];
  uploadId: Scalars['UploadId'];
};

export type VideoThumbnail = VideoV2Image & {
  __typename?: 'VideoThumbnail';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  sources?: Maybe<Array<VideoImageSource>>;
};

export type VideoTrackingEvent = {
  type: VideoTrackingEventType;
  siteSection: Scalars['String'];
  clientTimestamp: Scalars['String'];
  videoRef: Scalars['SlugOrID'];
  extraFields?: Maybe<Scalars['JSON']>;
};

export type VideoTrackingEventInput = {
  collection: Array<VideoTrackingEvent>;
};

export enum VideoTrackingEventType {
  Ready = 'READY',
  Start = 'START',
  ActiveView = 'ACTIVE_VIEW',
  Mute = 'MUTE',
  Unmute = 'UNMUTE',
  FullscreenStart = 'FULLSCREEN_START',
  FullscreenExit = 'FULLSCREEN_EXIT',
  ThreeSeconds = 'THREE_SECONDS',
  TenSeconds = 'TEN_SECONDS',
  TwentyFivePercent = 'TWENTY_FIVE_PERCENT',
  FiftyPercent = 'FIFTY_PERCENT',
  SeventyFivePercent = 'SEVENTY_FIVE_PERCENT',
  NinetyFivePercent = 'NINETY_FIVE_PERCENT',
  OneHundredPercent = 'ONE_HUNDRED_PERCENT',
  PlayerError = 'PLAYER_ERROR',
  SetupError = 'SETUP_ERROR'
}

export type VideoTrackingMutationResult = {
  __typename?: 'VideoTrackingMutationResult';
  error?: Maybe<VideoError>;
};

export type VideoUpdateDataInput = {
  title?: Maybe<Scalars['String']>;
  thumbnailUploadId?: Maybe<Scalars['String']>;
  englishSubtitle?: Maybe<VideoSubtitleInput>;
  germanSubtitle?: Maybe<VideoSubtitleInput>;
};

export type VideoUpdateInput = {
  apiKey: Scalars['String'];
  videoRef: Scalars['String'];
  reupload?: Maybe<Scalars['Boolean']>;
  encodingTriggerMode?: Maybe<VideoEncodingTriggerMode>;
  mute?: Maybe<Scalars['Boolean']>;
};

export type VideoUploadDetails = {
  __typename?: 'VideoUploadDetails';
  /** @deprecated UUID content should not be under `id`. In the future use `ref` */
  id?: Maybe<Scalars['SlugOrID']>;
  ref?: Maybe<Scalars['SlugOrID']>;
  globalId: Scalars['GlobalID'];
  links: VideoUploadLinks;
};

export type VideoUploadLinks = {
  __typename?: 'VideoUploadLinks';
  uploadUrl: Scalars['URL'];
};

export type VideoUploadResponse = {
  videoDetails?: Maybe<VideoUploadDetails>;
};

export type VideoV2 = {
  __typename?: 'VideoV2';
  /**
   * #logged-out #soft-logged-in
   *
   *  This will be a String or an ID until everything is migrated
   */
  ref?: Maybe<Scalars['SlugOrID']>;
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  ownerGlobalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  status: VideoV2Status;
  /** #logged-out #soft-logged-in */
  sources?: Maybe<Array<VideoSource>>;
  /** #logged-out #soft-logged-in */
  subtitles?: Maybe<Array<VideoV2Subtitle>>;
  /** #logged-out #soft-logged-in */
  sprites?: Maybe<Array<VideoSprite>>;
  /** #logged-out #soft-logged-in */
  defaultThumbnails?: Maybe<Array<VideoThumbnail>>;
  /** #logged-out #soft-logged-in */
  customThumbnails?: Maybe<Array<VideoThumbnail>>;
  /** #logged-out #soft-logged-in */
  links?: Maybe<VideoLinks>;
  /** #logged-out #soft-logged-in */
  attachments?: Maybe<Array<VideoAttachment>>;
  /**
   * #logged-out #soft-logged-in
   *
   *  The mute flag used on creation. Only available for new videos. This isn't 100% reliable, so use with caution
   */
  mute?: Maybe<Scalars['Boolean']>;
};

export type VideoV2Image = {
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  sources?: Maybe<Array<VideoImageSource>>;
};

export enum VideoV2Status {
  Created = 'CREATED',
  Encoding = 'ENCODING',
  Available = 'AVAILABLE',
  Failed = 'FAILED'
}

export type VideoV2Subtitle = {
  __typename?: 'VideoV2Subtitle';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  language: Scalars['String'];
  /** #logged-out #soft-logged-in */
  label: Scalars['String'];
  /** #logged-out #soft-logged-in */
  sources: Array<VideoV2SubtitleSource>;
};

export type VideoV2SubtitleSource = {
  __typename?: 'VideoV2SubtitleSource';
  /** #logged-out #soft-logged-in */
  type: VideoSubtitleType;
  /** #logged-out #soft-logged-in */
  source: Scalars['URL'];
};

/** Stuff that is implicitly scoped to the identified viewer */
export type Viewer = {
  __typename?: 'Viewer';
  /**
   * #rest #virtual #soft-logged-in
   *
   *  Platform features for the requesting user
   */
  features?: Maybe<Feature>;
  /**
   * #rest #virtual #soft-logged-in
   *
   *  Generic feature switches
   */
  featureSwitches?: Maybe<Array<Scalars['String']>>;
  /**
   * #rest #virtual
   *
   *  Get profile academic title update
   */
  profileAcademicTitleUpdate?: Maybe<ProfileAcademicTitleUpdate>;
  /**
   * #rest #virtual
   *
   *  Get profile haves update
   */
  profileHavesUpdate?: Maybe<ProfileHavesUpdate>;
  /**
   * #rest #virtual
   *
   *  Get profile status Update
   */
  profileStatusUpdate?: Maybe<ProfileUpdateStatus>;
  /**
   * #rest #virtual
   *
   *  Get profile wants update
   */
  profileWantsUpdate?: Maybe<ProfileWantsUpdate>;
  /**
   * #rest #virtual
   *
   *  Get profile business contact update
   */
  profileBusinessContactUpdate?: Maybe<ProfileBusinessContactUpdate>;
  /**
   * #rest #virtual
   *
   *  Get profile work experience update
   */
  profileWorkExperienceUpdate?: Maybe<ProfileWorkExperienceUpdate>;
  /**
   * #rest #virtual
   *
   *  Get company anniversary story
   */
  companyAnniversaryStory?: Maybe<CompanyAnniversaryStory>;
  /**
   * #rest(batched) #virtual
   *
   *  Get company anniversary story batch
   */
  companyAnniversaryStoryBatch?: Maybe<CompanyAnniversaryStory>;
  /**
   * #rest #virtual
   *
   *  Get Cover Image Update
   */
  coverImageUpdate?: Maybe<CoverImageUpdate>;
  /**
   * #rest(batched) #virtual
   *
   *  Get Cover Image Update batch
   */
  coverImageUpdateBatch?: Maybe<CoverImageUpdate>;
  /**
   * #rest(batched) #virtual
   *
   *  Get mymk recommendation story
   */
  mymkRecommendationStory?: Maybe<PeopleStoryGeneratorMymkRecommendation>;
  /** #soft-logged-in #rest #virtual */
  connectionLevel?: Maybe<ConnectionLevelResponse>;
  /**
   * #soft-logged-in
   * @deprecated This field was needed prior to full Armstrong roll-out. The corresponding connection-level endpoint has very low usage and will be removed.
   */
  connectionLevelSnapDefencing?: Maybe<ConnectionLevelResponse>;
  /**
   * #paginated #rest #virtual
   *
   *  Universal Search Company is the api for company search to be used by company FE instead of the search-frontend one.
   * As search-proxy REST API pagination is using limit+offset instead of the required standard we need to adapt the query.
   */
  companySearch?: Maybe<CompanySearchConnection>;
  /** #rest #virtual */
  singleUserCommonalities?: Maybe<Commonalities>;
  /** #rest #virtual */
  userSearchOccurrences?: Maybe<UserSearchOccurrences>;
  /**
   * #paginated #rest #virtual
   *
   *  Universal Search News is the api for News (content) search to be used by News FE instead of search-frontend one.
   * As search-proxy REST API pagination is using limit+offset instead of the required standard we need to adapt de query.
   */
  newsSearch?: Maybe<NewsSearchConnection>;
  /**
   * #paginated
   *
   *  Universal Search Group is the api for group (communities) search to be used by group FE instead of search-frontend one.
   * As search-proxy REST API pagination is using limit+offset instead of the required standard we need to adapt de query.
   */
  groupSearch?: Maybe<GroupSearchConnection>;
  /** #rest #virtual */
  similarCandidates?: Maybe<SimilarCandidates>;
  /**
   * #paginated #logged-out #soft-logged-in #rest #virtual
   *
   *  Returns the current user's most recent job detail page views.
   * Ordered by most-recent view first and uses native cursor pagination.
   * The `onlyActivePostings` parameter is still here for legacy reasons but it shouldn't
   */
  jobVisits?: Maybe<JobVisitsConnection>;
  /** #paginated #logged-out #soft-logged-in #rest #virtual */
  jobBookmarks?: Maybe<JobBookmarksConnection>;
  /**
   * #rest #virtual
   *
   *  Get the recent used user cvs from the success job applications
   */
  userRecentCvs?: Maybe<Array<Maybe<UserJobApplicationCv>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Return job recent searches consuming the DS recent_searches endpoint and the jobSearchResult resolver.
   */
  jobRecentSearchesJS?: Maybe<JobRecentSearchCollectionJs>;
  /**
   * #rest #virtual
   *
   *  Returns the job search inspiration for the user
   */
  jobSearchInspiration?: Maybe<JobSearchInspirationResponse>;
  /**
   * #rest #virtual
   *
   *  Retrieves search alerts for the logged in user.
   * If the only thing you need is the query id (guid), you can just ask for queryId field. It is more performant.
   */
  searchAlerts?: Maybe<SearchAlertResponse>;
  /**
   * #rest(batched) #virtual
   *
   *  Search alerts for the current user but selecting them by id.
   */
  searchAlertsByIds?: Maybe<Array<Maybe<SearchAlert>>>;
  /** #rest #virtual */
  jobSearchDoesItNeedRefinement?: Maybe<JobSearchNeedsRefinementResponse>;
  /**
   * #rest #virtual
   *
   *  Retrieves the new id associated for an old search alert id
   */
  jobSearchAlertNewId?: Maybe<JobSearchAlertNewIdResponse>;
  /**
   * #rest #virtual
   *
   *  Get the search alerts settings for the current user.
   */
  searchAlertSettings?: Maybe<UserSettingsResponse>;
  /**
   * #rest #virtual
   *
   *  Get skill recommendations for user
   */
  skillsRecommendations?: Maybe<SkillRecommendationResponse>;
  /**
   * #rest #virtual
   *
   *  Get a maximum of 40 skill recommendations for user
   */
  skillsRecommendationsWithFixedLimit?: Maybe<SkillRecommendationResponse>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Returns neffi score
   */
  networkEfficiencyIndicator?: Maybe<NetworkEfficiencyIndicator>;
  /** #rest #virtual */
  purchaseLegacyMobileOffer?: Maybe<PurchaseLegacyMobileOffer>;
  /**
   * #rest #virtual
   * @deprecated Yoda will be dying 15th of December!
   */
  xjmJob?: Maybe<XjmJob>;
  /** #rest #virtual */
  linkPreview?: Maybe<LinkPreviewResult>;
  /** #soft-logged-in #rest #virtual */
  partnerDetails?: Maybe<PartnerDetails>;
  /** #soft-logged-in #rest #virtual */
  partnerHighlight?: Maybe<PartnerHighlight>;
  /** #soft-logged-in #rest #virtual */
  partners?: Maybe<Partners>;
  /** #soft-logged-in #rest #virtual */
  partner?: Maybe<Partner>;
  /** #soft-logged-in #rest #virtual */
  partnersCategories?: Maybe<PartnersCategories>;
  /**
   * #rest #virtual
   *
   *  Return the neffi for the profile. Resolved by profile-backend, adding some profile specific business logic.
   * @deprecated Use viewer.networkEfficiencyIndicator instead
   */
  profileNeffi?: Maybe<NeffiCard>;
  /**
   * #rest #virtual
   *
   *  Hiring data for a profile
   */
  hiringProfile?: Maybe<HiringProfile>;
  /** #soft-logged-in #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  /**
   * #rest #virtual
   *
   *  All occupations the user can choose from. The first Bucket will always be VISIBLE (the occupations which are publicly visible on the user's XingId)
   */
  xingIdOccupationBuckets?: Maybe<Array<MyXingIdOccupationBucket>>;
  /**
   * #rest #virtual
   *
   *  Get status of profile picture upload
   */
  xingIdUpdateProgressProfileImage?: Maybe<XingIdUpdateProfileImageUploadPayload>;
  profileSkillsModuleRecommendation?: Maybe<ProfileSkillsModuleRecommendation>;
  /** #rest #virtual */
  profileSkillsPerformance?: Maybe<ProfileSkillsModuleSkillsPerformace>;
  /** #rest #virtual */
  profileSkillsPerformanceWithCurrentSkills?: Maybe<ProfileSkillsModuleSkillsPerformaceWithCurrentSkills>;
  /** #rest #virtual */
  profileTimelineForm?: Maybe<ProfileTimelineForm>;
  /** #rest #virtual */
  workExperiences?: Maybe<ProfileWorkExperienceCollection>;
  /**
   * #rest #virtual
   *
   *  List of status options that are available for a user. The selection is based on the types of occupations.
   */
  profilePersonalStatusOptions?: Maybe<ProfilePersonalStatusOptions>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Ordered list of available modules on Profiles platform
   */
  profileModuleStoreItems?: Maybe<Array<Maybe<ProfileModuleStoreItem>>>;
  advertisingScrambledId?: Maybe<Scalars['String']>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  counter and stats from different apps
   */
  appStats?: Maybe<AppStats>;
  /** #rest #virtual */
  recruiterSearchAppearances?: Maybe<RecruiterSearchAppearances>;
  /** #rest #virtual */
  recruiterBookmarks?: Maybe<RecruiterBookmarks>;
  /** #rest #virtual */
  recruiterInteractions?: Maybe<RecruiterInteractions>;
  /** #paginated #soft-logged-in #rest #virtual */
  recruiterInteractionsConnection?: Maybe<RecruiterInteractionConnection>;
  /** #rest #virtual */
  socialRecentChats?: Maybe<SocialMessengerRecentChats>;
  /**
   * #paginated #rest #virtual
   *
   *  Get shares for URN
   */
  socialShares?: Maybe<SocialSharesConnection>;
  /**
   * #rest #virtual
   *
   *  Get a single share by id
   */
  socialShare?: Maybe<SocialShareResult>;
  /**
   * #rest(batched) #virtual
   *
   *  Get a single share via URN
   */
  socialShareByURN?: Maybe<SocialShareResult>;
  /**
   * #rest(batched) #virtual
   *
   *  Get a list of shares via URNs
   */
  socialShareByURNs?: Maybe<Array<Maybe<SocialShareResult>>>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  socialInteractionTarget?: Maybe<SocialInteractionTarget>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  socialInteractionTargets?: Maybe<Array<Maybe<SocialInteractionTarget>>>;
  /**
   * #rest #virtual
   *
   *  Search proxy to get possible user records for mentions
   */
  socialUserSearch?: Maybe<SocialUserSearchResult>;
  /**
   * #rest #virtual
   *
   *  Get the social proof (top reactions) for URN
   */
  socialProof?: Maybe<SocialProofResult>;
  /**
   * #rest(batched) #virtual
   *
   *  Get the social proof (top reactions) for multiple URNs
   */
  socialProofs?: Maybe<Array<Maybe<SocialProofCollection>>>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Get social external link by URN
   */
  socialExternalLink?: Maybe<SocialExternalLinkResult>;
  /**
   * #paginated #rest #virtual
   *
   *  Get reactions for URN
   */
  socialReactions?: Maybe<SocialReactionsConnection>;
  /**
   * #paginated #rest #virtual
   *
   *  Get comments for URN
   */
  socialComments?: Maybe<SocialCommentsConnection>;
  /**
   * #rest #virtual
   *
   *  Get a single comment by id
   */
  socialComment?: Maybe<SocialCommentResult>;
  /**
   * #rest(batched) #virtual
   *
   *  Load one activity with id
   */
  discoActivity?: Maybe<DiscoActivity>;
  /** Entry point for network update page */
  discoNetworkUpdatePage?: Maybe<DiscoNetworkUpdatePage>;
  /** Entry point for me feed page */
  discoMeFeedPage?: Maybe<DiscoMeFeedPage>;
  /** Entry point for entity stream feed page */
  discoEntityStreamPage?: Maybe<DiscoEntityStreamPage>;
  /**
   * Provides data for network update widget integrated in SUPI
   * @deprecated feature was removed from network-home
   */
  discoNetworkUpdateWidget?: Maybe<DiscoNetworkUpdateWidget>;
  /** #rest #virtual */
  discoProfileCompletion?: Maybe<DiscoProfileCompletion>;
  /** #rest #virtual */
  discoProfileMissingFields?: Maybe<MissingFieldsCollection>;
  /**
   * #rest #virtual
   *
   *  Get collapsed modules from user
   */
  collapsedModules?: Maybe<Array<Maybe<CollapsedModule>>>;
  /**
   * #rest #virtual
   *
   *  Get salary insights
   */
  salaryInsights?: Maybe<SalaryInsights>;
  /**
   * #rest #virtual
   *
   *  Get skills insights
   */
  skillsInsights?: Maybe<SkillsInsights>;
  /** #rest #virtual */
  jobWishesPreference?: Maybe<JobWishesPreference>;
  /**
   * #rest #virtual
   *
   *  Retrieve the current user preferences
   */
  preferenceSettings?: Maybe<PreferencesSettings>;
  /** #rest #virtual */
  moveonCompanyCulturePreferencesAssessmentData?: Maybe<MoveonCompanyCulturePreferencesAssessmentDataResult>;
  /**
   * #rest #virtual
   *
   *  Get article content and social interaction information base on users culture preferences
   */
  moveonArticlesByCulturePreferences?: Maybe<MoveonArticlesResult>;
  /** #paginated #rest #virtual */
  moveonCompanyRecommendations?: Maybe<MoveonCompanyRecommendationsConnection>;
  /**
   * #rest #virtual
   * @deprecated It will be replaced with moveonCompanyRecommendationsAndJobSearchResolver
   */
  moveonCompanyRecommendationsAllIds?: Maybe<Array<Scalars['ID']>>;
  /** #rest #virtual */
  moveonCompanyRecommendationsJobSearch?: Maybe<MoveonCompanyRecommendationsJobSearch>;
  teamPermissions?: Maybe<TeamPermissionsViewer>;
  /** The user's story collection */
  myStoryCollection?: Maybe<StoryCollection>;
  /** List of story collections to show to the current user */
  storyCollectionList?: Maybe<StoryCollectionList>;
  /**
   * #rest #virtual
   *
   *  List all entity pages owned by current user
   */
  userEntityPages?: Maybe<UserEntityPages>;
  /**
   * List of events of the current user
   * @deprecated Events is being shutdown on the 31-12-2022. Do not remove calls before this day
   */
  events?: Maybe<EventUserEvents>;
  /**
   * List of invitations of the current user
   * @deprecated Events is being shutdown on the 31-12-2022. Do not remove calls before this day
   */
  eventInvitations?: Maybe<EventUserInvitations>;
  /**
   * Invitation of the current user for a specific event
   * @deprecated Events is being shutdown on the 31-12-2022. Do not remove calls before this day
   */
  eventInvitation?: Maybe<EventUserInvitation>;
  /**
   * #rest #virtual
   *
   *  Returns client billing address
   */
  paymentsClientBillingAddress?: Maybe<ClientBillingAddress>;
  /** #rest #virtual */
  payBilClient?: Maybe<PayBilClientResponse>;
  /**
   * #rest #virtual
   *
   *  List of invoices optionally filtered by product group and/or year
   */
  paymentsClientInvoices?: Maybe<ClientPaymentInvoices>;
  /**
   * #rest #virtual
   *
   *  Returns client overview data like client and product groups
   */
  paymentsClientOverview?: Maybe<ClientOverview>;
  /**
   * #rest #virtual
   *
   *  Returns Client Payment method data
   */
  bpayPaymentMethodData?: Maybe<BpayPaymentMethodDataResult>;
  /**
   * #rest #virtual
   *
   *  Returns client credit/discount balance data
   */
  bpayClientBalance?: Maybe<BpayClientBalanceResult>;
  /**
   * #rest #virtual
   *
   *  Returns data/table for Product Group running Contracts
   */
  bpayProductGroupRunningContracts?: Maybe<BpayProductGroupRunningContractsResult>;
  /**
   * #rest #virtual
   *
   *  Credit card url to initialise credit card PopUp
   */
  bpayCreditCardUrl?: Maybe<BpayCreditCardUrl>;
  /** #rest #virtual */
  editedCompanies?: Maybe<CompanyCollection>;
  /**
   * #paginated #rest #virtual
   *
   *  List Companies managed by the user
   */
  managedCompanies?: Maybe<ManagedCompaniesConnection>;
  /** #paginated #rest #virtual */
  companiesRecommendations?: Maybe<CompanyRecommendationConnection>;
  /**
   * #paginated #rest #virtual
   *
   *  List Companies followed by the user
   */
  followedCompanies?: Maybe<FollowedCompaniesConnection>;
  /**
   * #paginated
   * @deprecated Groups are going to be shutdown at the end of 2022. Checked 20.02.2023, still used by XING-WEB.UNKNOWNVERSION - 120k rq/week
   */
  groupsMemberships?: Maybe<GroupsMembershipsConnection>;
  /**
   * #soft-logged-in #rest #virtual
   * @deprecated Replaced by partnerDetails query
   */
  premiumPartnerDetails?: Maybe<PremiumPartnerDetails>;
  /** #soft-logged-in */
  premiumStartpage?: Maybe<PremiumStartpage>;
  /** #soft-logged-in #rest #virtual */
  userFlags?: Maybe<UserFlags>;
  /** #soft-logged-in #rest #virtual */
  premiumPartnerHighlight?: Maybe<PremiumPartnerHighlight>;
  /**
   * #soft-logged-in #rest #virtual
   * @deprecated Replaced by partnersCategories query
   */
  premiumPartnersCategories?: Maybe<PremiumPartnersCategories>;
  /** #soft-logged-in #rest #virtual */
  premiumStartpageInfo?: Maybe<PremiumStartpageInfo>;
  /** #soft-logged-in */
  premiumSelfDevelopment?: Maybe<PremiumSelfDevelopment>;
  /** #soft-logged-in #rest #virtual */
  premiumFeaturesOverview?: Maybe<PremiumFeaturesOverview>;
  /** #logged-out #soft-logged-in #rest #virtual */
  selfUserFlagDetails?: Maybe<UserFlagDetails>;
  /** #logged-out #soft-logged-in #rest #virtual */
  otherUserFlagDetails?: Maybe<UserFlagDetails>;
  /**
   * #soft-logged-in #rest #virtual
   * @deprecated Replaced by partners query
   */
  premiumPartners?: Maybe<PremiumPartners>;
  /**
   * #soft-logged-in #rest #virtual
   * @deprecated Replaced by partner query
   */
  premiumPartner?: Maybe<PremiumPartner>;
  /** #soft-logged-in #rest #virtual */
  premiumNews?: Maybe<PremiumNews>;
  /** #soft-logged-in #rest #virtual */
  premiumVisibility?: Maybe<PremiumVisibility>;
  /** #rest #virtual */
  premiumStatistics?: Maybe<PremiumStatistics>;
  /** #rest #virtual */
  vompNotifications?: Maybe<VompNotification>;
  /**
   * #paginated #rest #virtual
   *
   *  Listing VOMPs from a user
   */
  visitorsList?: Maybe<ProfileVisitorsConnection>;
  /**
   * #rest #virtual
   *
   *  Showing single VOMP
   */
  profileVisit?: Maybe<ProfileVisit>;
  /** #rest #virtual */
  vompStatistics?: Maybe<VompStatistics>;
  /** #rest #virtual */
  numberOfNewProfileVisits?: Maybe<NumberOfNewProfileVisits>;
  /** #rest #virtual */
  vompHighlights?: Maybe<VompHighlights>;
  /** #rest #virtual */
  visibilityInsights?: Maybe<VisibilityInsights>;
  /** #paginated #rest #virtual */
  notifications?: Maybe<NotificationConnection>;
  /** #rest #virtual */
  notification?: Maybe<Notification>;
  /**
   * #paginated
   * @deprecated Groups are going to be shutdown at the end of 2022. This field will stop working on 01/01/2023.
   */
  featuredCommunities?: Maybe<CommunitiesConnection>;
  /** Viewer to retriieve data from Profiles */
  vitaProfileImport?: Maybe<VitaProfileImport>;
  /** #rest #virtual */
  vitaLatestDocument?: Maybe<VitaDocumentResult>;
  /**
   * #rest #virtual
   *
   *  Retrieve the latest cover letter
   */
  vitaLatestCoverLetter?: Maybe<VitaDocumentResult>;
  /**
   * #rest #virtual
   *
   *  A users notification settings
   */
  notificationSettings?: Maybe<NotificationSettingsCollection>;
  /**
   * #rest #virtual
   *
   *  User settings from activities
   */
  activitiesSettings?: Maybe<ActivitiesSettings>;
  premiumSwitchSettings?: Maybe<PremiumSwitchSettings>;
  /** #rest #virtual */
  eventSettings?: Maybe<EventSettings>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Account related settings
   */
  accountSettings?: Maybe<AccountSettings>;
  /**
   * #rest #virtual
   *
   *  Login related settings
   */
  loginSettings?: Maybe<LoginSettings>;
  /**
   * #rest #virtual
   *
   *  Profile pages related Settings
   */
  profileSettings?: Maybe<ProfileSettings>;
  /**
   * #rest #virtual
   *
   *  Web sessions
   */
  loginSessions?: Maybe<Array<Maybe<LoginSession>>>;
  /**
   * #rest #virtual
   *
   *  App sessions (a.k.a. permissions)
   */
  xwsSessions?: Maybe<Array<Maybe<XwsSessions>>>;
  /**
   * #rest #virtual
   *
   *  Data Inquiry for the current user
   */
  userDataInquiry?: Maybe<UserDataInquiry>;
  /** #rest #virtual */
  messengerSettings?: Maybe<MessengerSettings>;
  /**
   * #rest #virtual
   *
   *  User settings from core
   */
  coreSettings?: Maybe<CoreSettings>;
  /**
   * #rest #virtual
   *
   *  Privacy settings
   */
  networkSettings?: Maybe<NetworkSettings>;
  /**
   * #rest #virtual
   *
   *  Logged-Out visibility related Settings
   */
  profilesLoggedoutSettings?: Maybe<ProfilesLoggedoutSettings>;
  /**
   * #rest #virtual
   *
   *  TFA settings
   */
  twoFaSettings?: Maybe<TwoFaSettings>;
  /**
   * #rest #virtual
   *
   *  social settings (e. g. mentionable)
   */
  socialSettings?: Maybe<SocialSettings>;
  /** #rest #virtual */
  groupsSettings?: Maybe<GroupsSettings>;
  /**
   * #paginated
   * @deprecated Section is not longer going to show all types of objects and query was splited in chats and signalsStacksCollection
   */
  networkUpdatesCollection?: Maybe<NetworkUpdatesConnection>;
  /**
   * #paginated #rest #virtual
   *
   *  search contacts
   *
   * ```
   * query ContactsSearch {
   *   viewer {
   *     contactsSearch(consumer: "test", keywords: "Gregor Gysi") {
   *       edges {
   *         node {
   *           id
   *           displayName
   *           lastName
   *           pageName
   *           profileImage(size: SQUARE_192) {
   *             __typename
   *             url
   *           }
   *           occupations {
   *             __typename
   *             subline
   *             headline
   *           }
   *           userFlags {
   *             displayFlag
   *           }
   *         }
   *       }
   *     }
   *   }
   * }
   * ```
   */
  contactsSearch?: Maybe<ContactsSearchConnection>;
  /** #logged-out #soft-logged-in #rest #virtual */
  networkHomeWebsocketAuthToken?: Maybe<NetworkHomeWebsocketAuthToken>;
  /**
   * get insights banner
   *
   * ```
   * query bannerProperty {
   *   viewer {
   *     bannerProperty(propertyName: DISPLAY_INSIGHTS_BANNER) {
   *       value
   *     }
   *   }
   * }
   * ```
   */
  bannerProperty?: Maybe<BannerProperty>;
  /**
   * #paginated
   * @deprecated Replaced by: networkUpdatesCollection
   */
  conversationStarters?: Maybe<ConversationStartersConnection>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signalsStacksCollection?: Maybe<SignalsStacksConnection>;
  /** #preview #rest(batched) #virtual */
  personalDetails?: Maybe<PersonalDetails>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signalsCollection?: Maybe<SignalsCollectionConnection>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signalsChangesCollection?: Maybe<SignalsCollectionConnection>;
  /** #paginated #soft-logged-in #rest #virtual */
  mymkRecommendations?: Maybe<MymkRecommenderConnection>;
  /** #paginated #rest #virtual */
  mymkCombinedRecommendations?: Maybe<MymkCombinedRecommenderConnection>;
  /**
   * #paginated #rest #virtual
   * @deprecated Use mymkBucketCollectionsRecommendations and mymkBucketRecommendations instead. WILL BE REMOVED ...
   */
  mymkBucketedRecommendations?: Maybe<MymkBucketedRecommenderConnection>;
  /** #paginated #rest #virtual */
  mymkBucketCollectionsRecommendations?: Maybe<MymkBucketCollectionsRecommenderConnection>;
  /** #paginated #rest #virtual */
  mymkBucketRecommendations?: Maybe<MymkCombinedRecommenderConnection>;
  /** #paginated #soft-logged-in #rest #virtual */
  membersSearch?: Maybe<MembersSearchConnection>;
  /** @deprecated Profile-wizard is decommissioned. Values are hardcoded in order to support not deprecated app versions. This field will be removed soon */
  onboardingProfile?: Maybe<OnboardingProfile>;
  /**
   * #logged-out #soft-logged-in
   *
   *  The client IP of the request
   */
  clientIp: Scalars['String'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Returns login state of the current session
   */
  loginState: LoginState;
  /**
   * #logged-out #soft-logged-in
   *
   *  Returns `true` if the caller is logged-in and has been successfully authenticated. For logged-out and soft-logged-in states returns `false`
   * @deprecated Login state is not longer boolean. Since soft login introduction there are three possible states, please use `Viewer.loginState` instead.
   */
  isLoggedIn?: Maybe<Scalars['Boolean']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  The id of the requesting user
   */
  id: Scalars['ID'];
  /**
   * #rest #virtual
   *
   *  TETRIS tracking properties for a single user
   */
  webTrackingData?: Maybe<WebTrackingData>;
  /**
   * #rest #virtual
   *
   *  Get an array of company ids representing employer preferences
   */
  employersPreference?: Maybe<EmployersPreference>;
  /** #rest #virtual */
  industriesPreference?: Maybe<IndustriesPreference>;
  /** #rest #virtual */
  disciplinesPreference?: Maybe<DisciplinesPreference>;
  /** #logged-out #soft-logged-in #rest #virtual */
  salaryExpectationsPreference?: Maybe<SalaryExpectationsPreference>;
  /** #rest #virtual */
  blockedCompanies?: Maybe<BlockedCompanies>;
  /** #rest #virtual */
  jobPreferenceUserFlags?: Maybe<JobPreferenceUserFlags>;
  /** #logged-out #soft-logged-in #rest #virtual */
  careerLevelPreference?: Maybe<CareerLevelPreference>;
  /** #rest #virtual */
  workplacePreference?: Maybe<WorkplacePreference>;
  /**
   * #rest #virtual
   * @deprecated Use jobPreferencesDataStateInfo instead
   */
  jobPreferencesDataState?: Maybe<JobPreferencesDataState>;
  /** #rest #virtual */
  jobPreferencesDataStateInfo?: Maybe<JobPreferencesDataStateInfo>;
  /** #logged-out #soft-logged-in #rest #virtual */
  locationsPreference?: Maybe<LocationsPreference>;
  /** #rest #virtual */
  workingHoursPreference?: Maybe<WorkingHoursPreference>;
  /** #rest #virtual */
  jobTitlesPreference?: Maybe<JobTitlesPreference>;
  /** #rest #virtual */
  targetPositionsPreference?: Maybe<TargetPositionsPreference>;
  /** #rest #virtual */
  unpreferredPositionsPreference?: Maybe<UnpreferredPositionsPreference>;
  /** #rest #virtual */
  jobTitleSuggestionsPreference?: Maybe<JobTitleSuggestionsPreference>;
  /** #rest #virtual */
  jobPreferencesJobSeekerStatus?: Maybe<JobPreferencesJobSeekerStatus>;
  /**
   * #paginated #rest #virtual
   *
   *  Fetch a paginated collection of own and shared message templates for the current user
   */
  xtmMessageTemplatesList?: Maybe<XtmMessageTemplateConnection>;
  /** #soft-logged-in #rest(batched) #virtual */
  networkRelationship?: Maybe<Array<NetworkRelationship>>;
  /**
   * #rest #virtual
   *
   *  Settings for sharing data to other users
   */
  dataSharingSettings?: Maybe<DataSharingSettings>;
  /** #soft-logged-in #rest(batched) #virtual */
  contactDistance?: Maybe<Array<ContactDistance>>;
  /**
   * #rest #virtual
   *
   *  Returns users for a given list of proximity (Around You) uuid's
   */
  networkProximityUsers?: Maybe<NetworkProximityUsers>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Count of contacts
   */
  contactsCount?: Maybe<ContactsCount>;
  /**
   * #rest #virtual
   *
   *  Count of same city contacts
   */
  contactsSameCityCount?: Maybe<ContactsSameCityCount>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  List of contacts with support for multiple filters
   */
  contactsNetwork?: Maybe<ContactsNetwork>;
  /**
   * #paginated #soft-logged-in #rest #virtual
   *
   *  List of contacts using relay cursor pagination.
   */
  contactsNetworkByCursor?: Maybe<ContactsNetworkByCursorConnection>;
  /**
   * #rest #virtual
   *
   *  List of available tags
   */
  networkTags?: Maybe<NetworkTags>;
  /**
   * #rest #virtual
   *
   *  List of aggregated companies
   */
  networkContactsCompanies?: Maybe<NetworkContactsCompanies>;
  /**
   * #rest #virtual
   *
   *  List of aggregated cities
   */
  networkContactsCities?: Maybe<NetworkContactsCities>;
  /** #paginated #rest #virtual */
  sharedContacts?: Maybe<SharedContactsConnection>;
  /**
   * #paginated #soft-logged-in #rest #virtual
   *
   *  List of premium contacts
   */
  premiumContacts?: Maybe<PremiumContactsCursorConnection>;
  /** #paginated #rest #virtual */
  contactsBirthdays?: Maybe<ContactWithBirthdayConnection>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Request persisted client settings for network apps
   */
  networkClientSettings?: Maybe<Array<NetworkClientSetting>>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  List of received contact requests
   */
  contactRequestsReceived?: Maybe<ContactRequestsReceived>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  List of sent contact requests
   */
  contactRequestsSent?: Maybe<ContactRequestsSent>;
  /**
   * #paginated #rest #virtual
   *
   *  List of sent contact requests using cursor pagination
   */
  contactRequestsSentByCursor?: Maybe<ContactRequestsSentConnection>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Decrypt a one-click Contact Request token
   */
  contactRequestsOneClickTokenPayload?: Maybe<ContactRequestsOneClickToken>;
  /**
   * #paginated #rest #virtual
   *
   *  Recruiters that get recommended to the user,
   * based on their hiring areas and the user's
   * job role, industry and discipline
   */
  recruiterRecommendations?: Maybe<RecruiterRecommendationsConnection>;
  /** #rest #virtual */
  tracy?: Maybe<Tracy>;
  /** #rest #virtual */
  tracyUser?: Maybe<Tracy>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Payment account details including payment method. Currently only one per user
   */
  paymentAccounts?: Maybe<PaymentAccounts>;
  /** #soft-logged-in #rest #virtual */
  paymentAccount?: Maybe<PaymentAccount>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Paypal url to initialise paypal form
   */
  paypalUrl?: Maybe<PaypalUrl>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Credit card url to initialise credit card PopUp
   */
  creditCardUrl?: Maybe<CreditCardUrl>;
  /**
   * #rest #virtual
   *
   *  Summary of subscriptions for the user
   */
  paymentSubscriptions?: Maybe<PaymentSubscriptions>;
  /**
   * #rest #virtual
   *
   *  Summary of single subscriptions for the user. Returns `null` if the user does not have a subscription for this product group.
   */
  paymentSubscription?: Maybe<PaymentSubscription>;
  /**
   * #rest #virtual
   *
   *  List of invoices optionally filtered by year and/or product group and/or regenerability
   */
  paymentInvoices?: Maybe<PaymentInvoices>;
  /**
   * #rest #virtual
   *
   *  Data to support showing notifications in the app such as expired credit card
   */
  paymentNotifications?: Maybe<PaymentNotifications>;
  /** #rest #virtual */
  circuitBreakerStatus?: Maybe<CircuitBreaker>;
  /**
   * #rest #virtual
   *
   *  Check if the viewer has seen given URN
   */
  hasSeen?: Maybe<HasSeenResponse>;
  /**
   * #rest #virtual
   *
   *  B2B Profile Settings data
   */
  b2bProfileSettings?: Maybe<B2BProfileSettings>;
  /**
   * #paginated #soft-logged-in #rest #virtual
   *
   *  Get direct contacts for the job posting's details page. The returned contacts will work either currently or previously in posting's company.
   * In order to specify so, the ```companyMembership``` param is used.
   */
  jobDetailsFirstDegreeContacts?: Maybe<JobDetailsConnection>;
  /**
   * #paginated #soft-logged-in #rest #virtual
   *
   *  Get second degree contacts (contacts from your direct contacts) for the job posting's details page. The returned contacts will currently work in the posting's company.
   */
  jobDetailsSecondDegreeContacts?: Maybe<JobDetailsSecondDegreeConnection>;
  /**
   * #paginated #soft-logged-in #rest #virtual
   *
   *  Get future colleagues for the job posting's details page. The returned contacts will be potential colleagues that the user would
   * work together in case he/she would start working in the job role that is advertised in the job posting the user is looking at.
   */
  jobDetailsFutureColleagues?: Maybe<JobDetailsFutureColleaguesConnection>;
  /** #paginated #rest #virtual */
  jobRecommendations?: Maybe<JobRecommenderConnection>;
  /** #rest #virtual */
  userJobRecoSettings?: Maybe<JobRecoUserSettings>;
  /**
   * #logged-out #soft-logged-in #rest #virtual
   *
   *  Query for similar jobs
   */
  similarJobs?: Maybe<JobRecommendationsSimilarJobs>;
  /**
   * #rest #virtual
   *
   *  Query for recommendation categories
   */
  jobRecoCategories?: Maybe<JobRecommendationsCategories>;
  /** #paginated #rest #virtual */
  contactCompaniesRecommendations?: Maybe<JobRecommenderConnection>;
  /** #paginated #logged-out #soft-logged-in #rest #virtual */
  similarJobsForUserRecommendations?: Maybe<JobRecommenderConnection>;
  /** #paginated #rest #virtual */
  topEmployerRecommendations?: Maybe<JobRecommenderConnection>;
  /** #rest #virtual */
  jobRoles?: Maybe<JobRolesCollection>;
  /**
   * #rest #virtual
   *
   *  Gets an onboarding journey
   */
  onboardingJourney?: Maybe<OnboardingJourneyType>;
  /**
   * #rest #virtual
   *
   *  Get redirect profile (the profile that user will be redirected after the onboarding flow) of onboarding user
   *
   * ```
   * query onboardingRedirectProfile {
   *   viewer {
   *     onboardingRedirectProfile {
   *       profile {
   *         id
   *         firstName
   *         lastName
   *         profileImage(size: SQUARE_32){
   *           url
   *         }
   *         profileOccupation {
   *           occupationOrg
   *           occupationTitle
   *         }
   *       }
   *     }
   *   }
   * }
   * ```
   */
  onboardingRedirectProfile?: Maybe<OnboardingRedirectProfile>;
  /** List blocked entities by the viewer user */
  blockedEntitiesPage?: Maybe<BlockedEntitiesPage>;
  /** #rest #virtual */
  jobSeekerGuidance?: Maybe<JobSeekerGuidance>;
  /**
   * #rest #virtual
   *
   *  Profiles search for the current projobs user
   */
  projobsProfileSearch?: Maybe<ProjobsProfileSearchResults>;
  /** #rest #virtual */
  projobsDocuments?: Maybe<ProjobsDocuments>;
  /**
   * #rest #virtual
   * @deprecated Will be removed at the end of Q4
   */
  projobsWishes?: Maybe<ProjobsWishes>;
  /**
   * #rest #virtual
   * @deprecated Will be removed at the end of Q4
   */
  projobsContactOptions?: Maybe<ProjobsContactOptions>;
  /** #rest #virtual */
  projobsSettings?: Maybe<ProjobsSettings>;
  /** #rest #virtual */
  projobsRecruiterInsights?: Maybe<ProjobsRecruiterInsights>;
  /**
   * #rest #virtual
   *
   *  List blocked users by the viewer user
   */
  blockedUsers?: Maybe<Array<Maybe<NetworkBlockedUsersBlockedUser>>>;
  loProfilePreview?: Maybe<LoProfile>;
  /** #rest #virtual */
  loProfilePreviewLegalNotice?: Maybe<ProfileLegalInformation>;
  /**
   * #rest #virtual
   *
   *  Get messenger banner info
   */
  messengerBanner?: Maybe<MessengerBanner>;
  /** #rest #virtual */
  chatQuickActions?: Maybe<MessengerQuickActions>;
  /** #rest #virtual */
  chatsSearch?: Maybe<ChatsSearch>;
  /** #rest #virtual */
  messagesSearch?: Maybe<MessagesSearch>;
  /** #rest #virtual */
  scheduledMessages?: Maybe<ScheduledMessages>;
  /** #paginated #rest #virtual */
  chatMessages?: Maybe<MessengerChatMessagesConnection>;
  /** #paginated #rest #virtual */
  messengerMessageSearch?: Maybe<MessengerMessageSearchConnection>;
  /** #rest #virtual */
  messengerControls?: Maybe<MessengerControls>;
  /** #paginated #rest #virtual */
  messengerContacts?: Maybe<MessengerContactsConnection>;
  /** #rest(batched) #virtual */
  chat?: Maybe<MessengerChat>;
  /** #paginated #rest #virtual */
  chats?: Maybe<MessengerChatsConnection>;
  /** #paginated #rest #virtual */
  chatsUpdates?: Maybe<MessengerChatsConnection>;
  /**
   * #rest(batched) #virtual
   *
   *  Query a chat without a scrambled-id. This is necessary to be backwards compatible with the messenger-classic after a redirect to the Armstrong messenger.
   * @deprecated Use `viewer.chat` it will be removed after full Armstrong rollout mobile and desktop web.
   */
  chatLegacy?: Maybe<MessengerChat>;
  /**
   * #rest #virtual
   *
   *  List of Templates
   */
  messengerMessageTemplates?: Maybe<MessengerMessageTemplates>;
  /**
   * #rest #virtual
   *
   *  Read a template
   */
  messengerMessageTemplate?: Maybe<MessengerMessageTemplatesInterface>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  List of feature switches experiments for the currently logged in user.
   */
  featureSwitchesExperiments?: Maybe<FeatureSwitchesExperimentsCollection>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  DEPRECATED
   * Predictive search is going to be shutdown as right now it's one used for mobile search always with kinds=members.
   * This will call incremental members search is search-backend.
   */
  predictiveSearch?: Maybe<PredictiveSearch>;
  /** #rest #virtual */
  contentEmailSubscriptions?: Maybe<EmailSubscriptions>;
  /** #paginated #rest #virtual */
  contentPageRecommendations?: Maybe<ContentPageRecommenderConnection>;
  /** #rest #virtual */
  contentPurchases?: Maybe<ContentPurchaseList>;
  /** #paginated #rest #virtual */
  contentBookmarks?: Maybe<ContentBookmarksConnection>;
  /**
   * #rest #virtual
   *
   *  Get managed insider page infos
   */
  contentInsiderPage?: Maybe<ContentManagedInsiderPage>;
  /**
   * #rest #virtual
   *
   *  Get managed page infos
   */
  contentPage?: Maybe<ContentManagedPage>;
  /** #rest #virtual */
  contentManagedPages?: Maybe<ContentPageList>;
  /** #rest #virtual */
  contentPageUsers?: Maybe<ContentPageUsers>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerProfileAcademicTitleUpdateArgs = {
  id: Scalars['ID'];
  userId?: Maybe<Scalars['Long']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerProfileHavesUpdateArgs = {
  id: Scalars['ID'];
  userId?: Maybe<Scalars['Long']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerProfileStatusUpdateArgs = {
  id: Scalars['ID'];
  userId?: Maybe<Scalars['Long']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerProfileWantsUpdateArgs = {
  id: Scalars['ID'];
  userId?: Maybe<Scalars['Long']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerProfileBusinessContactUpdateArgs = {
  id: Scalars['ID'];
  userId?: Maybe<Scalars['Long']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerProfileWorkExperienceUpdateArgs = {
  id: Scalars['ID'];
  userId?: Maybe<Scalars['Long']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerCompanyAnniversaryStoryArgs = {
  id: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerCompanyAnniversaryStoryBatchArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerCoverImageUpdateArgs = {
  id: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerCoverImageUpdateBatchArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMymkRecommendationStoryArgs = {
  id: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerCompanySearchArgs = {
  query: UniversalSearchCompanyQueryInput;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSingleUserCommonalitiesArgs = {
  userId: Scalars['ID'];
  maxCommonalities?: Maybe<Scalars['Int']>;
  ignorePrivacySettings?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerUserSearchOccurrencesArgs = {
  init?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  consumer?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerNewsSearchArgs = {
  query: UniversalSearchNewsQueryInput;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerGroupSearchArgs = {
  query: UniversalSearchGroupQueryInput;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSimilarCandidatesArgs = {
  userId?: Maybe<Scalars['Int']>;
  consumer?: Maybe<Scalars['String']>;
  candidateId?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  timeout?: Maybe<Scalars['Int']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobVisitsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  onlyActivePostings?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobBookmarksArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  state?: Maybe<JobBookmarkState>;
  onlyActivePostings?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobRecentSearchesJsArgs = {
  consumer: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  searchMode?: Maybe<SearchMode>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobSearchInspirationArgs = {
  consumer: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSearchAlertsArgs = {
  input?: Maybe<SearchAlertsInput>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSearchAlertsByIdsArgs = {
  ids?: Maybe<Array<Scalars['ID']>>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobSearchDoesItNeedRefinementArgs = {
  input: JobSearchNeedsRefinementInput;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobSearchAlertNewIdArgs = {
  oldAlertId: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSkillsRecommendationsArgs = {
  consumer: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  onboarding?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSkillsRecommendationsWithFixedLimitArgs = {
  consumer: Scalars['String'];
  onboarding?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerNetworkEfficiencyIndicatorArgs = {
  consumer: Scalars['String'];
  scoreVersion?: Maybe<Scalars['Int']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPurchaseLegacyMobileOfferArgs = {
  product: PurchaseProduct;
  platform: PurchaseMobilePlatform;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerXjmJobArgs = {
  id: Scalars['Int'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerLinkPreviewArgs = {
  url: Scalars['URL'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPartnerDetailsArgs = {
  slug?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPartnerHighlightArgs = {
  membership?: Maybe<PartnerMemberships>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPartnersArgs = {
  categories?: Maybe<Scalars['String']>;
  membership?: Maybe<PartnerMemberships>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPartnerArgs = {
  slug?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPartnersCategoriesArgs = {
  membership?: Maybe<PartnerMemberships>;
  sendAll?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerProfileSkillsPerformanceArgs = {
  consumer: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerProfileSkillsPerformanceWithCurrentSkillsArgs = {
  consumer: Scalars['String'];
  skills: Array<Scalars['String']>;
  topSkills?: Maybe<Array<Scalars['String']>>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerProfileTimelineFormArgs = {
  action: ProfileTimelineAction;
  occupationType?: Maybe<ProfileOccupationTypeIdentifier>;
  occupationTypeCategory?: Maybe<ProfileOccupationTypeCategoryIdentifier>;
  urn?: Maybe<Scalars['GlobalID']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerRecruiterSearchAppearancesArgs = {
  timeFrame?: Maybe<TimeFrameFilterOptions>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerRecruiterBookmarksArgs = {
  timeFrame?: Maybe<TimeFrameFilterOptions>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerRecruiterInteractionsArgs = {
  timeFrame?: Maybe<TimeFrameFilterOptions>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerRecruiterInteractionsConnectionArgs = {
  timeFrame?: Maybe<TimeFrameFilterOptions>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialRecentChatsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialSharesArgs = {
  urn: Scalars['GlobalID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialShareArgs = {
  id: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialShareByUrnArgs = {
  urn: Scalars['GlobalID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialShareByUrNsArgs = {
  urns?: Maybe<Array<Scalars['GlobalID']>>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialInteractionTargetArgs = {
  urn: Scalars['GlobalID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialInteractionTargetsArgs = {
  urns?: Maybe<Array<Scalars['GlobalID']>>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialUserSearchArgs = {
  query: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialProofArgs = {
  urn: Scalars['GlobalID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialProofsArgs = {
  urns?: Maybe<Array<Scalars['GlobalID']>>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialExternalLinkArgs = {
  urn: Scalars['GlobalID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialReactionsArgs = {
  urn: Scalars['GlobalID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialCommentsArgs = {
  urn: Scalars['GlobalID'];
  id?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSocialCommentArgs = {
  id: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerDiscoActivityArgs = {
  id: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerDiscoNetworkUpdatePageArgs = {
  platform?: Maybe<DiscoPlatform>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerDiscoMeFeedPageArgs = {
  platform?: Maybe<DiscoPlatform>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerDiscoEntityStreamPageArgs = {
  platform?: Maybe<DiscoPlatform>;
  entityPageId: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerDiscoNetworkUpdateWidgetArgs = {
  platform?: Maybe<DiscoPlatform>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerDiscoProfileCompletionArgs = {
  consumer: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMoveonCompanyRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerStoryCollectionListArgs = {
  supportedActors?: Array<StorySupportedActors>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerEventsArgs = {
  input: EventMyEventsQueryInput;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerEventInvitationsArgs = {
  input: EventUserInvitationsQueryInput;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerEventInvitationArgs = {
  eventId: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPaymentsClientBillingAddressArgs = {
  productGroup: PaymentClientProductGroup;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPayBilClientArgs = {
  clientId?: Maybe<Scalars['ID']>;
  embeddedBy?: Maybe<Scalars['String']>;
  testActionAllowed?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPaymentsClientInvoicesArgs = {
  year?: Maybe<Scalars['Int']>;
  productGroup: PaymentClientProductGroup;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerBpayPaymentMethodDataArgs = {
  clientId?: Maybe<Scalars['ID']>;
  embeddedBy?: Maybe<Scalars['String']>;
  testActionAllowed?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerBpayClientBalanceArgs = {
  clientId: Scalars['ID'];
  embeddedBy: EmbeddedBy;
  testActionAllowed?: Maybe<Scalars['Boolean']>;
  productGroup?: Maybe<PaymentClientProductGroup>;
  currency?: Maybe<PaymentCurrency>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerBpayProductGroupRunningContractsArgs = {
  productGroup: PaymentClientProductGroup;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerBpayCreditCardUrlArgs = {
  language?: Maybe<Scalars['String']>;
  embeddedBy?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['ID']>;
  agencyMode?: Maybe<Scalars['Boolean']>;
  testActionAllowed?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerManagedCompaniesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerCompaniesRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerFollowedCompaniesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  sortField?: Maybe<FollowedCompaniesSortField>;
  sortOrder?: Maybe<FollowedCompaniesSortOrder>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerGroupsMembershipsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  groupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  tagIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  states?: Maybe<Array<Maybe<GroupsMembershipState>>>;
  roles?: Maybe<Array<Maybe<GroupsMembershipRole>>>;
  groupStates?: Maybe<Array<Maybe<GroupsGroupState>>>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPremiumPartnerDetailsArgs = {
  slug?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPremiumStartpageInfoArgs = {
  platform?: Maybe<PremiumPlatform>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPremiumSelfDevelopmentArgs = {
  platform?: Maybe<PremiumPlatform>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPremiumFeaturesOverviewArgs = {
  platform?: Maybe<PremiumPlatform>;
  product?: Maybe<PremiumFeaturesOverviewProducts>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSelfUserFlagDetailsArgs = {
  displayFlag?: Maybe<UserFlagsDisplayFlag>;
  platform?: Maybe<PremiumPlatform>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerOtherUserFlagDetailsArgs = {
  otherDisplayFlag?: Maybe<UserFlagsDisplayFlag>;
  otherUserId?: Maybe<Scalars['ID']>;
  displayFlag?: Maybe<UserFlagsDisplayFlag>;
  platform?: Maybe<PremiumPlatform>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPremiumPartnersArgs = {
  categories?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPremiumPartnerArgs = {
  slug?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPremiumNewsArgs = {
  platform?: Maybe<PremiumPlatform>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPremiumVisibilityArgs = {
  platform?: Maybe<PremiumPlatform>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPremiumStatisticsArgs = {
  statisticId?: Maybe<Scalars['ID']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerVompNotificationsArgs = {
  notificationId?: Maybe<Scalars['ID']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerVisitorsListArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  isNewVisit?: Maybe<NewVisitType>;
  timeFrame?: Maybe<TimeFrameFilterOptions>;
  recruiter?: Maybe<RecruiterFilter>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerProfileVisitArgs = {
  profileVisitId: Scalars['Int'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerVompStatisticsArgs = {
  timeFrame?: Maybe<TimeFrameFilterOptions>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerVompHighlightsArgs = {
  timeFrame?: Maybe<TimeFrameFilterOptions>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerVisibilityInsightsArgs = {
  timeFrame?: Maybe<TimeFrameFilterOptions>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerNotificationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerNotificationArgs = {
  id: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerFeaturedCommunitiesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerNetworkUpdatesCollectionArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  filter: NetworkUpdatesFilter;
  sectionFilter?: Maybe<NetworkUpdatesSectionFilterInput>;
  includeAds?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContactsSearchArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
  keywords: Scalars['String'];
  filters?: Maybe<ContactsSearchFiltersInput>;
  highlight?: Maybe<Scalars['Boolean']>;
  agg?: Maybe<ContactsSearchAggregationsInput>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerBannerPropertyArgs = {
  propertyName?: Maybe<BannerPropertyName>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerConversationStartersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  includeAds?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSignalsStacksCollectionArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSignalsCollectionArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  filter: SignalsFilter;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSignalsChangesCollectionArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  filter: SignalsFilter;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMymkRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
  adhocCoworker?: Maybe<Scalars['Boolean']>;
  adhocSchoolmate?: Maybe<Scalars['Boolean']>;
  boostInactive?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMymkCombinedRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
  details?: Maybe<Scalars['Boolean']>;
  includeNonOwnedVcards?: Maybe<Scalars['Boolean']>;
  includeGender?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMymkBucketedRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
  buckets: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMymkBucketCollectionsRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
  buckets: Scalars['String'];
  bucketsLimit?: Maybe<Scalars['Int']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMymkBucketRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
  bucket: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMembersSearchArgs = {
  query: MembersSearchQueryInput;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobTitleSuggestionsPreferenceArgs = {
  language: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerXtmMessageTemplatesListArgs = {
  query?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerNetworkRelationshipArgs = {
  ids: Array<Scalars['ID']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContactDistanceArgs = {
  ids: Array<Scalars['SlugOrID']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerNetworkProximityUsersArgs = {
  uuids: Array<Scalars['UUID']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContactsNetworkArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<ContactsListOrderBy>;
  filters?: Maybe<ContactsFilters>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContactsNetworkByCursorArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  orderBy?: Maybe<ContactsListOrderBy>;
  filters?: Maybe<ContactsFilters>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSharedContactsArgs = {
  otherUserId: Scalars['SlugOrID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPremiumContactsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContactsBirthdaysArgs = {
  year?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  day?: Maybe<Scalars['Int']>;
  range?: Maybe<Range>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContactRequestsReceivedArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  orderBy?: Maybe<OrderDirection>;
  excludeSeen?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContactRequestsSentArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  orderBy?: Maybe<OrderDirection>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContactRequestsSentByCursorArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  orderBy?: Maybe<OrderDirection>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContactRequestsOneClickTokenPayloadArgs = {
  token: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerRecruiterRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerTracyUserArgs = {
  fields?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerCreditCardUrlArgs = {
  language?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPaymentSubscriptionArgs = {
  productGroup?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPaymentInvoicesArgs = {
  year?: Maybe<Scalars['Int']>;
  productGroup?: Maybe<Scalars['String']>;
  isRegeneratable?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerHasSeenArgs = {
  urn?: Maybe<Scalars['String']>;
  source?: Maybe<HasSeenSource>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobDetailsFirstDegreeContactsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  postingId: Scalars['ID'];
  consumer: Scalars['String'];
  companyMembership: CompanyMembership;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobDetailsSecondDegreeContactsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  postingId: Scalars['ID'];
  consumer: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobDetailsFutureColleaguesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  postingId: Scalars['ID'];
  consumer: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
  exclude?: Maybe<Array<Scalars['ID']>>;
  projobsDashboardFilter?: Maybe<Scalars['Boolean']>;
  maxNDaysOld?: Maybe<Scalars['Int']>;
  includeNew?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerUserJobRecoSettingsArgs = {
  consumer: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSimilarJobsArgs = {
  jobId: Scalars['ID'];
  consumer: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobRecoCategoriesArgs = {
  consumer: Scalars['String'];
  limitPerCategory: Scalars['Int'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContactCompaniesRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
  exclude?: Maybe<Array<Scalars['ID']>>;
  projobsDashboardFilter?: Maybe<Scalars['Boolean']>;
  maxNDaysOld?: Maybe<Scalars['Int']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerSimilarJobsForUserRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerTopEmployerRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
  exclude?: Maybe<Array<Scalars['ID']>>;
  projobsDashboardFilter?: Maybe<Scalars['Boolean']>;
  maxNDaysOld?: Maybe<Scalars['Int']>;
  includeNew?: Maybe<Scalars['Boolean']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobRolesArgs = {
  consumer: Scalars['String'];
  lang?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerJobSeekerGuidanceArgs = {
  platform: JobSeekerPlatform;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerProjobsProfileSearchArgs = {
  input: ProjobsProfileSearchQueryInput;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMessengerBannerArgs = {
  name: MessengerBannerType;
  chatId?: Maybe<Scalars['ID']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerChatQuickActionsArgs = {
  chatId: Scalars['ID'];
  contextId?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerChatsSearchArgs = {
  text: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMessagesSearchArgs = {
  text: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  lastSeenId?: Maybe<Scalars['ID']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerScheduledMessagesArgs = {
  recipientsIds: Array<Scalars['ID']>;
  contextId?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerChatMessagesArgs = {
  chatId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMessengerMessageSearchArgs = {
  query: MessengerMessageSearchQueryInput;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMessengerContactsArgs = {
  query?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerChatArgs = {
  id: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerChatsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  filter?: Maybe<MessengerChatsFilterTypes>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerChatsUpdatesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  filter?: Maybe<MessengerChatsFilterTypes>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerChatLegacyArgs = {
  id: Scalars['Int'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerMessengerMessageTemplateArgs = {
  id: Scalars['ID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerFeatureSwitchesExperimentsArgs = {
  names?: Maybe<Array<Maybe<Scalars['String']>>>;
  platform?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerPredictiveSearchArgs = {
  query: Scalars['String'];
  consumer: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
  kinds?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContentPageRecommendationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  consumer: Scalars['String'];
  pageTypes?: Maybe<Array<Maybe<ContentPageType>>>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContentPurchasesArgs = {
  type?: Maybe<Array<Maybe<ContentPurchaseType>>>;
  purchaseIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  subscriptionIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContentBookmarksArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContentInsiderPageArgs = {
  userId: Scalars['SlugOrID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContentPageArgs = {
  pageGlobalId: Scalars['GlobalID'];
};


/** Stuff that is implicitly scoped to the identified viewer */
export type ViewerContentPageUsersArgs = {
  pageGlobalId: Scalars['GlobalID'];
};

export type VisibilityInsights = {
  __typename?: 'VisibilityInsights';
  /**
   * #paginated #rest #virtual
   *
   *  List of VOMPs
   */
  profileVisits?: Maybe<ProfileVisitorsConnection>;
  /**
   * #virtual
   *
   *  Total number of news feed appearances
   */
  newsFeedAppearances?: Maybe<Scalars['Int']>;
  /**
   * #virtual
   *
   *  Total number of search appearances
   */
  searchAppearances?: Maybe<Scalars['Int']>;
};


export type VisibilityInsightsProfileVisitsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  timeFrame?: Maybe<TimeFrameFilterOptions>;
};

/** Visibility Setting Type */
export type VisibilitySetting = {
  __typename?: 'VisibilitySetting';
  visibleToHeadhunters: Scalars['Boolean'];
  visibleToRecruiters: Scalars['Boolean'];
  visibleToContacts: Scalars['Boolean'];
  visibleToOthers: Scalars['Boolean'];
  visibleToColleagues: Scalars['Boolean'];
};

export type VisibleJob = HasGlobalId & {
  __typename?: 'VisibleJob';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  activatedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  activeUntil?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  application?: Maybe<JobApplication>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated This field is not used anymore and will be removed in the future.
   */
  banner?: Maybe<JobBanner>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  careerLevel?: Maybe<CareerLevel>;
  /** #logged-out #soft-logged-in */
  companyInfo: JobCompanyInfo;
  /** #logged-out #soft-logged-in */
  description: JobDescription;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  employmentType?: Maybe<EmploymentType>;
  /** #soft-logged-in */
  features?: Maybe<JobFeatures>;
  /** #logged-out #soft-logged-in */
  globalId: Scalars['GlobalID'];
  hiringContact?: Maybe<JobHiringContact>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  industry?: Maybe<Industry>;
  /** #logged-out #soft-logged-in */
  jobCode?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  keywords: Array<Maybe<Scalars['String']>>;
  /** #logged-out #soft-logged-in */
  language?: Maybe<Scalars['String']>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated Use 'locations' field instead.
   */
  location?: Maybe<JobLocation>;
  /** #logged-out #soft-logged-in */
  locations: Array<JobLocation>;
  /** #logged-out #soft-logged-in */
  paid: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Defines if the posting is paid and does not come from a third party
   */
  prioritized: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated Projob was discontinued. This field will be removed on 2024-03-29!
   */
  projob: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  salary?: Maybe<JobSalary>;
  summary?: Maybe<JobSummary>;
  /** #rest #virtual */
  userScore?: Maybe<JobUserScore>;
  /** #logged-out #soft-logged-in */
  redirectsToThirdPartyUrl: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  refreshedAt: Scalars['Date'];
  /** #logged-out #soft-logged-in */
  remoteOptions?: Maybe<Array<Maybe<JobRemoteOptionValue>>>;
  /** #logged-out #soft-logged-in */
  seoName: Scalars['String'];
  /** #logged-out #soft-logged-in */
  serviceOfferingGroup: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  skills?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #logged-out #soft-logged-in */
  slug: Scalars['String'];
  /** #logged-out #soft-logged-in */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #logged-out #soft-logged-in */
  title: Scalars['String'];
  /** #logged-out #soft-logged-in */
  topJob: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  url: Scalars['URL'];
  /** #logged-out #soft-logged-in */
  userInteractions?: Maybe<JobUserInteractions>;
  /**
   * #logged-out #soft-logged-in
   * @deprecated This field is not used anymore and will be removed in the future.
   */
  video?: Maybe<JobVideo>;
  /** #rest(batched) #virtual */
  matchingHighlights?: Maybe<JobMatchingHighlightsV2>;
  /**
   * #soft-logged-in #rest(batched) #virtual
   *
   *  Matches the skills and job role of the current visible job with the current user's profile.
   * Returns two lists of entitized skills of the current job (one with matching skills and one with non-matching skills) and two
   * lists of entitized job roles (one with matching job roles and one with non-matching job roles).
   * The labels of each element are localized according to the user's language (based on the "accept-language" header set by NW1).
   */
  userProfileMatches?: Maybe<OntologyUserJobPostingProfileMatchResponse>;
};


export type VisibleJobUserScoreArgs = {
  consumer: Scalars['String'];
};


export type VisibleJobMatchingHighlightsArgs = {
  context: JobMatchingHighlightsContext;
};

export type VisitPerDay = {
  __typename?: 'VisitPerDay';
  date: Scalars['Date'];
  quantity: Scalars['Int'];
};

export type VisitsGraph = {
  __typename?: 'VisitsGraph';
  sectionHeadline: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  /** The trend percentage representing the visitors increase or decrease on the specified time frame */
  visitsTrend: Scalars['Float'];
  /** The array of visits for the specified time frame */
  visits: Array<VisitPerDay>;
  /** When the user is basic, a description is given */
  upsellDescription?: Maybe<Scalars['String']>;
};

export type VisitsViewError = {
  __typename?: 'VisitsViewError';
  message?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['String']>;
};

export type VisitsViewInput = {
  viewedAt: Scalars['Date'];
};

export type VisitsViewResult = {
  __typename?: 'VisitsViewResult';
  error?: Maybe<VisitsViewError>;
  success?: Maybe<VisitsViewSuccess>;
};

export type VisitsViewSuccess = {
  __typename?: 'VisitsViewSuccess';
  viewedAt: Scalars['Date'];
};

export type VitaAccountSettingsInput = {
  email?: Maybe<VitaEmailSettingInput>;
};

export type VitaAddressInput = {
  country?: Maybe<VitaCountryInput>;
};

export type VitaCountryInput = {
  localizationValue: Scalars['String'];
};

/** Types to describe cover letter */
export type VitaCoverLetter = {
  __typename?: 'VitaCoverLetter';
  /** #logged-out #soft-logged-in */
  token?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  createdAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  updatedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  theme?: Maybe<VitaDocumentTheme>;
  /** #logged-out #soft-logged-in */
  personalInformation?: Maybe<VitaDocumentCvPersonalInformation>;
  /** #logged-out #soft-logged-in */
  professionalExperience?: Maybe<Array<Maybe<VitaDocumentCvProfessionalExperience>>>;
  /** #logged-out #soft-logged-in */
  educationExperience?: Maybe<Array<Maybe<VitaDocumentCvEducationExperience>>>;
  /** #logged-out #soft-logged-in */
  skills?: Maybe<Array<Maybe<VitaDocumentCvSkill>>>;
  /** #logged-out #soft-logged-in */
  jobDetails?: Maybe<VitaJobDetails>;
  /** #logged-out #soft-logged-in */
  addressTo?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  signature?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  fileAttachments?: Maybe<VitaDocumentFileAttachments>;
  /** #logged-out #soft-logged-in */
  content?: Maybe<Array<VitaCoverLetterContent>>;
  /** #logged-out #soft-logged-in */
  language?: Maybe<VitaDocumentLanguage>;
};

export type VitaCoverLetterContent = VitaCoverLetterContentParagraph | VitaCoverLetterUnorderedList;

export type VitaCoverLetterContentInput = {
  type?: Maybe<Scalars['String']>;
  children?: Maybe<Array<VitaCoverLetterContentInput>>;
  text?: Maybe<Scalars['String']>;
  italic?: Maybe<Scalars['Boolean']>;
  bold?: Maybe<Scalars['Boolean']>;
};

export type VitaCoverLetterContentParagraph = {
  __typename?: 'VitaCoverLetterContentParagraph';
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
  /** #logged-out #soft-logged-in */
  children?: Maybe<Array<VitaCoverLetterText>>;
};

export type VitaCoverLetterListItem = {
  __typename?: 'VitaCoverLetterListItem';
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
  /** #logged-out #soft-logged-in */
  children?: Maybe<Array<VitaCoverLetterText>>;
};

export type VitaCoverLetterText = {
  __typename?: 'VitaCoverLetterText';
  /** #logged-out #soft-logged-in */
  text: Scalars['String'];
  /** #logged-out #soft-logged-in */
  italic?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  bold?: Maybe<Scalars['Boolean']>;
};

export type VitaCoverLetterUnorderedList = {
  __typename?: 'VitaCoverLetterUnorderedList';
  /** #logged-out #soft-logged-in */
  type: Scalars['String'];
  /** #logged-out #soft-logged-in */
  children?: Maybe<Array<VitaCoverLetterListItem>>;
};

export type VitaDocument = {
  __typename?: 'VitaDocument';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['UUID']>;
  /** #logged-out #soft-logged-in */
  token?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  createdAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  updatedAt?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  theme?: Maybe<VitaDocumentTheme>;
  /** #logged-out #soft-logged-in */
  cv?: Maybe<VitaDocumentCv>;
  /** #logged-out #soft-logged-in */
  language?: Maybe<VitaDocumentLanguage>;
  /** #logged-out #soft-logged-in */
  fileAttachments?: Maybe<VitaDocumentFileAttachments>;
};

export type VitaDocumentCv = {
  __typename?: 'VitaDocumentCV';
  /** #logged-out #soft-logged-in */
  personalInformation?: Maybe<VitaDocumentCvPersonalInformation>;
  /** #logged-out #soft-logged-in */
  professionalExperience?: Maybe<Array<Maybe<VitaDocumentCvProfessionalExperience>>>;
  /** #logged-out #soft-logged-in */
  educationExperience?: Maybe<Array<Maybe<VitaDocumentCvEducationExperience>>>;
  /** #logged-out #soft-logged-in */
  skills?: Maybe<Array<Maybe<VitaDocumentCvSkill>>>;
  /** #logged-out #soft-logged-in */
  aboutMe?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  preferences?: Maybe<VitaDocumentCvPreferences>;
};

export type VitaDocumentCvEducationExperience = {
  __typename?: 'VitaDocumentCVEducationExperience';
  /** #logged-out #soft-logged-in */
  courseOfStudy?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  degree?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  institution?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  startDate?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  endDate?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  isStillStudy?: Maybe<Scalars['Boolean']>;
};

export type VitaDocumentCvPersonalInformation = {
  __typename?: 'VitaDocumentCVPersonalInformation';
  /** #logged-out #soft-logged-in */
  firstName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  lastName?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  birthdate?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  birthplace?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  city?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  zip?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  street?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  country?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  phone?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  email?: Maybe<Scalars['String']>;
};

export type VitaDocumentCvPreferences = {
  __typename?: 'VitaDocumentCVPreferences';
  /** #logged-out #soft-logged-in */
  seekingStatus?: Maybe<SeekingStatus>;
  /** #logged-out #soft-logged-in */
  seekingReason?: Maybe<VitaSeekingReason>;
  /** #logged-out #soft-logged-in */
  otherSeekingReason?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  locations?: Maybe<Array<Maybe<VitaDocumentCvPreferencesLocation>>>;
  /** #logged-out #soft-logged-in */
  homeOffice?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  targetPosition?: Maybe<Scalars['String']>;
};

export type VitaDocumentCvPreferencesLocation = {
  __typename?: 'VitaDocumentCVPreferencesLocation';
  /** #logged-out #soft-logged-in */
  cityId?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  cityIdWithScrambling?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  cityName?: Maybe<Scalars['String']>;
};

export type VitaDocumentCvProfessionalExperience = {
  __typename?: 'VitaDocumentCVProfessionalExperience';
  /** #logged-out #soft-logged-in */
  occupation?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  company?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  industry?: Maybe<VitaDocumentCvProfessionalExperienceIndustry>;
  /** #logged-out #soft-logged-in */
  discipline?: Maybe<VitaDocumentCvProfessionalExperienceDiscipline>;
  /** #logged-out #soft-logged-in */
  jobLevel?: Maybe<VitaDocumentCvProfessionalExperienceJobLevel>;
  /** #logged-out #soft-logged-in */
  descriptions?: Maybe<Array<Maybe<VitaDocumentCvProfessionalExperienceDescription>>>;
  /** #logged-out #soft-logged-in */
  startDate?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  endDate?: Maybe<Scalars['Date']>;
  /** #logged-out #soft-logged-in */
  isCurrentEmployer?: Maybe<Scalars['Boolean']>;
};

export type VitaDocumentCvProfessionalExperienceDescription = {
  __typename?: 'VitaDocumentCVProfessionalExperienceDescription';
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
};

export type VitaDocumentCvProfessionalExperienceDiscipline = {
  __typename?: 'VitaDocumentCVProfessionalExperienceDiscipline';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['String']>;
};

export type VitaDocumentCvProfessionalExperienceIndustry = {
  __typename?: 'VitaDocumentCVProfessionalExperienceIndustry';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['String']>;
};

export type VitaDocumentCvProfessionalExperienceJobLevel = {
  __typename?: 'VitaDocumentCVProfessionalExperienceJobLevel';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  value?: Maybe<Scalars['String']>;
};

export type VitaDocumentCvSkill = {
  __typename?: 'VitaDocumentCVSkill';
  /** #logged-out #soft-logged-in */
  skill?: Maybe<Scalars['String']>;
};

export type VitaDocumentError = {
  __typename?: 'VitaDocumentError';
  /** #logged-out #soft-logged-in */
  code?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  message: Scalars['String'];
};

export type VitaDocumentFileAttachment = {
  __typename?: 'VitaDocumentFileAttachment';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['ID']>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['String']>;
};

export type VitaDocumentFileAttachments = {
  __typename?: 'VitaDocumentFileAttachments';
  /** #logged-out #soft-logged-in */
  profileImage?: Maybe<VitaDocumentFileAttachment>;
};

export enum VitaDocumentKind {
  Cv = 'CV',
  Cl = 'CL',
  All = 'ALL'
}

export enum VitaDocumentLanguage {
  De = 'DE',
  En = 'EN'
}

export enum VitaDocumentOrigin {
  Xing = 'XING',
  Lebenslauf = 'LEBENSLAUF'
}

export type VitaDocumentRenderingStatus = {
  __typename?: 'VitaDocumentRenderingStatus';
  /** #logged-out #soft-logged-in */
  status: VitaRenderingStatus;
  /** #logged-out #soft-logged-in */
  token?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['String']>;
};

export type VitaDocumentRenderingStatusError = {
  __typename?: 'VitaDocumentRenderingStatusError';
  /** #logged-out #soft-logged-in */
  message?: Maybe<Scalars['String']>;
};

export type VitaDocumentRenderingStatusResult = VitaDocumentRenderingStatus | VitaDocumentRenderingStatusError;

export type VitaDocumentResult = VitaDocument | VitaCoverLetter | VitaDocumentError;

export type VitaDocumentTheme = {
  __typename?: 'VitaDocumentTheme';
  /** #logged-out #soft-logged-in */
  color?: Maybe<VitaDocumentThemeColor>;
  /** #logged-out #soft-logged-in */
  template?: Maybe<VitaDocumentThemeTemplate>;
};

export enum VitaDocumentThemeColor {
  Brown = 'BROWN',
  DarkBlue = 'DARK_BLUE',
  DarkGreen = 'DARK_GREEN',
  Grey = 'GREY',
  LightBlue = 'LIGHT_BLUE',
  LightGreen = 'LIGHT_GREEN',
  LightSea = 'LIGHT_SEA',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE'
}

export enum VitaDocumentThemeTemplate {
  Creative = 'CREATIVE',
  Traditional = 'TRADITIONAL',
  TraditionalCoverLetter = 'TRADITIONAL_COVER_LETTER',
  Modern = 'MODERN',
  Frame = 'FRAME',
  Timeline = 'TIMELINE',
  Business = 'BUSINESS',
  Elegant = 'ELEGANT'
}

export type VitaEmailSettingInput = {
  active?: Maybe<Scalars['Email']>;
};

export type VitaImportDocumentPersonalInformation = {
  __typename?: 'VitaImportDocumentPersonalInformation';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['Date']>;
  city?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** #rest #virtual */
  settings?: Maybe<AccountSettings>;
  /** #rest #virtual */
  userDetails?: Maybe<XingIdContactDetails>;
  photoUrl?: Maybe<Scalars['String']>;
};

export type VitaImportDocumentPersonalInformationInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  birthdate?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  settings?: Maybe<VitaAccountSettingsInput>;
  userDetails?: Maybe<VitaXingIdContactDetailsInput>;
  photoUrl?: Maybe<Scalars['String']>;
};

export type VitaIndustryDisciplineJobLevelInput = {
  id?: Maybe<Scalars['String']>;
  localizationValue?: Maybe<Scalars['String']>;
};

export type VitaJobDetails = {
  __typename?: 'VitaJobDetails';
  /** #logged-out #soft-logged-in */
  title?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
};

export type VitaJobDetailsInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type VitaProfileAboutMe = {
  __typename?: 'VitaProfileAboutMe';
  aboutMe?: Maybe<Scalars['String']>;
};

export type VitaProfileAboutMeInput = {
  aboutMe?: Maybe<Scalars['String']>;
};

export type VitaProfileEducation = {
  __typename?: 'VitaProfileEducation';
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  isStillStudy?: Maybe<Scalars['Boolean']>;
  degree?: Maybe<Scalars['String']>;
  institution?: Maybe<Scalars['String']>;
  courseOfStudy?: Maybe<Scalars['String']>;
};

export type VitaProfileEducationCollection = {
  __typename?: 'VitaProfileEducationCollection';
  education?: Maybe<Array<Maybe<VitaProfileEducation>>>;
};

export type VitaProfileEducationCollectionInput = {
  education?: Maybe<Array<Maybe<VitaProfileEducationInput>>>;
};

export type VitaProfileEducationInput = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  degree?: Maybe<Scalars['String']>;
  institution?: Maybe<Scalars['String']>;
  courseOfStudy?: Maybe<Scalars['String']>;
  isStillStudy?: Maybe<Scalars['Boolean']>;
};

/** TYPES to retrieve Profile import data. */
export type VitaProfileImport = {
  __typename?: 'VitaProfileImport';
  /** #rest(batched) #virtual */
  personalInformation?: Maybe<VitaImportDocumentPersonalInformation>;
  /** #rest #virtual */
  educationExperience?: Maybe<VitaProfileEducationCollection>;
  /** #rest #virtual */
  professionalExperience?: Maybe<VitaProfileWorkExperienceCollection>;
  /** #rest #virtual */
  skills?: Maybe<VitaProfileSkills>;
  /** #rest #virtual */
  aboutMe?: Maybe<VitaProfileAboutMe>;
};

export type VitaProfileSkill = {
  __typename?: 'VitaProfileSkill';
  value?: Maybe<Scalars['String']>;
};

export type VitaProfileSkillInput = {
  value?: Maybe<Scalars['String']>;
};

export type VitaProfileSkills = {
  __typename?: 'VitaProfileSkills';
  collection?: Maybe<Array<Maybe<VitaProfileSkill>>>;
};

export type VitaProfileSkillsInput = {
  collection?: Maybe<Array<Maybe<VitaProfileSkillInput>>>;
};

export type VitaProfileWorkExperience = {
  __typename?: 'VitaProfileWorkExperience';
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  isCurrentEmployer?: Maybe<Scalars['Boolean']>;
  occupation?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  /** #rest(batched) #virtual */
  industries?: Maybe<Array<Maybe<Industry>>>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  discipline?: Maybe<Discipline>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  jobLevel?: Maybe<CareerLevel>;
  descriptions?: Maybe<Scalars['String']>;
};

export type VitaProfileWorkExperienceCollection = {
  __typename?: 'VitaProfileWorkExperienceCollection';
  collection?: Maybe<Array<Maybe<VitaProfileWorkExperience>>>;
};

export type VitaProfileWorkExperienceCollectionInput = {
  collection?: Maybe<Array<Maybe<VitaProfileWorkExperienceInput>>>;
};

export type VitaProfileWorkExperienceInput = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Maybe<VitaIndustryDisciplineJobLevelInput>>>;
  discipline?: Maybe<VitaIndustryDisciplineJobLevelInput>;
  jobLevel?: Maybe<VitaIndustryDisciplineJobLevelInput>;
  isCurrentEmployer?: Maybe<Scalars['Boolean']>;
  descriptions?: Maybe<Scalars['String']>;
};

export enum VitaRenderingStatus {
  Ready = 'READY',
  Pending = 'PENDING',
  None = 'NONE'
}

export enum VitaSeekingReason {
  AlreadyHaveJobToApply = 'ALREADY_HAVE_JOB_TO_APPLY',
  NotForJobToApply = 'NOT_FOR_JOB_TO_APPLY',
  KeepCvUpToDate = 'KEEP_CV_UP_TO_DATE',
  JustTestCvEditor = 'JUST_TEST_CV_EDITOR',
  Other = 'OTHER'
}

export type VitaXingIdContactDetailsDataInput = {
  address?: Maybe<VitaAddressInput>;
};

export type VitaXingIdContactDetailsInput = {
  business?: Maybe<VitaXingIdContactDetailsDataInput>;
  private?: Maybe<VitaXingIdContactDetailsDataInput>;
};

export type VompClickReason = {
  /** Input Click Reason data to be encoded. */
  input?: Maybe<ClickReasonInput>;
  /** Encoded Click Reason data. */
  encoded?: Maybe<Scalars['String']>;
};

export type VompConversationStarter = ConversationStarter & {
  __typename?: 'VompConversationStarter';
  /** #rest(batched) #virtual */
  actor?: Maybe<QualifiedVompVisitor>;
  /** #rest(batched) #virtual */
  object?: Maybe<QualifiedVomp>;
  /** #rest(batched) #virtual */
  target?: Maybe<QualifiedVompVisitee>;
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type VompHighlights = {
  __typename?: 'VompHighlights';
  /**
   * #virtual
   *
   *  Total number of visits
   */
  totalVisits: Scalars['Int'];
  /**
   * #virtual
   *
   *  Total number of unique visitors
   */
  visitors?: Maybe<Scalars['Int']>;
  /**
   * #virtual
   *
   *  Total number of recruiters
   */
  recruiters?: Maybe<Scalars['Int']>;
};

/** VOMP Notification Type */
export type VompNotification = {
  __typename?: 'VompNotification';
  /** VOMP Notification ID */
  id: Scalars['ID'];
  /** Trend percentage representing the increase or decrease by the visits */
  visitsTrend?: Maybe<Scalars['Float']>;
  /** Value of the interval what the visits have been done */
  intervalValue: Scalars['Int'];
  /** Unit of time regarding the interval what the visits have been done */
  intervalUnitTime: VompNotificationUnitTime;
  /** Collection of visits */
  visits?: Maybe<Array<VompVisit>>;
};

/** Available unit of times for the interval of time about the visits */
export enum VompNotificationUnitTime {
  Hours = 'HOURS',
  Days = 'DAYS'
}

export enum VompPlatformEnum {
  Android = 'ANDROID',
  Ios = 'IOS',
  WebSmallScreen = 'WEB_SMALL_SCREEN',
  WebLargeScreen = 'WEB_LARGE_SCREEN',
  Web = 'WEB'
}

export type VompStack = SignalsStack & {
  __typename?: 'VompStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type VompStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

export type VompStatistics = {
  __typename?: 'VompStatistics';
  searchTerms: StatisticsItem;
  recruiters: StatisticsItem;
  firstTimeVisitors: StatisticsItem;
  industryVisitors: StatisticsItem;
  companyVisitors: StatisticsItem;
  visitorTypes: StatisticsItem;
  /** @deprecated It should be replaced to graphVisitor. */
  graph?: Maybe<Array<StatisticsGraph>>;
  graphVisitor: VisitsGraph;
};

export type VompVisit = {
  visitorId: Scalars['ID'];
  type: Scalars['String'];
  viewedAt: Scalars['Date'];
};

export type VoucherRedeemMutationInput = {
  voucherCode: Scalars['String'];
};

/** Voucher redemption mutation for premium engagement */
export type VoucherRedemptionMutationResult = VoucherRedemptionSuccess | PremiumEngagementMutationError;

export type VoucherRedemptionSuccess = {
  __typename?: 'VoucherRedemptionSuccess';
  code?: Maybe<Scalars['String']>;
  redeemedAt?: Maybe<Scalars['String']>;
  bonusDays?: Maybe<Scalars['Int']>;
};

export type VoucherSpecialRedemptionMutationResult = VoucherSpecialRedemptionSuccess | PremiumEngagementMutationError;

export type VoucherSpecialRedemptionSuccess = {
  __typename?: 'VoucherSpecialRedemptionSuccess';
  code?: Maybe<Scalars['String']>;
  requiresPaymentData?: Maybe<Scalars['Boolean']>;
  sequenceId?: Maybe<Scalars['Int']>;
  bonusDays?: Maybe<Scalars['Int']>;
};

export type WebOrderInput = {
  contractId: Scalars['ID'];
};

export type WebPushSubscription = {
  __typename?: 'WebPushSubscription';
  /** #logged-out #soft-logged-in */
  subscriptionStatus: Scalars['String'];
  /** #logged-out #soft-logged-in */
  notificationEnv: Scalars['String'];
  /** #logged-out #soft-logged-in */
  visitorId: Scalars['String'];
  /** #logged-out #soft-logged-in */
  jobId: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  events: Scalars['String'];
  /** #logged-out #soft-logged-in */
  publicKey?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  url?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  authDetails?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  updatedAt?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  createdAt?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  ellipticCurve?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  locale?: Maybe<Scalars['String']>;
};

/**
 * [TETRIS](https://new-work.atlassian.net/wiki/spaces/SOLAR/pages/45877297/REST+API+for+TETRIS) tracking properties for the viewer.
 *
 * This specifically uses a different field casing than the normal `camelCase` of the
 * `New Work One` platform, because it's exported to an external tracking system
 */
export type WebTrackingData = {
  __typename?: 'WebTrackingData';
  PropUserBusinessCountry?: Maybe<Scalars['String']>;
  PropHashedUserId?: Maybe<Scalars['String']>;
  PropLastLogin?: Maybe<Scalars['Int']>;
  PropNumberContacts?: Maybe<Scalars['Int']>;
  PropSuccessfulInvitation?: Maybe<Scalars['Int']>;
  PropMembership?: Maybe<Scalars['Int']>;
  PropMemberships?: Maybe<Scalars['String']>;
  PropUserBusinessStatus?: Maybe<Scalars['String']>;
  PropApplicationLanguage?: Maybe<Scalars['String']>;
  PropAccountDuration?: Maybe<Scalars['Int']>;
  /** #soft-logged-in */
  PropTrackingThirdpartyMarketing?: Maybe<Scalars['Boolean']>;
  /** #soft-logged-in */
  PropTrackingThirdpartyStatistical?: Maybe<Scalars['Boolean']>;
  /** #soft-logged-in */
  PropTrackingThirdpartyExternal?: Maybe<Scalars['Boolean']>;
  PropBrazeAuthToken?: Maybe<Scalars['String']>;
};

export type WillingnessToChangeJob = {
  __typename?: 'WillingnessToChangeJob';
  probability?: Maybe<Scalars['String']>;
  reasons?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum WillingnessToTravelPreference {
  None = 'NONE',
  Occasional = 'OCCASIONAL',
  Frequent = 'FREQUENT'
}

export enum WillingnessToTravelPreferenceEnum {
  None = 'NONE',
  Occasional = 'OCCASIONAL',
  Frequent = 'FREQUENT'
}

export type WinningAd = {
  /**
   * #logged-out #soft-logged-in
   * @deprecated Field no longer supported
   */
  id: Scalars['Int'];
  /** #logged-out #soft-logged-in */
  sid: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  surn: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  type: AdTypes;
  /** #logged-out #soft-logged-in */
  description?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  trackingToken: Scalars['String'];
  /** #logged-out #soft-logged-in */
  sender: AdSender;
  /** #logged-out #soft-logged-in */
  deliveryId: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   * @deprecated ODT shutdown
   */
  odtTrackingToken: Scalars['String'];
};

export type WorkExperienceError = {
  __typename?: 'WorkExperienceError';
  message: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<WorkExperienceFieldErrors>;
};

export type WorkExperienceFieldErrors = {
  __typename?: 'WorkExperienceFieldErrors';
  companyName?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyId?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobTitle?: Maybe<Array<Maybe<Scalars['String']>>>;
  statusId?: Maybe<Array<Maybe<Scalars['String']>>>;
  levelId?: Maybe<Array<Maybe<Scalars['String']>>>;
  disciplineId?: Maybe<Array<Maybe<Scalars['String']>>>;
  industryId?: Maybe<Array<Maybe<Scalars['String']>>>;
  beginDate?: Maybe<Array<Maybe<Scalars['String']>>>;
  endDate?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WorkExperienceStatus = Localizable & {
  __typename?: 'WorkExperienceStatus';
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /** #logged-out #soft-logged-in */
  localizationKey: Scalars['String'];
  /** #logged-out #soft-logged-in */
  localizationValue: Scalars['String'];
};

export type WorkExperienceUpdateConversationStarter = ConversationStarter & {
  __typename?: 'WorkExperienceUpdateConversationStarter';
  /** #rest(batched) #virtual */
  actor?: Maybe<XingId>;
  /** #rest #virtual */
  object?: Maybe<ProfileWorkExperienceUpdate>;
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
};

export type WorkExperienceUpdateStack = SignalsStack & {
  __typename?: 'WorkExperienceUpdateStack';
  id: Scalars['ID'];
  newSignals: Scalars['Int'];
  totalSignals: Scalars['Int'];
  createdAt: Scalars['Date'];
  listedAt: Scalars['Date'];
  trackingToken?: Maybe<Scalars['String']>;
  /**
   * #paginated
   * @deprecated Conversation Starters app is decommissioned
   */
  signals?: Maybe<SignalsCollectionConnection>;
};


export type WorkExperienceUpdateStackSignalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

/** WorkingHoursPreference Type */
export type WorkingHoursPreference = {
  __typename?: 'WorkingHoursPreference';
  fullTime: Scalars['Boolean'];
  partTime: Scalars['Boolean'];
};

/** WorkplacePreference Type */
export type WorkplacePreference = {
  __typename?: 'WorkplacePreference';
  office: Scalars['Boolean'];
  partlyHome: Scalars['Boolean'];
  mostlyHome: Scalars['Boolean'];
  homeOffice: Scalars['Boolean'];
};

/** Information about a Job for the editor */
export type XjmJob = {
  __typename?: 'XJMJob';
  id: Scalars['ID'];
  jobManagerUrl: Scalars['URL'];
  /** #rest #virtual */
  potentialCandidates?: Maybe<PotentialCandidatesCollection>;
  /** #rest #virtual */
  potentialCandidatesTotals?: Maybe<PotentialCandidatesTotals>;
};


/** Information about a Job for the editor */
export type XjmJobPotentialCandidatesArgs = {
  interactions: Array<PotentialCandidatesInteraction>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  order: PotentialCandidatesOrder;
};

export type XjmProfileAdditionalDetails = {
  __typename?: 'XJMProfileAdditionalDetails';
  businessCountry?: Maybe<Scalars['String']>;
  businessCity?: Maybe<Scalars['String']>;
  education?: Maybe<Array<Maybe<ProfileEducation>>>;
  workExperience?: Maybe<Array<Maybe<ProfileWorkExperience>>>;
};

export type XingId = HasGlobalId & {
  __typename?: 'XingId';
  /**
   * #logged-out #soft-logged-in
   *
   *  Globally unique id for this instance based on typename and id
   */
  globalId: Scalars['GlobalID'];
  /** #logged-out #soft-logged-in */
  academicTitle?: Maybe<AcademicTitle>;
  /**
   * #logged-out #soft-logged-in
   *
   *  academic_title + first_name + last_name
   */
  displayName: Scalars['String'];
  /** #logged-out #soft-logged-in */
  firstName: Scalars['String'];
  /** #logged-out #soft-logged-in */
  lastName: Scalars['String'];
  /** #logged-out #soft-logged-in */
  gender?: Maybe<Gender>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Indicates whether users have a default headerImage for their current subscription.
   */
  hasDefaultHeaderImage: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Indicates whether headerImage for user must be upselled (fenced) or not
   */
  isUpsellRequiredForHeaderImage: Scalars['Boolean'];
  /** #logged-out #soft-logged-in */
  id: Scalars['ID'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Used inside urls e.g. /profile/John_Doe
   */
  pageName: Scalars['String'];
  /**
   * #logged-out #soft-logged-in
   *
   *  This XING ID is not accessible to the requester. Will be true if the requester is blocked by the XING ID (requesterIsStalker) OR the requester is blocking this XING ID (requesterIsVictim)
   */
  isBlockedForViewer: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  The requester is blocked by the XING ID. In other words, the requester is the stalker here and the visited XING ID is the victim
   */
  requesterIsStalker: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  The requester is blocking this XING ID. In other words, the requester is the victim here and the visited XING ID is the stalker
   */
  requesterIsVictim: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  User-defined occupations data
   */
  occupations?: Maybe<Array<Maybe<XingIdOccupation>>>;
  /** #logged-out #soft-logged-in */
  location?: Maybe<XingIdLocation>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Does the user have a profile photo?
   */
  hasNoProfilePhoto: Scalars['Boolean'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Hiring Flag
   */
  isHiring?: Maybe<Scalars['Boolean']>;
  /**
   * #logged-out #soft-logged-in
   *
   *  Hiring Details Flag
   */
  hasHiringDetails?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  profileImage?: Maybe<Array<Maybe<ProfileImage>>>;
  /** #logged-out #soft-logged-in #virtual */
  headerImage?: Maybe<Array<HeaderImage>>;
  /**
   * #rest(batched) #virtual
   *
   *  Relationship between 2 users
   */
  networkRelationship?: Maybe<NetworkRelationship>;
  /**
   * #rest(batched) #virtual
   *
   *  Request Click Reason data by its ID.
   */
  clickReasonProfileUrl?: Maybe<ClickReason>;
  /**
   * #rest(batched) #virtual
   *
   *  Request Click Reason data by its ID from a specific Entity.
   * SourceEntityId is basically the ID of the entity where the profile URL was seen and clicked.
   * For instance, if you see a profile link in a group, the sourceEntityId will be the group ID.
   */
  clickReasonProfileUrlFromEntity?: Maybe<ClickReason>;
  /**
   * #rest(batched) #virtual
   *
   *  B2B Client ID
   */
  b2bClientId?: Maybe<ProfilesB2bClientIdPayload>;
  /**
   * #logged-out #soft-logged-in #virtual
   *
   *  Combination of memberships and roles to be displayed as flag (UI related). Replaced by userFlags. Removed from the BE, will always return null
   * @deprecated Replaced by userFlags. Removed from the BE, will always return null. Checked on 2023.03.16 - still used by old mobile versions and unknown web ver.
   */
  displayFlag?: Maybe<DisplayFlag>;
  /**
   * Self representational quote of the user
   * @deprecated Is not part of XingID type anymore. See `status` field (in IDL). Checked on 2023.03.16 - still used by old mobile versions
   */
  profileQuote?: Maybe<Scalars['String']>;
  /** @deprecated Is not part of XingID type anymore. Will be exposed differently. Checked on 2023.03.16 - still used by unknown Web versions */
  birthday?: Maybe<Scalars['Date']>;
  /**
   * Level of contact. 1 - in contact, 0 - not a contact, 2 - contact of your contacts etc
   * @deprecated This field is no longer served in XingId node. Checked on 2023.03.16 - still used by active mobile app versions
   */
  contactDegree?: Maybe<Scalars['Int']>;
  /** #logged-out #soft-logged-in */
  status?: Maybe<ProfilePersonalStatus>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  userFlags?: Maybe<UserFlags>;
  /**
   * #logged-out #soft-logged-in #rest(batched) #virtual
   * @deprecated Use occupations instead. Checked on 14.11.2023 - still used a lot by Web and Mobile
   */
  profileOccupation?: Maybe<ProfileOccupation>;
};


export type XingIdProfileImageArgs = {
  size: Array<ProfileImageSize>;
};


export type XingIdHeaderImageArgs = {
  options: Array<ImageOptions>;
};


export type XingIdClickReasonProfileUrlArgs = {
  clickReasonId: ClickReasonsEnum;
};


export type XingIdClickReasonProfileUrlFromEntityArgs = {
  clickReasonId: ClickReasonsEnum;
  sourceEntityId: Scalars['SlugOrID'];
};

/** XingIdActionInterface */
export type XingIdActionInterface = {
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Action Payload for XING ID Module actions */
export type XingIdActionPayloadInterface = {
  xingIdModule?: Maybe<XingIdModule>;
};


/** Action Payload for XING ID Module actions */
export type XingIdActionPayloadInterfaceXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

/** Add a Contact */
export type XingIdAddAsContactAction = XingIdActionInterface & {
  __typename?: 'XingIdAddAsContactAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

export type XingIdAddContactInput = {
  id: Scalars['ID'];
};

export type XingIdAddContactPayload = XingIdActionPayloadInterface & {
  __typename?: 'XingIdAddContactPayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
  /**
   * #rest
   *
   *  XingIdModule of the target user (the contacted user)
   */
  xingIdModule?: Maybe<XingIdModule>;
};


export type XingIdAddContactPayloadXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

/** Add a ProBusiness Lead */
export type XingIdAddLeadAction = XingIdActionInterface & {
  __typename?: 'XingIdAddLeadAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Block a user */
export type XingIdBlockUserAction = XingIdActionInterface & {
  __typename?: 'XingIdBlockUserAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Bookmarking Users Feature was shutdown on 2020-11-23. This value need to be kept for legacy clients. */
export type XingIdBookmarkUserAction = XingIdActionInterface & {
  __typename?: 'XingIdBookmarkUserAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Do a phone call for a profile */
export type XingIdCallAction = XingIdActionInterface & {
  __typename?: 'XingIdCallAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Confirm a contact request */
export type XingIdConfirmContactAction = XingIdActionInterface & {
  __typename?: 'XingIdConfirmContactAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

export type XingIdConfirmContactInput = {
  id: Scalars['ID'];
};

/** XingIdConfirmContact payload */
export type XingIdConfirmContactPayload = XingIdActionPayloadInterface & {
  __typename?: 'XingIdConfirmContactPayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
  /**
   * #rest
   *
   *  XingIdModule of the target user (the confirmed user as a contact)
   */
  xingIdModule?: Maybe<XingIdModule>;
};


/** XingIdConfirmContact payload */
export type XingIdConfirmContactPayloadXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

/** Contact details of the user */
export type XingIdContactDetails = {
  __typename?: 'XingIdContactDetails';
  /** Business contact details of the user */
  business?: Maybe<XingIdContactDetailsData>;
  /** Private contact details of the user */
  private?: Maybe<XingIdContactDetailsData>;
};

/** Contact details data of the user */
export type XingIdContactDetailsData = {
  __typename?: 'XingIdContactDetailsData';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['Email']>;
  phone?: Maybe<PhoneNumber>;
  fax?: Maybe<PhoneNumber>;
  mobile?: Maybe<PhoneNumber>;
};

/** Decline contact request */
export type XingIdDeclineContactRequestAction = XingIdActionInterface & {
  __typename?: 'XingIdDeclineContactRequestAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

export type XingIdDeclineContactRequestInput = {
  id: Scalars['ID'];
};

/** XingIdDeclineContactRequest payload */
export type XingIdDeclineContactRequestPayload = XingIdActionPayloadInterface & {
  __typename?: 'XingIdDeclineContactRequestPayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
  /**
   * #rest
   *
   *  XingIdModule of the target user
   */
  xingIdModule?: Maybe<XingIdModule>;
};


/** XingIdDeclineContactRequest payload */
export type XingIdDeclineContactRequestPayloadXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

/** Delete contact */
export type XingIdDeleteContactAction = XingIdActionInterface & {
  __typename?: 'XingIdDeleteContactAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

export type XingIdDeleteContactInput = {
  id: Scalars['ID'];
};

/** XingIdDeleteContact payload */
export type XingIdDeleteContactPayload = XingIdActionPayloadInterface & {
  __typename?: 'XingIdDeleteContactPayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
  /**
   * #rest
   *
   *  XingIdModule of the target user
   */
  xingIdModule?: Maybe<XingIdModule>;
};


/** XingIdDeleteContact payload */
export type XingIdDeleteContactPayloadXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

/** XingIdDeleteHeaderImage payload */
export type XingIdDeleteHeaderImagePayload = XingIdActionPayloadInterface & {
  __typename?: 'XingIdDeleteHeaderImagePayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
  /**
   * #rest
   *
   *  XingIdModule of the logged in user
   */
  xingIdModule?: Maybe<XingIdModule>;
};


/** XingIdDeleteHeaderImage payload */
export type XingIdDeleteHeaderImagePayloadXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

/** XingIdDeleteProfileImage payload */
export type XingIdDeleteProfileImagePayload = XingIdActionPayloadInterface & {
  __typename?: 'XingIdDeleteProfileImagePayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
  /**
   * #rest
   *
   *  XingIdModule of the logged in user
   */
  xingIdModule?: Maybe<XingIdModule>;
};


/** XingIdDeleteProfileImage payload */
export type XingIdDeleteProfileImagePayloadXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

/** Edit your XING ID */
export type XingIdEditXingIdAction = XingIdActionInterface & {
  __typename?: 'XingIdEditXingIdAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Follow an insider */
export type XingIdFollowAction = XingIdActionInterface & {
  __typename?: 'XingIdFollowAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

export type XingIdFollowInput = {
  id: Scalars['ID'];
};

/** XingIdFollow payload */
export type XingIdFollowPayload = XingIdActionPayloadInterface & {
  __typename?: 'XingIdFollowPayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
  /**
   * #rest
   *
   *  XingIdModule of the target user (the followed user)
   */
  xingIdModule?: Maybe<XingIdModule>;
};


/** XingIdFollow payload */
export type XingIdFollowPayloadXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

/** Import VCard */
export type XingIdImportVcardAction = XingIdActionInterface & {
  __typename?: 'XingIdImportVcardAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Invite user to a group */
export type XingIdInviteGroupAction = XingIdActionInterface & {
  __typename?: 'XingIdInviteGroupAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Launch profile filling wizard for my profile */
export type XingIdLaunchWizardAction = XingIdActionInterface & {
  __typename?: 'XingIdLaunchWizardAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Determines which layout should be used when rendering this module */
export enum XingIdLayout {
  /** Represents the basic layout */
  Basic = 'BASIC',
  /** Represents the premium layout */
  Premium = 'PREMIUM'
}

/** XING ID Location */
export type XingIdLocation = Addressable & {
  __typename?: 'XingIdLocation';
  /** #logged-out #soft-logged-in */
  city?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in #rest(batched) #virtual */
  country?: Maybe<Country>;
  /** #logged-out #soft-logged-in */
  displayLocation?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  province?: Maybe<Province>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type XingIdModule = ModuleInterface & OutdatableModule & {
  __typename?: 'XingIdModule';
  /**
   * #soft-logged-in
   *
   *  Call to Actions
   */
  actions: Array<XingIdActionInterface>;
  /**
   * #soft-logged-in #rest #virtual
   *
   *  Private and business contact details of the user
   */
  contactDetails?: Maybe<XingIdContactDetails>;
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  title: Scalars['String'];
  /** #soft-logged-in */
  globalId: Scalars['GlobalID'];
  /** #soft-logged-in */
  outdated: Scalars['Boolean'];
  /** #soft-logged-in */
  outdatedFields?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  lastModified?: Maybe<Scalars['Date']>;
  /** #soft-logged-in */
  layout: XingIdLayout;
  /** #rest(batched) #virtual */
  xingId?: Maybe<XingId>;
  active?: Maybe<Scalars['Boolean']>;
};

/** Show my ProJob's career wishes settings */
export type XingIdMyCareerWishesAction = XingIdActionInterface & {
  __typename?: 'XingIdMyCareerWishesAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** XING ID Occupations */
export type XingIdOccupation = {
  __typename?: 'XingIdOccupation';
  /**
   * #logged-out #soft-logged-in
   *
   *  Identifier of Occupation's category
   */
  category: XingIdOccupationCategory;
  /**
   * #logged-out #soft-logged-in
   *
   *  Markdown-powered occupation text. The text translated using current_user's language settings
   */
  summary: Scalars['Markdown'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Company name for employees, school name for students, occupation text for insiders, coaches and ambassadors
   */
  headline: Scalars['String'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Job title for employees, subject for students, empty for insiders, coaches and ambassadors
   */
  subline: Scalars['String'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Fallback links for URN links in the summary
   */
  links?: Maybe<Array<XingIdOccupationLink>>;
};

/** Describes category of occupation */
export enum XingIdOccupationCategory {
  /** student, teacher etc */
  Education = 'EDUCATION',
  /** employee, executive etc */
  WorkExperience = 'WORK_EXPERIENCE',
  /** retired, unemployed etc */
  Inactive = 'INACTIVE',
  /** ambassador, insider, etc */
  Role = 'ROLE',
  /** recruiter */
  Other = 'OTHER'
}

/** XING ID Occupation Links */
export type XingIdOccupationLink = UniformResourceNameable & {
  __typename?: 'XingIdOccupationLink';
  /**
   * #logged-out #soft-logged-in
   *
   *  URN which is linked in the summary
   */
  urn: Scalars['URN'];
  /**
   * #logged-out #soft-logged-in
   *
   *  Fallback HTTP link
   */
  url: Scalars['URL'];
};

/** Enum type of the bucket */
export enum XingIdOccupationsBucketType {
  /** Publicliy visible occupations */
  Visible = 'VISIBLE',
  /** Current occupations */
  Current = 'CURRENT',
  /** Past occupations */
  Past = 'PAST',
  /** Roles occupations */
  Roles = 'ROLES',
  /** Occupations that represent the degrees of a user. */
  Degrees = 'DEGREES'
}

/** Open the insider article collection */
export type XingIdOpenInsiderCollectionAction = XingIdActionInterface & {
  __typename?: 'XingIdOpenInsiderCollectionAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Open LO Profile Preview */
export type XingIdOpenLoPreviewAction = XingIdActionInterface & {
  __typename?: 'XingIdOpenLoPreviewAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Open Recruiter Previewo of XTM */
export type XingIdOpenRecruiterPreviewAction = XingIdActionInterface & {
  __typename?: 'XingIdOpenRecruiterPreviewAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Open settings */
export type XingIdOpenSettingsAction = XingIdActionInterface & {
  __typename?: 'XingIdOpenSettingsAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Open profile in XTM  application */
export type XingIdOpenXtmAction = XingIdActionInterface & {
  __typename?: 'XingIdOpenXtmAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

export type XingIdOrError = XingId | ResponseError;

export enum XingIdPlatform {
  /** Do not notify any channel */
  None = 'NONE',
  /** Notify mobile apps */
  Mobile = 'MOBILE',
  /** Notify web */
  Web = 'WEB'
}

/** Show a printable version of the profile */
export type XingIdPrintAction = XingIdActionInterface & {
  __typename?: 'XingIdPrintAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Remove a ProBusiness Lead */
export type XingIdRemoveLeadAction = XingIdActionInterface & {
  __typename?: 'XingIdRemoveLeadAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

export type XingIdReorderOccupationsInput = {
  occupationIds: Array<Scalars['ID']>;
};

/** XingIdReorderOccupations response object */
export type XingIdReorderOccupationsPayload = XingIdActionPayloadInterface & {
  __typename?: 'XingIdReorderOccupationsPayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
  /**
   * #rest
   *
   *  XingIdModule of the logged in user
   */
  xingIdModule?: Maybe<XingIdModule>;
};


/** XingIdReorderOccupations response object */
export type XingIdReorderOccupationsPayloadXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

/** Report the profile */
export type XingIdReportProfileAction = XingIdActionInterface & {
  __typename?: 'XingIdReportProfileAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Send a message */
export type XingIdSendMessageAction = XingIdActionInterface & {
  __typename?: 'XingIdSendMessageAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Share a profile */
export type XingIdShareAction = XingIdActionInterface & {
  __typename?: 'XingIdShareAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Show my ProJob's career wishes */
export type XingIdShowCareerWishesAction = XingIdActionInterface & {
  __typename?: 'XingIdShowCareerWishesAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Show users contact details */
export type XingIdShowContactDetailsAction = XingIdActionInterface & {
  __typename?: 'XingIdShowContactDetailsAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Unblock a user */
export type XingIdUnblockUserAction = XingIdActionInterface & {
  __typename?: 'XingIdUnblockUserAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Bookmarking Users Feature was shutdown on 2020-11-23. This value need to be kept for legacy clients. */
export type XingIdUnbookmarkUserAction = XingIdActionInterface & {
  __typename?: 'XingIdUnbookmarkUserAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

/** Unfollow an insider */
export type XingIdUnfollowAction = XingIdActionInterface & {
  __typename?: 'XingIdUnfollowAction';
  /** #soft-logged-in */
  type: AvailableAction;
  /** #soft-logged-in */
  label: Scalars['String'];
  /** #soft-logged-in */
  order: Scalars['Int'];
  /** #soft-logged-in */
  isUpsellRequiredForViewer?: Maybe<Scalars['Boolean']>;
};

export type XingIdUnfollowInput = {
  id: Scalars['ID'];
};

/** XingIdUnfollow payload */
export type XingIdUnfollowPayload = XingIdActionPayloadInterface & {
  __typename?: 'XingIdUnfollowPayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
  /**
   * #rest
   *
   *  XingIdModule of the target user (the unfollowed user)
   */
  xingIdModule?: Maybe<XingIdModule>;
};


/** XingIdUnfollow payload */
export type XingIdUnfollowPayloadXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

export type XingIdUpdateContactDetails = {
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  /** The canonical name of the province */
  provinceName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<CountryCodesAlpha2>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
};

export type XingIdUpdateContactDetailsInput = {
  private?: Maybe<XingIdUpdateContactDetails>;
  business?: Maybe<XingIdUpdateContactDetails>;
};

export type XingIdUpdateContactDetailsPayload = XingIdActionPayloadInterface & {
  __typename?: 'XingIdUpdateContactDetailsPayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
  /**
   * #rest
   *
   *  XingId module of the logged-in user
   */
  xingIdModule?: Maybe<XingIdModule>;
};


export type XingIdUpdateContactDetailsPayloadXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

export type XingIdUpdateHeaderImageInput = {
  /** base64 encoded image */
  image64: Scalars['String'];
  publishStreamStory?: Maybe<Scalars['Boolean']>;
};

/** XingIdUpdateHeaderImage payload */
export type XingIdUpdateHeaderImagePayload = XingIdActionPayloadInterface & {
  __typename?: 'XingIdUpdateHeaderImagePayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
  /**
   * #rest
   *
   *  XingIdModule of the logged in user
   */
  xingIdModule?: Maybe<XingIdModule>;
};


/** XingIdUpdateHeaderImage payload */
export type XingIdUpdateHeaderImagePayloadXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

export type XingIdUpdateProfileImageInput = {
  /** base64 encoded image */
  image64: Scalars['String'];
  notifyPlatforms: Array<XingIdPlatform>;
};

/** XingIdUpdateProfileImage Payload */
export type XingIdUpdateProfileImagePayload = {
  __typename?: 'XingIdUpdateProfileImagePayload';
  /** #virtual */
  error?: Maybe<Scalars['DomainError']>;
};

export type XingIdUpdateProfileImageUploadPayload = {
  __typename?: 'XingIdUpdateProfileImageUploadPayload';
  currentStatus: Scalars['String'];
  percentage?: Maybe<Scalars['Int']>;
  nextPercentage?: Maybe<Scalars['Int']>;
};

export type XingIdUpdateStatusError = {
  __typename?: 'XingIdUpdateStatusError';
  message: Scalars['String'];
  errors?: Maybe<XingIdUpdateStatusErrors>;
};

export type XingIdUpdateStatusErrors = {
  __typename?: 'XingIdUpdateStatusErrors';
  internal?: Maybe<Scalars['String']>;
  /** In case something is wrong with the custom status we show a error message */
  text?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type XingIdUpdateStatusInput = {
  /** One element of the ProfilePersonalStatuses */
  identifier?: Maybe<ProfilePersonalStatuses>;
  /** The custom status that should be displayed */
  text?: Maybe<Scalars['String']>;
};

export type XingIdUpdateStatusPayload = {
  __typename?: 'XingIdUpdateStatusPayload';
  success?: Maybe<XingIdUpdateStatusSuccess>;
  error?: Maybe<XingIdUpdateStatusError>;
};

export type XingIdUpdateStatusSuccess = {
  __typename?: 'XingIdUpdateStatusSuccess';
  /** #rest */
  xingIdModule?: Maybe<XingIdModule>;
};


export type XingIdUpdateStatusSuccessXingIdModuleArgs = {
  actionsFilter?: Maybe<Array<AvailableAction>>;
};

export type XingMemberSince = {
  __typename?: 'XingMemberSince';
  /** #soft-logged-in */
  text?: Maybe<Scalars['String']>;
  /** #soft-logged-in */
  value?: Maybe<Scalars['String']>;
};

export type XingQuestionCv = BaseApplyQuestion & {
  __typename?: 'XingQuestionCV';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

export type XingQuestionEmail = BaseApplyQuestion & {
  __typename?: 'XingQuestionEmail';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

export type XingQuestionFirstName = BaseApplyQuestion & {
  __typename?: 'XingQuestionFirstName';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

export type XingQuestionLastName = BaseApplyQuestion & {
  __typename?: 'XingQuestionLastName';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

export type XingQuestionPhone = BaseApplyQuestion & {
  __typename?: 'XingQuestionPhone';
  /** #logged-out #soft-logged-in */
  id?: Maybe<Scalars['String']>;
  /** #logged-out #soft-logged-in */
  required?: Maybe<Scalars['Boolean']>;
  /** #logged-out #soft-logged-in */
  question?: Maybe<Scalars['String']>;
};

/**
 * This field only allow users with an active XTM seat to use the candidateSearch.
 * A null value is returned in case the user is not authorized.
 */
export type XtmAuthorizedUser = {
  __typename?: 'XtmAuthorizedUser';
  /** #rest #virtual */
  candidateSearch?: Maybe<CandidateSearchCollection>;
  /** #rest #virtual */
  hotleads?: Maybe<HotleadsCollection>;
};


/**
 * This field only allow users with an active XTM seat to use the candidateSearch.
 * A null value is returned in case the user is not authorized.
 */
export type XtmAuthorizedUserCandidateSearchArgs = {
  consumer: Scalars['String'];
  queries?: Maybe<CandidateSearchQueriesInput>;
  filters?: Maybe<CandidateSearchFiltersInput>;
  aggregations?: Maybe<CandidateSearchAggregationsInput>;
  highlight?: Maybe<HighlightInput>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  xtmProject?: Maybe<Scalars['Int']>;
  timeout?: Maybe<Scalars['Int']>;
};


/**
 * This field only allow users with an active XTM seat to use the candidateSearch.
 * A null value is returned in case the user is not authorized.
 */
export type XtmAuthorizedUserHotleadsArgs = {
  jobPostingId: Scalars['ID'];
  consumer: Scalars['String'];
  days?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  excludedCandidateIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  computeOverlappingSkills?: Maybe<Scalars['Boolean']>;
};

export type XtmConversations = {
  __typename?: 'XtmConversations';
  /** #rest #virtual */
  started?: Maybe<XtmConversationsStarted>;
  /** #rest #virtual */
  responseRate?: Maybe<XtmConversationsResponseRate>;
  /** #rest #virtual */
  replied?: Maybe<XtmConversationsReplied>;
};

export type XtmConversationsReplied = {
  __typename?: 'XtmConversationsReplied';
  histogram?: Maybe<Array<Maybe<XtmHistogramResult>>>;
};

export type XtmConversationsResponseRate = {
  __typename?: 'XtmConversationsResponseRate';
  total?: Maybe<Scalars['Int']>;
};

export type XtmConversationsStarted = {
  __typename?: 'XtmConversationsStarted';
  total?: Maybe<Scalars['Int']>;
  histogram?: Maybe<Array<Maybe<XtmHistogramResult>>>;
};

export type XtmCounterCollection = {
  __typename?: 'XtmCounterCollection';
  count?: Maybe<Scalars['Int']>;
};

export type XtmForbiddenError = {
  __typename?: 'XtmForbiddenError';
  message?: Maybe<Scalars['String']>;
};

export type XtmGlances = {
  __typename?: 'XtmGlances';
  /** #rest(batched) #virtual */
  xtmNotes?: Maybe<XtmCounterCollection>;
  /** #rest(batched) #virtual */
  xtmVisits?: Maybe<XtmCounterCollection>;
  /** #rest(batched) #virtual */
  xtmMessages?: Maybe<XtmCounterCollection>;
  /** #rest(batched) #virtual */
  xtmPools?: Maybe<XtmCounterCollection>;
  /** #rest(batched) #virtual */
  xtmProjects?: Maybe<XtmCounterCollection>;
};

export type XtmHistogramResult = {
  __typename?: 'XtmHistogramResult';
  timestamp?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

/** Types for XTM Message Templates */
export type XtmMessageTemplate = {
  __typename?: 'XtmMessageTemplate';
  id: Scalars['ID'];
  clientId: Scalars['ID'];
  creatorId: Scalars['ID'];
  title: Scalars['String'];
  body: Scalars['String'];
  subject: Scalars['String'];
  shared: Scalars['Boolean'];
  messagesCount: Scalars['Int'];
  responseRate?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  lastUsedAt?: Maybe<Scalars['Date']>;
};

export type XtmMessageTemplateConnection = HasCursorPagination & {
  __typename?: 'XtmMessageTemplateConnection';
  edges: Array<Maybe<XtmMessageTemplateListEdge>>;
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export type XtmMessageTemplateListEdge = PaginationEdge & {
  __typename?: 'XtmMessageTemplateListEdge';
  node?: Maybe<XtmMessageTemplateListItem>;
  /** #virtual */
  cursor: Scalars['String'];
};

export type XtmMessageTemplateListItem = {
  __typename?: 'XtmMessageTemplateListItem';
  id: Scalars['ID'];
  title: Scalars['String'];
  shared: Scalars['Boolean'];
  clientId: Scalars['ID'];
  creatorId: Scalars['ID'];
  createdAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type XtmMessageTemplateParserOutputElement = {
  __typename?: 'XtmMessageTemplateParserOutputElement';
  type?: Maybe<XtmTemplateParserOutputElementType>;
  value?: Maybe<Scalars['String']>;
};

export type XtmMessageTemplateResponse = {
  __typename?: 'XtmMessageTemplateResponse';
  messageTemplate: XtmMessageTemplate;
};

export type XtmPool = {
  __typename?: 'XtmPool';
  /** #rest #virtual */
  statistics?: Maybe<XtmProjectStatistics>;
};

export type XtmProject = {
  __typename?: 'XtmProject';
  /** #rest #virtual */
  statistics?: Maybe<XtmProjectStatistics>;
  conversations?: Maybe<XtmConversations>;
  weightFactorsOrder?: Maybe<Array<Maybe<XtmProjectWeightFactor>>>;
};


export type XtmProjectStatisticsArgs = {
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};


export type XtmProjectConversationsArgs = {
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};

export type XtmProjectCampaign = {
  __typename?: 'XtmProjectCampaign';
  id: Scalars['ID'];
  creatorId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  shareMessages?: Maybe<Scalars['Boolean']>;
  projectId?: Maybe<Scalars['ID']>;
  template?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  sendReminders?: Maybe<Scalars['Boolean']>;
};

export enum XtmProjectCampaignLimitationError {
  TooManyCampaigns = 'TOO_MANY_CAMPAIGNS',
  TooManyRecipients = 'TOO_MANY_RECIPIENTS',
  TooManyMessagesToNonContacts = 'TOO_MANY_MESSAGES_TO_NON_CONTACTS'
}

export type XtmProjectCampaignLimitationsInput = {
  projectId: Scalars['ID'];
  recipientIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type XtmProjectCampaignLimitationsResult = {
  __typename?: 'XtmProjectCampaignLimitationsResult';
  errors?: Maybe<Array<Maybe<XtmProjectCampaignLimitationError>>>;
  availableMtncQuota?: Maybe<Scalars['Int']>;
};

export type XtmProjectCreateUpdateCampaignInput = {
  id?: Maybe<Scalars['ID']>;
  subject?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  shareMessages?: Maybe<Scalars['Boolean']>;
  projectId?: Maybe<Scalars['ID']>;
  messageTemplateId?: Maybe<Scalars['ID']>;
  sendReminders?: Maybe<Scalars['Boolean']>;
};

export type XtmProjectCreateUpdateCampaignResult = XtmProjectCreateUpdateSuccess | XtmProjectCreateUpdateError;

export type XtmProjectCreateUpdateError = {
  __typename?: 'XtmProjectCreateUpdateError';
  message?: Maybe<Scalars['String']>;
};

export type XtmProjectCreateUpdateSuccess = {
  __typename?: 'XtmProjectCreateUpdateSuccess';
  campaign?: Maybe<XtmProjectCampaign>;
  subject?: Maybe<Array<Maybe<XtmMessageTemplateParserOutputElement>>>;
  body?: Maybe<Array<Maybe<XtmMessageTemplateParserOutputElement>>>;
};

export type XtmProjectSendCampaignInput = {
  projectId: Scalars['ID'];
  id: Scalars['ID'];
  recipientIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type XtmProjectSendCampaignResult = {
  __typename?: 'XtmProjectSendCampaignResult';
  sent?: Maybe<Scalars['Boolean']>;
};

export type XtmProjectStatistics = {
  __typename?: 'XtmProjectStatistics';
  candidates?: Maybe<XtmProjectStatisticsCandidates>;
  candidatesPerStatus?: Maybe<Array<Maybe<XtmStatusResult>>>;
  reviews?: Maybe<XtmProjectStatisticsReviews>;
};

export type XtmProjectStatisticsCandidates = {
  __typename?: 'XtmProjectStatisticsCandidates';
  total?: Maybe<Scalars['Int']>;
  histogram?: Maybe<Array<Maybe<XtmHistogramResult>>>;
};

export type XtmProjectStatisticsReviews = {
  __typename?: 'XtmProjectStatisticsReviews';
  pendingCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  candidateCount?: Maybe<Scalars['Int']>;
  histogram?: Maybe<Array<Maybe<XtmHistogramResult>>>;
};

export enum XtmProjectWeightFactor {
  Skills = 'SKILLS',
  CareerLevel = 'CAREER_LEVEL',
  JobTitle = 'JOB_TITLE',
  Languages = 'LANGUAGES',
  Location = 'LOCATION'
}

export type XtmSearchResult = {
  __typename?: 'XtmSearchResult';
  collection: Array<XtmSearchResultItem>;
  total: Scalars['Int'];
};

export type XtmSearchResultItem = {
  __typename?: 'XtmSearchResultItem';
  /** Unique identifier of the entity */
  id?: Maybe<Scalars['ID']>;
  /**
   * #rest(batched) #virtual
   *
   *  The profile information for the user
   */
  xingId?: Maybe<XingId>;
  /** Tracking token */
  trackingToken?: Maybe<Scalars['String']>;
  /** 0-based position in suggestion list */
  position?: Maybe<Scalars['Int']>;
};

export type XtmSeatsStats = {
  __typename?: 'XtmSeatsStats';
  totalSeats?: Maybe<Scalars['Int']>;
  assignedSeatsCount?: Maybe<Scalars['Int']>;
  availableSeatsCount?: Maybe<Scalars['Int']>;
  unavailableSeatsCount?: Maybe<Scalars['Int']>;
};

export type XtmSeatsStatsResponse = {
  __typename?: 'XtmSeatsStatsResponse';
  totalSeats?: Maybe<Scalars['Int']>;
  assignedSeatsCount?: Maybe<Scalars['Int']>;
  availableSeatsCount?: Maybe<Scalars['Int']>;
  unavailableSeatsCount?: Maybe<Scalars['Int']>;
  xtm?: Maybe<XtmSeatsStats>;
  xtp?: Maybe<XtmSeatsStats>;
};

export type XtmStatusResult = {
  __typename?: 'XtmStatusResult';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  /** #rest(batched) #virtual */
  candidates?: Maybe<Array<Maybe<XingId>>>;
};

export enum XtmTemplateParserOutputElementType {
  Valid = 'VALID',
  Invalid = 'INVALID',
  Text = 'TEXT'
}

export type XtmUpdateProjectInput = {
  id: Scalars['ID'];
  weightFactorsOrder?: Maybe<Array<Maybe<XtmProjectWeightFactor>>>;
};

export type XtmUpdateProjectResult = XtmUpdateProjectSuccess | XtmForbiddenError;

export type XtmUpdateProjectSuccess = {
  __typename?: 'XtmUpdateProjectSuccess';
  updated?: Maybe<Scalars['Boolean']>;
};

/**
 * App sessions (a.k.a. permissions)
 * They are scoper per app (not per device)
 */
export type XwsSessions = {
  __typename?: 'XwsSessions';
  id: Scalars['ID'];
  consumerId?: Maybe<Scalars['ID']>;
  consumerName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
};

export type BriefingDetailsInput = {
  briefingId: Scalars['ID'];
};

export type CandidateSearchDetailsInput = {
  briefingId: Scalars['ID'];
  candidateSearchId: Scalars['ID'];
};

export type CreateBriefingInput = {
  url: Scalars['String'];
  name: Scalars['String'];
  clientId: Scalars['ID'];
};

export type CreateCandidateSearchInput = {
  briefingId: Scalars['ID'];
  excludedCompanyIds?: Maybe<Array<Scalars['ID']>>;
};

export type CreateCvUploadParsedCvByUserIdInput = {
  userId?: Maybe<Scalars['ID']>;
  uploadId?: Maybe<Scalars['String']>;
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this parsed_cv originates from */
  source?: Maybe<Scalars['GlobalID']>;
  /** A string identifying the conceptual user flow from which a parsed_cv originates. While one job-posting could be the source (See above), there might be different used-flows that lead to the creation of a parsed_cv. */
  flowIdentifier?: Maybe<Scalars['String']>;
};

export type CreateCvUploadParsedCvInput = {
  /** ID the upload app returned for the given upload */
  uploadId?: Maybe<Scalars['String']>;
  /** A valid xing URN identifying the thing (think of processes as identifiable things) that this parsed_cv originates from */
  source?: Maybe<Scalars['GlobalID']>;
  /** A string identifying the conceptual user flow from which a parsed_cv originates. While one job-posting could be the source (See above), there might be different used-flows that lead to the creation of a parsed_cv. */
  flowIdentifier?: Maybe<Scalars['String']>;
};

export type DeleteCvUploadParsedCvInput = {
  id: Scalars['ID'];
};

export type InitialTalentsSearchInput = {
  briefingId: Scalars['ID'];
};

export type MymkBucketedRecommenderConnection = RecommenderResponse & HasCursorPagination & {
  __typename?: 'mymkBucketedRecommenderConnection';
  edges: Array<MymkCombinedRecommendationEdge>;
  requestTrackingToken: Scalars['String'];
  service: Scalars['String'];
  total: Scalars['Int'];
  /** #virtual */
  pageInfo: PageInfo;
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type UpdateBriefingInput = {
  briefingId: Scalars['ID'];
  status: BriefingStatus;
};

export enum VompTypeEnum {
  Internal = 'INTERNAL',
  External = 'EXTERNAL'
}
